var e,
  t,
  r,
  a,
  n = ["items", "handleClick", "initialItem", "className"],
  o = ["children", "className", "color", "tag", "size"],
  i = ["size", "type", "variant", "label"],
  l = ["odds", "bet", "text", "selected", "className", "setExplainerText"],
  s = ["id", "odds", "line", "lineLabel", "isSelected", "isLoading", "isDisabled", "isStrikethrough", "isPlaceholder", "variant", "animation", "description", "icon", "fluid", "fullHeight", "promoText", "was", "tabbable", "metadata", "onClick"],
  c = ["fill", "secondaryfill", "width", "height", "className", "accessibilityLabel"],
  u = ["fill", "secondaryfill", "width", "height", "className", "options"],
  d = ["name", "size", "color", "secondaryColor", "animate", "className", "options", "accessibilityLabel"],
  p = ["name", "size", "sport", "mode", "soccerType", "accessibilityLabel"],
  m = ["size", "className", "of", "bgColor", "type", "src", "icon", "iconColor", "country", "isCountry", "team", "id", "border", "borderColor", "altText", "mode", "onClick"],
  f = ["characterLimit", "legs", "bulletType", "boldText", "tabbable"],
  v = ["width", "minWidth", "height", "className", "rounded"],
  y = ["className", "tag", "wrapperTag", "children", "onSwiper"],
  g = ["tag", "children", "className", "swiper", "zoom", "lazy", "virtualIndex", "swiperSlideIndex"],
  h = ["text", "description", "type", "size", "fluid", "leftIcon", "rightIcon", "selected", "status", "children", "disabled", "variant", "team", "minWidth", "onClick", "accessibilityLabel", "className"],
  b = ["anchorTag", "label", "className"],
  N = ["isEnd", "isBeginning", "activeIndex", "visibleSlidesIndexes", "realIndex"],
  x = ["overlay", "showPagination", "showControls", "controlSize", "controlButtonType", "skipLink", "showFade", "showFadeLeft", "showFadeRight", "slideTo", "itemsDescription", "itemSpacing", "centerSlides", "initialIndex", "slideWrapperClasses", "cssMode", "tabbable", "id", "role", "forcePagination", "onItemChange", "handleItemImpression", "children"],
  k = ["navigation", "overlay", "breakpoint", "showPagination", "showControls", "controlSize", "controlButtonType", "skipLink", "isEnd", "isBeginning", "itemsDescription", "isLocked", "onFocus", "onBlur", "id", "role", "className", "forcePagination", "paginationClass", "slideWrapperClasses", "tabbable", "children"],
  w = ["id", "odds", "oldOdds", "isInBetSlip", "isLoading", "isDisabled", "isStrikethrough", "isPlaceholder", "variant", "subtitle", "onClick"],
  _ = ["score", "sport", "variant"],
  F = ["icon", "country", "displayName", "force", "team", "usePreferredName", "sport", "iconSize", "inverse", "home", "possession", "rank", "score", "groupBy", "description", "useAvatar", "avatar", "showAnimation", "showIcon", "center", "textSize", "skeleton", "tabbable", "hasPlayerName", "breakpoints", "compact", "lineClamp", "mode", "className"],
  S = ["date", "orientation", "variant"],
  C = ["from", "by", "delay", "stopAt", "finishedText", "format", "countUp", "color", "className", "onStop"],
  j = ["id", "competitors", "date", "variant", "hasLiveStream", "showCountdown", "skeleton", "onClick"],
  E = ["id", "competitors", "gameState", "date", "hasLiveStream", "onClick", "showCountdown", "preGameVariant", "skeleton"],
  T = ["items", "size", "initialActive", "activateItem", "overlay", "skipLink", "tabbable", "onActiveItem"],
  O = ["columns", "flush", "gap", "children", "className"],
  A = ["colStart", "colEnd", "colSpan", "rowStart", "rowEnd", "rowSpan", "items", "collapse", "children", "className"],
  M = ["selections", "competitor", "competitors", "type", "name", "marketHeader", "buttonOnly", "displayOrder", "groupBy", "oddsFormat", "dataFilterGroup", "canSelectMarkets", "selectedSelectionId", "marketTemplateTitle", "onSelectionClick", "updateMarket", "useSingleSelection", "showVersusDivider", "id", "sport", "mode"],
  L = ["caption", "labels", "details", "title", "description", "bg", "noBorder", "hasSGP", "className"],
  D = ["details", "hasSGP", "hasFirebets", "moreWagers", "showMore", "showLimit", "filters", "showMoreTotal", "canShowLess", "onShowMoreClick"],
  B = ["children", "showLimit", "filters", "showVersusDivider"],
  P = ["children", "showLimit"],
  I = ["duration", "easing", "onTransitionStateChange", "isExpanded", "defaultExpanded", "hasDisabledAnimation", "id"],
  z = ["disabled", "onClick", "refKey"],
  R = ["t", "x", "b", "noPad", "children", "className", "collapsible", "isOpen"],
  U = ["children"],
  H = ["children", "noPad"],
  G = ["children"],
  V = ["children", "isOpen"],
  W = ["children"],
  K = ["id", "rounded", "bg", "noPad", "showBorder", "className", "title", "description", "actionText", "children", "collapsible", "expandable", "restrictTo", "gap", "flow", "initiallyOpen", "defaultHeader", "headerBg", "headerDetails", "onToggle", "onCardClick"],
  Y = ["id", "header", "marketHeader", "markets", "marketFooter", "footer", "showBorder", "showVersusDivider", "type", "versusText", "groupBy", "showLimit", "filters", "sport", "canShowLess", "oddsFormat", "initiallyOpen", "eventDetails", "showMoreWagers", "hasSGP", "hasFirebets", "mode", "onSelectionClick", "onHeaderClick", "onEventHeaderClick", "onTemplateClick", "updateMarket", "updateMarkets"],
  $ = ["id", "header", "marketHeader", "markets", "marketFooter", "footer", "showBorder", "showBottomBorder", "showVersusDivider", "type", "versusText", "groupBy", "showLimit", "filters", "canShowLess", "oddsFormat", "initiallyOpen", "hasSGP", "hasFirebets", "isOddsBoost", "showMoreWagers", "skeleton", "eventDetails", "showEventHeader", "mode", "updateMarket", "onSelectionClick", "onHeaderClick", "onTemplateClick", "onEventHeaderClick", "updateMarkets"],
  q = ["header", "marketHeader", "markets", "marketFooter", "footer", "showBorder", "showVersusDivider", "type", "versusText", "groupBy", "showLimit", "filters", "canShowLess", "oddsFormat", "initiallyOpen", "hasSGP", "skeleton", "eventDetails", "sliderKeyBy", "updateMarket", "onTemplateClick", "onSelectionClick", "onHeaderClick", "updateMarkets"],
  J = ["children", "gap", "restrictTo"],
  X = ["type", "size", "shape", "overlay", "position", "textFormat", "status", "variant", "skeleton", "icon", "bgColor", "fgColor", "borderColor", "iconColor", "text", "children", "maxNumber", "numberAbbreviation", "className"],
  Z = ["id", "selected", "size", "shape", "type", "icon", "disabled", "customColors", "accessibilityLabel", "showAnimation", "className", "onToggle"],
  Q = ["marketTemplates", "id", "title", "description", "leadingIcon", "trailingDetails", "collapsible", "headerBg", "mode", "children", "initiallyOpen", "onHeaderClick", "restrictTo"],
  ee = ["scope", "children"],
  te = ["children"],
  re = ["children"],
  ae = ["asChild"],
  ne = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"],
  oe = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"],
  ie = ["container"],
  le = ["forceMount"],
  se = ["__scopeDialog"],
  ce = ["forceMount"],
  ue = ["__scopeDialog", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus"],
  de = ["__scopeDialog"],
  pe = ["__scopeDialog"];
function me(e) {
  return Ie(e) || je(e) || Be(e) || De();
}
function fe(e, t) {
  if (t && ("object" === ze(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e);
}
function ve(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return ve = function ve(e) {
    if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
    var r;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, a);
    }
    function a() {
      return ye(e, arguments, be(this).constructor);
    }
    return a.prototype = Object.create(e.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), he(a, e);
  }, ve(e);
}
function ye(e, t, r) {
  return ye = ge() ? Reflect.construct.bind() : function (e, t, r) {
    var a = [null];
    a.push.apply(a, t);
    var n = new (Function.bind.apply(e, a))();
    return r && he(n, r.prototype), n;
  }, ye.apply(null, arguments);
}
function ge() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function he(e, t) {
  return he = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, he(e, t);
}
function be(e) {
  return be = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, be(e);
}
function Ne(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function xe(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, Ae(a.key), a);
  }
}
function ke(e, t, r) {
  return t && xe(e.prototype, t), r && xe(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function we() {
  we = function we() {
    return e;
  };
  var e = {},
    t = Object.prototype,
    r = t.hasOwnProperty,
    a = Object.defineProperty || function (e, t, r) {
      e[t] = r.value;
    },
    n = "function" == typeof Symbol ? Symbol : {},
    o = n.iterator || "@@iterator",
    i = n.asyncIterator || "@@asyncIterator",
    l = n.toStringTag || "@@toStringTag";
  function s(e, t, r) {
    return Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    s({}, "");
  } catch (e) {
    s = function s(e, t, r) {
      return e[t] = r;
    };
  }
  function c(e, t, r, n) {
    var o = t && t.prototype instanceof p ? t : p,
      i = Object.create(o.prototype),
      l = new F(n || []);
    return a(i, "_invoke", {
      value: x(e, r, l)
    }), i;
  }
  function u(e, t, r) {
    try {
      return {
        type: "normal",
        arg: e.call(t, r)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  e.wrap = c;
  var d = {};
  function p() {}
  function m() {}
  function f() {}
  var v = {};
  s(v, o, function () {
    return this;
  });
  var y = Object.getPrototypeOf,
    g = y && y(y(S([])));
  g && g !== t && r.call(g, o) && (v = g);
  var h = f.prototype = p.prototype = Object.create(v);
  function b(e) {
    ["next", "throw", "return"].forEach(function (t) {
      s(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function N(e, t) {
    function n(a, o, i, l) {
      var s = u(e[a], e, o);
      if ("throw" !== s.type) {
        var c = s.arg,
          d = c.value;
        return d && "object" == ze(d) && r.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
          n("next", e, i, l);
        }, function (e) {
          n("throw", e, i, l);
        }) : t.resolve(d).then(function (e) {
          c.value = e, i(c);
        }, function (e) {
          return n("throw", e, i, l);
        });
      }
      l(s.arg);
    }
    var o;
    a(this, "_invoke", {
      value: function value(e, r) {
        function a() {
          return new t(function (t, a) {
            n(e, r, t, a);
          });
        }
        return o = o ? o.then(a, a) : a();
      }
    });
  }
  function x(e, t, r) {
    var a = "suspendedStart";
    return function (n, o) {
      if ("executing" === a) throw new Error("Generator is already running");
      if ("completed" === a) {
        if ("throw" === n) throw o;
        return C();
      }
      for (r.method = n, r.arg = o;;) {
        var i = r.delegate;
        if (i) {
          var l = k(i, r);
          if (l) {
            if (l === d) continue;
            return l;
          }
        }
        if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
          if ("suspendedStart" === a) throw a = "completed", r.arg;
          r.dispatchException(r.arg);
        } else "return" === r.method && r.abrupt("return", r.arg);
        a = "executing";
        var s = u(e, t, r);
        if ("normal" === s.type) {
          if (a = r.done ? "completed" : "suspendedYield", s.arg === d) continue;
          return {
            value: s.arg,
            done: r.done
          };
        }
        "throw" === s.type && (a = "completed", r.method = "throw", r.arg = s.arg);
      }
    };
  }
  function k(e, t) {
    var r = t.method,
      a = e.iterator[r];
    if (void 0 === a) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, k(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), d;
    var n = u(a, e.iterator, t.arg);
    if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, d;
    var o = n.arg;
    return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
  }
  function w(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function _(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function F(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(w, this), this.reset(!0);
  }
  function S(e) {
    if (e) {
      var t = e[o];
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var a = -1,
          n = function t() {
            for (; ++a < e.length;) if (r.call(e, a)) return t.value = e[a], t.done = !1, t;
            return t.value = void 0, t.done = !0, t;
          };
        return n.next = n;
      }
    }
    return {
      next: C
    };
  }
  function C() {
    return {
      value: void 0,
      done: !0
    };
  }
  return m.prototype = f, a(h, "constructor", {
    value: f,
    configurable: !0
  }), a(f, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = s(f, l, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
  }, e.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, s(e, l, "GeneratorFunction")), e.prototype = Object.create(h), e;
  }, e.awrap = function (e) {
    return {
      __await: e
    };
  }, b(N.prototype), s(N.prototype, i, function () {
    return this;
  }), e.AsyncIterator = N, e.async = function (t, r, a, n, o) {
    void 0 === o && (o = Promise);
    var i = new N(c(t, r, a, n), o);
    return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
      return e.done ? e.value : i.next();
    });
  }, b(h), s(h, l, "Generator"), s(h, o, function () {
    return this;
  }), s(h, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (e) {
    var t = Object(e),
      r = [];
    for (var a in t) r.push(a);
    return r.reverse(), function e() {
      for (; r.length;) {
        var a = r.pop();
        if (a in t) return e.value = a, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, e.values = S, F.prototype = {
    constructor: F,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !e) for (var t in this) "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var t = this;
      function a(r, a) {
        return i.type = "throw", i.arg = e, t.next = r, a && (t.method = "next", t.arg = void 0), !!a;
      }
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var o = this.tryEntries[n],
          i = o.completion;
        if ("root" === o.tryLoc) return a("end");
        if (o.tryLoc <= this.prev) {
          var l = r.call(o, "catchLoc"),
            s = r.call(o, "finallyLoc");
          if (l && s) {
            if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
            if (this.prev < o.finallyLoc) return a(o.finallyLoc);
          } else if (l) {
            if (this.prev < o.catchLoc) return a(o.catchLoc, !0);
          } else {
            if (!s) throw new Error("try statement without catch or finally");
            if (this.prev < o.finallyLoc) return a(o.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var n = this.tryEntries[a];
        if (n.tryLoc <= this.prev && r.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
          var o = n;
          break;
        }
      }
      o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
      var i = o ? o.completion : {};
      return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(i);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), _(r), d;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc === e) {
          var a = r.completion;
          if ("throw" === a.type) {
            var n = a.arg;
            _(r);
          }
          return n;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, t, r) {
      return this.delegate = {
        iterator: S(e),
        resultName: t,
        nextLoc: r
      }, "next" === this.method && (this.arg = void 0), d;
    }
  }, e;
}
function _e(e, t, r, a, n, o, i) {
  try {
    var l = e[o](i),
      s = l.value;
  } catch (e) {
    return void r(e);
  }
  l.done ? t(s) : Promise.resolve(s).then(a, n);
}
function Fe(e) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (a, n) {
      var o = e.apply(t, r);
      function i(e) {
        _e(o, a, n, i, l, "next", e);
      }
      function l(e) {
        _e(o, a, n, i, l, "throw", e);
      }
      i(void 0);
    });
  };
}
function Se(e, t) {
  var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Be(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var a = 0,
        n = function n() {};
      return {
        s: n,
        n: function n() {
          return a >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[a++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: n
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    i = !0,
    l = !1;
  return {
    s: function s() {
      r = r.call(e);
    },
    n: function n() {
      var e = r.next();
      return i = e.done, e;
    },
    e: function e(_e3) {
      l = !0, o = _e3;
    },
    f: function f() {
      try {
        i || null == r.return || r.return();
      } finally {
        if (l) throw o;
      }
    }
  };
}
function Ce(e) {
  return function (e) {
    if (Array.isArray(e)) return Pe(e);
  }(e) || je(e) || Be(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function je(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function Ee(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ee(Object(r), !0).forEach(function (t) {
      Oe(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ee(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Oe(e, t, r) {
  return (t = Ae(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Ae(e) {
  var t = function (e, t) {
    if ("object" !== ze(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== ze(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === ze(t) ? t : String(t);
}
function Me(e, t) {
  if (null == e) return {};
  var r,
    a,
    n = function (e, t) {
      if (null == e) return {};
      var r,
        a,
        n = {},
        o = Object.keys(e);
      for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || (n[r] = e[r]);
      return n;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Le(e, t) {
  return Ie(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || Be(e, t) || De();
}
function De() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Be(e, t) {
  if (e) {
    if ("string" == typeof e) return Pe(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Pe(e, t) : void 0;
  }
}
function Pe(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function Ie(e) {
  if (Array.isArray(e)) return e;
}
function ze(e) {
  return ze = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ze(e);
}
import * as Re from "react";
import Ue, { useState as He, useRef as Ge, useEffect as Ve, useLayoutEffect as We, memo as Ke, useCallback as Ye, createElement as $e, forwardRef as qe, isValidElement as Je, useMemo as Xe, createContext as Ze, Children as Qe, createRef as et, useImperativeHandle as tt, useContext as rt, cloneElement as at, Fragment as nt, useReducer as ot } from "react";
import it, { createPortal as lt, flushSync as st } from "react-dom";
var ct,
  ut = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  dt = {
    exports: {}
  },
  pt = {};
var mt,
  ft = {};
function vt() {
  return mt || (mt = 1, function (e) {
    "production" !== process.env.NODE_ENV && function () {
      var t = Ue,
        r = 60103,
        a = 60106;
      e.Fragment = 60107;
      var n = 60108,
        o = 60114,
        i = 60109,
        l = 60110,
        s = 60112,
        c = 60113,
        u = 60120,
        d = 60115,
        p = 60116,
        m = 60121,
        f = 60122,
        v = 60117,
        y = 60129,
        g = 60131;
      if ("function" == typeof Symbol && Symbol.for) {
        var h = Symbol.for;
        r = h("react.element"), a = h("react.portal"), e.Fragment = h("react.fragment"), n = h("react.strict_mode"), o = h("react.profiler"), i = h("react.provider"), l = h("react.context"), s = h("react.forward_ref"), c = h("react.suspense"), u = h("react.suspense_list"), d = h("react.memo"), p = h("react.lazy"), m = h("react.block"), f = h("react.server.block"), v = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), y = h("react.debug_trace_mode"), h("react.offscreen"), g = h("react.legacy_hidden");
      }
      var b = "function" == typeof Symbol && Symbol.iterator;
      var N = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function x(e) {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++) r[a - 1] = arguments[a];
        k("error", e, r);
      }
      function k(e, t, r) {
        var a = N.ReactDebugCurrentFrame,
          n = "";
        if (S) {
          var o = _(S.type),
            i = S._owner;
          n += function (e, t, r) {
            var a = "";
            if (t) {
              var n = t.fileName,
                o = n.replace(w, "");
              if (/^index\./.test(o)) {
                var i = n.match(w);
                if (i) {
                  var l = i[1];
                  if (l) o = l.replace(w, "") + "/" + o;
                }
              }
              a = " (at " + o + ":" + t.lineNumber + ")";
            } else r && (a = " (created by " + r + ")");
            return "\n    in " + (e || "Unknown") + a;
          }(o, S._source, i && _(i.type));
        }
        "" !== (n += a.getStackAddendum()) && (t += "%s", r = r.concat([n]));
        var l = r.map(function (e) {
          return "" + e;
        });
        l.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, l);
      }
      var w = /^(.*)[\\\/]/;
      function _(t) {
        if (null == t) return null;
        if ("number" == typeof t.tag && x("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), "function" == typeof t) return t.displayName || t.name || null;
        if ("string" == typeof t) return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case o:
            return "Profiler";
          case n:
            return "StrictMode";
          case c:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if ("object" === ze(t)) switch (t.$$typeof) {
          case l:
            return "Context.Consumer";
          case i:
            return "Context.Provider";
          case s:
            return v = t, y = t.render, g = "ForwardRef", h = y.displayName || y.name || "", v.displayName || ("" !== h ? g + "(" + h + ")" : g);
          case d:
            return _(t.type);
          case m:
            return _(t.render);
          case p:
            var r = 1 === (f = t)._status ? f._result : null;
            if (r) return _(r);
        }
        var f, v, y, g, h;
        return null;
      }
      var F = {};
      N.ReactDebugCurrentFrame;
      var S = null;
      function C(e) {
        S = e;
      }
      var j,
        E,
        T,
        O = N.ReactCurrentOwner,
        A = Object.prototype.hasOwnProperty,
        M = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0
        };
      T = {};
      function L(e, t, a, n, o) {
        var i,
          l = {},
          s = null,
          c = null;
        for (i in void 0 !== a && (s = "" + a), function (e) {
          if (A.call(e, "key")) {
            var t = Object.getOwnPropertyDescriptor(e, "key").get;
            if (t && t.isReactWarning) return !1;
          }
          return void 0 !== e.key;
        }(t) && (s = "" + t.key), function (e) {
          if (A.call(e, "ref")) {
            var t = Object.getOwnPropertyDescriptor(e, "ref").get;
            if (t && t.isReactWarning) return !1;
          }
          return void 0 !== e.ref;
        }(t) && (c = t.ref, function (e, t) {
          if ("string" == typeof e.ref && O.current && t && O.current.stateNode !== t) {
            var r = _(O.current.type);
            T[r] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(O.current.type), e.ref), T[r] = !0);
          }
        }(t, o)), t) A.call(t, i) && !M.hasOwnProperty(i) && (l[i] = t[i]);
        if (e && e.defaultProps) {
          var u = e.defaultProps;
          for (i in u) void 0 === l[i] && (l[i] = u[i]);
        }
        if (s || c) {
          var d = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
          s && function (e, t) {
            var r = function r() {
              j || (j = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
            };
            r.isReactWarning = !0, Object.defineProperty(e, "key", {
              get: r,
              configurable: !0
            });
          }(l, d), c && function (e, t) {
            var r = function r() {
              E || (E = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
            };
            r.isReactWarning = !0, Object.defineProperty(e, "ref", {
              get: r,
              configurable: !0
            });
          }(l, d);
        }
        return function (e, t, a, n, o, i, l) {
          var s = {
            $$typeof: r,
            type: e,
            key: t,
            ref: a,
            props: l,
            _owner: i,
            _store: {}
          };
          return Object.defineProperty(s._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: !1
          }), Object.defineProperty(s, "_self", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: n
          }), Object.defineProperty(s, "_source", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: o
          }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
        }(e, s, c, o, n, O.current, l);
      }
      var D,
        B = N.ReactCurrentOwner;
      function P(e) {
        S = e;
      }
      function I(e) {
        return "object" === ze(e) && null !== e && e.$$typeof === r;
      }
      function z() {
        if (B.current) {
          var e = _(B.current.type);
          if (e) return "\n\nCheck the render method of `" + e + "`.";
        }
        return "";
      }
      N.ReactDebugCurrentFrame, D = !1;
      var R = {};
      function U(e, t) {
        if (e._store && !e._store.validated && null == e.key) {
          e._store.validated = !0;
          var r = function (e) {
            var t = z();
            if (!t) {
              var r = "string" == typeof e ? e : e.displayName || e.name;
              r && (t = "\n\nCheck the top-level render call using <" + r + ">.");
            }
            return t;
          }(t);
          if (!R[r]) {
            R[r] = !0;
            var a = "";
            e && e._owner && e._owner !== B.current && (a = " It was passed a child from " + _(e._owner.type) + "."), P(e), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, a), P(null);
          }
        }
      }
      function H(e, t) {
        if ("object" === ze(e)) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
          var a = e[r];
          I(a) && U(a, t);
        } else if (I(e)) e._store && (e._store.validated = !0);else if (e) {
          var n = function (e) {
            if (null === e || "object" !== ze(e)) return null;
            var t = b && e[b] || e["@@iterator"];
            return "function" == typeof t ? t : null;
          }(e);
          if ("function" == typeof n && n !== e.entries) for (var o, i = n.call(e); !(o = i.next()).done;) I(o.value) && U(o.value, t);
        }
      }
      function G(e) {
        var t,
          r = e.type;
        if (null != r && "string" != typeof r) {
          if ("function" == typeof r) t = r.propTypes;else {
            if ("object" !== ze(r) || r.$$typeof !== s && r.$$typeof !== d) return;
            t = r.propTypes;
          }
          if (t) {
            var a = _(r);
            !function (e, t, r, a, n) {
              var o = Function.call.bind(Object.prototype.hasOwnProperty);
              for (var i in e) if (o(e, i)) {
                var l = void 0;
                try {
                  if ("function" != typeof e[i]) {
                    var s = Error((a || "React class") + ": " + r + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ze(e[i]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    throw s.name = "Invariant Violation", s;
                  }
                  l = e[i](t, i, a, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (e) {
                  l = e;
                }
                !l || l instanceof Error || (C(n), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", r, i, ze(l)), C(null)), l instanceof Error && !(l.message in F) && (F[l.message] = !0, C(n), x("Failed %s type: %s", r, l.message), C(null));
              }
            }(t, e.props, "prop", a, e);
          } else if (void 0 !== r.PropTypes && !D) {
            D = !0, x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _(r) || "Unknown");
          }
          "function" != typeof r.getDefaultProps || r.getDefaultProps.isReactClassApproved || x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function V(t, a, h, b, N, k) {
        var w = function (t) {
          return "string" == typeof t || "function" == typeof t || t === e.Fragment || t === o || t === y || t === n || t === c || t === u || t === g || "object" === ze(t) && null !== t && (t.$$typeof === p || t.$$typeof === d || t.$$typeof === i || t.$$typeof === l || t.$$typeof === s || t.$$typeof === v || t.$$typeof === m || t[0] === f);
        }(t);
        if (!w) {
          var F = "";
          (void 0 === t || "object" === ze(t) && null !== t && 0 === Object.keys(t).length) && (F += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S,
            C = function (e) {
              return void 0 !== e ? "\n\nCheck your code at " + e.fileName.replace(/^.*[\\\/]/, "") + ":" + e.lineNumber + "." : "";
            }(N);
          F += C || z(), null === t ? S = "null" : Array.isArray(t) ? S = "array" : void 0 !== t && t.$$typeof === r ? (S = "<" + (_(t.type) || "Unknown") + " />", F = " Did you accidentally export a JSX literal instead of a component?") : S = ze(t), x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", S, F);
        }
        var j = L(t, a, h, N, k);
        if (null == j) return j;
        if (w) {
          var E = a.children;
          if (void 0 !== E) if (b) {
            if (Array.isArray(E)) {
              for (var T = 0; T < E.length; T++) H(E[T], t);
              Object.freeze && Object.freeze(E);
            } else x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else H(E, t);
        }
        return t === e.Fragment ? function (e) {
          for (var t = Object.keys(e.props), r = 0; r < t.length; r++) {
            var a = t[r];
            if ("children" !== a && "key" !== a) {
              P(e), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), P(null);
              break;
            }
          }
          null !== e.ref && (P(e), x("Invalid attribute `ref` supplied to `React.Fragment`."), P(null));
        }(j) : G(j), j;
      }
      var W = function W(e, t, r) {
          return V(e, t, r, !1);
        },
        K = function K(e, t, r) {
          return V(e, t, r, !0);
        };
      e.jsx = W, e.jsxs = K;
    }();
  }(ft)), ft;
}
function yt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  return Array.isArray(e) ? e.filter(function (e) {
    return !!e;
  }).join(" ").concat(" ").concat(t) : "object" === ze(e) ? Object.entries(e).filter(function (e) {
    var t = Le(e, 2);
    t[0];
    return t[1];
  }).map(function (e) {
    var t = Le(e, 2),
      r = t[0];
    t[1];
    return r;
  }).join(" ").concat(" ").concat(t) : "string" == typeof e ? "".concat(e, " ").concat(t) : void 0;
}
!function (e) {
  "production" === process.env.NODE_ENV ? e.exports = function () {
    if (ct) return pt;
    ct = 1;
    var e = Ue,
      t = 60103;
    if (pt.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
      var r = Symbol.for;
      t = r("react.element"), pt.Fragment = r("react.fragment");
    }
    var a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      n = Object.prototype.hasOwnProperty,
      o = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };
    function i(e, r, i) {
      var l,
        s = {},
        c = null,
        u = null;
      for (l in void 0 !== i && (c = "" + i), void 0 !== r.key && (c = "" + r.key), void 0 !== r.ref && (u = r.ref), r) n.call(r, l) && !o.hasOwnProperty(l) && (s[l] = r[l]);
      if (e && e.defaultProps) for (l in r = e.defaultProps) void 0 === s[l] && (s[l] = r[l]);
      return {
        $$typeof: t,
        type: e,
        key: c,
        ref: u,
        props: s,
        _owner: a.current
      };
    }
    return pt.jsx = i, pt.jsxs = i, pt;
  }() : e.exports = vt();
}(dt);
var gt = function gt(e) {
  var t = e.items,
    r = e.handleClick,
    a = e.initialItem,
    o = e.className,
    i = void 0 === o ? "" : o,
    l = Me(e, n),
    s = Le(He(a || t[0].itemId), 2),
    c = s[0],
    u = s[1];
  return dt.exports.jsx("ul", Te(Te({}, l), {}, {
    className: "cui-inline-flex cui-flex-row !cui-list-none " + i,
    children: t.map(function (e) {
      var t = e.itemId,
        a = e.label;
      return dt.exports.jsx("li", {
        className: yt({
          "cui-bg-bg-default cui-text-fg-moderate cui-ring-1 cui-ring-fg-moderate": t !== c,
          "cui-bg-bg-layer-one cui-text-fg-primary-strong cui-ring-2 cui-ring-fg-primary-strong": t === c
        }, "cui-cursor-pointer cui-select-none cui-text-size-4 cui-p-3 first:cui-rounded-l-2 last:cui-rounded-r-2 cui-ring-inset"),
        "data-item-id": t,
        onClick: function onClick(e) {
          return function (e, t) {
            u(t), r && r(e, t);
          }(e, t);
        },
        children: a
      }, t);
    })
  }));
};
function ht(e) {
  var t = e.toString();
  if (t.includes(".")) {
    var r = t.split("."),
      a = r[1],
      n = r[0];
    if (1 === a.length) return "".concat(n, ".").concat(a, "0");
    if (2 === a.length) return "".concat(n, ".").concat(a);
    if (a.length >= 3) {
      if (a[2] <= 5) return "".concat(n, ".").concat(a.slice(0, 2));
      if (a[2] > 5) return "".concat(e.toFixed(2));
    }
  }
  return "".concat(e);
}
function bt(e) {
  if (null === e) return {
    odds: null,
    type: "number",
    exactOdds: null
  };
  if ("string" == typeof e) {
    if ("evs" === e.toLowerCase()) return {
      odds: 1,
      type: "fractional",
      fractions: ["1", "1"],
      exactOdds: 2
    };
    if ("sp" === e.toLowerCase()) return {
      odds: 1,
      type: "SP",
      fractions: ["1", "1"],
      exactOdds: 2
    };
    if (/^[\+|-]/.test(e)) {
      var t = +e.replace("+", "");
      return {
        odds: t,
        type: "american",
        exactOdds: +ht(t > 0 ? t / 100 + 1 : 100 / Math.abs(t) + 1)
      };
    }
    if (/\//.test(e)) {
      var r = e.split("/");
      return {
        odds: +r[0] / +r[1],
        type: "fractional",
        fractions: r,
        exactOdds: +r[0] / +r[1] == 1 ? 2 : +ht(+r[0] / +r[1] + 1)
      };
    }
    if (/\./.test(e)) return {
      odds: +e,
      type: "decimal",
      exactOdds: +e
    };
  }
  return "number" == typeof e && /\./.test("".concat(e)) ? {
    odds: e,
    type: "decimal",
    exactOdds: e
  } : {
    odds: +e,
    type: "number",
    exactOdds: +e > 0 ? +e / 100 + 1 : 100 / Math.abs(+e) + 1
  };
}
var Nt,
  xt = {
    blinkDuration: {
      default: 3e3,
      reduced: 2e3,
      off: 0
    },
    numberTweenDuration: {
      default: 700,
      reduced: 200,
      off: 1
    }
  };
function kt(e) {
  e.current && (clearTimeout(e.current), e.current = null);
}
!function (e) {
  e[e.UP = 0] = "UP", e[e.DOWN = 1] = "DOWN", e[e.EVEN = 2] = "EVEN";
}(Nt || (Nt = {}));
var wt = function wt(e) {
    var t = e.odds,
      r = e.oddsType,
      a = e.delay,
      n = void 0 === a ? 2200 : a,
      o = Ge([]),
      i = Ge(null),
      l = Le(He("EVEN"), 2),
      s = l[0],
      c = l[1];
    return Ve(function () {
      if (o.current) {
        if (kt(i), o.current.push(t || ""), 3 === o.current.length && (o.current = o.current.slice(1, 3)), o.current.length <= 1 || "SP" === r) c("EVEN");else {
          var e = Le(o.current, 2),
            a = e[0],
            l = e[1],
            s = "string" == typeof a ? +a.replace("+", "") : a,
            u = "string" == typeof l ? +l.replace("+", "") : l;
          u && s && (u > s ? c("UP") : u < s ? c("DOWN") : s === u && c("EVEN"));
        }
        i.current || (i.current = setTimeout(function () {
          c("EVEN");
        }, n));
      }
      return function () {
        kt(i);
      };
    }, [t]), [s];
  },
  _t = {
    threshold: .9
  };
function Ft(e, t) {
  var r = e.firstChild;
  r && !r.nextSibling && 3 == r.nodeType && "data" in r ? r.data = t : e.textContent = t;
}
var St = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0
  },
  Ct = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
  },
  jt = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"],
  Et = {
    CSS: {},
    springs: {}
  };
function Tt(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
function Ot(e, t) {
  return e.indexOf(t) > -1;
}
function At(e, t) {
  return e.apply(null, t);
}
var Mt = {
  arr: function arr(e) {
    return Array.isArray(e);
  },
  obj: function obj(e) {
    return Ot(Object.prototype.toString.call(e), "Object");
  },
  pth: function pth(e) {
    return Mt.obj(e) && e.hasOwnProperty("totalLength");
  },
  svg: function svg(e) {
    return e instanceof SVGElement;
  },
  inp: function inp(e) {
    return e instanceof HTMLInputElement;
  },
  dom: function dom(e) {
    return e.nodeType || Mt.svg(e);
  },
  str: function str(e) {
    return "string" == typeof e;
  },
  fnc: function fnc(e) {
    return "function" == typeof e;
  },
  und: function und(e) {
    return void 0 === e;
  },
  nil: function nil(e) {
    return Mt.und(e) || null === e;
  },
  hex: function hex(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  rgb: function rgb(e) {
    return /^rgb/.test(e);
  },
  hsl: function hsl(e) {
    return /^hsl/.test(e);
  },
  col: function col(e) {
    return Mt.hex(e) || Mt.rgb(e) || Mt.hsl(e);
  },
  key: function key(e) {
    return !St.hasOwnProperty(e) && !Ct.hasOwnProperty(e) && "targets" !== e && "keyframes" !== e;
  }
};
function Lt(e) {
  var t = /\(([^)]+)\)/.exec(e);
  return t ? t[1].split(",").map(function (e) {
    return parseFloat(e);
  }) : [];
}
function Dt(e, t) {
  var r = Lt(e),
    a = Tt(Mt.und(r[0]) ? 1 : r[0], .1, 100),
    n = Tt(Mt.und(r[1]) ? 100 : r[1], .1, 100),
    o = Tt(Mt.und(r[2]) ? 10 : r[2], .1, 100),
    i = Tt(Mt.und(r[3]) ? 0 : r[3], .1, 100),
    l = Math.sqrt(n / a),
    s = o / (2 * Math.sqrt(n * a)),
    c = s < 1 ? l * Math.sqrt(1 - s * s) : 0,
    u = s < 1 ? (s * l - i) / c : -i + l;
  function d(e) {
    var r = t ? t * e / 1e3 : e;
    return r = s < 1 ? Math.exp(-r * s * l) * (1 * Math.cos(c * r) + u * Math.sin(c * r)) : (1 + u * r) * Math.exp(-r * l), 0 === e || 1 === e ? e : 1 - r;
  }
  return t ? d : function () {
    var t = Et.springs[e];
    if (t) return t;
    for (var r = 1 / 6, a = 0, n = 0;;) if (1 === d(a += r)) {
      if (++n >= 16) break;
    } else n = 0;
    var o = a * r * 1e3;
    return Et.springs[e] = o, o;
  };
}
function Bt(e) {
  return void 0 === e && (e = 10), function (t) {
    return Math.ceil(Tt(t, 1e-6, 1) * e) * (1 / e);
  };
}
var Pt,
  It,
  zt = function () {
    var e = .1;
    function t(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function r(e, t) {
      return 3 * t - 6 * e;
    }
    function a(e) {
      return 3 * e;
    }
    function n(e, n, o) {
      return ((t(n, o) * e + r(n, o)) * e + a(n)) * e;
    }
    function o(e, n, o) {
      return 3 * t(n, o) * e * e + 2 * r(n, o) * e + a(n);
    }
    return function (t, r, a, i) {
      if (0 <= t && t <= 1 && 0 <= a && a <= 1) {
        var l = new Float32Array(11);
        if (t !== r || a !== i) for (var s = 0; s < 11; ++s) l[s] = n(s * e, t, a);
        return function (e) {
          return t === r && a === i || 0 === e || 1 === e ? e : n(c(e), r, i);
        };
      }
      function c(r) {
        for (var i = 0, s = 1; 10 !== s && l[s] <= r; ++s) i += e;
        --s;
        var c = i + (r - l[s]) / (l[s + 1] - l[s]) * e,
          u = o(c, t, a);
        return u >= .001 ? function (e, t, r, a) {
          for (var i = 0; i < 4; ++i) {
            var l = o(t, r, a);
            if (0 === l) return t;
            t -= (n(t, r, a) - e) / l;
          }
          return t;
        }(r, c, t, a) : 0 === u ? c : function (e, t, r, a, o) {
          var i,
            l,
            s = 0;
          do {
            (i = n(l = t + (r - t) / 2, a, o) - e) > 0 ? r = l : t = l;
          } while (Math.abs(i) > 1e-7 && ++s < 10);
          return l;
        }(r, i, i + e, t, a);
      }
    };
  }(),
  Rt = (Pt = {
    linear: function linear() {
      return function (e) {
        return e;
      };
    }
  }, It = {
    Sine: function Sine() {
      return function (e) {
        return 1 - Math.cos(e * Math.PI / 2);
      };
    },
    Circ: function Circ() {
      return function (e) {
        return 1 - Math.sqrt(1 - e * e);
      };
    },
    Back: function Back() {
      return function (e) {
        return e * e * (3 * e - 2);
      };
    },
    Bounce: function Bounce() {
      return function (e) {
        for (var t, r = 4; e < ((t = Math.pow(2, --r)) - 1) / 11;);
        return 1 / Math.pow(4, 3 - r) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2);
      };
    },
    Elastic: function Elastic(e, t) {
      void 0 === e && (e = 1), void 0 === t && (t = .5);
      var r = Tt(e, 1, 10),
        a = Tt(t, .1, 2);
      return function (e) {
        return 0 === e || 1 === e ? e : -r * Math.pow(2, 10 * (e - 1)) * Math.sin((e - 1 - a / (2 * Math.PI) * Math.asin(1 / r)) * (2 * Math.PI) / a);
      };
    }
  }, ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach(function (e, t) {
    It[e] = function () {
      return function (e) {
        return Math.pow(e, t + 2);
      };
    };
  }), Object.keys(It).forEach(function (e) {
    var t = It[e];
    Pt["easeIn" + e] = t, Pt["easeOut" + e] = function (e, r) {
      return function (a) {
        return 1 - t(e, r)(1 - a);
      };
    }, Pt["easeInOut" + e] = function (e, r) {
      return function (a) {
        return a < .5 ? t(e, r)(2 * a) / 2 : 1 - t(e, r)(-2 * a + 2) / 2;
      };
    }, Pt["easeOutIn" + e] = function (e, r) {
      return function (a) {
        return a < .5 ? (1 - t(e, r)(1 - 2 * a)) / 2 : (t(e, r)(2 * a - 1) + 1) / 2;
      };
    };
  }), Pt);
function Ut(e, t) {
  if (Mt.fnc(e)) return e;
  var r = e.split("(")[0],
    a = Rt[r],
    n = Lt(e);
  switch (r) {
    case "spring":
      return Dt(e, t);
    case "cubicBezier":
      return At(zt, n);
    case "steps":
      return At(Bt, n);
    default:
      return At(a, n);
  }
}
function Ht(e) {
  try {
    return document.querySelectorAll(e);
  } catch (e) {
    return;
  }
}
function Gt(e, t) {
  for (var r = e.length, a = arguments.length >= 2 ? arguments[1] : void 0, n = [], o = 0; o < r; o++) if (o in e) {
    var i = e[o];
    t.call(a, i, o, e) && n.push(i);
  }
  return n;
}
function Vt(e) {
  return e.reduce(function (e, t) {
    return e.concat(Mt.arr(t) ? Vt(t) : t);
  }, []);
}
function Wt(e) {
  return Mt.arr(e) ? e : (Mt.str(e) && (e = Ht(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
}
function Kt(e, t) {
  return e.some(function (e) {
    return e === t;
  });
}
function Yt(e) {
  var t = {};
  for (var r in e) t[r] = e[r];
  return t;
}
function $t(e, t) {
  var r = Yt(e);
  for (var a in e) r[a] = t.hasOwnProperty(a) ? t[a] : e[a];
  return r;
}
function qt(e, t) {
  var r = Yt(e);
  for (var a in t) r[a] = Mt.und(e[a]) ? t[a] : e[a];
  return r;
}
function Jt(e) {
  return Mt.rgb(e) ? (r = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(t = e)) ? "rgba(" + r[1] + ",1)" : t : Mt.hex(e) ? function (e) {
    var t = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, r, a) {
        return t + t + r + r + a + a;
      }),
      r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
    return "rgba(" + parseInt(r[1], 16) + "," + parseInt(r[2], 16) + "," + parseInt(r[3], 16) + ",1)";
  }(e) : Mt.hsl(e) ? function (e) {
    var t,
      r,
      a,
      n = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e),
      o = parseInt(n[1], 10) / 360,
      i = parseInt(n[2], 10) / 100,
      l = parseInt(n[3], 10) / 100,
      s = n[4] || 1;
    function c(e, t, r) {
      return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
    }
    if (0 == i) t = r = a = l;else {
      var u = l < .5 ? l * (1 + i) : l + i - l * i,
        d = 2 * l - u;
      t = c(d, u, o + 1 / 3), r = c(d, u, o), a = c(d, u, o - 1 / 3);
    }
    return "rgba(" + 255 * t + "," + 255 * r + "," + 255 * a + "," + s + ")";
  }(e) : void 0;
  var t, r;
}
function Xt(e) {
  var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(e);
  if (t) return t[1];
}
function Zt(e, t) {
  return Mt.fnc(e) ? e(t.target, t.id, t.total) : e;
}
function Qt(e, t) {
  return e.getAttribute(t);
}
function er(e, t, r) {
  if (Kt([r, "deg", "rad", "turn"], Xt(t))) return t;
  var a = Et.CSS[t + r];
  if (!Mt.und(a)) return a;
  var n = document.createElement(e.tagName),
    o = e.parentNode && e.parentNode !== document ? e.parentNode : document.body;
  o.appendChild(n), n.style.position = "absolute", n.style.width = 100 + r;
  var i = 100 / n.offsetWidth;
  o.removeChild(n);
  var l = i * parseFloat(t);
  return Et.CSS[t + r] = l, l;
}
function tr(e, t, r) {
  if (t in e.style) {
    var a = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
      n = e.style[t] || getComputedStyle(e).getPropertyValue(a) || "0";
    return r ? er(e, n, r) : n;
  }
}
function rr(e, t) {
  return Mt.dom(e) && !Mt.inp(e) && (!Mt.nil(Qt(e, t)) || Mt.svg(e) && e[t]) ? "attribute" : Mt.dom(e) && Kt(jt, t) ? "transform" : Mt.dom(e) && "transform" !== t && tr(e, t) ? "css" : null != e[t] ? "object" : void 0;
}
function ar(e) {
  if (Mt.dom(e)) {
    for (var t, r = e.style.transform || "", a = /(\w+)\(([^)]*)\)/g, n = new Map(); t = a.exec(r);) n.set(t[1], t[2]);
    return n;
  }
}
function nr(e, t, r, a) {
  var n = Ot(t, "scale") ? 1 : 0 + function (e) {
      return Ot(e, "translate") || "perspective" === e ? "px" : Ot(e, "rotate") || Ot(e, "skew") ? "deg" : void 0;
    }(t),
    o = ar(e).get(t) || n;
  return r && (r.transforms.list.set(t, o), r.transforms.last = t), a ? er(e, o, a) : o;
}
function or(e, t, r, a) {
  switch (rr(e, t)) {
    case "transform":
      return nr(e, t, a, r);
    case "css":
      return tr(e, t, r);
    case "attribute":
      return Qt(e, t);
    default:
      return e[t] || 0;
  }
}
function ir(e, t) {
  var r = /^(\*=|\+=|-=)/.exec(e);
  if (!r) return e;
  var a = Xt(e) || 0,
    n = parseFloat(t),
    o = parseFloat(e.replace(r[0], ""));
  switch (r[0][0]) {
    case "+":
      return n + o + a;
    case "-":
      return n - o + a;
    case "*":
      return n * o + a;
  }
}
function lr(e, t) {
  if (Mt.col(e)) return Jt(e);
  if (/\s/g.test(e)) return e;
  var r = Xt(e),
    a = r ? e.substr(0, e.length - r.length) : e;
  return t ? a + t : a;
}
function sr(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function cr(e) {
  for (var t, r = e.points, a = 0, n = 0; n < r.numberOfItems; n++) {
    var o = r.getItem(n);
    n > 0 && (a += sr(t, o)), t = o;
  }
  return a;
}
function ur(e) {
  if (e.getTotalLength) return e.getTotalLength();
  switch (e.tagName.toLowerCase()) {
    case "circle":
      return function (e) {
        return 2 * Math.PI * Qt(e, "r");
      }(e);
    case "rect":
      return function (e) {
        return 2 * Qt(e, "width") + 2 * Qt(e, "height");
      }(e);
    case "line":
      return function (e) {
        return sr({
          x: Qt(e, "x1"),
          y: Qt(e, "y1")
        }, {
          x: Qt(e, "x2"),
          y: Qt(e, "y2")
        });
      }(e);
    case "polyline":
      return cr(e);
    case "polygon":
      return function (e) {
        var t = e.points;
        return cr(e) + sr(t.getItem(t.numberOfItems - 1), t.getItem(0));
      }(e);
  }
}
function dr(e, t) {
  var r = t || {},
    a = r.el || function (e) {
      for (var t = e.parentNode; Mt.svg(t) && Mt.svg(t.parentNode);) t = t.parentNode;
      return t;
    }(e),
    n = a.getBoundingClientRect(),
    o = Qt(a, "viewBox"),
    i = n.width,
    l = n.height,
    s = r.viewBox || (o ? o.split(" ") : [0, 0, i, l]);
  return {
    el: a,
    viewBox: s,
    x: s[0] / 1,
    y: s[1] / 1,
    w: i,
    h: l,
    vW: s[2],
    vH: s[3]
  };
}
function pr(e, t, r) {
  function a(r) {
    void 0 === r && (r = 0);
    var a = t + r >= 1 ? t + r : 0;
    return e.el.getPointAtLength(a);
  }
  var n = dr(e.el, e.svg),
    o = a(),
    i = a(-1),
    l = a(1),
    s = r ? 1 : n.w / n.vW,
    c = r ? 1 : n.h / n.vH;
  switch (e.property) {
    case "x":
      return (o.x - n.x) * s;
    case "y":
      return (o.y - n.y) * c;
    case "angle":
      return 180 * Math.atan2(l.y - i.y, l.x - i.x) / Math.PI;
  }
}
function mr(e, t) {
  var r = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
    a = lr(Mt.pth(e) ? e.totalLength : e, t) + "";
  return {
    original: a,
    numbers: a.match(r) ? a.match(r).map(Number) : [0],
    strings: Mt.str(e) || t ? a.split(r) : []
  };
}
function fr(e) {
  return Gt(e ? Vt(Mt.arr(e) ? e.map(Wt) : Wt(e)) : [], function (e, t, r) {
    return r.indexOf(e) === t;
  });
}
function vr(e) {
  var t = fr(e);
  return t.map(function (e, r) {
    return {
      target: e,
      id: r,
      total: t.length,
      transforms: {
        list: ar(e)
      }
    };
  });
}
function yr(e, t) {
  var r = Yt(t);
  if (/^spring/.test(r.easing) && (r.duration = Dt(r.easing)), Mt.arr(e)) {
    var a = e.length;
    2 === a && !Mt.obj(e[0]) ? e = {
      value: e
    } : Mt.fnc(t.duration) || (r.duration = t.duration / a);
  }
  var n = Mt.arr(e) ? e : [e];
  return n.map(function (e, r) {
    var a = Mt.obj(e) && !Mt.pth(e) ? e : {
      value: e
    };
    return Mt.und(a.delay) && (a.delay = r ? 0 : t.delay), Mt.und(a.endDelay) && (a.endDelay = r === n.length - 1 ? t.endDelay : 0), a;
  }).map(function (e) {
    return qt(e, r);
  });
}
function gr(e, t) {
  var r = [],
    a = t.keyframes;
  for (var n in a && (t = qt(function (e) {
    for (var t = Gt(Vt(e.map(function (e) {
        return Object.keys(e);
      })), function (e) {
        return Mt.key(e);
      }).reduce(function (e, t) {
        return e.indexOf(t) < 0 && e.push(t), e;
      }, []), r = {}, a = function a(_a2) {
        var n = t[_a2];
        r[n] = e.map(function (e) {
          var t = {};
          for (var r in e) Mt.key(r) ? r == n && (t.value = e[r]) : t[r] = e[r];
          return t;
        });
      }, n = 0; n < t.length; n++) a(n);
    return r;
  }(a), t)), t) Mt.key(n) && r.push({
    name: n,
    tweens: yr(t[n], e)
  });
  return r;
}
function hr(e, t) {
  var r;
  return e.tweens.map(function (a) {
    var n = function (e, t) {
        var r = {};
        for (var a in e) {
          var n = Zt(e[a], t);
          Mt.arr(n) && 1 === (n = n.map(function (e) {
            return Zt(e, t);
          })).length && (n = n[0]), r[a] = n;
        }
        return r.duration = parseFloat(r.duration), r.delay = parseFloat(r.delay), r;
      }(a, t),
      o = n.value,
      i = Mt.arr(o) ? o[1] : o,
      l = Xt(i),
      s = or(t.target, e.name, l, t),
      c = r ? r.to.original : s,
      u = Mt.arr(o) ? o[0] : c,
      d = Xt(u) || Xt(s),
      p = l || d;
    return Mt.und(i) && (i = c), n.from = mr(u, p), n.to = mr(ir(i, u), p), n.start = r ? r.end : 0, n.end = n.start + n.delay + n.duration + n.endDelay, n.easing = Ut(n.easing, n.duration), n.isPath = Mt.pth(o), n.isPathTargetInsideSVG = n.isPath && Mt.svg(t.target), n.isColor = Mt.col(n.from.original), n.isColor && (n.round = 1), r = n, n;
  });
}
var br = {
  css: function css(e, t, r) {
    return e.style[t] = r;
  },
  attribute: function attribute(e, t, r) {
    return e.setAttribute(t, r);
  },
  object: function object(e, t, r) {
    return e[t] = r;
  },
  transform: function transform(e, t, r, a, n) {
    if (a.list.set(t, r), t === a.last || n) {
      var o = "";
      a.list.forEach(function (e, t) {
        o += t + "(" + e + ") ";
      }), e.style.transform = o;
    }
  }
};
function Nr(e, t) {
  vr(e).forEach(function (e) {
    for (var r in t) {
      var a = Zt(t[r], e),
        n = e.target,
        o = Xt(a),
        i = or(n, r, o, e),
        l = ir(lr(a, o || Xt(i)), i),
        s = rr(n, r);
      br[s](n, r, l, e.transforms, !0);
    }
  });
}
function xr(e, t) {
  return Gt(Vt(e.map(function (e) {
    return t.map(function (t) {
      return function (e, t) {
        var r = rr(e.target, t.name);
        if (r) {
          var a = hr(t, e),
            n = a[a.length - 1];
          return {
            type: r,
            property: t.name,
            animatable: e,
            tweens: a,
            duration: n.end,
            delay: a[0].delay,
            endDelay: n.endDelay
          };
        }
      }(e, t);
    });
  })), function (e) {
    return !Mt.und(e);
  });
}
function kr(e, t) {
  var r = e.length,
    a = function a(e) {
      return e.timelineOffset ? e.timelineOffset : 0;
    },
    n = {};
  return n.duration = r ? Math.max.apply(Math, e.map(function (e) {
    return a(e) + e.duration;
  })) : t.duration, n.delay = r ? Math.min.apply(Math, e.map(function (e) {
    return a(e) + e.delay;
  })) : t.delay, n.endDelay = r ? n.duration - Math.max.apply(Math, e.map(function (e) {
    return a(e) + e.duration - e.endDelay;
  })) : t.endDelay, n;
}
var wr = 0;
var _r = [],
  Fr = function () {
    var e;
    function t(r) {
      for (var a = _r.length, n = 0; n < a;) {
        var o = _r[n];
        o.paused ? (_r.splice(n, 1), a--) : (o.tick(r), n++);
      }
      e = n > 0 ? requestAnimationFrame(t) : void 0;
    }
    return "undefined" != typeof document && document.addEventListener("visibilitychange", function () {
      Cr.suspendWhenDocumentHidden && (Sr() ? e = cancelAnimationFrame(e) : (_r.forEach(function (e) {
        return e._onDocumentVisibility();
      }), Fr()));
    }), function () {
      e || Sr() && Cr.suspendWhenDocumentHidden || !(_r.length > 0) || (e = requestAnimationFrame(t));
    };
  }();
function Sr() {
  return !!document && document.hidden;
}
function Cr(e) {
  void 0 === e && (e = {});
  var t,
    r = 0,
    a = 0,
    n = 0,
    o = 0,
    i = null;
  function l(e) {
    var t = window.Promise && new Promise(function (e) {
      return i = e;
    });
    return e.finished = t, t;
  }
  var s = function (e) {
    var t = $t(St, e),
      r = $t(Ct, e),
      a = gr(r, e),
      n = vr(e.targets),
      o = xr(n, a),
      i = kr(o, r),
      l = wr;
    return wr++, qt(t, {
      id: l,
      children: [],
      animatables: n,
      animations: o,
      duration: i.duration,
      delay: i.delay,
      endDelay: i.endDelay
    });
  }(e);
  function c() {
    var e = s.direction;
    "alternate" !== e && (s.direction = "normal" !== e ? "normal" : "reverse"), s.reversed = !s.reversed, t.forEach(function (e) {
      return e.reversed = s.reversed;
    });
  }
  function u(e) {
    return s.reversed ? s.duration - e : e;
  }
  function d() {
    r = 0, a = u(s.currentTime) * (1 / Cr.speed);
  }
  function p(e, t) {
    t && t.seek(e - t.timelineOffset);
  }
  function m(e) {
    for (var t = 0, r = s.animations, a = r.length; t < a;) {
      var n = r[t],
        o = n.animatable,
        i = n.tweens,
        l = i.length - 1,
        c = i[l];
      l && (c = Gt(i, function (t) {
        return e < t.end;
      })[0] || c);
      for (var u = Tt(e - c.start - c.delay, 0, c.duration) / c.duration, d = isNaN(u) ? 1 : c.easing(u), p = c.to.strings, m = c.round, f = [], v = c.to.numbers.length, y = void 0, g = 0; g < v; g++) {
        var h = void 0,
          b = c.to.numbers[g],
          N = c.from.numbers[g] || 0;
        h = c.isPath ? pr(c.value, d * b, c.isPathTargetInsideSVG) : N + d * (b - N), m && (c.isColor && g > 2 || (h = Math.round(h * m) / m)), f.push(h);
      }
      var x = p.length;
      if (x) {
        y = p[0];
        for (var k = 0; k < x; k++) {
          p[k];
          var w = p[k + 1],
            _ = f[k];
          isNaN(_) || (y += w ? _ + w : _ + " ");
        }
      } else y = f[0];
      br[n.type](o.target, n.property, y, o.transforms), n.currentValue = y, t++;
    }
  }
  function f(e) {
    s[e] && !s.passThrough && s[e](s);
  }
  function v(e) {
    var d = s.duration,
      v = s.delay,
      y = d - s.endDelay,
      g = u(e);
    s.progress = Tt(g / d * 100, 0, 100), s.reversePlayback = g < s.currentTime, t && function (e) {
      if (s.reversePlayback) for (var r = o; r--;) p(e, t[r]);else for (var a = 0; a < o; a++) p(e, t[a]);
    }(g), !s.began && s.currentTime > 0 && (s.began = !0, f("begin")), !s.loopBegan && s.currentTime > 0 && (s.loopBegan = !0, f("loopBegin")), g <= v && 0 !== s.currentTime && m(0), (g >= y && s.currentTime !== d || !d) && m(d), g > v && g < y ? (s.changeBegan || (s.changeBegan = !0, s.changeCompleted = !1, f("changeBegin")), f("change"), m(g)) : s.changeBegan && (s.changeCompleted = !0, s.changeBegan = !1, f("changeComplete")), s.currentTime = Tt(g, 0, d), s.began && f("update"), e >= d && (a = 0, s.remaining && !0 !== s.remaining && s.remaining--, s.remaining ? (r = n, f("loopComplete"), s.loopBegan = !1, "alternate" === s.direction && c()) : (s.paused = !0, s.completed || (s.completed = !0, f("loopComplete"), f("complete"), !s.passThrough && "Promise" in window && (i(), l(s)))));
  }
  return l(s), s.reset = function () {
    var e = s.direction;
    s.passThrough = !1, s.currentTime = 0, s.progress = 0, s.paused = !0, s.began = !1, s.loopBegan = !1, s.changeBegan = !1, s.completed = !1, s.changeCompleted = !1, s.reversePlayback = !1, s.reversed = "reverse" === e, s.remaining = s.loop, t = s.children;
    for (var r = o = t.length; r--;) s.children[r].reset();
    (s.reversed && !0 !== s.loop || "alternate" === e && 1 === s.loop) && s.remaining++, m(s.reversed ? s.duration : 0);
  }, s._onDocumentVisibility = d, s.set = function (e, t) {
    return Nr(e, t), s;
  }, s.tick = function (e) {
    n = e, r || (r = n), v((n + (a - r)) * Cr.speed);
  }, s.seek = function (e) {
    v(u(e));
  }, s.pause = function () {
    s.paused = !0, d();
  }, s.play = function () {
    s.paused && (s.completed && s.reset(), s.paused = !1, _r.push(s), d(), Fr());
  }, s.reverse = function () {
    c(), s.completed = !s.reversed, d();
  }, s.restart = function () {
    s.reset(), s.play();
  }, s.remove = function (e) {
    Er(fr(e), s);
  }, s.reset(), s.autoplay && s.play(), s;
}
function jr(e, t) {
  for (var r = t.length; r--;) Kt(e, t[r].animatable.target) && t.splice(r, 1);
}
function Er(e, t) {
  var r = t.animations,
    a = t.children;
  jr(e, r);
  for (var n = a.length; n--;) {
    var o = a[n],
      i = o.animations;
    jr(e, i), i.length || o.children.length || a.splice(n, 1);
  }
  r.length || a.length || t.pause();
}
Cr.version = "3.2.1", Cr.speed = 1, Cr.suspendWhenDocumentHidden = !0, Cr.running = _r, Cr.remove = function (e) {
  for (var t = fr(e), r = _r.length; r--;) {
    Er(t, _r[r]);
  }
}, Cr.get = or, Cr.set = Nr, Cr.convertPx = er, Cr.path = function (e, t) {
  var r = Mt.str(e) ? Ht(e)[0] : e,
    a = t || 100;
  return function (e) {
    return {
      property: e,
      el: r,
      svg: dr(r),
      totalLength: ur(r) * (a / 100)
    };
  };
}, Cr.setDashoffset = function (e) {
  var t = ur(e);
  return e.setAttribute("stroke-dasharray", t), t;
}, Cr.stagger = function (e, t) {
  void 0 === t && (t = {});
  var r = t.direction || "normal",
    a = t.easing ? Ut(t.easing) : null,
    n = t.grid,
    o = t.axis,
    i = t.from || 0,
    l = "first" === i,
    s = "center" === i,
    c = "last" === i,
    u = Mt.arr(e),
    d = u ? parseFloat(e[0]) : parseFloat(e),
    p = u ? parseFloat(e[1]) : 0,
    m = Xt(u ? e[1] : e) || 0,
    f = t.start || 0 + (u ? d : 0),
    v = [],
    y = 0;
  return function (e, t, g) {
    if (l && (i = 0), s && (i = (g - 1) / 2), c && (i = g - 1), !v.length) {
      for (var h = 0; h < g; h++) {
        if (n) {
          var b = s ? (n[0] - 1) / 2 : i % n[0],
            N = s ? (n[1] - 1) / 2 : Math.floor(i / n[0]),
            x = b - h % n[0],
            k = N - Math.floor(h / n[0]),
            w = Math.sqrt(x * x + k * k);
          "x" === o && (w = -x), "y" === o && (w = -k), v.push(w);
        } else v.push(Math.abs(i - h));
        y = Math.max.apply(Math, v);
      }
      a && (v = v.map(function (e) {
        return a(e / y) * y;
      })), "reverse" === r && (v = v.map(function (e) {
        return o ? e < 0 ? -1 * e : -e : Math.abs(y - e);
      }));
    }
    return f + (u ? (p - d) / y : d) * (Math.round(100 * v[t]) / 100) + m;
  };
}, Cr.timeline = function (e) {
  void 0 === e && (e = {});
  var t = Cr(e);
  return t.duration = 0, t.add = function (r, a) {
    var n = _r.indexOf(t),
      o = t.children;
    function i(e) {
      e.passThrough = !0;
    }
    n > -1 && _r.splice(n, 1);
    for (var l = 0; l < o.length; l++) i(o[l]);
    var s = qt(r, $t(Ct, e));
    s.targets = s.targets || e.targets;
    var c = t.duration;
    s.autoplay = !1, s.direction = t.direction, s.timelineOffset = Mt.und(a) ? c : ir(a, c), i(t), t.seek(s.timelineOffset);
    var u = Cr(s);
    i(u), o.push(u);
    var d = kr(o, e);
    return t.delay = d.delay, t.endDelay = d.endDelay, t.duration = d.duration, t.seek(0), t.reset(), t.autoplay && t.play(), t;
  }, t;
}, Cr.easing = Ut, Cr.penner = Rt, Cr.random = function (e, t) {
  return Math.floor(Math.random() * (t - e + 1)) + e;
};
var Tr = function Tr(e) {
    var t = ze(e);
    return null != e && ("object" == t || "function" == t);
  },
  Or = "object" == ze(ut) && ut && ut.Object === Object && ut,
  Ar = Or,
  Mr = "object" == ("undefined" == typeof self ? "undefined" : ze(self)) && self && self.Object === Object && self,
  Lr = Ar || Mr || Function("return this")(),
  Dr = Lr,
  Br = function Br() {
    return Dr.Date.now();
  },
  Pr = /\s/;
var Ir = function Ir(e) {
    for (var t = e.length; t-- && Pr.test(e.charAt(t)););
    return t;
  },
  zr = Ir,
  Rr = /^\s+/;
var Ur = function Ur(e) {
    return e ? e.slice(0, zr(e) + 1).replace(Rr, "") : e;
  },
  Hr = Lr.Symbol,
  Gr = Hr,
  Vr = Object.prototype,
  Wr = Vr.hasOwnProperty,
  Kr = Vr.toString,
  Yr = Gr ? Gr.toStringTag : void 0;
var $r = function $r(e) {
    var t = Wr.call(e, Yr),
      r = e[Yr];
    try {
      e[Yr] = void 0;
      var a = !0;
    } catch (e) {}
    var n = Kr.call(e);
    return a && (t ? e[Yr] = r : delete e[Yr]), n;
  },
  qr = Object.prototype.toString;
var Jr = $r,
  Xr = function Xr(e) {
    return qr.call(e);
  },
  Zr = Hr ? Hr.toStringTag : void 0;
var Qr = function Qr(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : Zr && Zr in Object(e) ? Jr(e) : Xr(e);
};
var ea = function ea(e) {
    return null != e && "object" == ze(e);
  },
  ta = Qr,
  ra = ea;
var aa = function aa(e) {
    return "symbol" == ze(e) || ra(e) && "[object Symbol]" == ta(e);
  },
  na = Ur,
  oa = Tr,
  ia = aa,
  la = /^[-+]0x[0-9a-f]+$/i,
  sa = /^0b[01]+$/i,
  ca = /^0o[0-7]+$/i,
  ua = parseInt;
var da = function da(e) {
    if ("number" == typeof e) return e;
    if (ia(e)) return NaN;
    if (oa(e)) {
      var t = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = oa(t) ? t + "" : t;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = na(e);
    var r = sa.test(e);
    return r || ca.test(e) ? ua(e.slice(2), r ? 2 : 8) : la.test(e) ? NaN : +e;
  },
  pa = Tr,
  ma = Br,
  fa = da,
  va = Math.max,
  ya = Math.min;
var ga = function ga(e, t, r) {
    var a,
      n,
      o,
      i,
      l,
      s,
      c = 0,
      u = !1,
      d = !1,
      p = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    function m(t) {
      var r = a,
        o = n;
      return a = n = void 0, c = t, i = e.apply(o, r);
    }
    function f(e) {
      return c = e, l = setTimeout(y, t), u ? m(e) : i;
    }
    function v(e) {
      var r = e - s;
      return void 0 === s || r >= t || r < 0 || d && e - c >= o;
    }
    function y() {
      var e = ma();
      if (v(e)) return g(e);
      l = setTimeout(y, function (e) {
        var r = t - (e - s);
        return d ? ya(r, o - (e - c)) : r;
      }(e));
    }
    function g(e) {
      return l = void 0, p && a ? m(e) : (a = n = void 0, i);
    }
    function h() {
      var e = ma(),
        r = v(e);
      if (a = arguments, n = this, s = e, r) {
        if (void 0 === l) return f(s);
        if (d) return clearTimeout(l), l = setTimeout(y, t), m(s);
      }
      return void 0 === l && (l = setTimeout(y, t)), i;
    }
    return t = fa(t) || 0, pa(r) && (u = !!r.leading, o = (d = "maxWait" in r) ? va(fa(r.maxWait) || 0, t) : o, p = "trailing" in r ? !!r.trailing : p), h.cancel = function () {
      void 0 !== l && clearTimeout(l), c = 0, a = s = n = l = void 0;
    }, h.flush = function () {
      return void 0 === l ? i : g(ma());
    }, h;
  },
  ha = ga,
  ba = ga,
  Na = Tr;
var xa = function xa(e, t, r) {
    var a = !0,
      n = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return Na(r) && (a = "leading" in r ? !!r.leading : a, n = "trailing" in r ? !!r.trailing : n), ba(e, t, {
      leading: a,
      maxWait: t,
      trailing: n
    });
  },
  ka = xa,
  wa = !0,
  _a = ["evs", "sp"];
function Fa(e) {
  var t = e.prevOdds,
    r = e.parseOdds,
    a = e.description,
    n = e.line,
    o = e.odds,
    i = e.lineRef,
    l = e.oddsRef,
    s = e.animationState,
    c = e.parsedOdds,
    u = e.animationOptions,
    d = e.isEnabled,
    p = Ge(null);
  We(function () {
    var e,
      a,
      d = t.current.parsedOdds,
      m = r(o),
      f = "string" == typeof n && /^\+|-/.test(n) ? n.charAt(0) : "",
      v = {};
    if (i.current && n && Ft(i.current, "".concat(n)), l.current && o && Ft(l.current, "".concat(o)), m.type !== d.type || wa || "off" === s) {
      var y;
      wa && (wa = !1), null === (y = p.current) || void 0 === y || y.pause();
    } else {
      var g;
      "fractional" === m.type && "fractional" === d.type && null !== (g = d.fractions) && void 0 !== g && g.length ? v = {
        numerator: d.fractions[0],
        denominator: d.fractions[1],
        line: t.current.line ? t.current.line : "0"
      } : d.odds && m.odds && (v = {
        odds: "reduced" === s ? d.odds > m.odds ? m.odds + .05 * m.odds : m.odds - .05 * m.odds : d.odds,
        line: t.current.line ? t.current.line : "0"
      });
      var h = t.current.line !== n,
        b = t.current.parsedOdds.odds !== c.odds;
      p.current = Cr(Te(Te({
        targets: v
      }, "fractional" === m.type ? {
        numerator: null !== (e = m.fractions) && void 0 !== e && e.length ? m.fractions[0] : 0,
        denominator: null !== (a = m.fractions) && void 0 !== a && a.length ? m.fractions[1] : 0
      } : {
        odds: o
      }), {}, {
        line: n || "0",
        easing: "linear",
        duration: u.numberTweenDuration[s],
        round: "decimal" === m.type ? 0 : 10,
        complete: function complete() {
          setTimeout(function () {
            n && i.current && Ft(i.current, "".concat(n));
          }, 40);
        },
        update: function update() {
          if (l.current && b) if ("fractional" === m.type || "SP" === m.type) "string" == typeof o && _a.includes(o.toLowerCase()) ? Ft(l.current, o) : Ft(l.current, "".concat(Math.floor(+v.numerator), "/").concat(Math.floor(+v.denominator)));else if ("decimal" === m.type) {
            var e = function (e, t) {
              var r = e.toString(),
                a = r.includes(".") ? r.split(".") : t ? r : r + ".00";
              if (Array.isArray(a)) {
                var n = a[1].replace(/ /g, "");
                return n.length >= 2 && (n = n.slice(0, 2)), 1 === n.length && !t && (n += "0"), "".concat(a[0], ".").concat(n);
              }
              return a;
            }(v.odds);
            Ft(l.current, "".concat(e).replace(/ /g, ""));
          } else {
            var t = Math.floor(+v.odds),
              r = t > 0 ? "+" : "";
            Ft(l.current, "".concat(r).concat(t));
          }
          if (n && h && i.current) {
            var a = function (e, t) {
              var r = e.toString().trim(),
                a = r.includes(".") ? r.split(".").map(function (e) {
                  return e.trim();
                }) : null,
                n = "";
              if (!a || !Array.isArray(a)) return t ? "".concat(r, ".0") : "".concat(r);
              var o = a[1];
              return 0 !== o.length && t || (n = "".concat(a[0])), o.length >= 1 && (o = o.slice(0, 1), n = "".concat(a[0], ".").concat(o)), "".concat(n);
            }(!!f ? v.line : Math.floor(v.line), !!f);
            Ft(i.current, "".concat(f && +a > 0 ? "+" : "").concat(a));
          }
        }
      })), p.current && (p.current.restart(), p.current.suspendWhenDocumentHidden = !1, p.current.update = ka(p.current.update, 20));
    }
    return t.current = {
      parsedOdds: r(o),
      line: n
    }, function () {
      var e;
      null === (e = p.current) || void 0 === e || e.remove(v), p.current = null;
    };
  }, [o, n, d, a]);
}
var Sa,
  Ca = {
    positive: "cui-fill-status-positive",
    negative: "cui-fill-status-negative"
  },
  ja = {
    bottomRight: "cui-right-0 cui-bottom-0 cui-rotate-90",
    topRight: "cui-right-0 cui-top-0",
    bottomLeft: "cui-left-0 cui-bottom-0",
    topLeft: "cui-left-0 cui-top-0"
  },
  Ea = function Ea(e) {
    var t = e.id,
      r = e.status,
      a = void 0 === r ? "positive" : r,
      n = e.className,
      o = void 0 === n ? "" : n,
      i = e.movement,
      l = e.selected,
      s = "cui__market-button-arrow-".concat(t),
      c = "positive" === a ? "topRight" : "bottomRight";
    return dt.exports.jsx("svg", {
      id: s,
      width: "12",
      height: "12",
      viewBox: "0 0 8 8",
      fill: "current",
      xmlns: "http://www.w3.org/2000/svg",
      className: yt([ja[c], l ? "cui-fill-fg-inverse" : Ca[a], o, i ? "cui-visible" : "cui-invisible"], "cui-absolute cui-p-2px"),
      children: dt.exports.jsx("path", {
        d: "M1.70711 1.70711C1.07714 1.07714 1.52331 0 2.41421 0H7C7.55228 0 8 0.447715 8 1V5.58579C8 6.47669 6.92286 6.92286 6.29289 6.29289L4 4L1.70711 1.70711Z",
        fill: "current"
      })
    });
  },
  Ta = function Ta(e) {
    var t = e.selected,
      r = e.oddsState,
      a = e.id,
      n = e.isViewable,
      o = void 0 === n || n,
      i = e.animation,
      l = Ge(null),
      s = Ge(null);
    return Ve(function () {
      var e, t;
      (l.current = Cr({
        targets: [s.current],
        opacity: [0, 1],
        duration: 500,
        direction: "alternate",
        loop: "reduced" === i ? 4 : 6,
        easing: "linear",
        autoplay: !1
      }), r.EVEN || !o || "off" === i) ? null === (e = l.current) || void 0 === e || e.pause() : null === (t = l.current) || void 0 === t || t.restart();
      return function () {
        l.current = null;
      };
    }), dt.exports.jsxs("div", {
      ref: s,
      className: yt({
        "cui-ring-status-positive": r.UP && !t,
        "cui-ring-status-negative": r.DOWN && !t,
        "cui-ring-neutrals-transparent": r.EVEN,
        "cui-ring-fg-inverse": (r.UP || r.DOWN) && t
      }, "cui-rounded-[2px] cui-absolute cui-inset-0 cui-ring-1 cui-ring-solid cui-z-10"),
      "data-cy": "market-button-arrow-indicators",
      children: [dt.exports.jsx(Ea, {
        status: "positive",
        movement: r.UP,
        id: "positive-".concat(a),
        selected: t
      }), dt.exports.jsx(Ea, {
        status: "negative",
        movement: r.DOWN,
        id: "negative-".concat(a),
        selected: t
      })]
    });
  },
  Oa = function Oa(e) {
    return dt.exports.jsx("svg", Te(Te({
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "current",
      id: "market-btn-lock",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), {}, {
      children: dt.exports.jsxs("g", {
        className: "cui-fill-fg-moderate",
        children: [dt.exports.jsx("path", {
          d: "M19,10H5a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V13A3,3,0,0,0,19,10Zm-7,9a2,2,0,1,1,2-2A2,2,0,0,1,12,19Z",
          className: "cui-fill-fg-moderate"
        }), dt.exports.jsx("path", {
          d: "M18,8H16V6a3.958,3.958,0,0,0-3.911-4h-.042A3.978,3.978,0,0,0,8,5.911V8H6V5.9A5.961,5.961,0,0,1,11.949,0h.061A5.979,5.979,0,0,1,18,6.01Z"
        })]
      })
    }));
  },
  Aa = function Aa(e) {
    var t = e.lineRef,
      r = e.selected,
      a = e.lineLabel,
      n = e.hasLine,
      o = e.variant,
      i = (null == a ? void 0 : a.trim()) || "",
      l = /over/i.test(i.toLowerCase()),
      s = /under/i.test(i.toLowerCase()),
      c = /pick/i.test(i.toLowerCase());
    return n || c ? dt.exports.jsxs("div", {
      className: yt({
        "before:cui-content-['O'] sbk-desktop:before:cui-content-['Over']": l,
        "before:cui-content-['U'] sbk-desktop:before:cui-content-['Under']": s,
        "cui-text-fg-inverse": r
      }, "before:cui-mr-1 heading-sm-bold !cui-leading-1 cui-flex cui-items-center cui-justify-center"),
      "data-cy": "market-button-line-label-wrapper",
      children: [i && !l && !s && !c && dt.exports.jsx("span", {
        className: "cui-mr-1 cui-truncate cui-overflow-hidden cui-max-w-[18px] sbk-phone:cui-max-w-[68px]",
        children: i
      }), !n && c ? dt.exports.jsx("span", {
        children: "PICK"
      }) : dt.exports.jsx("span", {
        ref: t,
        className: yt({
          "cui-text-fg-inverse": r,
          "cui-text-fg-default": !r,
          "heading-lg-bold": "large" === o
        }, "cui__market-button-line")
      })]
    }) : null;
  },
  Ma = {
    "cui__mb-notification": "MBNotification-module_cui__mb-notification__5hH1k",
    notification: "MBNotification-module_notification__fDRNW"
  },
  La = new Uint8Array(16);
function Da() {
  if (!Sa && !(Sa = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Sa(La);
}
for (var Ba = [], Pa = 0; Pa < 256; ++Pa) Ba.push((Pa + 256).toString(16).slice(1));
var Ia = {
  randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
};
function za(e, t, r) {
  if (Ia.randomUUID && !t && !e) return Ia.randomUUID();
  var a = (e = e || {}).random || (e.rng || Da)();
  if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) {
    r = r || 0;
    for (var n = 0; n < 16; ++n) t[r + n] = a[n];
    return t;
  }
  return function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
    return Ba[e[t + 0]] + Ba[e[t + 1]] + Ba[e[t + 2]] + Ba[e[t + 3]] + "-" + Ba[e[t + 4]] + Ba[e[t + 5]] + "-" + Ba[e[t + 6]] + Ba[e[t + 7]] + "-" + Ba[e[t + 8]] + Ba[e[t + 9]] + "-" + Ba[e[t + 10]] + Ba[e[t + 11]] + Ba[e[t + 12]] + Ba[e[t + 13]] + Ba[e[t + 14]] + Ba[e[t + 15]];
  }(a);
}
var Ra = function Ra() {
    return "undefined" != typeof window ? za() : Math.abs(Date.now() * Math.random()).toString().replace(".", "");
  },
  Ua = {
    ADDED: "cui-w-full cui-bg-status-positive cui-text-fg-inverse cui-border-status-positive ".concat(Ma ? Ma["cui__mb-notification"] : ""),
    REMOVED: "cui-hidden"
  },
  Ha = Ke(function (e) {
    var t,
      r = e.isSelected,
      a = void 0 !== r && r,
      n = e.prevState,
      o = e.variant,
      i = Le(He(!1), 2),
      l = i[0],
      s = i[1],
      c = Ge(null);
    Ge(null), We(function () {
      n !== a && s(!0);
    }, [a, n]);
    var u = {
      isAdded: a,
      isRemoved: !a
    };
    return dt.exports.jsx("div", {
      id: "cui__market-button-notification-".concat(Ra()),
      ref: c,
      className: yt((t = {}, Oe(t, Ua.ADDED, u.isAdded && l), Oe(t, Ua.REMOVED, u.isRemoved && l), Oe(t, "cui-hidden", null === a || !l), Oe(t, "heading-sm-bold", "large" !== o), Oe(t, "heading-2xl-bold", "large" === o), t), "cui-select-none cui-pointer-events-none cui-absolute cui-inset-0 cui-flex cui-justify-center cui-items-center cui-z-[1] cui-rounded-2px"),
      children: u.isAdded ? "Added" : ""
    });
  }),
  Ga = function Ga(e) {
    var t = Ge(e);
    return Ve(function () {
      t.current = e;
    }), t;
  },
  Va = function Va(e, t, r) {
    function a() {
      i.current && clearTimeout(i.current), i.current = void 0;
    }
    function n() {
      i.current = void 0;
    }
    void 0 === t && (t = 100), void 0 === r && (r = 0);
    var o = Ga(e),
      i = Ge(),
      l = [t, r, o];
    return Ve(function () {
      return a;
    }, l), Ye(function () {
      var e = arguments,
        a = i.current;
      if (void 0 === a && r) return i.current = setTimeout(n, t), o.current.apply(null, e);
      a && clearTimeout(a), i.current = setTimeout(function () {
        i.current = void 0, o.current.apply(null, e);
      }, t);
    }, l);
  };
function Wa(e, t, r, a) {
  var n = Ge(r),
    o = Ge(a);
  Ve(function () {
    n.current = r, o.current = a;
  }), Ve(function () {
    function r() {
      if (!i) {
        for (var e = arguments.length, t = new Array(e), r = 0; e > r; r++) t[r] = arguments[r];
        n.current.apply(this, t);
      }
    }
    var a = e && "current" in e ? e.current : e;
    if (a) {
      var i = 0;
      a.addEventListener(t, r);
      var l = o.current;
      return function () {
        i = 1, a.removeEventListener(t, r), l && l();
      };
    }
  }, [e, t]);
}
var Ka = {},
  Ya = "undefined" == typeof window ? null : window,
  $a = Ya && void 0 !== Ya.visualViewport ? Ya.visualViewport : null,
  qa = function qa() {
    return [document.documentElement.clientWidth, document.documentElement.clientHeight];
  },
  Ja = function Ja(e) {
    void 0 === e && (e = Ka);
    var t = e,
      r = t.wait,
      a = t.leading,
      n = t.initialWidth,
      o = void 0 === n ? 0 : n,
      i = t.initialHeight,
      l = function (e, t, r) {
        var a = He(e);
        return [a[0], Va(a[1], t, r)];
      }("undefined" == typeof document ? [o, void 0 === i ? 0 : i] : qa, r, a),
      s = Le(l, 2),
      c = s[0],
      u = s[1],
      d = function d() {
        return u(qa);
      };
    return Wa(Ya, "resize", d), Wa($a, "resize", d), Wa(Ya, "orientationchange", d), c;
  },
  Xa = {
    name: "SBK - Tablet",
    styles: {
      width: "768px",
      height: "100%"
    }
  },
  Za = Number(null == Xa || null === (e = Xa.styles) || void 0 === e || null === (t = e.width) || void 0 === t ? void 0 : t.replace("px", "")) || 768,
  Qa = function Qa(e) {
    var t = e.oddsRef,
      r = e.selected,
      a = e.oddsState,
      n = e.isLargeOdds,
      o = e.variant,
      i = function (e) {
        return Ja(e)[0];
      }(),
      l = i <= Za,
      s = "boost" === o || "promo" === o,
      c = "promo" === o,
      u = "large" === o;
    return dt.exports.jsx("span", {
      ref: t,
      className: yt({
        "cui-text-fg-inverse": r,
        "cui-text-fg-primary": !r && !c,
        "cui-text-fg-primary-strong": c && !r,
        "cui-text-fg-moderate": a && !r,
        "heading-sm-bold": (!n || n && !l) && !c && !u,
        "heading-xs-bold": n && l && !c && !u,
        "heading-lg-bold": u,
        "group-hover:cui-text-fg-primary-strong": u && !r,
        "group-hover:cui-text-fg-inverse": u && r,
        "cui-text-right heading-xl-bold": c,
        "cui-w-full cui-block": !s,
        "cui-inline-block": s
      }),
      "data-cy": "market-button-odds"
    });
  },
  en = {
    "cui__loading-dot-1": "dots-module_cui__loading-dot-1__GwPlt",
    "cui__loading-dot-2": "dots-module_cui__loading-dot-2__nxcBt",
    "cui__loading-dot-3": "dots-module_cui__loading-dot-3__QZtui",
    fadeinout: "dots-module_fadeinout__ytpRf",
    "cui__loading-dot-inverse": "dots-module_cui__loading-dot-inverse__7J-XP",
    "cui__loading-dot-subtle": "dots-module_cui__loading-dot-subtle__LrYgd",
    darkMode: "dots-module_darkMode__lFVEM"
  },
  tn = function tn(e) {
    var t,
      r = e.index,
      a = e.variant,
      n = e.size;
    "default" === a && (t = ""), "inverse" === a && (t = en["cui__loading-dot-inverse"]), "subtle" === a && (t = en["cui__loading-dot-subtle"]);
    var o = yt({
      "cui-w-1 cui-h-1": "xs" === n,
      "cui-w-2 cui-h-2": "sm" === n,
      "cui-w-3 cui-h-3": "md" === n,
      "cui-w-4 cui-h-4": "lg" === n
    });
    return dt.exports.jsx("div", {
      className: yt([en["cui__loading-dot-".concat(r)], t, o], "cui-rounded-[9999px]")
    });
  },
  rn = function rn(e) {
    var t = e.variant,
      r = void 0 === t ? "default" : t,
      a = e.size,
      n = e.className,
      o = void 0 === n ? "" : n,
      i = a;
    return ["xs", "sm", "md", "lg"].includes(a) || (i = "md"), dt.exports.jsx("div", {
      className: "cui__loading-dots cui-flex cui-gap-1 ".concat(o).trim(),
      role: "progressbar",
      "aria-label": "Loading content",
      children: [1, 2, 3].map(function (e) {
        return dt.exports.jsx(tn, {
          index: e,
          variant: r,
          size: i
        }, "cui__loading-dot-".concat(e));
      })
    });
  },
  an = ["2xs", "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"],
  nn = new Map();
nn.set("2xs", {
  width: 8,
  height: 8
}), nn.set("xs", {
  width: 10,
  height: 10
}), nn.set("sm", {
  width: 12,
  height: 12
}), nn.set("md", {
  width: 16,
  height: 16
}), nn.set("lg", {
  width: 18,
  height: 18
}), nn.set("xl", {
  width: 24,
  height: 24
}), nn.set("2xl", {
  width: 36,
  height: 36
}), nn.set("3xl", {
  width: 48,
  height: 48
}), nn.set("4xl", {
  width: 64,
  height: 64
}), nn.set("5xl", {
  width: 72,
  height: 72
});
var on = function on(e) {
    var t = "string" == typeof e && an.includes(e);
    return {
      sizeClasses: "number" != typeof e ? yt({
        "cui-w-2 cui-h-2": "2xs" === e,
        "cui-w-[10px] cui-h-[10px]": "xs" === e,
        "cui-w-3 cui-h-3": "sm" === e,
        "cui-w-4 cui-h-4": "md" === e || !t,
        "cui-w-[18px] cui-h-[18px]": "lg" === e,
        "cui-w-6 cui-h-6": "xl" === e,
        "cui-w-9 cui-h-9": "2xl" === e,
        "cui-w-12 cui-h-12": "3xl" === e,
        "cui-w-16 cui-h-16": "4xl" === e,
        "cui-w-18 cui-h-18": "5xl" === e
      }, "cui-relative cui-inline-block cui-p-0 cui-m-0 [&>svg]:cui-inline-block cui-box-border !cui-not-italic !cui-text-[0px] !cui-leading-[0px]") : "cui-inline-block cui-box-border !cui-not-italic !cui-text-[0px] !cui-leading-[0px]",
      sizeStyle: t || "number" != typeof e ? {} : {
        width: "".concat(e, "px"),
        height: "".concat(e, "px")
      },
      sizeMap: nn.get(e) || {
        width: e
      }
    };
  },
  ln = "spinner-module_cui__loading-spinner-inverse__nd3k2",
  sn = "spinner-module_cui__loading-spinner-subtle__1t-Lt",
  cn = {
    display: {
      "3xl": "display-3xl",
      "3xl-bold": "display-3xl-bold",
      "2xl": "display-2xl",
      "2xl-bold": "display-2xl-bold",
      xl: "display-xl",
      "xl-bold": "display-xl-bold",
      lg: "display-lg",
      "lg-bold": "display-lg-bold",
      md: "display-md",
      "md-bold": "display-md-bold",
      sm: "display-sm",
      "sm-bold": "display-sm-bold",
      xs: "display-xs",
      "xs-bold": "display-xs-bold"
    },
    heading: {
      "2xl": "heading-2xl",
      "2xl-bold": "heading-2xl-bold",
      xl: "heading-xl",
      "xl-bold": "heading-xl-bold",
      lg: "heading-lg",
      "lg-bold": "heading-lg-bold",
      md: "heading-md",
      "md-bold": "heading-md-bold",
      sm: "heading-sm",
      "sm-bold": "heading-sm-bold",
      xs: "heading-xs",
      "xs-bold": "heading-xs-bold"
    },
    body: {
      xl: "body-xl",
      "xl-bold": "body-xl-bold",
      lg: "body-lg",
      "lg-bold": "body-lg-bold",
      md: "body-md",
      "md-bold": "body-md-bold",
      sm: "body-sm",
      "sm-bold": "body-sm-bold",
      xs: "body-xs",
      "xs-bold": "body-xs-bold"
    }
  },
  un = {
    "fg-default": "var(--fg-default)",
    "fg-moderate": "var(--fg-moderate)",
    "fg-subtle": "var(--fg-subtle)",
    "fg-minimal": "var(--fg-minimal)",
    "fg-inverse": "var(--fg-inverse)",
    "fg-primary": "var(--fg-primary)",
    "fg-primary-strong": "var(--fg-primary-strong)",
    "fg-primary-minimal": "var(--fg-primary-minimal)",
    "fg-global-black": "var(--fg-global-black)",
    "fg-global-white": "var(--fg-global-white)",
    "fg-focus": "var(--fg-focus)",
    "fg-focus-inverse": "var(--fg-focus-inverse)",
    "fg-text-link": "var(--fg-text-link)",
    "bg-base": "var(--bg-base)",
    "bg-default": "var(--bg-default)",
    "bg-layer-one": "var(--bg-layer-one)",
    "bg-layer-two": "var(--bg-layer-two)",
    "bg-layer-three": "var(--bg-layer-three)",
    "bg-primary": "var(--bg-primary)",
    "bg-primary-strong": "var(--bg-primary-strong)",
    "bg-primary-minimal": "var(--bg-primary-minimal)",
    "bg-transparent": "var(--bg-transparent)",
    "status-positive": "var(--status-positive)",
    "status-positive-strong": "var(--status-positive-strong)",
    "status-positive-subtle": "var(--status-positive-subtle)",
    "status-positive-minimal": "var(--status-positive-minimal)",
    "status-negative": "var(--status-negative)",
    "status-negative-strong": "var(--status-negative-strong)",
    "status-negative-subtle": "var(--status-negative-subtle)",
    "status-negative-minimal": "var(--status-negative-minimal)",
    "status-alert": "var(--status-alert)",
    "status-alert-strong": "var(--status-alert-strong)",
    "status-alert-subtle": "var(--status-alert-subtle)",
    "status-alert-minimal": "var(--status-alert-minimal)",
    "status-notification": "var(--status-notification)",
    "status-informational": "var(--status-informational)",
    "status-informational-strong": "var(--status-informational-strong)",
    "status-informational-subtle": "var(--status-informational-subtle)",
    "status-informational-minimal": "var(--status-informational-minimal)",
    "highlight-accent": "var(--highlight-accent)",
    "highlight-accent-strong": "var(--highlight-accent-strong)",
    "highlight-accent-subtle": "var(--highlight-accent-subtle)",
    "highlight-accent-minimal": "var(--highlight-accent-minimal)",
    "highlight-brand": "var(--highlight-brand)",
    "highlight-one": "var(--highlight-one)",
    "highlight-two": "var(--highlight-two)",
    "highlight-three": "var(--highlight-three)",
    "highlight-four": "var(--highlight-four)",
    "rewards-background": "var(--rewards-background)"
  },
  dn = {
    "fg-default": "cui-text-fg-default",
    "fg-moderate": "cui-text-fg-moderate",
    "fg-subtle": "cui-text-fg-subtle",
    "fg-minimal": "cui-text-fg-minimal",
    "fg-inverse": "cui-text-fg-inverse",
    "fg-primary": "cui-text-fg-primary",
    "fg-primary-strong": "cui-text-fg-primary-strong",
    "fg-primary-minimal": "cui-text-fg-primary-minimal",
    "fg-global-black": "cui-text-fg-global-black",
    "fg-global-white": "cui-text-fg-global-white",
    "fg-focus": "cui-text-fg-focus",
    "fg-focus-inverse": "cui-text-fg-focus-inverse",
    "bg-base": "cui-text-bg-base",
    "bg-default": "cui-text-bg-default",
    "bg-layer-one": "cui-text-bg-layer-one",
    "bg-layer-two": "cui-text-bg-layer-two",
    "bg-layer-three": "cui-text-bg-layer-three",
    "bg-primary": "cui-text-bg-primary",
    "bg-primary-strong": "cui-text-bg-primary-strong",
    "bg-primary-minimal": "cui-text-bg-primary-minimal",
    "highlight-accent": "cui-text-highlight-accent",
    "highlight-brand": "cui-text-highlight-brand",
    "highlight-one": "cui-text-highlight-one",
    "highlight-two": "cui-text-highlight-two",
    "highlight-three": "cui-text-highlight-three",
    "highlight-four": "cui-text-highlight-four",
    "status-positive": "cui-text-status-positive",
    "status-negative": "cui-text-status-negative",
    "status-notification": "cui-text-status-notification",
    "status-alert": "cui-text-status-alert",
    "rewards-background": "cui-text-rewards-background"
  },
  pn = {
    "bg-base": "cui-bg-bg-base",
    "bg-default": "cui-bg-bg-default",
    "bg-layer-one": "cui-bg-bg-layer-one",
    "bg-layer-two": "cui-bg-bg-layer-two",
    "bg-layer-three": "cui-bg-bg-layer-three",
    "bg-primary": "cui-bg-bg-primary",
    "bg-primary-strong": "cui-bg-bg-primary-strong",
    "bg-primary-minimal": "cui-bg-bg-primary-minimal",
    "highlight-accent": "cui-bg-highlight-accent",
    "highlight-brand": "cui-bg-highlight-brand",
    "highlight-one": "cui-bg-highlight-one",
    "highlight-two": "cui-bg-highlight-two",
    "highlight-three": "cui-bg-highlight-three",
    "highlight-four": "cui-bg-highlight-four",
    "status-positive": "cui-bg-status-positive",
    "status-negative": "cui-bg-status-negative",
    "status-notification": "cui-bg-status-notification",
    "status-alert": "cui-bg-status-alert",
    "rewards-background": "cui-bg-rewards-background"
  },
  mn = function mn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "body";
    return function (r) {
      var a,
        n = r.children,
        i = r.className,
        l = void 0 === i ? "" : i,
        s = r.color,
        c = void 0 === s ? "fg-default" : s,
        u = r.tag,
        d = void 0 === u ? e : u,
        p = r.size,
        m = void 0 === p ? "md" : p,
        f = Me(r, o),
        v = c in dn ? dn[c] : c;
      return $e(d || "span", Te({
        className: null === (a = yt([cn[t][m in cn[t] ? m : "md"], l, v], "cui-box-border")) || void 0 === a ? void 0 : a.trim()
      }, f), n);
    };
  },
  fn = mn("p", "body"),
  vn = mn("span", "heading"),
  yn = mn("span", "display"),
  gn = function gn(e) {
    var t = e.variant,
      r = void 0 === t ? "default" : t,
      a = e.size,
      n = e.label,
      o = on(a).sizeStyle,
      i = a || "md";
    ["xs", "sm", "md", "lg", "xl", "2xl"].includes(a) || (i = "md");
    var l,
      s = {
        "2xs": "xs-bold",
        xs: "xs-bold",
        sm: "xs-bold",
        md: "xs-bold",
        lg: "xs-bold",
        xl: "sm-bold",
        "2xl": "md-bold",
        "3xl": "lg-bold",
        "4xl": "lg-bold",
        "5xl": "lg-bold"
      }[i];
    return "default" === r && (l = ""), "inverse" === r && (l = ln), "subtle" === r && (l = sn), dt.exports.jsxs("div", {
      className: "cui-inline-flex cui-flex-col cui-items-center cui-justify-center",
      role: "progressbar",
      "aria-label": "Loading content",
      children: [dt.exports.jsx("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 43 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: yt({
          "cui-w-3 cui-h-3": "xs" === a,
          "cui-w-5 cui-h-5": "sm" === a,
          "cui-w-6 cui-h-6": "md" === a,
          "cui-w-9 cui-h-9": "lg" === a,
          "cui-w-12 cui-h-12": "xl" === a,
          "cui-w-16 cui-h-16": "2xl" === a,
          "cui-mb-3": !!n
        }, "cui-animate-spin ".concat(l)),
        style: o,
        children: dt.exports.jsxs("path", {
          d: "M4.78565 33.4401C8.06224 39.1522 14.2209 43 21.2783 43C31.7717 43 40.2783 34.4934 40.2783 24C40.2783 13.5066 31.7717 5 21.2783 5C15.3772 5 10.1044 7.69022 6.61951 11.9111L2.94097 8.51556C7.34341 3.30729 13.9246 0 21.2783 0C34.5331 0 45.2783 10.7452 45.2783 24C45.2783 37.2548 34.5331 48 21.2783 48C12.4367 48 4.71176 43.2189 0.547852 36.1011L4.78565 33.4401Z",
          fill: "var(--fg-primary)",
          children: [dt.exports.jsx("title", {
            children: "Loading Spinner"
          }), dt.exports.jsx("desc", {
            children: "Animated spinning icon indicating loading"
          })]
        })
      }), n ? dt.exports.jsx(yn, {
        size: s,
        className: "cui-max-w-[150px]",
        color: "inverse" === r ? "cui-text-fg-inverse" : "cui-text-fg-default",
        children: n
      }) : null]
    });
  },
  hn = function hn(e) {
    var t = e.size,
      r = void 0 === t ? "md" : t,
      a = e.type,
      n = e.variant,
      o = void 0 === n ? "default" : n,
      l = e.label,
      s = Me(e, i);
    return a && "spinner" !== a ? dt.exports.jsx(rn, Te({
      variant: o,
      size: r
    }, s)) : dt.exports.jsx(gn, Te({
      variant: o,
      size: r,
      label: l
    }, s));
  },
  bn = function bn() {
    return dt.exports.jsx("div", {
      className: "cui-flex cui-flex-col cui-w-full",
      "data-cy": "market-button-placeholder",
      children: dt.exports.jsx("div", {
        className: "cui-text-fg-subtle cui-mx-auto heading-sm-bold",
        children: "--"
      })
    });
  },
  Nn = qe(function (e, t) {
    var r = e.children,
      a = e.variant,
      n = e.isEnabled,
      o = e.className,
      i = e.hasDescription,
      l = e.fluid,
      s = void 0 !== l && l,
      c = e.fullHeight,
      u = void 0 !== c && c,
      d = "large" === a,
      p = "fixed" === a || "highlight" === a;
    return dt.exports.jsx("div", {
      className: yt(Oe({
        "cui-w-[154px]": d && !s,
        "cui-h-auto cui-min-h-[142px]": d && !u,
        "cui-h-[50px]": !d && !u,
        "cui-h-full": u,
        "cui-w-[60px] sbk-tablet:cui-w-[114px] sbk-desktop:cui-w-full sbk-desktop:cui-max-w-[264px]": p && !s && !i,
        "cui-w-full": "fluid" === a || s || i,
        "cui-pointer-events-none": !n
      }, o || "", !0), "cui__market-button-wrapper [&_*]:cui-box-border cui-relative cui-rounded-[2px] cui-group"),
      ref: t,
      children: r
    });
  }),
  xn = function xn(e) {
    var t = e.children,
      r = e.variant,
      a = "boost" === r || "promo" === r;
    return dt.exports.jsx("div", {
      className: yt({
        "cui-grid-cols-1 cui-w-full": "boost" !== r && "promo" !== r,
        "cui-grid-cols-[auto,1fr] cui-w-auto cui-gap-x-2xs cui-px-xs": a
      }, "cui-grid cui-items-center cui-justify-center cui-overflow-hidden"),
      children: t
    });
  },
  kn = function kn(e) {
    var t = e.isVariantLarge,
      r = e.icon,
      a = e.line,
      n = e.isSelected,
      o = e.description,
      i = e.lineRef,
      l = e.lineLabel,
      s = e.selected,
      c = e.variant;
    return o ? dt.exports.jsxs("div", {
      className: yt({
        "cui-flex": !t,
        "cui-flex-col": t
      }, "cui-items-center cui-justify-center"),
      children: [dt.exports.jsx("span", {
        className: yt({
          "cui-mr-2xs body-xs-bold -cui-mb-[2px]": !t,
          "cui-mb-xs cui-flex cui-items-center cui-justify-center": t
        }),
        children: r
      }), dt.exports.jsxs("div", {
        className: yt({
          "cui-px-2 cui-mb-2xs": t
        }, "cui-flex cui-items-start cui-justify-center"),
        children: [dt.exports.jsx("span", {
          className: yt({
            "cui-mr-2xs": !!a,
            "cui-text-fg-inverse": n,
            "heading-sm": !t,
            "heading-lg": t,
            "!cui-leading-1": !t
          }),
          children: o
        }), dt.exports.jsx(Aa, {
          variant: c,
          lineRef: i,
          selected: s,
          lineLabel: l,
          hasLine: !!a
        })]
      })]
    }) : null;
  },
  wn = Array.isArray,
  _n = wn,
  Fn = aa,
  Sn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  Cn = /^\w*$/;
var jn = function jn(e, t) {
    if (_n(e)) return !1;
    var r = ze(e);
    return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Fn(e)) || Cn.test(e) || !Sn.test(e) || null != t && e in Object(t);
  },
  En = Qr,
  Tn = Tr;
var On,
  An = function An(e) {
    if (!Tn(e)) return !1;
    var t = En(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
  },
  Mn = Lr["__core-js_shared__"],
  Ln = (On = /[^.]+$/.exec(Mn && Mn.keys && Mn.keys.IE_PROTO || "")) ? "Symbol(src)_1." + On : "";
var Dn = function Dn(e) {
    return !!Ln && Ln in e;
  },
  Bn = Function.prototype.toString;
var Pn = function Pn(e) {
    if (null != e) {
      try {
        return Bn.call(e);
      } catch (e) {}
      try {
        return e + "";
      } catch (e) {}
    }
    return "";
  },
  In = An,
  zn = Dn,
  Rn = Tr,
  Un = Pn,
  Hn = /^\[object .+?Constructor\]$/,
  Gn = Function.prototype,
  Vn = Object.prototype,
  Wn = Gn.toString,
  Kn = Vn.hasOwnProperty,
  Yn = RegExp("^" + Wn.call(Kn).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var $n = function $n(e) {
    return !(!Rn(e) || zn(e)) && (In(e) ? Yn : Hn).test(Un(e));
  },
  qn = function qn(e, t) {
    return null == e ? void 0 : e[t];
  };
var Jn = function Jn(e, t) {
    var r = qn(e, t);
    return $n(r) ? r : void 0;
  },
  Xn = Jn(Object, "create"),
  Zn = Xn;
var Qn = function Qn() {
  this.__data__ = Zn ? Zn(null) : {}, this.size = 0;
};
var eo = function eo(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  },
  to = Xn,
  ro = Object.prototype.hasOwnProperty;
var ao = function ao(e) {
    var t = this.__data__;
    if (to) {
      var r = t[e];
      return "__lodash_hash_undefined__" === r ? void 0 : r;
    }
    return ro.call(t, e) ? t[e] : void 0;
  },
  no = Xn,
  oo = Object.prototype.hasOwnProperty;
var io = Xn;
var lo = Qn,
  so = eo,
  co = ao,
  uo = function uo(e) {
    var t = this.__data__;
    return no ? void 0 !== t[e] : oo.call(t, e);
  },
  po = function po(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = io && void 0 === t ? "__lodash_hash_undefined__" : t, this;
  };
function mo(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
mo.prototype.clear = lo, mo.prototype.delete = so, mo.prototype.get = co, mo.prototype.has = uo, mo.prototype.set = po;
var fo = mo;
var vo = function vo() {
  this.__data__ = [], this.size = 0;
};
var yo = function yo(e, t) {
    return e === t || e != e && t != t;
  },
  go = yo;
var ho = function ho(e, t) {
    for (var r = e.length; r--;) if (go(e[r][0], t)) return r;
    return -1;
  },
  bo = ho,
  No = Array.prototype.splice;
var xo = function xo(e) {
    var t = this.__data__,
      r = bo(t, e);
    return !(r < 0) && (r == t.length - 1 ? t.pop() : No.call(t, r, 1), --this.size, !0);
  },
  ko = ho;
var wo = function wo(e) {
    var t = this.__data__,
      r = ko(t, e);
    return r < 0 ? void 0 : t[r][1];
  },
  _o = ho;
var Fo = ho;
var So = function So(e, t) {
    var r = this.__data__,
      a = Fo(r, e);
    return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
  },
  Co = vo,
  jo = xo,
  Eo = wo,
  To = function To(e) {
    return _o(this.__data__, e) > -1;
  },
  Oo = So;
function Ao(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Ao.prototype.clear = Co, Ao.prototype.delete = jo, Ao.prototype.get = Eo, Ao.prototype.has = To, Ao.prototype.set = Oo;
var Mo = Ao,
  Lo = Jn(Lr, "Map"),
  Do = fo,
  Bo = Mo,
  Po = Lo;
var Io = function Io(e) {
  var t = ze(e);
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
};
var zo = function zo(e, t) {
    var r = e.__data__;
    return Io(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
  },
  Ro = zo;
var Uo = zo;
var Ho = zo;
var Go = zo;
var Vo = function Vo(e, t) {
    var r = Go(this, e),
      a = r.size;
    return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
  },
  Wo = function Wo() {
    this.size = 0, this.__data__ = {
      hash: new Do(),
      map: new (Po || Bo)(),
      string: new Do()
    };
  },
  Ko = function Ko(e) {
    var t = Ro(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  },
  Yo = function Yo(e) {
    return Uo(this, e).get(e);
  },
  $o = function $o(e) {
    return Ho(this, e).has(e);
  },
  qo = Vo;
function Jo(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Jo.prototype.clear = Wo, Jo.prototype.delete = Ko, Jo.prototype.get = Yo, Jo.prototype.has = $o, Jo.prototype.set = qo;
var Xo = Jo,
  Zo = Xo;
function Qo(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
  var r = function r() {
    var a = arguments,
      n = t ? t.apply(this, a) : a[0],
      o = r.cache;
    if (o.has(n)) return o.get(n);
    var i = e.apply(this, a);
    return r.cache = o.set(n, i) || o, i;
  };
  return r.cache = new (Qo.Cache || Zo)(), r;
}
Qo.Cache = Zo;
var ei = Qo;
var ti = function ti(e) {
    var t = ei(e, function (e) {
        return 500 === r.size && r.clear(), e;
      }),
      r = t.cache;
    return t;
  },
  ri = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  ai = /\\(\\)?/g,
  ni = ti(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(ri, function (e, r, a, n) {
      t.push(a ? n.replace(ai, "$1") : r || e);
    }), t;
  });
var oi = function oi(e, t) {
    for (var r = -1, a = null == e ? 0 : e.length, n = Array(a); ++r < a;) n[r] = t(e[r], r, e);
    return n;
  },
  ii = oi,
  li = wn,
  si = aa,
  ci = Hr ? Hr.prototype : void 0,
  ui = ci ? ci.toString : void 0;
var di = function e(t) {
    if ("string" == typeof t) return t;
    if (li(t)) return ii(t, e) + "";
    if (si(t)) return ui ? ui.call(t) : "";
    var r = t + "";
    return "0" == r && 1 / t == -Infinity ? "-0" : r;
  },
  pi = di;
var mi = function mi(e) {
    return null == e ? "" : pi(e);
  },
  fi = wn,
  vi = jn,
  yi = ni,
  gi = mi;
var hi = aa;
var bi = function bi(e, t) {
    return fi(e) ? e : vi(e, t) ? [e] : yi(gi(e));
  },
  Ni = function Ni(e) {
    if ("string" == typeof e || hi(e)) return e;
    var t = e + "";
    return "0" == t && 1 / e == -Infinity ? "-0" : t;
  };
var xi = function xi(e, t) {
    for (var r = 0, a = (t = bi(t, e)).length; null != e && r < a;) e = e[Ni(t[r++])];
    return r && r == a ? e : void 0;
  },
  ki = xi;
var wi = function wi(e, t, r) {
    var a = null == e ? void 0 : ki(e, t);
    return void 0 === a ? r : a;
  },
  _i = function _i(e) {
    var t = e.odds,
      r = e.bet,
      a = e.text,
      n = void 0 === a ? "Bet Wins" : a,
      o = e.selected,
      i = e.className,
      s = e.setExplainerText,
      c = Me(e, l);
    if (!t) return null;
    var u = bt(t),
      d = u.exactOdds ? r * u.exactOdds - r : 0;
    return Ve(function () {
      s("$".concat(r, " ").concat(n, " $").concat(d.toFixed(2).replace(".00", "")));
    }, [r, n]), dt.exports.jsxs("div", Te(Te({
      className: "cui-flex ".concat(i)
    }, c), {}, {
      "data-cy": "market-button-explainer",
      children: [dt.exports.jsxs("span", {
        className: yt({
          "cui-text-fg-moderate": !o,
          "cui-text-fg-inverse": o
        }, "heading-sm-bold"),
        children: ["$", r, " ", n]
      }), dt.exports.jsxs("span", {
        className: yt({
          "cui-text-fg-primary": !o,
          "cui-text-fg-inverse": o
        }, "heading-sm-bold cui-ml-2xs"),
        children: ["$", d.toFixed(2).replace(".00", "")]
      })]
    }));
  },
  Fi = function Fi(e) {
    var t = e.promoText,
      r = e.variant,
      a = e.odds,
      n = e.selected,
      o = e.setExplainerText,
      i = wi(t, "bet", null);
    return t && "promo" === r ? "object" === ze(t) && i ? dt.exports.jsx(_i, {
      className: "cui-mt-2px",
      bet: i,
      odds: a,
      selected: n,
      setExplainerText: o
    }) : Je(t) ? t : dt.exports.jsx("div", {
      className: "heading-md cui-text-left",
      children: t
    }) : null;
  },
  Si = "Was-module_diagonal__nAkKP",
  Ci = "Was-module_diagonal-inverse__tySem",
  ji = function ji(e) {
    var t,
      r = e.children,
      a = e.variant,
      n = e.selected;
    return "boost" === a && r ? dt.exports.jsx("div", {
      className: "cui-relative",
      "data-cy": "market-button-was-price",
      children: dt.exports.jsx("div", {
        className: yt((t = {}, Oe(t, "".concat(Ci, " cui-text-fg-inverse"), n), Oe(t, Si, !n), t), "body-sm"),
        children: r
      })
    }) : null;
  },
  Ei = {
    highlight: "MarketButton-module_highlight__kS-r6"
  },
  Ti = {
    BASE: "cui-border-1 cui-border-solid cui-bg-bg-layer-one active:cui-bg-bg-primary-minimal cui-text-fg-default cui-border-fg-primary-minimal cui-z-0 cui-h-full",
    BASE_LARGE: "cui-group cui-border-1 cui-border-solid cui-bg-bg-layer-one active:cui-bg-bg-primary-minimal hover:cui-bg-bg-layer-two cui-text-fg-default cui-border-fg-primary-minimal cui-z-0 cui-h-full",
    SELECTED: "cui-border-1 cui-border-solid cui-border-fg-primary-strong cui-bg-bg-primary-strong hover:cui-bg-bg-primary active:cui-bg-bg-primary cui-text-fg-inverse",
    SELECTED_LARGE: "cui-border-1 cui-border-solid cui-border-fg-primary-strong cui-bg-fg-default hover:cui-bg-bg-primary cui-text-fg-inverse cui-h-full",
    HIGHLIGHT: Ei ? Ei.highlight : "",
    BOOSTED: "cui__market-button-boosted",
    PROMO: "cui__market-button-promo",
    FOCUSED: "focus-visible:cui-outline focus-visible:cui-outline-offset-2 focus-visible:cui-outline-2 focus-visible:cui-outline-fg-focus",
    DISABLED: "cui__market-button-disabled cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
    STRIKETHROUGH: "cui__market-button-strikethrough cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
    PLACEHOLDER: "cui__market-button-placeholder cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
    LOADING: "cui__market-button-loading cui-border-1 cui-border-solid cui-bg-bg-layer-one cui-text-fg-default cui-border-fg-primary-minimal cui-pointer-events-none"
  },
  Oi = ["over", "under"];
var Ai = function Ai() {},
  Mi = function Mi(e) {
    var t,
      r = e.id,
      a = e.odds,
      n = void 0 === a ? "" : a,
      o = e.line,
      i = void 0 === o ? "" : o,
      l = e.lineLabel,
      c = e.isSelected,
      u = void 0 !== c && c,
      d = e.isLoading,
      p = void 0 !== d && d,
      m = e.isDisabled,
      f = void 0 !== m && m,
      v = e.isStrikethrough,
      y = void 0 !== v && v,
      g = e.isPlaceholder,
      h = void 0 !== g && g,
      b = e.variant,
      N = void 0 === b ? "fixed" : b,
      x = e.animation,
      k = void 0 === x ? "default" : x,
      w = e.description,
      _ = e.icon,
      F = e.fluid,
      S = e.fullHeight,
      C = e.promoText,
      j = e.was,
      E = e.tabbable,
      T = void 0 === E || E,
      O = e.metadata,
      A = void 0 === O ? {} : O,
      M = e.onClick,
      L = void 0 === M ? Ai : M,
      D = Me(e, s),
      B = Le(He(u), 2),
      P = B[0],
      I = B[1],
      z = Le(He(!1), 2),
      R = (z[0], z[1]),
      U = Le(He(""), 2),
      H = U[0],
      G = U[1],
      V = Le(He(k), 2),
      W = V[0],
      K = V[1],
      Y = bt(n || "EVS"),
      $ = Le(wt({
        odds: Y.exactOdds,
        oddsType: Y.type,
        delay: xt.blinkDuration[W]
      }), 1)[0],
      q = Ge(null),
      J = Ge(null),
      X = Ge({
        parsedOdds: Y,
        line: i
      }),
      Z = Ge(u),
      Q = Ge(null),
      ee = Xe(function () {
        return {
          UP: "UP" === $,
          DOWN: "DOWN" === $,
          EVEN: "EVEN" === $
        };
      }, [$]),
      te = N.toLowerCase(),
      re = "boost" === te,
      ae = "promo" === te,
      ne = !!l && Oi.includes(l.toLowerCase()),
      oe = !(p || f || y || h),
      ie = !1;
    null !== n && (ie = "string" == typeof n ? n.length > 6 : n.toString().length > 6);
    var le,
      se,
      ce,
      ue,
      de,
      pe,
      me,
      fe = "large" === te,
      ve = Xe(function () {
        return function (e, t, r, a, n, o, i, l, s, c) {
          var u = c.displayName,
            d = c.team,
            p = c.columnHeader,
            m = c.marketName,
            f = c.marketTemplateTitle,
            v = u && "".concat(u, ","),
            y = d && d !== u ? "".concat(d, ",") : "",
            g = m && "".concat(m, ","),
            h = f && "".concat(f, ","),
            b = p && "".concat(p, ","),
            N = e || "",
            x = t ? "boosted" : "",
            k = r ? "promotional" : "",
            w = s ? ", a ".concat(s) : "",
            _ = t && a ? "before boost, odds were ".concat(a) : "",
            F = n && o && i ? "".concat(n.toLowerCase(), " ").concat(i) : "",
            S = i && !o ? "with a ".concat(i) : "",
            C = n && !o ? n.toLowerCase() : i && !o ? "line" : "",
            j = l ? "odds at ".concat(l) : "";
          return "".concat(h, " ").concat(null != v ? v : g, " ").concat(y, " ").concat(b, " ").concat(N, " ").concat(F, " ").concat(x, " ").concat(k, " ").concat(j).concat(w, " ").concat(_, " ").concat(S, " ").concat(C).replace(/undefined/g, "").trim().replace(/  +/g, " ");
        }(w, re, ae, j, l, ne, i, n, H, A);
      }, [w, re, ae, j, l, ne, i, n, H, A]),
      ye = !P && oe && !fe,
      ge = yt((Oe(t = {}, Ti.BASE, ye), Oe(t, Ti.BASE_LARGE, !P && oe && fe), Oe(t, Ti.FOCUSED, !0), Oe(t, Ti.HIGHLIGHT, "highlight" === N && !P && oe), Oe(t, Ti.STRIKETHROUGH, y), Oe(t, Ti.PLACEHOLDER, h || null === n), Oe(t, Ti.LOADING, p), Oe(t, Ti.DISABLED, f), Oe(t, "".concat(Ti.BASE, " cui__market-button-odds-states"), ee.UP || ee.DOWN), Oe(t, Ti.SELECTED, P && oe && !fe), Oe(t, Ti.SELECTED_LARGE, P && oe && fe), Oe(t, "cui-h-full", !fe), Oe(t, "cui-py-sm cui-min-h-[144px]", fe), Oe(t, "hover:cui-bg-bg-primary-minimal", ye), t), "cui__market-button cui-z-0 cui-rounded-2px cui-outline-none cui-box-border cui-border-1 cui-relative cui-transition-all cui-duration-200 cui-w-full cui-p-0 cui-m-0 cui-inline-flex cui-flex-col cui-justify-center cui-items-center cui-relative cui-cursor-pointer cui-select-none"),
      he = function he() {
        R(function (e) {
          return !e;
        });
      };
    return se = (le = {
      refs: [Q],
      onVisible: function onVisible(e) {
        K(k);
      },
      onInvisible: function onInvisible(e) {
        K("off");
      }
    }).refs, ce = le.onVisible, ue = le.onInvisible, de = void 0 === ue ? function () {} : ue, pe = le.ioConfig, me = void 0 === pe ? _t : pe, Ve(function () {
      var e = new IntersectionObserver(function (e) {
        return e.forEach(function (e) {
          return e.isIntersecting ? ce(e) : de && de(e);
        });
      }, me);
      return se.forEach(function (t) {
        return t.current && e.observe(t.current);
      }), function () {
        se.forEach(function (t) {
          return t.current && e.unobserve(t.current);
        });
      };
    }, []), Ve(function () {
      I(u), Z.current = u, K(k);
    }, [u, k]), Fa({
      prevOdds: X,
      parseOdds: bt,
      line: i,
      odds: n,
      lineRef: J,
      oddsRef: q,
      animationState: W,
      parsedOdds: Y,
      animationOptions: xt,
      description: w,
      isEnabled: oe
    }), null === n ? dt.exports.jsx(Nn, {
      variant: te,
      isEnabled: !1,
      hasDescription: !1,
      fluid: F,
      children: dt.exports.jsx("div", {
        className: ge,
        children: dt.exports.jsx(bn, {})
      })
    }) : oe ? dt.exports.jsxs(Nn, {
      variant: te,
      isEnabled: oe,
      ref: Q,
      hasDescription: !!w,
      fluid: F,
      fullHeight: S,
      children: [!p && "off" !== W && dt.exports.jsx(Ha, {
        isSelected: u,
        prevState: Z.current,
        variant: te
      }), dt.exports.jsx("button", Te(Te({
        id: "market-button-".concat(r),
        type: "button",
        role: "switch",
        tabIndex: T ? 0 : -1,
        "aria-checked": P,
        "aria-disabled": f,
        "aria-label": ve,
        disabled: f,
        className: ge
      }, D), {}, {
        onClick: function onClick(e) {
          return L(e, r);
        },
        onFocus: he,
        onBlur: he,
        "data-cy": "market-button-btn",
        children: dt.exports.jsxs(dt.exports.Fragment, {
          children: [dt.exports.jsx(Ta, {
            oddsState: ee,
            selected: P,
            id: r,
            isViewable: Y.type === X.current.parsedOdds.type,
            animation: W
          }), w ? dt.exports.jsx(kn, {
            isVariantLarge: fe,
            isSelected: u,
            selected: P,
            description: w,
            line: i,
            lineLabel: l,
            lineRef: J,
            variant: te,
            icon: _
          }) : dt.exports.jsx(Aa, {
            variant: te,
            lineRef: J,
            selected: P,
            lineLabel: l,
            hasLine: !!i
          }), dt.exports.jsxs(xn, {
            variant: te,
            children: [dt.exports.jsx(ji, {
              variant: te,
              selected: P,
              children: j
            }), dt.exports.jsx(Qa, {
              oddsRef: q,
              selected: P,
              oddsState: ee.DOWN,
              isLargeOdds: ie,
              variant: te
            }), dt.exports.jsx(Fi, {
              promoText: C,
              variant: te,
              odds: n,
              selected: P,
              setExplainerText: G
            })]
          })]
        })
      }))]
    }) : dt.exports.jsx(Nn, {
      variant: te,
      isEnabled: oe,
      ref: Q,
      hasDescription: !!w,
      fluid: F,
      fullHeight: S,
      children: dt.exports.jsxs("div", {
        className: ge,
        children: [p && dt.exports.jsx(hn, {
          size: "sm",
          type: "dots"
        }), f && !p && dt.exports.jsx(Oa, {
          className: yt({
            "cui-w-10 cui-h-10": fe
          }, "cui-fill-fg-bold"),
          "data-cy": "market-button-lock"
        }), h && !p && !f && dt.exports.jsx(bn, {}), !y || p || f || h ? null : dt.exports.jsx("div", {
          className: "cui-flex cui-flex-col cui-w-full",
          "data-cy": "market-button-strikethrough",
          children: dt.exports.jsx("div", {
            className: "cui-line-through cui-text-fg-moderate cui-mx-auto",
            children: n
          })
        })]
      })
    });
  };
Mi.Explainer = _i;
var Li = (Oe(r = {
    brandCzrRewards: function brandCzrRewards() {
      return import("./brand_czr-rewards-a5ac547a.js");
    },
    brandCcStripeColor: function brandCcStripeColor() {
      return import("./brand_cc-stripe-color-1354225b.js");
    },
    brandCcPaypalColor1: function brandCcPaypalColor1() {
      return import("./brand_cc-paypal-color-1-05634332.js");
    },
    brandCcAppleColor: function brandCcAppleColor() {
      return import("./brand_cc-apple-color-ebb32645.js");
    },
    brandCcGoogleColor: function brandCcGoogleColor() {
      return import("./brand_cc-google-color-d13415f6.js");
    },
    brandCcAmexColor: function brandCcAmexColor() {
      return import("./brand_cc-amex-color-d4310c46.js");
    },
    brandCcMastercardColor: function brandCcMastercardColor() {
      return import("./brand_cc-mastercard-color-ea22b23c.js");
    },
    brandNbaPlayoffsColorOnLight: function brandNbaPlayoffsColorOnLight() {
      return import("./brand_nba-playoffs-color_onLight-be9ca29e.js");
    },
    brandNbaPlayoffsColorOnDark: function brandNbaPlayoffsColorOnDark() {
      return import("./brand_nba-playoffs-color_onDark-6d1309fa.js");
    },
    brandNbaChampionshipColorOnLight: function brandNbaChampionshipColorOnLight() {
      return import("./brand_nba-championship-color_onLight-19115a73.js");
    },
    brandNbaChampionshipColorOnDark: function brandNbaChampionshipColorOnDark() {
      return import("./brand_nba-championship-color_onDark-475170b9.js");
    },
    brandCcCitiColor: function brandCcCitiColor() {
      return import("./brand_cc-citi-color-e8ea9f99.js");
    },
    brandPennResponsibleGamingColor: function brandPennResponsibleGamingColor() {
      return import("./brand_penn-responsible-gaming_color-34f9c91d.js");
    },
    brandCcVipPreferredColor: function brandCcVipPreferredColor() {
      return import("./brand_cc-vip-preferred-color-836fb2b2.js");
    },
    brandCcPlayPlusColor: function brandCcPlayPlusColor() {
      return import("./brand_cc-play-plus-color-5e76bec6.js");
    },
    brandCcPayNearMeColor: function brandCcPayNearMeColor() {
      return import("./brand_cc-pay-near-me-color-1b4d3778.js");
    },
    brandCcOnlineBankingColor: function brandCcOnlineBankingColor() {
      return import("./brand_cc-online-banking-color-cbd1b1d9.js");
    },
    brandResponsibleGamingStamp: function brandResponsibleGamingStamp() {
      return import("./brand_responsible-gaming-stamp-99027ba3.js");
    },
    brandWvLottery: function brandWvLottery() {
      return import("./brand_wv-lottery-810610bf.js");
    },
    brandGamesenseColor: function brandGamesenseColor() {
      return import("./brand_gamesense-color-10eada4d.js");
    },
    brandCpoResponsibleGaming: function brandCpoResponsibleGaming() {
      return import("./brand_cpo-responsible-gaming-725124a8.js");
    },
    brandCpoResponsibleGamingColor: function brandCpoResponsibleGamingColor() {
      return import("./brand_cpo-responsible-gaming_color-3a5f4972.js");
    },
    brandCpoCopyLogo: function brandCpoCopyLogo() {
      return import("./brand_cpo-copy-logo-0346dd23.js");
    },
    brandCpoFullLogo: function brandCpoFullLogo() {
      return import("./brand_cpo-full-logo-355b6b6e.js");
    },
    brandWhResponsibleGaming: function brandWhResponsibleGaming() {
      return import("./brand_wh-responsible-gaming-09e91f1e.js");
    },
    brandCcAfterpayColor: function brandCcAfterpayColor() {
      return import("./brand_cc-afterpay-color-7124229a.js");
    },
    brandCcDiscoverColor: function brandCcDiscoverColor() {
      return import("./brand_cc-discover-color-f65a7e92.js");
    },
    brandCcVisaColor: function brandCcVisaColor() {
      return import("./brand_cc-visa-color-55ad97b5.js");
    },
    brandHorseshoeColorOnDark: function brandHorseshoeColorOnDark() {
      return import("./brand_horseshoe-color_onDark-ecd3bc9f.js");
    },
    brandHorseshoeHorseshoe: function brandHorseshoeHorseshoe() {
      return import("./brand_horseshoe-horseshoe-ba3c74e8.js");
    },
    brandHorseshoeHorseshoeColor: function brandHorseshoeHorseshoeColor() {
      return import("./brand_horseshoe-horseshoe-color-7fcffc4e.js");
    },
    brandHorseshoe: function brandHorseshoe() {
      return import("./brand_horseshoe-a09e7ae4.js");
    },
    brandHorseshoeColorOnLight: function brandHorseshoeColorOnLight() {
      return import("./brand_horseshoe-color_onLight-c29f5370.js");
    },
    brandNhlOnLight: function brandNhlOnLight() {
      return import("./brand_nhl_onLight-9c456ccb.js");
    },
    brandWilliamHillMonogramColorOnLight: function brandWilliamHillMonogramColorOnLight() {
      return import("./brand_william-hill-monogram_color_onLight-bbd53073.js");
    },
    brandWilliamHillMonogramColorOnDark: function brandWilliamHillMonogramColorOnDark() {
      return import("./brand_william-hill-monogram_color_onDark-012897e1.js");
    },
    brandNhlOnDark: function brandNhlOnDark() {
      return import("./brand_nhl_onDark-286c0329.js");
    },
    brandNflOnLight: function brandNflOnLight() {
      return import("./brand_nfl_onLight-004cc3bf.js");
    },
    brandNflOnDark: function brandNflOnDark() {
      return import("./brand_nfl_onDark-dd81c154.js");
    },
    brandNbaOnLight: function brandNbaOnLight() {
      return import("./brand_nba_onLight-88403021.js");
    },
    brandNbaOnDark: function brandNbaOnDark() {
      return import("./brand_nba_onDark-63177029.js");
    },
    brandMlbOnLight: function brandMlbOnLight() {
      return import("./brand_mlb_onLight-22831cf9.js");
    },
    brandMlbOnDark: function brandMlbOnDark() {
      return import("./brand_mlb_onDark-6e07aa50.js");
    },
    brandWilliamHillColorOnDark: function brandWilliamHillColorOnDark() {
      return import("./brand_william-hill_color_onDark-27f7147a.js");
    },
    brandWilliamHillColorOnLight: function brandWilliamHillColorOnLight() {
      return import("./brand_william-hill_color_onLight-788ba7ba.js");
    },
    brandCaesarsSportsbookColorOnLight: function brandCaesarsSportsbookColorOnLight() {
      return import("./brand_caesars-sportsbook-color_onLight-35234635.js");
    },
    brandCaesarsSportsbookColorOnDark: function brandCaesarsSportsbookColorOnDark() {
      return import("./brand_caesars-sportsbook-color_onDark-c4536388.js");
    },
    brandCaesarsSportsbookCasinoColorOnDark: function brandCaesarsSportsbookCasinoColorOnDark() {
      return import("./brand_caesars-sportsbook-casino-color_onDark-b698c205.js");
    },
    brandCaesarsSportsbookCasino: function brandCaesarsSportsbookCasino() {
      return import("./brand_caesars-sportsbook-casino-f1e92cbf.js");
    },
    brandCaesarsSportsbookCasinoColorOnLight: function brandCaesarsSportsbookCasinoColorOnLight() {
      return import("./brand_caesars-sportsbook-casino-color_onLight-82e24fae.js");
    },
    brandCaesarsSportsbook: function brandCaesarsSportsbook() {
      return import("./brand_caesars-sportsbook-3ee5fbf5.js");
    },
    brandCzrRewardsCredits: function brandCzrRewardsCredits() {
      return import("./brand_czr-rewards-credits-1a2d85f2.js");
    },
    brandCzrProfileLaurel: function brandCzrProfileLaurel() {
      return import("./brand_czr-profile-laurel-9952a5ce.js");
    },
    brandCzrResponsibleGamingColor: function brandCzrResponsibleGamingColor() {
      return import("./brand_czr-responsible-gaming_color-57c68c41.js");
    },
    brandCzrRewardsDiamondColor: function brandCzrRewardsDiamondColor() {
      return import("./brand_czr-rewards-diamond_color-58a5d3ca.js");
    },
    brandCzrRewardsDiamondEliteColor: function brandCzrRewardsDiamondEliteColor() {
      return import("./brand_czr-rewards-diamond-elite_color-1612bffe.js");
    },
    brandCzrRewardsGoldColor: function brandCzrRewardsGoldColor() {
      return import("./brand_czr-rewards-gold_color-611219aa.js");
    },
    brandCzrRewardsSevenStarsColor: function brandCzrRewardsSevenStarsColor() {
      return import("./brand_czr-rewards-seven-stars_color-5a6fbfdb.js");
    },
    brandCzrRewardsPlatinumColor: function brandCzrRewardsPlatinumColor() {
      return import("./brand_czr-rewards-platinum_color-b0bc1dda.js");
    },
    brandCzrRewardsDiamondPlusColor: function brandCzrRewardsDiamondPlusColor() {
      return import("./brand_czr-rewards-diamond-plus_color-37f625f5.js");
    },
    brandCbsSports: function brandCbsSports() {
      return import("./brand_cbs-sports-f8a75af7.js");
    },
    brandEspn: function brandEspn() {
      return import("./brand_espn-098f964a.js");
    },
    brandCzrGobletAppColorOnDark: function brandCzrGobletAppColorOnDark() {
      return import("./brand_czr-goblet-app_color_onDark-5166e4de.js");
    },
    brandCzrGobletAppColorOnLight: function brandCzrGobletAppColorOnLight() {
      return import("./brand_czr-goblet-app_color_onLight-b1c09346.js");
    },
    brandTiktok: function brandTiktok() {
      return import("./brand_tiktok-c8287900.js");
    },
    brandX: function brandX() {
      return import("./brand_x-2311923d.js");
    },
    brandTwitter: function brandTwitter() {
      return import("./brand_twitter-4bd57125.js");
    },
    brandInstagram: function brandInstagram() {
      return import("./brand_instagram-643ca2ae.js");
    },
    brandFacebook: function brandFacebook() {
      return import("./brand_facebook-d2a9f977.js");
    },
    brandStorybookColor: function brandStorybookColor() {
      return import("./brand_storybook_color-5670645b.js");
    },
    brandStorybook: function brandStorybook() {
      return import("./brand_storybook-92c62437.js");
    },
    brandCzrGptColor: function brandCzrGptColor() {
      return import("./brand_czr-gpt_color-7c5544d4.js");
    },
    brandCzrLaurel: function brandCzrLaurel() {
      return import("./brand_czr-laurel-886eb65c.js");
    },
    brandTurtleCreek: function brandTurtleCreek() {
      return import("./brand_turtle-creek-28de5b0b.js");
    },
    brandOntarioIgamingColor: function brandOntarioIgamingColor() {
      return import("./brand_ontario-igaming_color-1b170198.js");
    },
    brandHarrahsPhiladelphia: function brandHarrahsPhiladelphia() {
      return import("./brand_harrahs-philadelphia-4646c277.js");
    },
    brandCaesarsPalaceColor: function brandCaesarsPalaceColor() {
      return import("./brand_caesars-palace_color-fcc399a3.js");
    },
    brandCaesarsPalace: function brandCaesarsPalace() {
      return import("./brand_caesars-palace-0706c7ce.js");
    },
    brandNjResponsibleGamingColor: function brandNjResponsibleGamingColor() {
      return import("./brand_nj-responsible-gaming_color-ac0ef895.js");
    },
    brandResponsibleGaming: function brandResponsibleGaming() {
      return import("./brand_responsible-gaming-29e190d8.js");
    },
    brandCzrGobletOutline: function brandCzrGobletOutline() {
      return import("./brand_czr-goblet_outline-48b89322.js");
    },
    brandCzrGobletCircle: function brandCzrGobletCircle() {
      return import("./brand_czr-goblet-circle-12da189b.js");
    },
    brandCzrGoblet: function brandCzrGoblet() {
      return import("./brand_czr-goblet-de58bf2d.js");
    },
    brandCaesarsMdmColor: function brandCaesarsMdmColor() {
      return import("./brand_caesars-mdm_color-f98d2835.js");
    },
    brandWsopColorOnDark: function brandWsopColorOnDark() {
      return import("./brand_wsop_color_onDark-61111b59.js");
    },
    brandWsopColorOnLight: function brandWsopColorOnLight() {
      return import("./brand_wsop_color_onLight-0e04b515.js");
    },
    brandWsop: function brandWsop() {
      return import("./brand_wsop-40e80662.js");
    },
    flagChina: function flagChina() {
      return import("./flag_china-1c98f682.js");
    },
    flagSaintVincentGrenadines: function flagSaintVincentGrenadines() {
      return import("./flag_saint-vincent-grenadines-79e42671.js");
    },
    flagWales: function flagWales() {
      return import("./flag_wales-65429d74.js");
    },
    flagScotland: function flagScotland() {
      return import("./flag_scotland-a304c0ab.js");
    },
    flagRefugeeOlympicTeam: function flagRefugeeOlympicTeam() {
      return import("./flag_refugee-olympic-team-d608e093.js");
    },
    flagIndividualNeutralAthlete: function flagIndividualNeutralAthlete() {
      return import("./flag_individual-neutral-athlete-f4fb86c3.js");
    },
    flagPlaceholder: function flagPlaceholder() {
      return import("./flag_placeholder-e4dac168.js");
    },
    flagAruba: function flagAruba() {
      return import("./flag_aruba-9e6ef596.js");
    },
    flagBhutan: function flagBhutan() {
      return import("./flag_bhutan-ae7bf56d.js");
    },
    flagGuam: function flagGuam() {
      return import("./flag_guam-c5dd20d8.js");
    },
    flagSolomonIslands: function flagSolomonIslands() {
      return import("./flag_solomon-islands-5d93857d.js");
    },
    flagCookIslands: function flagCookIslands() {
      return import("./flag_cook-islands-b08c0a46.js");
    },
    flagChineseTaipei: function flagChineseTaipei() {
      return import("./flag_chinese-taipei-6301e5d5.js");
    },
    flagQatar: function flagQatar() {
      return import("./flag_qatar-dae4ace2.js");
    },
    flagHongKong: function flagHongKong() {
      return import("./flag_hong-kong-310474ae.js");
    },
    flagBermuda: function flagBermuda() {
      return import("./flag_bermuda-f3c573da.js");
    },
    flagCaymanIslands: function flagCaymanIslands() {
      return import("./flag_cayman-islands-2b76b9c2.js");
    },
    flagAmericanSamoa: function flagAmericanSamoa() {
      return import("./flag_american-samoa-b7105232.js");
    },
    flagNorthernIreland: function flagNorthernIreland() {
      return import("./flag_northern-ireland-2c6df5c0.js");
    },
    flagUsVirginIslands: function flagUsVirginIslands() {
      return import("./flag_us-virgin-islands-ee8c1132.js");
    },
    flagGuadeloupe: function flagGuadeloupe() {
      return import("./flag_guadeloupe-92596ce5.js");
    },
    flagVenezuela: function flagVenezuela() {
      return import("./flag_venezuela-0a60ff9e.js");
    },
    flagYemen: function flagYemen() {
      return import("./flag_yemen-54049918.js");
    },
    flagTrinidadTobago: function flagTrinidadTobago() {
      return import("./flag_trinidad-tobago-6285935e.js");
    },
    flagAfghanistan: function flagAfghanistan() {
      return import("./flag_afghanistan-32133cdd.js");
    },
    flagFiji: function flagFiji() {
      return import("./flag_fiji-e8a4f340.js");
    },
    flagEcuador: function flagEcuador() {
      return import("./flag_ecuador-2ccd003b.js");
    },
    flagFaroeIslands: function flagFaroeIslands() {
      return import("./flag_faroe-islands-31d58e24.js");
    },
    flagFalklandIslands: function flagFalklandIslands() {
      return import("./flag_falkland-islands-a9bea8f6.js");
    },
    flagEuropeanUnion: function flagEuropeanUnion() {
      return import("./flag_european-union-d1f795c9.js");
    },
    flagEthiopia: function flagEthiopia() {
      return import("./flag_ethiopia-7b169671.js");
    },
    flagEstonia: function flagEstonia() {
      return import("./flag_estonia-3cf55c7b.js");
    },
    flagEritrea: function flagEritrea() {
      return import("./flag_eritrea-50988216.js");
    },
    flagEquatorialGuinea: function flagEquatorialGuinea() {
      return import("./flag_equatorial-guinea-cc86e9ca.js");
    },
    flagEngland: function flagEngland() {
      return import("./flag_england-5e9315a0.js");
    },
    flagElSalvador: function flagElSalvador() {
      return import("./flag_el-salvador-4063f325.js");
    },
    flagEgypt: function flagEgypt() {
      return import("./flag_egypt-e9120c3a.js");
    },
    flagCroatia: function flagCroatia() {
      return import("./flag_croatia-f51a8623.js");
    },
    flagEastTimor: function flagEastTimor() {
      return import("./flag_east-timor-ec974fb1.js");
    },
    flagDominicanRepublic: function flagDominicanRepublic() {
      return import("./flag_dominican-republic-06cee98c.js");
    },
    flagDjibouti: function flagDjibouti() {
      return import("./flag_djibouti-3cb671c1.js");
    },
    flagDenmark: function flagDenmark() {
      return import("./flag_denmark-7d1b3c37.js");
    },
    flagDemocraticRepublicOfCongo: function flagDemocraticRepublicOfCongo() {
      return import("./flag_democratic-republic-of-congo-79630e22.js");
    },
    flagCzech: function flagCzech() {
      return import("./flag_czech-eb026799.js");
    },
    flagCyprus: function flagCyprus() {
      return import("./flag_cyprus-f5dc4139.js");
    },
    flagCuba: function flagCuba() {
      return import("./flag_cuba-8ae68c93.js");
    },
    flagIvoryCoast: function flagIvoryCoast() {
      return import("./flag_ivory-coast-0292d13d.js");
    },
    flagCostaRica: function flagCostaRica() {
      return import("./flag_costa-rica-00a96889.js");
    },
    flagComoros: function flagComoros() {
      return import("./flag_comoros-c303857a.js");
    },
    flagColombia: function flagColombia() {
      return import("./flag_colombia-1193f55a.js");
    },
    flagChile: function flagChile() {
      return import("./flag_chile-f487b493.js");
    },
    flagBahrain: function flagBahrain() {
      return import("./flag_bahrain-a0b05b53.js");
    },
    flagChad: function flagChad() {
      return import("./flag_chad-77e22703.js");
    },
    flagBurkinaFaso: function flagBurkinaFaso() {
      return import("./flag_burkina-faso-6c5eecc6.js");
    },
    flagCentralAfricanRepublic: function flagCentralAfricanRepublic() {
      return import("./flag_central-african-republic-215dacf9.js");
    },
    flagCapeVerde: function flagCapeVerde() {
      return import("./flag_cape-verde-dc68aed9.js");
    },
    flagCanada: function flagCanada() {
      return import("./flag_canada-88c1f6dd.js");
    },
    flagCameroon: function flagCameroon() {
      return import("./flag_cameroon-ddb88936.js");
    },
    flagCambodia: function flagCambodia() {
      return import("./flag_cambodia-c0840bcc.js");
    },
    flagBelgium: function flagBelgium() {
      return import("./flag_belgium-49dc1045.js");
    },
    flagBurundi: function flagBurundi() {
      return import("./flag_burundi-ef48f88b.js");
    },
    flagBurma: function flagBurma() {
      return import("./flag_burma-d6e2955f.js");
    },
    flagMyanmar: function flagMyanmar() {
      return import("./flag_myanmar-e9819cde.js");
    },
    flagBulgaria: function flagBulgaria() {
      return import("./flag_bulgaria-43b4091e.js");
    },
    flagBrunei: function flagBrunei() {
      return import("./flag_brunei-bdb36b8b.js");
    },
    flagBrazil: function flagBrazil() {
      return import("./flag_brazil-7c863896.js");
    },
    flagBotswana: function flagBotswana() {
      return import("./flag_botswana-2e4e4088.js");
    },
    flagBosnia: function flagBosnia() {
      return import("./flag_bosnia-4262bf96.js");
    },
    flagBolivia: function flagBolivia() {
      return import("./flag_bolivia-cc154db7.js");
    },
    flagBenin: function flagBenin() {
      return import("./flag_benin-e2becbda.js");
    },
    flagBelize: function flagBelize() {
      return import("./flag_belize-a48c81df.js");
    },
    flagBelarus: function flagBelarus() {
      return import("./flag_belarus-0ad89712.js");
    },
    flagBarbados: function flagBarbados() {
      return import("./flag_barbados-1f54d519.js");
    },
    flagBangladesh: function flagBangladesh() {
      return import("./flag_bangladesh-2e5b5817.js");
    },
    flagBahamas: function flagBahamas() {
      return import("./flag_bahamas-3540c891.js");
    },
    flagAzerbaijan: function flagAzerbaijan() {
      return import("./flag_azerbaijan-c3a367ca.js");
    },
    flagAlbania: function flagAlbania() {
      return import("./flag_albania-d75ddd47.js");
    },
    flagAustria: function flagAustria() {
      return import("./flag_austria-ad59f6c3.js");
    },
    flagAustralia: function flagAustralia() {
      return import("./flag_australia-98e08f1b.js");
    },
    flagArmenia: function flagArmenia() {
      return import("./flag_armenia-132604f0.js");
    },
    flagArgentina: function flagArgentina() {
      return import("./flag_argentina-8fda6b6e.js");
    },
    flagAntiguaBarbuda: function flagAntiguaBarbuda() {
      return import("./flag_antigua-barbuda-7ade8fb9.js");
    },
    flagAngola: function flagAngola() {
      return import("./flag_angola-196ca1b2.js");
    },
    flagAndorra: function flagAndorra() {
      return import("./flag_andorra-e5b22780.js");
    },
    flagAlgeria: function flagAlgeria() {
      return import("./flag_algeria-125ef456.js");
    },
    flagFinland: function flagFinland() {
      return import("./flag_finland-217c6a1b.js");
    },
    flagFrance: function flagFrance() {
      return import("./flag_france-3008716e.js");
    },
    flagBritishVirginIslands: function flagBritishVirginIslands() {
      return import("./flag_british-virgin-islands-67985d9e.js");
    },
    flagPuertoRico: function flagPuertoRico() {
      return import("./flag_puerto-rico-63f321ee.js");
    },
    flagSwaziland: function flagSwaziland() {
      return import("./flag_swaziland-911be8f5.js");
    },
    flagEswatini: function flagEswatini() {
      return import("./flag_eswatini-0c833b17.js");
    },
    flagZimbabwe: function flagZimbabwe() {
      return import("./flag_zimbabwe-5da514e8.js");
    },
    flagZambia: function flagZambia() {
      return import("./flag_zambia-b7ca764e.js");
    },
    flagFrenchGuiana: function flagFrenchGuiana() {
      return import("./flag_french-guiana-b94ff4db.js");
    },
    flagVietnam: function flagVietnam() {
      return import("./flag_vietnam-3df7a5d2.js");
    },
    flagUnitedStatesOfAmerica: function flagUnitedStatesOfAmerica() {
      return import("./flag_united-states-of-america-6e4c0965.js");
    },
    flagGuineaBissau: function flagGuineaBissau() {
      return import("./flag_guinea-bissau-77126304.js");
    },
    flagVanuatu: function flagVanuatu() {
      return import("./flag_vanuatu-5ebaba8a.js");
    },
    flagUzbekistan: function flagUzbekistan() {
      return import("./flag_uzbekistan-3305486b.js");
    },
    flagUruguay: function flagUruguay() {
      return import("./flag_uruguay-4cf546e3.js");
    },
    flagUnitedArabEmirates: function flagUnitedArabEmirates() {
      return import("./flag_united-arab-emirates-3ce30575.js");
    },
    flagUkraine: function flagUkraine() {
      return import("./flag_ukraine-43db97e1.js");
    },
    flagUnitedKingdom: function flagUnitedKingdom() {
      return import("./flag_united-kingdom-9f2bd14d.js");
    },
    flagUganda: function flagUganda() {
      return import("./flag_uganda-245fb37a.js");
    },
    flagTuvalu: function flagTuvalu() {
      return import("./flag_tuvalu-cc551dbf.js");
    },
    flagTurkmenistan: function flagTurkmenistan() {
      return import("./flag_turkmenistan-09b092a5.js");
    },
    flagTurkey: function flagTurkey() {
      return import("./flag_turkey-aa971a69.js");
    },
    flagTunisia: function flagTunisia() {
      return import("./flag_tunisia-000be0d9.js");
    },
    flagGabon: function flagGabon() {
      return import("./flag_gabon-d2613a7b.js");
    },
    flagTogo: function flagTogo() {
      return import("./flag_togo-15d62e73.js");
    },
    flagTonga: function flagTonga() {
      return import("./flag_tonga-530d10ad.js");
    },
    flagThailand: function flagThailand() {
      return import("./flag_thailand-765e1d7e.js");
    },
    flagTanzania: function flagTanzania() {
      return import("./flag_tanzania-76bda741.js");
    },
    flagTajikistan: function flagTajikistan() {
      return import("./flag_tajikistan-6c42b930.js");
    },
    flagTaiwan: function flagTaiwan() {
      return import("./flag_taiwan-1e1ff638.js");
    },
    flagSyria: function flagSyria() {
      return import("./flag_syria-c0d4c307.js");
    },
    flagSwitzerland: function flagSwitzerland() {
      return import("./flag_switzerland-81641099.js");
    },
    flagSweden: function flagSweden() {
      return import("./flag_sweden-2187280f.js");
    },
    flagSuriname: function flagSuriname() {
      return import("./flag_suriname-a49519ac.js");
    },
    flagSudan: function flagSudan() {
      return import("./flag_sudan-82c37d9a.js");
    },
    flagSriLanka: function flagSriLanka() {
      return import("./flag_sri-lanka-8ea488c9.js");
    },
    flagSomalia: function flagSomalia() {
      return import("./flag_somalia-8737facb.js");
    },
    flagSpain: function flagSpain() {
      return import("./flag_spain-6fb9754b.js");
    },
    flagSouthSudan: function flagSouthSudan() {
      return import("./flag_south-sudan-c567bad5.js");
    },
    flagSouthSandwichIslands: function flagSouthSandwichIslands() {
      return import("./flag_south-sandwich-islands-19a55a07.js");
    },
    flagSouthAfrica: function flagSouthAfrica() {
      return import("./flag_south-africa-a751d9f8.js");
    },
    flagSlovenia: function flagSlovenia() {
      return import("./flag_slovenia-4d0133c0.js");
    },
    flagSlovakia: function flagSlovakia() {
      return import("./flag_slovakia-c7101eae.js");
    },
    flagSingapore: function flagSingapore() {
      return import("./flag_singapore-dedffb14.js");
    },
    flagSierraLeone: function flagSierraLeone() {
      return import("./flag_sierra-leone-3e7bedf9.js");
    },
    flagSeychelles: function flagSeychelles() {
      return import("./flag_seychelles-8c73c42a.js");
    },
    flagSerbia: function flagSerbia() {
      return import("./flag_serbia-d13c3ee9.js");
    },
    flagSenegal: function flagSenegal() {
      return import("./flag_senegal-78c0b866.js");
    },
    flagSaudiArabia: function flagSaudiArabia() {
      return import("./flag_saudi-arabia-7beee166.js");
    },
    flagSaoTomeAndPrincipe: function flagSaoTomeAndPrincipe() {
      return import("./flag_sao-tome-and-principe-2bcd0013.js");
    },
    flagSanMarino: function flagSanMarino() {
      return import("./flag_san-marino-55fc6c80.js");
    },
    flagSamoa: function flagSamoa() {
      return import("./flag_samoa-31d9b2da.js");
    },
    flagSaintLucia: function flagSaintLucia() {
      return import("./flag_saint-lucia-bc3bd172.js");
    },
    flagSaintKittsNevis: function flagSaintKittsNevis() {
      return import("./flag_saint-kitts-nevis-a238eb9e.js");
    },
    flagRwanda: function flagRwanda() {
      return import("./flag_rwanda-c88b3ff2.js");
    },
    flagRussia: function flagRussia() {
      return import("./flag_russia-79079929.js");
    },
    flagRomania: function flagRomania() {
      return import("./flag_romania-7d830c43.js");
    },
    flagRepublicOfTheCongo: function flagRepublicOfTheCongo() {
      return import("./flag_republic-of-the-congo-26bb5183.js");
    },
    flagQuatar: function flagQuatar() {
      return import("./flag_quatar-f2de5327.js");
    },
    flagPortugal: function flagPortugal() {
      return import("./flag_portugal-553d948c.js");
    },
    flagPoland: function flagPoland() {
      return import("./flag_poland-09ed2134.js");
    },
    flagPhilippines: function flagPhilippines() {
      return import("./flag_philippines-f4bf1ce0.js");
    },
    flagPeru: function flagPeru() {
      return import("./flag_peru-8038ad4d.js");
    },
    flagParaguay: function flagParaguay() {
      return import("./flag_paraguay-18e545f7.js");
    },
    flagPapuaNewGuinea: function flagPapuaNewGuinea() {
      return import("./flag_papua-new-guinea-a5ec8fc0.js");
    },
    flagPalau: function flagPalau() {
      return import("./flag_palau-8c342cad.js");
    },
    flagPanama: function flagPanama() {
      return import("./flag_panama-d35af864.js");
    },
    flagPalestine: function flagPalestine() {
      return import("./flag_palestine-48c16684.js");
    },
    flagNorway: function flagNorway() {
      return import("./flag_norway-2968b980.js");
    },
    flagPakistan: function flagPakistan() {
      return import("./flag_pakistan-f039b5fb.js");
    },
    flagOman: function flagOman() {
      return import("./flag_oman-0295ba87.js");
    },
    flagNorthKorea: function flagNorthKorea() {
      return import("./flag_north-korea-60b99d3b.js");
    },
    flagNigeria: function flagNigeria() {
      return import("./flag_nigeria-1e595cde.js");
    },
    flagNiger: function flagNiger() {
      return import("./flag_niger-aaecc5a2.js");
    },
    flagNicaragua: function flagNicaragua() {
      return import("./flag_nicaragua-d3f9eb79.js");
    },
    flagNewZealand: function flagNewZealand() {
      return import("./flag_new-zealand-491e8cbf.js");
    },
    flagNetherlands: function flagNetherlands() {
      return import("./flag_netherlands-2336e048.js");
    },
    flagNepal: function flagNepal() {
      return import("./flag_nepal-cb8250de.js");
    },
    flagNauru: function flagNauru() {
      return import("./flag_nauru-602636d0.js");
    },
    flagNamibia: function flagNamibia() {
      return import("./flag_namibia-50e23d78.js");
    },
    flagMozambique: function flagMozambique() {
      return import("./flag_mozambique-cdc8ac78.js");
    },
    flagMontenegro: function flagMontenegro() {
      return import("./flag_montenegro-31a27407.js");
    },
    flagMongolia: function flagMongolia() {
      return import("./flag_mongolia-9c8bba31.js");
    },
    flagMonaco: function flagMonaco() {
      return import("./flag_monaco-006a970d.js");
    },
    flagMoldova: function flagMoldova() {
      return import("./flag_moldova-02e7fda9.js");
    },
    flagMicronesia: function flagMicronesia() {
      return import("./flag_micronesia-22cad491.js");
    },
    flagMexico: function flagMexico() {
      return import("./flag_mexico-62e294af.js");
    },
    flagMarshallIslands: function flagMarshallIslands() {
      return import("./flag_marshall-islands-536b813c.js");
    },
    flagMauritius: function flagMauritius() {
      return import("./flag_mauritius-9c7510e6.js");
    },
    flagMauritania: function flagMauritania() {
      return import("./flag_mauritania-89972bb5.js");
    },
    flagMadagascar: function flagMadagascar() {
      return import("./flag_madagascar-a3e2da12.js");
    },
    flagMorocco: function flagMorocco() {
      return import("./flag_morocco-1ed099a5.js");
    },
    flagMalta: function flagMalta() {
      return import("./flag_malta-51de50dd.js");
    },
    flagMaldives: function flagMaldives() {
      return import("./flag_maldives-8d59271a.js");
    },
    flagMali: function flagMali() {
      return import("./flag_mali-82627c43.js");
    },
    flagMalaysia: function flagMalaysia() {
      return import("./flag_malaysia-32f3a780.js");
    },
    flagMalawi: function flagMalawi() {
      return import("./flag_malawi-772b090d.js");
    },
    flagMacedonia: function flagMacedonia() {
      return import("./flag_macedonia-76fae2c1.js");
    },
    flagLuxembourg: function flagLuxembourg() {
      return import("./flag_luxembourg-41a409d7.js");
    },
    flagLithuania: function flagLithuania() {
      return import("./flag_lithuania-da792419.js");
    },
    flagLiechtenstein: function flagLiechtenstein() {
      return import("./flag_liechtenstein-d7d224c9.js");
    },
    flagLibya: function flagLibya() {
      return import("./flag_libya-5aa42ac4.js");
    },
    flagLiberia: function flagLiberia() {
      return import("./flag_liberia-308db1f4.js");
    },
    flagLesotho: function flagLesotho() {
      return import("./flag_lesotho-f60c5f36.js");
    },
    flagLebanon: function flagLebanon() {
      return import("./flag_lebanon-0d1da8d3.js");
    },
    flagGreece: function flagGreece() {
      return import("./flag_greece-3148b2b1.js");
    },
    flagLatvia: function flagLatvia() {
      return import("./flag_latvia-ea77b90f.js");
    },
    flagLaos: function flagLaos() {
      return import("./flag_laos-a9590232.js");
    },
    flagKyrgyzstan: function flagKyrgyzstan() {
      return import("./flag_kyrgyzstan-95ba0390.js");
    },
    flagKuwait: function flagKuwait() {
      return import("./flag_kuwait-9eda2ce0.js");
    },
    flagKosovo: function flagKosovo() {
      return import("./flag_kosovo-cdce5b7e.js");
    },
    flagKorea: function flagKorea() {
      return import("./flag_korea-b0eb6484.js");
    },
    flagKiribati: function flagKiribati() {
      return import("./flag_kiribati-5189f9cd.js");
    },
    flagKenya: function flagKenya() {
      return import("./flag_kenya-4eb12c66.js");
    },
    flagKazakhstan: function flagKazakhstan() {
      return import("./flag_kazakhstan-e1ba83ba.js");
    },
    flagJordan: function flagJordan() {
      return import("./flag_jordan-9cd50b98.js");
    },
    flagJersey: function flagJersey() {
      return import("./flag_jersey-cf11c057.js");
    },
    flagJapan: function flagJapan() {
      return import("./flag_japan-a25fa7d6.js");
    },
    flagJamaica: function flagJamaica() {
      return import("./flag_jamaica-d73bd76c.js");
    },
    flagItaly: function flagItaly() {
      return import("./flag_italy-8c80fefa.js");
    },
    flagIsrael: function flagIsrael() {
      return import("./flag_israel-0cc0c78f.js");
    },
    flagIsleOfMan: function flagIsleOfMan() {
      return import("./flag_isle-of-man-3d121037.js");
    },
    flagIreland: function flagIreland() {
      return import("./flag_ireland-a1d0fcb7.js");
    },
    flagIraq: function flagIraq() {
      return import("./flag_iraq-64e6b76f.js");
    },
    flagIran: function flagIran() {
      return import("./flag_iran-a525f90e.js");
    },
    flagIndonesia: function flagIndonesia() {
      return import("./flag_indonesia-660d38c8.js");
    },
    flagIndia: function flagIndia() {
      return import("./flag_india-1f0f81c6.js");
    },
    flagIceland: function flagIceland() {
      return import("./flag_iceland-15972672.js");
    },
    flagHungary: function flagHungary() {
      return import("./flag_hungary-a7b83afd.js");
    },
    flagHonduras: function flagHonduras() {
      return import("./flag_honduras-43a1eefa.js");
    },
    flagHaiti: function flagHaiti() {
      return import("./flag_haiti-362e2cfb.js");
    },
    flagGuyana: function flagGuyana() {
      return import("./flag_guyana-f9ee4671.js");
    },
    flagGuinea: function flagGuinea() {
      return import("./flag_guinea-7c329154.js");
    },
    flagGambia: function flagGambia() {
      return import("./flag_gambia-6a06b4c0.js");
    },
    flagGuernsey: function flagGuernsey() {
      return import("./flag_guernsey-fd962c3e.js");
    },
    flagGuatemala: function flagGuatemala() {
      return import("./flag_guatemala-87a989ac.js");
    },
    flagGrenada: function flagGrenada() {
      return import("./flag_grenada-1d24a900.js");
    },
    flagGermany: function flagGermany() {
      return import("./flag_germany-713060dc.js");
    },
    flagGibraltar: function flagGibraltar() {
      return import("./flag_gibraltar-a9e29747.js");
    },
    flagGhana: function flagGhana() {
      return import("./flag_ghana-0b17a72e.js");
    },
    flagGeorgia: function flagGeorgia() {
      return import("./flag_georgia-ebfdbf25.js");
    },
    flagDominica: function flagDominica() {
      return import("./flag_dominica-1e85e242.js");
    },
    iconSportsArchery: function iconSportsArchery() {
      return import("./icon_sports_archery-4821b332.js");
    },
    iconSportsRodeo: function iconSportsRodeo() {
      return import("./icon_sports_rodeo-c493df7b.js");
    },
    iconSportsEntertainmentAwards: function iconSportsEntertainmentAwards() {
      return import("./icon_sports_entertainment-awards-fbbc6087.js");
    },
    iconSportsCompetitiveEating: function iconSportsCompetitiveEating() {
      return import("./icon_sports_competitive-eating-61953fac.js");
    },
    iconSportsSurfing: function iconSportsSurfing() {
      return import("./icon_sports_surfing-da684785.js");
    },
    iconSportsSailing: function iconSportsSailing() {
      return import("./icon_sports_sailing-80e4884b.js");
    },
    iconSportsDiving: function iconSportsDiving() {
      return import("./icon_sports_diving-188cafed.js");
    },
    iconSportsVirtualCycling: function iconSportsVirtualCycling() {
      return import("./icon_sports_virtual-cycling-d1331eaa.js");
    },
    iconSportsWrestling: function iconSportsWrestling() {
      return import("./icon_sports_wrestling-ecf2eb2c.js");
    },
    iconSportsRugbyUnion: function iconSportsRugbyUnion() {
      return import("./icon_sports_rugby-union-e4536d8e.js");
    },
    iconSportsNetball: function iconSportsNetball() {
      return import("./icon_sports_netball-1614e4b1.js");
    },
    iconSportsFieldHockey: function iconSportsFieldHockey() {
      return import("./icon_sports_field-hockey-ce142d52.js");
    },
    iconSportsBeachVolleyball: function iconSportsBeachVolleyball() {
      return import("./icon_sports_beach-volleyball-c246d5cd.js");
    },
    iconSportsBeachSoccer: function iconSportsBeachSoccer() {
      return import("./icon_sports_beach-soccer-11f61282.js");
    },
    iconSportsLacrosse: function iconSportsLacrosse() {
      return import("./icon_sports_lacrosse-0b8be656.js");
    },
    iconSportsWinterSports: function iconSportsWinterSports() {
      return import("./icon_sports_winter-sports-b30774ef.js");
    },
    iconSportsGymanstics: function iconSportsGymanstics() {
      return import("./icon_sports_gymanstics-a88ead27.js");
    },
    iconSportsOlympics: function iconSportsOlympics() {
      return import("./icon_sports_olympics-fe0e18ad.js");
    },
    iconSportsBlackjack: function iconSportsBlackjack() {
      return import("./icon_sports_blackjack-5189742a.js");
    },
    iconSportsSwimming: function iconSportsSwimming() {
      return import("./icon_sports_swimming-0bf82492.js");
    },
    iconSportsHorseRacing: function iconSportsHorseRacing() {
      return import("./icon_sports_horse-racing-9efce199.js");
    },
    iconSportsAthletics: function iconSportsAthletics() {
      return import("./icon_sports_athletics-14d1e6f1.js");
    },
    iconSportsFencing: function iconSportsFencing() {
      return import("./icon_sports_fencing-8da6d9ea.js");
    },
    iconSportsFishing: function iconSportsFishing() {
      return import("./icon_sports_fishing-439046b7.js");
    },
    iconSportsSnooker: function iconSportsSnooker() {
      return import("./icon_sports_snooker-ae2ea5c3.js");
    },
    iconSportsTableTennis: function iconSportsTableTennis() {
      return import("./icon_sports_table-tennis-9de4b394.js");
    },
    iconSportsSoccer: function iconSportsSoccer() {
      return import("./icon_sports_soccer-2f8d4cb7.js");
    },
    iconSportsWaterPolo: function iconSportsWaterPolo() {
      return import("./icon_sports_water-polo-c9e12191.js");
    },
    iconSportsDarts: function iconSportsDarts() {
      return import("./icon_sports_darts-2a717e4c.js");
    },
    iconSportsBowling: function iconSportsBowling() {
      return import("./icon_sports_bowling-0cb79744.js");
    },
    iconSportsBadminton: function iconSportsBadminton() {
      return import("./icon_sports_badminton-9e69383a.js");
    },
    iconSportsPool: function iconSportsPool() {
      return import("./icon_sports_pool-87d365bc.js");
    },
    iconSportsHockey: function iconSportsHockey() {
      return import("./icon_sports_hockey-f16cb7c1.js");
    },
    iconSportsVolleyball: function iconSportsVolleyball() {
      return import("./icon_sports_volleyball-82c31181.js");
    },
    iconSportsEgaming: function iconSportsEgaming() {
      return import("./icon_sports_egaming-097726a7.js");
    },
    iconSportsBoxing: function iconSportsBoxing() {
      return import("./icon_sports_boxing-6f5e18d3.js");
    },
    iconSportsBaseball: function iconSportsBaseball() {
      return import("./icon_sports_baseball-740c984f.js");
    },
    iconSportsBasketball: function iconSportsBasketball() {
      return import("./icon_sports_basketball-1bb675a3.js");
    },
    iconSportsRacing: function iconSportsRacing() {
      return import("./icon_sports_racing-5a968e06.js");
    },
    iconSportsTennis: function iconSportsTennis() {
      return import("./icon_sports_tennis-8363f917.js");
    },
    iconSportsMma: function iconSportsMma() {
      return import("./icon_sports_mma-a80e4499.js");
    },
    iconSportsCricket: function iconSportsCricket() {
      return import("./icon_sports_cricket-7455db68.js");
    },
    iconSportsCycling: function iconSportsCycling() {
      return import("./icon_sports_cycling-7d872aa2.js");
    },
    iconSportsGolf: function iconSportsGolf() {
      return import("./icon_sports_golf-d5804604.js");
    },
    iconSportsOlympicsDiving2: function iconSportsOlympicsDiving2() {
      return import("./icon_sports_olympics_diving-2-5c4233ff.js");
    },
    iconSportsOlympicsBasketball3X3: function iconSportsOlympicsBasketball3X3() {
      return import("./icon_sports_olympics_basketball-3x3-26a2ed68.js");
    },
    iconSportsOlympicsGymnasticsTrampoline: function iconSportsOlympicsGymnasticsTrampoline() {
      return import("./icon_sports_olympics_gymnastics-trampoline-e259587b.js");
    },
    iconSportsOlympicsCyclingRoad: function iconSportsOlympicsCyclingRoad() {
      return import("./icon_sports_olympics_cycling-road-da5b5f98.js");
    },
    iconSportsOlympicsWeightlifting: function iconSportsOlympicsWeightlifting() {
      return import("./icon_sports_olympics_weightlifting-c036c8f3.js");
    },
    iconSportsOlympicsWaterPolo: function iconSportsOlympicsWaterPolo() {
      return import("./icon_sports_olympics_water-polo-71d658c1.js");
    },
    iconSportsOlympicsWrestling: function iconSportsOlympicsWrestling() {
      return import("./icon_sports_olympics_wrestling-e84e715c.js");
    },
    iconSportsOlympicsVolleyballBeach: function iconSportsOlympicsVolleyballBeach() {
      return import("./icon_sports_olympics_volleyball-beach-fba863d9.js");
    },
    iconSportsOlympicsTriathlon: function iconSportsOlympicsTriathlon() {
      return import("./icon_sports_olympics_triathlon-0a808574.js");
    },
    iconSportsOlympicsVolleyballIndoor: function iconSportsOlympicsVolleyballIndoor() {
      return import("./icon_sports_olympics_volleyball-indoor-3d28c6c9.js");
    },
    iconSportsOlympicsTableTennis: function iconSportsOlympicsTableTennis() {
      return import("./icon_sports_olympics_table-tennis-dc1bb03a.js");
    },
    iconSportsOlympicsTennis: function iconSportsOlympicsTennis() {
      return import("./icon_sports_olympics_tennis-ce18118f.js");
    },
    iconSportsOlympicsTaekwondo: function iconSportsOlympicsTaekwondo() {
      return import("./icon_sports_olympics_taekwondo-30e0308e.js");
    },
    iconSportsOlympicsSailing: function iconSportsOlympicsSailing() {
      return import("./icon_sports_olympics_sailing-293728de.js");
    },
    iconSportsOlympicsCanoeingFlatwater: function iconSportsOlympicsCanoeingFlatwater() {
      return import("./icon_sports_olympics_canoeing-flatwater-95b4d533.js");
    },
    iconSportsOlympicsBoxing: function iconSportsOlympicsBoxing() {
      return import("./icon_sports_olympics_boxing-384c06c6.js");
    },
    iconSportsOlympicsBreaking: function iconSportsOlympicsBreaking() {
      return import("./icon_sports_olympics_breaking-478105cd.js");
    },
    iconSportsOlympicsSwimmingMarathon: function iconSportsOlympicsSwimmingMarathon() {
      return import("./icon_sports_olympics_swimming-marathon-af9fd82d.js");
    },
    iconSportsOlympicsSurfing: function iconSportsOlympicsSurfing() {
      return import("./icon_sports_olympics_surfing-9b290260.js");
    },
    iconSportsOlympicsSwimming: function iconSportsOlympicsSwimming() {
      return import("./icon_sports_olympics_swimming-44f581ca.js");
    },
    iconSportsOlympicsSwimmingArtistic: function iconSportsOlympicsSwimmingArtistic() {
      return import("./icon_sports_olympics_swimming-artistic-f57b860f.js");
    },
    iconSportsOlympicsShooting: function iconSportsOlympicsShooting() {
      return import("./icon_sports_olympics_shooting-2c12fec9.js");
    },
    iconSportsOlympicsSkateboarding: function iconSportsOlympicsSkateboarding() {
      return import("./icon_sports_olympics_skateboarding-ebaa7dae.js");
    },
    iconSportsSquash: function iconSportsSquash() {
      return import("./icon_sports_squash-b8c24e1a.js");
    },
    iconSportsSoftball: function iconSportsSoftball() {
      return import("./icon_sports_softball-9bee5d67.js");
    }
  }, "iconSportsRugbyUnion", function () {
    return import("./icon_sports_rugby-union-e4536d8e.js");
  }), Oe(r, "iconSportsRugbyLeague", function () {
    return import("./icon_sports_rugby-league-bcd14373.js");
  }), Oe(r, "iconSportsRowing", function () {
    return import("./icon_sports_rowing-e37af799.js");
  }), Oe(r, "iconSportsPolitics", function () {
    return import("./icon_sports_politics-bedc7911.js");
  }), Oe(r, "iconSportsPoker", function () {
    return import("./icon_sports_poker-6556a26b.js");
  }), Oe(r, "iconSportsMotorbike", function () {
    return import("./icon_sports_motorbike-0f38d672.js");
  }), Oe(r, "iconSportsHandball", function () {
    return import("./icon_sports_handball-345f5a50.js");
  }), Oe(r, "iconSportsGreyhound", function () {
    return import("./icon_sports_greyhound-e6291588.js");
  }), Oe(r, "iconSportsGaelicFootball", function () {
    return import("./icon_sports_gaelic-football-28f70419.js");
  }), Oe(r, "iconSportsGaelicHurling", function () {
    return import("./icon_sports_gaelic-hurling-5461debf.js");
  }), Oe(r, "iconSportsFutsal", function () {
    return import("./icon_sports_futsal-6d26eb89.js");
  }), Oe(r, "iconSportsBowls", function () {
    return import("./icon_sports_bowls-ef186a3a.js");
  }), Oe(r, "iconSportsAussieRules", function () {
    return import("./icon_sports_aussie-rules-4e6a248f.js");
  }), Oe(r, "iconSportsOlympicsRugbySevens", function () {
    return import("./icon_sports_olympics_rugby-sevens-626fcca1.js");
  }), Oe(r, "iconSportsOlympicsRugbyLeague", function () {
    return import("./icon_sports_olympics_rugby-league-c93be950.js");
  }), Oe(r, "iconSportsOlympicsRowing", function () {
    return import("./icon_sports_olympics_rowing-0002afc1.js");
  }), Oe(r, "iconSportsOlympicsGolf", function () {
    return import("./icon_sports_olympics_golf-55f04eb1.js");
  }), Oe(r, "iconSportsOlympicsJudo", function () {
    return import("./icon_sports_olympics_judo-201d445b.js");
  }), Oe(r, "iconSportsOlympicsPentathlon", function () {
    return import("./icon_sports_olympics_pentathlon-44330c32.js");
  }), Oe(r, "iconSportsOlympicsGymnasticsRhythmic", function () {
    return import("./icon_sports_olympics_gymnastics-rhythmic-492e49eb.js");
  }), Oe(r, "iconSportsOlympicsHandball", function () {
    return import("./icon_sports_olympics_handball-94489be6.js");
  }), Oe(r, "iconSportsOlympicsGymnasticsArtistic", function () {
    return import("./icon_sports_olympics_gymnastics-artistic-54720694.js");
  }), Oe(r, "iconSportsOlympicsFieldHockey", function () {
    return import("./icon_sports_olympics_field-hockey-a99ce03a.js");
  }), Oe(r, "iconSportsOlympicsCanoeingSlalom", function () {
    return import("./icon_sports_olympics_canoeing-slalom-128a445c.js");
  }), Oe(r, "iconSportsOlympicsClimbing", function () {
    return import("./icon_sports_olympics_climbing-03156d62.js");
  }), Oe(r, "iconSportsOlympicsCyclingBmxFreestyle", function () {
    return import("./icon_sports_olympics_cycling-bmx-freestyle-798b88c4.js");
  }), Oe(r, "iconSportsOlympicsFencing", function () {
    return import("./icon_sports_olympics_fencing-8638a8cc.js");
  }), Oe(r, "iconSportsOlympicsSoccer", function () {
    return import("./icon_sports_olympics_soccer-932a643d.js");
  }), Oe(r, "iconSportsOlympicsEquestrian", function () {
    return import("./icon_sports_olympics_equestrian-3f4e2d69.js");
  }), Oe(r, "iconSportsOlympicsEquestrianEventing", function () {
    return import("./icon_sports_olympics_equestrian-eventing-f7fd21b3.js");
  }), Oe(r, "iconSportsOlympicsEquestrianJumping", function () {
    return import("./icon_sports_olympics_equestrian-jumping-cc1d99bb.js");
  }), Oe(r, "iconSportsOlympicsDiving", function () {
    return import("./icon_sports_olympics_diving-adda99b8.js");
  }), Oe(r, "iconSportsOlympicsEquestrianDressage", function () {
    return import("./icon_sports_olympics_equestrian-dressage-53c56a6f.js");
  }), Oe(r, "iconSportsOlympicsBasketball", function () {
    return import("./icon_sports_olympics_basketball-8306857b.js");
  }), Oe(r, "iconSportsOlympicsCyclingTrack", function () {
    return import("./icon_sports_olympics_cycling-track-55aecd8a.js");
  }), Oe(r, "iconSportsOlympicsArchery", function () {
    return import("./icon_sports_olympics_archery-02f2f4c5.js");
  }), Oe(r, "iconSportsOlympicsAthletics", function () {
    return import("./icon_sports_olympics_athletics-8a72adf3.js");
  }), Oe(r, "iconSportsOlympicsBadminton", function () {
    return import("./icon_sports_olympics_badminton-d2074998.js");
  }), Oe(r, "iconSportsOlympicsCyclingBmx", function () {
    return import("./icon_sports_olympics_cycling-bmx-9f3536e3.js");
  }), Oe(r, "iconSportsOlympicsCyclingMountainBiking", function () {
    return import("./icon_sports_olympics_cycling-mountain-biking-6d8807a7.js");
  }), Oe(r, "iconSportsFootball", function () {
    return import("./icon_sports_football-79a37561.js");
  }), Oe(r, "iconUiSortAscend", function () {
    return import("./icon_ui_sort-ascend-9332c7b2.js");
  }), Oe(r, "iconUiTriangleSmLeft", function () {
    return import("./icon_ui_triangle-sm-left-07f739cb.js");
  }), Oe(r, "iconUiTriangleMdUp", function () {
    return import("./icon_ui_triangle-md-up-2cebbab2.js");
  }), Oe(r, "iconUiTriangleMdDown", function () {
    return import("./icon_ui_triangle-md-down-28ea3eb8.js");
  }), Oe(r, "iconUiStatusVoid", function () {
    return import("./icon_ui_status-void-882fd944.js");
  }), Oe(r, "iconUiEqual", function () {
    return import("./icon_ui_equal-29c2b6e1.js");
  }), Oe(r, "iconUiBookmarkOutline", function () {
    return import("./icon_ui_bookmark_outline-68c8d45d.js");
  }), Oe(r, "iconUiBookmark", function () {
    return import("./icon_ui_bookmark-ed9ee514.js");
  }), Oe(r, "iconUiGlobe", function () {
    return import("./icon_ui_globe-870a8ab2.js");
  }), Oe(r, "iconUiCheckboxMinus", function () {
    return import("./icon_ui_checkbox-minus-e5c4aa44.js");
  }), Oe(r, "iconUiRedo", function () {
    return import("./icon_ui_redo-a5bf20c7.js");
  }), Oe(r, "iconUiUndo", function () {
    return import("./icon_ui_undo-30cebf17.js");
  }), Oe(r, "iconUiTrophy", function () {
    return import("./icon_ui_trophy-34cbf0d7.js");
  }), Oe(r, "iconUiParlay", function () {
    return import("./icon_ui_parlay-06172037.js");
  }), Oe(r, "iconUiSortDescend", function () {
    return import("./icon_ui_sort-descend-294377a7.js");
  }), Oe(r, "iconUiTrendDown", function () {
    return import("./icon_ui_trend-down-2527076b.js");
  }), Oe(r, "iconUiTrendUp", function () {
    return import("./icon_ui_trend-up-18edee40.js");
  }), Oe(r, "iconUiThumbUpOutline", function () {
    return import("./icon_ui_thumb-up-outline-a67e17f0.js");
  }), Oe(r, "iconUiThumbDownOutline", function () {
    return import("./icon_ui_thumb-down-outline-f8ae9a70.js");
  }), Oe(r, "iconUiThumbUp", function () {
    return import("./icon_ui_thumb-up-d9ec02be.js");
  }), Oe(r, "iconUiThumbDown", function () {
    return import("./icon_ui_thumb-down-c2feb305.js");
  }), Oe(r, "iconUiPlus", function () {
    return import("./icon_ui_plus-ecd4ccce.js");
  }), Oe(r, "iconUiSgp", function () {
    return import("./icon_ui_sgp-5e9cc683.js");
  }), Oe(r, "iconUiPromotionsOutline", function () {
    return import("./icon_ui_promotions_outline-035a8883.js");
  }), Oe(r, "iconUiPushpin", function () {
    return import("./icon_ui_pushpin-07aa5110.js");
  }), Oe(r, "iconUiHandTwoPointer", function () {
    return import("./icon_ui_hand-two-pointer-8dd0a160.js");
  }), Oe(r, "iconUiFootballPlayerRun", function () {
    return import("./icon_ui_football-player-run-3b0c199e.js");
  }), Oe(r, "iconUiFootballPlayerPass", function () {
    return import("./icon_ui_football-player-pass-88306ecb.js");
  }), Oe(r, "iconUiHandThreePointer", function () {
    return import("./icon_ui_hand-three-pointer-5c1b6825.js");
  }), Oe(r, "iconUiHandThreeFingers", function () {
    return import("./icon_ui_hand-three-fingers-587028ab.js");
  }), Oe(r, "iconUiHandTwoFingers", function () {
    return import("./icon_ui_hand-two-fingers-173c908b.js");
  }), Oe(r, "iconUiCalculator", function () {
    return import("./icon_ui_calculator-f760d399.js");
  }), Oe(r, "iconUiPulse", function () {
    return import("./icon_ui_pulse-203a0d96.js");
  }), Oe(r, "iconUiParty", function () {
    return import("./icon_ui_party-38e0e2c9.js");
  }), Oe(r, "iconUiX", function () {
    return import("./icon_ui_x-d723c142.js");
  }), Oe(r, "iconUiFlag", function () {
    return import("./icon_ui_flag-29a63d6e.js");
  }), Oe(r, "iconUiMinus", function () {
    return import("./icon_ui_minus-6164cf33.js");
  }), Oe(r, "iconUiNotchDown", function () {
    return import("./icon_ui_notch-down-5ef66a1f.js");
  }), Oe(r, "iconUiNotchUp", function () {
    return import("./icon_ui_notch-up-5ea8426e.js");
  }), Oe(r, "iconUiTennis", function () {
    return import("./icon_ui_tennis-2a537b92.js");
  }), Oe(r, "iconUiFootball", function () {
    return import("./icon_ui_football-639ada45.js");
  }), Oe(r, "iconUiBasketball", function () {
    return import("./icon_ui_basketball-c6d5a595.js");
  }), Oe(r, "iconUiScoreboard", function () {
    return import("./icon_ui_scoreboard-bcc42372.js");
  }), Oe(r, "iconUiBetslip", function () {
    return import("./icon_ui_betslip-32321a37.js");
  }), Oe(r, "iconUiBetslipOutline", function () {
    return import("./icon_ui_betslip-outline-0c720152.js");
  }), Oe(r, "iconUiAlphaOrder", function () {
    return import("./icon_ui_alpha-order-df7e6c44.js");
  }), Oe(r, "iconUiPromotions", function () {
    return import("./icon_ui_promotions-b0c05cab.js");
  }), Oe(r, "iconUiSuperParlay", function () {
    return import("./icon_ui_super-parlay-f1614d2a.js");
  }), Oe(r, "iconUiStatusLive", function () {
    return import("./icon_ui_status-live-77bb0190.js");
  }), Oe(r, "iconUiTimeline", function () {
    return import("./icon_ui_timeline-92644d52.js");
  }), Oe(r, "iconUiClock", function () {
    return import("./icon_ui_clock-04d6309f.js");
  }), Oe(r, "iconUiField", function () {
    return import("./icon_ui_field-f5eb0786.js");
  }), Oe(r, "iconUiWatch", function () {
    return import("./icon_ui_watch-47023282.js");
  }), Oe(r, "iconUiMagnifier", function () {
    return import("./icon_ui_magnifier-90152422.js");
  }), Oe(r, "iconUiMagnifierOutline", function () {
    return import("./icon_ui_magnifier_outline-eeb9609d.js");
  }), Oe(r, "iconUiInfo", function () {
    return import("./icon_ui_info-cdd97b13.js");
  }), Oe(r, "iconUiGear", function () {
    return import("./icon_ui_gear-a9a0ed6e.js");
  }), Oe(r, "iconUiChevronRight", function () {
    return import("./icon_ui_chevron-right-b7ac5212.js");
  }), Oe(r, "iconUiInfoOutline", function () {
    return import("./icon_ui_info_outline-958c2534.js");
  }), Oe(r, "iconUiChevronUp", function () {
    return import("./icon_ui_chevron-up-6ddf717a.js");
  }), Oe(r, "iconUiChevronLeft", function () {
    return import("./icon_ui_chevron-left-dd309eb8.js");
  }), Oe(r, "iconUiChevronDown", function () {
    return import("./icon_ui_chevron-down-2cde81b1.js");
  }), Oe(r, "iconUiBank", function () {
    return import("./icon_ui_bank-ffea7a3e.js");
  }), Oe(r, "iconUiCasino", function () {
    return import("./icon_ui_casino-a8c918ca.js");
  }), Oe(r, "iconUiCasinoOutline", function () {
    return import("./icon_ui_casino_outline-32b743c1.js");
  }), Oe(r, "iconUiSportsOutline", function () {
    return import("./icon_ui_sports_outline-431db3d2.js");
  }), Oe(r, "iconUiSports", function () {
    return import("./icon_ui_sports-1ac3eb85.js");
  }), Oe(r, "iconUiDotsHorizontal", function () {
    return import("./icon_ui_dots-horizontal-77a0c16e.js");
  }), Oe(r, "iconUiShow", function () {
    return import("./icon_ui_show-0be01470.js");
  }), Oe(r, "iconUiPlantLeaf", function () {
    return import("./icon_ui_plant-leaf-999c5fe6.js");
  }), Oe(r, "iconUiClosedCaptioning", function () {
    return import("./icon_ui_closed-captioning-97748b45.js");
  }), Oe(r, "iconUiWheelchair", function () {
    return import("./icon_ui_wheelchair-9e07ad98.js");
  }), Oe(r, "iconUiAudioDescription", function () {
    return import("./icon_ui_audio-description-88d984eb.js");
  }), Oe(r, "iconUiAccessibility", function () {
    return import("./icon_ui_accessibility-adf47f2e.js");
  }), Oe(r, "iconUiPound", function () {
    return import("./icon_ui_pound-179dbfe7.js");
  }), Oe(r, "iconUiEuro", function () {
    return import("./icon_ui_euro-d88f64be.js");
  }), Oe(r, "iconUiBaseballPlayerBall", function () {
    return import("./icon_ui_baseball-player-ball-82ff11bf.js");
  }), Oe(r, "iconUiBaseballPlayerInplay", function () {
    return import("./icon_ui_baseball-player-inplay-449a3e85.js");
  }), Oe(r, "iconUiBaseballPlayerStrike", function () {
    return import("./icon_ui_baseball-player-strike-5ea0a21f.js");
  }), Oe(r, "iconUiStadium", function () {
    return import("./icon_ui_stadium-9bb5bb1f.js");
  }), Oe(r, "iconUiBoost", function () {
    return import("./icon_ui_boost-e77ef1e0.js");
  }), Oe(r, "iconUiDotsVertical", function () {
    return import("./icon_ui_dots-vertical-fde28633.js");
  }), Oe(r, "iconUiStatusLost", function () {
    return import("./icon_ui_status-lost-da86d6a3.js");
  }), Oe(r, "iconUiStatusWon", function () {
    return import("./icon_ui_status-won-b4dba029.js");
  }), Oe(r, "iconUiBan", function () {
    return import("./icon_ui_ban-dd138e24.js");
  }), Oe(r, "iconUiCheckmark", function () {
    return import("./icon_ui_checkmark-58a8cf41.js");
  }), Oe(r, "iconUiCheckmarkCircle", function () {
    return import("./icon_ui_checkmark-circle-3581ff07.js");
  }), Oe(r, "iconUiRibbon", function () {
    return import("./icon_ui_ribbon-3e0537d3.js");
  }), Oe(r, "iconUiWallet", function () {
    return import("./icon_ui_wallet-d621d15b.js");
  }), Oe(r, "iconUiTshirt", function () {
    return import("./icon_ui_tshirt-62cbffc7.js");
  }), Oe(r, "iconUiTicket", function () {
    return import("./icon_ui_ticket-13eed956.js");
  }), Oe(r, "iconUiBed", function () {
    return import("./icon_ui_bed-9f8ce56c.js");
  }), Oe(r, "iconUiBell", function () {
    return import("./icon_ui_bell-bc1eb220.js");
  }), Oe(r, "iconUiHotel", function () {
    return import("./icon_ui_hotel-05ad4223.js");
  }), Oe(r, "iconUiConcierge", function () {
    return import("./icon_ui_concierge-41992971.js");
  }), Oe(r, "iconUiArrowDown", function () {
    return import("./icon_ui_arrow-down-cd61d4bb.js");
  }), Oe(r, "iconUiArrowLeft", function () {
    return import("./icon_ui_arrow-left-c5d759eb.js");
  }), Oe(r, "iconUiArrowRight", function () {
    return import("./icon_ui_arrow-right-cd89c3b3.js");
  }), Oe(r, "iconUiArrowUp", function () {
    return import("./icon_ui_arrow-up-8de3182a.js");
  }), Oe(r, "iconUiLaunch", function () {
    return import("./icon_ui_launch-f68f3476.js");
  }), Oe(r, "iconUiFireBetsColor", function () {
    return import("./icon_ui_fire-bets_color-b8bed63c.js");
  }), Oe(r, "iconUiDownload", function () {
    return import("./icon_ui_download-7dffdbcb.js");
  }), Oe(r, "iconUiUpload", function () {
    return import("./icon_ui_upload-b74e6bc1.js");
  }), Oe(r, "iconUiBulletList", function () {
    return import("./icon_ui_bullet-list-fa77b2d7.js");
  }), Oe(r, "iconUiUpcoming", function () {
    return import("./icon_ui_upcoming-cb0f9e15.js");
  }), Oe(r, "iconUiTransactions", function () {
    return import("./icon_ui_transactions-e075a7dd.js");
  }), Oe(r, "iconUiStarPromo", function () {
    return import("./icon_ui_star-promo-c98a2352.js");
  }), Oe(r, "iconUiArchive", function () {
    return import("./icon_ui_archive-a317acdf.js");
  }), Oe(r, "iconUiCompetitions", function () {
    return import("./icon_ui_competitions-206763df.js");
  }), Oe(r, "iconUiOddsFormatFraction", function () {
    return import("./icon_ui_odds-format-fraction-d55e1911.js");
  }), Oe(r, "iconUiOddsFormatDecimal", function () {
    return import("./icon_ui_odds-format-decimal-6d603492.js");
  }), Oe(r, "iconUiOddsFormatAmerican", function () {
    return import("./icon_ui_odds-format-american-4094f4f0.js");
  }), Oe(r, "iconUiComments", function () {
    return import("./icon_ui_comments-11884019.js");
  }), Oe(r, "iconUiHeartOutline", function () {
    return import("./icon_ui_heart_outline-e2e570a2.js");
  }), Oe(r, "iconUiPlay", function () {
    return import("./icon_ui_play-bc471568.js");
  }), Oe(r, "iconUiMenu", function () {
    return import("./icon_ui_menu-4ee5d831.js");
  }), Oe(r, "iconUiArrowRightCircle", function () {
    return import("./icon_ui_arrow-right-circle-f2ba9ea7.js");
  }), Oe(r, "iconUiMute", function () {
    return import("./icon_ui_mute-8dc41188.js");
  }), Oe(r, "iconUiVolume", function () {
    return import("./icon_ui_volume-2c89e8e6.js");
  }), Oe(r, "iconUiUserSettings", function () {
    return import("./icon_ui_user-settings-98587be5.js");
  }), Oe(r, "iconUiUserPromo", function () {
    return import("./icon_ui_user-promo-2dd9d05d.js");
  }), Oe(r, "iconUiScanId", function () {
    return import("./icon_ui_scan-id-6c82b941.js");
  }), Oe(r, "iconUiChecklist", function () {
    return import("./icon_ui_checklist-2f145c05.js");
  }), Oe(r, "iconUiError", function () {
    return import("./icon_ui_error-b00fa6f2.js");
  }), Oe(r, "iconUiWarning", function () {
    return import("./icon_ui_warning-7fafb3fb.js");
  }), Oe(r, "iconUiDeleteX", function () {
    return import("./icon_ui_delete-x-a3a36afd.js");
  }), Oe(r, "iconUiAlignRight", function () {
    return import("./icon_ui_align-right-2b5b1d12.js");
  }), Oe(r, "iconUiAlignLeft", function () {
    return import("./icon_ui_align-left-af296afb.js");
  }), Oe(r, "iconUiAlignCenter", function () {
    return import("./icon_ui_align-center-fc58280b.js");
  }), Oe(r, "iconUiDocument", function () {
    return import("./icon_ui_document-baaaeaab.js");
  }), Oe(r, "iconUiFunnel", function () {
    return import("./icon_ui_funnel-7e89e501.js");
  }), Oe(r, "iconUiSettings", function () {
    return import("./icon_ui_settings-01b500d1.js");
  }), Oe(r, "iconUiGrid", function () {
    return import("./icon_ui_grid-e33d843e.js");
  }), Oe(r, "iconUiMinusCircle", function () {
    return import("./icon_ui_minus-circle-89dad204.js");
  }), Oe(r, "iconUiLogout", function () {
    return import("./icon_ui_logout-fe184fc9.js");
  }), Oe(r, "iconUiPin", function () {
    return import("./icon_ui_pin-cc213772.js");
  }), Oe(r, "iconUiBulb", function () {
    return import("./icon_ui_bulb-96296f48.js");
  }), Oe(r, "iconUiGift", function () {
    return import("./icon_ui_gift-b23475fc.js");
  }), Oe(r, "iconUiHome", function () {
    return import("./icon_ui_home-902896cd.js");
  }), Oe(r, "iconUiKeyboard", function () {
    return import("./icon_ui_keyboard-5eb15f44.js");
  }), Oe(r, "iconUiHistory", function () {
    return import("./icon_ui_history-2dfc4e8b.js");
  }), Oe(r, "iconUiPencil", function () {
    return import("./icon_ui_pencil-35e12f60.js");
  }), Oe(r, "iconUiLightning", function () {
    return import("./icon_ui_lightning-09fbb11d.js");
  }), Oe(r, "iconUiQuestion", function () {
    return import("./icon_ui_question-c814653c.js");
  }), Oe(r, "iconUiAlarm", function () {
    return import("./icon_ui_alarm-8b373548.js");
  }), Oe(r, "iconUiPersonCircle", function () {
    return import("./icon_ui_person-circle-efa1bffd.js");
  }), Oe(r, "iconUiView", function () {
    return import("./icon_ui_view-19ba1c3d.js");
  }), Oe(r, "iconUiHide", function () {
    return import("./icon_ui_hide-f0c4fb3f.js");
  }), Oe(r, "iconUiShare", function () {
    return import("./icon_ui_share-df49383b.js");
  }), Oe(r, "iconUiChat", function () {
    return import("./icon_ui_chat-87d130a4.js");
  }), Oe(r, "iconUiEnvelope", function () {
    return import("./icon_ui_envelope-f20e6c6a.js");
  }), Oe(r, "iconUiCalendar", function () {
    return import("./icon_ui_calendar-f49fd6ea.js");
  }), Oe(r, "iconUiCreditCard", function () {
    return import("./icon_ui_credit-card-a3cd06ac.js");
  }), Oe(r, "iconUiSticker", function () {
    return import("./icon_ui_sticker-71ad22ab.js");
  }), Oe(r, "iconUiPhone", function () {
    return import("./icon_ui_phone-1933f86b.js");
  }), Oe(r, "iconUiLink", function () {
    return import("./icon_ui_link-4e2e1e0a.js");
  }), Oe(r, "iconUiPerson", function () {
    return import("./icon_ui_person-8ee21c63.js");
  }), Oe(r, "iconUiLocked", function () {
    return import("./icon_ui_locked-40547282.js");
  }), Oe(r, "iconUiUnlocked", function () {
    return import("./icon_ui_unlocked-dc37808d.js");
  }), Oe(r, "iconUiStarOutline", function () {
    return import("./icon_ui_star_outline-f3d9c6f5.js");
  }), Oe(r, "iconUiAndroidFaceId", function () {
    return import("./icon_ui_android_face_id-f77414e0.js");
  }), Oe(r, "iconUiIosTouchId", function () {
    return import("./icon_ui_ios_touch_id-efaec6c7.js");
  }), Oe(r, "iconUiCloseCircle", function () {
    return import("./icon_ui_close-circle-12101bf0.js");
  }), Oe(r, "iconUiHeart", function () {
    return import("./icon_ui_heart-182e612f.js");
  }), Oe(r, "iconUiCopy", function () {
    return import("./icon_ui_copy-ed40bad7.js");
  }), Oe(r, "iconUiQuickPickInitials", function () {
    return import("./icon_ui_quick-pick-initials-6577ee9c.js");
  }), Oe(r, "iconUiQuickPick", function () {
    return import("./icon_ui_quick-pick-6327d088.js");
  }), Oe(r, "iconUiStar", function () {
    return import("./icon_ui_star-ead7d03d.js");
  }), Oe(r, "iconUiGps", function () {
    return import("./icon_ui_gps-0f78f03a.js");
  }), Oe(r, "iconUiIosFaceId", function () {
    return import("./icon_ui_ios-face-id-d9687ca7.js");
  }), Oe(r, "iconUiAndroidTouchId", function () {
    return import("./icon_ui_android-touch-id-8b988f99.js");
  }), Oe(r, "iconUiNeutralBan", function () {
    return import("./icon_ui_neutral-ban-86e0359f.js");
  }), Oe(r, "iconUiTrash", function () {
    return import("./icon_ui_trash-a35193c1.js");
  }), Oe(r, "iconUiDollar", function () {
    return import("./icon_ui_dollar-6a9ebee6.js");
  }), Oe(r, "iconUiLive", function () {
    return import("./icon_ui_live-5b6e5909.js");
  }), Oe(r, "iconUiCasinoChip", function () {
    return import("./icon_ui_casino-chip-daafb6a6.js");
  }), Oe(r, "iconUiLuckySeven", function () {
    return import("./icon_ui_lucky-seven-192575f5.js");
  }), Oe(r, "iconUiDealer", function () {
    return import("./icon_ui_dealer-57da90f6.js");
  }), Oe(r, "iconUiTableGames", function () {
    return import("./icon_ui_table-games-b1c1c07f.js");
  }), Oe(r, "iconUiCheckboxUnchecked", function () {
    return import("./icon_ui_checkbox-unchecked-8bf2ee2d.js");
  }), Oe(r, "iconUiCheckboxChecked", function () {
    return import("./icon_ui_checkbox-checked-5fb84c78.js");
  }), Oe(r, "iconUiTemple", function () {
    return import("./icon_ui_temple-b6d6a40c.js");
  }), Oe(r, "iconUiTempleOutline", function () {
    return import("./icon_ui_temple-outline-75bde2cd.js");
  }), Oe(r, "iconUiMeterFaster", function () {
    return import("./icon_ui_meter-faster-8c8b7271.js");
  }), Oe(r, "iconUiMeterSlower", function () {
    return import("./icon_ui_meter-slower-da704bee.js");
  }), Oe(r, "iconUiCasinoCash", function () {
    return import("./icon_ui_casino-cash-2c6c7de4.js");
  }), Oe(r, "iconUiTriangleSmRight", function () {
    return import("./icon_ui_triangle-sm-right-75400023.js");
  }), r),
  Di = (Oe(a = {
    logoNflCleOnDark: function logoNflCleOnDark() {
      return import("./logo_nfl_cle_onDark-dd4e1561.js");
    },
    logoNflCleOnLight: function logoNflCleOnLight() {
      return import("./logo_nfl_cle_onLight-9fcde2f0.js");
    },
    logoNhlUtaOnDark: function logoNhlUtaOnDark() {
      return import("./logo_nhl_uta_onDark-feb91ff0.js");
    },
    logoNhlUtaOnLight: function logoNhlUtaOnLight() {
      return import("./logo_nhl_uta_onLight-c119603f.js");
    },
    logoNbaMinOnLight: function logoNbaMinOnLight() {
      return import("./logo_nba_min_onLight-e3c6a895.js");
    },
    logoNhlNyrOnLight: function logoNhlNyrOnLight() {
      return import("./logo_nhl_nyr_onLight-5ce2cb29.js");
    },
    logoNhlCbjOnLight: function logoNhlCbjOnLight() {
      return import("./logo_nhl_cbj_onLight-7f3437f6.js");
    },
    logoNhlAnaOnDark: function logoNhlAnaOnDark() {
      return import("./logo_nhl_ana_onDark-44030268.js");
    },
    logoNhlAnaOnLight: function logoNhlAnaOnLight() {
      return import("./logo_nhl_ana_onLight-4d370cb8.js");
    },
    logoNhlWshOnLight: function logoNhlWshOnLight() {
      return import("./logo_nhl_wsh_onLight-368b08dd.js");
    },
    logoNhlVanOnLight: function logoNhlVanOnLight() {
      return import("./logo_nhl_van_onLight-38e4b948.js");
    },
    logoNhlFlaOnLight: function logoNhlFlaOnLight() {
      return import("./logo_nhl_fla_onLight-e0902427.js");
    },
    logoNhlWpgOnLight: function logoNhlWpgOnLight() {
      return import("./logo_nhl_wpg_onLight-91fa33bb.js");
    },
    logoNhlCarOnLight: function logoNhlCarOnLight() {
      return import("./logo_nhl_car_onLight-9c7014d0.js");
    },
    logoNhlEdmOnLight: function logoNhlEdmOnLight() {
      return import("./logo_nhl_edm_onLight-081bc775.js");
    },
    logoNhlBosOnLight: function logoNhlBosOnLight() {
      return import("./logo_nhl_bos_onLight-980e36c7.js");
    },
    logoNhlBufOnLight: function logoNhlBufOnLight() {
      return import("./logo_nhl_buf_onLight-d2fafb17.js");
    },
    logoNhlCgyOnLight: function logoNhlCgyOnLight() {
      return import("./logo_nhl_cgy_onLight-92153f4a.js");
    },
    logoNhlChiOnLight: function logoNhlChiOnLight() {
      return import("./logo_nhl_chi_onLight-57bc823f.js");
    },
    logoNhlSeaOnLight: function logoNhlSeaOnLight() {
      return import("./logo_nhl_sea_onLight-6617e34f.js");
    },
    logoNhlColOnLight: function logoNhlColOnLight() {
      return import("./logo_nhl_col_onLight-6d988d51.js");
    },
    logoNhlDalOnLight: function logoNhlDalOnLight() {
      return import("./logo_nhl_dal_onLight-d1f794c1.js");
    },
    logoNhlDetOnLight: function logoNhlDetOnLight() {
      return import("./logo_nhl_det_onLight-10f161b3.js");
    },
    logoNhlOttOnLight: function logoNhlOttOnLight() {
      return import("./logo_nhl_ott_onLight-5560f581.js");
    },
    logoNhlMinOnLight: function logoNhlMinOnLight() {
      return import("./logo_nhl_min_onLight-b3e32c5a.js");
    },
    logoNhlMtlOnLight: function logoNhlMtlOnLight() {
      return import("./logo_nhl_mtl_onLight-b37a4812.js");
    },
    logoNhlNshOnLight: function logoNhlNshOnLight() {
      return import("./logo_nhl_nsh_onLight-79b1fc0d.js");
    },
    logoNhlNjdOnLight: function logoNhlNjdOnLight() {
      return import("./logo_nhl_njd_onLight-477262ea.js");
    },
    logoNhlNyiOnLight: function logoNhlNyiOnLight() {
      return import("./logo_nhl_nyi_onLight-ecae1355.js");
    },
    logoNhlStlOnLight: function logoNhlStlOnLight() {
      return import("./logo_nhl_stl_onLight-87cd1f28.js");
    },
    logoNhlPhiOnLight: function logoNhlPhiOnLight() {
      return import("./logo_nhl_phi_onLight-fdc2e7ed.js");
    },
    logoNhlPitOnLight: function logoNhlPitOnLight() {
      return import("./logo_nhl_pit_onLight-8da2a9e3.js");
    },
    logoNhlSjsOnLight: function logoNhlSjsOnLight() {
      return import("./logo_nhl_sjs_onLight-262f04fb.js");
    },
    logoNhlVgkOnLight: function logoNhlVgkOnLight() {
      return import("./logo_nhl_vgk_onLight-4fd51249.js");
    },
    logoNhlTblOnLight: function logoNhlTblOnLight() {
      return import("./logo_nhl_tbl_onLight-9ef9b984.js");
    },
    logoNhlVgkOnDark: function logoNhlVgkOnDark() {
      return import("./logo_nhl_vgk_onDark-bdc69d01.js");
    },
    logoNhlPitOnDark: function logoNhlPitOnDark() {
      return import("./logo_nhl_pit_onDark-b29060d5.js");
    },
    logoNhlWshOnDark: function logoNhlWshOnDark() {
      return import("./logo_nhl_wsh_onDark-dc7055b1.js");
    },
    logoNhlFlaOnDark: function logoNhlFlaOnDark() {
      return import("./logo_nhl_fla_onDark-f118acba.js");
    },
    logoNhlVanOnDark: function logoNhlVanOnDark() {
      return import("./logo_nhl_van_onDark-fe3459ea.js");
    },
    logoNhlBosOnDark: function logoNhlBosOnDark() {
      return import("./logo_nhl_bos_onDark-f1f96711.js");
    },
    logoNhlBufOnDark: function logoNhlBufOnDark() {
      return import("./logo_nhl_buf_onDark-43f3631e.js");
    },
    logoNhlCgyOnDark: function logoNhlCgyOnDark() {
      return import("./logo_nhl_cgy_onDark-17f40d73.js");
    },
    logoNhlCarOnDark: function logoNhlCarOnDark() {
      return import("./logo_nhl_car_onDark-c7de8e5d.js");
    },
    logoNhlChiOnDark: function logoNhlChiOnDark() {
      return import("./logo_nhl_chi_onDark-5f9ca134.js");
    },
    logoNhlCbjOnDark: function logoNhlCbjOnDark() {
      return import("./logo_nhl_cbj_onDark-e6a6c8cb.js");
    },
    logoNhlColOnDark: function logoNhlColOnDark() {
      return import("./logo_nhl_col_onDark-dde60ec8.js");
    },
    logoNhlDalOnDark: function logoNhlDalOnDark() {
      return import("./logo_nhl_dal_onDark-ce2cbe75.js");
    },
    logoNhlDetOnDark: function logoNhlDetOnDark() {
      return import("./logo_nhl_det_onDark-4c864dff.js");
    },
    logoNhlEdmOnDark: function logoNhlEdmOnDark() {
      return import("./logo_nhl_edm_onDark-a4b2f3b3.js");
    },
    logoNhlWpgOnDark: function logoNhlWpgOnDark() {
      return import("./logo_nhl_wpg_onDark-9e397670.js");
    },
    logoNhlMinOnDark: function logoNhlMinOnDark() {
      return import("./logo_nhl_min_onDark-5fc5496a.js");
    },
    logoNhlMtlOnDark: function logoNhlMtlOnDark() {
      return import("./logo_nhl_mtl_onDark-b53a1456.js");
    },
    logoNhlNshOnDark: function logoNhlNshOnDark() {
      return import("./logo_nhl_nsh_onDark-159a33f2.js");
    },
    logoNhlNjdOnDark: function logoNhlNjdOnDark() {
      return import("./logo_nhl_njd_onDark-33213868.js");
    },
    logoNhlNyiOnDark: function logoNhlNyiOnDark() {
      return import("./logo_nhl_nyi_onDark-3d2c7a04.js");
    },
    logoNhlNyrOnDark: function logoNhlNyrOnDark() {
      return import("./logo_nhl_nyr_onDark-4f4817fc.js");
    },
    logoNhlOttOnDark: function logoNhlOttOnDark() {
      return import("./logo_nhl_ott_onDark-a08a5dc6.js");
    },
    logoNhlPhiOnDark: function logoNhlPhiOnDark() {
      return import("./logo_nhl_phi_onDark-ba6f7b6a.js");
    },
    logoNhlSeaOnDark: function logoNhlSeaOnDark() {
      return import("./logo_nhl_sea_onDark-2d35b425.js");
    },
    logoNhlSjsOnDark: function logoNhlSjsOnDark() {
      return import("./logo_nhl_sjs_onDark-d48b6e8a.js");
    },
    logoNhlStlOnDark: function logoNhlStlOnDark() {
      return import("./logo_nhl_stl_onDark-d4565b8f.js");
    },
    logoNhlTblOnDark: function logoNhlTblOnDark() {
      return import("./logo_nhl_tbl_onDark-2c865004.js");
    },
    logoNhlTorOnLight: function logoNhlTorOnLight() {
      return import("./logo_nhl_tor_onLight-4a92095c.js");
    },
    logoNhlTorOnDark: function logoNhlTorOnDark() {
      return import("./logo_nhl_tor_onDark-e27c2473.js");
    },
    logoNhlLakOnDark: function logoNhlLakOnDark() {
      return import("./logo_nhl_lak_onDark-69ac4688.js");
    },
    logoNhlLakOnLight: function logoNhlLakOnLight() {
      return import("./logo_nhl_lak_onLight-e3897519.js");
    },
    logoNflBalOnDark: function logoNflBalOnDark() {
      return import("./logo_nfl_bal_onDark-4233ba80.js");
    },
    logoNflCinOnLight: function logoNflCinOnLight() {
      return import("./logo_nfl_cin_onLight-d80630e2.js");
    },
    logoNflGbOnLight: function logoNflGbOnLight() {
      return import("./logo_nfl_gb_onLight-1ec82acd.js");
    },
    logoNflNyjOnLight: function logoNflNyjOnLight() {
      return import("./logo_nfl_nyj_onLight-cf93e2fc.js");
    },
    logoNflTbOnLight: function logoNflTbOnLight() {
      return import("./logo_nfl_tb_onLight-fa463602.js");
    },
    logoNflSfOnLight: function logoNflSfOnLight() {
      return import("./logo_nfl_sf_onLight-64a1295c.js");
    },
    logoNflSeaOnLight: function logoNflSeaOnLight() {
      return import("./logo_nfl_sea_onLight-4d291883.js");
    },
    logoNflWasOnLight: function logoNflWasOnLight() {
      return import("./logo_nfl_was_onLight-3546c996.js");
    },
    logoNflMiaOnLight: function logoNflMiaOnLight() {
      return import("./logo_nfl_mia_onLight-6f001dd6.js");
    },
    logoNflAtlOnLight: function logoNflAtlOnLight() {
      return import("./logo_nfl_atl_onLight-7c091c9b.js");
    },
    logoNflAriOnLight: function logoNflAriOnLight() {
      return import("./logo_nfl_ari_onLight-8bf65779.js");
    },
    logoNflBalOnLight: function logoNflBalOnLight() {
      return import("./logo_nfl_bal_onLight-51f33611.js");
    },
    logoNflChiOnLight: function logoNflChiOnLight() {
      return import("./logo_nfl_chi_onLight-88ad3500.js");
    },
    logoNflBufOnLight: function logoNflBufOnLight() {
      return import("./logo_nfl_buf_onLight-af7c63da.js");
    },
    logoNflKcOnLight: function logoNflKcOnLight() {
      return import("./logo_nfl_kc_onLight-769f7e31.js");
    },
    logoNflDenOnLight: function logoNflDenOnLight() {
      return import("./logo_nfl_den_onLight-a597cd31.js");
    },
    logoNflDalOnLight: function logoNflDalOnLight() {
      return import("./logo_nfl_dal_onLight-c084b6ac.js");
    },
    logoNflIndOnLight: function logoNflIndOnLight() {
      return import("./logo_nfl_ind_onLight-6e050c31.js");
    },
    logoNflDetOnLight: function logoNflDetOnLight() {
      return import("./logo_nfl_det_onLight-c5c493be.js");
    },
    logoNflLacOnLight: function logoNflLacOnLight() {
      return import("./logo_nfl_lac_onLight-1d2dd83f.js");
    },
    logoNflHouOnLight: function logoNflHouOnLight() {
      return import("./logo_nfl_hou_onLight-704d681f.js");
    },
    logoNflCinOnDark: function logoNflCinOnDark() {
      return import("./logo_nfl_cin_onDark-86741ccd.js");
    },
    logoNflJaxOnLight: function logoNflJaxOnLight() {
      return import("./logo_nfl_jax_onLight-fdf09668.js");
    },
    logoNflLvOnLight: function logoNflLvOnLight() {
      return import("./logo_nfl_lv_onLight-a413897d.js");
    },
    logoNflCarOnLight: function logoNflCarOnLight() {
      return import("./logo_nfl_car_onLight-00d7772a.js");
    },
    logoNflIndOnDark: function logoNflIndOnDark() {
      return import("./logo_nfl_ind_onDark-3c67ef23.js");
    },
    logoNflLarOnLight: function logoNflLarOnLight() {
      return import("./logo_nfl_lar_onLight-61167d14.js");
    },
    logoNflTenOnLight: function logoNflTenOnLight() {
      return import("./logo_nfl_ten_onLight-1760a88a.js");
    },
    logoNflMinOnLight: function logoNflMinOnLight() {
      return import("./logo_nfl_min_onLight-64e6b5e1.js");
    },
    logoNflNeOnLight: function logoNflNeOnLight() {
      return import("./logo_nfl_ne_onLight-5a8248cc.js");
    },
    logoNflNoOnLight: function logoNflNoOnLight() {
      return import("./logo_nfl_no_onLight-a3a66ee2.js");
    },
    logoNflNygOnLight: function logoNflNygOnLight() {
      return import("./logo_nfl_nyg_onLight-234f347f.js");
    },
    logoNflPhiOnLight: function logoNflPhiOnLight() {
      return import("./logo_nfl_phi_onLight-72adfbc3.js");
    },
    logoNflPitOnLight: function logoNflPitOnLight() {
      return import("./logo_nfl_pit_onLight-65b68192.js");
    },
    logoNflPhiOnDark: function logoNflPhiOnDark() {
      return import("./logo_nfl_phi_onDark-2d69805f.js");
    },
    logoNflDenOnDark: function logoNflDenOnDark() {
      return import("./logo_nfl_den_onDark-b696f2d3.js");
    },
    logoNflJaxOnDark: function logoNflJaxOnDark() {
      return import("./logo_nfl_jax_onDark-cc8cb4b9.js");
    },
    logoNflWasOnDark: function logoNflWasOnDark() {
      return import("./logo_nfl_was_onDark-f86c39e7.js");
    },
    logoNflSfOnDark: function logoNflSfOnDark() {
      return import("./logo_nfl_sf_onDark-541986ac.js");
    },
    logoNflAriOnDark: function logoNflAriOnDark() {
      return import("./logo_nfl_ari_onDark-ad2b69be.js");
    },
    logoNflSeaOnDark: function logoNflSeaOnDark() {
      return import("./logo_nfl_sea_onDark-f7c86c75.js");
    },
    logoNflTenOnDark: function logoNflTenOnDark() {
      return import("./logo_nfl_ten_onDark-eea30015.js");
    },
    logoNflCarOnDark: function logoNflCarOnDark() {
      return import("./logo_nfl_car_onDark-4d052adb.js");
    },
    logoNflBufOnDark: function logoNflBufOnDark() {
      return import("./logo_nfl_buf_onDark-ab1dd165.js");
    },
    logoNflTbOnDark: function logoNflTbOnDark() {
      return import("./logo_nfl_tb_onDark-ba49474c.js");
    },
    logoNflDalOnDark: function logoNflDalOnDark() {
      return import("./logo_nfl_dal_onDark-f9b6baec.js");
    },
    logoNflMinOnDark: function logoNflMinOnDark() {
      return import("./logo_nfl_min_onDark-be7de5db.js");
    },
    logoNflPitOnDark: function logoNflPitOnDark() {
      return import("./logo_nfl_pit_onDark-b9e79e37.js");
    },
    logoNflNoOnDark: function logoNflNoOnDark() {
      return import("./logo_nfl_no_onDark-3dda5fde.js");
    },
    logoNflNygOnDark: function logoNflNygOnDark() {
      return import("./logo_nfl_nyg_onDark-73b95b6a.js");
    },
    logoNflNeOnDark: function logoNflNeOnDark() {
      return import("./logo_nfl_ne_onDark-0fa0363f.js");
    },
    logoNflDetOnDark: function logoNflDetOnDark() {
      return import("./logo_nfl_det_onDark-c004a619.js");
    },
    logoNflMiaOnDark: function logoNflMiaOnDark() {
      return import("./logo_nfl_mia_onDark-37a9f20d.js");
    },
    logoNflLarOnDark: function logoNflLarOnDark() {
      return import("./logo_nfl_lar_onDark-0646b4a0.js");
    },
    logoNflLacOnDark: function logoNflLacOnDark() {
      return import("./logo_nfl_lac_onDark-4e0cd697.js");
    },
    logoNflLvOnDark: function logoNflLvOnDark() {
      return import("./logo_nfl_lv_onDark-7e0c115d.js");
    },
    logoNflKcOnDark: function logoNflKcOnDark() {
      return import("./logo_nfl_kc_onDark-7080214f.js");
    },
    logoNflAtlOnDark: function logoNflAtlOnDark() {
      return import("./logo_nfl_atl_onDark-e85929e9.js");
    },
    logoNflChiOnDark: function logoNflChiOnDark() {
      return import("./logo_nfl_chi_onDark-3b022e01.js");
    },
    logoNflHouOnDark: function logoNflHouOnDark() {
      return import("./logo_nfl_hou_onDark-d383342b.js");
    },
    logoNflGbOnDark: function logoNflGbOnDark() {
      return import("./logo_nfl_gb_onDark-e88b6811.js");
    },
    logoNflNyjOnDark: function logoNflNyjOnDark() {
      return import("./logo_nfl_nyj_onDark-efece7a7.js");
    },
    logoNbaDalOnLight: function logoNbaDalOnLight() {
      return import("./logo_nba_dal_onLight-4d7f3c85.js");
    },
    logoNbaDenOnLight: function logoNbaDenOnLight() {
      return import("./logo_nba_den_onLight-4a1ab172.js");
    },
    logoNbaMilOnLight: function logoNbaMilOnLight() {
      return import("./logo_nba_mil_onLight-577d0276.js");
    },
    logoNbaChaOnLight: function logoNbaChaOnLight() {
      return import("./logo_nba_cha_onLight-cb7de40e.js");
    },
    logoNbaDalOnDark: function logoNbaDalOnDark() {
      return import("./logo_nba_dal_onDark-f0d6b28d.js");
    },
    logoNbaCleOnDark: function logoNbaCleOnDark() {
      return import("./logo_nba_cle_onDark-6babd2d1.js");
    },
    logoNbaCleOnLight: function logoNbaCleOnLight() {
      return import("./logo_nba_cle_onLight-cc293d5b.js");
    },
    logoNbaDetOnLight: function logoNbaDetOnLight() {
      return import("./logo_nba_det_onLight-e266a039.js");
    },
    logoNbaAtlOnLight: function logoNbaAtlOnLight() {
      return import("./logo_nba_atl_onLight-79b0b169.js");
    },
    logoNbaSasOnLight: function logoNbaSasOnLight() {
      return import("./logo_nba_sas_onLight-272729bf.js");
    },
    logoNbaWasOnLight: function logoNbaWasOnLight() {
      return import("./logo_nba_was_onLight-71678f23.js");
    },
    logoNbaTorOnLight: function logoNbaTorOnLight() {
      return import("./logo_nba_tor_onLight-4b8e24e6.js");
    },
    logoNbaBknOnLight: function logoNbaBknOnLight() {
      return import("./logo_nba_bkn_onLight-87e92acb.js");
    },
    logoNbaBosOnLight: function logoNbaBosOnLight() {
      return import("./logo_nba_bos_onLight-345d69a2.js");
    },
    logoNbaOkcOnLight: function logoNbaOkcOnLight() {
      return import("./logo_nba_okc_onLight-7dc862f0.js");
    },
    logoNbaMiaOnLight: function logoNbaMiaOnLight() {
      return import("./logo_nba_mia_onLight-413e0e21.js");
    },
    logoNbaGswOnLight: function logoNbaGswOnLight() {
      return import("./logo_nba_gsw_onLight-8e57f315.js");
    },
    logoNbaHouOnLight: function logoNbaHouOnLight() {
      return import("./logo_nba_hou_onLight-0370798a.js");
    },
    logoNbaIndOnLight: function logoNbaIndOnLight() {
      return import("./logo_nba_ind_onLight-1528ca71.js");
    },
    logoNbaLacOnLight: function logoNbaLacOnLight() {
      return import("./logo_nba_lac_onLight-94899f37.js");
    },
    logoNbaLalOnLight: function logoNbaLalOnLight() {
      return import("./logo_nba_lal_onLight-f6a11300.js");
    },
    logoNbaMemOnLight: function logoNbaMemOnLight() {
      return import("./logo_nba_mem_onLight-d8115e53.js");
    },
    logoNbaBosOnDark: function logoNbaBosOnDark() {
      return import("./logo_nba_bos_onDark-376a09c2.js");
    },
    logoNbaNopOnLight: function logoNbaNopOnLight() {
      return import("./logo_nba_nop_onLight-10e6939a.js");
    },
    logoNbaChiOnLight: function logoNbaChiOnLight() {
      return import("./logo_nba_chi_onLight-970d2350.js");
    },
    logoNbaNykOnLight: function logoNbaNykOnLight() {
      return import("./logo_nba_nyk_onLight-dc9266de.js");
    },
    logoNbaUtaOnLight: function logoNbaUtaOnLight() {
      return import("./logo_nba_uta_onLight-de67e4df.js");
    },
    logoNbaOrlOnLight: function logoNbaOrlOnLight() {
      return import("./logo_nba_orl_onLight-3ef36c84.js");
    },
    logoNbaPorOnLight: function logoNbaPorOnLight() {
      return import("./logo_nba_por_onLight-53083087.js");
    },
    logoNbaPhxOnLight: function logoNbaPhxOnLight() {
      return import("./logo_nba_phx_onLight-f9bb2c52.js");
    },
    logoNbaDetOnDark: function logoNbaDetOnDark() {
      return import("./logo_nba_det_onDark-dcf0e050.js");
    },
    logoNbaSacOnLight: function logoNbaSacOnLight() {
      return import("./logo_nba_sac_onLight-ea7bffb4.js");
    },
    logoNbaGswOnDark: function logoNbaGswOnDark() {
      return import("./logo_nba_gsw_onDark-646622b1.js");
    },
    logoNbaPhxOnDark: function logoNbaPhxOnDark() {
      return import("./logo_nba_phx_onDark-89abcfa5.js");
    },
    logoNbaDenOnDark: function logoNbaDenOnDark() {
      return import("./logo_nba_den_onDark-762e8783.js");
    },
    logoNbaChaOnDark: function logoNbaChaOnDark() {
      return import("./logo_nba_cha_onDark-240c587e.js");
    },
    logoNbaBknOnDark: function logoNbaBknOnDark() {
      return import("./logo_nba_bkn_onDark-43b600dd.js");
    },
    logoNbaSasOnDark: function logoNbaSasOnDark() {
      return import("./logo_nba_sas_onDark-19ffb1af.js");
    },
    logoNbaUtaOnDark: function logoNbaUtaOnDark() {
      return import("./logo_nba_uta_onDark-bfd2d069.js");
    },
    logoNbaLacOnDark: function logoNbaLacOnDark() {
      return import("./logo_nba_lac_onDark-75384eb0.js");
    },
    logoNbaLalOnDark: function logoNbaLalOnDark() {
      return import("./logo_nba_lal_onDark-93b21e18.js");
    },
    logoNbaHouOnDark: function logoNbaHouOnDark() {
      return import("./logo_nba_hou_onDark-9407336d.js");
    },
    logoNbaIndOnDark: function logoNbaIndOnDark() {
      return import("./logo_nba_ind_onDark-0050f253.js");
    },
    logoNbaTorOnDark: function logoNbaTorOnDark() {
      return import("./logo_nba_tor_onDark-3922f673.js");
    },
    logoNbaMemOnDark: function logoNbaMemOnDark() {
      return import("./logo_nba_mem_onDark-f9866208.js");
    },
    logoNbaMilOnDark: function logoNbaMilOnDark() {
      return import("./logo_nba_mil_onDark-86ca3750.js");
    },
    logoNbaMiaOnDark: function logoNbaMiaOnDark() {
      return import("./logo_nba_mia_onDark-0974fcb6.js");
    },
    logoNbaMinOnDark: function logoNbaMinOnDark() {
      return import("./logo_nba_min_onDark-78ae677f.js");
    },
    logoNbaChiOnDark: function logoNbaChiOnDark() {
      return import("./logo_nba_chi_onDark-20bdb7ba.js");
    },
    logoNbaNopOnDark: function logoNbaNopOnDark() {
      return import("./logo_nba_nop_onDark-32e1db8e.js");
    },
    logoNbaNykOnDark: function logoNbaNykOnDark() {
      return import("./logo_nba_nyk_onDark-6f963f0d.js");
    },
    logoNbaOkcOnDark: function logoNbaOkcOnDark() {
      return import("./logo_nba_okc_onDark-523c25f2.js");
    },
    logoNbaOrlOnDark: function logoNbaOrlOnDark() {
      return import("./logo_nba_orl_onDark-66e7e155.js");
    },
    logoNbaPhiOnLight: function logoNbaPhiOnLight() {
      return import("./logo_nba_phi_onLight-8351f1a4.js");
    },
    logoNbaPhiOnDark: function logoNbaPhiOnDark() {
      return import("./logo_nba_phi_onDark-580c9873.js");
    },
    logoNbaWasOnDark: function logoNbaWasOnDark() {
      return import("./logo_nba_was_onDark-7434c08e.js");
    },
    logoNbaPorOnDark: function logoNbaPorOnDark() {
      return import("./logo_nba_por_onDark-25ef4eff.js");
    },
    logoNbaSacOnDark: function logoNbaSacOnDark() {
      return import("./logo_nba_sac_onDark-03caa0a5.js");
    },
    logoNbaAtlOnDark: function logoNbaAtlOnDark() {
      return import("./logo_nba_atl_onDark-ac0ded59.js");
    },
    logoMlbNymOnLight: function logoMlbNymOnLight() {
      return import("./logo_mlb_nym_onLight-987db202.js");
    },
    logoMlbSeaOnLight: function logoMlbSeaOnLight() {
      return import("./logo_mlb_sea_onLight-5e1c8e2f.js");
    },
    logoMlbLaaOnLight: function logoMlbLaaOnLight() {
      return import("./logo_mlb_laa_onLight-f12ff93c.js");
    },
    logoMlbCinOnDark: function logoMlbCinOnDark() {
      return import("./logo_mlb_cin_onDark-52896710.js");
    },
    logoMlbHouOnDark: function logoMlbHouOnDark() {
      return import("./logo_mlb_hou_onDark-965429b4.js");
    },
    logoMlbKcOnDark: function logoMlbKcOnDark() {
      return import("./logo_mlb_kc_onDark-3d09e2ce.js");
    },
    logoMlbLadOnDark: function logoMlbLadOnDark() {
      return import("./logo_mlb_lad_onDark-b07b32d3.js");
    },
    logoMlbMiaOnDark: function logoMlbMiaOnDark() {
      return import("./logo_mlb_mia_onDark-6f706639.js");
    },
    logoMlbMilOnDark: function logoMlbMilOnDark() {
      return import("./logo_mlb_mil_onDark-f2a7bf1c.js");
    },
    logoMlbPitOnDark: function logoMlbPitOnDark() {
      return import("./logo_mlb_pit_onDark-687cd4ff.js");
    },
    logoMlbNyyOnDark: function logoMlbNyyOnDark() {
      return import("./logo_mlb_nyy_onDark-963bce67.js");
    },
    logoMlbOakOnDark: function logoMlbOakOnDark() {
      return import("./logo_mlb_oak_onDark-6a9fc0cd.js");
    },
    logoMlbPhiOnDark: function logoMlbPhiOnDark() {
      return import("./logo_mlb_phi_onDark-03cda3e8.js");
    },
    logoMlbMiaOnLight: function logoMlbMiaOnLight() {
      return import("./logo_mlb_mia_onLight-a243d559.js");
    },
    logoMlbSdOnDark: function logoMlbSdOnDark() {
      return import("./logo_mlb_sd_onDark-f91b04b1.js");
    },
    logoMlbSeaOnDark: function logoMlbSeaOnDark() {
      return import("./logo_mlb_sea_onDark-72b8d810.js");
    },
    logoMlbSfOnDark: function logoMlbSfOnDark() {
      return import("./logo_mlb_sf_onDark-9d84930a.js");
    },
    logoMlbSfOnLight: function logoMlbSfOnLight() {
      return import("./logo_mlb_sf_onLight-98b5302c.js");
    },
    logoMlbStlOnDark: function logoMlbStlOnDark() {
      return import("./logo_mlb_stl_onDark-da0b27bd.js");
    },
    logoMlbTbOnDark: function logoMlbTbOnDark() {
      return import("./logo_mlb_tb_onDark-bc693f81.js");
    },
    logoMlbTorOnDark: function logoMlbTorOnDark() {
      return import("./logo_mlb_tor_onDark-e1d441df.js");
    },
    logoMlbWshOnDark: function logoMlbWshOnDark() {
      return import("./logo_mlb_wsh_onDark-3d32c5a1.js");
    },
    logoMlbCinOnLight: function logoMlbCinOnLight() {
      return import("./logo_mlb_cin_onLight-fc113785.js");
    },
    logoMlbCleOnDark: function logoMlbCleOnDark() {
      return import("./logo_mlb_cle_onDark-d3d1f1fc.js");
    },
    logoMlbCleOnLight: function logoMlbCleOnLight() {
      return import("./logo_mlb_cle_onLight-92c21ca6.js");
    },
    logoMlbDetOnDark: function logoMlbDetOnDark() {
      return import("./logo_mlb_det_onDark-2074f92f.js");
    },
    logoMlbDetOnLight: function logoMlbDetOnLight() {
      return import("./logo_mlb_det_onLight-1ec0b037.js");
    },
    logoMlbHouOnLight: function logoMlbHouOnLight() {
      return import("./logo_mlb_hou_onLight-97f3753b.js");
    },
    logoMlbKcOnLight: function logoMlbKcOnLight() {
      return import("./logo_mlb_kc_onLight-47f22070.js");
    },
    logoMlbLadOnLight: function logoMlbLadOnLight() {
      return import("./logo_mlb_lad_onLight-baac06c0.js");
    },
    logoMlbChcOnLight: function logoMlbChcOnLight() {
      return import("./logo_mlb_chc_onLight-09abb4af.js");
    },
    logoMlbMilOnLight: function logoMlbMilOnLight() {
      return import("./logo_mlb_mil_onLight-fcf1738f.js");
    },
    logoMlbMinOnDark: function logoMlbMinOnDark() {
      return import("./logo_mlb_min_onDark-f733236e.js");
    },
    logoMlbMinOnLight: function logoMlbMinOnLight() {
      return import("./logo_mlb_min_onLight-de7ed436.js");
    },
    logoMlbNymOnDark: function logoMlbNymOnDark() {
      return import("./logo_mlb_nym_onDark-c6b16e64.js");
    },
    logoMlbNyyOnLight: function logoMlbNyyOnLight() {
      return import("./logo_mlb_nyy_onLight-064a2701.js");
    },
    logoMlbOakOnLight: function logoMlbOakOnLight() {
      return import("./logo_mlb_oak_onLight-2e0de6aa.js");
    },
    logoMlbPhiOnLight: function logoMlbPhiOnLight() {
      return import("./logo_mlb_phi_onLight-d525fddc.js");
    },
    logoMlbPitOnLight: function logoMlbPitOnLight() {
      return import("./logo_mlb_pit_onLight-230fbc6c.js");
    },
    logoMlbSdOnLight: function logoMlbSdOnLight() {
      return import("./logo_mlb_sd_onLight-cdb4cada.js");
    },
    logoMlbBosOnLight: function logoMlbBosOnLight() {
      return import("./logo_mlb_bos_onLight-b0c4117a.js");
    }
  }, "logoMlbSfOnLight", function () {
    return import("./logo_mlb_sf_onLight-98b5302c.js");
  }), Oe(a, "logoMlbStlOnLight", function () {
    return import("./logo_mlb_stl_onLight-8fc71a10.js");
  }), Oe(a, "logoMlbTbOnLight", function () {
    return import("./logo_mlb_tb_onLight-7a6f1aed.js");
  }), Oe(a, "logoMlbTexOnLight", function () {
    return import("./logo_mlb_tex_onLight-29ec7f31.js");
  }), Oe(a, "logoMlbTexOnDark", function () {
    return import("./logo_mlb_tex_onDark-50336755.js");
  }), Oe(a, "logoMlbTorOnLight", function () {
    return import("./logo_mlb_tor_onLight-d2365a76.js");
  }), Oe(a, "logoMlbWshOnLight", function () {
    return import("./logo_mlb_wsh_onLight-9cd53052.js");
  }), Oe(a, "logoMlbColOnDark", function () {
    return import("./logo_mlb_col_onDark-3634197d.js");
  }), Oe(a, "logoMlbColOnLight", function () {
    return import("./logo_mlb_col_onLight-790ade9e.js");
  }), Oe(a, "logoMlbBalOnDark", function () {
    return import("./logo_mlb_bal_onDark-4fd15c20.js");
  }), Oe(a, "logoMlbBosOnDark", function () {
    return import("./logo_mlb_bos_onDark-3bc6188d.js");
  }), Oe(a, "logoMlbLaaOnDark", function () {
    return import("./logo_mlb_laa_onDark-0e01e095.js");
  }), Oe(a, "logoMlbChcOnDark", function () {
    return import("./logo_mlb_chc_onDark-2adf52a8.js");
  }), Oe(a, "logoMlbCwsOnDark", function () {
    return import("./logo_mlb_cws_onDark-37d86c37.js");
  }), Oe(a, "logoMlbAtlOnDark", function () {
    return import("./logo_mlb_atl_onDark-d2e7d7c4.js");
  }), Oe(a, "logoMlbAriOnDark", function () {
    return import("./logo_mlb_ari_onDark-c9e8897c.js");
  }), Oe(a, "logoMlbAriOnLight", function () {
    return import("./logo_mlb_ari_onLight-88b383ae.js");
  }), Oe(a, "logoMlbBalOnLight", function () {
    return import("./logo_mlb_bal_onLight-725418d1.js");
  }), Oe(a, "logoMlbCwsOnLight", function () {
    return import("./logo_mlb_cws_onLight-2d907819.js");
  }), Oe(a, "logoMlbAtlOnLight", function () {
    return import("./logo_mlb_atl_onLight-98fd483d.js");
  }), a),
  Bi = new Map();
Bi.set(["china"], "flagChina"), Bi.set(["saint", "vincent", "grenadines"], "flagSaintVincentGrenadines"), Bi.set(["wales"], "flagWales"), Bi.set(["scotland"], "flagScotland"), Bi.set(["refugee olympic team", " refugee", " olympics", "refugee", "olympic", "team"], "flagRefugeeOlympicTeam"), Bi.set(["individual", "neutral", "athletes", "athlete", "olympics"], "flagIndividualNeutralAthlete"), Bi.set(["placeholder"], "flagPlaceholder"), Bi.set(["aruba"], "flagAruba"), Bi.set(["bhutan"], "flagBhutan"), Bi.set(["guam"], "flagGuam"), Bi.set(["solomon", "islands"], "flagSolomonIslands"), Bi.set(["cook", "islands"], "flagCookIslands"), Bi.set(["chinese", "taipei", "taiwan"], "flagChineseTaipei"), Bi.set(["qatar"], "flagQatar"), Bi.set(["hong", "kong"], "flagHongKong"), Bi.set(["bermuda"], "flagBermuda"), Bi.set(["cayman", "islands"], "flagCaymanIslands"), Bi.set(["american", "samoa"], "flagAmericanSamoa"), Bi.set(["northern", "ireland"], "flagNorthernIreland"), Bi.set(["virgin", "islands", "us"], "flagUsVirginIslands"), Bi.set(["guadeloupe"], "flagGuadeloupe"), Bi.set(["venezuela"], "flagVenezuela"), Bi.set(["yemen"], "flagYemen"), Bi.set(["tobago", "trinidad"], "flagTrinidadTobago"), Bi.set(["afghanistan"], "flagAfghanistan"), Bi.set(["fiji"], "flagFiji"), Bi.set(["ecuador"], "flagEcuador"), Bi.set(["faroe", "islands"], "flagFaroeIslands"), Bi.set(["islands", "falkland"], "flagFalklandIslands"), Bi.set(["eu", "european", "union"], "flagEuropeanUnion"), Bi.set(["ethiopia"], "flagEthiopia"), Bi.set(["estonia"], "flagEstonia"), Bi.set(["eritrea"], "flagEritrea"), Bi.set(["guinea", "equatorial"], "flagEquatorialGuinea"), Bi.set(["england"], "flagEngland"), Bi.set(["el", "salvador"], "flagElSalvador"), Bi.set(["egypt"], "flagEgypt"), Bi.set(["croatia"], "flagCroatia"), Bi.set(["east", "timor", "leste", "timor-leste"], "flagEastTimor"), Bi.set(["republic", "dominican"], "flagDominicanRepublic"), Bi.set(["djibouti"], "flagDjibouti"), Bi.set(["denmark"], "flagDenmark"), Bi.set(["republic", "congo", "democratic", "of"], "flagDemocraticRepublicOfCongo"), Bi.set(["czech", "republic"], "flagCzech"), Bi.set(["cyprus"], "flagCyprus"), Bi.set(["cuba"], "flagCuba"), Bi.set(["cote", "ivoire", "ivory", "coast"], "flagIvoryCoast"), Bi.set(["costarica", "costa", "rica"], "flagCostaRica"), Bi.set(["comoros"], "flagComoros"), Bi.set(["colombia"], "flagColombia"), Bi.set(["chile"], "flagChile"), Bi.set(["bahrain"], "flagBahrain"), Bi.set(["chad"], "flagChad"), Bi.set(["burkina", "faso"], "flagBurkinaFaso"), Bi.set(["central", "republic", "african"], "flagCentralAfricanRepublic"), Bi.set(["cape", "verde"], "flagCapeVerde"), Bi.set(["canada"], "flagCanada"), Bi.set(["cameroon"], "flagCameroon"), Bi.set(["cambodia"], "flagCambodia"), Bi.set(["belgium"], "flagBelgium"), Bi.set(["burundi"], "flagBurundi"), Bi.set(["burma"], "flagBurma"), Bi.set(["myanmar"], "flagMyanmar"), Bi.set(["bulgaria"], "flagBulgaria"), Bi.set(["brunei"], "flagBrunei"), Bi.set(["brazil"], "flagBrazil"), Bi.set(["botswana"], "flagBotswana"), Bi.set(["bosnia", "herzegovina"], "flagBosnia"), Bi.set(["bolivia"], "flagBolivia"), Bi.set(["benin"], "flagBenin"), Bi.set(["belize"], "flagBelize"), Bi.set(["belarus"], "flagBelarus"), Bi.set(["barbados"], "flagBarbados"), Bi.set(["bangladesh"], "flagBangladesh"), Bi.set(["bahamas"], "flagBahamas"), Bi.set(["azerbaijan"], "flagAzerbaijan"), Bi.set(["albania"], "flagAlbania"), Bi.set(["austria"], "flagAustria"), Bi.set(["australia"], "flagAustralia"), Bi.set(["armenia"], "flagArmenia"), Bi.set(["argentina"], "flagArgentina"), Bi.set(["antigua", "barbuda"], "flagAntiguaBarbuda"), Bi.set(["angola"], "flagAngola"), Bi.set(["andorra"], "flagAndorra"), Bi.set(["algeria"], "flagAlgeria"), Bi.set(["finland"], "flagFinland"), Bi.set(["france", "martinique", "guadeloupe"], "flagFrance"), Bi.set(["island", "british", "virgin", "islands"], "flagBritishVirginIslands"), Bi.set(["puerto", "rico"], "flagPuertoRico"), Bi.set(["swaziland", "eswatini"], "flagSwaziland"), Bi.set(["swaziland", "eswatini"], "flagEswatini"), Bi.set(["zimbabwe"], "flagZimbabwe"), Bi.set(["zambia"], "flagZambia"), Bi.set(["french", "guiana"], "flagFrenchGuiana"), Bi.set(["vietnam"], "flagVietnam"), Bi.set(["usa", "united states of america", "america", "us", "united states", "united", "states", "of"], "flagUnitedStatesOfAmerica"), Bi.set(["guinea-bissau", "guinea", "bissau"], "flagGuineaBissau"), Bi.set(["vanuatu"], "flagVanuatu"), Bi.set(["uzbekistan"], "flagUzbekistan"), Bi.set(["uruguay"], "flagUruguay"), Bi.set(["arab", "emirates", "united"], "flagUnitedArabEmirates"), Bi.set(["ukraine"], "flagUkraine"), Bi.set(["united", "kingdom", "uk", "great", "britain"], "flagUnitedKingdom"), Bi.set(["uganda"], "flagUganda"), Bi.set(["tuvalu"], "flagTuvalu"), Bi.set(["turkmenistan"], "flagTurkmenistan"), Bi.set(["turkey"], "flagTurkey"), Bi.set(["tunisia"], "flagTunisia"), Bi.set(["gabon"], "flagGabon"), Bi.set(["togo"], "flagTogo"), Bi.set(["tonga"], "flagTonga"), Bi.set(["thailand"], "flagThailand"), Bi.set(["tanzania"], "flagTanzania"), Bi.set(["tajikistan"], "flagTajikistan"), Bi.set(["taiwan"], "flagTaiwan"), Bi.set(["syria"], "flagSyria"), Bi.set(["swiss", "switzerland"], "flagSwitzerland"), Bi.set(["sweden"], "flagSweden"), Bi.set(["suriname"], "flagSuriname"), Bi.set(["sudan"], "flagSudan"), Bi.set(["lanka", "sri"], "flagSriLanka"), Bi.set(["somalia"], "flagSomalia"), Bi.set(["spain"], "flagSpain"), Bi.set(["south", "sudan"], "flagSouthSudan"), Bi.set(["islands", "south", "sandwich"], "flagSouthSandwichIslands"), Bi.set(["south", "africa"], "flagSouthAfrica"), Bi.set(["slovenia"], "flagSlovenia"), Bi.set(["slovakia"], "flagSlovakia"), Bi.set(["singapore"], "flagSingapore"), Bi.set(["leone", "sierra"], "flagSierraLeone"), Bi.set(["seychelles"], "flagSeychelles"), Bi.set(["serbia"], "flagSerbia"), Bi.set(["senegal"], "flagSenegal"), Bi.set(["arabia", "saudi"], "flagSaudiArabia"), Bi.set(["and", "principe", "sao", "tome", "são", "tomé", "príncipe"], "flagSaoTomeAndPrincipe"), Bi.set(["marino", "san"], "flagSanMarino"), Bi.set(["samoa"], "flagSamoa"), Bi.set(["saint", "lucia"], "flagSaintLucia"), Bi.set(["kitts", "nevis", "saint"], "flagSaintKittsNevis"), Bi.set(["rwanda"], "flagRwanda"), Bi.set(["russia"], "flagRussia"), Bi.set(["romania"], "flagRomania"), Bi.set(["republic", "congo", "of", "the"], "flagRepublicOfTheCongo"), Bi.set(["quatar"], "flagQuatar"), Bi.set(["portugal"], "flagPortugal"), Bi.set(["poland"], "flagPoland"), Bi.set(["philippines"], "flagPhilippines"), Bi.set(["peru"], "flagPeru"), Bi.set(["paraguay"], "flagParaguay"), Bi.set(["new", "guinea", "papua"], "flagPapuaNewGuinea"), Bi.set(["palau"], "flagPalau"), Bi.set(["panama"], "flagPanama"), Bi.set(["palestine"], "flagPalestine"), Bi.set(["norway"], "flagNorway"), Bi.set(["pakistan"], "flagPakistan"), Bi.set(["oman"], "flagOman"), Bi.set(["korea", "north"], "flagNorthKorea"), Bi.set(["nigeria"], "flagNigeria"), Bi.set(["niger"], "flagNiger"), Bi.set(["nicaragua"], "flagNicaragua"), Bi.set(["new", "zealand"], "flagNewZealand"), Bi.set(["netherlands"], "flagNetherlands"), Bi.set(["nepal"], "flagNepal"), Bi.set(["nauru"], "flagNauru"), Bi.set(["namibia"], "flagNamibia"), Bi.set(["mozambique"], "flagMozambique"), Bi.set(["montenegro"], "flagMontenegro"), Bi.set(["mongolia"], "flagMongolia"), Bi.set(["monaco"], "flagMonaco"), Bi.set(["moldova"], "flagMoldova"), Bi.set(["micronesia", "federated", "states", "of"], "flagMicronesia"), Bi.set(["mexico"], "flagMexico"), Bi.set(["islands", "marshall"], "flagMarshallIslands"), Bi.set(["mauritius"], "flagMauritius"), Bi.set(["mauritania"], "flagMauritania"), Bi.set(["madagascar"], "flagMadagascar"), Bi.set(["marocco", "morocco"], "flagMorocco"), Bi.set(["malta"], "flagMalta"), Bi.set(["maldives"], "flagMaldives"), Bi.set(["mali"], "flagMali"), Bi.set(["malaysia"], "flagMalaysia"), Bi.set(["malawi"], "flagMalawi"), Bi.set(["macedonia", "north"], "flagMacedonia"), Bi.set(["luxembourg"], "flagLuxembourg"), Bi.set(["lithuania"], "flagLithuania"), Bi.set(["liechtenstein"], "flagLiechtenstein"), Bi.set(["libya"], "flagLibya"), Bi.set(["liberia"], "flagLiberia"), Bi.set(["lesotho"], "flagLesotho"), Bi.set(["lebanon"], "flagLebanon"), Bi.set(["greece"], "flagGreece"), Bi.set(["latvia"], "flagLatvia"), Bi.set(["laos"], "flagLaos"), Bi.set(["kyrgyzstan"], "flagKyrgyzstan"), Bi.set(["kuwait"], "flagKuwait"), Bi.set(["kosovo"], "flagKosovo"), Bi.set(["korea", "south"], "flagKorea"), Bi.set(["kiribati"], "flagKiribati"), Bi.set(["kenya"], "flagKenya"), Bi.set(["kazakhstan"], "flagKazakhstan"), Bi.set(["jordan"], "flagJordan"), Bi.set(["jersey"], "flagJersey"), Bi.set(["japan"], "flagJapan"), Bi.set(["jamaica"], "flagJamaica"), Bi.set(["italy"], "flagItaly"), Bi.set(["israel"], "flagIsrael"), Bi.set(["man", "of", "isle"], "flagIsleOfMan"), Bi.set(["ireland"], "flagIreland"), Bi.set(["iraq"], "flagIraq"), Bi.set(["iran"], "flagIran"), Bi.set(["indonesia"], "flagIndonesia"), Bi.set(["india"], "flagIndia"), Bi.set(["iceland"], "flagIceland"), Bi.set(["hungary"], "flagHungary"), Bi.set(["honduras"], "flagHonduras"), Bi.set(["haiti"], "flagHaiti"), Bi.set(["guyana"], "flagGuyana"), Bi.set(["guinea"], "flagGuinea"), Bi.set(["gambia"], "flagGambia"), Bi.set(["guernsey"], "flagGuernsey"), Bi.set(["guatemala"], "flagGuatemala"), Bi.set(["grenada"], "flagGrenada"), Bi.set(["germany"], "flagGermany"), Bi.set(["gibraltar"], "flagGibraltar"), Bi.set(["ghana"], "flagGhana"), Bi.set(["georgia"], "flagGeorgia"), Bi.set(["dominica", "caribbean", "island"], "flagDominica");
var Pi = function Pi(e, t, r) {
    var a = -1,
      n = e.length;
    t < 0 && (t = -t > n ? 0 : n + t), (r = r > n ? n : r) < 0 && (r += n), n = t > r ? 0 : r - t >>> 0, t >>>= 0;
    for (var o = Array(n); ++a < n;) o[a] = e[a + t];
    return o;
  },
  Ii = Pi;
var zi = function zi(e, t, r) {
    var a = e.length;
    return r = void 0 === r ? a : r, !t && r >= a ? e : Ii(e, t, r);
  },
  Ri = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
var Ui = function Ui(e) {
  return Ri.test(e);
};
var Hi = function Hi(e) {
    return e.split("");
  },
  Gi = "[\\ud800-\\udfff]",
  Vi = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
  Wi = "\\ud83c[\\udffb-\\udfff]",
  Ki = "[^\\ud800-\\udfff]",
  Yi = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  $i = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  qi = "(?:" + Vi + "|" + Wi + ")" + "?",
  Ji = "[\\ufe0e\\ufe0f]?" + qi + ("(?:\\u200d(?:" + [Ki, Yi, $i].join("|") + ")[\\ufe0e\\ufe0f]?" + qi + ")*"),
  Xi = "(?:" + [Ki + Vi + "?", Vi, Yi, $i, Gi].join("|") + ")",
  Zi = RegExp(Wi + "(?=" + Wi + ")|" + Xi + Ji, "g");
var Qi = Hi,
  el = Ui,
  tl = function tl(e) {
    return e.match(Zi) || [];
  };
var rl = function rl(e) {
    return el(e) ? tl(e) : Qi(e);
  },
  al = zi,
  nl = Ui,
  ol = rl,
  il = mi;
var ll = function (e) {
    return function (t) {
      t = il(t);
      var r = nl(t) ? ol(t) : void 0,
        a = r ? r[0] : t.charAt(0),
        n = r ? al(r, 1).join("") : t.slice(1);
      return a[e]() + n;
    };
  }("toUpperCase"),
  sl = mi,
  cl = ll;
var ul = function ul(e) {
  return cl(sl(e).toLowerCase());
};
var dl = function dl(e, t, r, a) {
  var n = -1,
    o = null == e ? 0 : e.length;
  for (a && o && (r = e[++n]); ++n < o;) r = t(r, e[n], n, e);
  return r;
};
var pl = function (e) {
    return function (t) {
      return null == e ? void 0 : e[t];
    };
  }({
    "À": "A",
    "Á": "A",
    "Â": "A",
    "Ã": "A",
    "Ä": "A",
    "Å": "A",
    "à": "a",
    "á": "a",
    "â": "a",
    "ã": "a",
    "ä": "a",
    "å": "a",
    "Ç": "C",
    "ç": "c",
    "Ð": "D",
    "ð": "d",
    "È": "E",
    "É": "E",
    "Ê": "E",
    "Ë": "E",
    "è": "e",
    "é": "e",
    "ê": "e",
    "ë": "e",
    "Ì": "I",
    "Í": "I",
    "Î": "I",
    "Ï": "I",
    "ì": "i",
    "í": "i",
    "î": "i",
    "ï": "i",
    "Ñ": "N",
    "ñ": "n",
    "Ò": "O",
    "Ó": "O",
    "Ô": "O",
    "Õ": "O",
    "Ö": "O",
    "Ø": "O",
    "ò": "o",
    "ó": "o",
    "ô": "o",
    "õ": "o",
    "ö": "o",
    "ø": "o",
    "Ù": "U",
    "Ú": "U",
    "Û": "U",
    "Ü": "U",
    "ù": "u",
    "ú": "u",
    "û": "u",
    "ü": "u",
    "Ý": "Y",
    "ý": "y",
    "ÿ": "y",
    "Æ": "Ae",
    "æ": "ae",
    "Þ": "Th",
    "þ": "th",
    "ß": "ss",
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
  }),
  ml = mi,
  fl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
  vl = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
var yl = function yl(e) {
    return (e = ml(e)) && e.replace(fl, pl).replace(vl, "");
  },
  gl = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
var hl = function hl(e) {
    return e.match(gl) || [];
  },
  bl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
var Nl = function Nl(e) {
    return bl.test(e);
  },
  xl = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
  kl = "[" + xl + "]",
  wl = "\\d+",
  _l = "[\\u2700-\\u27bf]",
  Fl = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
  Sl = "[^\\ud800-\\udfff" + xl + wl + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
  Cl = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  jl = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  El = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
  Tl = "(?:" + Fl + "|" + Sl + ")",
  Ol = "(?:" + El + "|" + Sl + ")",
  Al = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
  Ml = "[\\ufe0e\\ufe0f]?" + Al + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", Cl, jl].join("|") + ")[\\ufe0e\\ufe0f]?" + Al + ")*"),
  Ll = "(?:" + [_l, Cl, jl].join("|") + ")" + Ml,
  Dl = RegExp([El + "?" + Fl + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [kl, El, "$"].join("|") + ")", Ol + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [kl, El + Tl, "$"].join("|") + ")", El + "?" + Tl + "+(?:['’](?:d|ll|m|re|s|t|ve))?", El + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", wl, Ll].join("|"), "g");
var Bl = hl,
  Pl = Nl,
  Il = mi,
  zl = function zl(e) {
    return e.match(Dl) || [];
  };
var Rl = dl,
  Ul = yl,
  Hl = function Hl(e, t, r) {
    return e = Il(e), void 0 === (t = r ? void 0 : t) ? Pl(e) ? zl(e) : Bl(e) : e.match(t) || [];
  },
  Gl = RegExp("['’]", "g");
var Vl,
  Wl = function Wl(e) {
    return function (t) {
      return Rl(Hl(Ul(t).replace(Gl, "")), e, "");
    };
  },
  Kl = ul,
  Yl = Wl(function (e, t, r) {
    return t = t.toLowerCase(), e + (r ? Kl(t) : t);
  }),
  $l = Yl;
!function (e) {
  e[e.pulse = 0] = "pulse", e[e.ping = 1] = "ping", e[e.spin = 2] = "spin", e[e.bounce = 3] = "bounce";
}(Vl || (Vl = {}));
var ql = Object.values(Vl).filter(function (e) {
    return "string" == typeof e;
  }),
  Jl = "LiveIcon-module_animate-ping-slow__C78RD";
var Xl = {
    iconUiLiveAnimated: function iconUiLiveAnimated(e) {
      e.fill, e.secondaryfill;
      var t = e.width,
        r = e.height,
        a = e.className,
        n = (e.accessibilityLabel, Me(e, c)),
        o = "string" == typeof t ? +t : t,
        i = {
          width: o,
          height: "100%" === r ? o : 0
        };
      return dt.exports.jsxs("span", Te(Te({
        className: "cui-relative cui-inline-block ".concat(a || "").trim()
      }, n), {}, {
        style: i,
        children: [dt.exports.jsx("span", {
          className: "cui-absolute cui-top-0 cui-block cui-rounded-[9999px] cui-bg-highlight-accent",
          style: i
        }), dt.exports.jsx("span", {
          className: "cui-absolute cui-top-0 cui-block cui-rounded-[9999px] cui-bg-highlight-accent ".concat(Jl),
          style: i
        })]
      }));
    },
    iconUiBaseballDiamond: function iconUiBaseballDiamond(e) {
      e.fill, e.secondaryfill;
      var t = e.width,
        r = (e.height, e.className, e.options),
        a = void 0 === r ? {
          first: !1,
          second: !1,
          third: !1
        } : r,
        n = (Me(e, u), a.first),
        o = a.second,
        i = a.third,
        l = "var(--highlight-accent)",
        s = "var(--fg-subtle)";
      return dt.exports.jsxs("svg", {
        width: t,
        height: t,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [dt.exports.jsxs("g", {
          clipPath: "url(#clip0_3514_4415)",
          children: [dt.exports.jsx("rect", {
            x: "3.90283",
            y: "6.92215",
            width: "5.27908",
            height: "5.27908",
            transform: "rotate(45 3.90283 6.92215)",
            fill: i ? l : s
          }), dt.exports.jsx("rect", {
            x: "8.18994",
            y: "2.43399",
            width: "5.27908",
            height: "5.27908",
            transform: "rotate(45 8.18994 2.43399)",
            fill: o ? l : s
          }), dt.exports.jsx("rect", {
            x: "12.2764",
            y: "6.98917",
            width: "5.27908",
            height: "5.27908",
            transform: "rotate(45 12.2764 6.98917)",
            fill: n ? l : s
          })]
        }), dt.exports.jsx("defs", {
          children: dt.exports.jsx("clipPath", {
            id: "clip0_3514_4415",
            children: dt.exports.jsx("rect", {
              width: "16",
              height: "15.1111",
              fill: "white",
              transform: "translate(0 0.888885)"
            })
          })
        })]
      });
    },
    iconUiQuickPick: function iconUiQuickPick(e) {
      var t = e.fill || "currentColor";
      e.secondaryfill;
      var r = e.width || "100%",
        a = e.height || "100%";
      return dt.exports.jsx("svg", {
        height: a,
        width: r,
        viewBox: "0 0 24 23",
        xmlns: "http://www.w3.org/2000/svg",
        children: dt.exports.jsxs("g", {
          fill: "none",
          children: [dt.exports.jsxs("g", {
            clipPath: "url(#1695326058776-3484395_clip0_4248_48)",
            children: [dt.exports.jsx("path", {
              d: "M4.31 11.62l1.11 1.61h-1.63l-1.03-1.59h-0.65c-0.74 0-1.24-0.56-1.24-1.38v-6.39c0-0.8 0.51-1.36 1.24-1.36h1.93c0.74 0 1.25 0.56 1.25 1.36v6.39c0 0.78-0.44 1.23-0.98 1.36z m-0.54-7.6h-1.38c-0.04 0-0.05 0.01-0.05 0.06v5.99c0 0.03 0.01 0.05 0.05 0.05h1.38c0.02 0 0.05-0.03 0.05-0.05v-5.99c0-0.04-0.02-0.05-0.05-0.06z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M9.23 11.64h-1.93c-0.74 0-1.24-0.56-1.24-1.38v-7.73h1.48v7.54c0 0.03 0.01 0.05 0.04 0.05h1.38c0.02 0 0.05-0.03 0.05-0.05v-7.54h1.47v7.73c0 0.82-0.51 1.37-1.25 1.38z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M11.2 11.61v-9.08h1.47v9.08h-1.47z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M16.53 11.62h-1.93c-0.72 0-1.24-0.57-1.24-1.37v-6.38c0-0.79 0.52-1.36 1.24-1.36h1.93c0.73 0 1.25 0.57 1.25 1.36v1.82h-1.48v-1.61c0-0.04-0.02-0.05-0.04-0.06h-1.38c-0.04 0-0.05 0.01-0.05 0.06v5.99c0 0.03 0.01 0.05 0.05 0.05h1.38c0.02 0 0.05-0.03 0.04-0.05v-1.62h1.48v1.8c0 0.8-0.52 1.37-1.25 1.37z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M21.99 11.61l-1.25-3.38-0.63 1.39v1.99h-1.48v-9.08h1.48v4.19l1.85-4.19h1.54l-1.8 3.98 1.94 5.1h-1.65z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M11.14 17.4h-1.5v3.12h-1.3v-8.01h2.8c0.66 0 1.1 0.49 1.1 1.2v2.49c0 0.71-0.44 1.2-1.1 1.2z m-0.24-3.58h-1.26v2.26h1.26c0.02 0 0.04-0.01 0.04-0.05v-2.16c0-0.04-0.02-0.05-0.04-0.05z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M12.71 20.52v-8.01h1.3v8.01h-1.3z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M17.38 20.53h-1.71c-0.63 0-1.09-0.5-1.1-1.21v-5.64c0-0.7 0.46-1.2 1.1-1.2h1.71c0.65 0 1.1 0.5 1.1 1.2v1.66h-1.3v-1.47c0-0.03-0.02-0.04-0.04-0.05h-1.22c-0.03 0-0.04 0.01-0.04 0.05v5.29c0 0.02 0.01 0.05 0.04 0.04h1.22c0.02 0 0.04-0.02 0.04-0.04v-1.47h1.3v1.63c0 0.71-0.46 1.21-1.1 1.21z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M22.18 20.52l-1.11-2.99-0.56 1.24v1.75h-1.3v-8.01h1.3v3.69l1.64-3.69h1.36l-1.59 3.51 1.72 4.5h-1.46z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M3.82 20.51c-0.29 0-0.58-0.04-0.87-0.12a3.2 3.2 0 0 1-1.94-1.53 3.19 3.19 0 0 1-0.29-2.44 3.22 3.22 0 0 1 3.97-2.23 0.46 0.46 0 0 1 0.32 0.57 0.46 0.46 0 0 1-0.57 0.33 2.29 2.29 0 0 0-2.82 1.58 2.29 2.29 0 0 0 1.58 2.82 2.29 2.29 0 0 0 2.86-2.67 0.46 0.46 0 0 1 0.91-0.19 3.22 3.22 0 0 1-3.15 3.88z",
              fill: t
            }), dt.exports.jsx("path", {
              d: "M3.94 18.81a0.46 0.46 0 0 1-0.37-0.18l-1.3-1.7a0.46 0.46 0 1 1 0.73-0.56l0.9 1.16 2.22-3.51a0.46 0.46 0 1 1 0.78 0.5l-2.57 4.07a0.47 0.47 0 0 1-0.37 0.22h-0.02z",
              fill: t
            })]
          }), dt.exports.jsx("defs", {
            children: dt.exports.jsx("path", {
              d: "M0 0h23.04v23.04h-23.04z",
              fill: t,
              transform: "translate(.625)"
            })
          })]
        })
      });
    }
  },
  Zl = ["iconUiDotsVertical"],
  Ql = ["OnLight", "OnDark"],
  es = ["brandMlb", "brandNba", "brandNhl", "brandNfl"].map(function (e) {
    return Ce(Ql.map(function (t) {
      return e + t;
    }));
  }).flat(),
  ts = ["of", "the", "and"],
  rs = function rs(e) {
    var t,
      r,
      a = e.name,
      n = void 0 === a ? "" : a,
      o = e.size,
      i = void 0 === o ? "md" : o,
      l = e.color,
      s = void 0 === l ? "cui-fill-bg-default" : l,
      c = e.secondaryColor,
      u = void 0 === c ? "" : c,
      p = e.animate,
      m = void 0 === p ? null : p,
      f = e.className,
      v = void 0 === f ? "" : f,
      y = e.options,
      g = e.accessibilityLabel,
      h = void 0 === g ? "" : g,
      b = Me(e, d),
      N = Le(He(), 2),
      x = N[0],
      k = N[1],
      w = n && $l(n),
      _ = /^flag/.test(w),
      F = /^brand/.test(w),
      S = /^ui/.test(w),
      C = Ge("cui__icon-id-".concat(Ra())),
      j = /^icon/i.test(w);
    w = j || _ || F ? w : $l("icon_".concat(w));
    var E = [];
    if (!(_ || F || j || S)) {
      var T,
        O = "string" == typeof n && n.split(" ").map(function (e) {
          return e.toLowerCase();
        }).filter(function (e) {
          return !ts.includes(e);
        }),
        A = Se(Bi);
      try {
        var M = function M() {
          var e = Le(T.value, 2),
            t = e[0],
            r = e[1];
          if (Array.isArray(O)) {
            if (1 === O.length) return E.push($l("flag_".concat(O[0]))), _ = !0, "break";
            if (O.every(function (e) {
              return t.includes(e);
            })) return E.push(r), _ = !0, "break";
          }
        };
        for (A.s(); !(T = A.n()).done;) {
          if ("break" === M()) break;
        }
      } catch (e) {
        A.e(e);
      } finally {
        A.f();
      }
    }
    var L = es.includes(w) || /Color/.test(w) || _,
      D = on(i),
      B = D.sizeStyle,
      P = D.sizeMap;
    Ve(function () {
      w in Xl && Xl[w] ? k({
        default: Xl[w]
      }) : w && w in Li ? as(w, k) : 1 === E.length && as(E[0], k);
    }, [n, s, u]);
    var I = function (e) {
        return e && ql.includes(e) ? {
          spin: "cui-animate-spin",
          pulse: "cui-animate-pulse",
          ping: "cui-animate-ping",
          bounce: "cui-animate-bounce"
        }[e] : "";
      }(m),
      z = Zl.includes(w),
      R = "number" == typeof i ? null === (t = B.width) || void 0 === t ? void 0 : t.replace("px", "") : P.width,
      U = "number" == typeof i ? null === (r = B.height) || void 0 === r ? void 0 : r.replace("px", "") : P.height;
    return x ? dt.exports.jsx("i", Te(Te({
      className: "cui__icons-".concat(String(w), " ").concat(L ? "cui__color_icon" : "", " ").concat("cui-relative cui-inline-block cui-p-0 cui-m-0 cui-w-auto cui-h-auto [&>svg]:cui-inline-block cui-box-border !cui-not-italic !cui-text-[0px] !cui-leading-[0px]", " ").concat(I, " ").concat(v).replace("  ", " ").trim()
    }, b), {}, {
      children: dt.exports.jsx(x.default, {
        fill: _ ? "" : wi(un, s, "var(--fg-default)"),
        secondaryfill: wi(un, u) || u,
        width: z ? "100%" : R,
        height: z ? U : "100%",
        id: C.current,
        options: y,
        accessibilityLabel: h
      })
    })) : null;
  };
function as(e, t) {
  return ns.apply(this, arguments);
}
function ns() {
  return (ns = Fe(we().mark(function e(t, r) {
    var a;
    return we().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (e.prev = 0, "function" != typeof Li[t]) {
            e.next = 6;
            break;
          }
          return e.next = 4, Li[t]();
        case 4:
          a = e.sent, r(a);
        case 6:
          e.next = 11;
          break;
        case 8:
          e.prev = 8, e.t0 = e.catch(0), e.t0 instanceof Error && os(e.t0);
        case 11:
        case "end":
          return e.stop();
      }
    }, e, null, [[0, 8]]);
  }))).apply(this, arguments);
}
function os(e) {
  console.error("Could't retrieve icon: ", e);
}
function is(e) {
  var t = e.fill,
    r = e.secondaryfill,
    a = e.width,
    n = void 0 === a ? "100%" : a,
    o = e.height,
    i = void 0 === o ? "100%" : o,
    l = e.accessibilityLabel,
    s = void 0 === l ? "" : l;
  return dt.exports.jsxs("svg", {
    width: n,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": s,
    children: [dt.exports.jsx("path", {
      d: "M5.15692 7.50625C6.25992 9.63741 6.99268 13.4039 6.99268 17.6951C6.99268 19.8783 6.80292 21.9259 6.47128 23.6913C6.12762 23.654 5.77992 23.6127 5.42847 23.5672C10.481 24.2212 14.7559 24.0106 17.373 23.7363C17.0361 21.9607 16.8431 19.897 16.8431 17.6951C16.8431 13.3205 17.6047 9.49105 18.7437 7.38382C16.7171 4.795 18.3361 0.712638 18.3361 0.712638L16.3313 0.276963C15.796 2.36688 14.0742 3.89667 12.0327 3.89667C9.99124 3.89667 8.26073 2.35943 7.7302 0.261471L8.75897 0.0367126L5.66416 0.712638C5.66416 0.712638 7.33501 4.92597 5.15692 7.50625Z",
      fill: t
    }), dt.exports.jsx("path", {
      d: "M8.92711 0L7.73005 0.261484C8.26058 2.35945 9.99125 3.89669 12.0327 3.89669C14.0742 3.89669 15.7961 2.36688 16.3313 0.276944L15.0567 0C14.4086 2.91006 12.0001 2.73198 12.0001 2.73198C12.0001 2.73198 9.57508 2.91006 8.92711 0Z",
      fill: r
    }), dt.exports.jsx("path", {
      d: "M17.373 23.7363C19.1266 23.5524 20.1359 23.3401 20.1359 23.3401C19.1271 16.5584 21 8.94769 21 8.94769C19.9711 8.57442 19.2457 8.02469 18.7439 7.38354C17.6048 9.49072 16.8431 13.3204 16.8431 17.6951C16.8431 19.897 17.0362 21.9608 17.373 23.7363Z",
      fill: r
    }), dt.exports.jsx("path", {
      d: "M5.15679 7.50598C6.25986 9.6371 6.99269 13.4037 6.99269 17.6951C6.99269 19.8784 6.80293 21.9259 6.47129 23.6914C5.62526 23.5993 4.75479 23.4837 3.86395 23.3401C4.87288 16.5583 3 8.94763 3 8.94763C3.96299 8.5983 4.65982 8.09465 5.15679 7.50598Z",
      fill: r
    }), dt.exports.jsx("path", {
      d: "M20.0214 14.9383C19.7788 17.4589 19.6922 20.4639 20.1173 23.3217C20.1173 23.3217 14.5234 24.4987 6.79182 23.7088C12.7493 23.509 17.8195 19.9497 20.0214 14.9383Z",
      fill: "#F4F5F4",
      fillOpacity: "0.2"
    }), dt.exports.jsx("path", {
      d: "M3.86409 23.3401C4.87301 16.5583 3.00014 8.94767 3.00014 8.94767C8.18419 7.06734 5.66416 0.712651 5.66416 0.712651L8.92712 0C9.57508 2.91006 12.0001 2.73198 12.0001 2.73198C12.0001 2.73198 14.4086 2.91006 15.0567 0L18.3361 0.712651C18.3361 0.712651 15.8159 7.06734 21 8.94767C21 8.94767 19.1271 16.5585 20.1359 23.3401C20.1359 23.3401 13.0799 24.8249 3.86409 23.3401Z",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".3",
      stroke: "#DADDDC",
      fill: "none"
    })]
  });
}
var ls = function ls(e) {
    var t = e.fill,
      r = e.secondaryfill,
      a = e.width,
      n = void 0 === a ? "100%" : a,
      o = e.height,
      i = void 0 === o ? "100%" : o,
      l = e.accessibilityLabel,
      s = void 0 === l ? "" : l;
    return dt.exports.jsxs("svg", {
      width: n,
      height: i,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": s,
      children: [dt.exports.jsx("path", {
        d: "M8.46708 19.0705L6.05171 18.7105L5.7786 20.0608C5.69092 20.4941 5.32213 20.8242 4.88187 20.8632L2.59001 21.0668C2.55951 21.0695 2.52902 21.0708 2.4989 21.0708C2.01842 21.0708 1.60293 20.7317 1.51259 20.2507L0.76624 16.2776C0.706204 15.9584 0.80493 15.6283 1.03021 15.3942C1.25549 15.1602 1.58178 15.0493 1.90293 15.0971L5.81976 15.6809L6.48836 12.3764L7.29056 12.5882L6.64007 15.8032L8.54388 16.087C8.43468 16.2898 8.35043 16.4995 8.2904 16.7171C8.27553 16.7712 8.26238 16.8258 8.25037 16.8806L6.47559 16.6161L6.21619 17.8976L8.23208 18.198C8.24199 18.262 8.25304 18.3269 8.26581 18.393C8.31117 18.6286 8.37921 18.855 8.46708 19.0705ZM5.23122 18.5883L1.95095 18.0995L2.32642 20.0976C2.34338 20.188 2.42515 20.2499 2.51663 20.2417L4.8083 20.0382C4.88606 20.0313 4.95105 19.973 4.96649 19.8966L5.23122 18.5883ZM5.65509 16.4937L1.78057 15.9164C1.77085 15.9149 1.76132 15.9143 1.75236 15.9143C1.68927 15.9143 1.64715 15.9473 1.62657 15.9689C1.60294 15.9934 1.5652 16.0464 1.58006 16.1248L1.78914 17.238L5.3957 17.7755L5.65509 16.4937Z",
        fill: r,
        stroke: "#DADDDC",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".3"
      }), dt.exports.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: ".3",
        fill: t,
        stroke: "#DADDDC",
        d: "M18.997 20.5169C21.6618 18.7251 23.2504 15.7487 23.2504 12.5378C23.2504 11.2406 22.9964 9.98215 22.4955 8.79781C22.0116 7.6537 21.3186 6.62603 20.4362 5.74359C19.5537 4.86096 18.5261 4.16816 17.3819 3.68425C16.1976 3.18338 14.9391 2.92932 13.642 2.92932C11.3093 2.92932 9.05996 3.77555 7.30862 5.3119C5.97696 6.48023 5.00208 7.98323 4.4772 9.64671L3.85739 9.51425C3.525 9.44335 3.19166 9.62994 3.07826 9.95032C2.94637 10.3233 3.16117 10.7293 3.54349 10.8301L8.87147 12.2357C9.57742 12.4219 10.1517 12.8929 10.3526 13.5948C10.5752 14.3728 10.4414 14.9518 9.75695 15.6025C8.87947 16.4367 8.75235 17.2597 8.93684 18.2166C9.19852 19.5729 10.3891 20.5573 11.7679 20.5573C11.9669 20.5573 12.1687 20.5424 12.364 20.4952C12.6067 20.4365 12.9147 20.2969 13.2798 20.0942C15.0912 19.0884 17.324 19.2411 18.9715 20.4974L18.997 20.5169ZM11.4174 17.2421C11.8678 17.2421 12.2327 17.6071 12.2327 18.0575C12.2327 18.5079 11.8678 18.8728 11.4174 18.8728C10.967 18.8728 10.602 18.5079 10.602 18.0575C10.602 17.6071 10.967 17.2421 11.4174 17.2421Z"
      }), dt.exports.jsx("path", {
        opacity: "0.2",
        d: "M18.9976 20.516C21.6625 18.7243 23.251 15.7478 23.251 12.537C23.251 11.2398 22.997 9.98131 22.4961 8.79698C22.4475 8.68199 22.3967 8.56817 22.3439 8.45557C22.3591 8.69976 22.3484 8.98505 22.3383 9.25217C22.3323 9.40959 22.3267 9.5607 22.3267 9.69336C22.3267 13.8133 19.6438 17.2565 15.3464 19.4556C16.6187 19.3392 17.9157 19.691 18.9721 20.4966L18.9976 20.516Z",
        fill: "#F4F5F4"
      })]
    });
  },
  ss = "TeamLogo-module_cuiSoccerOutline__UsOw1",
  cs = "TeamLogo-module_cuiLogoOutline__ErDlG";
function us(e) {
  var t = e.fill,
    r = e.secondaryfill,
    a = e.width,
    n = void 0 === a ? "100%" : a,
    o = e.height,
    i = void 0 === o ? "100%" : o,
    l = e.accessibilityLabel,
    s = void 0 === l ? "" : l;
  return dt.exports.jsxs("svg", {
    width: n,
    height: i,
    "aria-label": s,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [dt.exports.jsx("path", {
      d: "M41.0213 32.1563C40.6383 31.7733 40.0638 31.6776 39.6808 32.0606C39.6808 32.0606 39.3936 32.2521 39.0106 32.635L10.5745 28.9967C10.5745 28.8053 10.5745 28.7095 10.5745 28.518C10.383 28.0393 9.80851 27.7521 9.32978 27.9436C7.89361 28.518 1 31.1031 1 34.6457C1 38.9542 13.9255 43.2627 21.1064 43.2627C29.0532 43.2627 40.351 33.8797 40.8298 33.4967C41.3085 33.1138 41.3085 32.5393 41.0213 32.1563Z",
      fill: r,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".3",
      stroke: "#DADDDC",
      className: cs
    }), dt.exports.jsx("path", {
      d: "M26.851 4.96485C16.7978 4.96485 8.65955 13.1031 8.65955 23.1563V30.8159C8.65955 31.1031 8.75529 31.3904 9.04252 31.5819C9.23401 31.7733 14.5 35.6031 26.851 35.6031C39.2021 35.6031 44.468 31.7733 44.6595 31.5819C44.9468 31.3904 45.0425 31.1031 45.0425 30.8159V23.1563C45.0425 13.1031 36.9042 4.96485 26.851 4.96485Z",
      fill: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".3",
      stroke: "#DADDDC",
      className: cs
    }), dt.exports.jsx("path", {
      d: "M43.8939 32.0886C44.371 31.8108 44.6205 31.6209 44.6595 31.5819C44.9468 31.3904 45.0425 31.1031 45.0425 30.8159V23.1563C45.0425 14.2338 38.6318 6.81963 30.1614 5.26481C35.1645 8.06759 38.6364 14.0748 38.6364 21.054V34.1351C41.0237 33.5014 42.7484 32.7205 43.8939 32.0886Z",
      fill: "#F4F5F4",
      fillOpacity: "0.2"
    })]
  });
}
function ds(e) {
  var t = e.fill,
    r = e.secondaryfill,
    a = e.width,
    n = void 0 === a ? "100%" : a,
    o = e.height,
    i = void 0 === o ? "100%" : o,
    l = e.accessibilityLabel,
    s = void 0 === l ? "" : l;
  return dt.exports.jsxs("svg", {
    width: n,
    height: i,
    viewBox: "0 0 48 48",
    fill: "none",
    "aria-label": s,
    xmlns: "http://www.w3.org/2000/svg",
    children: [dt.exports.jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.2596 17.4497C19.4129 17.5917 19.5 17.7911 19.5 18V25.5L20.0854 26.6708C19.9168 26.7551 19.7161 26.8168 19.5 26.8629V37C19.5 37.1817 19.4341 37.3572 19.3144 37.4939L12.3144 45.4939C12.172 45.6566 11.9663 45.75 11.75 45.75H8.75C8.51393 45.75 8.29164 45.6389 8.15 45.45L2.15 37.45C2.05263 37.3202 2 37.1623 2 37V24C2 23.8641 2.03694 23.7307 2.10688 23.6141L5.10688 18.6141C5.23191 18.4057 5.45017 18.2709 5.69248 18.2522L10.9742 17.8459L11.0988 17.6279L11.4203 17.8116L18.6925 17.2522C18.9008 17.2362 19.1063 17.3078 19.2596 17.4497ZM10.075 19.4195L6.1938 19.7181L3.5 24.2077V24.342C4.53645 24.476 5.74876 24.6234 7.03702 24.7673C7.05275 24.7191 7.07341 24.6724 7.09882 24.6279L10.075 19.4195ZM8.64763 24.9408L11.8821 19.2805L16.4468 18.9294L13.2359 25.3512C13.0206 25.3357 12.8029 25.3194 12.5832 25.3023C11.3005 25.2024 9.95715 25.0766 8.64763 24.9408ZM7.1044 26.284C5.79855 26.1396 4.56383 25.9907 3.5 25.8544V31.336C4.69775 31.4788 6.10052 31.6282 7.56062 31.7587L7.1044 26.284ZM9.07635 31.8851L8.62312 26.4463C9.90302 26.5781 11.2129 26.7001 12.4668 26.7977C12.6705 26.8136 12.8729 26.8288 13.0736 26.8434L13.5535 32.1226C13.3002 32.1171 13.0408 32.1097 12.7762 32.1005C11.5984 32.0592 10.335 31.9822 9.07635 31.8851ZM7.68704 33.2757C6.18752 33.1447 4.74094 32.9926 3.5 32.8465V36.75L3.88208 37.2594C4.98921 37.3691 6.54124 37.4925 8.23481 37.5793L8.12596 37.416C8.05558 37.3104 8.01313 37.1887 8.00259 37.0623L7.68704 33.2757ZM9.26718 39.1279C7.7536 39.0678 6.29872 38.9726 5.0931 38.8741L9.125 44.25H11.4097L12.1582 43.3945L12.126 43.416L9.26718 39.1279ZM13.155 42.2554L11.1055 39.1811C12.7232 39.2095 14.3545 39.1852 15.7508 39.0615L15.8569 39.1675L13.155 42.2554ZM17.5006 37.2889L18 36.7182V33.359C17.7196 33.4261 17.4104 33.4757 17.0874 33.5136C16.54 33.5779 15.8996 33.6137 15.1965 33.6272L15.4723 36.6617L16.3061 37.4954C16.752 37.4401 17.154 37.3718 17.5006 37.2889ZM14.3394 37.65C13.2509 37.6979 12.0457 37.7019 10.8163 37.6752C10.5737 37.6699 10.3309 37.6635 10.0887 37.656L9.48134 36.7449L9.20252 33.399C10.4001 33.4889 11.5988 33.5602 12.7238 33.5995C13.0515 33.611 13.3744 33.6198 13.6901 33.6256L14.0031 37.0679C14.019 37.2426 14.0956 37.4063 14.2197 37.5303L14.3394 37.65ZM15.0603 32.1293C15.7678 32.1183 16.3949 32.0846 16.9126 32.0239C17.4333 31.9628 17.7877 31.8802 17.9919 31.7948C17.9947 31.7936 17.9974 31.7925 18 31.7914V27.0129C17.7241 27.0223 17.4293 27.026 17.1194 27.025C16.368 27.0225 15.5098 26.992 14.5886 26.9409L15.0603 32.1293ZM14.8618 25.4535C15.6898 25.4972 16.4549 25.5228 17.1243 25.525C17.4422 25.526 17.7349 25.5218 18 25.512V19.1771L14.8618 25.4535ZM18.0945 31.7449C18.1032 31.737 18.1091 31.7334 18.1099 31.7335C18.1106 31.7337 18.1063 31.7376 18.0945 31.7449Z",
      fill: r,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".3",
      stroke: "#DADDDC"
    }), dt.exports.jsx("path", {
      d: "M4.36581 14.326C4.7412 14.1825 5.52193 13.9927 5.52193 13.9927C9.89865 5.57966 24.4215 4.1123 24.4215 4.1123C48.0723 2.22202 43.5234 24.8155 43.1801 25.2309C42.8369 25.6464 42.2587 25.8641 42.2587 25.8641C42.0655 27.8603 42.6039 30.919 39.2615 32.3206C35.7898 33.7764 33.9176 34.4963 33.9022 34.5288L32.5337 34.7756C32.5337 34.7756 30.9493 36.6916 26.8058 37.6092C22.7891 38.4987 19.0564 37.9332 18.1439 35.2558C16.9829 31.8492 17.0994 26.3457 17.0994 23.2572L17.0998 23.2568C7.77673 22.6999 4.08858 20.3004 4.08858 20.3004C3.35283 18.0259 3.9903 14.4695 4.36569 14.326H4.36581ZM25.0183 36.1777C27.985 35.8209 30.1557 34.4561 29.8743 33.8164C29.8743 33.8164 29.149 30.666 29.0978 30.5238L27.8008 25.8504C27.7798 25.7762 26.1868 23.5413 24.3348 24.3525C22.7545 25.0447 22.6442 25.1679 21.6042 25.6815C21.2109 25.8758 21.3669 26.2336 21.7249 28.7367C21.8197 29.3997 21.8172 29.7214 20.3418 30.9943C20.0817 31.2188 19.952 30.8481 19.952 33.5023C19.952 36.1564 21.8623 36.5571 25.0183 36.1776V36.1777Z",
      fill: t,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".3",
      stroke: "#DADDDC"
    }), dt.exports.jsx("path", {
      d: "M38.0083 32.8432C38.3995 32.681 38.8174 32.5068 39.2615 32.3206C42.0584 31.1477 42.1378 28.8145 42.2025 26.9145C42.2151 26.544 42.2272 26.1899 42.2587 25.8641C42.2587 25.8641 42.8369 25.6464 43.1801 25.2309C43.33 25.0495 44.282 20.6385 43.3372 15.8841C42.8962 13.9698 42.2396 12.2148 41.3803 10.675C39.3508 7.32429 35.7021 4.58423 29.3038 4.08228C34.4482 7.1457 38.6364 14.0751 38.6364 20.9775L38.0083 32.8432Z",
      fill: "#F4F5F4",
      fillOpacity: "0.2"
    })]
  });
}
function ps() {
  return ps = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ps.apply(this, arguments);
}
function ms() {
  return ms = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ms.apply(this, arguments);
}
function fs() {
  return fs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, fs.apply(this, arguments);
}
function vs() {
  return vs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, vs.apply(this, arguments);
}
function ys() {
  return ys = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ys.apply(this, arguments);
}
function gs() {
  return gs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, gs.apply(this, arguments);
}
function hs() {
  return hs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, hs.apply(this, arguments);
}
function bs() {
  return bs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, bs.apply(this, arguments);
}
function Ns() {
  return Ns = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Ns.apply(this, arguments);
}
function xs() {
  return xs = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, xs.apply(this, arguments);
}
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ks.apply(this, arguments);
}
var ws = {
    collar: function collar(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", ps({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("g", {
        clipPath: "url(#1676044220916-7167729_clip0_3053_511)"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M16 1c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1v1a4 4 0 1 0 8 0V1z",
        fill: r
      })), Ue.createElement("defs", null, Ue.createElement("clipPath", {
        id: "1676044220916-7167729_clip0_3053_511"
      }, Ue.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "#fff"
      })))));
    },
    collarShoulders: function collarShoulders(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", ms({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M4.323 1.086A1 1 0 0 1 4.729 1h3.646a1 1 0 0 1 .852.477c.31.506.732 1.058 1.214 1.52.489.47.987.794 1.447.93.423.126.826.1 1.251-.165.463-.289 1.038-.917 1.62-2.18A1 1 0 0 1 15.666 1h3.646a1 1 0 0 1 .34.06L24 3v2l-4.863-2h-2.849c-.604 1.146-1.298 1.965-2.091 2.46-.96.597-1.963.656-2.877.385-.877-.26-1.646-.812-2.263-1.404A9.64 9.64 0 0 1 7.835 3H4.94L0 5v-.5V3l4.323-1.914z",
        fill: r,
        fillRule: "evenodd"
      })));
    },
    collarSleeves: function collarSleeves(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", fs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("g", {
        clipPath: "url(#1676044220915-6500173_clip0_3053_534)"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M16 1c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1v1a4 4 0 1 0 8 0V1z",
        fill: r
      }), Ue.createElement("path", {
        d: "M20.016 1.402l3.4 1.706c.4.2.6.501.6.902v6.02c0 .601-.4 1.002-1 1.002h-3v-9.63z",
        fill: r
      }), Ue.createElement("path", {
        d: "M4 1.387v9.628H1c-.6 0-1-.401-1-1.003V3.994c0-.401.2-.702.6-.902L4 1.387z",
        fill: r
      })), Ue.createElement("defs", null, Ue.createElement("clipPath", {
        id: "1676044220915-6500173_clip0_3053_534"
      }, Ue.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "#fff"
      })))));
    },
    half: function half(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", vs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M19.4 1.1l4 2c.4.2.6.5.6.9v6c0 .6-.4 1-1 1h-3v11c0 .6-.4 1-1 1h-7V5c1.7 0 3-1.3 3-3 0-.6.4-1 1-1h3c.2 0 .3 0 .4.1z",
        fill: r
      })));
    },
    plain: function plain(e) {
      var t = e.fill || "currentColor";
      e.secondaryfill;
      var r = e.width || "100%",
        a = e.height || "100%";
      return Ue.createElement("svg", ys({
        height: a,
        width: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      })));
    },
    squares: function squares(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", gs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M6 23H5c-.6 0-1-.4-1-1v-1h2v2z",
        fill: r
      }), Ue.createElement("path", {
        d: "M14 23h-4v-2h4v2z",
        fill: r
      }), Ue.createElement("path", {
        d: "M20 21v1c0 .6-.4 1-1 1h-1v-2h2z",
        fill: r
      }), Ue.createElement("path", {
        d: "M22 2.4l1.4.7c.4.2.6.5.6.9v1h-2V2.4z",
        fill: r
      }), Ue.createElement("path", {
        d: "M18 1h-2c-.6 0-1 .4-1 1 0 .92-.38 1.723-1 2.266V5h-4v-.734C9.38 3.723 9 2.92 9 2c0-.6-.4-1-1-1H6v4H2V2.4l-1.4.7c-.4.2-.6.5-.6.9v1h2v4H0v1c0 .6.4 1 1 1h1V9h4v4H4v4h2v4h4v-4h4v4h4v-4h2v-4h-2V9h4v2h1c.6 0 1-.4 1-1V9h-2V5h-4V1zm-4 8V5h4v4h-4zm0 4h4v4h-4v-4zm-4 0v4H6v-4h4zm0-4V5H6v4h4zm0 0v4h4V9h-4z",
        fill: r,
        fillRule: "evenodd"
      })));
    },
    stripeDiagonal: function stripeDiagonal(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", hs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M15 2c0-.6.4-1 1-1v1a4 4 0 0 1-8 0V1c.6 0 1 .4 1 1 0 1.7 1.3 3 3 3s3-1.3 3-3z",
        fill: r
      }), Ue.createElement("path", {
        d: "M20 8.063L5.063 23H5c-.6 0-1-.4-1-1v-4.106l16-16v6.169z",
        fill: r
      })));
    },
    stripeHorizontal: function stripeHorizontal(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", bs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M4 8h16v5H4z",
        fill: r
      })));
    },
    stripeVertical: function stripeVertical(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", Ns({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M9 4.646A3.99 3.99 0 0 0 12 6a3.99 3.99 0 0 0 3-1.354V23H9V4.646z",
        fill: r
      })));
    },
    stripesHorizontal: function stripesHorizontal(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", xs({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M4 3h5.16A3.138 3.138 0 0 1 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v1h4v2H0v2h4v2h16V9h4V7h-4V5h4V4c0-.4-.2-.7-.6-.9l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 .353-.056.69-.16 1H20v2H4V3zm16 4v2H4V7h16z",
        fill: r,
        fillRule: "evenodd"
      }), Ue.createElement("path", {
        d: "M4 13h16v2H4v-2z",
        fill: r
      }), Ue.createElement("path", {
        d: "M20 17H4v2h16v-2z",
        fill: r
      }), Ue.createElement("path", {
        d: "M20 21H4v1c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-1z",
        fill: r
      })));
    },
    stripesVertical: function stripesVertical(e) {
      var t = e.fill || "currentColor",
        r = e.secondaryfill || t,
        a = e.width || "100%",
        n = e.height || "100%";
      return Ue.createElement("svg", ks({
        height: n,
        width: a,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, "accessibilityLabel" in e && e.accessibilityLabel ? {
        "aria-label": e.accessibilityLabel
      } : {}), Ue.createElement("g", {
        fill: "none"
      }, Ue.createElement("path", {
        d: "M23.4 3.1l-4-2c-.1-.1-.2-.1-.4-.1h-3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S9 3.7 9 2c0-.6-.4-1-1-1H5c-.2 0-.3 0-.4.1l-4 2c-.4.2-.6.5-.6.9v6c0 .6.4 1 1 1h3v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V11h3c.6 0 1-.4 1-1V4c0-.4-.2-.7-.6-.9z",
        fill: t
      }), Ue.createElement("path", {
        d: "M15 2c0-.6.4-1 1-1v1c0 .484-.086.949-.244 1.378L17 4v19h-2V4.646a4 4 0 0 1-2 1.228V23h-2V5.874a4 4 0 0 1-2-1.228V23H7V4l1.244-.622A3.992 3.992 0 0 1 8 2V1c.6 0 1 .4 1 1 0 1.7 1.3 3 3 3s3-1.3 3-3z",
        fill: r
      })));
    }
  },
  _s = function _s(e) {
    var t = e.type,
      r = e.primaryColor,
      a = e.secondaryColor,
      n = e.width,
      o = void 0 === n ? "100%" : n,
      i = e.height,
      l = void 0 === i ? "100%" : i,
      s = e.accessibilityLabel;
    return ws[t]({
      fill: r || "#FEFEFE",
      secondaryfill: a || "#FEFEFE",
      width: o,
      height: l,
      accessibilityLabel: s
    });
  },
  Fs = new Map();
Fs.set({
  l: "nfl",
  "arizona cardinals": "n",
  "ari cardinals": "s",
  "nfl-ari": "a"
}, {
  name: "Arizona Cardinals",
  shortName: "ARI Cardinals",
  city: "Arizona",
  nickName: "Cardinals",
  abbreviation: "ARI",
  color: {
    primary: {
      value: "#97233F",
      type: "color"
    },
    secondary: {
      value: "#FFB612",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "atlanta falcons": "n",
  "atl falcons": "s",
  "nfl-atl": "a"
}, {
  name: "Atlanta Falcons",
  shortName: "ATL Falcons",
  city: "Atlanta",
  nickName: "Falcons",
  abbreviation: "ATL",
  color: {
    primary: {
      value: "#A71930",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "carolina panthers": "n",
  "car panthers": "s",
  "nfl-car": "a"
}, {
  name: "Carolina Panthers",
  shortName: "CAR Panthers",
  city: "Carolina",
  nickName: "Panthers",
  abbreviation: "CAR",
  color: {
    primary: {
      value: "#0085CA",
      type: "color"
    },
    secondary: {
      value: "#101820",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "chicago bears": "n",
  "chi bears": "s",
  "nfl-chi": "a"
}, {
  name: "Chicago Bears",
  shortName: "CHI Bears",
  city: "Chicago",
  nickName: "Bears",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#0B162A",
      type: "color"
    },
    secondary: {
      value: "#C83803",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "dallas cowboys": "n",
  "dal cowboys": "s",
  "nfl-dal": "a"
}, {
  name: "Dallas Cowboys",
  shortName: "DAL Cowboys",
  city: "Dallas",
  nickName: "Cowboys",
  abbreviation: "DAL",
  color: {
    primary: {
      value: "#003594",
      type: "color"
    },
    secondary: {
      value: "#7F9695",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "detroit lions": "n",
  "det lions": "s",
  "nfl-det": "a"
}, {
  name: "Detroit Lions",
  shortName: "DET Lions",
  city: "Detroit",
  nickName: "Lions",
  abbreviation: "DET",
  color: {
    primary: {
      value: "#0076B6",
      type: "color"
    },
    secondary: {
      value: "#B0B7BC",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "green bay packers": "n",
  "gb packers": "s",
  "nfl-gb": "a"
}, {
  name: "Green Bay Packers",
  shortName: "GB Packers",
  city: "Green Bay",
  nickName: "Packers",
  abbreviation: "GB",
  color: {
    primary: {
      value: "#203731",
      type: "color"
    },
    secondary: {
      value: "#FFB612",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "los angeles rams": "n",
  "la rams": "s",
  "nfl-lar": "a"
}, {
  name: "Los Angeles Rams",
  shortName: "LA Rams",
  city: "Los Angeles",
  nickName: "Rams",
  abbreviation: "LAR",
  color: {
    primary: {
      value: "#FFA300",
      type: "color"
    },
    secondary: {
      value: "#FFA300",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "minnesota vikings": "n",
  "min vikings": "s",
  "nfl-min": "a"
}, {
  name: "Minnesota Vikings",
  shortName: "MIN Vikings",
  city: "Minnesota",
  nickName: "Vikings",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#4F2683",
      type: "color"
    },
    secondary: {
      value: "#FFC62F",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "new orleans saints": "n",
  "no saints": "s",
  "nfl-no": "a"
}, {
  name: "New Orleans Saints",
  shortName: "NO Saints",
  city: "New Orleans",
  nickName: "Saints",
  abbreviation: "NO",
  color: {
    primary: {
      value: "#D3BC8D",
      type: "color"
    },
    secondary: {
      value: "#101820",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "new york giants": "n",
  "ny giants": "s",
  "nfl-nyg": "a"
}, {
  name: "New York Giants",
  shortName: "NY Giants",
  city: "New York",
  nickName: "Giants",
  abbreviation: "NYG",
  color: {
    primary: {
      value: "#0B2265",
      type: "color"
    },
    secondary: {
      value: "#A71930",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "philadelphia eagles": "n",
  "phi eagles": "s",
  "nfl-phi": "a"
}, {
  name: "Philadelphia Eagles",
  shortName: "PHI Eagles",
  city: "Philadelphia",
  nickName: "Eagles",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#004C54",
      type: "color"
    },
    secondary: {
      value: "#A5ACAF",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "san francisco 49ers": "n",
  "sf 49ers": "s",
  "nfl-sf": "a"
}, {
  name: "San Francisco 49ers",
  shortName: "SF 49ers",
  city: "San Francisco",
  nickName: "49ers",
  abbreviation: "SF",
  color: {
    primary: {
      value: "#AA0000",
      type: "color"
    },
    secondary: {
      value: "#B3995D",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "seattle seahawks": "n",
  "sea seahawks": "s",
  "nfl-sea": "a"
}, {
  name: "Seattle Seahawks",
  shortName: "SEA Seahawks",
  city: "Seattle",
  nickName: "Seahawks",
  abbreviation: "SEA",
  color: {
    primary: {
      value: "#002244",
      type: "color"
    },
    secondary: {
      value: "#69BE28",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "tampa bay buccaneers": "n",
  "tb buccaneers": "s",
  "nfl-tb": "a"
}, {
  name: "Tampa Bay Buccaneers",
  shortName: "TB Buccaneers",
  city: "Tampa Bay",
  nickName: "Buccaneers",
  abbreviation: "TB",
  color: {
    primary: {
      value: "#D50A0A",
      type: "color"
    },
    secondary: {
      value: "#0A0A08",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "washington commanders": "n",
  "was commanders": "s",
  "nfl-was": "a"
}, {
  name: "Washington Commanders",
  shortName: "WAS Commanders",
  city: "Washington",
  nickName: "Commanders",
  abbreviation: "WAS",
  color: {
    primary: {
      value: "#5A1414",
      type: "color"
    },
    secondary: {
      value: "#FFB612",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "baltimore ravens": "n",
  "bal ravens": "s",
  "nfl-bal": "a"
}, {
  name: "Baltimore Ravens",
  shortName: "BAL Ravens",
  city: "Baltimore",
  nickName: "Ravens",
  abbreviation: "BAL",
  color: {
    primary: {
      value: "#241773",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "buffalo bills": "n",
  "buf bills": "s",
  "nfl-buf": "a"
}, {
  name: "Buffalo Bills",
  shortName: "BUF Bills",
  city: "Buffalo",
  nickName: "Bills",
  abbreviation: "BUF",
  color: {
    primary: {
      value: "#00338D",
      type: "color"
    },
    secondary: {
      value: "#C60C30",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "cincinnati bengals": "n",
  "cin bengals": "s",
  "nfl-cin": "a"
}, {
  name: "Cincinnati Bengals",
  shortName: "CIN Bengals",
  city: "Cincinnati",
  nickName: "Bengals",
  abbreviation: "CIN",
  color: {
    primary: {
      value: "#FB4F14",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "cleveland browns": "n",
  "cle browns": "s",
  "nfl-cle": "a"
}, {
  name: "Cleveland Browns",
  shortName: "CLE Browns",
  city: "Cleveland",
  nickName: "Browns",
  abbreviation: "CLE",
  color: {
    primary: {
      value: "#FF3C00",
      type: "color"
    },
    secondary: {
      value: "#311D00",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "denver broncos": "n",
  "den broncos": "s",
  "nfl-den": "a"
}, {
  name: "Denver Broncos",
  shortName: "DEN Broncos",
  city: "Denver",
  nickName: "Broncos",
  abbreviation: "DEN",
  color: {
    primary: {
      value: "#002244",
      type: "color"
    },
    secondary: {
      value: "#FB4F14",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "houston texans": "n",
  "hou texans": "s",
  "nfl-hou": "a"
}, {
  name: "Houston Texans",
  shortName: "HOU Texans",
  city: "Houston",
  nickName: "Texans",
  abbreviation: "HOU",
  color: {
    primary: {
      value: "#03202F",
      type: "color"
    },
    secondary: {
      value: "#A71930",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "indianapolis colts": "n",
  "ind colts": "s",
  "nfl-ind": "a"
}, {
  name: "Indianapolis Colts",
  shortName: "IND Colts",
  city: "Indianapolis",
  nickName: "Colts",
  abbreviation: "IND",
  color: {
    primary: {
      value: "#002C5F",
      type: "color"
    },
    secondary: {
      value: "#A2AAAD",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "jacksonville jaguars": "n",
  "jax jaguars": "s",
  "nfl-jax": "a"
}, {
  name: "Jacksonville Jaguars",
  shortName: "JAX Jaguars",
  city: "Jacksonville",
  nickName: "Jaguars",
  abbreviation: "JAX",
  color: {
    primary: {
      value: "#006778",
      type: "color"
    },
    secondary: {
      value: "#D7A22A",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "kansas city chiefs": "n",
  "kc chiefs": "s",
  "nfl-kc": "a"
}, {
  name: "Kansas City Chiefs",
  shortName: "KC Chiefs",
  city: "Kansas City",
  nickName: "Chiefs",
  abbreviation: "KC",
  color: {
    primary: {
      value: "#E31837",
      type: "color"
    },
    secondary: {
      value: "#FFB81C",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "las vegas raiders": "n",
  "lv raiders": "s",
  "nfl-lv": "a"
}, {
  name: "Las Vegas Raiders",
  shortName: "LV Raiders",
  city: "Las Vegas",
  nickName: "Raiders",
  abbreviation: "LV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#A5ACAF",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "los angeles chargers": "n",
  "la chargers": "s",
  "nfl-lac": "a"
}, {
  name: "Los Angeles Chargers",
  shortName: "LA Chargers",
  city: "Los Angeles",
  nickName: "Chargers",
  abbreviation: "LAC",
  color: {
    primary: {
      value: "#007BC7",
      type: "color"
    },
    secondary: {
      value: "#FFC20E",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "miami dolphins": "n",
  "mia dolphins": "s",
  "nfl-mia": "a"
}, {
  name: "Miami Dolphins",
  shortName: "MIA Dolphins",
  city: "Miami",
  nickName: "Dolphins",
  abbreviation: "MIA",
  color: {
    primary: {
      value: "#008E97",
      type: "color"
    },
    secondary: {
      value: "#FC4C02",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "new england patriots": "n",
  "ne patriots": "s",
  "nfl-ne": "a"
}, {
  name: "New England Patriots",
  shortName: "NE Patriots",
  city: "New England",
  nickName: "Patriots",
  abbreviation: "NE",
  color: {
    primary: {
      value: "#002244",
      type: "color"
    },
    secondary: {
      value: "#C60C30",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "new york jets": "n",
  "ny jets": "s",
  "nfl-nyj": "a"
}, {
  name: "New York Jets",
  shortName: "NY Jets",
  city: "New York",
  nickName: "Jets",
  abbreviation: "NYJ",
  color: {
    primary: {
      value: "#125740",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "pittsburgh steelers": "n",
  "pit steelers": "s",
  "nfl-pit": "a"
}, {
  name: "Pittsburgh Steelers",
  shortName: "PIT Steelers",
  city: "Pittsburgh",
  nickName: "Steelers",
  abbreviation: "PIT",
  color: {
    primary: {
      value: "#FFB612",
      type: "color"
    },
    secondary: {
      value: "#101820",
      type: "color"
    }
  }
}), Fs.set({
  l: "nfl",
  "tennessee titans": "n",
  "ten titans": "s",
  "nfl-ten": "a"
}, {
  name: "Tennessee Titans",
  shortName: "TEN Titans",
  city: "Tennessee",
  nickName: "Titans",
  abbreviation: "TEN",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      value: "#4B92DB",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "boston celtics": "n",
  "bos celtics": "s",
  "nba-bos": "a"
}, {
  name: "Boston Celtics",
  shortName: "BOS Celtics",
  city: "Boston",
  nickName: "Celtics",
  abbreviation: "BOS",
  color: {
    primary: {
      value: "#008348",
      type: "color"
    },
    secondary: {
      value: "#BB9753",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "brooklyn nets": "n",
  "bkn nets": "s",
  "nba-bkn": "a"
}, {
  name: "Brooklyn Nets",
  shortName: "BKN Nets",
  city: "Brooklyn",
  nickName: "Nets",
  abbreviation: "BKN",
  color: {
    primary: {
      value: "#707271",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "new york knicks": "n",
  "ny knicks": "s",
  "nba-nyk": "a"
}, {
  name: "New York Knicks",
  shortName: "NY Knicks",
  city: "New York",
  nickName: "Knicks",
  abbreviation: "NYK",
  color: {
    primary: {
      value: "#006BB6",
      type: "color"
    },
    secondary: {
      value: "#1D428A",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "philadelphia 76ers": "n",
  "phi 76ers": "s",
  "nba-phi": "a"
}, {
  name: "Philadelphia 76ers",
  shortName: "PHI 76ers",
  city: "Philadelphia",
  nickName: "76ers",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#ED174C",
      type: "color"
    },
    secondary: {
      value: "#C8102E",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "toronto raptors": "n",
  "tor raptors": "s",
  "nba-tor": "a"
}, {
  name: "Toronto Raptors",
  shortName: "TOR Raptors",
  city: "Toronto",
  nickName: "Raptors",
  abbreviation: "TOR",
  color: {
    primary: {
      value: "#CE1141",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "chicago bulls": "n",
  "chi bulls": "s",
  "nba-chi": "a"
}, {
  name: "Chicago Bulls",
  shortName: "CHI Bulls",
  city: "Chicago",
  nickName: "Bulls",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#CE1141",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "cleveland cavaliers": "n",
  "cle cavaliers": "s",
  "nba-cle": "a"
}, {
  name: "Cleveland Cavaliers",
  shortName: "CLE Cavaliers",
  city: "Cleveland",
  nickName: "Cavaliers",
  abbreviation: "CLE",
  color: {
    primary: {
      value: "#860038",
      type: "color"
    },
    secondary: {
      value: "#BC945C",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "detroit pistons": "n",
  "det pistons": "s",
  "nba-det": "a"
}, {
  name: "Detroit Pistons",
  shortName: "DET Pistons",
  city: "Detroit",
  nickName: "Pistons",
  abbreviation: "DET",
  color: {
    primary: {
      value: "#1D428A",
      type: "color"
    },
    secondary: {
      value: "#C8102E",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "indiana pacers": "n",
  "ind pacers": "s",
  "nba-ind": "a"
}, {
  name: "Indiana Pacers",
  shortName: "IND Pacers",
  city: "Indiana",
  nickName: "Pacers",
  abbreviation: "IND",
  color: {
    primary: {
      value: "#FDBB30",
      type: "color"
    },
    secondary: {
      value: "#002D62",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "milwaukee bucks": "n",
  "mil bucks": "s",
  "nba-mil": "a"
}, {
  name: "Milwaukee Bucks",
  shortName: "MIL Bucks",
  city: "Milwaukee",
  nickName: "Bucks",
  abbreviation: "MIL",
  color: {
    primary: {
      value: "#00471B",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "atlanta hawks": "n",
  "atl hawks": "s",
  "nba-atl": "a"
}, {
  name: "Atlanta Hawks",
  shortName: "ATL Hawks",
  city: "Atlanta",
  nickName: "Hawks",
  abbreviation: "ATL",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      value: "#9EA2A2",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "charlotte hornets": "n",
  "cha hornets": "s",
  "nba-cha": "a"
}, {
  name: "Charlotte Hornets",
  shortName: "CHA Hornets",
  city: "Charlotte",
  nickName: "Hornets",
  abbreviation: "CHA",
  color: {
    primary: {
      value: "#00788C",
      type: "color"
    },
    secondary: {
      value: "#1D1160",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "miami heat": "n",
  "mia heat": "s",
  "nba-mia": "a"
}, {
  name: "Miami Heat",
  shortName: "MIA Heat",
  city: "Miami",
  nickName: "Heat",
  abbreviation: "MIA",
  color: {
    primary: {
      value: "#98002E",
      type: "color"
    },
    secondary: {
      value: "#F9A01B",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "orlando magic": "n",
  "orl magic": "s",
  "nba-orl": "a"
}, {
  name: "Orlando Magic",
  shortName: "ORL Magic",
  city: "Orlando",
  nickName: "Magic",
  abbreviation: "ORL",
  color: {
    primary: {
      value: "#0077C0",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "washington wizards": "n",
  "was wizards": "s",
  "nba-was": "a"
}, {
  name: "Washington Wizards",
  shortName: "WAS Wizards",
  city: "Washington",
  nickName: "Wizards",
  abbreviation: "WAS",
  color: {
    primary: {
      value: "#002B5C",
      type: "color"
    },
    secondary: {
      value: "#E31837",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "golden state warriors": "n",
  "gs warriors": "s",
  "nba-gsw": "a"
}, {
  name: "Golden State Warriors",
  shortName: "GS Warriors",
  city: "Golden State",
  nickName: "Warriors",
  abbreviation: "GSW",
  color: {
    primary: {
      value: "#FDB927",
      type: "color"
    },
    secondary: {
      value: "#1D428A",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "los angeles clippers": "n",
  "la clippers": "s",
  "nba-lac": "a"
}, {
  name: "Los Angeles Clippers",
  shortName: "LA Clippers",
  city: "Los Angeles",
  nickName: "Clippers",
  abbreviation: "LAC",
  color: {
    primary: {
      value: "#1D428A",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "los angeles lakers": "n",
  "la lakers": "s",
  "nba-lal": "a"
}, {
  name: "Los Angeles Lakers",
  shortName: "LA Lakers",
  city: "Los Angeles",
  nickName: "Lakers",
  abbreviation: "LAL",
  color: {
    primary: {
      value: "#31006F",
      type: "color"
    },
    secondary: {
      value: "#FDB927",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "phoenix suns": "n",
  "phx suns": "s",
  "nba-phx": "a"
}, {
  name: "Phoenix Suns",
  shortName: "PHX Suns",
  city: "Phoenix",
  nickName: "Suns",
  abbreviation: "PHX",
  color: {
    primary: {
      value: "#E56020",
      type: "color"
    },
    secondary: {
      value: "#1D1160",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "sacramento kings": "n",
  "sac kings": "s",
  "nba-sac": "a"
}, {
  name: "Sacramento Kings",
  shortName: "SAC Kings",
  city: "Sacramento",
  nickName: "Kings",
  abbreviation: "SAC",
  color: {
    primary: {
      value: "#5B2B82",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "denver nuggets": "n",
  "den nuggets": "s",
  "nba-den": "a"
}, {
  name: "Denver Nuggets",
  shortName: "DEN Nuggets",
  city: "Denver",
  nickName: "Nuggets",
  abbreviation: "DEN",
  color: {
    primary: {
      value: "#0E2240",
      type: "color"
    },
    secondary: {
      value: "#FEC524",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "minnesota timberwolves": "n",
  "min timberwolves": "s",
  "nba-min": "a"
}, {
  name: "Minnesota Timberwolves",
  shortName: "MIN Timberwolves",
  city: "Minnesota",
  nickName: "Timberwolves",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#266092",
      type: "color"
    },
    secondary: {
      value: "#0C233F",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "oklahoma city thunder": "n",
  "okc thunder": "s",
  "nba-okc": "a"
}, {
  name: "Oklahoma City Thunder",
  shortName: "OKC Thunder",
  city: "Oklahoma City",
  nickName: "Thunder",
  abbreviation: "OKC",
  color: {
    primary: {
      value: "#007AC1",
      type: "color"
    },
    secondary: {
      value: "#EF3B24",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "portland trail blazers": "n",
  "por trail blazers": "s",
  "nba-por": "a"
}, {
  name: "Portland Trail Blazers",
  shortName: "POR Trail Blazers",
  city: "Portland",
  nickName: "Trail Blazers",
  abbreviation: "POR",
  color: {
    primary: {
      value: "#E03A3E",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "utah jazz": "n",
  "uta jazz": "s",
  "nba-uta": "a"
}, {
  name: "Utah Jazz",
  shortName: "UTA Jazz",
  city: "Utah",
  nickName: "Jazz",
  abbreviation: "UTA",
  color: {
    primary: {
      value: "#FFF21F",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "dallas mavericks": "n",
  "dal mavericks": "s",
  "nba-dal": "a"
}, {
  name: "Dallas Mavericks",
  shortName: "DAL Mavericks",
  city: "Dallas",
  nickName: "Mavericks",
  abbreviation: "DAL",
  color: {
    primary: {
      value: "#0064B1",
      type: "color"
    },
    secondary: {
      value: "#00285E",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "houston rockets": "n",
  "hou rockets": "s",
  "nba-hou": "a"
}, {
  name: "Houston Rockets",
  shortName: "HOU Rockets",
  city: "Houston",
  nickName: "Rockets",
  abbreviation: "HOU",
  color: {
    primary: {
      value: "#CE1141",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "memphis grizzlies": "n",
  "mem grizzlies": "s",
  "nba-mem": "a"
}, {
  name: "Memphis Grizzlies",
  shortName: "MEM Grizzlies",
  city: "Memphis",
  nickName: "Grizzlies",
  abbreviation: "MEM",
  color: {
    primary: {
      value: "#5D76A9",
      type: "color"
    },
    secondary: {
      value: "#12173F",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "new orleans pelicans": "n",
  "no pelicans": "s",
  "nba-nop": "a"
}, {
  name: "New Orleans Pelicans",
  shortName: "NO Pelicans",
  city: "New Orleans",
  nickName: "Pelicans",
  abbreviation: "NOP",
  color: {
    primary: {
      value: "#B4975A",
      type: "color"
    },
    secondary: {
      value: "#0C2340",
      type: "color"
    }
  }
}), Fs.set({
  l: "nba",
  "san antonio spurs": "n",
  "sa spurs": "s",
  "nba-sas": "a"
}, {
  name: "San Antonio Spurs",
  shortName: "SA Spurs",
  city: "San Antonio",
  nickName: "Spurs",
  abbreviation: "SAS",
  color: {
    primary: {
      value: "#061922",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "new york rangers": "n",
  "ny rangers": "s",
  "nhl-nyr": "a"
}, {
  name: "New York Rangers",
  shortName: "NY Rangers",
  city: "New York",
  nickName: "Rangers",
  abbreviation: "NYR",
  color: {
    primary: {
      value: "#0033A0",
      type: "color"
    },
    secondary: {
      value: "#E31937",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "boston bruins": "n",
  "bos bruins": "s",
  "nhl-bos": "a"
}, {
  name: "Boston Bruins",
  shortName: "BOS Bruins",
  city: "Boston",
  nickName: "Bruins",
  abbreviation: "BOS",
  color: {
    primary: {
      value: "#FFB81C",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "buffalo sabres": "n",
  "buf sabres": "s",
  "nhl-buf": "a"
}, {
  name: "Buffalo Sabres",
  shortName: "BUF Sabres",
  city: "Buffalo",
  nickName: "Sabres",
  abbreviation: "BUF",
  color: {
    primary: {
      value: "#102F82",
      type: "color"
    },
    secondary: {
      value: "#FBB800",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "new jersey devils": "n",
  "nj devils": "s",
  "nhl-njd": "a"
}, {
  name: "New Jersey Devils",
  shortName: "NJ Devils",
  city: "New Jersey",
  nickName: "Devils",
  abbreviation: "NJD",
  color: {
    primary: {
      value: "#CE0E2D",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "new york islanders": "n",
  "ny islanders": "s",
  "nhl-nyi": "a"
}, {
  name: "New York Islanders",
  shortName: "NY Islanders",
  city: "New York",
  nickName: "Islanders",
  abbreviation: "NYI",
  color: {
    primary: {
      value: "#FC4C02",
      type: "color"
    },
    secondary: {
      value: "#003087",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "philadelphia flyers": "n",
  "phi flyers": "s",
  "nhl-phi": "a"
}, {
  name: "Philadelphia Flyers",
  shortName: "PHI Flyers",
  city: "Philadelphia",
  nickName: "Flyers",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#FF4713",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "pittsburgh penguins": "n",
  "pit penguins": "s",
  "nhl-pit": "a"
}, {
  name: "Pittsburgh Penguins",
  shortName: "PIT Penguins",
  city: "Pittsburgh",
  nickName: "Penguins",
  abbreviation: "PIT",
  color: {
    primary: {
      value: "#FCB514",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "washington capitals": "n",
  "wsh capitals": "s",
  "nhl-wsh": "a"
}, {
  name: "Washington Capitals",
  shortName: "WSH Capitals",
  city: "Washington",
  nickName: "Capitals",
  abbreviation: "WSH",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      value: "#CE0E2D",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "carolina hurricanes": "n",
  "car hurricanes": "s",
  "nhl-car": "a"
}, {
  name: "Carolina Hurricanes",
  shortName: "CAR Hurricanes",
  city: "Carolina",
  nickName: "Hurricanes",
  abbreviation: "CAR",
  color: {
    primary: {
      value: "#CE1126",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "chicago blackhawks": "n",
  "chi blackhawks": "s",
  "nhl-chi": "a"
}, {
  name: "Chicago Blackhawks",
  shortName: "CHI Blackhawks",
  city: "Chicago",
  nickName: "Blackhawks",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#CF0A2C",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "columbus blue jackets": "n",
  "clb blue jackets": "s",
  "nhl-cbj": "a"
}, {
  name: "Columbus Blue Jackets",
  shortName: "CLB Blue Jackets",
  city: "Columbus",
  nickName: "Blue Jackets",
  abbreviation: "CBJ",
  color: {
    primary: {
      value: "#72253D",
      type: "color"
    },
    secondary: {
      value: "#CE0E2D",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "dallas stars": "n",
  "dal stars": "s",
  "nhl-dal": "a"
}, {
  name: "Dallas Stars",
  shortName: "DAL Stars",
  city: "Dallas",
  nickName: "Stars",
  abbreviation: "DAL",
  color: {
    primary: {
      value: "#00843D",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "detroit red wings": "n",
  "det red wings": "s",
  "nhl-det": "a"
}, {
  name: "Detroit Red Wings",
  shortName: "DET Red Wings",
  city: "Detroit",
  nickName: "Red Wings",
  abbreviation: "DET",
  color: {
    primary: {
      value: "#CE1126",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "florida panthers": "n",
  "fla panthers": "s",
  "nhl-fla": "a"
}, {
  name: "Florida Panthers",
  shortName: "FLA Panthers",
  city: "Florida",
  nickName: "Panthers",
  abbreviation: "FLA",
  color: {
    primary: {
      value: "#E31937",
      type: "color"
    },
    secondary: {
      value: "#002D62",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "nashville predators": "n",
  "nsh predators": "s",
  "nhl-nsh": "a"
}, {
  name: "Nashville Predators",
  shortName: "NSH Predators",
  city: "Nashville",
  nickName: "Predators",
  abbreviation: "NSH",
  color: {
    primary: {
      value: "#FFB71B",
      type: "color"
    },
    secondary: {
      value: "#011E41",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "tampa bay lightning": "n",
  "tb lightning": "s",
  "nhl-tbl": "a"
}, {
  name: "Tampa Bay Lightning",
  shortName: "TB Lightning",
  city: "Tampa Bay",
  nickName: "Lightning",
  abbreviation: "TBL",
  color: {
    primary: {
      value: "#122797",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "anaheim ducks": "n",
  "ana ducks": "s",
  "nhl-ana": "a"
}, {
  name: "Anaheim Ducks",
  shortName: "ANA Ducks",
  city: "Anaheim",
  nickName: "Ducks",
  abbreviation: "ANA",
  color: {
    primary: {
      value: "#FF4D00",
      type: "color"
    },
    secondary: {
      value: "#B7955B",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "utah hockey club": "n",
  "uta hockey club": "s",
  "nhl-uta": "a"
}, {
  name: "Utah Hockey Club",
  shortName: "UTA Hockey Club",
  city: "Utah",
  nickName: "Hockey Club",
  abbreviation: "UTA",
  color: {
    primary: {
      value: "#6CACE4",
      type: "color"
    },
    secondary: {
      value: "#010101",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "colorado avalanche": "n",
  "col avalanche": "s",
  "nhl-col": "a"
}, {
  name: "Colorado Avalanche",
  shortName: "COL Avalanche",
  city: "Colorado",
  nickName: "Avalanche",
  abbreviation: "COL",
  color: {
    primary: {
      value: "#236092",
      type: "color"
    },
    secondary: {
      value: "#011E41",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "los angeles kings": "n",
  "la kings": "s",
  "nhl-lak": "a"
}, {
  name: "Los Angeles Kings",
  shortName: "LA Kings",
  city: "Los Angeles",
  nickName: "Kings",
  abbreviation: "LAK",
  color: {
    primary: {
      value: "#231F20",
      type: "color"
    },
    secondary: {
      value: "#A2A9AD",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "minnesota wild": "n",
  "min wild": "s",
  "nhl-min": "a"
}, {
  name: "Minnesota Wild",
  shortName: "MIN Wild",
  city: "Minnesota",
  nickName: "Wild",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#124734",
      type: "color"
    },
    secondary: {
      value: "#AA182C",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "san jose sharks": "n",
  "sj sharks": "s",
  "nhl-sjs": "a"
}, {
  name: "San Jose Sharks",
  shortName: "SJ Sharks",
  city: "San Jose",
  nickName: "Sharks",
  abbreviation: "SJS",
  color: {
    primary: {
      value: "#006072",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "st. louis blues": "n",
  "stl blues": "s",
  "nhl-stl": "a"
}, {
  name: "St. Louis Blues",
  shortName: "STL Blues",
  city: "St. Louis",
  nickName: "Blues",
  abbreviation: "STL",
  color: {
    primary: {
      value: "#003087",
      type: "color"
    },
    secondary: {
      value: "#FFB71B",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "vegas golden knights": "n",
  "veg golden knights": "s",
  "nhl-vgk": "a"
}, {
  name: "Vegas Golden Knights",
  shortName: "VEG Golden Knights",
  city: "Vegas",
  nickName: "Golden Knights",
  abbreviation: "VGK",
  color: {
    primary: {
      value: "#B7955B",
      type: "color"
    },
    secondary: {
      value: "#333F42",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "seattle kraken": "n",
  "sea kraken": "s",
  "nhl-sea": "a"
}, {
  name: "Seattle Kraken",
  shortName: "SEA Kraken",
  city: "Seattle",
  nickName: "Kraken",
  abbreviation: "SEA",
  color: {
    primary: {
      value: "#629EB5",
      type: "color"
    },
    secondary: {
      value: "#001425",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "calgary flames": "n",
  "cgy flames": "s",
  "nhl-cgy": "a"
}, {
  name: "Calgary Flames",
  shortName: "CGY Flames",
  city: "Calgary",
  nickName: "Flames",
  abbreviation: "CGY",
  color: {
    primary: {
      value: "#DA1A32",
      type: "color"
    },
    secondary: {
      value: "#FDBE57",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "edmonton oilers": "n",
  "edm oilers": "s",
  "nhl-edm": "a"
}, {
  name: "Edmonton Oilers",
  shortName: "EDM Oilers",
  city: "Edmonton",
  nickName: "Oilers",
  abbreviation: "EDM",
  color: {
    primary: {
      value: "#EF4F23",
      type: "color"
    },
    secondary: {
      value: "#0A1F41",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "montreal canadiens": "n",
  "mtl canadiens": "s",
  "nhl-mtl": "a"
}, {
  name: "Montreal Canadiens",
  shortName: "MTL Canadiens",
  city: "Montreal",
  nickName: "Canadiens",
  abbreviation: "MTL",
  color: {
    primary: {
      value: "#AA182C",
      type: "color"
    },
    secondary: {
      value: "#001E61",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "ottawa senators": "n",
  "ott senators": "s",
  "nhl-ott": "a"
}, {
  name: "Ottawa Senators",
  shortName: "OTT Senators",
  city: "Ottawa",
  nickName: "Senators",
  abbreviation: "OTT",
  color: {
    primary: {
      value: "#B79257",
      type: "color"
    },
    secondary: {
      value: "#DA1A32",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "toronto maple leafs": "n",
  "tor maple leafs": "s",
  "nhl-tor": "a"
}, {
  name: "Toronto Maple Leafs",
  shortName: "TOR Maple Leafs",
  city: "Toronto",
  nickName: "Maple Leafs",
  abbreviation: "TOR",
  color: {
    primary: {
      value: "#00205B",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "vancouver canucks": "n",
  "van canucks": "s",
  "nhl-van": "a"
}, {
  name: "Vancouver Canucks",
  shortName: "VAN Canucks",
  city: "Vancouver",
  nickName: "Canucks",
  abbreviation: "VAN",
  color: {
    primary: {
      value: "#003E7E",
      type: "color"
    },
    secondary: {
      value: "#00205B",
      type: "color"
    }
  }
}), Fs.set({
  l: "nhl",
  "winnipeg jets": "n",
  "wpg jets": "s",
  "nhl-wpg": "a"
}, {
  name: "Winnipeg Jets",
  shortName: "WPG Jets",
  city: "Winnipeg",
  nickName: "Jets",
  abbreviation: "WPG",
  color: {
    primary: {
      value: "#011E41",
      type: "color"
    },
    secondary: {
      value: "#CE0E2D",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "baltimore orioles": "n",
  "bal orioles": "s",
  "mlb-bal": "a"
}, {
  name: "Baltimore Orioles",
  shortName: "BAL Orioles",
  city: "Baltimore",
  nickName: "Orioles",
  abbreviation: "BAL",
  color: {
    primary: {
      value: "#F15D22",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "boston red sox": "n",
  "bos red sox": "s",
  "mlb-bos": "a"
}, {
  name: "Boston Red Sox",
  shortName: "BOS Red Sox",
  city: "Boston",
  nickName: "Red Sox",
  abbreviation: "BOS",
  color: {
    primary: {
      value: "#BD3039",
      type: "color"
    },
    secondary: {
      value: "#0C2340",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "chicago white sox": "n",
  "chi white sox": "s",
  "mlb-cws": "a"
}, {
  name: "Chicago White Sox",
  shortName: "CHI White Sox",
  city: "Chicago",
  nickName: "White Sox",
  abbreviation: "CWS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "cincinnati reds": "n",
  "cin reds": "s",
  "mlb-cin": "a"
}, {
  name: "Cincinnati Reds",
  shortName: "CIN Reds",
  city: "Cincinnati",
  nickName: "Reds",
  abbreviation: "CIN",
  color: {
    primary: {
      value: "#D31245",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "cleveland guardians": "n",
  "cle guardians": "s",
  "mlb-cle": "a"
}, {
  name: "Cleveland Guardians",
  shortName: "CLE Guardians",
  city: "Cleveland",
  nickName: "Guardians",
  abbreviation: "CLE",
  color: {
    primary: {
      value: "#0A243D",
      type: "color"
    },
    secondary: {
      value: "#E50022",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "detroit tigers": "n",
  "det tigers": "s",
  "mlb-det": "a"
}, {
  name: "Detroit Tigers",
  shortName: "DET Tigers",
  city: "Detroit",
  nickName: "Tigers",
  abbreviation: "DET",
  color: {
    primary: {
      value: "#001C42",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "houston astros": "n",
  "hou astros": "s",
  "mlb-hou": "a"
}, {
  name: "Houston Astros",
  shortName: "HOU Astros",
  city: "Houston",
  nickName: "Astros",
  abbreviation: "HOU",
  color: {
    primary: {
      value: "#E86D1F",
      type: "color"
    },
    secondary: {
      value: "#002D62",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "kansas city royals": "n",
  "kc royals": "s",
  "mlb-kc": "a"
}, {
  name: "Kansas City Royals",
  shortName: "KC Royals",
  city: "Kansas City",
  nickName: "Royals",
  abbreviation: "KC",
  color: {
    primary: {
      value: "#004687",
      type: "color"
    },
    secondary: {
      value: "#B4975A",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "los angeles angels": "n",
  "la angels": "s",
  "mlb-laa": "a"
}, {
  name: "Los Angeles Angels",
  shortName: "LA Angels",
  city: "Los Angeles",
  nickName: "Angels",
  abbreviation: "LAA",
  color: {
    primary: {
      value: "#BA0021",
      type: "color"
    },
    secondary: {
      value: "#002B5C",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "minnesota twins": "n",
  "min twins": "s",
  "mlb-min": "a"
}, {
  name: "Minnesota Twins",
  shortName: "MIN Twins",
  city: "Minnesota",
  nickName: "Twins",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#002B5C",
      type: "color"
    },
    secondary: {
      value: "#D31245",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "new york yankees": "n",
  "ny yankees": "s",
  "mlb-nyy": "a"
}, {
  name: "New York Yankees",
  shortName: "NY Yankees",
  city: "New York",
  nickName: "Yankees",
  abbreviation: "NYY",
  color: {
    primary: {
      value: "#002A5C",
      type: "color"
    },
    secondary: {
      value: "#EF3E42",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "oakland athletics": "n",
  "oak athletics": "s",
  "mlb-oak": "a"
}, {
  name: "Oakland Athletics",
  shortName: "OAK Athletics",
  city: "Oakland",
  nickName: "Athletics",
  abbreviation: "OAK",
  color: {
    primary: {
      value: "#00483A",
      type: "color"
    },
    secondary: {
      value: "#FDBB3",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "seattle mariners": "n",
  "sea mariners": "s",
  "mlb-sea": "a"
}, {
  name: "Seattle Mariners",
  shortName: "SEA Mariners",
  city: "Seattle",
  nickName: "Mariners",
  abbreviation: "SEA",
  color: {
    primary: {
      value: "#006C67",
      type: "color"
    },
    secondary: {
      value: "#002B5C",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "tampa bay rays": "n",
  "tb rays": "s",
  "mlb-tb": "a"
}, {
  name: "Tampa Bay Rays",
  shortName: "TB Rays",
  city: "Tampa Bay",
  nickName: "Rays",
  abbreviation: "TB",
  color: {
    primary: {
      value: "#79BDE8",
      type: "color"
    },
    secondary: {
      value: "#002D62",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "texas rangers": "n",
  "tex rangers": "s",
  "mlb-tex": "a"
}, {
  name: "Texas Rangers",
  shortName: "TEX Rangers",
  city: "Texas",
  nickName: "Rangers",
  abbreviation: "TEX",
  color: {
    primary: {
      value: "#004B8D",
      type: "color"
    },
    secondary: {
      value: "#D31245",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "toronto blue jays": "n",
  "tor blue jays": "s",
  "mlb-tor": "a"
}, {
  name: "Toronto Blue Jays",
  shortName: "TOR Blue Jays",
  city: "Toronto",
  nickName: "Blue Jays",
  abbreviation: "TOR",
  color: {
    primary: {
      value: "#134A8E",
      type: "color"
    },
    secondary: {
      value: "#ED174F",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "arizona diamondbacks": "n",
  "ari diamondbacks": "s",
  "mlb-ari": "a"
}, {
  name: "Arizona Diamondbacks",
  shortName: "ARI Diamondbacks",
  city: "Arizona",
  nickName: "Diamondbacks",
  abbreviation: "ARI",
  color: {
    primary: {
      value: "#B81237",
      type: "color"
    },
    secondary: {
      value: "#EEE1C3",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "atlanta braves": "n",
  "atl braves": "s",
  "mlb-atl": "a"
}, {
  name: "Atlanta Braves",
  shortName: "ATL Braves",
  city: "Atlanta",
  nickName: "Braves",
  abbreviation: "ATL",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      value: "#D0043C",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "chicago cubs": "n",
  "chi cubs": "s",
  "mlb-chc": "a"
}, {
  name: "Chicago Cubs",
  shortName: "CHI Cubs",
  city: "Chicago",
  nickName: "Cubs",
  abbreviation: "CHC",
  color: {
    primary: {
      value: "#0E3386",
      type: "color"
    },
    secondary: {
      value: "#DF1739",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "colorado rockies": "n",
  "col rockies": "s",
  "mlb-col": "a"
}, {
  name: "Colorado Rockies",
  shortName: "COL Rockies",
  city: "Colorado",
  nickName: "Rockies",
  abbreviation: "COL",
  color: {
    primary: {
      value: "#33006F",
      type: "color"
    },
    secondary: {
      value: "#C4CED4",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "los angeles dodgers": "n",
  "la dodgers": "s",
  "mlb-lad": "a"
}, {
  name: "Los Angeles Dodgers",
  shortName: "LA Dodgers",
  city: "Los Angeles",
  nickName: "Dodgers",
  abbreviation: "LAD",
  color: {
    primary: {
      value: "#005596",
      type: "color"
    },
    secondary: {
      value: "#EF3E42",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "miami marlins": "n",
  "mia marlins": "s",
  "mlb-mia": "a"
}, {
  name: "Miami Marlins",
  shortName: "MIA Marlins",
  city: "Miami",
  nickName: "Marlins",
  abbreviation: "MIA",
  color: {
    primary: {
      value: "#00A0DD",
      type: "color"
    },
    secondary: {
      value: "#EF3742",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "milwaukee brewers": "n",
  "mil brewers": "s",
  "mlb-mil": "a"
}, {
  name: "Milwaukee Brewers",
  shortName: "MIL Brewers",
  city: "Milwaukee",
  nickName: "Brewers",
  abbreviation: "MIL",
  color: {
    primary: {
      value: "#12284B",
      type: "color"
    },
    secondary: {
      value: "#FFC52F",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "new york mets": "n",
  "ny mets": "s",
  "mlb-nym": "a"
}, {
  name: "New York Mets",
  shortName: "NY Mets",
  city: "New York",
  nickName: "Mets",
  abbreviation: "NYM",
  color: {
    primary: {
      value: "#F47D30",
      type: "color"
    },
    secondary: {
      value: "#004B8D",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "philadelphia phillies": "n",
  "phi phillies": "s",
  "mlb-phi": "a"
}, {
  name: "Philadelphia Phillies",
  shortName: "PHI Phillies",
  city: "Philadelphia",
  nickName: "Phillies",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#C20C31",
      type: "color"
    },
    secondary: {
      value: "#004B8D",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "pittsburgh pirates": "n",
  "pit pirates": "s",
  "mlb-pit": "a"
}, {
  name: "Pittsburgh Pirates",
  shortName: "PIT Pirates",
  city: "Pittsburgh",
  nickName: "Pirates",
  abbreviation: "PIT",
  color: {
    primary: {
      value: "#27251F",
      type: "color"
    },
    secondary: {
      value: "#FFC425",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "san diego padres": "n",
  "sd padres": "s",
  "mlb-sd": "a"
}, {
  name: "San Diego Padres",
  shortName: "SD Padres",
  city: "San Diego",
  nickName: "Padres",
  abbreviation: "SD",
  color: {
    primary: {
      value: "#FFC425",
      type: "color"
    },
    secondary: {
      value: "#2F241D",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "san francisco giants": "n",
  "sf giants": "s",
  "mlb-sf": "a"
}, {
  name: "San Francisco Giants",
  shortName: "SF Giants",
  city: "San Francisco",
  nickName: "Giants",
  abbreviation: "SF",
  color: {
    primary: {
      value: "#F4793E",
      type: "color"
    },
    secondary: {
      value: "#231F20",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "st. louis cardinals": "n",
  "stl cardinals": "s",
  "mlb-stl": "a"
}, {
  name: "St. Louis Cardinals",
  shortName: "STL Cardinals",
  city: "St. Louis",
  nickName: "Cardinals",
  abbreviation: "STL",
  color: {
    primary: {
      value: "#BE0A14",
      type: "color"
    },
    secondary: {
      value: "#FFE512",
      type: "color"
    }
  }
}), Fs.set({
  l: "mlb",
  "washington nationals": "n",
  "wsh nationals": "s",
  "mlb-wsh": "a"
}, {
  name: "Washington Nationals",
  shortName: "WSH Nationals",
  city: "Washington",
  nickName: "Nationals",
  abbreviation: "WSH",
  color: {
    primary: {
      value: "#002D62",
      type: "color"
    },
    secondary: {
      value: "#D31245",
      type: "color"
    }
  }
}), Fs.set({
  l: "soccer",
  "paris saint-germain": "n",
  psg: "s",
  "soccer-psg": "a"
}, {
  name: "Paris Saint-Germain",
  shortName: "PSG",
  city: "Paris",
  nickName: "Parisians",
  abbreviation: "PSG",
  color: {
    primary: {
      value: "#004170",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  marseille: "n",
  "soccer-mar": "a"
}, {
  name: "Marseille",
  shortName: "Marseille",
  city: "Marseille",
  nickName: "Marseillais",
  abbreviation: "MAR",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#2FAEE0",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "as monaco": "n",
  monaco: "s",
  "soccer-mon": "a"
}, {
  name: "AS Monaco",
  shortName: "Monaco",
  city: "Monaco",
  nickName: "Monégasques",
  abbreviation: "MON",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#E51B22",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "half"
  }
}), Fs.set({
  l: "soccer",
  lens: "n",
  "soccer-len": "a"
}, {
  name: "Lens",
  shortName: "Lens",
  city: "Lens",
  nickName: "Sang et Or",
  abbreviation: "LEN",
  color: {
    primary: {
      value: "#FFF200",
      type: "color"
    },
    secondary: {
      value: "#EC1C24",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeDiagonal"
  }
}), Fs.set({
  l: "soccer",
  "stade rennais": "n",
  rennes: "s",
  "soccer-ren": "a"
}, {
  name: "Stade Rennais",
  shortName: "Rennes",
  city: "Rennes",
  nickName: "Rennais",
  abbreviation: "REN",
  color: {
    primary: {
      value: "#E13327",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  lille: "n",
  "soccer-lil": "a"
}, {
  name: "Lille",
  shortName: "Lille",
  city: "Lille",
  nickName: "Dogues",
  abbreviation: "LIL",
  color: {
    primary: {
      value: "#E01E13",
      type: "color"
    },
    secondary: {
      value: "#24216A",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  lorient: "n",
  "soccer-lor": "a"
}, {
  name: "Lorient",
  shortName: "Lorient",
  city: "Lorient",
  nickName: "Merlus",
  abbreviation: "LOR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#F58113",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "squares"
  }
}), Fs.set({
  l: "soccer",
  nice: "n",
  "soccer-nic": "a"
}, {
  name: "Nice",
  shortName: "Nice",
  city: "Nice",
  nickName: "Aiglons",
  abbreviation: "NIC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#ED1C24",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  lyon: "n",
  "soccer-lyo": "a"
}, {
  name: "Lyon",
  shortName: "Lyon",
  city: "Lyon",
  nickName: "Lyonnais",
  abbreviation: "LYO",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#DA0812",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "stade de reims": "n",
  reims: "s",
  "soccer-rei": "a"
}, {
  name: "Stade de Reims",
  shortName: "Reims",
  city: "Reims",
  nickName: "Rémois",
  abbreviation: "REI",
  color: {
    primary: {
      value: "#EE2223",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  toulouse: "n",
  "soccer-tou": "a"
}, {
  name: "Toulouse",
  shortName: "Toulouse",
  city: "Toulouse",
  nickName: "Toulousains",
  abbreviation: "TOU",
  color: {
    primary: {
      value: "#3E2C56",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "clermont foot": "n",
  clermont: "s",
  "soccer-cle": "a"
}, {
  name: "Clermont Foot",
  shortName: "Clermont",
  city: "Clermont-Ferrand",
  nickName: "Clermontois",
  abbreviation: "CLE",
  color: {
    primary: {
      value: "#C50C46",
      type: "color"
    },
    secondary: {
      value: "#002D6A",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  nantes: "n",
  "soccer-nan": "a"
}, {
  name: "Nantes",
  shortName: "Nantes",
  city: "Nantes",
  nickName: "Nantais",
  abbreviation: "NAN",
  color: {
    primary: {
      value: "#FCD405",
      type: "color"
    },
    secondary: {
      value: "#1B8F3A",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  montpellier: "n",
  "soccer-mon": "a"
}, {
  name: "Montpellier",
  shortName: "Montpellier",
  city: "Montpellier",
  nickName: "Héraultais",
  abbreviation: "MON",
  color: {
    primary: {
      value: "#344575",
      type: "color"
    },
    secondary: {
      value: "#D87043",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  strasbourg: "n",
  "soccer-str": "a"
}, {
  name: "Strasbourg",
  shortName: "Strasbourg",
  city: "Strasbourg",
  nickName: "Racingmen",
  abbreviation: "STR",
  color: {
    primary: {
      value: "#004996",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  brest: "n",
  "soccer-bre": "a"
}, {
  name: "Brest",
  shortName: "Brest",
  city: "Brest",
  nickName: "Brestois",
  abbreviation: "BRE",
  color: {
    primary: {
      value: "#ED1C24",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  troyes: "n",
  "soccer-tro": "a"
}, {
  name: "Troyes",
  shortName: "Troyes",
  city: "Troyes",
  nickName: "Troyens",
  abbreviation: "TRO",
  color: {
    primary: {
      value: "#006EB2",
      type: "color"
    },
    secondary: {
      value: "#006EB2",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "aj auxerre": "n",
  auxerre: "s",
  "soccer-aux": "a"
}, {
  name: "AJ Auxerre",
  shortName: "Auxerre",
  city: "Auxerre",
  nickName: "Auxerrois",
  abbreviation: "AUX",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#4087BF",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "ac ajaccio": "n",
  ajaccio: "s",
  "soccer-aja": "a"
}, {
  name: "AC Ajaccio",
  shortName: "Ajaccio",
  city: "Ajaccio",
  nickName: "Ajacciens",
  abbreviation: "AJA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#EC1C24",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  angers: "n",
  "soccer-ang": "a"
}, {
  name: "Angers",
  shortName: "Angers",
  city: "Angers",
  nickName: "Angevins",
  abbreviation: "ANG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  metz: "n",
  "soccer-met": "a"
}, {
  name: "Metz",
  shortName: "Metz",
  city: "Metz",
  nickName: "Messins",
  abbreviation: "MET",
  color: {
    primary: {
      value: "#6E0F12",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  bordeaux: "n",
  "soccer-bor": "a"
}, {
  name: "Bordeaux",
  shortName: "Bordeaux",
  city: "Bordeaux",
  nickName: "Girondins",
  abbreviation: "BOR",
  color: {
    primary: {
      value: "#001B50",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesHorizontal"
  }
}), Fs.set({
  l: "soccer",
  nimes: "n",
  "soccer-nim": "a"
}, {
  name: "Nimes",
  shortName: "Nimes",
  city: "Nimes",
  nickName: "Nîmois",
  abbreviation: "NIM",
  color: {
    primary: {
      value: "#E40613",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "dijon fco": "n",
  dijon: "s",
  "soccer-dij": "a"
}, {
  name: "Dijon FCO",
  shortName: "Dijon",
  city: "Dijon",
  nickName: "Dijonnais",
  abbreviation: "DIJ",
  color: {
    primary: {
      value: "#D3072A",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "sc amiens": "n",
  amiens: "s",
  "soccer-ami": "a"
}, {
  name: "SC Amiens",
  shortName: "Amiens",
  city: "Amiens",
  nickName: "Amiénois",
  abbreviation: "AMI",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#007AC1",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  caen: "n",
  "soccer-cae": "a"
}, {
  name: "Caen",
  shortName: "Caen",
  city: "Caen",
  nickName: "Malherbistes",
  abbreviation: "CAE",
  color: {
    primary: {
      value: "#3B4560",
      type: "color"
    },
    secondary: {
      value: "#CE4B43",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  guingamp: "n",
  "soccer-gui": "a"
}, {
  name: "Guingamp",
  shortName: "Guingamp",
  city: "Guingamp",
  nickName: "Guingampais",
  abbreviation: "GUI",
  color: {
    primary: {
      value: "#E30613",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "fortuna düsseldorf": "n",
  "düsseldorf": "s",
  "soccer-f95": "a"
}, {
  name: "Fortuna Düsseldorf",
  shortName: "Düsseldorf",
  city: "Düsseldorf",
  nickName: "Flingeraner",
  abbreviation: "F95",
  color: {
    primary: {
      value: "#E30511",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "arminia bielefeld": "n",
  bielefeld: "s",
  "soccer-dsc": "a"
}, {
  name: "Arminia Bielefeld",
  shortName: "Bielefeld",
  city: "Bielefeld",
  nickName: "Arminen",
  abbreviation: "DSC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#004e95",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeDiagonal"
  }
}), Fs.set({
  l: "soccer",
  "bayer leverkusen": "n",
  leverkusen: "s",
  "soccer-b04": "a"
}, {
  name: "Bayer Leverkusen",
  shortName: "Leverkusen",
  city: "Leverkusen",
  nickName: "Werkself",
  abbreviation: "B04",
  color: {
    primary: {
      value: "#e32221",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "bayern munich": "n",
  bayern: "s",
  "soccer-mun": "a"
}, {
  name: "Bayern Munich",
  shortName: "Bayern",
  city: "Munich",
  nickName: "Die Roten",
  abbreviation: "MUN",
  color: {
    primary: {
      value: "#dc052d",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "borussia dortmund": "n",
  dortmund: "s",
  "soccer-dor": "a"
}, {
  name: "Borussia Dortmund",
  shortName: "Dortmund",
  city: "Dortmund",
  nickName: "Die Schwarzgelben",
  abbreviation: "DOR",
  color: {
    primary: {
      value: "#fde100",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "borussia monchengladbach": "n",
  gladbach: "s",
  "soccer-bmg": "a"
}, {
  name: "Borussia Monchengladbach",
  shortName: "Gladbach",
  city: "Mönchengladbach",
  nickName: "Die Fohlen",
  abbreviation: "BMG",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#2b7a6a",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "eintracht frankfurt": "n",
  frankfurt: "s",
  "soccer-sge": "a"
}, {
  name: "Eintracht Frankfurt",
  shortName: "Frankfurt",
  city: "Frankfurt",
  nickName: "Die Adler",
  abbreviation: "SGE",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "fc augsburg": "n",
  augsburg: "s",
  "soccer-fca": "a"
}, {
  name: "FC Augsburg",
  shortName: "Augsburg",
  city: "Augsburg",
  nickName: "Fuggerstädter",
  abbreviation: "FCA",
  color: {
    primary: {
      value: "#ba3733",
      type: "color"
    },
    secondary: {
      value: "#46714d",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "fc cologne": "n",
  cologne: "s",
  "soccer-koe": "a"
}, {
  name: "FC Cologne",
  shortName: "Cologne",
  city: "Cologne",
  nickName: "Die Geißböcke",
  abbreviation: "KOE",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#ed1c24",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeDiagonal"
  }
}), Fs.set({
  l: "soccer",
  "fc union berlin": "n",
  "union berlin": "s",
  "soccer-fcu": "a"
}, {
  name: "FC Union Berlin",
  shortName: "Union Berlin",
  city: "Berlin",
  nickName: "Die Eisernen",
  abbreviation: "FCU",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#eb1923",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "hannover 96": "n",
  hannover: "s",
  "soccer-h96": "a"
}, {
  name: "Hannover 96",
  shortName: "Hannover",
  city: "Hanover",
  nickName: "Die Roten",
  abbreviation: "H96",
  color: {
    primary: {
      value: "#C73736",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "hertha berlin": "n",
  hertha: "s",
  "soccer-her": "a"
}, {
  name: "Hertha Berlin",
  shortName: "Hertha",
  city: "Berlin",
  nickName: "Die Alte Dame",
  abbreviation: "HER",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#004D9E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  mainz: "n",
  "soccer-m05": "a"
}, {
  name: "Mainz",
  shortName: "Mainz",
  city: "Mainz",
  nickName: "Die Nullfünfer",
  abbreviation: "M05",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#C3141E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "squares"
  }
}), Fs.set({
  l: "soccer",
  nurnberg: "n",
  "soccer-fcn": "a"
}, {
  name: "Nurnberg",
  shortName: "Nurnberg",
  city: "Nuremberg",
  nickName: "Der Club",
  abbreviation: "FCN",
  color: {
    primary: {
      value: "#AD1732",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "rb leipzig": "n",
  leipzig: "s",
  "soccer-rsb": "a"
}, {
  name: "RB Leipzig",
  shortName: "Leipzig",
  city: "Leipzig",
  nickName: "Die Rot",
  abbreviation: "RSB",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#DD013F",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "sc freiburg": "n",
  freiburg: "s",
  "soccer-scf": "a"
}, {
  name: "SC Freiburg",
  shortName: "Freiburg",
  city: "Freiburg",
  nickName: "Die Breisgauer",
  abbreviation: "SCF",
  color: {
    primary: {
      value: "#C63F41",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "sc paderborn 07": "n",
  paderborn: "s",
  "soccer-p07": "a"
}, {
  name: "SC Paderborn 07",
  shortName: "Paderborn",
  city: "Paderborn",
  nickName: "07",
  abbreviation: "P07",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#005CA8",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "fc schalke 04": "n",
  schalke: "s",
  "soccer-s04": "a"
}, {
  name: "FC Schalke 04",
  shortName: "Schalke",
  city: "Gelsenkirchen",
  nickName: "Königsblauen",
  abbreviation: "S04",
  color: {
    primary: {
      value: "#1961B5",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "spvgg greuther furth": "n",
  "greuther fürth": "s",
  "soccer-spv": "a"
}, {
  name: "SpVgg Greuther Furth",
  shortName: "Greuther Fürth",
  city: "Fürth",
  nickName: "Kleeblätter",
  abbreviation: "SPV",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#009932",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesHorizontal"
  }
}), Fs.set({
  l: "soccer",
  "tsg hoffenheim": "n",
  hoffenheim: "s",
  "soccer-tsg": "a"
}, {
  name: "TSG Hoffenheim",
  shortName: "Hoffenheim",
  city: "Sinsheim",
  nickName: "Die Kraichgauer",
  abbreviation: "TSG",
  color: {
    primary: {
      value: "#1961B5",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "vfl bochum": "n",
  bochum: "s",
  "soccer-boc": "a"
}, {
  name: "VfL Bochum",
  shortName: "Bochum",
  city: "Bochum",
  nickName: "Die Unabsteigbaren",
  abbreviation: "BOC",
  color: {
    primary: {
      value: "#005CA9",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "sv darmstadt 98": "n",
  darmstadt: "s",
  "soccer-svd": "a"
}, {
  name: "SV Darmstadt 98",
  shortName: "Darmstadt",
  city: "Darmstadt",
  nickName: "Darmstadt",
  abbreviation: "SVD",
  color: {
    primary: {
      value: "#004F9F",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "vfb stuttgart": "n",
  stuttgart: "s",
  "soccer-vfb": "a"
}, {
  name: "VfB Stuttgart",
  shortName: "Stuttgart",
  city: "Stuttgart",
  nickName: "Die Schwaben",
  abbreviation: "VFB",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#E32219",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  "vfl wolfsburg": "n",
  wolfsburg: "s",
  "soccer-wob": "a"
}, {
  name: "VfL Wolfsburg",
  shortName: "Wolfsburg",
  city: "Wolfsburg",
  nickName: "Die Wölfe",
  abbreviation: "WOB",
  color: {
    primary: {
      value: "#65B32E",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "werder bremen": "n",
  werder: "s",
  "soccer-svw": "a"
}, {
  name: "Werder Bremen",
  shortName: "Werder",
  city: "Bremen",
  nickName: "Werderaner",
  abbreviation: "SVW",
  color: {
    primary: {
      value: "#1D9053",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "fc heidenheim 1846": "n",
  heidenheim: "s",
  "soccer-hdh": "a"
}, {
  name: "FC Heidenheim 1846",
  shortName: "Heidenheim",
  city: "Heidenheim",
  nickName: "Heidenheim",
  abbreviation: "HDH",
  color: {
    primary: {
      value: "#E2001A",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "ac milan": "n",
  "soccer-mil": "a"
}, {
  name: "AC Milan",
  shortName: "AC Milan",
  city: "Milan",
  nickName: "Rossoneri",
  abbreviation: "MIL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FB090B",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "as roma": "n",
  roma: "s",
  "soccer-roma": "a"
}, {
  name: "AS Roma",
  shortName: "Roma",
  city: "Rome",
  nickName: "Giallorossi",
  abbreviation: "ROMA",
  color: {
    primary: {
      value: "#8E1f2f",
      type: "color"
    },
    secondary: {
      value: "#f0bc42",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  atalanta: "n",
  "soccer-ata": "a"
}, {
  name: "Atalanta",
  shortName: "Atalanta",
  city: "Bergamo",
  nickName: "La Dea",
  abbreviation: "ATA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#1e71b8",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "benevento calcio": "n",
  benevento: "s",
  "soccer-ben": "a"
}, {
  name: "Benevento Calcio",
  shortName: "Benevento",
  city: "Benevento",
  nickName: "Stregoni",
  abbreviation: "BEN",
  color: {
    primary: {
      value: "#A5282d",
      type: "color"
    },
    secondary: {
      value: "#ebac3a",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  bologna: "n",
  "soccer-bol": "a"
}, {
  name: "Bologna",
  shortName: "Bologna",
  city: "Bologna",
  nickName: "Rossoblu",
  abbreviation: "BOL",
  color: {
    primary: {
      value: "#1a2f48",
      type: "color"
    },
    secondary: {
      value: "#a21c26",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "brescia calcio": "n",
  brescia: "s",
  "soccer-bre": "a"
}, {
  name: "Brescia Calcio",
  shortName: "Brescia",
  city: "Brescia",
  nickName: "Rondinelle",
  abbreviation: "BRE",
  color: {
    primary: {
      value: "#005ca8",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  cagliari: "n",
  "soccer-cag": "a"
}, {
  name: "Cagliari",
  shortName: "Cagliari",
  city: "Cagliari",
  nickName: "Isolani",
  abbreviation: "CAG",
  color: {
    primary: {
      value: "#002350",
      type: "color"
    },
    secondary: {
      value: "#ad002a",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "half"
  }
}), Fs.set({
  l: "soccer",
  "ac chievoverona": "n",
  chievo: "s",
  "soccer-chv": "a"
}, {
  name: "AC ChievoVerona",
  shortName: "Chievo",
  city: "Chievo",
  nickName: "Gialloblu",
  abbreviation: "CHV",
  color: {
    primary: {
      value: "#0068b0",
      type: "color"
    },
    secondary: {
      value: "#ffe72c",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "us cremonese": "n",
  cremonese: "s",
  "soccer-cre": "a"
}, {
  name: "US Cremonese",
  shortName: "Cremonese",
  city: "Cremona",
  nickName: "Grigiorossi",
  abbreviation: "CRE",
  color: {
    primary: {
      value: "#53606b",
      type: "color"
    },
    secondary: {
      value: "#cd2e22",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "fc crotone": "n",
  crotone: "s",
  "soccer-cro": "a"
}, {
  name: "FC Crotone",
  shortName: "Crotone",
  city: "Crotone",
  nickName: "Pitagorici",
  abbreviation: "CRO",
  color: {
    primary: {
      value: "#323047",
      type: "color"
    },
    secondary: {
      value: "#df4a37",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  empoli: "n",
  "soccer-emp": "a"
}, {
  name: "Empoli",
  shortName: "Empoli",
  city: "Empoli",
  nickName: "Azzurri",
  abbreviation: "EMP",
  color: {
    primary: {
      value: "#00579c",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  fiorentina: "n",
  "soccer-fio": "a"
}, {
  name: "Fiorentina",
  shortName: "Fiorentina",
  city: "Florence",
  nickName: "Viola",
  abbreviation: "FIO",
  color: {
    primary: {
      value: "#483E92",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  frosinone: "n",
  "soccer-fro": "a"
}, {
  name: "Frosinone",
  shortName: "Frosinone",
  city: "Frosinone",
  nickName: "Canarini",
  abbreviation: "FRO",
  color: {
    primary: {
      value: "#edd82b",
      type: "color"
    },
    secondary: {
      value: "#194378",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  genoa: "n",
  "soccer-gen": "a"
}, {
  name: "Genoa",
  shortName: "Genoa",
  city: "Genoa",
  nickName: "Rossoblu",
  abbreviation: "GEN",
  color: {
    primary: {
      value: "#05232f",
      type: "color"
    },
    secondary: {
      value: "#ad1919",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "half"
  }
}), Fs.set({
  l: "soccer",
  "hellas verona": "n",
  verona: "s",
  "soccer-ver": "a"
}, {
  name: "Hellas Verona",
  shortName: "Verona",
  city: "Verona",
  nickName: "Gialloblu",
  abbreviation: "VER",
  color: {
    primary: {
      value: "#005395",
      type: "color"
    },
    secondary: {
      value: "#Ffe74a",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "inter milan": "n",
  inter: "s",
  "soccer-int": "a"
}, {
  name: "Inter Milan",
  shortName: "Inter",
  city: "Milan",
  nickName: "Nerazzurri",
  abbreviation: "INT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#010e80",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  juventus: "n",
  "soccer-juv": "a"
}, {
  name: "Juventus",
  shortName: "Juventus",
  city: "Turin",
  nickName: "Bianconeri",
  abbreviation: "JUV",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  lazio: "n",
  "soccer-laz": "a"
}, {
  name: "Lazio",
  shortName: "Lazio",
  city: "Rome",
  nickName: "Biancocelesti",
  abbreviation: "LAZ",
  color: {
    primary: {
      value: "#87d8f7",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  lecce: "n",
  "soccer-lec": "a"
}, {
  name: "Lecce",
  shortName: "Lecce",
  city: "Lecce",
  nickName: "Giallorossi",
  abbreviation: "LEC",
  color: {
    primary: {
      value: "#fff200",
      type: "color"
    },
    secondary: {
      value: "#ed1b23",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  monza: "n",
  "soccer-mon": "a"
}, {
  name: "Monza",
  shortName: "Monza",
  city: "Monza",
  nickName: "Biancorossi",
  abbreviation: "MON",
  color: {
    primary: {
      value: "#d20606",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  napoli: "n",
  "soccer-nap": "a"
}, {
  name: "Napoli",
  shortName: "Napoli",
  city: "Naples",
  nickName: "Partenopei",
  abbreviation: "NAP",
  color: {
    primary: {
      value: "#12a0d7",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "parma calcio 1913": "n",
  parma: "s",
  "soccer-par": "a"
}, {
  name: "Parma Calcio 1913",
  shortName: "Parma",
  city: "Parma",
  nickName: "Crociati",
  abbreviation: "PAR",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  salernitana: "n",
  "soccer-sal": "a"
}, {
  name: "Salernitana",
  shortName: "Salernitana",
  city: "Salerno",
  nickName: "Granata",
  abbreviation: "SAL",
  color: {
    primary: {
      value: "#953847",
      type: "color"
    },
    secondary: {
      value: "#953847",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  sampdoria: "n",
  "soccer-sam": "a"
}, {
  name: "Sampdoria",
  shortName: "Sampdoria",
  city: "Sampdoria",
  nickName: "Blucerchiati",
  abbreviation: "SAM",
  color: {
    primary: {
      value: "#1b5497",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  sassuolo: "n",
  "soccer-sas": "a"
}, {
  name: "Sassuolo",
  shortName: "Sassuolo",
  city: "Sassuolo",
  nickName: "Neroverdi",
  abbreviation: "SAS",
  color: {
    primary: {
      value: "#00a752",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  spal: "n",
  "soccer-spal": "a"
}, {
  name: "SPAL",
  shortName: "SPAL",
  city: "Ferrara",
  nickName: "Biancazzurri",
  abbreviation: "SPAL",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#3697c4",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "spezia calcio": "n",
  spezia: "s",
  "soccer-spe": "a"
}, {
  name: "Spezia Calcio",
  shortName: "Spezia",
  city: "La Spezia",
  nickName: "Aquilotti",
  abbreviation: "SPE",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  torino: "n",
  "soccer-tor": "a"
}, {
  name: "Torino",
  shortName: "Torino",
  city: "Turin",
  nickName: "Granata",
  abbreviation: "TOR",
  color: {
    primary: {
      value: "#8a1e03",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  udinese: "n",
  "soccer-udi": "a"
}, {
  name: "Udinese",
  shortName: "Udinese",
  city: "Udine",
  nickName: "Bianconeri",
  abbreviation: "UDI",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "venezia fc": "n",
  venezia: "s",
  "soccer-vfc": "a"
}, {
  name: "Venezia FC",
  shortName: "Venezia",
  city: "Venice",
  nickName: "Leoni Alati",
  abbreviation: "VFC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#09611f",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "afc bournemouth": "n",
  bournemouth: "s",
  "soccer-bou": "a"
}, {
  name: "AFC Bournemouth",
  shortName: "Bournemouth",
  city: "Bournemouth",
  nickName: "Cherries",
  abbreviation: "BOU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#BA0F13",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  arsenal: "n",
  "soccer-ars": "a"
}, {
  name: "Arsenal",
  shortName: "Arsenal",
  city: "Arsenal",
  nickName: "Gunners",
  abbreviation: "ARS",
  color: {
    primary: {
      value: "#EF0107",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "aston villa": "n",
  "soccer-avl": "a"
}, {
  name: "Aston Villa",
  shortName: "Aston Villa",
  city: "Aston Villa",
  nickName: "Villans",
  abbreviation: "AVL",
  color: {
    primary: {
      value: "#670E36",
      type: "color"
    },
    secondary: {
      value: "#95BFE5",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  brentford: "n",
  "soccer-bre": "a"
}, {
  name: "Brentford",
  shortName: "Brentford",
  city: "Brentford",
  nickName: "Bees",
  abbreviation: "BRE",
  color: {
    primary: {
      value: "#E30613",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "brighton & hove albion": "n",
  brighton: "s",
  "soccer-bha": "a"
}, {
  name: "Brighton & Hove Albion",
  shortName: "Brighton",
  city: "Brighton",
  nickName: "Seagulls",
  abbreviation: "BHA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#005DAA",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "burnley f.c.": "n",
  burnley: "s",
  "soccer-bur": "a"
}, {
  name: "Burnley F.C.",
  shortName: "Burnley",
  city: "Burnley",
  nickName: "Clarets",
  abbreviation: "BUR",
  color: {
    primary: {
      value: "#630530",
      type: "color"
    },
    secondary: {
      value: "#97D9F6",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "cardiff city": "n",
  cardiff: "s",
  "soccer-car": "a"
}, {
  name: "Cardiff City",
  shortName: "Cardiff",
  city: "Cardiff",
  nickName: "Bluebirds",
  abbreviation: "CAR",
  color: {
    primary: {
      value: "#0070B5",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  chelsea: "n",
  "soccer-che": "a"
}, {
  name: "Chelsea",
  shortName: "Chelsea",
  city: "Chelsea",
  nickName: "Chelsea",
  abbreviation: "CHE",
  color: {
    primary: {
      value: "#034694",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "crystal palace f.c.": "n",
  "crystal palace": "s",
  "soccer-cry": "a"
}, {
  name: "Crystal Palace F.C.",
  shortName: "Crystal Palace",
  city: " Selhurst",
  nickName: "Eagles",
  abbreviation: "CRY",
  color: {
    primary: {
      value: "#1B458F",
      type: "color"
    },
    secondary: {
      value: "#C4122E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "everton f.c.": "n",
  everton: "s",
  "soccer-eve": "a"
}, {
  name: "Everton F.C.",
  shortName: "Everton",
  city: "Liverpool",
  nickName: "Toffees",
  abbreviation: "EVE",
  color: {
    primary: {
      value: "#274488",
      type: "color"
    },
    secondary: {
      value: "#f3f3f3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  fulham: "n",
  "soccer-ful": "a"
}, {
  name: "Fulham",
  shortName: "Fulham",
  city: "Fulham",
  nickName: "Cottagers",
  abbreviation: "FUL",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "huddersfield town": "n",
  huddersfield: "s",
  "soccer-hud": "a"
}, {
  name: "Huddersfield Town",
  shortName: "Huddersfield",
  city: "Huddersfield",
  nickName: "Terriers",
  abbreviation: "HUD",
  color: {
    primary: {
      value: "#2E70BE",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "leeds united": "n",
  leeds: "s",
  "soccer-lee": "a"
}, {
  name: "Leeds United",
  shortName: "Leeds",
  city: "Leeds",
  nickName: "Whites",
  abbreviation: "LEE",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#1D428A",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "leicester city f.c.": "n",
  "leicester city": "s",
  "soccer-lei": "a"
}, {
  name: "Leicester City F.C.",
  shortName: "Leicester City",
  city: "Leicester",
  nickName: "Foxes",
  abbreviation: "LEI",
  color: {
    primary: {
      value: "#0053A0",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  liverpool: "n",
  "soccer-liv": "a"
}, {
  name: "Liverpool",
  shortName: "Liverpool",
  city: "Liverpool",
  nickName: "Reds",
  abbreviation: "LIV",
  color: {
    primary: {
      value: "#D00027",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "luton town": "n",
  luton: "s",
  "soccer-ltn": "a"
}, {
  name: "Luton Town",
  shortName: "Luton",
  city: "Luton",
  nickName: "Hatters",
  abbreviation: "LTN",
  color: {
    primary: {
      value: "#FA4616",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "manchester city": "n",
  "man city": "s",
  "soccer-mnc": "a"
}, {
  name: "Manchester City",
  shortName: "Man City",
  city: "Manchester",
  nickName: "City",
  abbreviation: "MNC",
  color: {
    primary: {
      value: "#97C1E7",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "manchester united": "n",
  "man united": "s",
  "soccer-man": "a"
}, {
  name: "Manchester United",
  shortName: "Man United",
  city: "Manchester",
  nickName: "Red Devils",
  abbreviation: "MAN",
  color: {
    primary: {
      value: "#DA020E",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "newcastle united": "n",
  newcastle: "s",
  "soccer-new": "a"
}, {
  name: "Newcastle United",
  shortName: "Newcastle",
  city: "Newcastle upon Tyne",
  nickName: "Magpies",
  abbreviation: "NEW",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "norwich city": "n",
  norwich: "s",
  "soccer-nor": "a"
}, {
  name: "Norwich City",
  shortName: "Norwich",
  city: "Norwich",
  nickName: "Canaries",
  abbreviation: "NOR",
  color: {
    primary: {
      value: "#FFF200",
      type: "color"
    },
    secondary: {
      value: "#00A650",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "nottingham forest": "n",
  "nott'm forest": "s",
  "soccer-nfo": "a"
}, {
  name: "Nottingham Forest",
  shortName: "Nott'm Forest",
  city: "Nottingham",
  nickName: "Reds",
  abbreviation: "NFO",
  color: {
    primary: {
      value: "#e53233",
      type: "color"
    },
    secondary: {
      value: "#e53233",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "sheffield united": "n",
  "sheffield utd": "s",
  "soccer-shu": "a"
}, {
  name: "Sheffield United",
  shortName: "Sheffield Utd",
  city: "Sheffield",
  nickName: "Blades",
  abbreviation: "SHU",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#EC2227",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  southampton: "n",
  "soccer-sou": "a"
}, {
  name: "Southampton",
  shortName: "Southampton",
  city: "Southampton",
  nickName: "Saints",
  abbreviation: "SOU",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#ED1A3B",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "stoke city": "n",
  stoke: "s",
  "soccer-sto": "a"
}, {
  name: "Stoke City",
  shortName: "Stoke",
  city: "Stoke",
  nickName: "Potters",
  abbreviation: "STO",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#E03A3E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "swansea city": "n",
  swansea: "s",
  "soccer-swa": "a"
}, {
  name: "Swansea City",
  shortName: "Swansea",
  city: "Swansea",
  nickName: "Swans",
  abbreviation: "SWA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "tottenham hotspur": "n",
  tottenham: "s",
  "soccer-tot": "a"
}, {
  name: "Tottenham Hotspur",
  shortName: "Tottenham",
  city: "Tottenham",
  nickName: "Spurs",
  abbreviation: "TOT",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#132257",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  watford: "n",
  "soccer-wat": "a"
}, {
  name: "Watford",
  shortName: "Watford",
  city: "Watford",
  nickName: "Hornets",
  abbreviation: "WAT",
  color: {
    primary: {
      value: "#FBEE23",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "west bromwich albion": "n",
  "west brom": "s",
  "soccer-wba": "a"
}, {
  name: "West Bromwich Albion",
  shortName: "West Brom",
  city: "West Bromwich",
  nickName: "Baggies",
  abbreviation: "WBA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#122F67",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "west ham united": "n",
  "west ham": "s",
  "soccer-whu": "a"
}, {
  name: "West Ham United",
  shortName: "West Ham",
  city: "West Ham",
  nickName: "Hammers",
  abbreviation: "WHU",
  color: {
    primary: {
      value: "#7C2C3B",
      type: "color"
    },
    secondary: {
      value: "#2DAFE6",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "wolverhampton wanderers": "n",
  wolves: "s",
  "soccer-wol": "a"
}, {
  name: "Wolverhampton Wanderers",
  shortName: "Wolves",
  city: "Wolverhampton",
  nickName: "Wolves",
  abbreviation: "WOL",
  color: {
    primary: {
      value: "#FDB913",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "alavés": "n",
  "soccer-ala": "a"
}, {
  name: "Alavés",
  shortName: "Alavés",
  city: "Alavés",
  nickName: "Babazorros",
  abbreviation: "ALA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#0761AF",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "almería": "n",
  "soccer-alm": "a"
}, {
  name: "Almería",
  shortName: "Almería",
  city: "Almería",
  nickName: "Indálicos",
  abbreviation: "ALM",
  color: {
    primary: {
      value: "#EE1119",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "athletic club": "n",
  athletic: "s",
  "soccer-ath": "a"
}, {
  name: "Athletic Club",
  shortName: "Athletic",
  city: "Bilbao",
  nickName: "Leones",
  abbreviation: "ATH",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#EE2523",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "atletico madrid": "n",
  atletico: "s",
  "soccer-atm": "a"
}, {
  name: "Atletico Madrid",
  shortName: "Atletico",
  city: "Madrid",
  nickName: "Colchoneros",
  abbreviation: "ATM",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#CB3524",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  barcelona: "n",
  "soccer-bar": "a"
}, {
  name: "Barcelona",
  shortName: "Barcelona",
  city: "Barcelona",
  nickName: "Blaugrana",
  abbreviation: "BAR",
  color: {
    primary: {
      value: "#004D98",
      type: "color"
    },
    secondary: {
      value: "#A50045",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "cádiz": "n",
  "soccer-cad": "a"
}, {
  name: "Cádiz",
  shortName: "Cádiz",
  city: "Cádiz",
  nickName: "Submarino Amarillo",
  abbreviation: "CAD",
  color: {
    primary: {
      value: "#FDE607",
      type: "color"
    },
    secondary: {
      value: "#FDE607",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "celta vigo": "n",
  celta: "s",
  "soccer-cel": "a"
}, {
  name: "Celta Vigo",
  shortName: "Celta",
  city: "Vigo",
  nickName: "Celtiñas",
  abbreviation: "CEL",
  color: {
    primary: {
      value: "#8AC3EF",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  eibar: "n",
  "soccer-eib": "a"
}, {
  name: "Eibar",
  shortName: "Eibar",
  city: "Eibar",
  nickName: "Armeros",
  abbreviation: "EIB",
  color: {
    primary: {
      value: "#0C2D69",
      type: "color"
    },
    secondary: {
      value: "#AA093C",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  elche: "n",
  "soccer-elc": "a"
}, {
  name: "Elche",
  shortName: "Elche",
  city: "Elche",
  nickName: "Franjiverdes",
  abbreviation: "ELC",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#05642C",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  espanyol: "n",
  "soccer-esp": "a"
}, {
  name: "Espanyol",
  shortName: "Espanyol",
  city: "Barcelona",
  nickName: "Pericos",
  abbreviation: "ESP",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#007FC8",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  getafe: "n",
  "soccer-get": "a"
}, {
  name: "Getafe",
  shortName: "Getafe",
  city: "Getafe",
  nickName: "Azulones",
  abbreviation: "GET",
  color: {
    primary: {
      value: "#005999",
      type: "color"
    },
    secondary: {
      value: "#7DA738",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  girona: "n",
  "soccer-gir": "a"
}, {
  name: "Girona",
  shortName: "Girona",
  city: "Girona",
  nickName: "Blanquivermells",
  abbreviation: "GIR",
  color: {
    primary: {
      value: "#CD2534",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  granada: "n",
  "soccer-gra": "a"
}, {
  name: "Granada",
  shortName: "Granada",
  city: "Granada",
  nickName: "Nazaries",
  abbreviation: "GRA",
  color: {
    primary: {
      value: "#A61B2B",
      type: "color"
    },
    secondary: {
      value: "#F3F3F3",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesHorizontal"
  }
}), Fs.set({
  l: "soccer",
  huesca: "n",
  "soccer-hue": "a"
}, {
  name: "Huesca",
  shortName: "Huesca",
  city: "Huesca",
  nickName: "Oscenses",
  abbreviation: "HUE",
  color: {
    primary: {
      value: "#283380",
      type: "color"
    },
    secondary: {
      value: "#CF122D",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "leganés": "n",
  "soccer-leg": "a"
}, {
  name: "Leganés",
  shortName: "Leganés",
  city: "Leganés",
  nickName: "Pepineros",
  abbreviation: "LEG",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#0C1F6E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  levante: "n",
  "soccer-lev": "a"
}, {
  name: "Levante",
  shortName: "Levante",
  city: "Valencia",
  nickName: "Granotes",
  abbreviation: "LEV",
  color: {
    primary: {
      value: "#005CA5",
      type: "color"
    },
    secondary: {
      value: "#B4053F",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  mallorca: "n",
  "soccer-mll": "a"
}, {
  name: "Mallorca",
  shortName: "Mallorca",
  city: "Palma",
  nickName: "Bermellones",
  abbreviation: "MLL",
  color: {
    primary: {
      value: "#E20613",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  osasuna: "n",
  "soccer-osa": "a"
}, {
  name: "Osasuna",
  shortName: "Osasuna",
  city: "Pamplona",
  nickName: "Rojillos",
  abbreviation: "OSA",
  color: {
    primary: {
      value: "#D91A21",
      type: "color"
    },
    secondary: {
      value: "#0A346F",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "rayo vallecano": "n",
  rayo: "s",
  "soccer-ray": "a"
}, {
  name: "Rayo Vallecano",
  shortName: "Rayo",
  city: "Madrid",
  nickName: "Rayistas",
  abbreviation: "RAY",
  color: {
    primary: {
      value: "#f3f3f3",
      type: "color"
    },
    secondary: {
      value: "#E53027",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeDiagonal"
  }
}), Fs.set({
  l: "soccer",
  "real betis": "n",
  betis: "s",
  "soccer-bet": "a"
}, {
  name: "Real Betis",
  shortName: "Betis",
  city: "Seville",
  nickName: "Verdiblancos",
  abbreviation: "BET",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#0BB363",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "real madrid": "n",
  "soccer-rma": "a"
}, {
  name: "Real Madrid",
  shortName: "Real Madrid",
  city: "Madrid",
  nickName: "Merengues",
  abbreviation: "RMA",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#00529F",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "real sociedad": "n",
  sociedad: "s",
  "soccer-rso": "a"
}, {
  name: "Real Sociedad",
  shortName: "Sociedad",
  city: "San Sebastián",
  nickName: "Txuri-Urdin",
  abbreviation: "RSO",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#0067B1",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "real valladolid": "n",
  valladolid: "s",
  "soccer-vll": "a"
}, {
  name: "Real Valladolid",
  shortName: "Valladolid",
  city: "Valladolid",
  nickName: "Pucela",
  abbreviation: "VLL",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#921B88",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  sevilla: "n",
  "soccer-sev": "a"
}, {
  name: "Sevilla",
  shortName: "Sevilla",
  city: "Seville",
  nickName: "Sevillistas",
  abbreviation: "SEV",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#F43333",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "las palmas": "n",
  "soccer-lpa": "a"
}, {
  name: "Las Palmas",
  shortName: "Las Palmas",
  city: "Las Palmas",
  nickName: "Los Amarillos",
  abbreviation: "LPA",
  color: {
    primary: {
      value: "#ffe400",
      type: "color"
    },
    secondary: {
      value: "#004b9d",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  valencia: "n",
  "soccer-val": "a"
}, {
  name: "Valencia",
  shortName: "Valencia",
  city: "Valencia",
  nickName: "Che",
  abbreviation: "VAL",
  color: {
    primary: {
      value: "#F3F3F3",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  villarreal: "n",
  "soccer-vil": "a"
}, {
  name: "Villarreal",
  shortName: "Villarreal",
  city: "Villarreal",
  nickName: "Submarino Amarillo",
  abbreviation: "VIL",
  color: {
    primary: {
      value: "#FFE667",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "atlanta united fc": "n",
  atlanta: "s",
  "soccer-atl": "a"
}, {
  name: "Atlanta United FC",
  shortName: "Atlanta",
  city: "Atlanta",
  nickName: "Five Stripes",
  abbreviation: "ATL",
  color: {
    primary: {
      value: "#FF4500",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "austin fc": "n",
  austin: "s",
  "soccer-aus": "a"
}, {
  name: "Austin FC",
  shortName: "Austin",
  city: "Austin",
  nickName: "Verde",
  abbreviation: "AUS",
  color: {
    primary: {
      value: "#00A94F",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "chicago fire fc": "n",
  chicago: "s",
  "soccer-chi": "a"
}, {
  name: "Chicago Fire FC",
  shortName: "Chicago",
  city: "Chicago",
  nickName: "Fire",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#141946",
      type: "color"
    },
    secondary: {
      value: "#FF0000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "fc cincinnati": "n",
  cincinnati: "s",
  "soccer-cin": "a"
}, {
  name: "FC Cincinnati",
  shortName: "Cincinnati",
  city: "Cincinnati",
  nickName: "FCC",
  abbreviation: "CIN",
  color: {
    primary: {
      value: "#263B80",
      type: "color"
    },
    secondary: {
      value: "#F05323",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "colorado rapids": "n",
  colorado: "s",
  "soccer-col": "a"
}, {
  name: "Colorado Rapids",
  shortName: "Colorado",
  city: "Commerce City",
  nickName: "Rapids",
  abbreviation: "COL",
  color: {
    primary: {
      value: "#960A2C",
      type: "color"
    },
    secondary: {
      value: "#9CC2EA",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "columbus crew": "n",
  columbus: "s",
  "soccer-clb": "a"
}, {
  name: "Columbus Crew",
  shortName: "Columbus",
  city: "Columbus",
  nickName: "Crew",
  abbreviation: "CLB",
  color: {
    primary: {
      value: "#FEDD00",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "d.c. united": "n",
  "d.c.": "s",
  "soccer-dcu": "a"
}, {
  name: "D.C. United",
  shortName: "D.C.",
  city: "Washington, D.C.",
  nickName: "Black-and-Red",
  abbreviation: "DCU",
  color: {
    primary: {
      value: "#FEFEFE",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "fc dallas": "n",
  dallas: "s",
  "soccer-dal": "a"
}, {
  name: "FC Dallas",
  shortName: "Dallas",
  city: "Frisco",
  nickName: "Toros",
  abbreviation: "DAL",
  color: {
    primary: {
      value: "#E81F3E",
      type: "color"
    },
    secondary: {
      value: "#2A4076",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "houston dynamo fc": "n",
  houston: "s",
  "soccer-hou": "a"
}, {
  name: "Houston Dynamo FC",
  shortName: "Houston",
  city: "Houston",
  nickName: "Dynamo",
  abbreviation: "HOU",
  color: {
    primary: {
      value: "#FF6B00",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "inter miami cf": "n",
  "inter miami": "s",
  "soccer-mia": "a"
}, {
  name: "Inter Miami CF",
  shortName: "Inter Miami",
  city: "Miami",
  nickName: "Herons",
  abbreviation: "MIA",
  color: {
    primary: {
      value: "#F7B5CD",
      type: "color"
    },
    secondary: {
      value: "#231F20",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collar"
  }
}), Fs.set({
  l: "soccer",
  "la galaxy": "n",
  "soccer-lag": "a"
}, {
  name: "LA Galaxy",
  shortName: "LA Galaxy",
  city: "Carson",
  nickName: "Galaxy",
  abbreviation: "LAG",
  color: {
    primary: {
      value: "#FEFEFE",
      type: "color"
    },
    secondary: {
      value: "#00245D",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "los angeles fc": "n",
  "la fc": "s",
  "soccer-lafc": "a"
}, {
  name: "Los Angeles FC",
  shortName: "LA FC",
  city: "Los Angeles",
  nickName: "Black & Gold",
  abbreviation: "LAFC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#C39E6D",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "minnesota united fc": "n",
  minnesota: "s",
  "soccer-min": "a"
}, {
  name: "Minnesota United FC",
  shortName: "Minnesota",
  city: "St. Paul",
  nickName: "Loons",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#8CD2F4",
      type: "color"
    },
    secondary: {
      value: "#E4E5E6",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeVertical"
  }
}), Fs.set({
  l: "soccer",
  "cf montreal impact": "n",
  "cf montreal": "s",
  "soccer-mtl": "a"
}, {
  name: "CF Montreal Impact",
  shortName: "CF Montreal",
  city: "Montreal",
  nickName: "Impact",
  abbreviation: "MTL",
  color: {
    primary: {
      value: "#0033A1",
      type: "color"
    },
    secondary: {
      value: "#9EA1A2",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "nashville sc": "n",
  nashville: "s",
  "soccer-nsh": "a"
}, {
  name: "Nashville SC",
  shortName: "Nashville",
  city: "Nashville",
  nickName: "Boys in Gold",
  abbreviation: "NSH",
  color: {
    primary: {
      value: "#ECE83A",
      type: "color"
    },
    secondary: {
      value: "#1F1646",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripesVertical"
  }
}), Fs.set({
  l: "soccer",
  "new england revolution": "n",
  "new england": "s",
  "soccer-ne": "a"
}, {
  name: "New England Revolution",
  shortName: "New England",
  city: "New England",
  nickName: "Revs",
  abbreviation: "NE",
  color: {
    primary: {
      value: "#0A2240",
      type: "color"
    },
    secondary: {
      value: "#CE0E2D",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "new york city fc": "n",
  "nyc fc": "s",
  "soccer-nyc": "a"
}, {
  name: "New York City FC",
  shortName: "NYC FC",
  city: "New York City",
  nickName: "Blues",
  abbreviation: "NYC",
  color: {
    primary: {
      value: "#6CACE4",
      type: "color"
    },
    secondary: {
      value: "#00285E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "new york red bulls": "n",
  "new york": "s",
  "soccer-ny": "a"
}, {
  name: "New York Red Bulls",
  shortName: "New York",
  city: "Harrison",
  nickName: "Red Bulls",
  abbreviation: "NY",
  color: {
    primary: {
      value: "#ED1E36",
      type: "color"
    },
    secondary: {
      value: "#FEFEFE",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "orlando city sc": "n",
  orlando: "s",
  "soccer-orl": "a"
}, {
  name: "Orlando City SC",
  shortName: "Orlando",
  city: "Orlando",
  nickName: "Lions",
  abbreviation: "ORL",
  color: {
    primary: {
      value: "#633492",
      type: "color"
    },
    secondary: {
      value: "#FEFEFE",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "philadelphia union": "n",
  philadelphia: "s",
  "soccer-phi": "a"
}, {
  name: "Philadelphia Union",
  shortName: "Philadelphia",
  city: "Chester",
  nickName: "Union",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#071B2C",
      type: "color"
    },
    secondary: {
      value: "#B19B69",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "portland timbers": "n",
  portland: "s",
  "soccer-por": "a"
}, {
  name: "Portland Timbers",
  shortName: "Portland",
  city: "Portland",
  nickName: "Timbers",
  abbreviation: "POR",
  color: {
    primary: {
      value: "#00482B",
      type: "color"
    },
    secondary: {
      value: "#D69A00",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "real salt lake": "n",
  "soccer-rsl": "a"
}, {
  name: "Real Salt Lake",
  shortName: "Real Salt Lake",
  city: "Sandy",
  nickName: "Claret and Cobalt",
  abbreviation: "RSL",
  color: {
    primary: {
      value: "#B30838",
      type: "color"
    },
    secondary: {
      value: "#F1CB00",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "san jose earthquakes": "n",
  "san jose": "s",
  "soccer-sj": "a"
}, {
  name: "San Jose Earthquakes",
  shortName: "San Jose",
  city: "San Jose",
  nickName: "Quakes",
  abbreviation: "SJ",
  color: {
    primary: {
      value: "#0067B1",
      type: "color"
    },
    secondary: {
      value: "#FEFEFE",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "seattle sounders fc": "n",
  seattle: "s",
  "soccer-sea": "a"
}, {
  name: "Seattle Sounders FC",
  shortName: "Seattle",
  city: "Seattle",
  nickName: "Sounders",
  abbreviation: "SEA",
  color: {
    primary: {
      value: "#005595",
      type: "color"
    },
    secondary: {
      value: "#5D9741",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarSleeves"
  }
}), Fs.set({
  l: "soccer",
  "sporting kansas city": "n",
  "kansas city": "s",
  "soccer-skc": "a"
}, {
  name: "Sporting Kansas City",
  shortName: "Kansas City",
  city: "Kansas City",
  nickName: "Wizards",
  abbreviation: "SKC",
  color: {
    primary: {
      value: "#002F65",
      type: "color"
    },
    secondary: {
      value: "#FEFEFE",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "toronto fc": "n",
  toronto: "s",
  "soccer-tor": "a"
}, {
  name: "Toronto FC",
  shortName: "Toronto",
  city: "Toronto",
  nickName: "Reds",
  abbreviation: "TOR",
  color: {
    primary: {
      value: "#B81137",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "soccer",
  "vancouver whitecaps fc": "n",
  vancouver: "s",
  "soccer-van": "a"
}, {
  name: "Vancouver Whitecaps FC",
  shortName: "Vancouver",
  city: "Vancouver",
  nickName: "Caps",
  abbreviation: "VAN",
  color: {
    primary: {
      value: "#FEFEFE",
      type: "color"
    },
    secondary: {
      value: "#00245E",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "stripeHorizontal"
  }
}), Fs.set({
  l: "soccer",
  "st. louis city sc": "n",
  "st. louis": "s",
  "soccer-stl": "a"
}, {
  name: "St. Louis City SC",
  shortName: "St. Louis",
  city: "St. Louis",
  nickName: "City",
  abbreviation: "STL",
  color: {
    primary: {
      value: "#E0004D",
      type: "color"
    },
    secondary: {
      value: "#0C2340",
      type: "color"
    }
  },
  attributes: {
    jerseyType: "collarShoulders"
  }
}), Fs.set({
  l: "college",
  "boston college eagles": "n",
  "bc eagles": "s",
  "college-bc": "a"
}, {
  name: "Boston College Eagles",
  shortName: "BC Eagles",
  city: "Boston College",
  nickName: "Eagles",
  abbreviation: "BC",
  color: {
    primary: {
      value: "#98002E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#BC9B6A"
    }
  }
}), Fs.set({
  l: "college",
  "clemson tigers": "n",
  "clem tigers": "s",
  "college-clem": "a"
}, {
  name: "Clemson Tigers",
  shortName: "CLEM Tigers",
  city: "Clemson",
  nickName: "Tigers",
  abbreviation: "CLEM",
  color: {
    primary: {
      value: "#F56600",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "duke blue devils": "n",
  "college-duke": "a"
}, {
  name: "Duke Blue Devils",
  shortName: "DUKE Blue Devils",
  city: "Duke",
  nickName: "Blue Devils",
  abbreviation: "DUKE",
  color: {
    primary: {
      value: "#003087",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "florida state seminoles": "n",
  "fsu seminoles": "s",
  "college-fsu": "a"
}, {
  name: "Florida State Seminoles",
  shortName: "FSU Seminoles",
  city: "Florida State",
  nickName: "Seminoles",
  abbreviation: "FSU",
  color: {
    primary: {
      value: "#782F40",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#A8936B"
    }
  }
}), Fs.set({
  l: "college",
  "georgia tech yellow jackets": "n",
  "gt yellow jackets": "s",
  "college-gt": "a"
}, {
  name: "Georgia Tech Yellow Jackets",
  shortName: "GT Yellow Jackets",
  city: "Georgia Tech",
  nickName: "Yellow Jackets",
  abbreviation: "GT",
  color: {
    primary: {
      value: "#B3A369",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FDB813"
    }
  }
}), Fs.set({
  l: "college",
  "louisville cardinals": "n",
  "lou cardinals": "s",
  "college-lou": "a"
}, {
  name: "Louisville Cardinals",
  shortName: "LOU Cardinals",
  city: "Louisville",
  nickName: "Cardinals",
  abbreviation: "LOU",
  color: {
    primary: {
      value: "#AD0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#070707"
    }
  }
}), Fs.set({
  l: "college",
  "dixie state trailblazers": "n",
  "dix trailblazers": "s",
  "college-dix": "a"
}, {
  name: "Dixie State Trailblazers",
  shortName: "DIX Trailblazers",
  city: "Dixie State",
  nickName: "Trailblazers",
  abbreviation: "DIX",
  color: {
    primary: {
      value: "#BA1C21",
      type: "color"
    },
    secondary: {
      value: "#0C233F",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "miami (fl) hurricanes": "n",
  "mia hurricanes": "s",
  "college-mia": "a"
}, {
  name: "Miami (FL) Hurricanes",
  shortName: "MIA Hurricanes",
  city: "Miami (FL)",
  nickName: "Hurricanes",
  abbreviation: "MIA",
  color: {
    primary: {
      value: "#F47321",
      type: "color"
    },
    secondary: {
      value: "#005030",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "nc state wolfpack": "n",
  "ncst wolfpack": "s",
  "college-ncst": "a",
  "north carolina state wolfpack": "an"
}, {
  name: "NC State Wolfpack",
  alternateNames: ["North Carolina State Wolfpack"],
  shortName: "NCST Wolfpack",
  city: "North Carolina State",
  nickName: "Wolfpack",
  abbreviation: "NCST",
  color: {
    primary: {
      value: "#CC0000",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "long island sharks": "n",
  "liu sharks": "s",
  "college-liu": "a"
}, {
  name: "Long Island Sharks",
  shortName: "LIU Sharks",
  city: "Long Island",
  nickName: "Sharks",
  abbreviation: "LIU",
  color: {
    primary: {
      value: "#69B3E7",
      type: "color"
    },
    secondary: {
      value: "#FFC72C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "bentley falcons": "n",
  "bent falcons": "s",
  "college-bent": "a"
}, {
  name: "Bentley Falcons",
  shortName: "BENT Falcons",
  city: "Falcons",
  nickName: "Falcons",
  abbreviation: "BENT",
  color: {
    primary: {
      value: "#1B5FAA",
      type: "color"
    },
    secondary: {
      value: "#88898A",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "pittsburgh panthers": "n",
  "pitt panthers": "s",
  "college-pitt": "a"
}, {
  name: "Pittsburgh Panthers",
  shortName: "PITT Panthers",
  city: "Pittsburgh",
  nickName: "Panthers",
  abbreviation: "PITT",
  color: {
    primary: {
      value: "#003594",
      type: "color"
    },
    secondary: {
      value: "#FFB81C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "syracuse orange": "n",
  "syr orange": "s",
  "college-syr": "a"
}, {
  name: "Syracuse Orange",
  shortName: "SYR Orange",
  city: "Syracuse",
  nickName: "Orange",
  abbreviation: "SYR",
  color: {
    primary: {
      value: "#F76900",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "north carolina tar heels": "n",
  "unc tar heels": "s",
  "college-unc": "a"
}, {
  name: "North Carolina Tar Heels",
  shortName: "UNC Tar Heels",
  city: "North Carolina",
  nickName: "Tar Heels",
  abbreviation: "UNC",
  color: {
    primary: {
      value: "#7BAFD4",
      type: "color"
    },
    secondary: {
      value: "#13294B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "virginia cavaliers": "n",
  "uva cavaliers": "s",
  "college-uva": "a"
}, {
  name: "Virginia Cavaliers",
  shortName: "UVA Cavaliers",
  city: "Virginia",
  nickName: "Cavaliers",
  abbreviation: "UVA",
  color: {
    primary: {
      value: "#232D4B",
      type: "color"
    },
    secondary: {
      value: "#E57200",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "virginia tech hokies": "n",
  "vt hokies": "s",
  "college-vt": "a"
}, {
  name: "Virginia Tech Hokies",
  shortName: "VT Hokies",
  city: "Virginia Tech",
  nickName: "Hokies",
  abbreviation: "VT",
  color: {
    primary: {
      value: "#630031",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FBB088"
    }
  }
}), Fs.set({
  l: "college",
  "wake forest demon deacons": "n",
  "wake demon deacons": "s",
  "college-wake": "a"
}, {
  name: "Wake Forest Demon Deacons",
  shortName: "WAKE Demon Deacons",
  city: "Wake Forest",
  nickName: "Demon Deacons",
  abbreviation: "WAKE",
  color: {
    primary: {
      value: "#9E7E38",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "illinois fighting illini": "n",
  "ill fighting illini": "s",
  "college-ill": "a"
}, {
  name: "Illinois Fighting Illini",
  shortName: "ILL Fighting Illini",
  city: "Illinois",
  nickName: "Fighting Illini",
  abbreviation: "ILL",
  color: {
    primary: {
      value: "#C84113",
      type: "color"
    },
    secondary: {
      value: "#13294B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "indiana hoosiers": "n",
  "ind hoosiers": "s",
  "college-iu": "a"
}, {
  name: "Indiana Hoosiers",
  shortName: "IND Hoosiers",
  city: "Indiana",
  nickName: "Hoosiers",
  abbreviation: "IU",
  color: {
    primary: {
      value: "#990000",
      type: "color"
    },
    secondary: {
      value: "#EDEBEB",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "iowa hawkeyes": "n",
  "college-iowa": "a"
}, {
  name: "Iowa Hawkeyes",
  shortName: "IOWA Hawkeyes",
  city: "Iowa",
  nickName: "Hawkeyes",
  abbreviation: "IOWA",
  color: {
    primary: {
      value: "#FFCD00",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "michigan wolverines": "n",
  "mich wolverines": "s",
  "college-mich": "a"
}, {
  name: "Michigan Wolverines",
  shortName: "MICH Wolverines",
  city: "Michigan",
  nickName: "Wolverines",
  abbreviation: "MICH",
  color: {
    primary: {
      value: "#00274c",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FAC417"
    }
  }
}), Fs.set({
  l: "college",
  "michigan state spartans": "n",
  "msu spartans": "s",
  "college-msu": "a"
}, {
  name: "Michigan State Spartans",
  shortName: "MSU Spartans",
  city: "Michigan State",
  nickName: "Spartans",
  abbreviation: "MSU",
  color: {
    primary: {
      value: "#18453B",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "minnesota golden gophers": "n",
  "minn golden gophers": "s",
  "college-minn": "a"
}, {
  name: "Minnesota Golden Gophers",
  shortName: "MINN Golden Gophers",
  city: "Minnesota",
  nickName: "Golden Gophers",
  abbreviation: "MINN",
  color: {
    primary: {
      value: "#7a0019",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#ffcc33"
    }
  }
}), Fs.set({
  l: "college",
  "nebraska cornhuskers": "n",
  "neb cornhuskers": "s",
  "college-neb": "a"
}, {
  name: "Nebraska Cornhuskers",
  shortName: "NEB Cornhuskers",
  city: "Nebraska",
  nickName: "Cornhuskers",
  abbreviation: "NEB",
  color: {
    primary: {
      value: "#e41c38",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "northwestern wildcats": "n",
  "nu wildcats": "s",
  "college-nu": "a"
}, {
  name: "Northwestern Wildcats",
  shortName: "NU Wildcats",
  city: "Northwestern",
  nickName: "Wildcats",
  abbreviation: "NU",
  color: {
    primary: {
      value: "#4E2A84",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oregon state beavers": "n",
  "osu beavers": "s",
  "college-osu": "a"
}, {
  name: "Oregon State Beavers",
  shortName: "OSU Beavers",
  city: "Oregon State",
  nickName: "Beavers",
  abbreviation: "OSU",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      value: "#A7B1B7",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "penn state nittany lions": "n",
  "psu nittany lions": "s",
  "college-psu": "a"
}, {
  name: "Penn State Nittany Lions",
  shortName: "PSU Nittany Lions",
  city: "Penn State",
  nickName: "Nittany Lions",
  abbreviation: "PSU",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "purdue boilermakers": "n",
  "pur boilermakers": "s",
  "college-pur": "a"
}, {
  name: "Purdue Boilermakers",
  shortName: "PUR Boilermakers",
  city: "Purdue",
  nickName: "Boilermakers",
  abbreviation: "PUR",
  color: {
    primary: {
      value: "#cfb991",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "rutgers scarlet knights": "n",
  "rutg scarlet knights": "s",
  "college-rutg": "a"
}, {
  name: "Rutgers Scarlet Knights",
  shortName: "RUTG Scarlet Knights",
  city: "Rutgers",
  nickName: "Scarlet Knights",
  abbreviation: "RUTG",
  color: {
    primary: {
      value: "#cc0033",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "maryland terrapins": "n",
  "umd terrapins": "s",
  "college-umd": "a"
}, {
  name: "Maryland Terrapins",
  shortName: "UMD Terrapins",
  city: "Maryland",
  nickName: "Terrapins",
  abbreviation: "UMD",
  color: {
    primary: {
      value: "#E03a3e",
      type: "color"
    },
    secondary: {
      value: "#ffd200",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "wisconsin badgers": "n",
  "wis badgers": "s",
  "college-wis": "a"
}, {
  name: "Wisconsin Badgers",
  shortName: "WIS Badgers",
  city: "Wisconsin",
  nickName: "Badgers",
  abbreviation: "WIS",
  color: {
    primary: {
      value: "#c5050c",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "baylor bears": "n",
  "bay bears": "s",
  "college-bay": "a"
}, {
  name: "Baylor Bears",
  shortName: "BAY Bears",
  city: "Baylor",
  nickName: "Bears",
  abbreviation: "BAY",
  color: {
    primary: {
      value: "#154734",
      type: "color"
    },
    secondary: {
      value: "#FFB81C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "iowa state cyclones": "n",
  "isu cyclones": "s",
  "college-isu": "a"
}, {
  name: "Iowa State Cyclones",
  shortName: "ISU Cyclones",
  city: "Iowa State",
  nickName: "Cyclones",
  abbreviation: "ISU",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      value: "#F1BE48",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "kansas jayhawks": "n",
  "ku jayhawks": "s",
  "college-ku": "a"
}, {
  name: "Kansas Jayhawks",
  shortName: "KU Jayhawks",
  city: "Kansas",
  nickName: "Jayhawks",
  abbreviation: "KU",
  color: {
    primary: {
      value: "#0051BA",
      type: "color"
    },
    secondary: {
      value: "#e8000d",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "kansas state wildcats": "n",
  "ksu wildcats": "s",
  "college-ksu": "a"
}, {
  name: "Kansas State Wildcats",
  shortName: "KSU Wildcats",
  city: "Kansas State",
  nickName: "Wildcats",
  abbreviation: "KSU",
  color: {
    primary: {
      value: "#512888",
      type: "color"
    },
    secondary: {
      value: "#D1D1D1",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oklahoma sooners": "n",
  "ou sooners": "s",
  "college-ou": "a"
}, {
  name: "Oklahoma Sooners",
  shortName: "OU Sooners",
  city: "Oklahoma",
  nickName: "Sooners",
  abbreviation: "OU",
  color: {
    primary: {
      value: "#841617",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oklahoma state cowboys": "n",
  "okst cowboys": "s",
  "college-okst": "a"
}, {
  name: "Oklahoma State Cowboys",
  shortName: "OKST Cowboys",
  city: "Oklahoma State",
  nickName: "Cowboys",
  abbreviation: "OKST",
  color: {
    primary: {
      value: "#FF7300",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "tcu horned frogs": "n",
  "college-tcu": "a"
}, {
  name: "TCU Horned Frogs",
  shortName: "TCU Horned Frogs",
  city: "TCU",
  nickName: "Horned Frogs",
  abbreviation: "TCU",
  color: {
    primary: {
      value: "#4d1979",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "texas longhorns": "n",
  "ut longhorns": "s",
  "college-tex": "a"
}, {
  name: "Texas Longhorns",
  shortName: "UT Longhorns",
  city: "Texas",
  nickName: "Longhorns",
  abbreviation: "TEX",
  color: {
    primary: {
      value: "#bf5700",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "texas tech red raiders": "n",
  "ttu red raiders": "s",
  "college-ttu": "a"
}, {
  name: "Texas Tech Red Raiders",
  shortName: "TTU Red Raiders",
  city: "Texas Tech",
  nickName: "Red Raiders",
  abbreviation: "TTU",
  color: {
    primary: {
      value: "#CC0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "west virginia mountaineers": "n",
  "wvu mountaineers": "s",
  "college-wvu": "a"
}, {
  name: "West Virginia Mountaineers",
  shortName: "WVU Mountaineers",
  city: "West Virginia",
  nickName: "Mountaineers",
  abbreviation: "WVU",
  color: {
    primary: {
      value: "#002855",
      type: "color"
    },
    secondary: {
      value: "#EAAA00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "arizona wildcats": "n",
  "ariz wildcats": "s",
  "college-ariz": "a"
}, {
  name: "Arizona Wildcats",
  shortName: "ARIZ Wildcats",
  city: "Arizona",
  nickName: "Wildcats",
  abbreviation: "ARIZ",
  color: {
    primary: {
      value: "#CC0033",
      type: "color"
    },
    secondary: {
      value: "#0C234B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "arizona state sun devils": "n",
  "asu sun devils": "s",
  "college-asu": "a"
}, {
  name: "Arizona State Sun Devils",
  shortName: "ASU Sun Devils",
  city: "Arizona State",
  nickName: "Sun Devils",
  abbreviation: "ASU",
  color: {
    primary: {
      value: "#8C1D40",
      type: "color"
    },
    secondary: {
      value: "#FFC627",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "california golden bears": "n",
  "cal golden bears": "s",
  "college-cal": "a"
}, {
  name: "California Golden Bears",
  shortName: "CAL Golden Bears",
  city: "CAL",
  nickName: "Golden Bears",
  abbreviation: "CAL",
  color: {
    primary: {
      value: "#003262",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFDE30"
    }
  }
}), Fs.set({
  l: "college",
  "colorado buffaloes": "n",
  "colo buffaloes": "s",
  "college-colo": "a"
}, {
  name: "Colorado Buffaloes",
  shortName: "COLO Buffaloes",
  city: "Colorado",
  nickName: "Buffaloes",
  abbreviation: "COLO",
  color: {
    primary: {
      value: "#CFB87C",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oregon ducks": "n",
  "ore ducks": "s",
  "college-ore": "a"
}, {
  name: "Oregon Ducks",
  shortName: "ORE Ducks",
  city: "Oregon",
  nickName: "Ducks",
  abbreviation: "ORE",
  color: {
    primary: {
      value: "#154733",
      type: "color"
    },
    secondary: {
      value: "#FEE11A",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "stanford cardinal": "n",
  "stan cardinal": "s",
  "college-stan": "a"
}, {
  name: "Stanford Cardinal",
  shortName: "STAN Cardinal",
  city: "Stanford",
  nickName: "Cardinal",
  abbreviation: "STAN",
  color: {
    primary: {
      value: "#8C1515",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "ucla bruins": "n",
  "college-ucla": "a"
}, {
  name: "UCLA Bruins",
  shortName: "UCLA Bruins",
  city: "UCLA",
  nickName: "Bruins",
  abbreviation: "UCLA",
  color: {
    primary: {
      value: "#2774AE",
      type: "color"
    },
    secondary: {
      value: "#FFD100",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "usc trojans": "n",
  "college-usc": "a"
}, {
  name: "USC Trojans",
  shortName: "USC Trojans",
  city: "USC",
  nickName: "Trojans",
  abbreviation: "USC",
  color: {
    primary: {
      value: "#990000",
      type: "color"
    },
    secondary: {
      value: "#FFCC00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "utah utes": "n",
  "college-utah": "a"
}, {
  name: "Utah Utes",
  shortName: "UTAH Utes",
  city: "Utah",
  nickName: "Utes",
  abbreviation: "UTAH",
  color: {
    primary: {
      value: "#CC0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "washington huskies": "n",
  "wash huskies": "s",
  "college-wash": "a"
}, {
  name: "Washington Huskies",
  shortName: "WASH Huskies",
  city: "Washington",
  nickName: "Huskies",
  abbreviation: "WASH",
  color: {
    primary: {
      value: "#4B2E83",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#E8D4A3"
    }
  }
}), Fs.set({
  l: "college",
  "washington state cougars": "n",
  "wsu cougars": "s",
  "college-wsu": "a"
}, {
  name: "Washington State Cougars",
  shortName: "WSU Cougars",
  city: "Washington State",
  nickName: "Cougars",
  abbreviation: "WSU",
  color: {
    primary: {
      value: "#981E32",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "alabama crimson tide": "n",
  "ala crimson tide": "s",
  "college-ala": "a"
}, {
  name: "Alabama Crimson Tide",
  shortName: "ALA Crimson Tide",
  city: "Alabama",
  nickName: "Crimson Tide",
  abbreviation: "ALA",
  color: {
    primary: {
      value: "#9e1b32",
      type: "color"
    },
    secondary: {
      value: "#828a8f",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "arkansas razorbacks": "n",
  "ark razorbacks": "s",
  "college-ark": "a"
}, {
  name: "Arkansas Razorbacks",
  shortName: "ARK Razorbacks",
  city: "Arkansas",
  nickName: "Razorbacks",
  abbreviation: "ARK",
  color: {
    primary: {
      value: "#9D2235",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "auburn tigers": "n",
  "aub tigers": "s",
  "college-aub": "a"
}, {
  name: "Auburn Tigers",
  shortName: "AUB Tigers",
  city: "Auburn",
  nickName: "Tigers",
  abbreviation: "AUB",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      value: "#dd550c",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "florida gators": "n",
  "uf gators": "s",
  "college-uf": "a"
}, {
  name: "Florida Gators",
  shortName: "UF Gators",
  city: "Florida",
  nickName: "Gators",
  abbreviation: "UF",
  color: {
    primary: {
      value: "#0021A5",
      type: "color"
    },
    secondary: {
      value: "#fa4616",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "georgia bulldogs": "n",
  "uga bulldogs": "s",
  "college-uga": "a"
}, {
  name: "Georgia Bulldogs",
  shortName: "UGA Bulldogs",
  city: "Georgia",
  nickName: "Bulldogs",
  abbreviation: "UGA",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "kentucky wildcats": "n",
  "uk wildcats": "s",
  "college-uk": "a"
}, {
  name: "Kentucky Wildcats",
  shortName: "UK Wildcats",
  city: "Kentucky",
  nickName: "Wildcats",
  abbreviation: "UK",
  color: {
    primary: {
      value: "#0033a0",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "lsu tigers": "n",
  "college-lsu": "a"
}, {
  name: "LSU Tigers",
  shortName: "LSU Tigers",
  city: "LSU",
  nickName: "Tigers",
  abbreviation: "LSU",
  color: {
    primary: {
      value: "#461D7C",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FDB827"
    }
  }
}), Fs.set({
  l: "college",
  "ole miss rebels": "n",
  "miss rebels": "s",
  "college-miss": "a"
}, {
  name: "Ole Miss Rebels",
  shortName: "MISS Rebels",
  city: "Ole Miss",
  nickName: "Rebels",
  abbreviation: "MISS",
  color: {
    primary: {
      value: "#CE1126",
      type: "color"
    },
    secondary: {
      value: "#14213D",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "mississippi state bulldogs": "n",
  "msst bulldogs": "s",
  "college-msst": "a"
}, {
  name: "Mississippi State Bulldogs",
  shortName: "MSST Bulldogs",
  city: "Mississippi State",
  nickName: "Bulldogs",
  abbreviation: "MSST",
  color: {
    primary: {
      value: "#660000",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "missouri tigers": "n",
  "mu tigers": "s",
  "college-mu": "a",
  "mizzou tigers": "an"
}, {
  name: "Missouri Tigers",
  alternateNames: ["Mizzou Tigers"],
  shortName: "MU Tigers",
  city: "Missouri",
  nickName: "Tigers",
  abbreviation: "MU",
  color: {
    primary: {
      value: "#F1B82D",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "south carolina gamecocks": "n",
  "sc gamecocks": "s",
  "college-sc": "a"
}, {
  name: "South Carolina Gamecocks",
  shortName: "SC Gamecocks",
  city: "South Carolina",
  nickName: "Gamecocks",
  abbreviation: "SC",
  color: {
    primary: {
      value: "#73000A",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "tennessee volunteers": "n",
  "tenn volunteers": "s",
  "college-tenn": "a"
}, {
  name: "Tennessee Volunteers",
  shortName: "TENN Volunteers",
  city: "Tennessee",
  nickName: "Volunteers",
  abbreviation: "TENN",
  color: {
    primary: {
      value: "#FF8200",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "texas a&m aggies": "n",
  "a&m aggies": "s",
  "college-a&m": "a",
  "txa&m aggies": "an",
  "ta&m aggies": "an"
}, {
  name: "Texas A&M Aggies",
  alternateNames: ["TXA&M Aggies", "TA&M Aggies"],
  shortName: "A&M Aggies",
  city: "Texas A&M",
  nickName: "Aggies",
  abbreviation: "A&M",
  color: {
    primary: {
      value: "#500000",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "vanderbilt commodores": "n",
  "van commodores": "s",
  "college-van": "a"
}, {
  name: "Vanderbilt Commodores",
  shortName: "VAN Commodores",
  city: "Vanderbilt",
  nickName: "Commodores",
  abbreviation: "VAN",
  color: {
    primary: {
      value: "#866d4b",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "byu cougars": "n",
  "college-byu": "a",
  "brigham young cougars": "an",
  "brigham young": "an"
}, {
  name: "BYU Cougars",
  alternateNames: ["Brigham Young Cougars", "Brigham Young"],
  shortName: "BYU Cougars",
  city: "BYU",
  nickName: "Cougars",
  abbreviation: "BYU",
  color: {
    primary: {
      value: "#002E5D",
      type: "color"
    },
    secondary: {
      value: "#0062B8",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "army black knights": "n",
  "college-army": "a"
}, {
  name: "Army Black Knights",
  shortName: "ARMY Black Knights",
  city: "Army",
  nickName: "Black Knights",
  abbreviation: "ARMY",
  color: {
    primary: {
      value: "#D4BF91",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "massachusetts minutemen": "n",
  "umass minutemen": "s",
  "college-umass": "a"
}, {
  name: "Massachusetts Minutemen",
  shortName: "UMASS Minutemen",
  city: "Massachusetts",
  nickName: "Minutemen",
  abbreviation: "UMASS",
  color: {
    primary: {
      value: "#003DA5",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "notre dame fighting irish": "n",
  "nd fighting irish": "s",
  "college-nd": "a"
}, {
  name: "Notre Dame Fighting Irish",
  shortName: "ND Fighting Irish",
  city: "Notre Dame",
  nickName: "Fighting Irish",
  abbreviation: "ND",
  color: {
    primary: {
      value: "#C99700",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#0C2340"
    }
  }
}), Fs.set({
  l: "college",
  "cincinnati bearcats": "n",
  "cin bearcats": "s",
  "college-cin": "a"
}, {
  name: "Cincinnati Bearcats",
  shortName: "CIN Bearcats",
  city: "Cincinnati",
  nickName: "Bearcats",
  abbreviation: "CIN",
  color: {
    primary: {
      value: "#E00122",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "dallas baptist patriots": "n",
  "dbu patriots": "s",
  "college-dbu": "a"
}, {
  name: "Dallas Baptist Patriots",
  shortName: "DBU Patriots",
  city: "Dallas Baptist",
  nickName: "Patriots",
  abbreviation: "DBU",
  color: {
    primary: {
      value: "#C41230",
      type: "color"
    },
    secondary: {
      value: "#0B1F2C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "tarleton state texans": "n",
  "ts texans": "s",
  "college-ts": "a"
}, {
  name: "Tarleton State Texans",
  shortName: "TS Texans",
  city: "Tarleton State",
  nickName: "Texans",
  abbreviation: "TS",
  color: {
    primary: {
      value: "#5A2B81",
      type: "color"
    },
    secondary: {
      value: "#F6f6f6",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "mercyhurst lakers": "n",
  "mer lakers": "s",
  "college-mer": "a"
}, {
  name: "Mercyhurst Lakers",
  shortName: "MER Lakers",
  city: "Mercyhurst",
  nickName: "Lakers",
  abbreviation: "MER",
  color: {
    primary: {
      value: "#07594D",
      type: "color"
    },
    secondary: {
      value: "#182752",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "american international yellow jackets": "n",
  "aic yellow jackets": "s",
  "college-aic": "a"
}, {
  name: "American International Yellow Jackets",
  shortName: "AIC Yellow Jackets",
  city: "American International",
  nickName: "Yellow Jackets",
  abbreviation: "AIC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFB60F",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "augustana vikings": "n",
  "aug vikings": "s",
  "college-aug": "a"
}, {
  name: "Augustana Vikings",
  shortName: "AUG Vikings",
  city: "Augustana",
  nickName: "Vikings",
  abbreviation: "AUG",
  color: {
    primary: {
      value: "#0E1B3B",
      type: "color"
    },
    secondary: {
      value: "#FCD006",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "connecticut huskies": "n",
  "uconn huskies": "s",
  "college-conn": "a"
}, {
  name: "Connecticut Huskies",
  shortName: "UCONN Huskies",
  city: "Connecticut",
  nickName: "Huskies",
  abbreviation: "CONN",
  color: {
    primary: {
      value: "#000E2F",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "east carolina pirates": "n",
  "ecu pirates": "s",
  "college-ecu": "a"
}, {
  name: "East Carolina Pirates",
  shortName: "ECU Pirates",
  city: "Eastern Carolina",
  nickName: "Pirates",
  abbreviation: "ECU",
  color: {
    primary: {
      value: "#592A8A",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCE28"
    }
  }
}), Fs.set({
  l: "college",
  "houston cougars": "n",
  "hou cougars": "s",
  "college-hou": "a"
}, {
  name: "Houston Cougars",
  shortName: "HOU Cougars",
  city: "Houston",
  nickName: "Cougars",
  abbreviation: "HOU",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "memphis tigers": "n",
  "mem tigers": "s",
  "college-mem": "a"
}, {
  name: "Memphis Tigers",
  shortName: "MEM Tigers",
  city: "Memphis",
  nickName: "Tigers",
  abbreviation: "MEM",
  color: {
    primary: {
      value: "#003087",
      type: "color"
    },
    secondary: {
      value: "#94948f",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "navy midshipmen": "n",
  "college-navy": "a"
}, {
  name: "Navy Midshipmen",
  shortName: "NAVY Midshipmen",
  city: "Navy",
  nickName: "Midshipmen",
  abbreviation: "NAVY",
  color: {
    primary: {
      value: "#00205B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FCBA29"
    }
  }
}), Fs.set({
  l: "college",
  "smu mustangs": "n",
  "college-smu": "a"
}, {
  name: "SMU Mustangs",
  shortName: "SMU Mustangs",
  city: "Southern Methodist",
  nickName: "Mustangs",
  abbreviation: "SMU",
  color: {
    primary: {
      value: "#0033A0",
      type: "color"
    },
    secondary: {
      value: "#C8102E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "south florida bulls": "n",
  "usf bulls": "s",
  "college-usf": "a"
}, {
  name: "South Florida Bulls",
  shortName: "USF Bulls",
  city: "South Florida",
  nickName: "Bulls",
  abbreviation: "USF",
  color: {
    primary: {
      value: "#006747",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "temple owls": "n",
  "tem owls": "s",
  "college-tem": "a"
}, {
  name: "Temple Owls",
  shortName: "TEM Owls",
  city: "Temple",
  nickName: "Owls",
  abbreviation: "TEM",
  color: {
    primary: {
      value: "#9D2235",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "tulane green wave": "n",
  "tuln green wave": "s",
  "college-tuln": "a"
}, {
  name: "Tulane Green Wave",
  shortName: "TULN Green Wave",
  city: "Tulane",
  nickName: "Green Wave",
  abbreviation: "TULN",
  color: {
    primary: {
      value: "#006747",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "tulsa golden hurricane": "n",
  "tlsa golden hurricane": "s",
  "college-tlsa": "a"
}, {
  name: "Tulsa Golden Hurricane",
  shortName: "TLSA Golden Hurricane",
  city: "Tulsa",
  nickName: "Golden Hurricane",
  abbreviation: "TLSA",
  color: {
    primary: {
      value: "#002D72",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "ucf knights": "n",
  "college-ucf": "a",
  "university of central florida knights": "an"
}, {
  name: "UCF Knights",
  alternateNames: ["University of Central Florida Knights"],
  shortName: "UCF Knights",
  city: "UCF",
  nickName: "Knights",
  abbreviation: "UCF",
  color: {
    primary: {
      value: "#FFC904",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#B4985A"
    }
  }
}), Fs.set({
  l: "college",
  "charlotte 49ers": "n",
  "char 49ers": "s",
  "college-clt": "a"
}, {
  name: "Charlotte 49ers",
  shortName: "CHAR 49ers",
  city: "Charlotte",
  nickName: "49ers",
  abbreviation: "CLT",
  color: {
    primary: {
      value: "#046A38",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "florida atlantic owls": "n",
  "fau owls": "s",
  "college-fau": "a"
}, {
  name: "Florida Atlantic Owls",
  shortName: "FAU Owls",
  city: "Florida Atlantic",
  nickName: "Owls",
  abbreviation: "FAU",
  color: {
    primary: {
      value: "#003366",
      type: "color"
    },
    secondary: {
      value: "#cc0000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "catawba college": "n",
  catawba: "s",
  "college-cat": "a"
}, {
  name: "Catawba College",
  shortName: "Catawba",
  city: "Catawba",
  nickName: "Indians",
  preferredNickName: "Catawba",
  abbreviation: "CAT",
  color: {
    primary: {
      value: "#002969",
      type: "color"
    },
    secondary: {
      value: "#CF142B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "miami (oh) redhawks": "n",
  "m-oh redhawks": "s",
  "college-m-oh": "a"
}, {
  name: "Miami (OH) Redhawks",
  shortName: "M-OH Redhawks",
  city: "Miami (OH)",
  nickName: "Redhawks",
  abbreviation: "M-OH",
  color: {
    primary: {
      value: "#B61E2E",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "florida international panthers": "n",
  "fiu panthers": "s",
  "college-fiu": "a"
}, {
  name: "Florida International Panthers",
  shortName: "FIU Panthers",
  city: "FIU",
  nickName: "Panthers",
  abbreviation: "FIU",
  color: {
    primary: {
      value: "#081E3F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#B6862C"
    }
  }
}), Fs.set({
  l: "college",
  "louisiana tech bulldogs": "n",
  "lt bulldogs": "s",
  "college-lt": "a"
}, {
  name: "Louisiana Tech Bulldogs",
  shortName: "LT Bulldogs",
  city: "Louisiana Tech",
  nickName: "Bulldogs",
  abbreviation: "LT",
  color: {
    primary: {
      value: "#002F8B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#ED1C24"
    }
  }
}), Fs.set({
  l: "college",
  "marshall thundering herd": "n",
  "mrsh thundering herd": "s",
  "college-mrsh": "a"
}, {
  name: "Marshall Thundering Herd",
  shortName: "MRSH Thundering Herd",
  city: "Marshall",
  nickName: "Thundering Herd",
  abbreviation: "MRSH",
  color: {
    primary: {
      value: "#00B140",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "middle tennessee blue raiders": "n",
  "mtsu blue raiders": "s",
  "college-mtsu": "a"
}, {
  name: "Middle Tennessee Blue Raiders",
  shortName: "MTSU Blue Raiders",
  city: "Middle Tennessee",
  nickName: "Blue Raiders",
  abbreviation: "MTSU",
  color: {
    primary: {
      value: "#0066CC",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "north texas mean green": "n",
  "unt mean green": "s",
  "college-unt": "a"
}, {
  name: "North Texas Mean Green",
  shortName: "UNT Mean Green",
  city: "North Texas",
  nickName: "Mean Green",
  abbreviation: "UNT",
  color: {
    primary: {
      value: "#00853E",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "old dominion monarchs": "n",
  "odu monarchs": "s",
  "college-odu": "a"
}, {
  name: "Old Dominion Monarchs",
  shortName: "ODU Monarchs",
  city: "Old Dominion",
  nickName: "Monarchs",
  abbreviation: "ODU",
  color: {
    primary: {
      value: "#003057",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FBFBFB"
    }
  }
}), Fs.set({
  l: "college",
  "rice owls": "n",
  "college-rice": "a"
}, {
  name: "Rice Owls",
  shortName: "RICE Owls",
  city: "Rice",
  nickName: "Owls",
  abbreviation: "RICE",
  color: {
    primary: {
      value: "#00205B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "southern miss golden eagles": "n",
  "usm golden eagles": "s",
  "college-usm": "a"
}, {
  name: "Southern Miss Golden Eagles",
  shortName: "USM Golden Eagles",
  city: "Southern Miss",
  nickName: "Golden Eagles",
  abbreviation: "USM",
  color: {
    primary: {
      value: "#FFAB00",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#201C1D"
    }
  }
}), Fs.set({
  l: "college",
  "utep miners": "n",
  "college-utep": "a"
}, {
  name: "UTEP Miners",
  shortName: "UTEP Miners",
  city: "UTEP",
  nickName: "Miners",
  abbreviation: "UTEP",
  color: {
    primary: {
      value: "#FF8200",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#041E42"
    }
  }
}), Fs.set({
  l: "college",
  "utsa roadrunners": "n",
  "college-utsa": "a",
  "university of texas at san antonio": "an"
}, {
  name: "UTSA Roadrunners",
  alternateNames: ["University of Texas at San Antonio"],
  shortName: "UTSA Roadrunners",
  city: "UTSA",
  nickName: "Roadrunners",
  abbreviation: "UTSA",
  color: {
    primary: {
      value: "#f15a22",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#0C2340"
    }
  }
}), Fs.set({
  l: "college",
  "western kentucky hilltoppers": "n",
  "wku hilltoppers": "s",
  "college-wku": "a"
}, {
  name: "Western Kentucky Hilltoppers",
  shortName: "WKU Hilltoppers",
  city: "Western Kentucky",
  nickName: "Hilltoppers",
  abbreviation: "WKU",
  color: {
    primary: {
      value: "#c60c30",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#010000"
    }
  }
}), Fs.set({
  l: "college",
  "akron zips": "n",
  "akr zips": "s",
  "college-akr": "a"
}, {
  name: "Akron Zips",
  shortName: "AKR Zips",
  city: "Akron",
  nickName: "Zips",
  abbreviation: "AKR",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#C29C41"
    }
  }
}), Fs.set({
  l: "college",
  "ball state cardinals": "n",
  "ball cardinals": "s",
  "college-ball": "a"
}, {
  name: "Ball State Cardinals",
  shortName: "BALL Cardinals",
  city: "Ball State",
  nickName: "Cardinals",
  abbreviation: "BALL",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "bowling green falcons": "n",
  "bgsu falcons": "s",
  "college-bgsu": "a"
}, {
  name: "Bowling Green Falcons",
  shortName: "BGSU Falcons",
  city: "Bowling Green",
  nickName: "Falcons",
  abbreviation: "BGSU",
  color: {
    primary: {
      value: "#FE5000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#4f2c1d"
    }
  }
}), Fs.set({
  l: "college",
  "buffalo bulls": "n",
  "buff bulls": "s",
  "college-buff": "a"
}, {
  name: "Buffalo Bulls",
  shortName: "BUFF Bulls",
  city: "Buffalo",
  nickName: "Bulls",
  abbreviation: "BUFF",
  color: {
    primary: {
      value: "#00338D",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#C60C30"
    }
  }
}), Fs.set({
  l: "college",
  "central michigan chippewas": "n",
  "cmu chippewas": "s",
  "college-cmu": "a"
}, {
  name: "Central Michigan Chippewas",
  shortName: "CMU Chippewas",
  city: "Central Michigan",
  nickName: "Chippewas",
  abbreviation: "CMU",
  color: {
    primary: {
      value: "#6A0032",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "eastern michigan eagles": "n",
  "emu eagles": "s",
  "college-emu": "a"
}, {
  name: "Eastern Michigan Eagles",
  shortName: "EMU Eagles",
  city: "Eastern Michigan",
  nickName: "Eagles",
  abbreviation: "EMU",
  color: {
    primary: {
      value: "#006633",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "kent state golden flashes": "n",
  "kent golden flashes": "s",
  "college-kent": "a"
}, {
  name: "Kent State Golden Flashes",
  shortName: "KENT Golden Flashes",
  city: "Kent State",
  nickName: "Golden Flashes",
  abbreviation: "KENT",
  color: {
    primary: {
      value: "#002664",
      type: "color"
    },
    secondary: {
      value: "#eaab00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "northern illinois huskies": "n",
  "niu huskies": "s",
  "college-niu": "a"
}, {
  name: "Northern Illinois Huskies",
  shortName: "NIU Huskies",
  city: "Northern Illinois",
  nickName: "Huskies",
  abbreviation: "NIU",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#080808"
    }
  }
}), Fs.set({
  l: "college",
  "colorado college tigers": "n",
  "cc tigers": "s",
  "college-cc": "a"
}, {
  name: "Colorado College Tigers",
  shortName: "CC Tigers",
  city: "Colorado College",
  abbreviation: "CC",
  nickName: "Tigers",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F2AF36"
    }
  }
}), Fs.set({
  l: "college",
  "northern michigan wildcats": "n",
  "nm wildcats": "s",
  "college-nm": "a"
}, {
  name: "Northern Michigan Wildcats",
  shortName: "NM Wildcats",
  city: "Northern Michigan",
  abbreviation: "NM",
  nickName: "Wildcats",
  color: {
    primary: {
      value: "#095339",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFC425"
    }
  }
}), Fs.set({
  l: "college",
  "michigan tech huskies": "n",
  "mtt huskies": "s",
  "college-mtt": "a"
}, {
  name: "Michigan Tech Huskies",
  shortName: "MTT Huskies",
  city: "Michigan Tech",
  abbreviation: "MTT",
  nickName: "Huskies",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCD00"
    }
  }
}), Fs.set({
  l: "college",
  "lake superior state lakers": "n",
  "lss lakers": "s",
  "college-lss": "a"
}, {
  name: "Lake Superior State Lakers",
  shortName: "LSS Lakers",
  city: "Lake Superior State",
  abbreviation: "LSS",
  nickName: "Lakers",
  color: {
    primary: {
      value: "#003F87",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFC61E"
    }
  }
}), Fs.set({
  l: "college",
  "rensselaer polytechnic institute engineers": "n",
  "rpi engineers": "s",
  "college-rpi": "a"
}, {
  name: "Rensselaer Polytechnic Institute Engineers",
  shortName: "RPI Engineers",
  city: "Rensselaer Polytechnic Institute",
  abbreviation: "RPI",
  nickName: "Engineers",
  color: {
    primary: {
      value: "#232020",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#f6f6f6"
    }
  }
}), Fs.set({
  l: "college",
  "ohio state buckeyes": "n",
  "osu buckeyes": "s",
  "college-osu": "a"
}, {
  name: "Ohio State Buckeyes",
  shortName: "OSU Buckeyes",
  city: "Ohio State",
  abbreviation: "OSU",
  nickName: "Buckeyes",
  color: {
    primary: {
      value: "#BB0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#666666"
    }
  }
}), Fs.set({
  l: "college",
  "ferris state bulldogs": "n",
  "fs bulldogs": "s",
  "college-fs": "a"
}, {
  name: "Ferris State Bulldogs",
  shortName: "FS Bulldogs",
  city: "Ferris State",
  nickName: "Bulldogs",
  abbreviation: "FS",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FCC917"
    }
  }
}), Fs.set({
  l: "college",
  "bemidji state beavers": "n",
  "bs beavers": "s",
  "college-bs": "a"
}, {
  name: "Bemidji State Beavers",
  shortName: "BS Beavers",
  city: "Bemidji State",
  nickName: "Beavers",
  abbreviation: "BS",
  color: {
    primary: {
      value: "#004D44",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#D4B67C"
    }
  }
}), Fs.set({
  l: "college",
  "rochester institute of technology tigers": "n",
  "rit tigers": "s",
  "college-rit": "a"
}, {
  name: "Rochester Institute of Technology Tigers",
  shortName: "RIT Tigers",
  city: "Rochester Institute of Technology",
  nickName: "Tigers",
  abbreviation: "RIT",
  color: {
    primary: {
      value: "#231F20",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F36917"
    }
  }
}), Fs.set({
  l: "college",
  "ohio bobcats": "n",
  "college-ohio": "a"
}, {
  name: "Ohio Bobcats",
  shortName: "OHIO Bobcats",
  city: "Ohio",
  nickName: "Bobcats",
  abbreviation: "OHIO",
  color: {
    primary: {
      value: "#00694E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "toledo rockets": "n",
  "tol rockets": "s",
  "college-tol": "a"
}, {
  name: "Toledo Rockets",
  shortName: "TOL Rockets",
  city: "Toledo",
  nickName: "Rockets",
  abbreviation: "TOL",
  color: {
    primary: {
      value: "#FFD200",
      type: "color"
    },
    secondary: {
      value: "#134FC0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "western michigan broncos": "n",
  "wmu broncos": "s",
  "college-wmu": "a"
}, {
  name: "Western Michigan Broncos",
  shortName: "WMU Broncos",
  city: "Western Michigan",
  nickName: "Broncos",
  abbreviation: "WMU",
  color: {
    primary: {
      value: "#6C4023",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "air force falcons": "n",
  "af falcons": "s",
  "college-af": "a"
}, {
  name: "Air Force Falcons",
  shortName: "AF Falcons",
  city: "Air Force",
  nickName: "Falcons",
  abbreviation: "AF",
  color: {
    primary: {
      value: "#003087",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "boise state broncos": "n",
  "bsu broncos": "s",
  "college-bsu": "a"
}, {
  name: "Boise State Broncos",
  shortName: "BSU Broncos",
  city: "Boise State",
  nickName: "Broncos",
  abbreviation: "BSU",
  color: {
    primary: {
      value: "#0033A0",
      type: "color"
    },
    secondary: {
      value: "#D64309",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "colorado state rams": "n",
  "csu rams": "s",
  "college-csu": "a"
}, {
  name: "Colorado State Rams",
  shortName: "CSU Rams",
  city: "Colorado State",
  nickName: "Rams",
  abbreviation: "CSU",
  color: {
    primary: {
      value: "#1E4D2B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "fresno state bulldogs": "n",
  "fres bulldogs": "s",
  "college-fres": "a"
}, {
  name: "Fresno State Bulldogs",
  shortName: "FRES Bulldogs",
  city: "Fresno State",
  nickName: "Bulldogs",
  abbreviation: "FRES",
  color: {
    primary: {
      value: "#db0032",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#002E6D"
    }
  }
}), Fs.set({
  l: "college",
  "hawaii rainbow warriors": "n",
  "haw rainbow warriors": "s",
  "college-haw": "a"
}, {
  name: "Hawaii Rainbow Warriors",
  alertNames: ["Hawai'i Rainbow Warriors"],
  shortName: "HAW Rainbow Warriors",
  city: "Hawaii",
  nickName: "Rainbow Warriors",
  abbreviation: "HAW",
  color: {
    primary: {
      value: "#024731",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "nevada wolf pack": "n",
  "nev wolf pack": "s",
  "college-nev": "a",
  "nevada wolfpack": "an"
}, {
  name: "Nevada Wolf Pack",
  alternateNames: ["Nevada Wolfpack"],
  shortName: "NEV Wolf Pack",
  city: "Nevada",
  nickName: "Wolf Pack",
  abbreviation: "NEV",
  color: {
    primary: {
      value: "#003366",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "new mexico lobos": "n",
  "unm lobos": "s",
  "college-unm": "a"
}, {
  name: "New Mexico Lobos",
  shortName: "UNM Lobos",
  city: "New Mexico",
  nickName: "Lobos",
  abbreviation: "UNM",
  color: {
    primary: {
      value: "#BA0C2F",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "south dakota state jackrabbits": "n",
  "sdsu jackrabbits": "s",
  "college-sdsu": "a"
}, {
  name: "South Dakota State Jackrabbits",
  shortName: "SDSU Jackrabbits",
  city: "South Dakota State",
  nickName: "Jackrabbits",
  abbreviation: "SDSU",
  color: {
    primary: {
      value: "#D41736",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "san jose state spartans": "n",
  "sjsu spartans": "s",
  "college-sjsu": "a"
}, {
  name: "San Jose State Spartans",
  shortName: "SJSU Spartans",
  city: "San Jose",
  nickName: "Spartans",
  abbreviation: "SJSU",
  color: {
    primary: {
      value: "#0055A2",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFC021"
    }
  }
}), Fs.set({
  l: "college",
  "unlv rebels": "n",
  "college-unlv": "a",
  "university of nevada, las vegas": "an",
  "university of nevada las vegas": "an"
}, {
  name: "UNLV Rebels",
  alternateNames: ["University of Nevada, Las Vegas", "University of Nevada Las Vegas"],
  shortName: "UNLV Rebels",
  city: "UNLV",
  nickName: "Rebels",
  abbreviation: "UNLV",
  color: {
    primary: {
      value: "#CF0A2C",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "utah state aggies": "n",
  "usu aggies": "s",
  "college-usu": "a"
}, {
  name: "Utah State Aggies",
  shortName: "USU Aggies",
  city: "Utah State",
  nickName: "Aggies",
  abbreviation: "USU",
  color: {
    primary: {
      value: "#00263A",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "wyoming cowboys": "n",
  "wy cowboys": "s",
  "college-wyo": "a"
}, {
  name: "Wyoming Cowboys",
  shortName: "WY Cowboys",
  city: "Wyoming",
  nickName: "Cowboys",
  abbreviation: "WYO",
  color: {
    primary: {
      value: "#FFC425",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#492F24"
    }
  }
}), Fs.set({
  l: "college",
  "appalachian state mountaineers": "n",
  "app mountaineers": "s",
  "college-app": "a"
}, {
  name: "Appalachian State Mountaineers",
  shortName: "APP Mountaineers",
  city: "Appalachian State",
  nickName: "Mountaineers",
  abbreviation: "APP",
  color: {
    primary: {
      value: "#222222",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCC00"
    }
  }
}), Fs.set({
  l: "college",
  "arkansas state red wolves": "n",
  "arst red wolves": "s",
  "college-arst": "a"
}, {
  name: "Arkansas State Red Wolves",
  shortName: "ARST Red Wolves",
  city: "Arkansas State",
  nickName: "Red Wolves",
  abbreviation: "ARST",
  color: {
    primary: {
      value: "#cc092f",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "georgia southern eagles": "n",
  "gaso eagles": "s",
  "college-gaso": "a"
}, {
  name: "Georgia Southern Eagles",
  shortName: "GASO Eagles",
  city: "Georgia Southern",
  nickName: "Eagles",
  abbreviation: "GASO",
  color: {
    primary: {
      value: "#011e41",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "georgia state panthers": "n",
  "gsu panthers": "s",
  "college-gsu": "a"
}, {
  name: "Georgia State Panthers",
  shortName: "GSU Panthers",
  city: "Georgia State",
  nickName: "Panthers",
  abbreviation: "GSU",
  color: {
    primary: {
      value: "#0039A6",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "idaho vandals": "n",
  "idho vandals": "s",
  "college-idho": "a"
}, {
  name: "Idaho Vandals",
  shortName: "IDHO Vandals",
  city: "Idaho",
  nickName: "Vandals",
  abbreviation: "IDHO",
  color: {
    primary: {
      value: "#B3A369",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCC13"
    }
  }
}), Fs.set({
  l: "college",
  "louisiana ragin' cajuns": "n",
  "ull ragin' cajuns": "s",
  "college-ull": "a",
  "louisiana-lafayette ragin' cajuns": "an",
  "louisiana lafayette ragin' cajuns": "an"
}, {
  name: "Louisiana Ragin' Cajuns",
  alternateNames: ["Louisiana-Lafayette Ragin' Cajuns", "Louisiana Lafayette Ragin' Cajuns"],
  shortName: "ULL Ragin' Cajuns",
  city: "Louisiana Lafayette",
  nickName: "Ragin' Cajuns",
  abbreviation: "ULL",
  color: {
    primary: {
      value: "#CE181E",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "louisiana-monroe warhawks": "n",
  "ulm warhawks": "s",
  "college-ulm": "a"
}, {
  name: "Louisiana-Monroe Warhawks",
  shortName: "ULM Warhawks",
  city: "Louisiana-Monroe",
  nickName: "Warhawks",
  abbreviation: "ULM",
  color: {
    primary: {
      value: "#840029",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FDB913"
    }
  }
}), Fs.set({
  l: "college",
  "new mexico state aggies": "n",
  "nmsu aggies": "s",
  "college-nmsu": "a"
}, {
  name: "New Mexico State Aggies",
  shortName: "NMSU Aggies",
  city: "New Mexico State",
  nickName: "Aggies",
  abbreviation: "NMSU",
  color: {
    primary: {
      value: "#861F41",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#221E1F"
    }
  }
}), Fs.set({
  l: "college",
  "south alabama jaguars": "n",
  "usa jaguars": "s",
  "college-usa": "a"
}, {
  name: "South Alabama Jaguars",
  shortName: "USA Jaguars",
  city: "South Alabama",
  nickName: "Jaguars",
  abbreviation: "USA",
  color: {
    primary: {
      value: "#00205B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "texas state bobcats": "n",
  "txst bobcats": "s",
  "college-txst": "a"
}, {
  name: "Texas State Bobcats",
  shortName: "TXST Bobcats",
  city: "Texas State",
  nickName: "Bobcats",
  abbreviation: "TXST",
  color: {
    primary: {
      value: "#501214",
      type: "color"
    },
    secondary: {
      value: "#8D734A",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "troy trojans": "n",
  "college-troy": "a"
}, {
  name: "Troy Trojans",
  shortName: "TROY Trojans",
  city: "Troy",
  nickName: "Trojans",
  abbreviation: "TROY",
  color: {
    primary: {
      value: "#8a2432",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "cal poly mustangs": "n",
  "cp mustangs": "s",
  "college-cp": "a"
}, {
  name: "Cal Poly Mustangs",
  shortName: "CP Mustangs",
  city: "Cal Poly",
  nickName: "Mustangs",
  abbreviation: "CP",
  color: {
    primary: {
      value: "#003831",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFF1D0"
    }
  }
}), Fs.set({
  l: "college",
  "eastern washington eagles": "n",
  "ewu eagles": "s",
  "college-ewu": "a"
}, {
  name: "Eastern Washington Eagles",
  shortName: "EWU Eagles",
  city: "Eastern Washington",
  nickName: "Eagles",
  abbreviation: "EWU",
  color: {
    primary: {
      value: "#a10022",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "idaho state bengals": "n",
  "idst bengals": "s",
  "college-idst": "a"
}, {
  name: "Idaho State Bengals",
  shortName: "IDST Bengals",
  city: "Idaho State",
  nickName: "Bengals",
  abbreviation: "IDST",
  color: {
    primary: {
      value: "#FF671F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "montana grizzlies": "n",
  "mont grizzlies": "s",
  "college-mont": "a"
}, {
  name: "Montana Grizzlies",
  shortName: "MONT Grizzlies",
  city: "Montana",
  nickName: "Grizzlies",
  abbreviation: "MONT",
  color: {
    primary: {
      value: "#660033",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "montana state bobcats": "n",
  "mtst bobcats": "s",
  "college-mtst": "a"
}, {
  name: "Montana State Bobcats",
  shortName: "MTST Bobcats",
  city: "Montana State",
  nickName: "Bobcats",
  abbreviation: "MTST",
  color: {
    primary: {
      value: "#00205B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#D3AF7E"
    }
  }
}), Fs.set({
  l: "college",
  "north dakota fighting hawks": "n",
  "und fighting hawks": "s",
  "college-und": "a"
}, {
  name: "North Dakota Fighting Hawks",
  shortName: "UND Fighting Hawks",
  city: "North Dakota",
  nickName: "Fighting Hawks",
  abbreviation: "UND",
  color: {
    primary: {
      value: "#009A44",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "northern arizona lumberjacks": "n",
  "nau lumberjacks": "s",
  "college-nau": "a"
}, {
  name: "Northern Arizona Lumberjacks",
  shortName: "NAU Lumberjacks",
  city: "Northern Arizona",
  nickName: "Lumberjacks",
  abbreviation: "NAU",
  color: {
    primary: {
      value: "#003466",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "northern colorado bears": "n",
  "unco bears": "s",
  "college-unco": "a"
}, {
  name: "Northern Colorado Bears",
  shortName: "UNCO Bears",
  city: "Northern Colorado",
  nickName: "Bears",
  abbreviation: "UNCO",
  color: {
    primary: {
      value: "#013C65",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F9D245"
    }
  }
}), Fs.set({
  l: "college",
  "portland state vikings": "n",
  "prst vikings": "s",
  "college-prst": "a"
}, {
  name: "Portland State Vikings",
  shortName: "PRST Vikings",
  city: "Portland State",
  nickName: "Vikings",
  abbreviation: "PRST",
  color: {
    primary: {
      value: "#154734",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#BFCFD8"
    }
  }
}), Fs.set({
  l: "college",
  "sacramento state hornets": "n",
  "sac hornets": "s",
  "college-sac": "a"
}, {
  name: "Sacramento State Hornets",
  shortName: "SAC Hornets",
  city: "Sacramento State",
  nickName: "Hornets",
  abbreviation: "SAC",
  color: {
    primary: {
      value: "#043927",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "southern utah thunderbirds": "n",
  "suu thunderbirds": "s",
  "college-suu": "a"
}, {
  name: "Southern Utah Thunderbirds",
  shortName: "SUU Thunderbirds",
  city: "Southern Utah",
  nickName: "Thunderbirds",
  abbreviation: "SUU",
  color: {
    primary: {
      value: "#C41425",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#050607"
    }
  }
}), Fs.set({
  l: "college",
  "uc davis aggies": "n",
  "ucd aggies": "s",
  "college-ucd": "a"
}, {
  name: "UC Davis Aggies",
  shortName: "UCD Aggies",
  city: "UC Davis",
  nickName: "Aggies",
  abbreviation: "UCD",
  color: {
    primary: {
      value: "#002855",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#CB992B"
    }
  }
}), Fs.set({
  l: "college",
  "weber state wildcats": "n",
  "web wildcats": "s",
  "college-web": "a"
}, {
  name: "Weber State Wildcats",
  shortName: "WEB Wildcats",
  city: "Weber State",
  nickName: "Wildcats",
  abbreviation: "WEB",
  color: {
    primary: {
      value: "#4b2682",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "charleston southern buccaneers": "n",
  "chso buccaneers": "s",
  "college-chso": "a"
}, {
  name: "Charleston Southern Buccaneers",
  shortName: "CHSO Buccaneers",
  city: "Charleston Southern",
  nickName: "Buccaneers",
  abbreviation: "CHSO",
  color: {
    primary: {
      value: "#A8996E",
      type: "color"
    },
    secondary: {
      value: "#002855",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "coastal carolina chanticleers": "n",
  "ccu chanticleers": "s",
  "college-ccu": "a"
}, {
  name: "Coastal Carolina Chanticleers",
  shortName: "CCU Chanticleers",
  city: "Coastal Carolina",
  nickName: "Chanticleers",
  abbreviation: "CCU",
  color: {
    primary: {
      value: "#006f71",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "gardner webb runnin' bulldogs": "n",
  "webb bulldogs": "s",
  "college-webb": "a"
}, {
  name: "Gardner Webb Runnin' Bulldogs",
  shortName: "WEBB Bulldogs",
  city: "Gardner-Webb",
  nickName: "Bulldogs",
  abbreviation: "WEBB",
  color: {
    primary: {
      value: "#A6192E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "kennesaw state owls": "n",
  "kenn owls": "s",
  "college-kenn": "a"
}, {
  name: "Kennesaw State Owls",
  shortName: "KENN Owls",
  city: "Kennesaw State",
  nickName: "Owls",
  abbreviation: "KENN",
  color: {
    primary: {
      value: "#FDBB30",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#0B1315"
    }
  }
}), Fs.set({
  l: "college",
  "liberty flames": "n",
  "lib flames": "s",
  "college-lib": "a"
}, {
  name: "Liberty Flames",
  shortName: "LIB Flames",
  city: "Liberty",
  nickName: "Flames",
  abbreviation: "LIB",
  color: {
    primary: {
      value: "#0A254E",
      type: "color"
    },
    secondary: {
      value: "#990000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "monmouth hawks": "n",
  "monm hawks": "s",
  "college-monm": "a"
}, {
  name: "Monmouth Hawks",
  shortName: "MONM Hawks",
  city: "Monmouth",
  nickName: "Hawks",
  abbreviation: "MONM",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "presbyterian blue hose": "n",
  "pre blue hose": "s",
  "college-pre": "a"
}, {
  name: "Presbyterian Blue Hose",
  shortName: "PRE Blue Hose",
  city: "Presbyterian",
  nickName: "Blue Hose",
  abbreviation: "PRE",
  color: {
    primary: {
      value: "#0060A9",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "albany great danes": "n",
  "alby great danes": "s",
  "college-alby": "a"
}, {
  name: "Albany Great Danes",
  shortName: "ALBY Great Danes",
  city: "Albany",
  nickName: "Great Danes",
  abbreviation: "ALBY",
  color: {
    primary: {
      value: "#461660",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FCBB0D"
    }
  }
}), Fs.set({
  l: "college",
  "delaware fightin' blue hens": "n",
  "del fightin' blue hens": "s",
  "college-del": "a"
}, {
  name: "Delaware Fightin' Blue Hens",
  shortName: "DEL Fightin' Blue Hens",
  city: "Delaware",
  nickName: "Fightin' Blue Hen",
  abbreviation: "DEL",
  color: {
    primary: {
      value: "#00539f",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFD200"
    }
  }
}), Fs.set({
  l: "college",
  "elon phoenix": "n",
  "college-elon": "a"
}, {
  name: "Elon Phoenix",
  shortName: "ELON Phoenix",
  city: "Elon",
  nickName: "Phoenix",
  abbreviation: "ELON",
  color: {
    primary: {
      value: "#73000a",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#AEA460"
    }
  }
}), Fs.set({
  l: "college",
  "james madison dukes": "n",
  "jmu dukes": "s",
  "college-jmu": "a"
}, {
  name: "James Madison Dukes",
  shortName: "JMU Dukes",
  city: "James Madison",
  nickName: "Dukes",
  abbreviation: "JMU",
  color: {
    primary: {
      value: "#450084",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#D5A10E"
    }
  }
}), Fs.set({
  l: "college",
  "maine black bears": "n",
  "college-mne": "a"
}, {
  name: "Maine Black Bears",
  shortName: "MAINE Black Bears",
  city: "Maine",
  nickName: "Black Bears",
  abbreviation: "MNE",
  color: {
    primary: {
      value: "#003263",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "new hampshire wildcats": "n",
  "unh wildcats": "s",
  "college-unh": "a"
}, {
  name: "New Hampshire Wildcats",
  shortName: "UNH Wildcats",
  city: "New Hampshire",
  nickName: "Wildcats",
  abbreviation: "UNH",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "rhode island rams": "n",
  "uri rams": "s",
  "college-uri": "a"
}, {
  name: "Rhode Island Rams",
  shortName: "URI Rams",
  city: "Rhode Island",
  nickName: "Rams",
  abbreviation: "URI",
  color: {
    primary: {
      value: "#68abe8",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#003559"
    }
  }
}), Fs.set({
  l: "college",
  "richmond spiders": "n",
  "rich spiders": "s",
  "college-rich": "a"
}, {
  name: "Richmond Spiders",
  shortName: "RICH Spiders",
  city: "Richmond",
  nickName: "Spiders",
  abbreviation: "RICH",
  color: {
    primary: {
      value: "#000066",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#003256"
    }
  }
}), Fs.set({
  l: "college",
  "stony brook seawolves": "n",
  "ston seawolves": "s",
  "college-ston": "a"
}, {
  name: "Stony Brook Seawolves",
  shortName: "STON Seawolves",
  city: "Stony Brook",
  nickName: "Seawolves",
  abbreviation: "STON",
  color: {
    primary: {
      value: "#990000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#16243E"
    }
  }
}), Fs.set({
  l: "college",
  "towson tigers": "n",
  "tows tigers": "s",
  "college-tows": "a"
}, {
  name: "Towson Tigers",
  shortName: "TOWS Tigers",
  city: "Towson",
  nickName: "Tigers",
  abbreviation: "TOWS",
  color: {
    primary: {
      value: "#FFBB00",
      type: "color"
    },
    secondary: {
      value: "#3C3C3C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "villanova wildcats": "n",
  "nova wildcats": "s",
  "college-nova": "a"
}, {
  name: "Villanova Wildcats",
  shortName: "NOVA Wildcats",
  city: "Villanova",
  nickName: "Wildcats",
  abbreviation: "NOVA",
  color: {
    primary: {
      value: "#00205b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "william & mary tribe": "n",
  "w&m tribe": "s",
  "college-w&m": "a"
}, {
  name: "William & Mary Tribe",
  shortName: "W&M Tribe",
  city: "William & Mary",
  nickName: "Tribe",
  abbreviation: "W&M",
  color: {
    primary: {
      value: "#115740",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FDF71C"
    }
  }
}), Fs.set({
  l: "college",
  "brown bears": "n",
  "brwn bears": "s",
  "college-brwn": "a"
}, {
  name: "Brown Bears",
  shortName: "BRWN Bears",
  city: "Brown",
  nickName: "Bears",
  abbreviation: "BRWN",
  color: {
    primary: {
      value: "#4E3629",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#7C2529"
    }
  }
}), Fs.set({
  l: "college",
  "cornell big red": "n",
  "cor big red": "s",
  "college-cor": "a"
}, {
  name: "Cornell Big Red",
  shortName: "COR Big Red",
  city: "Cornell",
  nickName: "Big Red",
  abbreviation: "COR",
  color: {
    primary: {
      value: "#B31B1B",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "columbia lions": "n",
  "clmb lions": "s",
  "college-clmb": "a"
}, {
  name: "Columbia Lions",
  shortName: "CLMB Lions",
  city: "Columbia",
  nickName: "Lions",
  abbreviation: "CLMB",
  color: {
    primary: {
      value: "#9BCBEB",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#003865"
    }
  }
}), Fs.set({
  l: "college",
  "dartmouth big green": "n",
  "dart big green": "s",
  "college-dart": "a"
}, {
  name: "Dartmouth Big Green",
  shortName: "DART Big Green",
  city: "Dartmouth",
  nickName: "Big Green",
  abbreviation: "DART",
  color: {
    primary: {
      value: "#046A38",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "harvard crimson": "n",
  "harv crimson": "s",
  "college-harv": "a"
}, {
  name: "Harvard Crimson",
  shortName: "HARV Crimson",
  city: "Harvard",
  nickName: "Crimson",
  abbreviation: "HARV",
  color: {
    primary: {
      value: "#A41034",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "pennsylvania quakers": "n",
  "penn quakers": "s",
  "college-penn": "a"
}, {
  name: "Pennsylvania Quakers",
  shortName: "PENN Quakers",
  city: "UPenn",
  nickName: "Quakers",
  abbreviation: "PENN",
  color: {
    primary: {
      value: "#990000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "princeton tigers": "n",
  "prin tigers": "s",
  "college-prin": "a"
}, {
  name: "Princeton Tigers",
  shortName: "PRIN Tigers",
  city: "Princeton",
  nickName: "Tigers",
  abbreviation: "PRIN",
  color: {
    primary: {
      value: "#FF671F",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "yale bulldogs": "n",
  "college-yale": "a"
}, {
  name: "Yale Bulldogs",
  shortName: "YALE Bulldogs",
  city: "Yale",
  nickName: "Bulldogs",
  abbreviation: "YALE",
  color: {
    primary: {
      value: "#00356b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "bethune-cookman wildcats": "n",
  "cook wildcats": "s",
  "college-cook": "a",
  "bethune cookman wildcats": "an"
}, {
  name: "Bethune-Cookman Wildcats",
  alternateNames: ["Bethune Cookman Wildcats"],
  shortName: "COOK Wildcats",
  city: "Bethune-Cookman Wildcats",
  nickName: "Wildcats",
  abbreviation: "COOK",
  color: {
    primary: {
      value: "#F2A900",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "delaware state hornets": "n",
  "dsu hornets": "s",
  "college-dsu": "a"
}, {
  name: "Delaware State Hornets",
  shortName: "DSU Hornets",
  city: "Delaware State",
  nickName: "Hornets",
  abbreviation: "DSU",
  color: {
    primary: {
      value: "#EE3124",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#01A9EF"
    }
  }
}), Fs.set({
  l: "college",
  "florida a&m rattlers": "n",
  "famu rattlers": "s",
  "college-famu": "a"
}, {
  name: "Florida A&M Rattlers",
  shortName: "FAMU Rattlers",
  city: "Florida A&M",
  nickName: "Rattlers",
  abbreviation: "FAMU",
  color: {
    primary: {
      value: "#ee7624",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#00B552"
    }
  }
}), Fs.set({
  l: "college",
  "hampton pirates": "n",
  "hamp pirates": "s",
  "college-hamp": "a"
}, {
  name: "Hampton Pirates",
  shortName: "HAMP Pirates",
  city: "Hampton",
  nickName: "Pirates",
  abbreviation: "HAMP",
  color: {
    primary: {
      value: "#0060A9",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "howard bison": "n",
  "how bison": "s",
  "college-how": "a"
}, {
  name: "Howard Bison",
  shortName: "HOW Bison",
  city: "Howard",
  nickName: "Bison",
  abbreviation: "HOW",
  color: {
    primary: {
      value: "#003A63",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#E51937"
    }
  }
}), Fs.set({
  l: "college",
  "morgan state bears": "n",
  morg: "s",
  "college-morg": "a"
}, {
  name: "Morgan State Bears",
  shortName: "MORG",
  city: "Morgan State",
  nickName: "Bears",
  abbreviation: "MORG",
  color: {
    primary: {
      value: "#1b4383",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F47937"
    }
  }
}), Fs.set({
  l: "college",
  "norfolk state spartans": "n",
  norf: "s",
  "college-norf": "a"
}, {
  name: "Norfolk State Spartans",
  shortName: "NORF",
  city: "Norfolk State",
  nickName: "Spartans",
  abbreviation: "NORF",
  color: {
    primary: {
      value: "#007A53",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "north carolina a&t aggies": "n",
  ncat: "s",
  "college-ncat": "a"
}, {
  name: "North Carolina A&T Aggies",
  shortName: "NCAT",
  city: "North Carolina A&T",
  nickName: "Aggies",
  abbreviation: "NCAT",
  color: {
    primary: {
      value: "#F3B237",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#003D6D"
    }
  }
}), Fs.set({
  l: "college",
  "north carolina central eagles": "n",
  nccu: "s",
  "college-nccu": "a"
}, {
  name: "North Carolina Central Eagles",
  shortName: "NCCU",
  city: "NC Central",
  nickName: "Eagles",
  abbreviation: "NCCU",
  color: {
    primary: {
      value: "#880023",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#8E9093"
    }
  }
}), Fs.set({
  l: "college",
  "savannah state tigers": "n",
  "sav tigers": "s",
  "college-sav": "a"
}, {
  name: "Savannah State Tigers",
  shortName: "SAV Tigers",
  city: "Savannah State",
  nickName: "Tigers",
  abbreviation: "SAV",
  color: {
    primary: {
      value: "#002395",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FF5B00"
    }
  }
}), Fs.set({
  l: "college",
  "south carolina state bulldogs": "n",
  "scst bulldogs": "s",
  "college-scst": "a"
}, {
  name: "South Carolina State Bulldogs",
  shortName: "SCST Bulldogs",
  city: "South Carolina State",
  nickName: "Bulldogs",
  abbreviation: "SCST",
  color: {
    primary: {
      value: "#862633",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#080D35"
    }
  }
}), Fs.set({
  l: "college",
  "illinois state redbirds": "n",
  "ilst redbirds": "s",
  "college-ilst": "a"
}, {
  name: "Illinois State Redbirds",
  shortName: "ILST Redbirds",
  city: "Illinois State",
  nickName: "Redbirds",
  abbreviation: "ILST",
  color: {
    primary: {
      value: "#ce1126",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#010000"
    }
  }
}), Fs.set({
  l: "college",
  "indiana state sycamores": "n",
  "inst sycamores": "s",
  "college-inst": "a"
}, {
  name: "Indiana State Sycamores",
  shortName: "INST Sycamores",
  city: "Indiana State",
  nickName: "Sycamores",
  abbreviation: "INST",
  color: {
    primary: {
      value: "#0142BC",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "missouri state bears": "n",
  "most bears": "s",
  "college-most": "a"
}, {
  name: "Missouri State Bears",
  shortName: "MOST Bears",
  city: "Missouri State",
  nickName: "Bears",
  abbreviation: "MOST",
  color: {
    primary: {
      value: "#5E0009",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "north dakota state bison": "n",
  "ndsu bison": "s",
  "college-ndsu": "a"
}, {
  name: "North Dakota State Bison",
  shortName: "NDSU Bison",
  city: "North Dakota State",
  nickName: "Bison",
  abbreviation: "NDSU",
  color: {
    primary: {
      value: "#0a5640",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FEBB1C"
    }
  }
}), Fs.set({
  l: "college",
  "northern iowa panthers": "n",
  "uni panthers": "s",
  "college-uni": "a"
}, {
  name: "Northern Iowa Panthers",
  shortName: "UNI Panthers",
  city: "Northern Iowa",
  nickName: "Panthers",
  abbreviation: "UNI",
  color: {
    primary: {
      value: "#4B116F",
      type: "color"
    },
    secondary: {
      value: "#FFCC00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "south dakota coyotes": "n",
  "sdak coyotes": "s",
  "college-sdak": "a"
}, {
  name: "South Dakota Coyotes",
  shortName: "SDAK Coyotes",
  city: "South Dakota",
  nickName: "Coyotes",
  abbreviation: "SDAK",
  color: {
    primary: {
      value: "#ad0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "southern illinois salukis": "n",
  "siu salukis": "s",
  "college-siu": "a"
}, {
  name: "Southern Illinois Salukis",
  shortName: "SIU Salukis",
  city: "Southern Illinois",
  nickName: "Salukis",
  abbreviation: "SIU",
  color: {
    primary: {
      value: "#720000",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "western illinois leathernecks": "n",
  "wiu leathernecks": "s",
  "college-wiu": "a"
}, {
  name: "Western Illinois Leathernecks",
  shortName: "WIU Leathernecks",
  city: "Western Illinois",
  nickName: "Leathernecks",
  abbreviation: "WIU",
  color: {
    primary: {
      value: "#663399",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCC00"
    }
  }
}), Fs.set({
  l: "college",
  "youngstown state penguins": "n",
  "ysu penguins": "s",
  "college-ysu": "a"
}, {
  name: "Youngstown State Penguins",
  shortName: "YSU Penguins",
  city: "Youngstown State",
  nickName: "Penguins",
  abbreviation: "YSU",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "bryant bulldogs": "n",
  "bry bulldogs": "s",
  "college-bry": "a"
}, {
  name: "Bryant Bulldogs",
  shortName: "BRY Bulldogs",
  city: "Bryant",
  nickName: "Bulldogs",
  abbreviation: "BRY",
  color: {
    primary: {
      value: "#b4975b",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "central connecticut state blue devils": "n",
  "ccsu blue devils": "s",
  "college-ccsu": "a",
  "central conn. state blue devils": "an"
}, {
  name: "Central Connecticut State Blue Devils",
  alternateNames: ["Central Conn. State Blue Devils"],
  shortName: "CCSU Blue Devils",
  city: "Central Connecticut",
  nickName: "Blue Devils",
  abbreviation: "CCSU",
  color: {
    primary: {
      value: "#00539b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "duquesne dukes": "n",
  "duq dukes": "s",
  "college-duq": "a"
}, {
  name: "Duquesne Dukes",
  shortName: "DUQ Dukes",
  city: "Duquesne",
  nickName: "Dukes",
  abbreviation: "DUQ",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#D31145"
    }
  }
}), Fs.set({
  l: "college",
  "robert morris colonials": "n",
  "rmu colonials": "s",
  "college-rmu": "a"
}, {
  name: "Robert Morris Colonials",
  shortName: "RMU Colonials",
  city: "Robert Morris (PA)",
  nickName: "Colonials",
  abbreviation: "RMU",
  color: {
    primary: {
      value: "#14234b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#AF1C2E"
    }
  }
}), Fs.set({
  l: "college",
  "sacred heart pioneers": "n",
  "shu pioneers": "s",
  "college-shu": "a"
}, {
  name: "Sacred Heart Pioneers",
  shortName: "SHU Pioneers",
  city: "Sacred Heart",
  nickName: "Pioneers",
  abbreviation: "SHU",
  color: {
    primary: {
      value: "#ce1141",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "st. lawrence saints": "n",
  "stl saints": "s",
  "college-stl": "a"
}, {
  name: "St. Lawrence Saints",
  shortName: "STL Saints",
  city: "St. Lawrence",
  nickName: "Saints",
  abbreviation: "STL",
  color: {
    primary: {
      value: "#BE2032",
      type: "color"
    },
    secondary: {
      value: "#654134",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "st. cloud state huskies": "n",
  "scs huskies": "s",
  "college-scs": "a"
}, {
  name: "St. Cloud State Huskies",
  shortName: "SCS Huskies",
  city: "St. Cloud State",
  nickName: "Huskies",
  abbreviation: "SCS",
  color: {
    primary: {
      value: "#A10209",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "alaska anchorage seawolves": "n",
  "aa seawolves": "s",
  "college-aa": "a"
}, {
  name: "Alaska Anchorage Seawolves",
  shortName: "AA Seawolves",
  city: "Alaska Anchorage",
  nickName: "Seawolves",
  abbreviation: "AA",
  color: {
    primary: {
      value: "#00583D",
      type: "color"
    },
    secondary: {
      value: "#FFC425",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "alaska nanooks": "n",
  "ak nanooks": "s",
  "college-ak": "a"
}, {
  name: "Alaska Nanooks",
  shortName: "AK Nanooks",
  city: "Alaska",
  nickName: "Nanooks",
  abbreviation: "AK",
  color: {
    primary: {
      value: "#236192",
      type: "color"
    },
    secondary: {
      value: "#FFCD00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "union garnet chargers": "n",
  "un garnet chargers": "s",
  "college-union": "a"
}, {
  name: "Union Garnet Chargers",
  shortName: "UN Garnet Chargers",
  city: "Union",
  nickName: "Garnet Chargers",
  abbreviation: "UNION",
  color: {
    primary: {
      value: "#862633",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "minnesota duluth bulldogs": "n",
  "umd bulldogs": "s",
  "college-umd": "a"
}, {
  name: "Minnesota Duluth Bulldogs",
  shortName: "UMD Bulldogs",
  city: "Minnesota Duluth",
  nickName: "Bulldogs",
  abbreviation: "UMD",
  color: {
    primary: {
      value: "#8E0A26",
      type: "color"
    },
    secondary: {
      value: "#FAB937",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "clarkson golden knights": "n",
  "cl golden knights": "s",
  "college-clk": "a"
}, {
  name: "Clarkson Golden Knights",
  shortName: "CL Golden Knights",
  city: "Clarkson",
  nickName: "Golden Knights",
  abbreviation: "CLK",
  color: {
    primary: {
      value: "#0D433B",
      type: "color"
    },
    secondary: {
      value: "#FAC922",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "saint francis (pa) red flash": "n",
  "sfu red flash": "s",
  "college-sfu": "a",
  "st. francis (pa) red flash": "an",
  "saint francis red flash": "an",
  "st francis (pa) red flash": "an"
}, {
  name: "Saint Francis (PA) Red Flash",
  alternateNames: ["St. Francis (PA) Red Flash", "Saint Francis Red Flash", "St Francis (PA) Red Flash"],
  shortName: "SFU Red Flash",
  city: "St. Francis (PA)",
  nickName: "Red Flash",
  abbreviation: "SFU",
  color: {
    primary: {
      value: "#bd1f25",
      type: "color"
    },
    secondary: {
      value: "#231F20",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "wagner seahawks": "n",
  "wag seahawks": "s",
  "college-wag": "a"
}, {
  name: "Wagner Seahawks",
  shortName: "WAG Seahawks",
  city: "Wagner",
  nickName: "Seahawks",
  abbreviation: "WAG",
  color: {
    primary: {
      value: "#00483a",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "austin peay governors": "n",
  "peay governors": "s",
  "college-peay": "a"
}, {
  name: "Austin Peay Governors",
  shortName: "PEAY Governors",
  city: "Austin Peay",
  nickName: "Governors",
  abbreviation: "PEAY",
  color: {
    primary: {
      value: "#C41E3A",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "eastern illinois panthers": "n",
  "eiu panthers": "s",
  "college-eiu": "a"
}, {
  name: "Eastern Illinois Panthers",
  shortName: "EIU Panthers",
  city: "Eastern Illinois",
  nickName: "Panthers",
  abbreviation: "EIU",
  color: {
    primary: {
      value: "#004b83",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "eastern kentucky colonels": "n",
  "eky colonels": "s",
  "college-eky": "a"
}, {
  name: "Eastern Kentucky Colonels",
  shortName: "EKY Colonels",
  city: "Eastern Kentucky",
  nickName: "Colonels",
  abbreviation: "EKY",
  color: {
    primary: {
      value: "#8a0039",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "jacksonville state gamecocks": "n",
  "jvst gamecocks": "s",
  "college-jvst": "a"
}, {
  name: "Jacksonville State Gamecocks",
  shortName: "JVST Gamecocks",
  city: "Jacksonville State",
  nickName: "Gamecocks",
  abbreviation: "JVST",
  color: {
    primary: {
      value: "#CC0000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "murray state racers": "n",
  "murr racers": "s",
  "college-murr": "a"
}, {
  name: "Murray State Racers",
  shortName: "MURR Racers",
  city: "Murray State",
  nickName: "Racers",
  abbreviation: "MURR",
  color: {
    primary: {
      value: "#ECAC00",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFE000"
    }
  }
}), Fs.set({
  l: "college",
  "southeast missouri state redhawks": "n",
  "semo redhawks": "s",
  "college-semo": "a"
}, {
  name: "Southeast Missouri State Redhawks",
  shortName: "SEMO Redhawks",
  city: "Southeast Missouri State",
  nickName: "Redhawks",
  abbreviation: "SEMO",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "tennessee state tigers": "n",
  "tnst tigers": "s",
  "college-tnst": "a"
}, {
  name: "Tennessee State Tigers",
  shortName: "TNST Tigers",
  city: "Tennessee State",
  nickName: "Tigers",
  abbreviation: "TNST",
  color: {
    primary: {
      value: "#00539F",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "tennessee tech golden eagles": "n",
  tntc: "s",
  "college-tntc": "a"
}, {
  name: "Tennessee Tech Golden Eagles",
  shortName: "TNTC",
  city: "Tennessee Tech",
  nickName: "Golden Eagles",
  abbreviation: "TNTC",
  color: {
    primary: {
      value: "#4F2984",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFDD00"
    }
  }
}), Fs.set({
  l: "college",
  "tennessee martin skyhawks": "n",
  "utm skyhawks": "s",
  "college-utm": "a"
}, {
  name: "Tennessee Martin Skyhawks",
  shortName: "UTM Skyhawks",
  city: "Tennessee-Martin",
  nickName: "Skyhawks",
  abbreviation: "UTM",
  color: {
    primary: {
      value: "#f79728",
      type: "color"
    },
    secondary: {
      value: "#002A5B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "bucknell bison": "n",
  "buck bison": "s",
  "college-buck": "a"
}, {
  name: "Bucknell Bison",
  shortName: "BUCK Bison",
  city: "Bucknell",
  nickName: "Bison",
  abbreviation: "BUCK",
  color: {
    primary: {
      value: "#E87722",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#003865"
    }
  }
}), Fs.set({
  l: "college",
  "colgate raiders": "n",
  "colg raiders": "s",
  "college-colg": "a"
}, {
  name: "Colgate Raiders",
  shortName: "COLG Raiders",
  city: "Colgate",
  nickName: "Raiders",
  abbreviation: "COLG",
  color: {
    primary: {
      value: "#821019",
      type: "color"
    },
    secondary: {
      value: "#D2D4D6",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "fordham rams": "n",
  "for rams": "s",
  "college-for": "a"
}, {
  name: "Fordham Rams",
  shortName: "FOR Rams",
  city: "Fordham",
  nickName: "Rams",
  abbreviation: "FOR",
  color: {
    primary: {
      value: "#860038",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "georgetown hoyas": "n",
  "gtwn hoyas": "s",
  "college-gtwn": "a"
}, {
  name: "Georgetown Hoyas",
  shortName: "GTWN Hoyas",
  city: "Georgetown",
  nickName: "Hoyas",
  abbreviation: "GTWN",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "holy cross crusaders": "n",
  "hc crusaders": "s",
  "college-hc": "a"
}, {
  name: "Holy Cross Crusaders",
  shortName: "HC Crusaders",
  city: "Holy Cross",
  nickName: "Crusaders",
  abbreviation: "HC",
  color: {
    primary: {
      value: "#602d89",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#1B2154"
    }
  }
}), Fs.set({
  l: "college",
  "lafayette leopards": "n",
  "laf leopards": "s",
  "college-laf": "a"
}, {
  name: "Lafayette Leopards",
  shortName: "LAF Leopards",
  city: "Lafayette",
  nickName: "Leopards",
  abbreviation: "LAF",
  color: {
    primary: {
      value: "#98002e",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#CDBDA3"
    }
  }
}), Fs.set({
  l: "college",
  "lehigh mountain hawks": "n",
  "leh mountain hawks": "s",
  "college-leh": "a"
}, {
  name: "Lehigh Mountain Hawks",
  shortName: "LEH Mountain Hawks",
  city: "Lehigh",
  nickName: "Mountain Hawks",
  abbreviation: "LEH",
  color: {
    primary: {
      value: "#653600",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#CFAB7A"
    }
  }
}), Fs.set({
  l: "college",
  "butler bulldogs": "n",
  "but bulldogs": "s",
  "college-but": "a"
}, {
  name: "Butler Bulldogs",
  shortName: "BUT Bulldogs",
  city: "Butler",
  nickName: "Bulldogs",
  abbreviation: "BUT",
  color: {
    primary: {
      value: "#13294b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "campbell fighting camels": "n",
  "camp fighting camels": "s",
  "college-camp": "a"
}, {
  name: "Campbell Fighting Camels",
  shortName: "CAMP Fighting Camels",
  city: "Campbell",
  nickName: "Fighting Camels",
  abbreviation: "CAMP",
  color: {
    primary: {
      value: "#f58025",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "davidson wildcats": "n",
  "dav wildcats": "s",
  "college-dav": "a"
}, {
  name: "Davidson Wildcats",
  shortName: "DAV Wildcats",
  city: "Davidson",
  nickName: "Wildcats",
  abbreviation: "DAV",
  color: {
    primary: {
      value: "#ac1a2f",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "dayton flyers": "n",
  "day flyers": "s",
  "college-day": "a"
}, {
  name: "Dayton Flyers",
  shortName: "DAY Flyers",
  city: "Dayton",
  nickName: "Flyers",
  abbreviation: "DAY",
  color: {
    primary: {
      value: "#CE1141",
      type: "color"
    },
    secondary: {
      value: "#002F87",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "drake bulldogs": "n",
  "drke bulldogs": "s",
  "college-drke": "a"
}, {
  name: "Drake Bulldogs",
  shortName: "DRKE Bulldogs",
  city: "Drake",
  nickName: "Bulldogs",
  abbreviation: "DRKE",
  color: {
    primary: {
      value: "#004477",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "jacksonville dolphins": "n",
  "jac dolphins": "s",
  "college-jac": "a"
}, {
  name: "Jacksonville Dolphins",
  shortName: "JAC Dolphins",
  city: "Jacksonville",
  nickName: "Dolphins",
  abbreviation: "JAC",
  color: {
    primary: {
      value: "#004E44",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "marist red foxes": "n",
  "mrst red foxes": "s",
  "college-mrst": "a"
}, {
  name: "Marist Red Foxes",
  shortName: "MRST Red Foxes",
  city: "Marist",
  nickName: "Red Foxes",
  abbreviation: "MRST",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "morehead state eagles": "n",
  "more eagles": "s",
  "college-more": "a"
}, {
  name: "Morehead State Eagles",
  shortName: "MORE Eagles",
  city: "Morehead State",
  nickName: "Eagles",
  abbreviation: "MORE",
  color: {
    primary: {
      value: "#005EB8",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "san diego toreros": "n",
  "usd toreros": "s",
  "college-usd": "a"
}, {
  name: "San Diego Toreros",
  shortName: "USD Toreros",
  city: "San Diego",
  nickName: "Toreros",
  abbreviation: "USD",
  color: {
    primary: {
      value: "#002868",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#84BCE8"
    }
  }
}), Fs.set({
  l: "college",
  "stetson hatters": "n",
  "stet hatters": "s",
  "college-stet": "a"
}, {
  name: "Stetson Hatters",
  shortName: "STET Hatters",
  city: "Stetson",
  nickName: "Hatters",
  abbreviation: "STET",
  color: {
    primary: {
      value: "#00523E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "valparaiso beacons": "n",
  "valp beacons": "s",
  "college-valp": "a"
}, {
  name: "Valparaiso Beacons",
  shortName: "VALP Beacons",
  city: "Valparaiso",
  nickName: "Beacons",
  abbreviation: "VALP",
  color: {
    primary: {
      value: "#381e0e",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFD204"
    }
  }
}), Fs.set({
  l: "college",
  "chattanooga mocs": "n",
  "chat mocs": "s",
  "college-chat": "a"
}, {
  name: "Chattanooga Mocs",
  shortName: "CHAT Mocs",
  city: "Chattanooga",
  nickName: "Mocs",
  abbreviation: "CHAT",
  color: {
    primary: {
      value: "#00386b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#E0AA0F"
    }
  }
}), Fs.set({
  l: "college",
  "east tennessee state buccaneers": "n",
  "etsu buccaneers": "s",
  "college-etsu": "a"
}, {
  name: "East Tennessee State Buccaneers",
  shortName: "ETSU Buccaneers",
  city: "East Tennessee State",
  nickName: "Buccaneers",
  abbreviation: "ETSU",
  color: {
    primary: {
      value: "#041e42",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#BE9434"
    }
  }
}), Fs.set({
  l: "college",
  "furman paladins": "n",
  "fur paladins": "s",
  "college-fur": "a"
}, {
  name: "Furman Paladins",
  shortName: "FUR Paladins",
  city: "Furman",
  nickName: "Paladins",
  abbreviation: "FUR",
  color: {
    primary: {
      value: "#582C83",
      type: "color"
    },
    secondary: {
      value: "#201547",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "mercer bears": "n",
  mer: "s",
  "college-mer": "a"
}, {
  name: "Mercer Bears",
  shortName: "MER",
  city: "Mercer",
  nickName: "Bears",
  abbreviation: "MER",
  color: {
    primary: {
      value: "#f76800",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "samford bulldogs": "n",
  "sam bulldogs": "s",
  "college-sam": "a"
}, {
  name: "Samford Bulldogs",
  shortName: "SAM Bulldogs",
  city: "Samford",
  nickName: "Bulldogs",
  abbreviation: "SAM",
  color: {
    primary: {
      value: "#002649",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#D2D4D5"
    }
  }
}), Fs.set({
  l: "college",
  "citadel bulldogs": "n",
  "cit bulldogs": "s",
  "college-cit": "a",
  "the citadel bulldogs": "an"
}, {
  name: "Citadel Bulldogs",
  alternateNames: ["The Citadel Bulldogs"],
  shortName: "CIT Bulldogs",
  city: "The Citadel",
  nickName: "Bulldogs",
  abbreviation: "CIT",
  color: {
    primary: {
      value: "#3975B7",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#1F3A60"
    }
  }
}), Fs.set({
  l: "college",
  "vmi keydets": "n",
  "college-vmi": "a"
}, {
  name: "VMI Keydets",
  shortName: "VMI Keydets",
  city: "VMI",
  nickName: "Keydets",
  abbreviation: "VMI",
  color: {
    primary: {
      value: "#AE122A",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "western carolina catamounts": "n",
  "wcu catamounts": "s",
  "college-wcu": "a"
}, {
  name: "Western Carolina Catamounts",
  shortName: "WCU Catamounts",
  city: "Western Carolina",
  nickName: "Catamounts",
  abbreviation: "WCU",
  color: {
    primary: {
      value: "#592c88",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "wofford terriers": "n",
  "wof terriers": "s",
  "college-wof": "a"
}, {
  name: "Wofford Terriers",
  shortName: "WOF Terriers",
  city: "Wofford Terriers",
  nickName: "Terriers",
  abbreviation: "WOF",
  color: {
    primary: {
      value: "#886E4C",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFD700"
    }
  }
}), Fs.set({
  l: "college",
  "abilene christian wildcats": "n",
  "acu wildcats": "s",
  "college-acu": "a"
}, {
  name: "Abilene Christian Wildcats",
  shortName: "ACU Wildcats",
  city: "Abilene Christian",
  nickName: "Wildcats",
  abbreviation: "ACU",
  color: {
    primary: {
      value: "#4f2170",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "central arkansas bears": "n",
  "uca bears": "s",
  "college-uca": "a"
}, {
  name: "Central Arkansas Bears",
  shortName: "UCA Bears",
  city: "Central Arkansas",
  nickName: "Bears",
  abbreviation: "UCA",
  color: {
    primary: {
      value: "#4f2d7f",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "houston baptist huskies": "n",
  hbu: "s",
  "college-hbu": "a"
}, {
  name: "Houston Baptist Huskies",
  shortName: "HBU",
  city: "Houston Baptist",
  nickName: "Huskies",
  abbreviation: "HBU",
  color: {
    primary: {
      value: "#00529C",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F85512"
    }
  }
}), Fs.set({
  l: "college",
  "incarnate word cardinals": "n",
  "iw cardinals": "s",
  "college-iw": "a"
}, {
  name: "Incarnate Word Cardinals",
  shortName: "IW Cardinals",
  city: "Incarnate Word",
  nickName: "Cardinals",
  abbreviation: "IW",
  color: {
    primary: {
      value: "#cb333b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "lamar cardinals": "n",
  "lam cardinals": "s",
  "college-lam": "a"
}, {
  name: "Lamar Cardinals",
  shortName: "LAM Cardinals",
  city: "Lamar Cardinals",
  nickName: "Cardinals",
  abbreviation: "LAM",
  color: {
    primary: {
      value: "#dc0032",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "mcneese state cowboys": "n",
  mcns: "s",
  "college-mcns": "a",
  "mcneese cowboys": "an"
}, {
  name: "McNeese State Cowboys",
  alternateNames: ["McNeese Cowboys"],
  shortName: "MCNS",
  city: "McNeese",
  nickName: "Cowboys",
  abbreviation: "MCNS",
  color: {
    primary: {
      value: "#00529b",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFD204"
    }
  }
}), Fs.set({
  l: "college",
  "nicholls state colonels": "n",
  "nich colonels": "s",
  "college-nich": "a"
}, {
  name: "Nicholls State Colonels",
  shortName: "NICH Colonels",
  city: "Nicholls State",
  nickName: "Colonels",
  abbreviation: "NICH",
  color: {
    primary: {
      value: "#ae132a",
      type: "color"
    },
    secondary: {
      value: "#72808A",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "mississippi college choctaws": "n",
  "mi choctaws": "s",
  "college-mcc": "a"
}, {
  name: "Mississippi College Choctaws",
  preferredName: "Mississippi College",
  shortName: "MI Choctaws",
  city: "Mississippi",
  nickName: "Choctaws",
  preferredNickName: "Mississippi",
  abbreviation: "MCC",
  color: {
    primary: {
      value: "#0B335E",
      type: "color"
    },
    secondary: {
      value: "#FAB20B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "northwestern state demons": "n",
  "nwst demons": "s",
  "college-nwst": "a"
}, {
  name: "Northwestern State Demons",
  shortName: "NWST Demons",
  city: "Northwestern State",
  nickName: "Demons",
  abbreviation: "NWST",
  color: {
    primary: {
      value: "#663399",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#F68428"
    }
  }
}), Fs.set({
  l: "college",
  "sam houston state bearkats": "n",
  "shsu bearkats": "s",
  "college-shsu": "a"
}, {
  name: "Sam Houston State Bearkats",
  shortName: "SHSU Bearkats",
  city: "Sam Houston State",
  nickName: "Bearkats",
  abbreviation: "SHSU",
  color: {
    primary: {
      value: "#fe5100",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "southeastern louisiana lions": "n",
  sela: "s",
  "college-sela": "a"
}, {
  name: "Southeastern Louisiana Lions",
  shortName: "SELA",
  city: "Southeastern Louisiana",
  nickName: "Lions",
  abbreviation: "SELA",
  color: {
    primary: {
      value: "#006341",
      type: "color"
    },
    secondary: {
      value: "#EAAA00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "stephen f. austin lumberjacks": "n",
  "sfa lumberjacks": "s",
  "college-sfa": "a"
}, {
  name: "Stephen F. Austin Lumberjacks",
  shortName: "SFA Lumberjacks",
  city: "Stephen F. Austin",
  nickName: "Lumberjacks",
  abbreviation: "SFA",
  color: {
    primary: {
      value: "#613393",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#f6f6f6"
    }
  }
}), Fs.set({
  l: "college",
  "alabama a&m bulldogs": "n",
  "aamu bulldogs": "s",
  "college-aamu": "a"
}, {
  name: "Alabama A&M Bulldogs",
  shortName: "AAMU Bulldogs",
  city: "Alabama A&M",
  nickName: "Bulldogs",
  abbreviation: "AAMU",
  color: {
    primary: {
      value: "#660000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "alabama state hornets": "n",
  "alst hornets": "s",
  "college-alst": "a"
}, {
  name: "Alabama State Hornets",
  shortName: "ALST Hornets",
  city: "Alabama State",
  nickName: "Hornets",
  abbreviation: "ALST",
  color: {
    primary: {
      value: "#C99700",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "alcorn state braves": "n",
  "alcn braves": "s",
  "college-alcn": "a"
}, {
  name: "Alcorn State Braves",
  shortName: "ALCN Braves",
  city: "Alcorn State",
  nickName: "Braves",
  abbreviation: "ALCN",
  color: {
    primary: {
      value: "#ce8e00",
      type: "color"
    },
    secondary: {
      value: "#4B306A",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "ua pine bluff golden lions": "n",
  "uapb golden lions": "s",
  "college-uapb": "a"
}, {
  name: "UA Pine Bluff Golden Lions",
  shortName: "UAPB Golden Lions",
  city: "Arkansas Pine Bluff",
  nickName: "Golden Lions",
  abbreviation: "UAPB",
  color: {
    primary: {
      value: "#EEB310",
      type: "color"
    },
    secondary: {
      value: "#E31837",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "grambling state tigers": "n",
  "gsu tigers": "s",
  "college-gsu": "a",
  "grambling tigers": "an"
}, {
  name: "Grambling State Tigers",
  alternateNames: ["Grambling Tigers"],
  shortName: "GSU Tigers",
  city: "Grambling State",
  nickName: "Tigers",
  abbreviation: "GSU",
  color: {
    primary: {
      value: "#eaa921",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#101008"
    }
  }
}), Fs.set({
  l: "college",
  "jackson state tigers": "n",
  "jkst tigers": "s",
  "college-jkst": "a"
}, {
  name: "Jackson State Tigers",
  shortName: "JKST Tigers",
  city: "Jackson State",
  nickName: "Tigers",
  abbreviation: "JKST",
  color: {
    primary: {
      value: "#002147",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "mississippi valley state delta devils": "n",
  "mvsu delta devils": "s",
  "college-mvsu": "a"
}, {
  name: "Mississippi Valley State Delta Devils",
  shortName: "MVSU Delta Devils",
  city: "Mississippi Valley State",
  nickName: "Delta Devils",
  abbreviation: "MVSU",
  color: {
    primary: {
      value: "#00703c",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "prairie view a&m panthers": "n",
  pv: "s",
  "college-pv": "a"
}, {
  name: "Prairie View A&M Panthers",
  shortName: "PV",
  city: "Prairie View A&M",
  nickName: "Panthers",
  abbreviation: "PV",
  color: {
    primary: {
      value: "#330066",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FFCC33"
    }
  }
}), Fs.set({
  l: "college",
  "southern jaguars": "n",
  "subr jaguars": "s",
  "college-subr": "a",
  "southern university jaguars": "an"
}, {
  name: "Southern Jaguars",
  alternateNames: ["Southern University Jaguars"],
  shortName: "SUBR Jaguars",
  city: "Southern University",
  nickName: "Jaguars",
  abbreviation: "SUBR",
  color: {
    primary: {
      value: "#58b6e7",
      type: "color"
    },
    secondary: {
      value: "#FFCE34",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "texas southern tigers": "n",
  "txso tigers": "s",
  "college-txso": "a"
}, {
  name: "Texas Southern Tigers",
  shortName: "TXSO Tigers",
  city: "Texas Southern",
  nickName: "Tigers",
  abbreviation: "TXSO",
  color: {
    primary: {
      value: "#7c183e",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "uab blazers": "n",
  "college-uab": "a"
}, {
  name: "UAB Blazers",
  shortName: "UAB Blazers",
  city: "UAB",
  abbreviation: "UAB",
  nickname: "Blazers",
  color: {
    primary: {
      type: "color",
      value: "#006341"
    },
    secondary: {
      type: "color",
      value: "#CC8A00"
    }
  }
}), Fs.set({
  l: "college",
  "binghamton bearcats": "n",
  "bing bearcats": "s",
  "college-bing": "a"
}, {
  name: "Binghamton Bearcats",
  shortName: "BING Bearcats",
  city: "Binghamton",
  nickName: "Bearcats",
  abbreviation: "BING",
  color: {
    primary: {
      type: "color",
      value: "#006F53"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "njit highlanders": "n",
  "college-njit": "a"
}, {
  name: "NJIT Highlanders",
  shortName: "NJIT Highlanders",
  city: "NJIT",
  nickName: "Highlanders",
  abbreviation: "NJIT",
  color: {
    primary: {
      value: "#CC0000",
      type: "color"
    },
    secondary: {
      value: "#000033",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "umbc retrievers": "n",
  "college-umbc": "a"
}, {
  name: "UMBC Retrievers",
  shortName: "UMBC Retrievers",
  city: "UMBC",
  nickName: "Retrievers",
  abbreviation: "UMBC",
  color: {
    primary: {
      type: "color",
      value: "#221F1F"
    },
    secondary: {
      type: "color",
      value: "#FFC10E"
    }
  }
}), Fs.set({
  l: "college",
  "umass lowell river hawks": "n",
  "uml river hawks": "s",
  "college-uml": "a"
}, {
  name: "UMass Lowell River Hawks",
  shortName: "UML River Hawks",
  city: "UMass Lowell",
  nickName: "River Hawks",
  abbreviation: "UML",
  color: {
    primary: {
      value: "#003DA5",
      type: "color"
    },
    secondary: {
      value: "#C8102E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "vermont catamounts": "n",
  "uvm catamounts": "s",
  "college-uvm": "a"
}, {
  name: "Vermont Catamounts",
  shortName: "UVM Catamounts",
  city: "Vermont",
  nickName: "Catamounts",
  abbreviation: "UVM",
  color: {
    primary: {
      value: "#007155",
      type: "color"
    },
    secondary: {
      value: "#FFD416",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "george mason patriots": "n",
  "gmu patriots": "s",
  "college-gmu": "a"
}, {
  name: "George Mason Patriots",
  shortName: "GMU Patriots",
  city: "George Mason",
  nickName: "Patriots",
  abbreviation: "GMU",
  color: {
    primary: {
      type: "color",
      value: "#006539"
    },
    secondary: {
      type: "color",
      value: "#FBC52B"
    }
  }
}), Fs.set({
  l: "college",
  "george washington colonials": "n",
  "gw revolutionaries": "s",
  "college-gw": "a",
  "george washington revolutionaries": "an"
}, {
  name: "George Washington Colonials",
  alternateNames: ["George Washington Revolutionaries"],
  shortName: "GW Revolutionaries",
  city: "George Washington",
  nickName: "Colonials",
  abbreviation: "GW",
  color: {
    primary: {
      type: "color",
      value: "#063065"
    },
    secondary: {
      type: "color",
      value: "#FFB923"
    }
  }
}), Fs.set({
  l: "college",
  "la salle explorers": "n",
  "lasal explorers": "s",
  "college-las": "a"
}, {
  name: "La Salle Explorers",
  shortName: "LaSal Explorers",
  city: "La Salle",
  nickName: "Explorers",
  abbreviation: "LAS",
  color: {
    primary: {
      type: "color",
      value: "#000F4C"
    },
    secondary: {
      type: "color",
      value: "#FFF200"
    }
  }
}), Fs.set({
  l: "college",
  "loyola ramblers": "n",
  "ly-il ramblers": "s",
  "college-lchi": "a"
}, {
  name: "Loyola Ramblers",
  shortName: "Ly-Il Ramblers",
  city: "Loyola Chicago",
  nickName: "Ramblers",
  abbreviation: "LCHI",
  color: {
    primary: {
      value: "#922247",
      type: "color"
    },
    secondary: {
      value: "#FEBD18",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "saint joseph's hawks": "n",
  "st. joe's hawks": "s",
  "college-sju": "a",
  "saint josephs hawks": "an",
  "st joesphs hawks": "an"
}, {
  name: "Saint Joseph's Hawks",
  alternateNames: ["Saint Josephs Hawks", "St Joesphs Hawks"],
  shortName: "St. Joe's Hawks",
  city: "Saint Joseph's",
  nickName: "Hawks",
  abbreviation: "SJU",
  color: {
    primary: {
      type: "color",
      value: "#C2071B"
    },
    secondary: {
      type: "color",
      value: "#0B0908"
    }
  }
}), Fs.set({
  l: "college",
  "saint louis billikens": "n",
  "slu billikens": "s",
  "college-slu": "a"
}, {
  name: "Saint Louis Billikens",
  shortName: "SLU Billikens",
  city: "Saint Louis",
  nickName: "Billikens",
  abbreviation: "SLU",
  color: {
    primary: {
      value: "#003DA5",
      type: "color"
    },
    secondary: {
      value: "#C8C9C7",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "st. bonaventure bonnies": "n",
  "sbu bonnies": "s",
  "college-sbu": "a",
  "saint bonaventure bonnies": "an",
  "st bonaventure bonnies": "an"
}, {
  name: "St. Bonaventure Bonnies",
  alternateNames: ["Saint Bonaventure Bonnies", "St Bonaventure Bonnies"],
  shortName: "SBU Bonnies",
  city: "St. Bonaventure",
  nickName: "Bonnies",
  abbreviation: "SBU",
  color: {
    primary: {
      value: "#54261A",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "vcu rams": "n",
  "college-vcu": "a"
}, {
  name: "VCU Rams",
  shortName: "VCU Rams",
  city: "VCU",
  nickName: "Rams",
  abbreviation: "VCU",
  color: {
    primary: {
      value: "#FFB300",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "bellarmine knights": "n",
  "bell knights": "s",
  "college-bell": "a"
}, {
  name: "Bellarmine Knights",
  shortName: "BELL Knights",
  city: "Bellarmine",
  nickName: "Knights",
  abbreviation: "BELL",
  color: {
    primary: {
      value: "#752936",
      type: "color"
    },
    secondary: {
      value: "#C8C8C8",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "long beach state beach": "n",
  "lbst beach": "s",
  "college-lbst": "a"
}, {
  name: "Long Beach State Beach",
  shortName: "LBST Beach",
  city: "Long Beach State",
  nickName: "Beach",
  abbreviation: "LBST",
  color: {
    primary: {
      value: "#FFC72A",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "florida gulf coast eagles": "n",
  "fgcu eagles": "s",
  "college-fgcu": "a"
}, {
  name: "Florida Gulf Coast Eagles",
  shortName: "FGCU Eagles",
  city: "FGCU",
  nickName: "Eagles",
  abbreviation: "FGCU",
  color: {
    primary: {
      value: "#0051F0",
      type: "color"
    },
    secondary: {
      value: "#007749",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "lipscomb bisons": "n",
  "lip bisons": "s",
  "college-lip": "a"
}, {
  name: "Lipscomb Bisons",
  shortName: "LIP Bisons",
  city: "Lipscomb",
  nickName: "Bisons",
  abbreviation: "LIP",
  color: {
    primary: {
      type: "color",
      value: "#122A65"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "north alabama lions": "n",
  "nortal lions": "s",
  "college-una": "a"
}, {
  name: "North Alabama Lions",
  shortName: "NortAL Lions",
  city: "North Alabama",
  nickName: "Lions",
  abbreviation: "UNA",
  color: {
    primary: {
      value: "#46166B",
      type: "color"
    },
    secondary: {
      value: "#DB9F11",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "north florida ospreys": "n",
  "unf ospreys": "s",
  "college-unf": "a"
}, {
  name: "North Florida Ospreys",
  shortName: "UNF Ospreys",
  city: "North Florida",
  nickName: "Ospreys",
  abbreviation: "UNF",
  color: {
    primary: {
      type: "color",
      value: "#0A548D"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "queens university royals": "n",
  "quc royals": "s",
  "college-quc": "a"
}, {
  name: "Queens University Royals",
  shortName: "QUC Royals",
  city: "Queens University",
  nickName: "Royals",
  abbreviation: "QUC",
  color: {
    primary: {
      value: "#243167",
      type: "color"
    },
    secondary: {
      value: "#857040",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "creighton bluejays": "n",
  "crei bluejays": "s",
  "college-crei": "a"
}, {
  name: "Creighton Bluejays",
  shortName: "CREI Bluejays",
  city: "Creighton",
  nickName: "Bluejays",
  abbreviation: "CREI",
  color: {
    primary: {
      value: "#0054A6",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "depaul blue demons": "n",
  "dpu blue demons": "s",
  "college-dpu": "a"
}, {
  name: "DePaul Blue Demons",
  shortName: "DPU Blue Demons",
  city: "DePaul",
  nickName: "Blue Demons",
  abbreviation: "DPU",
  color: {
    primary: {
      type: "color",
      value: "#336698"
    },
    secondary: {
      type: "color",
      value: "#BD0F10"
    }
  }
}), Fs.set({
  l: "college",
  "marquette golden eagles": "n",
  "marq golden eagles": "s",
  "college-marq": "a"
}, {
  name: "Marquette Golden Eagles",
  shortName: "MARQ Golden Eagles",
  city: "Marquette",
  nickName: "Golden Eagles",
  abbreviation: "MARQ",
  color: {
    primary: {
      value: "#003366",
      type: "color"
    },
    secondary: {
      value: "#FFCC00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "providence friars": "n",
  "prov friars": "s",
  "college-prov": "a"
}, {
  name: "Providence Friars",
  shortName: "PROV Friars",
  city: "Providence",
  nickName: "Friars",
  abbreviation: "PROV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "seton hall pirates": "n",
  "sh pirates": "s",
  "college-hall": "a"
}, {
  name: "Seton Hall Pirates",
  shortName: "SH Pirates",
  city: "Seton Hall",
  nickName: "Pirates",
  abbreviation: "HALL",
  color: {
    primary: {
      value: "#004488",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "st. john's red storm": "n",
  "sju red storm": "s",
  "college-sju": "a",
  "st johns red storm": "an"
}, {
  name: "St. John's Red Storm",
  alternateNames: ["St Johns Red Storm"],
  shortName: "SJU Red Storm",
  city: "St. John's",
  nickName: "Red Storm",
  abbreviation: "SJU",
  color: {
    primary: {
      type: "color",
      value: "#D31145"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "xavier musketeers": "n",
  "xav musketeers": "s",
  "college-xav": "a"
}, {
  name: "Xavier Musketeers",
  shortName: "XAV Musketeers",
  city: "Xavier",
  nickName: "Musketeers",
  abbreviation: "XAV",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      value: "#9EA2A2",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "high point panthers": "n",
  "hpu panthers": "s",
  "college-hpu": "a"
}, {
  name: "High Point Panthers",
  shortName: "HPU Panthers",
  city: "High Point",
  nickName: "Panthers",
  abbreviation: "HPU",
  color: {
    primary: {
      type: "color",
      value: "#AAB3B8"
    },
    secondary: {
      type: "color",
      value: "#342B88"
    }
  }
}), Fs.set({
  l: "college",
  "longwood lancers": "n",
  "long lancers": "s",
  "college-long": "a"
}, {
  name: "Longwood Lancers",
  shortName: "LONG Lancers",
  city: "Longwood",
  nickName: "Lancers",
  abbreviation: "LONG",
  color: {
    primary: {
      type: "color",
      value: "#004990"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "radford highlanders": "n",
  "rad highlanders": "s",
  "college-rad": "a"
}, {
  name: "Radford Highlanders",
  shortName: "RAD Highlanders",
  city: "Radford",
  nickName: "Highlanders",
  abbreviation: "RAD",
  color: {
    primary: {
      type: "color",
      value: "#BC1515"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "unc asheville bulldogs": "n",
  "unca bulldogs": "s",
  "college-unca": "a"
}, {
  name: "UNC Asheville Bulldogs",
  shortName: "UNCA Bulldogs",
  city: "UNC Asheville",
  nickName: "Bulldogs",
  abbreviation: "UNCA",
  color: {
    primary: {
      value: "#003DA5",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "winthrop eagles": "n",
  "win eagles": "s",
  "college-win": "a"
}, {
  name: "Winthrop Eagles",
  shortName: "WIN Eagles",
  city: "Winthrop",
  nickName: "Eagles",
  abbreviation: "WIN",
  color: {
    primary: {
      type: "color",
      value: "#9E0B0E"
    },
    secondary: {
      type: "color",
      value: "#FFAF1E"
    }
  }
}), Fs.set({
  l: "college",
  "cal state bakersfield roadrunners": "n",
  "csb roadrunners": "s",
  "college-csb": "a"
}, {
  name: "Cal State Bakersfield Roadrunners",
  shortName: "CSB Roadrunners",
  city: "Bakersfield",
  nickName: "Roadrunners",
  abbreviation: "CSB",
  color: {
    primary: {
      type: "color",
      value: "#005DAB"
    },
    secondary: {
      type: "color",
      value: "#FFD204"
    }
  }
}), Fs.set({
  l: "college",
  "cal state northridge matadors": "n",
  "csun matadors": "s",
  "college-csun": "a"
}, {
  name: "Cal State Northridge Matadors",
  shortName: "CSUN Matadors",
  city: "CSUN",
  nickName: "Matadors",
  abbreviation: "CSUN",
  color: {
    primary: {
      type: "color",
      value: "#CD1041"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "cal state fullerton titans": "n",
  "csf titans": "s",
  "college-csf": "a"
}, {
  name: "Cal State Fullerton Titans",
  shortName: "CSF Titans",
  city: "Cal State Fullerton",
  nickName: "Titans",
  abbreviation: "CSF",
  color: {
    primary: {
      type: "color",
      value: "#003768"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "uc irvine anteaters": "n",
  "uci anteaters": "s",
  "college-uci": "a"
}, {
  name: "UC Irvine Anteaters",
  shortName: "UCI Anteaters",
  city: "UC Irvine",
  nickName: "Anteaters",
  abbreviation: "UCI",
  color: {
    primary: {
      type: "color",
      value: "#002B5C"
    },
    secondary: {
      type: "color",
      value: "#FBC22D"
    }
  }
}), Fs.set({
  l: "college",
  "uc riverside highlanders": "n",
  "ucrv highlanders": "s",
  "college-ucrv": "a"
}, {
  name: "UC Riverside Highlanders",
  shortName: "UCRV Highlanders",
  city: "UC Riverside",
  nickName: "Highlanders",
  abbreviation: "UCRV",
  color: {
    primary: {
      type: "color",
      value: "#14234F"
    },
    secondary: {
      type: "color",
      value: "#CCA61F"
    }
  }
}), Fs.set({
  l: "college",
  "uc san diego tritons": "n",
  "ucsd tritons": "s",
  "college-ucsd": "a"
}, {
  name: "UC San Diego Tritons",
  shortName: "UCSD Tritons",
  city: "UC San Diego",
  nickName: "Tritons",
  abbreviation: "UCSD",
  color: {
    primary: {
      value: "#192847",
      type: "color"
    },
    secondary: {
      value: "#FBCB07",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "uc santa barbara gauchos": "n",
  "ucsb gauchos": "s",
  "college-ucsb": "a"
}, {
  name: "UC Santa Barbara Gauchos",
  shortName: "UCSB Gauchos",
  city: "UC Santa Barbara",
  nickName: "Gauchos",
  abbreviation: "UCSB",
  color: {
    primary: {
      value: "#003660",
      type: "color"
    },
    secondary: {
      value: "#FEBC11",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "charleston cougars": "n",
  "cofc cougars": "s",
  "college-cofc": "a"
}, {
  name: "Charleston Cougars",
  shortName: "COFC Cougars",
  city: "Charleston",
  nickName: "Cougars",
  abbreviation: "COFC",
  color: {
    primary: {
      type: "color",
      value: "#B5A172"
    },
    secondary: {
      type: "color",
      value: "#6A0018"
    }
  }
}), Fs.set({
  l: "college",
  "drexel dragons": "n",
  "drex dragons": "s",
  "college-drex": "a"
}, {
  name: "Drexel Dragons",
  shortName: "DREX Dragons",
  city: "Drexel",
  nickName: "Dragons",
  abbreviation: "DREX",
  color: {
    primary: {
      type: "color",
      value: "#010160"
    },
    secondary: {
      type: "color",
      value: "#FFDC3E"
    }
  }
}), Fs.set({
  l: "college",
  "hofstra pride": "n",
  "hof pride": "s",
  "college-hof": "a"
}, {
  name: "Hofstra Pride",
  shortName: "HOF Pride",
  city: "Hofstra",
  nickName: "Pride",
  abbreviation: "HOF",
  color: {
    primary: {
      type: "color",
      value: "#0756A4"
    },
    secondary: {
      type: "color",
      value: "#FFCf1B"
    }
  }
}), Fs.set({
  l: "college",
  "northeastern huskies": "n",
  "ne huskies": "s",
  "college-ne": "a"
}, {
  name: "Northeastern Huskies",
  shortName: "NE Huskies",
  city: "Northeastern",
  nickName: "Huskies",
  abbreviation: "NE",
  color: {
    primary: {
      type: "color",
      value: "#CC0001"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "unc wilmington seahawks": "n",
  "uncw seahawks": "s",
  "college-uncw": "a"
}, {
  name: "UNC Wilmington Seahawks",
  shortName: "UNCW Seahawks",
  city: "UNCW",
  nickName: "Seahawks",
  abbreviation: "UNCW",
  color: {
    primary: {
      value: "#003366",
      type: "color"
    },
    secondary: {
      value: "#006666",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "cleveland state vikings": "n",
  "clev vikings": "s",
  "college-clev": "a"
}, {
  name: "Cleveland State Vikings",
  shortName: "CLEV Vikings",
  city: "Cleveland State",
  nickName: "Vikings",
  abbreviation: "CLEV",
  color: {
    primary: {
      value: "#006747",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "detroit mercy titans": "n",
  "det titans": "s",
  "college-det": "a"
}, {
  name: "Detroit Mercy Titans",
  shortName: "DET Titans",
  city: "Detroit",
  nickName: "Titans",
  abbreviation: "DET",
  color: {
    primary: {
      value: "#002D72",
      type: "color"
    },
    secondary: {
      value: "#A6093D",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "iupui jaguars": "n",
  "college-iupu": "a"
}, {
  name: "IUPUI Jaguars",
  shortName: "IUPUI Jaguars",
  city: "IUPUI",
  nickName: "Jaguars",
  abbreviation: "IUPU",
  color: {
    primary: {
      type: "color",
      value: "#A81F30"
    },
    secondary: {
      type: "color",
      value: "#DC973C"
    }
  }
}), Fs.set({
  l: "college",
  "milwaukee panthers": "n",
  "uwm panthers": "s",
  "college-uwm": "a"
}, {
  name: "Milwaukee Panthers",
  shortName: "UWM Panthers",
  city: "Milwaukee",
  nickName: "Panthers",
  abbreviation: "UWM",
  color: {
    primary: {
      value: "#FFBD00",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "northern kentucky norse": "n",
  "nku norse": "s",
  "college-nku": "a"
}, {
  name: "Northern Kentucky Norse",
  shortName: "NKU Norse",
  city: "Northern Kentucky",
  nickName: "Norse",
  abbreviation: "NKU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#ffc72c",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oakland golden grizzlies": "n",
  "oak golden grizzlies": "s",
  "college-oak": "a"
}, {
  name: "Oakland Golden Grizzlies",
  shortName: "OAK Golden Grizzlies",
  city: "Oakland",
  nickName: "Golden Grizzlies",
  abbreviation: "OAK",
  color: {
    primary: {
      type: "color",
      value: "#000000"
    },
    secondary: {
      type: "color",
      value: "#998448"
    }
  }
}), Fs.set({
  l: "college",
  "purdue fort wayne mastodons": "n",
  "pfw mastodons": "s",
  "college-pfw": "a"
}, {
  name: "Purdue Fort Wayne Mastodons",
  shortName: "PFW Mastodons",
  city: "Purdue Fort Wayne",
  nickName: "Mastodons",
  abbreviation: "PFW",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#C28E0E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "wright state raiders": "n",
  "wrst raiders": "s",
  "college-wrst": "a"
}, {
  name: "Wright State Raiders",
  shortName: "WRST Raiders",
  city: "Wright State",
  nickName: "Raiders",
  abbreviation: "WRST",
  color: {
    primary: {
      type: "color",
      value: "#006F53"
    },
    secondary: {
      type: "color",
      value: "#E9AF10"
    }
  }
}), Fs.set({
  l: "college",
  "chicago state cougars": "n",
  "chs cougars": "s",
  "college-chs": "a"
}, {
  name: "Chicago State Cougars",
  shortName: "CHS Cougars",
  city: "Chicago State",
  nickName: "Cougars",
  abbreviation: "CHS",
  color: {
    primary: {
      type: "color",
      value: "#006700"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "hartford hawks": "n",
  "hart hawks": "s",
  "college-hart": "a"
}, {
  name: "Hartford Hawks",
  shortName: "HART Hawks",
  city: "Hartford",
  nickName: "Hawks",
  abbreviation: "HART",
  color: {
    primary: {
      type: "color",
      value: "#ED1B2E"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "canisius golden griffins": "n",
  "can golden griffins": "s",
  "college-can": "a"
}, {
  name: "Canisius Golden Griffins",
  shortName: "CAN Golden Griffins",
  city: "Canisius",
  nickName: "Golden Griffins",
  abbreviation: "CAN",
  color: {
    primary: {
      type: "color",
      value: "#002859"
    },
    secondary: {
      type: "color",
      value: "#EEB211"
    }
  }
}), Fs.set({
  l: "college",
  "fairfield stags": "n",
  "fair stags": "s",
  "college-fair": "a"
}, {
  name: "Fairfield Stags",
  shortName: "FAIR Stags",
  city: "Fairfield",
  nickName: "Stags",
  abbreviation: "FAIR",
  color: {
    primary: {
      type: "color",
      value: "#181111"
    },
    secondary: {
      type: "color",
      value: "#D4290F"
    }
  }
}), Fs.set({
  l: "college",
  "iona gaels": "n",
  "college-iona": "a"
}, {
  name: "Iona Gaels",
  shortName: "IONA Gaels",
  city: "Iona",
  nickName: "Gaels",
  abbreviation: "IONA",
  color: {
    primary: {
      value: "#6F2C3F",
      type: "color"
    },
    secondary: {
      value: "#F2A900",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "manhattan jaspers": "n",
  "man jaspers": "s",
  "college-man": "a"
}, {
  name: "Manhattan Jaspers",
  shortName: "MAN Jaspers",
  city: "Manhattan",
  nickName: "Jaspers",
  abbreviation: "MAN",
  color: {
    primary: {
      type: "color",
      value: "#528C39"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "mount saint mary's mountaineers": "n",
  "msm mountaineers": "s",
  "college-msm": "a"
}, {
  name: "Mount Saint Mary's Mountaineers",
  shortName: "MSM Mountaineers",
  city: "Mount St. Mary's",
  nickName: "Mountaineers",
  abbreviation: "MSM",
  color: {
    primary: {
      value: "#002855",
      type: "color"
    },
    secondary: {
      value: "#84754E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "niagara purple eagles": "n",
  "niag purple eagles": "s",
  "college-niag": "a"
}, {
  name: "Niagara Purple Eagles",
  shortName: "NIAG Purple Eagles",
  city: "Niagara",
  nickName: "Purple Eagles",
  abbreviation: "NIAG",
  color: {
    primary: {
      type: "color",
      value: "#69207E"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "quinnipiac bobcats": "n",
  "qu bobcats": "s",
  "college-qu": "a"
}, {
  name: "Quinnipiac Bobcats",
  shortName: "QU Bobcats",
  city: "Quinnipiac",
  nickName: "Bobcats",
  abbreviation: "QU",
  color: {
    primary: {
      type: "color",
      value: "#0C2340"
    },
    secondary: {
      type: "color",
      value: "#FFB81C"
    }
  }
}), Fs.set({
  l: "college",
  "le moyne dolphins": "n",
  "lm dolphins": "s",
  "college-lm": "a"
}, {
  name: "Le Moyne Dolphins",
  shortName: "LM Dolphins",
  city: "Le Moyne",
  nickName: "Dolphins",
  abbreviation: "LM",
  color: {
    primary: {
      type: "color",
      value: "#00452A"
    },
    secondary: {
      type: "color",
      value: "#FCE300"
    }
  }
}), Fs.set({
  l: "college",
  "rider broncs": "n",
  "rid broncs": "s",
  "college-rid": "a"
}, {
  name: "Rider Broncs",
  shortName: "RID Broncs",
  city: "Rider",
  nickName: "Broncs",
  abbreviation: "RID",
  color: {
    primary: {
      type: "color",
      value: "#A80532"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "st. peter's peacocks": "n",
  "spu peacocks": "s",
  "college-spu": "a",
  "st. pete peacocks": "an"
}, {
  name: "St. Peter's Peacocks",
  alternateNames: ["St. Pete Peacocks"],
  shortName: "SPU Peacocks",
  city: "Saint Peter's",
  nickName: "Peacocks",
  abbreviation: "SPU",
  color: {
    primary: {
      type: "color",
      value: "#004CC2"
    },
    secondary: {
      type: "color",
      value: "#30C808"
    }
  }
}), Fs.set({
  l: "college",
  "siena saints": "n",
  "sie saints": "s",
  "college-sie": "a"
}, {
  name: "Siena Saints",
  shortName: "SIE Saints",
  city: "Siena",
  nickName: "Saints",
  abbreviation: "SIE",
  color: {
    primary: {
      value: "#006B54",
      type: "color"
    },
    secondary: {
      value: "#FCC917",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "coppin state eagles": "n",
  "copp eagles": "s",
  "college-copp": "a"
}, {
  name: "Coppin State Eagles",
  shortName: "COPP Eagles",
  city: "Coppin State",
  nickName: "Eagles",
  abbreviation: "COPP",
  color: {
    primary: {
      type: "color",
      value: "#2E3192"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "maryland eastern shore hawks": "n",
  "umes hawks": "s",
  "college-umes": "a"
}, {
  name: "Maryland Eastern Shore Hawks",
  shortName: "UMES Hawks",
  city: "UMES",
  nickName: "Hawks",
  abbreviation: "UMES",
  color: {
    primary: {
      value: "#822433",
      type: "color"
    },
    secondary: {
      value: "#8B8D8E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "belmont bruins": "n",
  "bel bruins": "s",
  "college-bel": "a"
}, {
  name: "Belmont Bruins",
  shortName: "BEL Bruins",
  city: "Belmont",
  nickName: "Bruins",
  abbreviation: "BEL",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      value: "#00205B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "bradley braves": "n",
  "brad braves": "s",
  "college-brad": "a"
}, {
  name: "Bradley Braves",
  shortName: "BRAD Braves",
  city: "Bradley",
  nickName: "Braves",
  abbreviation: "BRAD",
  color: {
    primary: {
      type: "color",
      value: "#FF151A"
    },
    secondary: {
      type: "color",
      value: "F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "evansville purple aces": "n",
  "evan aces": "s",
  "college-evan": "a"
}, {
  name: "Evansville Purple Aces",
  shortName: "EVAN Aces",
  city: "Evansville",
  nickName: "Aces",
  abbreviation: "EVAN",
  color: {
    primary: {
      value: "#52237F",
      type: "color"
    },
    secondary: {
      value: "#F36F21",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "uic flames": "n",
  "college-uic": "a"
}, {
  name: "UIC Flames",
  shortName: "UIC Flames",
  city: "UIC",
  nickName: "Flames",
  abbreviation: "UIC",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      value: "#AC1E2D",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "fairleigh dickinson knights": "n",
  "fdu knights": "s",
  "college-fdu": "a"
}, {
  name: "Fairleigh Dickinson Knights",
  shortName: "FDU Knights",
  city: "Fairleigh Dickinson",
  nickName: "Knights",
  abbreviation: "FDU",
  color: {
    primary: {
      value: "#9d2235",
      type: "color"
    },
    secondary: {
      value: "#003882",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "merrimack warriors": "n",
  "mrmk warriors": "s",
  "college-mrmk": "a"
}, {
  name: "Merrimack Warriors",
  shortName: "MRMK Warriors",
  city: "Merrimack",
  nickName: "Warriors",
  abbreviation: "MRMK",
  color: {
    primary: {
      value: "#003768",
      type: "color"
    },
    secondary: {
      value: "#FDB813",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "st. francis brooklyn terriers": "n",
  "sfny ny terriers": "s",
  "college-sfny": "a",
  "st francis brooklyn terriers": "an"
}, {
  name: "St. Francis Brooklyn Terriers",
  alternateNames: ["St Francis Brooklyn Terriers"],
  shortName: "SFNY NY Terriers",
  city: "St. Francis Brooklyn",
  nickName: "Terriers",
  abbreviation: "SFNY",
  color: {
    primary: {
      value: "#CE1126",
      type: "color"
    },
    secondary: {
      value: "#0038A8",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "stonehill skyhawks": "n",
  "shc skyhawks": "s",
  "college-shc": "a"
}, {
  name: "Stonehill Skyhawks",
  shortName: "SHC Skyhawks",
  city: "Stonehill",
  nickName: "Skyhawks",
  abbreviation: "SHC",
  color: {
    primary: {
      value: "#2F2975",
      type: "color"
    },
    secondary: {
      value: "F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "lindenwood lions": "n",
  "lwu lions": "s",
  "college-lwu": "a"
}, {
  name: "Lindenwood Lions",
  shortName: "LWU Lions",
  city: "Lindenwood",
  nickName: "Lions",
  abbreviation: "LWU",
  color: {
    primary: {
      value: "#231F20",
      type: "color"
    },
    secondary: {
      value: "#C8B362",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "little rock trojans": "n",
  "ualr trojans": "s",
  "college-ualr": "a"
}, {
  name: "Little Rock Trojans",
  shortName: "UALR Trojans",
  city: "Little Rock",
  nickName: "Trojans",
  abbreviation: "UALR",
  color: {
    primary: {
      value: "#6E2639",
      type: "color"
    },
    secondary: {
      value: "#A7A9AC",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "siu edwardsville cougars": "n",
  "siue cougars": "s",
  "college-siue": "a"
}, {
  name: "SIU Edwardsville Cougars",
  shortName: "SIUE Cougars",
  city: "SIUE",
  nickName: "Cougars",
  abbreviation: "SIUE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#EF3829",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "southern indiana screaming eagles": "n",
  "usi screaming eagles": "s",
  "college-usi": "a"
}, {
  name: "Southern Indiana Screaming Eagles",
  shortName: "USI Screaming Eagles",
  city: "Southern Indiana",
  nickName: "Screaming Eagles",
  abbreviation: "USI",
  color: {
    primary: {
      value: "#DD1731",
      type: "color"
    },
    secondary: {
      value: "#0F2B53",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "american eagles": "n",
  "amer eagles": "s",
  "college-amer": "a"
}, {
  name: "American Eagles",
  shortName: "AMER Eagles",
  city: "American University",
  nickName: "Eagles",
  abbreviation: "AMER",
  color: {
    primary: {
      value: "#F0F0F0",
      type: "color"
    },
    secondary: {
      value: "#C41230",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "boston university terriers": "n",
  "bu terriers": "s",
  "college-bu": "a"
}, {
  name: "Boston University Terriers",
  shortName: "BU Terriers",
  city: "Boston University",
  nickName: "Terriers",
  abbreviation: "BU",
  color: {
    primary: {
      type: "color",
      value: "#DD072E"
    },
    secondary: {
      type: "color",
      value: "#F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "loyola greyhounds": "n",
  "lmd greyhounds": "s",
  "college-lmd": "a"
}, {
  name: "Loyola Greyhounds",
  shortName: "LMD Greyhounds",
  city: "Loyola Maryland",
  nickName: "Greyhounds",
  abbreviation: "LMD",
  color: {
    primary: {
      value: "#00694E",
      type: "color"
    },
    secondary: {
      value: "#CACAC8",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "unc greensboro spartans": "n",
  "uncg spartans": "s",
  "college-uncg": "a"
}, {
  name: "UNC Greensboro Spartans",
  shortName: "UNCG Spartans",
  city: "UNCG",
  nickName: "Spartans",
  abbreviation: "UNCG",
  color: {
    primary: {
      type: "color",
      value: "#003559"
    },
    secondary: {
      type: "color",
      value: "#E6BE2A"
    }
  }
}), Fs.set({
  l: "college",
  "houston christian huskies": "n",
  "hcu huskies": "s",
  "college-hcu": "a"
}, {
  name: "Houston Christian Huskies",
  shortName: "HCU Huskies",
  city: "Houston Christian",
  nickName: "Huskies",
  abbreviation: "HCU",
  color: {
    primary: {
      value: "#1C4E9D",
      type: "color"
    },
    secondary: {
      value: "#F3652C",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "new orleans privateers": "n",
  "uno privateers": "s",
  "college-uno": "a"
}, {
  name: "New Orleans Privateers",
  shortName: "UNO Privateers",
  city: "New Orleans",
  nickName: "Privateers",
  abbreviation: "UNO",
  color: {
    primary: {
      type: "color",
      value: "#2B3986"
    },
    secondary: {
      type: "color",
      value: "#F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "texas a&m-commerce lions": "n",
  "tamc lions": "s",
  "college-tamc": "a",
  "texas a&m commerce lions": "an"
}, {
  name: "Texas A&M-Commerce Lions",
  alternateNames: ["Texas A&M Commerce Lions"],
  shortName: "TAMC Lions",
  city: "Texas A&M-Commerce",
  nickName: "Lions",
  abbreviation: "TAMC",
  color: {
    primary: {
      value: "#1D2953",
      type: "color"
    },
    secondary: {
      value: "#E8A311",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "texas a&m-corpus christi islanders": "n",
  "tamu-cc islanders": "s",
  "college-tamu-cc": "a",
  "texas a&m corpus christi islanders": "an",
  "texas a&m corpus islanders": "an"
}, {
  name: "Texas A&M-Corpus Christi Islanders",
  alternateNames: ["Texas A&M Corpus Christi Islanders", "Texas A&M Corpus Islanders"],
  shortName: "TAMU-CC Islanders",
  city: "Texas A&M-Corpus Christi",
  nickName: "Islanders",
  abbreviation: "TAMU-CC",
  color: {
    primary: {
      value: "#0067C5",
      type: "color"
    },
    secondary: {
      value: "#007F3E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "gonzaga bulldogs": "n",
  "gonz bulldogs": "s",
  "college-gonz": "a"
}, {
  name: "Gonzaga Bulldogs",
  shortName: "Gonz Bulldogs",
  city: "Gonzaga",
  nickName: "Bulldogs",
  abbreviation: "GONZ",
  color: {
    primary: {
      value: "#041E42",
      type: "color"
    },
    secondary: {
      value: "#C8102E",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "loyola marymount lions": "n",
  "lmu lions": "s",
  "college-lmu": "a"
}, {
  name: "Loyola Marymount Lions",
  shortName: "LMU Lions",
  city: "Loyola Marymount",
  nickName: "Lions",
  abbreviation: "LMU",
  color: {
    primary: {
      type: "color",
      value: "#8C0029"
    },
    secondary: {
      type: "color",
      value: "#00314A"
    }
  }
}), Fs.set({
  l: "college",
  "pacific tigers": "n",
  "pac tigers": "s",
  "college-pac": "a"
}, {
  name: "Pacific Tigers",
  shortName: "Pac Tigers",
  city: "Pacific",
  nickName: "Tigers",
  abbreviation: "PAC",
  color: {
    primary: {
      type: "color",
      value: "#F47820"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "pepperdine waves": "n",
  "pepp waves": "s",
  "college-pepp": "a"
}, {
  name: "Pepperdine Waves",
  shortName: "PEPP Waves",
  city: "Pepperdine",
  nickName: "Waves",
  abbreviation: "PEPP",
  color: {
    primary: {
      type: "color",
      value: "#009C98"
    },
    secondary: {
      type: "color",
      value: "#003A72"
    }
  }
}), Fs.set({
  l: "college",
  "portland pilots": "n",
  "port pilots": "s",
  "college-port": "a"
}, {
  name: "Portland Pilots",
  shortName: "PORT Pilots",
  city: "Portland",
  nickName: "Pilots",
  abbreviation: "PORT",
  color: {
    primary: {
      type: "color",
      value: "#0E034E"
    },
    secondary: {
      type: "color",
      value: "#F0F0F0"
    }
  }
}), Fs.set({
  l: "college",
  "saint mary's gaels": "n",
  "stm gaels": "s",
  "college-stm": "a",
  "st. mary's gaels": "an",
  "st marys gaels": "an",
  "saint marys gaels": "an"
}, {
  name: "Saint Mary's Gaels",
  alternateNames: ["St. Mary's Gaels", "St Marys Gaels", "Saint Marys Gaels"],
  shortName: "STM Gaels",
  city: "Saint Mary's",
  nickName: "Gaels",
  abbreviation: "STM",
  color: {
    primary: {
      value: "#D80024",
      type: "color"
    },
    secondary: {
      value: "#06315B",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "san francisco dons": "n",
  "sf dons": "s",
  "college-sf": "a"
}, {
  name: "San Francisco Dons",
  shortName: "SF Dons",
  city: "San Francisco",
  nickName: "Dons",
  abbreviation: "SF",
  color: {
    primary: {
      type: "color",
      value: "#22523F"
    },
    secondary: {
      type: "color",
      value: "#FFE13A"
    }
  }
}), Fs.set({
  l: "college",
  "santa clara broncos": "n",
  "scu broncos": "s",
  "college-scu": "a"
}, {
  name: "Santa Clara Broncos",
  shortName: "SCU Broncos",
  city: "Santa Clara",
  nickName: "Broncos",
  abbreviation: "SCU",
  color: {
    primary: {
      value: "#862633",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "california baptist lancers": "n",
  "calbap lancers": "s",
  "college-calbap": "a"
}, {
  name: "California Baptist Lancers",
  shortName: "CalBap Lancers",
  city: "California Baptist",
  nickName: "Lancers",
  abbreviation: "CALBAP",
  color: {
    primary: {
      value: "#002554",
      type: "color"
    },
    secondary: {
      value: "#A37400",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "grand canyon antelopes": "n",
  "gcu antelopes": "s",
  "college-gcu": "a"
}, {
  name: "Grand Canyon Antelopes",
  shortName: "GCU Antelopes",
  city: "Grand Canyon",
  nickName: "Antelopes",
  abbreviation: "GCU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#522398",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "seattle redhawks": "n",
  "sea redhawks": "s",
  "college-sea": "a"
}, {
  name: "Seattle Redhawks",
  shortName: "SEA Redhawks",
  city: "Seattle",
  nickName: "Redhawks",
  abbreviation: "SEA",
  color: {
    primary: {
      type: "color",
      value: "#BF2E1A"
    },
    secondary: {
      type: "color",
      value: "#231F20"
    }
  }
}), Fs.set({
  l: "college",
  "ut arlington mavericks": "n",
  "uta mavericks": "s",
  "college-uta": "a"
}, {
  name: "UT Arlington Mavericks",
  shortName: "UTA Mavericks",
  city: "UT Arlington",
  nickName: "Mavericks",
  abbreviation: "UTA",
  color: {
    primary: {
      value: "#0064B1",
      type: "color"
    },
    secondary: {
      value: "#F58025",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "ut rio grande valley vaqueros": "n",
  "utrgv vaqueros": "s",
  "college-utrgv": "a"
}, {
  name: "UT Rio Grande Valley Vaqueros",
  shortName: "UTRGV Vaqueros",
  city: "UT Rio Grande Valley",
  nickName: "Vaqueros",
  abbreviation: "UTRGV",
  color: {
    primary: {
      value: "#F05023",
      type: "color"
    },
    secondary: {
      value: "#FFA300",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "utah tech trailblazers": "n",
  "ut trailblazers": "s",
  "college-ut": "a"
}, {
  name: "Utah Tech Trailblazers",
  shortName: "UT Trailblazers",
  city: "Utah Tech",
  nickName: "Trailblazers",
  abbreviation: "UT",
  color: {
    primary: {
      value: "#BA1C21",
      type: "color"
    },
    secondary: {
      value: "#003058",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "utah valley wolverines": "n",
  "uvu wolverines": "s",
  "college-uvu": "a"
}, {
  name: "Utah Valley Wolverines",
  shortName: "UVU Wolverines",
  city: "Utah Valley",
  nickName: "Wolverines",
  abbreviation: "UVU",
  color: {
    primary: {
      value: "#275D38",
      type: "color"
    },
    secondary: {
      value: "#000000",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "denver pioneers": "n",
  "college-den": "a"
}, {
  name: "Denver Pioneers",
  shortName: "Denver Pioneers",
  city: "Denver",
  nickName: "Pioneers",
  abbreviation: "DEN",
  color: {
    primary: {
      type: "color",
      value: "#98002E"
    },
    secondary: {
      type: "color",
      value: "#AA976C"
    }
  }
}), Fs.set({
  l: "college",
  "kansas city roos": "n",
  "umkc roos": "s",
  "college-umkc": "a",
  "umkc kangaroos": "an"
}, {
  name: "Kansas City Roos",
  alternateNames: ["UMKC Kangaroos"],
  shortName: "UMKC Roos",
  city: "Kansas City",
  nickName: "Roos",
  abbreviation: "UMKC",
  color: {
    primary: {
      value: "#005293",
      type: "color"
    },
    secondary: {
      value: "#FECB00",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "omaha mavericks": "n",
  "oma mavericks": "s",
  "college-oma": "a"
}, {
  name: "Omaha Mavericks",
  shortName: "OMA Mavericks",
  city: "Omaha",
  nickName: "Mavericks",
  abbreviation: "OMA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#D71920",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "oral roberts golden eagles": "n",
  "oru golden eagles": "s",
  "college-oru": "a"
}, {
  name: "Oral Roberts Golden Eagles",
  shortName: "ORU Golden Eagles",
  city: "Oral Roberts",
  nickName: "Golden Eagles",
  abbreviation: "ORU",
  color: {
    primary: {
      value: "#002F60",
      type: "color"
    },
    secondary: {
      value: "#C5B783",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "st. thomas (mn) tommies": "n",
  "ust tommies": "s",
  "college-ust": "a"
}, {
  name: "St. Thomas (MN) Tommies",
  shortName: "UST Tommies",
  city: "St. Thomas (MN)",
  nickName: "Tommies",
  abbreviation: "UST",
  color: {
    primary: {
      value: "#512773",
      type: "color"
    },
    secondary: {
      value: "#F0F0F0",
      type: "color"
    }
  }
}), Fs.set({
  l: "college",
  "wichita state shockers": "n",
  "wich shockers": "s",
  "college-wich": "a"
}, {
  name: "Wichita State Shockers",
  shortName: "Wich Shockers",
  city: "Wichita State",
  nickName: "Shockers",
  abbreviation: "WICH",
  color: {
    primary: {
      type: "color",
      value: "#101008"
    },
    secondary: {
      type: "color",
      value: "#F8D429"
    }
  }
}), Fs.set({
  l: "college",
  "usc upstate spartans": "n",
  "upst spartans": "s",
  "college-upst": "a",
  "usc upstate": "an"
}, {
  name: "USC Upstate Spartans",
  alternateNames: ["USC Upstate"],
  shortName: "UPST Spartans",
  city: "Spartanburg",
  nickName: "Spartans",
  abbreviation: "UPST",
  color: {
    primary: {
      type: "color",
      value: "#00703C"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "college",
  "green bay phoenix": "n",
  "gb phoenix": "s",
  "college-gbp": "a"
}, {
  name: "Green Bay Phoenix",
  shortName: "GB Phoenix",
  nickName: "Phoenix",
  city: "Green Bay",
  abbreviation: "GBP",
  color: {
    primary: {
      type: "color",
      value: "#006747"
    },
    secondary: {
      type: "color",
      value: "#9D2235"
    }
  }
}), Fs.set({
  l: "college",
  "ut martin skyhawks": "n",
  "utm skyhawks": "s",
  "college-utm": "a"
}, {
  name: "UT Martin Skyhawks",
  shortName: "UTM Skyhawks",
  city: "Tennessee-Martin",
  nickName: "Skyhawks",
  abbreviation: "UTM",
  color: {
    primary: {
      type: "color",
      value: "#F79728"
    },
    secondary: {
      type: "color",
      value: "#002A5B"
    }
  }
}), Fs.set({
  l: "college",
  "san diego state aztecs": "n",
  "sdsu aztecs": "s",
  "college-sdsu": "a",
  "san diego st aztecs": "an",
  "san diego st": "an"
}, {
  name: "San Diego State Aztecs",
  alternateNames: ["San Diego St Aztecs", "San Diego St"],
  shortName: "SDSU Aztecs",
  city: "San Diego State",
  nickName: "Aztecs",
  abbreviation: "SDSU",
  color: {
    primary: {
      type: "color",
      value: "#231F20"
    },
    secondary: {
      type: "color",
      value: "#BF2C37"
    }
  }
}), Fs.set({
  l: "wnba",
  "atlanta dream": "n",
  "atl dream": "s",
  "wnba-atl": "a"
}, {
  name: "Atlanta Dream",
  shortName: "ATL Dream",
  city: "Atlanta",
  nickName: "Dream",
  abbreviation: "ATL",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#418FDE"
    }
  }
}), Fs.set({
  l: "wnba",
  "dallas wings": "n",
  "dal wings": "s",
  "wnba-dal": "a"
}, {
  name: "Dallas Wings",
  shortName: "DAL Wings",
  city: "Dallas",
  nickName: "Wings",
  abbreviation: "DAL",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#C4D600"
    }
  }
}), Fs.set({
  l: "wnba",
  "las vegas aces": "n",
  "las aces": "s",
  "wnba-las": "a"
}, {
  name: "Las Vegas Aces",
  shortName: "LAS Aces",
  city: "Las Vegas",
  nickName: "Aces",
  abbreviation: "LAS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#9FA0A2"
    }
  }
}), Fs.set({
  l: "wnba",
  "los angeles sparks": "n",
  "la sparks": "s",
  "wnba-las": "a"
}, {
  name: "Los Angeles Sparks",
  shortName: "LA Sparks",
  city: "Los Angeles",
  nickName: "Sparks",
  abbreviation: "LAS",
  color: {
    primary: {
      value: "#FFC72C",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#702F8A"
    }
  }
}), Fs.set({
  l: "wnba",
  "connecticut sun": "n",
  "con sun": "s",
  "wnba-con": "a"
}, {
  name: "Connecticut Sun",
  shortName: "CON Sun",
  city: "Connecticut",
  nickName: "Sun",
  abbreviation: "CON",
  color: {
    primary: {
      value: "#DC4405",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FEFEFE"
    }
  }
}), Fs.set({
  l: "wnba",
  "minnesota lynx": "n",
  "min lynx": "s",
  "wnba-min": "a"
}, {
  name: "Minnesota Lynx",
  shortName: "MIN Lynx",
  city: "Minnesota",
  nickName: "Lynx",
  abbreviation: "MIN",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#236192"
    }
  }
}), Fs.set({
  l: "wnba",
  "new york liberty": "n",
  "nyl liberty": "s",
  "wnba-nyl": "a"
}, {
  name: "New York Liberty",
  shortName: "NYL Liberty",
  city: "New York",
  nickName: "Liberty",
  abbreviation: "NYL",
  color: {
    primary: {
      value: "#87CFBD",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#000000"
    }
  }
}), Fs.set({
  l: "wnba",
  "phoenix mercury": "n",
  "pho mercury": "s",
  "wnba-pho": "a"
}, {
  name: "Phoenix Mercury",
  shortName: "PHO Mercury",
  city: "Phoenix",
  nickName: "Mercury",
  abbreviation: "PHO",
  color: {
    primary: {
      value: "#201747",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#CB6015"
    }
  }
}), Fs.set({
  l: "wnba",
  "seattle storm": "n",
  "sea storm": "s",
  "wnba-sea": "a"
}, {
  name: "Seattle Storm",
  shortName: "SEA Storm",
  city: "Seattle",
  nickName: "Storm",
  abbreviation: "SEA",
  color: {
    primary: {
      value: "#2C5234",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#FBE122"
    }
  }
}), Fs.set({
  l: "wnba",
  "indiana fever": "n",
  "ind fever": "s",
  "wnba-ind": "a"
}, {
  name: "Indiana Fever",
  shortName: "IND Fever",
  city: "Indiana",
  nickName: "Fever",
  abbreviation: "IND",
  color: {
    primary: {
      value: "#C8102E",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#041E42"
    }
  }
}), Fs.set({
  l: "wnba",
  "washington mystics": "n",
  "was mystics": "s",
  "wnba-was": "a"
}, {
  name: "Washington Mystics",
  shortName: "WAS Mystics",
  city: "Washington",
  nickName: "Mystics",
  abbreviation: "WAS",
  color: {
    primary: {
      value: "#0C2340",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#C8102E"
    }
  }
}), Fs.set({
  l: "wnba",
  "chicago sky": "n",
  "chi sky": "s",
  "wnba-chi": "a"
}, {
  name: "Chicago Sky",
  shortName: "CHI Sky",
  city: "Chicago",
  nickName: "Sky",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#FFCD00",
      type: "color"
    },
    secondary: {
      type: "color",
      value: "#418FDE"
    }
  }
}), Fs.set({
  l: "countries",
  afghanistan: "n",
  "countries-afg": "a"
}, {
  name: "Afghanistan",
  alternateNames: [],
  shortName: "Afghanistan",
  city: "Afghanistan",
  nickName: "Afghanistan",
  abbreviation: "AFG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  albania: "n",
  "countries-alb": "a"
}, {
  name: "Albania",
  alternateNames: [],
  shortName: "Albania",
  city: "Albania",
  nickName: "Albania",
  abbreviation: "ALB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  algeria: "n",
  "countries-alg": "a"
}, {
  name: "Algeria",
  alternateNames: [],
  shortName: "Algeria",
  city: "Algeria",
  nickName: "Algeria",
  abbreviation: "ALG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  andorra: "n",
  "countries-and": "a"
}, {
  name: "Andorra",
  alternateNames: [],
  shortName: "Andorra",
  city: "Andorra",
  nickName: "Andorra",
  abbreviation: "AND",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  angola: "n",
  "countries-ang": "a"
}, {
  name: "Angola",
  alternateNames: [],
  shortName: "Angola",
  city: "Angola",
  nickName: "Angola",
  abbreviation: "ANG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "antigua and barbuda": "n",
  "countries-ant": "a",
  barbuda: "an"
}, {
  name: "Antigua and Barbuda",
  alternateNames: ["Barbuda"],
  shortName: "Antigua and Barbuda",
  city: "Antigua and Barbuda",
  nickName: "Antigua and Barbuda",
  abbreviation: "ANT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  argentina: "n",
  "countries-arg": "a"
}, {
  name: "Argentina",
  alternateNames: [],
  shortName: "Argentina",
  city: "Argentina",
  nickName: "Argentina",
  abbreviation: "ARG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  armenia: "n",
  "countries-arm": "a"
}, {
  name: "Armenia",
  alternateNames: [],
  shortName: "Armenia",
  city: "Armenia",
  nickName: "Armenia",
  abbreviation: "ARM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  aruba: "n",
  "countries-aru": "a"
}, {
  name: "Aruba",
  alternateNames: [],
  shortName: "Aruba",
  city: "Aruba",
  nickName: "Aruba",
  abbreviation: "ARU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "american samoa": "n",
  "countries-asa": "a"
}, {
  name: "American Samoa",
  alternateNames: [],
  shortName: "American Samoa",
  city: "American Samoa",
  nickName: "American Samoa",
  abbreviation: "ASA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  australia: "n",
  "countries-aus": "a"
}, {
  name: "Australia",
  alternateNames: [],
  shortName: "Australia",
  city: "Australia",
  nickName: "Australia",
  abbreviation: "AUS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  austria: "n",
  "countries-aut": "a"
}, {
  name: "Austria",
  alternateNames: [],
  shortName: "Austria",
  city: "Austria",
  nickName: "Austria",
  abbreviation: "AUT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  azerbaijan: "n",
  "countries-aze": "a"
}, {
  name: "Azerbaijan",
  alternateNames: [],
  shortName: "Azerbaijan",
  city: "Azerbaijan",
  nickName: "Azerbaijan",
  abbreviation: "AZE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bahamas: "n",
  "countries-bah": "a"
}, {
  name: "Bahamas",
  alternateNames: [],
  shortName: "Bahamas",
  city: "Bahamas",
  nickName: "Bahamas",
  abbreviation: "BAH",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bangladesh: "n",
  "countries-ban": "a"
}, {
  name: "Bangladesh",
  alternateNames: [],
  shortName: "Bangladesh",
  city: "Bangladesh",
  nickName: "Bangladesh",
  abbreviation: "BAN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  barbados: "n",
  "countries-bar": "a"
}, {
  name: "Barbados",
  alternateNames: [],
  shortName: "Barbados",
  city: "Barbados",
  nickName: "Barbados",
  abbreviation: "BAR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  burundi: "n",
  "countries-bdi": "a"
}, {
  name: "Burundi",
  alternateNames: [],
  shortName: "Burundi",
  city: "Burundi",
  nickName: "Burundi",
  abbreviation: "BDI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  belgium: "n",
  "countries-bel": "a"
}, {
  name: "Belgium",
  alternateNames: [],
  shortName: "Belgium",
  city: "Belgium",
  nickName: "Belgium",
  abbreviation: "BEL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  benin: "n",
  "countries-ben": "a"
}, {
  name: "Benin",
  alternateNames: [],
  shortName: "Benin",
  city: "Benin",
  nickName: "Benin",
  abbreviation: "BEN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bermuda: "n",
  "countries-ber": "a"
}, {
  name: "Bermuda",
  alternateNames: [],
  shortName: "Bermuda",
  city: "Bermuda",
  nickName: "Bermuda",
  abbreviation: "BER",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bhutan: "n",
  "countries-bhu": "a"
}, {
  name: "Bhutan",
  alternateNames: [],
  shortName: "Bhutan",
  city: "Bhutan",
  nickName: "Bhutan",
  abbreviation: "BHU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "bosnia and herzegovina": "n",
  "countries-bih": "a",
  bosnia: "an"
}, {
  name: "Bosnia and Herzegovina",
  alternateNames: ["Bosnia"],
  shortName: "Bosnia and Herzegovina",
  city: "Bosnia and Herzegovina",
  nickName: "Bosnia and Herzegovina",
  abbreviation: "BIH",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  belize: "n",
  "countries-biz": "a"
}, {
  name: "Belize",
  alternateNames: [],
  shortName: "Belize",
  city: "Belize",
  nickName: "Belize",
  abbreviation: "BIZ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  belarus: "n",
  "countries-blr": "a"
}, {
  name: "Belarus",
  alternateNames: [],
  shortName: "Belarus",
  city: "Belarus",
  nickName: "Belarus",
  abbreviation: "BLR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bolivia: "n",
  "countries-bol": "a"
}, {
  name: "Bolivia",
  alternateNames: [],
  shortName: "Bolivia",
  city: "Bolivia",
  nickName: "Bolivia",
  abbreviation: "BOL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  botswana: "n",
  "countries-bot": "a"
}, {
  name: "Botswana",
  alternateNames: [],
  shortName: "Botswana",
  city: "Botswana",
  nickName: "Botswana",
  abbreviation: "BOT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  brazil: "n",
  "countries-bra": "a"
}, {
  name: "Brazil",
  alternateNames: [],
  shortName: "Brazil",
  city: "Brazil",
  nickName: "Brazil",
  abbreviation: "BRA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bahrain: "n",
  "countries-brn": "a"
}, {
  name: "Bahrain",
  alternateNames: [],
  shortName: "Bahrain",
  city: "Bahrain",
  nickName: "Bahrain",
  abbreviation: "BRN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  brunei: "n",
  "countries-bru": "a"
}, {
  name: "Brunei",
  alternateNames: [],
  shortName: "Brunei",
  city: "Brunei",
  nickName: "Brunei",
  abbreviation: "BRU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  bulgaria: "n",
  "countries-bul": "a"
}, {
  name: "Bulgaria",
  alternateNames: [],
  shortName: "Bulgaria",
  city: "Bulgaria",
  nickName: "Bulgaria",
  abbreviation: "BUL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "burkina faso": "n",
  "countries-bur": "a"
}, {
  name: "Burkina Faso",
  alternateNames: [],
  shortName: "Burkina Faso",
  city: "Burkina Faso",
  nickName: "Burkina Faso",
  abbreviation: "BUR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "central african republic": "n",
  "countries-caf": "a"
}, {
  name: "Central African Republic",
  alternateNames: [],
  shortName: "Central African Republic",
  city: "Central African Republic",
  nickName: "Central African Republic",
  abbreviation: "CAF",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  cambodia: "n",
  "countries-cam": "a"
}, {
  name: "Cambodia",
  alternateNames: [],
  shortName: "Cambodia",
  city: "Cambodia",
  nickName: "Cambodia",
  abbreviation: "CAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  canada: "n",
  "countries-can": "a"
}, {
  name: "Canada",
  alternateNames: [],
  shortName: "Canada",
  city: "Canada",
  nickName: "Canada",
  abbreviation: "CAN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "cayman islands": "n",
  "countries-cay": "a"
}, {
  name: "Cayman Islands",
  alternateNames: [],
  shortName: "Cayman Islands",
  city: "Cayman Islands",
  nickName: "Cayman Islands",
  abbreviation: "CAY",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "republic of the congo": "n",
  "countries-cgo": "a"
}, {
  name: "Republic of the Congo",
  alternateNames: [],
  shortName: "Republic of the Congo",
  city: "Republic of the Congo",
  nickName: "Republic of the Congo",
  abbreviation: "CGO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  chad: "n",
  "countries-cha": "a"
}, {
  name: "Chad",
  alternateNames: [],
  shortName: "Chad",
  city: "Chad",
  nickName: "Chad",
  abbreviation: "CHA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  chile: "n",
  "countries-chi": "a"
}, {
  name: "Chile",
  alternateNames: [],
  shortName: "Chile",
  city: "Chile",
  nickName: "Chile",
  abbreviation: "CHI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  china: "n",
  "countries-chn": "a"
}, {
  name: "China",
  alternateNames: [],
  shortName: "China",
  city: "China",
  nickName: "China",
  abbreviation: "CHN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "ivory coast": "n",
  "countries-civ": "a",
  "côte d'ivoire": "an"
}, {
  name: "Ivory Coast",
  alternateNames: ["Côte d'Ivoire"],
  shortName: "Ivory Coast",
  city: "Ivory Coast",
  nickName: "Ivory Coast",
  abbreviation: "CIV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  cameroon: "n",
  "countries-cmr": "a"
}, {
  name: "Cameroon",
  alternateNames: [],
  shortName: "Cameroon",
  city: "Cameroon",
  nickName: "Cameroon",
  abbreviation: "CMR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "democratic republic of the congo": "n",
  "countries-cod": "a"
}, {
  name: "Democratic Republic of the Congo",
  alternateNames: [],
  shortName: "Democratic Republic of the Congo",
  city: "Democratic Republic of the Congo",
  nickName: "Democratic Republic of the Congo",
  abbreviation: "COD",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "cook islands": "n",
  "countries-cok": "a"
}, {
  name: "Cook Islands",
  alternateNames: [],
  shortName: "Cook Islands",
  city: "Cook Islands",
  nickName: "Cook Islands",
  abbreviation: "COK",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  colombia: "n",
  "countries-col": "a"
}, {
  name: "Colombia",
  alternateNames: [],
  shortName: "Colombia",
  city: "Colombia",
  nickName: "Colombia",
  abbreviation: "COL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  comoros: "n",
  "countries-com": "a"
}, {
  name: "Comoros",
  alternateNames: [],
  shortName: "Comoros",
  city: "Comoros",
  nickName: "Comoros",
  abbreviation: "COM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "cape verde": "n",
  "countries-cpv": "a"
}, {
  name: "Cape Verde",
  alternateNames: [],
  shortName: "Cape Verde",
  city: "Cape Verde",
  nickName: "Cape Verde",
  abbreviation: "CPV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "costa rica": "n",
  "countries-crc": "a"
}, {
  name: "Costa Rica",
  alternateNames: [],
  shortName: "Costa Rica",
  city: "Costa Rica",
  nickName: "Costa Rica",
  abbreviation: "CRC",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  croatia: "n",
  "countries-cro": "a"
}, {
  name: "Croatia",
  alternateNames: [],
  shortName: "Croatia",
  city: "Croatia",
  nickName: "Croatia",
  abbreviation: "CRO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  cuba: "n",
  "countries-cub": "a"
}, {
  name: "Cuba",
  alternateNames: [],
  shortName: "Cuba",
  city: "Cuba",
  nickName: "Cuba",
  abbreviation: "CUB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  cyprus: "n",
  "countries-cyp": "a"
}, {
  name: "Cyprus",
  alternateNames: [],
  shortName: "Cyprus",
  city: "Cyprus",
  nickName: "Cyprus",
  abbreviation: "CYP",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "czech republic": "n",
  "countries-cze": "a",
  czechia: "an",
  czech: "an",
  "czech rep": "an"
}, {
  name: "Czech Republic",
  alternateNames: ["Czechia", "Czech", "Czech Rep"],
  shortName: "Czech Republic",
  city: "Czech Republic",
  nickName: "Czech Republic",
  abbreviation: "CZE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  denmark: "n",
  "countries-den": "a"
}, {
  name: "Denmark",
  alternateNames: [],
  shortName: "Denmark",
  city: "Denmark",
  nickName: "Denmark",
  abbreviation: "DEN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  djibouti: "n",
  "countries-dji": "a"
}, {
  name: "Djibouti",
  alternateNames: [],
  shortName: "Djibouti",
  city: "Djibouti",
  nickName: "Djibouti",
  abbreviation: "DJI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  dominica: "n",
  "countries-dma": "a"
}, {
  name: "Dominica",
  alternateNames: [],
  shortName: "Dominica",
  city: "Dominica",
  nickName: "Dominica",
  abbreviation: "DMA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "dominican republic": "n",
  "countries-dom": "a"
}, {
  name: "Dominican Republic",
  alternateNames: [],
  shortName: "Dominican Republic",
  city: "Dominican Republic",
  nickName: "Dominican Republic",
  abbreviation: "DOM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  ecuador: "n",
  "countries-ecu": "a"
}, {
  name: "Ecuador",
  alternateNames: [],
  shortName: "Ecuador",
  city: "Ecuador",
  nickName: "Ecuador",
  abbreviation: "ECU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  egypt: "n",
  "countries-egy": "a"
}, {
  name: "Egypt",
  alternateNames: [],
  shortName: "Egypt",
  city: "Egypt",
  nickName: "Egypt",
  abbreviation: "EGY",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  eritrea: "n",
  "countries-eri": "a"
}, {
  name: "Eritrea",
  alternateNames: [],
  shortName: "Eritrea",
  city: "Eritrea",
  nickName: "Eritrea",
  abbreviation: "ERI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "el salvador": "n",
  "countries-esa": "a"
}, {
  name: "El Salvador",
  alternateNames: [],
  shortName: "El Salvador",
  city: "El Salvador",
  nickName: "El Salvador",
  abbreviation: "ESA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  spain: "n",
  "countries-esp": "a"
}, {
  name: "Spain",
  alternateNames: [],
  shortName: "Spain",
  city: "Spain",
  nickName: "Spain",
  abbreviation: "ESP",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  estonia: "n",
  "countries-est": "a"
}, {
  name: "Estonia",
  alternateNames: [],
  shortName: "Estonia",
  city: "Estonia",
  nickName: "Estonia",
  abbreviation: "EST",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  ethiopia: "n",
  "countries-eth": "a"
}, {
  name: "Ethiopia",
  alternateNames: [],
  shortName: "Ethiopia",
  city: "Ethiopia",
  nickName: "Ethiopia",
  abbreviation: "ETH",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  fiji: "n",
  "countries-fij": "a"
}, {
  name: "Fiji",
  alternateNames: [],
  shortName: "Fiji",
  city: "Fiji",
  nickName: "Fiji",
  abbreviation: "FIJ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  finland: "n",
  "countries-fin": "a"
}, {
  name: "Finland",
  alternateNames: [],
  shortName: "Finland",
  city: "Finland",
  nickName: "Finland",
  abbreviation: "FIN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  france: "n",
  "countries-fra": "a"
}, {
  name: "France",
  alternateNames: [],
  shortName: "France",
  city: "France",
  nickName: "France",
  abbreviation: "FRA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  scotland: "n",
  "countries-sct": "a"
}, {
  name: "Scotland",
  alternateNames: [],
  shortName: "Scotland",
  city: "Scotland",
  nickName: "Scotland",
  abbreviation: "SCT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  england: "n",
  "countries-eng": "a"
}, {
  name: "England",
  alternateNames: [],
  shortName: "England",
  city: "England",
  nickName: "England",
  abbreviation: "ENG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  wales: "n",
  "countries-wal": "a"
}, {
  name: "Wales",
  alternateNames: [],
  shortName: "Wales",
  city: "Wales",
  nickName: "Wales",
  abbreviation: "WAL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "northern ireland": "n",
  "countries-nir": "a"
}, {
  name: "Northern Ireland",
  alternateNames: [],
  shortName: "Northern Ireland",
  city: "Northern Ireland",
  nickName: "Northern Ireland",
  abbreviation: "NIR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "federated states of micronesia": "n",
  "countries-fsm": "a",
  micronesia: "an"
}, {
  name: "Federated States of Micronesia",
  alternateNames: ["Micronesia"],
  shortName: "Federated States of Micronesia",
  city: "Federated States of Micronesia",
  nickName: "Federated States of Micronesia",
  abbreviation: "FSM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  gabon: "n",
  "countries-gab": "a"
}, {
  name: "Gabon",
  alternateNames: [],
  shortName: "Gabon",
  city: "Gabon",
  nickName: "Gabon",
  abbreviation: "GAB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "the gambia": "n",
  "countries-gam": "a",
  gambia: "an"
}, {
  name: "The Gambia",
  alternateNames: ["Gambia"],
  shortName: "The Gambia",
  city: "The Gambia",
  nickName: "The Gambia",
  abbreviation: "GAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "great britain": "n",
  "countries-gbr": "a",
  "united kingdom": "an",
  uk: "an"
}, {
  name: "Great Britain",
  alternateNames: ["United Kingdom", "uk"],
  shortName: "Great Britain",
  city: "Great Britain",
  nickName: "Great Britain",
  abbreviation: "GBR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "guinea-bissau": "n",
  "countries-gbs": "a"
}, {
  name: "Guinea-Bissau",
  alternateNames: [],
  shortName: "Guinea-Bissau",
  city: "Guinea-Bissau",
  nickName: "Guinea-Bissau",
  abbreviation: "GBS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  georgia: "n",
  "countries-geo": "a"
}, {
  name: "Georgia",
  alternateNames: [],
  shortName: "Georgia",
  city: "Georgia",
  nickName: "Georgia",
  abbreviation: "GEO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "equatorial guinea": "n",
  "countries-geq": "a"
}, {
  name: "Equatorial Guinea",
  alternateNames: [],
  shortName: "Equatorial Guinea",
  city: "Equatorial Guinea",
  nickName: "Equatorial Guinea",
  abbreviation: "GEQ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  germany: "n",
  "countries-ger": "a"
}, {
  name: "Germany",
  alternateNames: [],
  shortName: "Germany",
  city: "Germany",
  nickName: "Germany",
  abbreviation: "GER",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  ghana: "n",
  "countries-gha": "a"
}, {
  name: "Ghana",
  alternateNames: [],
  shortName: "Ghana",
  city: "Ghana",
  nickName: "Ghana",
  abbreviation: "GHA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  greece: "n",
  "countries-gre": "a"
}, {
  name: "Greece",
  alternateNames: [],
  shortName: "Greece",
  city: "Greece",
  nickName: "Greece",
  abbreviation: "GRE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  grenada: "n",
  "countries-grn": "a"
}, {
  name: "Grenada",
  alternateNames: [],
  shortName: "Grenada",
  city: "Grenada",
  nickName: "Grenada",
  abbreviation: "GRN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  guatemala: "n",
  "countries-gua": "a"
}, {
  name: "Guatemala",
  alternateNames: [],
  shortName: "Guatemala",
  city: "Guatemala",
  nickName: "Guatemala",
  abbreviation: "GUA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  guinea: "n",
  "countries-gui": "a"
}, {
  name: "Guinea",
  alternateNames: [],
  shortName: "Guinea",
  city: "Guinea",
  nickName: "Guinea",
  abbreviation: "GUI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  guam: "n",
  "countries-gum": "a"
}, {
  name: "Guam",
  alternateNames: [],
  shortName: "Guam",
  city: "Guam",
  nickName: "Guam",
  abbreviation: "GUM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  guyana: "n",
  "countries-guy": "a"
}, {
  name: "Guyana",
  alternateNames: [],
  shortName: "Guyana",
  city: "Guyana",
  nickName: "Guyana",
  abbreviation: "GUY",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  haiti: "n",
  "countries-hai": "a"
}, {
  name: "Haiti",
  alternateNames: [],
  shortName: "Haiti",
  city: "Haiti",
  nickName: "Haiti",
  abbreviation: "HAI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "hong kong": "n",
  "countries-hkg": "a"
}, {
  name: "Hong Kong",
  alternateNames: [],
  shortName: "Hong Kong",
  city: "Hong Kong",
  nickName: "Hong Kong",
  abbreviation: "HKG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  honduras: "n",
  "countries-hon": "a"
}, {
  name: "Honduras",
  alternateNames: [],
  shortName: "Honduras",
  city: "Honduras",
  nickName: "Honduras",
  abbreviation: "HON",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  hungary: "n",
  "countries-hun": "a"
}, {
  name: "Hungary",
  alternateNames: [],
  shortName: "Hungary",
  city: "Hungary",
  nickName: "Hungary",
  abbreviation: "HUN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  indonesia: "n",
  "countries-ina": "a"
}, {
  name: "Indonesia",
  alternateNames: [],
  shortName: "Indonesia",
  city: "Indonesia",
  nickName: "Indonesia",
  abbreviation: "INA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  india: "n",
  "countries-ind": "a"
}, {
  name: "India",
  alternateNames: [],
  shortName: "India",
  city: "India",
  nickName: "India",
  abbreviation: "IND",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  iran: "n",
  "countries-iri": "a"
}, {
  name: "Iran",
  alternateNames: [],
  shortName: "Iran",
  city: "Iran",
  nickName: "Iran",
  abbreviation: "IRI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  ireland: "n",
  "countries-irl": "a"
}, {
  name: "Ireland",
  alternateNames: [],
  shortName: "Ireland",
  city: "Ireland",
  nickName: "Ireland",
  abbreviation: "IRL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  iraq: "n",
  "countries-irq": "a"
}, {
  name: "Iraq",
  alternateNames: [],
  shortName: "Iraq",
  city: "Iraq",
  nickName: "Iraq",
  abbreviation: "IRQ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  iceland: "n",
  "countries-isl": "a"
}, {
  name: "Iceland",
  alternateNames: [],
  shortName: "Iceland",
  city: "Iceland",
  nickName: "Iceland",
  abbreviation: "ISL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  israel: "n",
  "countries-isr": "a"
}, {
  name: "Israel",
  alternateNames: [],
  shortName: "Israel",
  city: "Israel",
  nickName: "Israel",
  abbreviation: "ISR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "virgin islands": "n",
  "countries-isv": "a",
  "u.s. virgin islands": "an"
}, {
  name: "Virgin Islands",
  alternateNames: ["U.S. Virgin Islands"],
  shortName: "Virgin Islands",
  city: "Virgin Islands",
  nickName: "Virgin Islands",
  abbreviation: "ISV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  italy: "n",
  "countries-ita": "a"
}, {
  name: "Italy",
  alternateNames: [],
  shortName: "Italy",
  city: "Italy",
  nickName: "Italy",
  abbreviation: "ITA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "british virgin islands": "n",
  "countries-ivb": "a"
}, {
  name: "British Virgin Islands",
  alternateNames: [],
  shortName: "British Virgin Islands",
  city: "British Virgin Islands",
  nickName: "British Virgin Islands",
  abbreviation: "IVB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  jamaica: "n",
  "countries-jam": "a"
}, {
  name: "Jamaica",
  alternateNames: [],
  shortName: "Jamaica",
  city: "Jamaica",
  nickName: "Jamaica",
  abbreviation: "JAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  jordan: "n",
  "countries-jor": "a"
}, {
  name: "Jordan",
  alternateNames: [],
  shortName: "Jordan",
  city: "Jordan",
  nickName: "Jordan",
  abbreviation: "JOR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  japan: "n",
  "countries-jpn": "a"
}, {
  name: "Japan",
  alternateNames: [],
  shortName: "Japan",
  city: "Japan",
  nickName: "Japan",
  abbreviation: "JPN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  kazakhstan: "n",
  "countries-kaz": "a"
}, {
  name: "Kazakhstan",
  alternateNames: [],
  shortName: "Kazakhstan",
  city: "Kazakhstan",
  nickName: "Kazakhstan",
  abbreviation: "KAZ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  kenya: "n",
  "countries-ken": "a"
}, {
  name: "Kenya",
  alternateNames: [],
  shortName: "Kenya",
  city: "Kenya",
  nickName: "Kenya",
  abbreviation: "KEN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  kyrgyzstan: "n",
  "countries-kgz": "a"
}, {
  name: "Kyrgyzstan",
  alternateNames: [],
  shortName: "Kyrgyzstan",
  city: "Kyrgyzstan",
  nickName: "Kyrgyzstan",
  abbreviation: "KGZ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  kiribati: "n",
  "countries-kir": "a"
}, {
  name: "Kiribati",
  alternateNames: [],
  shortName: "Kiribati",
  city: "Kiribati",
  nickName: "Kiribati",
  abbreviation: "KIR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "south korea": "n",
  "countries-kor": "a"
}, {
  name: "South Korea",
  alternateNames: [],
  shortName: "South Korea",
  city: "South Korea",
  nickName: "South Korea",
  abbreviation: "KOR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
});
Fs.set({
  l: "countries",
  kosovo: "n",
  "countries-kos": "a"
}, {
  name: "Kosovo",
  alternateNames: [],
  shortName: "Kosovo",
  city: "Kosovo",
  nickName: "Kosovo",
  abbreviation: "KOS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "saudi arabia": "n",
  "countries-ksa": "a"
}, {
  name: "Saudi Arabia",
  alternateNames: [],
  shortName: "Saudi Arabia",
  city: "Saudi Arabia",
  nickName: "Saudi Arabia",
  abbreviation: "KSA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  kuwait: "n",
  "countries-kuw": "a"
}, {
  name: "Kuwait",
  alternateNames: [],
  shortName: "Kuwait",
  city: "Kuwait",
  nickName: "Kuwait",
  abbreviation: "KUW",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  laos: "n",
  "countries-lao": "a"
}, {
  name: "Laos",
  alternateNames: [],
  shortName: "Laos",
  city: "Laos",
  nickName: "Laos",
  abbreviation: "LAO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  latvia: "n",
  "countries-lat": "a"
}, {
  name: "Latvia",
  alternateNames: [],
  shortName: "Latvia",
  city: "Latvia",
  nickName: "Latvia",
  abbreviation: "LAT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  libya: "n",
  "countries-lba": "a"
}, {
  name: "Libya",
  alternateNames: [],
  shortName: "Libya",
  city: "Libya",
  nickName: "Libya",
  abbreviation: "LBA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  lebanon: "n",
  "countries-lbn": "a"
}, {
  name: "Lebanon",
  alternateNames: [],
  shortName: "Lebanon",
  city: "Lebanon",
  nickName: "Lebanon",
  abbreviation: "LBN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  liberia: "n",
  "countries-lbr": "a"
}, {
  name: "Liberia",
  alternateNames: [],
  shortName: "Liberia",
  city: "Liberia",
  nickName: "Liberia",
  abbreviation: "LBR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "saint lucia": "n",
  "st. lucia": "s",
  "countries-lca": "a"
}, {
  name: "Saint Lucia",
  alternateNames: [],
  shortName: "St. Lucia",
  city: "Saint Lucia",
  nickName: "Saint Lucia",
  abbreviation: "LCA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  lesotho: "n",
  "countries-les": "a"
}, {
  name: "Lesotho",
  alternateNames: [],
  shortName: "Lesotho",
  city: "Lesotho",
  nickName: "Lesotho",
  abbreviation: "LES",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  liechtenstein: "n",
  "countries-lie": "a"
}, {
  name: "Liechtenstein",
  alternateNames: [],
  shortName: "Liechtenstein",
  city: "Liechtenstein",
  nickName: "Liechtenstein",
  abbreviation: "LIE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  lithuania: "n",
  "countries-ltu": "a"
}, {
  name: "Lithuania",
  alternateNames: [],
  shortName: "Lithuania",
  city: "Lithuania",
  nickName: "Lithuania",
  abbreviation: "LTU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  luxembourg: "n",
  "countries-lux": "a"
}, {
  name: "Luxembourg",
  alternateNames: [],
  shortName: "Luxembourg",
  city: "Luxembourg",
  nickName: "Luxembourg",
  abbreviation: "LUX",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  madagascar: "n",
  "countries-mad": "a"
}, {
  name: "Madagascar",
  alternateNames: [],
  shortName: "Madagascar",
  city: "Madagascar",
  nickName: "Madagascar",
  abbreviation: "MAD",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  morocco: "n",
  "countries-mar": "a"
}, {
  name: "Morocco",
  alternateNames: [],
  shortName: "Morocco",
  city: "Morocco",
  nickName: "Morocco",
  abbreviation: "MAR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  malaysia: "n",
  "countries-mas": "a"
}, {
  name: "Malaysia",
  alternateNames: [],
  shortName: "Malaysia",
  city: "Malaysia",
  nickName: "Malaysia",
  abbreviation: "MAS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  malawi: "n",
  "countries-maw": "a"
}, {
  name: "Malawi",
  alternateNames: [],
  shortName: "Malawi",
  city: "Malawi",
  nickName: "Malawi",
  abbreviation: "MAW",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  moldova: "n",
  "countries-mda": "a"
}, {
  name: "Moldova",
  alternateNames: [],
  shortName: "Moldova",
  city: "Moldova",
  nickName: "Moldova",
  abbreviation: "MDA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  maldives: "n",
  "countries-mdv": "a"
}, {
  name: "Maldives",
  alternateNames: [],
  shortName: "Maldives",
  city: "Maldives",
  nickName: "Maldives",
  abbreviation: "MDV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mexico: "n",
  "countries-mex": "a"
}, {
  name: "Mexico",
  alternateNames: [],
  shortName: "Mexico",
  city: "Mexico",
  nickName: "Mexico",
  abbreviation: "MEX",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mongolia: "n",
  "countries-mgl": "a"
}, {
  name: "Mongolia",
  alternateNames: [],
  shortName: "Mongolia",
  city: "Mongolia",
  nickName: "Mongolia",
  abbreviation: "MGL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "marshall islands": "n",
  "countries-mhl": "a"
}, {
  name: "Marshall Islands",
  alternateNames: [],
  shortName: "Marshall Islands",
  city: "Marshall Islands",
  nickName: "Marshall Islands",
  abbreviation: "MHL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "north macedonia": "n",
  "countries-mkd": "a",
  macedonia: "an"
}, {
  name: "North Macedonia",
  alternateNames: ["Macedonia"],
  shortName: "North Macedonia",
  city: "North Macedonia",
  nickName: "North Macedonia",
  abbreviation: "MKD",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mali: "n",
  "countries-mli": "a"
}, {
  name: "Mali",
  alternateNames: [],
  shortName: "Mali",
  city: "Mali",
  nickName: "Mali",
  abbreviation: "MLI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  malta: "n",
  "countries-mlt": "a"
}, {
  name: "Malta",
  alternateNames: [],
  shortName: "Malta",
  city: "Malta",
  nickName: "Malta",
  abbreviation: "MLT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  montenegro: "n",
  "countries-mne": "a"
}, {
  name: "Montenegro",
  alternateNames: [],
  shortName: "Montenegro",
  city: "Montenegro",
  nickName: "Montenegro",
  abbreviation: "MNE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  monaco: "n",
  "countries-mon": "a"
}, {
  name: "Monaco",
  alternateNames: [],
  shortName: "Monaco",
  city: "Monaco",
  nickName: "Monaco",
  abbreviation: "MON",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mozambique: "n",
  "countries-moz": "a"
}, {
  name: "Mozambique",
  alternateNames: [],
  shortName: "Mozambique",
  city: "Mozambique",
  nickName: "Mozambique",
  abbreviation: "MOZ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mauritius: "n",
  "countries-mri": "a"
}, {
  name: "Mauritius",
  alternateNames: [],
  shortName: "Mauritius",
  city: "Mauritius",
  nickName: "Mauritius",
  abbreviation: "MRI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  mauritania: "n",
  "countries-mtn": "a"
}, {
  name: "Mauritania",
  alternateNames: [],
  shortName: "Mauritania",
  city: "Mauritania",
  nickName: "Mauritania",
  abbreviation: "MTN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  myanmar: "n",
  "countries-mya": "a",
  burma: "an"
}, {
  name: "Myanmar",
  alternateNames: ["Burma"],
  shortName: "Myanmar",
  city: "Myanmar",
  nickName: "Myanmar",
  abbreviation: "MYA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  namibia: "n",
  "countries-nam": "a"
}, {
  name: "Namibia",
  alternateNames: [],
  shortName: "Namibia",
  city: "Namibia",
  nickName: "Namibia",
  abbreviation: "NAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  nicaragua: "n",
  "countries-nca": "a"
}, {
  name: "Nicaragua",
  alternateNames: [],
  shortName: "Nicaragua",
  city: "Nicaragua",
  nickName: "Nicaragua",
  abbreviation: "NCA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  netherlands: "n",
  "countries-ned": "a"
}, {
  name: "Netherlands",
  alternateNames: [],
  shortName: "Netherlands",
  city: "Netherlands",
  nickName: "Netherlands",
  abbreviation: "NED",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  nepal: "n",
  "countries-nep": "a"
}, {
  name: "Nepal",
  alternateNames: [],
  shortName: "Nepal",
  city: "Nepal",
  nickName: "Nepal",
  abbreviation: "NEP",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  nigeria: "n",
  "countries-ngr": "a"
}, {
  name: "Nigeria",
  alternateNames: [],
  shortName: "Nigeria",
  city: "Nigeria",
  nickName: "Nigeria",
  abbreviation: "NGR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  niger: "n",
  "countries-nig": "a"
}, {
  name: "Niger",
  alternateNames: [],
  shortName: "Niger",
  city: "Niger",
  nickName: "Niger",
  abbreviation: "NIG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  norway: "n",
  "countries-nor": "a"
}, {
  name: "Norway",
  alternateNames: [],
  shortName: "Norway",
  city: "Norway",
  nickName: "Norway",
  abbreviation: "NOR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  nauru: "n",
  "countries-nru": "a"
}, {
  name: "Nauru",
  alternateNames: [],
  shortName: "Nauru",
  city: "Nauru",
  nickName: "Nauru",
  abbreviation: "NRU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "new zealand": "n",
  "countries-nzl": "a"
}, {
  name: "New Zealand",
  alternateNames: [],
  shortName: "New Zealand",
  city: "New Zealand",
  nickName: "New Zealand",
  abbreviation: "NZL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  oman: "n",
  "countries-oma": "a"
}, {
  name: "Oman",
  alternateNames: [],
  shortName: "Oman",
  city: "Oman",
  nickName: "Oman",
  abbreviation: "OMA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  pakistan: "n",
  "countries-pak": "a"
}, {
  name: "Pakistan",
  alternateNames: [],
  shortName: "Pakistan",
  city: "Pakistan",
  nickName: "Pakistan",
  abbreviation: "PAK",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  panama: "n",
  "countries-pan": "a"
}, {
  name: "Panama",
  alternateNames: [],
  shortName: "Panama",
  city: "Panama",
  nickName: "Panama",
  abbreviation: "PAN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  paraguay: "n",
  "countries-par": "a"
}, {
  name: "Paraguay",
  alternateNames: [],
  shortName: "Paraguay",
  city: "Paraguay",
  nickName: "Paraguay",
  abbreviation: "PAR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  peru: "n",
  "countries-per": "a"
}, {
  name: "Peru",
  alternateNames: [],
  shortName: "Peru",
  city: "Peru",
  nickName: "Peru",
  abbreviation: "PER",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  philippines: "n",
  "countries-phi": "a"
}, {
  name: "Philippines",
  alternateNames: [],
  shortName: "Philippines",
  city: "Philippines",
  nickName: "Philippines",
  abbreviation: "PHI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  palestine: "n",
  "countries-ple": "a"
}, {
  name: "Palestine",
  alternateNames: [],
  shortName: "Palestine",
  city: "Palestine",
  nickName: "Palestine",
  abbreviation: "PLE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  palau: "n",
  "countries-plw": "a"
}, {
  name: "Palau",
  alternateNames: [],
  shortName: "Palau",
  city: "Palau",
  nickName: "Palau",
  abbreviation: "PLW",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "papua new guinea": "n",
  "countries-png": "a"
}, {
  name: "Papua New Guinea",
  alternateNames: [],
  shortName: "Papua New Guinea",
  city: "Papua New Guinea",
  nickName: "Papua New Guinea",
  abbreviation: "PNG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  poland: "n",
  "countries-pol": "a"
}, {
  name: "Poland",
  alternateNames: [],
  shortName: "Poland",
  city: "Poland",
  nickName: "Poland",
  abbreviation: "POL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  portugal: "n",
  "countries-por": "a"
}, {
  name: "Portugal",
  alternateNames: [],
  shortName: "Portugal",
  city: "Portugal",
  nickName: "Portugal",
  abbreviation: "POR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "north korea": "n",
  "countries-prk": "a",
  "democratic people's republic of korea": "an"
}, {
  name: "North Korea",
  alternateNames: ["Democratic People's Republic of Korea"],
  shortName: "North Korea",
  city: "North Korea",
  nickName: "North Korea",
  abbreviation: "PRK",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "refugee olympic team": "n",
  "countries-ref": "a"
}, {
  name: "Refugee Olympic Team",
  alternateNames: [],
  shortName: "Refugee Olympic Team",
  city: "Refugee Olympic Team",
  nickName: "Refugee Olympic Team",
  abbreviation: "REF",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "puerto rico": "n",
  "countries-pur": "a"
}, {
  name: "Puerto Rico",
  alternateNames: [],
  shortName: "Puerto Rico",
  city: "Puerto Rico",
  nickName: "Puerto Rico",
  abbreviation: "PUR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  qatar: "n",
  "countries-qat": "a"
}, {
  name: "Qatar",
  alternateNames: [],
  shortName: "Qatar",
  city: "Qatar",
  nickName: "Qatar",
  abbreviation: "QAT",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  romania: "n",
  "countries-rou": "a"
}, {
  name: "Romania",
  alternateNames: [],
  shortName: "Romania",
  city: "Romania",
  nickName: "Romania",
  abbreviation: "ROU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "south africa": "n",
  "countries-rsa": "a"
}, {
  name: "South Africa",
  alternateNames: [],
  shortName: "South Africa",
  city: "South Africa",
  nickName: "South Africa",
  abbreviation: "RSA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  russia: "n",
  "countries-rus": "a"
}, {
  name: "Russia",
  alternateNames: [],
  shortName: "Russia",
  city: "Russia",
  nickName: "Russia",
  abbreviation: "RUS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  rwanda: "n",
  "countries-rwa": "a"
}, {
  name: "Rwanda",
  alternateNames: [],
  shortName: "Rwanda",
  city: "Rwanda",
  nickName: "Rwanda",
  abbreviation: "RWA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  samoa: "n",
  "countries-sam": "a"
}, {
  name: "Samoa",
  alternateNames: [],
  shortName: "Samoa",
  city: "Samoa",
  nickName: "Samoa",
  abbreviation: "SAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  senegal: "n",
  "countries-sen": "a"
}, {
  name: "Senegal",
  alternateNames: [],
  shortName: "Senegal",
  city: "Senegal",
  nickName: "Senegal",
  abbreviation: "SEN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  seychelles: "n",
  "countries-sey": "a"
}, {
  name: "Seychelles",
  alternateNames: [],
  shortName: "Seychelles",
  city: "Seychelles",
  nickName: "Seychelles",
  abbreviation: "SEY",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  singapore: "n",
  "countries-sgp": "a"
}, {
  name: "Singapore",
  alternateNames: [],
  shortName: "Singapore",
  city: "Singapore",
  nickName: "Singapore",
  abbreviation: "SGP",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "saint kitts and nevis": "n",
  "countries-skn": "a",
  "st. kitts and nevis": "an"
}, {
  name: "Saint Kitts and Nevis",
  alternateNames: ["St. Kitts and Nevis"],
  shortName: "Saint Kitts and Nevis",
  city: "Saint Kitts and Nevis",
  nickName: "Saint Kitts and Nevis",
  abbreviation: "SKN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "sierra leone": "n",
  "countries-sle": "a"
}, {
  name: "Sierra Leone",
  alternateNames: [],
  shortName: "Sierra Leone",
  city: "Sierra Leone",
  nickName: "Sierra Leone",
  abbreviation: "SLE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  slovenia: "n",
  "countries-slo": "a"
}, {
  name: "Slovenia",
  alternateNames: [],
  shortName: "Slovenia",
  city: "Slovenia",
  nickName: "Slovenia",
  abbreviation: "SLO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "san marino": "n",
  "countries-smr": "a"
}, {
  name: "San Marino",
  alternateNames: [],
  shortName: "San Marino",
  city: "San Marino",
  nickName: "San Marino",
  abbreviation: "SMR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "solomon islands": "n",
  "countries-sol": "a"
}, {
  name: "Solomon Islands",
  alternateNames: [],
  shortName: "Solomon Islands",
  city: "Solomon Islands",
  nickName: "Solomon Islands",
  abbreviation: "SOL",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  somalia: "n",
  "countries-som": "a"
}, {
  name: "Somalia",
  alternateNames: [],
  shortName: "Somalia",
  city: "Somalia",
  nickName: "Somalia",
  abbreviation: "SOM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  serbia: "n",
  "countries-srb": "a"
}, {
  name: "Serbia",
  alternateNames: [],
  shortName: "Serbia",
  city: "Serbia",
  nickName: "Serbia",
  abbreviation: "SRB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "sri lanka": "n",
  "countries-sri": "a"
}, {
  name: "Sri Lanka",
  alternateNames: [],
  shortName: "Sri Lanka",
  city: "Sri Lanka",
  nickName: "Sri Lanka",
  abbreviation: "SRI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "south sudan": "n",
  "countries-ssd": "a"
}, {
  name: "South Sudan",
  alternateNames: [],
  shortName: "South Sudan",
  city: "South Sudan",
  nickName: "South Sudan",
  abbreviation: "SSD",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "são tomé and príncipe": "n",
  "countries-stp": "a",
  "sao tome and principe": "an"
}, {
  name: "São Tomé and Príncipe",
  alternateNames: ["Sao Tome and Principe"],
  shortName: "São Tomé and Príncipe",
  city: "São Tomé and Príncipe",
  nickName: "São Tomé and Príncipe",
  abbreviation: "STP",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  sudan: "n",
  "countries-sud": "a"
}, {
  name: "Sudan",
  alternateNames: [],
  shortName: "Sudan",
  city: "Sudan",
  nickName: "Sudan",
  abbreviation: "SUD",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  switzerland: "n",
  "countries-sui": "a"
}, {
  name: "Switzerland",
  alternateNames: [],
  shortName: "Switzerland",
  city: "Switzerland",
  nickName: "Switzerland",
  abbreviation: "SUI",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  suriname: "n",
  "countries-sur": "a"
}, {
  name: "Suriname",
  alternateNames: [],
  shortName: "Suriname",
  city: "Suriname",
  nickName: "Suriname",
  abbreviation: "SUR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  slovakia: "n",
  "countries-svk": "a"
}, {
  name: "Slovakia",
  alternateNames: [],
  shortName: "Slovakia",
  city: "Slovakia",
  nickName: "Slovakia",
  abbreviation: "SVK",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  sweden: "n",
  "countries-swe": "a"
}, {
  name: "Sweden",
  alternateNames: [],
  shortName: "Sweden",
  city: "Sweden",
  nickName: "Sweden",
  abbreviation: "SWE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  eswatini: "n",
  "countries-swz": "a",
  swaziland: "an"
}, {
  name: "Eswatini",
  alternateNames: ["Swaziland"],
  shortName: "Eswatini",
  city: "Eswatini",
  nickName: "Eswatini",
  abbreviation: "SWZ",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  syria: "n",
  "countries-syr": "a"
}, {
  name: "Syria",
  alternateNames: [],
  shortName: "Syria",
  city: "Syria",
  nickName: "Syria",
  abbreviation: "SYR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  tanzania: "n",
  "countries-tan": "a"
}, {
  name: "Tanzania",
  alternateNames: [],
  shortName: "Tanzania",
  city: "Tanzania",
  nickName: "Tanzania",
  abbreviation: "TAN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  tonga: "n",
  "countries-tga": "a"
}, {
  name: "Tonga",
  alternateNames: [],
  shortName: "Tonga",
  city: "Tonga",
  nickName: "Tonga",
  abbreviation: "TGA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  thailand: "n",
  "countries-tha": "a"
}, {
  name: "Thailand",
  alternateNames: [],
  shortName: "Thailand",
  city: "Thailand",
  nickName: "Thailand",
  abbreviation: "THA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  tajikistan: "n",
  "countries-tjk": "a"
}, {
  name: "Tajikistan",
  alternateNames: [],
  shortName: "Tajikistan",
  city: "Tajikistan",
  nickName: "Tajikistan",
  abbreviation: "TJK",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  turkmenistan: "n",
  "countries-tkm": "a"
}, {
  name: "Turkmenistan",
  alternateNames: [],
  shortName: "Turkmenistan",
  city: "Turkmenistan",
  nickName: "Turkmenistan",
  abbreviation: "TKM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "east timor": "n",
  "countries-tls": "a"
}, {
  name: "East Timor",
  alternateNames: [],
  shortName: "East Timor",
  city: "East Timor",
  nickName: "East Timor",
  abbreviation: "TLS",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  togo: "n",
  "countries-tog": "a"
}, {
  name: "Togo",
  alternateNames: [],
  shortName: "Togo",
  city: "Togo",
  nickName: "Togo",
  abbreviation: "TOG",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "chinese taipei": "n",
  "countries-tpe": "a",
  taipei: "an",
  taiwan: "an"
}, {
  name: "Chinese Taipei",
  alternateNames: ["Taipei", "Taiwan"],
  shortName: "Chinese Taipei",
  city: "Chinese Taipei",
  nickName: "Chinese Taipei",
  abbreviation: "TPE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "trinidad and tobago": "n",
  "countries-tto": "a"
}, {
  name: "Trinidad and Tobago",
  alternateNames: [],
  shortName: "Trinidad and Tobago",
  city: "Trinidad and Tobago",
  nickName: "Trinidad and Tobago",
  abbreviation: "TTO",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  tunisia: "n",
  "countries-tun": "a"
}, {
  name: "Tunisia",
  alternateNames: [],
  shortName: "Tunisia",
  city: "Tunisia",
  nickName: "Tunisia",
  abbreviation: "TUN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  turkey: "n",
  "countries-tur": "a",
  turkiye: "an"
}, {
  name: "Turkey",
  alternateNames: ["Turkiye"],
  shortName: "Turkey",
  city: "Turkey",
  nickName: "Turkey",
  abbreviation: "TUR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  tuvalu: "n",
  "countries-tuv": "a"
}, {
  name: "Tuvalu",
  alternateNames: [],
  shortName: "Tuvalu",
  city: "Tuvalu",
  nickName: "Tuvalu",
  abbreviation: "TUV",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "united arab emirates": "n",
  "countries-uae": "a"
}, {
  name: "United Arab Emirates",
  alternateNames: [],
  shortName: "United Arab Emirates",
  city: "United Arab Emirates",
  nickName: "United Arab Emirates",
  abbreviation: "UAE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  uganda: "n",
  "countries-uga": "a"
}, {
  name: "Uganda",
  alternateNames: [],
  shortName: "Uganda",
  city: "Uganda",
  nickName: "Uganda",
  abbreviation: "UGA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  ukraine: "n",
  "countries-ukr": "a"
}, {
  name: "Ukraine",
  alternateNames: [],
  shortName: "Ukraine",
  city: "Ukraine",
  nickName: "Ukraine",
  abbreviation: "UKR",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  uruguay: "n",
  "countries-uru": "a"
}, {
  name: "Uruguay",
  alternateNames: [],
  shortName: "Uruguay",
  city: "Uruguay",
  nickName: "Uruguay",
  abbreviation: "URU",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "united states": "n",
  "countries-usa": "a",
  usa: "an",
  "united states of america": "an",
  america: "an"
}, {
  name: "United States",
  alternateNames: ["usa", "United States of America", "America"],
  shortName: "United States",
  city: "United States",
  nickName: "United States",
  abbreviation: "USA",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  uzbekistan: "n",
  "countries-uzb": "a"
}, {
  name: "Uzbekistan",
  alternateNames: [],
  shortName: "Uzbekistan",
  city: "Uzbekistan",
  nickName: "Uzbekistan",
  abbreviation: "UZB",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  vanuatu: "n",
  "countries-van": "a"
}, {
  name: "Vanuatu",
  alternateNames: [],
  shortName: "Vanuatu",
  city: "Vanuatu",
  nickName: "Vanuatu",
  abbreviation: "VAN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  venezuela: "n",
  "countries-ven": "a"
}, {
  name: "Venezuela",
  alternateNames: [],
  shortName: "Venezuela",
  city: "Venezuela",
  nickName: "Venezuela",
  abbreviation: "VEN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  vietnam: "n",
  "countries-vie": "a"
}, {
  name: "Vietnam",
  alternateNames: [],
  shortName: "Vietnam",
  city: "Vietnam",
  nickName: "Vietnam",
  abbreviation: "VIE",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "saint vincent and the grenadines": "n",
  "st. vincent and the grenadines": "an",
  "countries-vin": "a"
}, {
  name: "Saint Vincent and the Grenadines",
  alternateNames: ["St. Vincent and the Grenadines"],
  shortName: "St. Vincent and the Grenadines",
  city: "Saint Vincent and the Grenadines",
  nickName: "Saint Vincent and the Grenadines",
  abbreviation: "VIN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  yemen: "n",
  "countries-yem": "a"
}, {
  name: "Yemen",
  alternateNames: [],
  shortName: "Yemen",
  city: "Yemen",
  nickName: "Yemen",
  abbreviation: "YEM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  zambia: "n",
  "countries-zam": "a"
}, {
  name: "Zambia",
  alternateNames: [],
  shortName: "Zambia",
  city: "Zambia",
  nickName: "Zambia",
  abbreviation: "ZAM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  zimbabwe: "n",
  "countries-zim": "a"
}, {
  name: "Zimbabwe",
  alternateNames: [],
  shortName: "Zimbabwe",
  city: "Zimbabwe",
  nickName: "Zimbabwe",
  abbreviation: "ZIM",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
}), Fs.set({
  l: "countries",
  "individual neutral athletes": "n",
  "countries-ain": "a"
}, {
  name: "Individual Neutral Athletes",
  alternateNames: [],
  shortName: "Individual Neutral Athletes",
  city: "Individual Neutral Athletes",
  nickName: "Individual Neutral Athletes",
  abbreviation: "AIN",
  color: {
    primary: {
      value: "#000000",
      type: "color"
    },
    secondary: {
      value: "#FFFFFF",
      type: "color"
    }
  }
});
var Ss = function Ss(e) {
    if (!e) return null;
    var t,
      r = e.toLowerCase(),
      a = Se(Fs);
    try {
      for (a.s(); !(t = a.n()).done;) {
        var n = Le(t.value, 2),
          o = n[0],
          i = n[1];
        if (r in o && "l" !== r) return Te(Te({}, i), {}, {
          league: o.l
        });
      }
    } catch (e) {
      a.e(e);
    } finally {
      a.f();
    }
    return null;
  },
  Cs = {
    league: void 0,
    colors: [void 0, void 0, void 0],
    abbreviation: void 0
  },
  js = function js(e) {
    if (!e) return Cs;
    var t = Ss(e);
    if (t) {
      var r,
        a,
        n,
        o = t.color,
        i = "soccer" === t.league,
        l = [null === (r = o.primary) || void 0 === r ? void 0 : r.value, null === (a = o.secondary) || void 0 === a ? void 0 : a.value, i ? t.attributes.jerseyType : null === (n = o.tertiary) || void 0 === n ? void 0 : n.value];
      return {
        league: t.league,
        abbreviation: "".concat(t.league, "-").concat(t.abbreviation.toLowerCase()),
        colors: l
      };
    }
    return Cs;
  },
  Es = ll,
  Ts = Wl(function (e, t, r) {
    return e + (r ? " " : "") + Es(t);
  }),
  Os = Ts,
  As = function As(e) {
    var t = e.children,
      r = e.size,
      a = e.className,
      n = void 0 === a ? "" : a,
      o = e.rest,
      i = on(r).sizeClasses;
    return dt.exports.jsx("i", Te(Te({
      className: "".concat(i, " ").concat(n, " cui__color_icon")
    }, o), {}, {
      children: t
    }));
  };
var Ms = ["college", "soccer"],
  Ls = function Ls(e) {
    var t,
      r,
      a = e.name,
      n = void 0 === a ? "" : a,
      o = e.size,
      i = void 0 === o ? "md" : o,
      l = e.sport,
      s = void 0 === l ? "basketball" : l,
      c = e.mode,
      u = void 0 === c ? "light" : c,
      d = (e.soccerType, e.accessibilityLabel, Me(e, p)),
      m = Le(He(), 2),
      f = m[0],
      v = m[1],
      y = on(i),
      g = y.sizeMap,
      h = y.sizeStyle,
      b = js(n),
      N = b.colors,
      x = b.league,
      k = b.abbreviation,
      w = Le(N || [], 3),
      _ = w[0],
      F = void 0 === _ ? "" : _,
      S = w[1],
      C = void 0 === S ? "" : S,
      j = w[2],
      E = x && !Ms.includes(x) && k ? $l(function (e, t) {
        return "logo_".concat(e.toLowerCase(), "_").concat("dark" === t ? "onDark" : "onLight");
      }(k, u)) : null,
      T = "college" === x,
      O = "soccer" === x;
    if (Ve(function () {
      Fe(we().mark(function e() {
        var t;
        return we().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, !E || !(E in Di)) {
                e.next = 6;
                break;
              }
              return e.next = 4, Di[E]();
            case 4:
              t = e.sent, v(t);
            case 6:
              e.next = 11;
              break;
            case 8:
              e.prev = 8, e.t0 = e.catch(0), console.error("Could't retrieve logo: ", e.t0);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, null, [[0, 8]]);
      }))();
    }, [n, u]), O) return dt.exports.jsx(As, {
      size: i,
      rest: d,
      className: ss,
      children: dt.exports.jsx(_s, {
        type: j,
        primaryColor: F,
        secondaryColor: C,
        width: g.width,
        height: g.height,
        accessibilityLabel: "".concat(Os(n), " logo")
      })
    });
    if (T || "wnba" === x) switch (!0) {
      case ["basketball", "ncaab", "ncaawb"].includes(s):
        return dt.exports.jsx(As, {
          size: i,
          rest: d,
          children: dt.exports.jsx(is, {
            fill: F || "var(--gray-600)",
            secondaryfill: C || "#FEFEFE",
            width: g.width,
            height: g.height,
            accessibilityLabel: "".concat(Os(n), " logo")
          })
        });
      case ["football", "ncaaf"].includes(s):
        return dt.exports.jsx(As, {
          size: i,
          rest: d,
          children: dt.exports.jsx(ls, {
            fill: F || "var(--gray-600)",
            secondaryfill: C || "#FEFEFE",
            width: g.width,
            height: g.height,
            accessibilityLabel: "".concat(Os(n), " logo")
          })
        });
      case ["baseball", "ncaabaseball", "dibaseball", "di baseball"].includes(s):
        return dt.exports.jsx(As, {
          size: i,
          rest: d,
          children: dt.exports.jsx(us, {
            fill: F || "var(--gray-600)",
            secondaryfill: C || "#FEFEFE",
            width: g.width,
            height: g.height,
            accessibilityLabel: "".concat(Os(n), " logo")
          })
        });
      case ["hockey", "ncaah"].includes(s):
        return dt.exports.jsx(As, {
          size: i,
          rest: d,
          children: dt.exports.jsx(ds, {
            fill: F || "var(--gray-600)",
            secondaryfill: C || "#FEFEFE",
            width: g.width,
            height: g.height,
            accessibilityLabel: "".concat(Os(n), " logo")
          })
        });
      default:
        return dt.exports.jsx(As, {
          size: i,
          rest: d,
          children: dt.exports.jsx(is, {
            fill: F || "var(--gray-600)",
            secondaryfill: C || "#FEFEFE",
            width: g.width,
            height: g.height,
            accessibilityLabel: "".concat(Os(n), " logo")
          })
        });
    }
    return f ? dt.exports.jsx(As, {
      size: i,
      rest: d,
      children: dt.exports.jsx(f.default, {
        width: "number" == typeof i ? null === (t = h.width) || void 0 === t ? void 0 : t.replace("px", "") : g.width,
        height: "number" == typeof i ? null === (r = h.height) || void 0 === r ? void 0 : r.replace("px", "") : g.height,
        accessibilityLabel: "".concat(Os(n), " logo")
      })
    }) : null;
  };
Ls.displayName = "TeamLogo";
var Ds = {
    "fg-default": "cui-border-fg-default",
    "fg-moderate": "cui-border-fg-moderate",
    "fg-subtle": "cui-border-fg-subtle",
    "fg-minimal": "cui-border-fg-minimal",
    "fg-inverse": "cui-border-fg-inverse",
    "fg-primary": "cui-border-fg-primary",
    "fg-primary-strong": "cui-border-fg-primary-strong",
    "fg-primary-minimal": "cui-border-fg-primary-minimal",
    "fg-global-black": "cui-border-fg-global-black",
    "fg-global-white": "cui-border-fg-global-white",
    "fg-focus": "cui-border-fg-focus",
    "fg-focus-inverse": "cui-border-fg-focus-inverse",
    "bg-base": "cui-border-bg-base",
    "bg-default": "cui-border-bg-default",
    "bg-layer-one": "cui-border-bg-layer-one",
    "bg-layer-two": "cui-border-bg-layer-two",
    "bg-layer-three": "cui-border-bg-layer-three",
    "bg-primary": "cui-border-bg-primary",
    "bg-primary-strong": "cui-border-bg-primary-strong",
    "bg-primary-minimal": "cui-border-bg-primary-minimal",
    "highlight-accent": "cui-border-highlight-accent",
    "highlight-brand": "cui-border-highlight-brand",
    "highlight-one": "cui-border-highlight-one",
    "highlight-two": "cui-border-highlight-two",
    "highlight-three": "cui-border-highlight-three",
    "highlight-four": "cui-border-highlight-four",
    "status-positive": "cui-border-status-positive",
    "status-negative": "cui-border-status-negative",
    "status-notification": "cui-border-status-notification",
    "status-alert": "cui-border-status-alert",
    "rewards-background": "cui-border-rewards-background",
    none: ""
  },
  Bs = {
    1: "cui-border-1",
    2: "cui-border-2",
    4: "cui-border-4",
    none: ""
  },
  Ps = ["draw", "tie"],
  Is = {
    "2xs": "cui-top-1px",
    xs: "cui-top-1px",
    sm: "cui-top-1px",
    md: "cui-top-1px",
    lg: "cui-top-2px",
    xl: "cui-top-1",
    "2xl": "cui-top-1",
    "3xl": "cui-top-2",
    "4xl": "cui-top-3",
    "5xl": "cui-top-3"
  },
  zs = ["2xs", "xs", "sm", "md", "lg", "xl"],
  Rs = function Rs(e) {
    var t,
      r = e.size,
      a = void 0 === r ? "2xl" : r,
      n = e.className,
      o = void 0 === n ? "" : n,
      i = e.of,
      l = void 0 === i ? "athlete" : i,
      s = e.bgColor,
      c = void 0 === s ? "neutral" : s,
      u = e.type,
      d = void 0 === u ? "circle" : u,
      p = e.src,
      f = void 0 === p ? "" : p,
      v = e.icon,
      y = void 0 === v ? "" : v,
      g = e.iconColor,
      h = void 0 === g ? "" : g,
      b = e.country,
      N = e.isCountry,
      x = e.team,
      k = void 0 === x ? "" : x,
      w = e.id,
      _ = e.border,
      F = void 0 === _ ? 1 : _,
      S = e.borderColor,
      C = void 0 === S ? "fg-subtle" : S,
      j = e.altText,
      E = void 0 === j ? "" : j,
      T = e.mode,
      O = void 0 === T ? "light" : T,
      A = e.onClick,
      M = void 0 === A ? function () {} : A,
      L = Me(e, m),
      D = on(a),
      B = (D.sizeStyle, D.sizeClasses),
      P = D.sizeMap,
      I = js(k || ""),
      z = (I.league, I.abbreviation),
      R = void 0 === z ? "" : z,
      U = Le(I.colors, 1)[0],
      H = void 0 === U ? "" : U,
      G = w ? "".concat(w) : "cui__avatar-".concat(Ra());
    return dt.exports.jsxs("div", Te(Te({
      className: yt((t = {}, Oe(t, B, !!a), Oe(t, "cui-rounded-[9999px]", "circle" === d), Oe(t, "cui-bg-bg-layer-two", "neutral" === c), Oe(t, Bs[F], "none" !== F), Oe(t, "cui-border-solid", "none" !== F), Oe(t, Ds[C], "none" !== F), Oe(t, o, !0), t), "cui__avatar cui-relative cui-box-border cui-overflow-hidden cui-grid cui-place-items-center cui__color_icon"),
      id: G,
      onClick: function onClick(e) {
        return M(e, G);
      }
    }, L), {}, {
      children: [dt.exports.jsx(Us, Te({}, {
        src: f,
        size: a,
        sizeClasses: B,
        sizeMap: P,
        of: l,
        bgColor: c,
        icon: y,
        iconColor: h,
        team: k,
        country: b,
        isCountry: N,
        teamColorPrimary: H,
        logoName: R,
        altText: E,
        mode: O
      })), dt.exports.jsx("div", {
        className: "cui-absolute cui-inset-0 cui-z-0",
        style: {
          background: Hs(c, H, !!k)
        }
      })]
    }));
  },
  Us = function Us(e) {
    var t,
      r,
      a = e.src,
      n = e.size,
      o = void 0 === n ? "2xl" : n,
      i = e.sizeMap,
      l = e.sizeClasses,
      s = e.of,
      c = e.icon,
      u = e.iconColor,
      d = e.logoName,
      p = (e.bgColor, e.team),
      m = e.country,
      f = e.isCountry,
      v = (e.teamColorPrimary, e.altText, e.mode),
      y = Ps.includes((null == p ? void 0 : p.toLowerCase()) || "");
    if (a) return dt.exports.jsx("div", {
      className: yt((r = {}, Oe(r, l, !!o), Oe(r, "-cui-ml-1px", zs.includes(o)), r), "".concat("cui-relative cui-z-[1]", " cui-p-2px cui-aspect-auto cui-object-contain")),
      style: {
        backgroundImage: "url(".concat(a, ")"),
        backgroundSize: "auto 100%",
        backgroundPosition: "50%",
        backgroundRepeat: "no-repeat"
      }
    });
    if (c || p && f || m || y) {
      var g = void 0 !== m ? Ss(m) || Ss("countries-".concat(null == m ? void 0 : m.toLowerCase())) : null,
        h = y && !c ? "icon_ui_neutral-ban" : c || (p && f ? p : "") || (null == g ? void 0 : g.name) || m,
        b = {
          className: yt({
            "-cui-ml-1px": zs.includes(o)
          }, "".concat("cui-relative cui-z-[1]")),
          color: u || "fg-moderate",
          name: h,
          mode: v,
          size: i && "width" in i ? i.width - .3 * i.width : 0
        },
        N = rs(b),
        x = dt.exports.jsx(rs, Te(Te({}, b), {}, {
          name: "flag_placeholder"
        }));
      return N || (m ? x : null);
    }
    return !a && "athlete" === s || "logo" === s ? dt.exports.jsx(Ls, {
      name: d,
      className: "cui-relative cui-z-[1]",
      mode: v,
      size: i && "width" in i ? i.width - .2 * i.width : 0
    }) : dt.exports.jsx(rs, {
      name: "ui_person",
      color: "fg-moderate",
      className: yt((t = {}, Oe(t, Is[o], !0), Oe(t, "-cui-ml-1px", zs.includes(o)), t), "".concat("cui-relative cui-z-[1]")),
      size: o
    });
  };
function Hs(e, t, r) {
  return e && "team" !== e || !r || !t ? e in un ? un[e] : "var(--bg-layer-two)" : "".concat(t);
}
var Gs = ["nhl", "nfl", "nba", "mlb"],
  Vs = function Vs(e) {
    var t = e.children;
    return dt.exports.jsx("div", {
      tabIndex: -1,
      role: "presentation",
      children: t
    });
  },
  Ws = function Ws(e) {
    var t = e.image,
      r = e.showAvatar,
      a = e.competition,
      n = e.promoName,
      o = e.team,
      i = a ? a.toLowerCase() : null;
    return r ? t ? dt.exports.jsx(Vs, {
      children: dt.exports.jsx(Rs, {
        src: t,
        size: "3xl",
        bgColor: "bg-default",
        altText: "Promotional image for the sponsor ".concat(n),
        tabIndex: -1
      })
    }) : i && Gs.includes(i) ? dt.exports.jsx(Vs, {
      children: dt.exports.jsx(Rs, {
        icon: "brand_".concat(i, "_onLight"),
        size: "3xl",
        bgColor: "bg-default",
        tabIndex: -1
      })
    }) : o ? dt.exports.jsx(Vs, {
      children: dt.exports.jsx(Rs, {
        team: o,
        size: "3xl",
        bgColor: "bg-default",
        tabIndex: -1
      })
    }) : dt.exports.jsx(Vs, {
      children: dt.exports.jsx(Rs, {
        icon: "icon_ui_quick-pick",
        bgColor: "bg-default",
        iconColor: "fg-primary",
        size: "3xl",
        tabIndex: -1
      })
    }) : null;
  },
  Ks = {
    filled: {
      bg: "cui-bg-bg-primary",
      border: "cui-border-neutrals-transparent"
    },
    hollow: {
      bg: "cui-bg-bg-default",
      border: "cui-ring-fg-primary"
    }
  },
  Ys = "cui-box-content cui-w-2 cui-h-2 cui-rounded-[9999px] cui-z-[1]",
  $s = function $s(e) {
    var t = e.type,
      r = void 0 === t ? "filled" : t,
      a = Object.values(Ks[r]).join(" ");
    switch (r) {
      case "filled":
      default:
        return dt.exports.jsx("div", {
          className: "".concat(Ys, " ").concat(a)
        });
      case "hollow":
        return dt.exports.jsx("div", {
          className: "".concat(Ys, " cui-ring-1 cui-ring-inset ").concat(a)
        });
    }
  },
  qs = function qs(e) {
    var t,
      r = e.hideBottomPole,
      a = e.isLastLeg,
      n = e.isFirstLeg,
      o = e.hideBullet,
      i = e.icon,
      l = e.text,
      s = e.bulletType;
    return dt.exports.jsx("li", {
      className: yt((t = {}, Oe(t, "after:cui-absolute after:cui-content-[''] after:cui-h-full after:cui-w-1px after:cui-bg-fg-primary after:cui-z-0 after:cui-bottom-0 after:cui-top-[8px]", !r && !a), Oe(t, "cui-pt-1", !n), Oe(t, "cui-invisible", o), t), "cui-min-w-[20px] cui-m-0 cui-p-0 cui-flex cui-justify-center cui-items-start cui-relative"),
      role: "presentation",
      children: i ? dt.exports.jsxs("div", {
        className: "cui-z-[1] focus:cui-outline-none group-focus-visible:cui-ring-1 group-focus-visible:cui-ring-offset-2 group-focus-visible:cui-ring-fg-focus",
        role: "presentation",
        "aria-hidden": "true",
        children: [i, dt.exports.jsx("span", {
          className: "cui-sr-only",
          children: l
        })]
      }) : dt.exports.jsx($s, {
        type: s
      })
    });
  };
function Js(e, t) {
  t && e.length;
  return t ? "".concat(e.slice(0, t)).concat("") : e;
}
function Xs(e) {
  return "object" === ze(e) && "name" in e && e.name ? Te({
    size: "xs"
  }, e) : "string" == typeof e && e ? {
    name: e,
    size: "xs"
  } : null;
}
var Zs = function Zs() {
    return dt.exports.jsx("div", {
      className: "cui-w-1px cui-h-md cui-bg-fg-subtle",
      children: " "
    });
  },
  Qs = function Qs(e) {
    var t,
      r = e.tag,
      a = e.fgColor,
      n = void 0 === a ? "fg-moderate" : a,
      o = e.textSize,
      i = void 0 === o ? "body-sm-bold" : o,
      l = e.bgColor,
      s = void 0 === l ? "neutrals-transparent" : l,
      c = e.leftIcon,
      u = void 0 === c ? "" : c,
      d = e.rightIcon,
      p = void 0 === d ? "" : d,
      m = e.showDivider,
      f = void 0 === m || m,
      v = e.isFirst,
      y = void 0 !== v && v,
      g = e.isLast,
      h = void 0 !== g && g,
      b = Xs(u),
      N = Xs(p),
      x = "bg-default" === s || "neutrals-transparent" === s,
      k = y && h;
    return dt.exports.jsxs(dt.exports.Fragment, {
      children: [f && !y ? dt.exports.jsx(Zs, {}) : null, dt.exports.jsxs("span", {
        className: yt((t = {}, Oe(t, i, !!i), Oe(t, "cui-mx-1", !!s && !x), Oe(t, "cui-px-1", !y && !h), Oe(t, "cui-pl-1", h && !k), Oe(t, "cui-pr-1", y && !k), t), "cui-inline-flex cui-gap-1 cui-items-center cui-py-0 cui-rounded-2px"),
        style: {
          color: "var(--".concat(n, ")"),
          background: "var(--".concat(s, ")")
        },
        children: [b ? dt.exports.jsx(rs, Te({}, b)) : null, r, N ? dt.exports.jsx(rs, Te({}, N)) : null]
      })]
    });
  },
  ec = {
    exports: {}
  },
  tc = ec.exports = function () {
    var e = 1e3,
      t = 6e4,
      r = 36e5,
      a = "millisecond",
      n = "second",
      o = "minute",
      i = "hour",
      l = "day",
      s = "week",
      c = "month",
      u = "quarter",
      d = "year",
      _p2 = "date",
      m = "Invalid Date",
      f = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
      v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      y = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(e) {
          var t = ["th", "st", "nd", "rd"],
            r = e % 100;
          return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
        }
      },
      g = function g(e, t, r) {
        var a = String(e);
        return !a || a.length >= t ? e : "" + Array(t + 1 - a.length).join(r) + e;
      },
      h = {
        s: g,
        z: function z(e) {
          var t = -e.utcOffset(),
            r = Math.abs(t),
            a = Math.floor(r / 60),
            n = r % 60;
          return (t <= 0 ? "+" : "-") + g(a, 2, "0") + ":" + g(n, 2, "0");
        },
        m: function e(t, r) {
          if (t.date() < r.date()) return -e(r, t);
          var a = 12 * (r.year() - t.year()) + (r.month() - t.month()),
            n = t.clone().add(a, c),
            o = r - n < 0,
            i = t.clone().add(a + (o ? -1 : 1), c);
          return +(-(a + (r - n) / (o ? n - i : i - n)) || 0);
        },
        a: function a(e) {
          return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
        },
        p: function p(e) {
          return {
            M: c,
            y: d,
            w: s,
            d: l,
            D: _p2,
            h: i,
            m: o,
            s: n,
            ms: a,
            Q: u
          }[e] || String(e || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(e) {
          return void 0 === e;
        }
      },
      b = "en",
      N = {};
    N[b] = y;
    var x = function x(e) {
        return e instanceof F;
      },
      k = function e(t, r, a) {
        var n;
        if (!t) return b;
        if ("string" == typeof t) {
          var o = t.toLowerCase();
          N[o] && (n = o), r && (N[o] = r, n = o);
          var i = t.split("-");
          if (!n && i.length > 1) return e(i[0]);
        } else {
          var l = t.name;
          N[l] = t, n = l;
        }
        return !a && n && (b = n), n || !a && b;
      },
      w = function w(e, t) {
        if (x(e)) return e.clone();
        var r = "object" == ze(t) ? t : {};
        return r.date = e, r.args = arguments, new F(r);
      },
      _ = h;
    _.l = k, _.i = x, _.w = function (e, t) {
      return w(e, {
        locale: t.$L,
        utc: t.$u,
        x: t.$x,
        $offset: t.$offset
      });
    };
    var F = function () {
        function y(e) {
          this.$L = k(e.locale, null, !0), this.parse(e);
        }
        var g = y.prototype;
        return g.parse = function (e) {
          this.$d = function (e) {
            var t = e.date,
              r = e.utc;
            if (null === t) return new Date(NaN);
            if (_.u(t)) return new Date();
            if (t instanceof Date) return new Date(t);
            if ("string" == typeof t && !/Z$/i.test(t)) {
              var a = t.match(f);
              if (a) {
                var n = a[2] - 1 || 0,
                  o = (a[7] || "0").substring(0, 3);
                return r ? new Date(Date.UTC(a[1], n, a[3] || 1, a[4] || 0, a[5] || 0, a[6] || 0, o)) : new Date(a[1], n, a[3] || 1, a[4] || 0, a[5] || 0, a[6] || 0, o);
              }
            }
            return new Date(t);
          }(e), this.$x = e.x || {}, this.init();
        }, g.init = function () {
          var e = this.$d;
          this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
        }, g.$utils = function () {
          return _;
        }, g.isValid = function () {
          return !(this.$d.toString() === m);
        }, g.isSame = function (e, t) {
          var r = w(e);
          return this.startOf(t) <= r && r <= this.endOf(t);
        }, g.isAfter = function (e, t) {
          return w(e) < this.startOf(t);
        }, g.isBefore = function (e, t) {
          return this.endOf(t) < w(e);
        }, g.$g = function (e, t, r) {
          return _.u(e) ? this[t] : this.set(r, e);
        }, g.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }, g.valueOf = function () {
          return this.$d.getTime();
        }, g.startOf = function (e, t) {
          var r = this,
            a = !!_.u(t) || t,
            u = _.p(e),
            m = function m(e, t) {
              var n = _.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
              return a ? n : n.endOf(l);
            },
            f = function f(e, t) {
              return _.w(r.toDate()[e].apply(r.toDate("s"), (a ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(t)), r);
            },
            v = this.$W,
            y = this.$M,
            g = this.$D,
            h = "set" + (this.$u ? "UTC" : "");
          switch (u) {
            case d:
              return a ? m(1, 0) : m(31, 11);
            case c:
              return a ? m(1, y) : m(0, y + 1);
            case s:
              var b = this.$locale().weekStart || 0,
                N = (v < b ? v + 7 : v) - b;
              return m(a ? g - N : g + (6 - N), y);
            case l:
            case _p2:
              return f(h + "Hours", 0);
            case i:
              return f(h + "Minutes", 1);
            case o:
              return f(h + "Seconds", 2);
            case n:
              return f(h + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, g.endOf = function (e) {
          return this.startOf(e, !1);
        }, g.$set = function (e, t) {
          var r,
            s = _.p(e),
            u = "set" + (this.$u ? "UTC" : ""),
            m = (r = {}, r[l] = u + "Date", r[_p2] = u + "Date", r[c] = u + "Month", r[d] = u + "FullYear", r[i] = u + "Hours", r[o] = u + "Minutes", r[n] = u + "Seconds", r[a] = u + "Milliseconds", r)[s],
            f = s === l ? this.$D + (t - this.$W) : t;
          if (s === c || s === d) {
            var v = this.clone().set(_p2, 1);
            v.$d[m](f), v.init(), this.$d = v.set(_p2, Math.min(this.$D, v.daysInMonth())).$d;
          } else m && this.$d[m](f);
          return this.init(), this;
        }, g.set = function (e, t) {
          return this.clone().$set(e, t);
        }, g.get = function (e) {
          return this[_.p(e)]();
        }, g.add = function (a, u) {
          var p,
            m = this;
          a = Number(a);
          var f = _.p(u),
            v = function v(e) {
              var t = w(m);
              return _.w(t.date(t.date() + Math.round(e * a)), m);
            };
          if (f === c) return this.set(c, this.$M + a);
          if (f === d) return this.set(d, this.$y + a);
          if (f === l) return v(1);
          if (f === s) return v(7);
          var y = (p = {}, p[o] = t, p[i] = r, p[n] = e, p)[f] || 1,
            g = this.$d.getTime() + a * y;
          return _.w(g, this);
        }, g.subtract = function (e, t) {
          return this.add(-1 * e, t);
        }, g.format = function (e) {
          var t = this,
            r = this.$locale();
          if (!this.isValid()) return r.invalidDate || m;
          var a = e || "YYYY-MM-DDTHH:mm:ssZ",
            n = _.z(this),
            o = this.$H,
            i = this.$m,
            l = this.$M,
            s = r.weekdays,
            c = r.months,
            u = function u(e, r, n, o) {
              return e && (e[r] || e(t, a)) || n[r].slice(0, o);
            },
            d = function d(e) {
              return _.s(o % 12 || 12, e, "0");
            },
            p = r.meridiem || function (e, t, r) {
              var a = e < 12 ? "AM" : "PM";
              return r ? a.toLowerCase() : a;
            },
            f = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: l + 1,
              MM: _.s(l + 1, 2, "0"),
              MMM: u(r.monthsShort, l, c, 3),
              MMMM: u(c, l),
              D: this.$D,
              DD: _.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: u(r.weekdaysMin, this.$W, s, 2),
              ddd: u(r.weekdaysShort, this.$W, s, 3),
              dddd: s[this.$W],
              H: String(o),
              HH: _.s(o, 2, "0"),
              h: d(1),
              hh: d(2),
              a: p(o, i, !0),
              A: p(o, i, !1),
              m: String(i),
              mm: _.s(i, 2, "0"),
              s: String(this.$s),
              ss: _.s(this.$s, 2, "0"),
              SSS: _.s(this.$ms, 3, "0"),
              Z: n
            };
          return a.replace(v, function (e, t) {
            return t || f[e] || n.replace(":", "");
          });
        }, g.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, g.diff = function (a, p, m) {
          var f,
            v = _.p(p),
            y = w(a),
            g = (y.utcOffset() - this.utcOffset()) * t,
            h = this - y,
            b = _.m(this, y);
          return b = (f = {}, f[d] = b / 12, f[c] = b, f[u] = b / 3, f[s] = (h - g) / 6048e5, f[l] = (h - g) / 864e5, f[i] = h / r, f[o] = h / t, f[n] = h / e, f)[v] || h, m ? b : _.a(b);
        }, g.daysInMonth = function () {
          return this.endOf(c).$D;
        }, g.$locale = function () {
          return N[this.$L];
        }, g.locale = function (e, t) {
          if (!e) return this.$L;
          var r = this.clone(),
            a = k(e, t, !0);
          return a && (r.$L = a), r;
        }, g.clone = function () {
          return _.w(this.$d, this);
        }, g.toDate = function () {
          return new Date(this.valueOf());
        }, g.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }, g.toISOString = function () {
          return this.$d.toISOString();
        }, g.toString = function () {
          return this.$d.toUTCString();
        }, y;
      }(),
      S = F.prototype;
    return w.prototype = S, [["$ms", a], ["$s", n], ["$m", o], ["$H", i], ["$W", l], ["$M", c], ["$y", d], ["$D", _p2]].forEach(function (e) {
      S[e[1]] = function (t) {
        return this.$g(t, e[0], e[1]);
      };
    }), w.extend = function (e, t) {
      return e.$i || (e(t, F, w), e.$i = !0), w;
    }, w.locale = k, w.isDayjs = x, w.unix = function (e) {
      return w(1e3 * e);
    }, w.en = N[b], w.Ls = N, w.p = {}, w;
  }(),
  rc = {
    exports: {}
  },
  ac = rc.exports = function (e, t, r) {
    t.prototype.isToday = function () {
      var e = "YYYY-MM-DD",
        t = r();
      return this.format(e) === t.format(e);
    };
  },
  nc = {
    exports: {}
  },
  oc = nc.exports = function (e, t, r) {
    t.prototype.isTomorrow = function () {
      var e = "YYYY-MM-DD",
        t = r().add(1, "day");
      return this.format(e) === t.format(e);
    };
  };
tc.extend(ac), tc.extend(oc);
var ic = {
    "men-on-base": function menOnBase(e) {
      return {
        showDivider: !1,
        leftIcon: {
          name: "icon_ui_baseball_diamond",
          size: "lg",
          options: e.options,
          className: "cui-absolute"
        }
      };
    },
    date: function date(e) {
      var t = "date" in e ? tc(e.date) : "",
        r = tc(new Date()).diff(t, "days"),
        a = t && t.isToday(),
        n = t && t.isTomorrow(),
        o = t && t.isValid(),
        i = t && t.format("ddd").toUpperCase();
      return n && (i = "Tomorrow"), a && (i = "Today"), Math.abs(r) >= 6 && (i = t && t.format("MMM D").toUpperCase()), o ? [Te({
        tag: o ? i : ""
      }, e), Te({
        tag: o ? t.format("h:mm A") : "",
        showDivider: !0
      }, e)] : [{
        tag: "---",
        fgColor: "fg-subtle"
      }, {
        tag: "---",
        fgColor: "fg-subtle"
      }];
    },
    live: function live(e) {
      return {
        leftIcon: {
          name: "ui_live_animated",
          size: 8
        },
        tag: "Live",
        fgColor: "highlight-accent"
      };
    },
    livestream: function livestream(e) {
      var t = e.tag;
      return {
        leftIcon: {
          name: "ui_watch",
          size: "md",
          color: "highlight-accent"
        },
        tag: t || "Watch"
      };
    },
    highlight: function highlight(e) {
      return {
        fgColor: "highlight-accent"
      };
    },
    "highlight-bg": function highlightBg(e) {
      return {
        bgColor: "ultramarine-300",
        fgColor: "highlight-accent"
      };
    },
    signpost: function signpost(e) {
      return {
        textSize: "display-xs",
        fgColor: "fg-moderate"
      };
    },
    suspended: function suspended(e) {
      return {
        tag: "Suspended",
        fgColor: "status-negative"
      };
    },
    "rain-delay": function rainDelay(e) {
      return {
        tag: "Rain Delay",
        fgColor: "status-negative"
      };
    },
    firebets: function firebets(e) {
      return {
        tag: "",
        leftIcon: {
          name: "ui_fire-bets_color",
          size: "md"
        }
      };
    },
    sgp: function sgp(e) {
      return {
        tag: "",
        leftIcon: {
          name: "ui_sgp",
          size: "md",
          color: "fg-primary"
        }
      };
    }
  },
  lc = Wl(function (e, t, r) {
    return e + (r ? "-" : "") + t.toLowerCase();
  }),
  sc = lc,
  cc = function cc(e) {
    var t,
      r,
      a = e.list,
      n = (e.gap, e.noPad),
      o = void 0 !== n && n,
      i = e.noWrap,
      l = void 0 !== i && i,
      s = e.className,
      c = void 0 === s ? "" : s,
      u = null == a ? void 0 : a.filter(function (e) {
        return !!e;
      }).map(function (e, t) {
        var n = 0 === t || 1 === a.length,
          o = t === a.length - 1 || 1 === a.length,
          i = "cui__details-detail-".concat(sc("string" == typeof e ? e : ""), "-").concat(t),
          l = e && "type" in e ? e.type : "",
          s = e && "tag" in e ? e.tag : "",
          c = e && l && l in ic ? ic[l](e) : {},
          u = !(n || 1 === t && r) && (Array.isArray(c) || "boolean" != typeof (null == c ? void 0 : c.showDivider) ? "boolean" != typeof (null == e ? void 0 : e.showDivider) || (null == e ? void 0 : e.showDivider) : null == c ? void 0 : c.showDivider);
        return r || (r = 0 === t && "live" === l), l && "string" == typeof l ? "live" === l && 0 === t ? 1 === a.length ? $e(Qs, Te(Te({}, c), {}, {
          showDivider: u,
          isFirst: n,
          isLast: o,
          key: i
        })) : $e(Qs, Te(Te({}, c), {}, {
          tag: "",
          showDivider: u,
          isFirst: n,
          key: i
        })) : "date" === l ? Array.isArray(c) ? c.map(function (r, a) {
          var n = {
            showDivider: null != r && r.showDivider ? null == r ? void 0 : r.showDivider : null == e ? void 0 : e.showDivider
          };
          return $e(Qs, Te(Te({}, r), {}, {
            showDivider: n.showDivider,
            isFirst: 0 === t && 0 === a,
            isLast: o && a === c.length - 1,
            key: "".concat(i, "-").concat(a)
          }));
        }) : null : $e(Qs, Te(Te({}, c), {}, {
          tag: s || (Array.isArray(c) ? "" : c.tag),
          showDivider: u,
          isFirst: n,
          isLast: o,
          key: i
        })) : $e(Qs, Te(Te({}, e), {}, {
          showDivider: u,
          isFirst: n,
          isLast: o,
          key: i
        }));
      }).filter(function (e) {
        return !!e;
      });
    return null != u && u.length ? dt.exports.jsx("div", {
      className: null === (t = yt(Oe({
        "cui-py-1": !o,
        "cui-flex-wrap": !l
      }, c, !!c), "cui__details cui-flex cui-items-center cui-gap-y-2px cui-min-h-[26px]")) || void 0 === t ? void 0 : t.trim(),
      children: u
    }) : null;
  },
  uc = function uc(e) {
    var t = e.isTitle,
      r = e.isDate,
      a = e.boldText,
      n = e.hideBullet,
      o = e.showBulletOnly,
      i = e.text,
      l = e.characterLimit,
      s = e.children,
      c = t ? {
        elementtiming: "quick_picks"
      } : {};
    return r ? dt.exports.jsx("li", {
      className: yt({
        "-cui-ml-6": n
      }, "cui__leg-date cui-flex cui-items-center cui-text-fg-default focus:cui-outline-none focus-visible:cui-ring-1 focus-visible:cui-ring-offset-2 focus-visible:cui-ring-fg-focus"),
      "aria-hidden": o ? "true" : "false",
      tabIndex: o ? -1 : 0,
      children: dt.exports.jsx(cc, {
        className: "cui-pt-2px cui-pb-1",
        noPad: !0,
        list: [{
          type: "date",
          date: i,
          textSize: "body-sm"
        }]
      })
    }) : dt.exports.jsx("li", Te(Te({
      className: yt({
        "display-sm-bold": t,
        "body-sm": !a && !t,
        "body-sm-bold": a && !t,
        "-cui-ml-6": n
      }, "cui-flex cui-items-center cui-text-fg-default focus:cui-outline-none focus-visible:cui-ring-1 focus-visible:cui-ring-offset-2 focus-visible:cui-ring-fg-focus"),
      "aria-hidden": o ? "true" : "false",
      tabIndex: o ? -1 : 0
    }, c), {}, {
      children: !o && i ? Js(i, l) : s
    }));
  },
  dc = function dc(e) {
    var t = e.icon,
      r = e.children,
      a = e.bulletType,
      n = void 0 === a ? "hollow" : a,
      o = e.boldText,
      i = void 0 !== o && o,
      l = e.isTitle,
      s = void 0 !== l && l,
      c = e.isDate,
      u = void 0 !== c && c,
      d = e.text,
      p = void 0 === d ? "" : d,
      m = e.characterLimit,
      f = e.options,
      v = void 0 === f ? {} : f,
      y = e.isFirstLeg,
      g = void 0 !== y && y,
      h = e.isLastLeg,
      b = void 0 !== h && h,
      N = v.hideBottomPole,
      x = void 0 !== N && N,
      k = v.hideBullet,
      w = void 0 !== k && k,
      _ = v.showBulletOnly,
      F = void 0 !== _ && _;
    return p || r || F ? dt.exports.jsxs(dt.exports.Fragment, {
      children: [dt.exports.jsx(qs, Te({}, {
        hideBottomPole: x,
        isLastLeg: b,
        isFirstLeg: g,
        hideBullet: w,
        icon: t,
        text: p,
        bulletType: n
      })), dt.exports.jsx(uc, Te({}, {
        isTitle: s,
        isDate: u,
        boldText: i,
        hideBullet: w,
        showBulletOnly: F,
        text: p,
        characterLimit: m,
        children: r
      }))]
    }) : null;
  },
  pc = function pc(e) {
    var t = e.characterLimit,
      r = void 0 === t ? null : t,
      a = e.legs,
      n = e.bulletType,
      o = void 0 === n ? "hollow" : n,
      i = e.boldText,
      l = void 0 !== i && i,
      s = e.tabbable,
      c = void 0 === s || s,
      u = Me(e, f),
      d = (null == a ? void 0 : a.length) - 1;
    return dt.exports.jsx("ol", Te(Te({
      className: "cui-group cui-m-0 cui-p-0 cui-list-none cui-grid cui-grid-cols-[auto,1fr] cui-grid-flow-row cui-gap-x-xs cui-gap-y-2xs focus:cui-outline-none focus-visible:cui-outline-none",
      tabIndex: c ? 0 : -1
    }, u), {}, {
      children: null == a ? void 0 : a.map(function (e, t) {
        if (null !== e) return $e(dc, Te(Te({}, Te(Te({}, e), {}, {
          bulletType: null != e && e.bulletType ? e.bulletType : o,
          characterLimit: null != e && e.characterLimit ? null == e ? void 0 : e.characterLimit : r,
          boldText: e.boldText ? e.boldText : l
        })), {}, {
          key: "cui__leg-".concat(null == e ? void 0 : e.id).concat(Ra()),
          text: e.text,
          isFirstLeg: 0 === t,
          isLastLeg: t === d
        }));
      })
    }));
  },
  mc = function mc(e) {
    var t = e.computedLegs;
    return dt.exports.jsx("div", {
      className: "cui-flex-grow",
      role: "group",
      children: dt.exports.jsx(pc, {
        legs: t,
        "aria-label": "Quick Pick",
        tabbable: !1
      })
    });
  },
  fc = function fc(e) {
    var t = e.name,
      r = e.size,
      a = void 0 === r ? "sm" : r;
    return dt.exports.jsx("div", {
      className: yt({
        "cui-p-2px": "2xs" === a,
        "cui-px-2xs cui-py-2px": "2xs" !== a
      }, "cui-bg-bg-primary cui-flex cui-items-center cui-justify-center cui-rounded-1"),
      children: dt.exports.jsx(rs, {
        name: t,
        color: "fg-inverse",
        size: a
      })
    });
  },
  vc = {
    qp: "ui_quick-pick-initials",
    sgp: "ui_sgp",
    none: ""
  };
function yc(e) {
  var t = e.badge,
    r = e.title,
    a = e.showBadge,
    n = e.legs,
    o = e.startTime,
    i = e.showTime,
    l = {
      icon: dt.exports.jsx(fc, {
        name: vc[t]
      }),
      text: r,
      boldText: !0,
      isTitle: !0,
      options: {}
    },
    s = {
      text: o,
      isDate: !0,
      options: {
        hideBullet: !0
      }
    };
  return a || (l.icon = null, l.options.hideBullet = !0), [l, i ? s : {}].concat(Ce(n.map(function (e) {
    return Te({
      text: e.selectionDisplayName,
      id: null == e ? void 0 : e.marketId
    }, e);
  })));
}
var gc = function gc(e) {
  var t = e.legs,
    r = void 0 === t ? [] : t,
    a = e.onClick,
    n = void 0 === a ? function () {} : a,
    o = e.price,
    i = e.title,
    l = e.disabled,
    s = void 0 !== l && l,
    c = e.selected,
    u = void 0 !== c && c,
    d = e.badge,
    p = void 0 === d ? "qp" : d,
    m = e.promo,
    f = e.showBadge,
    v = void 0 !== f && f,
    y = e.showAvatar,
    g = void 0 === y || y,
    h = e.showBorder,
    b = void 0 === h || h,
    N = e.showTime,
    x = void 0 !== N && N,
    k = e.startTime,
    w = e.id,
    _ = e.role,
    F = void 0 === _ ? "group" : _,
    S = e.bet,
    C = void 0 === S ? 20 : S,
    j = wi(m, "image", null),
    E = wi(m, "competition", null),
    T = wi(m, "name", null),
    O = wi(m, "team", null),
    A = Xe(function () {
      return yc({
        badge: p,
        title: i,
        showBadge: v,
        legs: r,
        startTime: k,
        showTime: x
      });
    }, [p, i, v, r, x, k]),
    M = "Quick Pick".concat(i ? ", ".concat(i, ",") : "", " with ").concat(r.length, " legs ").concat(T ? ", sponsored by ".concat(T) : "");
  return dt.exports.jsxs("div", {
    className: yt({
      "cui-border-solid cui-border-1 cui-border-fg-minimal": b,
      "cui-border-solid cui-border-1 cui-border-neutrals-transparent": !b
    }, "cui-flex cui-flex-col cui-py-xs cui-w-[300px] cui-h-full cui-rounded-1 cui-box-border cui-bg-bg-default"),
    role: F,
    "aria-label": M,
    id: w,
    tabIndex: 0,
    "data-cy": "quick-pick",
    children: [dt.exports.jsxs("div", {
      className: "cui-w-auto cui-flex-grow cui-flex cui-items-start cui-justify-between cui-px-xs cui-gap-xs",
      tabIndex: -1,
      children: [dt.exports.jsx(mc, {
        computedLegs: A
      }), dt.exports.jsx(Ws, Te({}, {
        showAvatar: g,
        competition: E,
        image: j,
        team: O,
        promoName: T
      }))]
    }), dt.exports.jsx("div", {
      className: "cui-pt-xs cui-px-sm",
      children: dt.exports.jsx(Mi, {
        id: "".concat(w, "-market-button"),
        odds: o,
        onClick: function onClick(e) {
          return n(r, e);
        },
        isSelected: u,
        isDisabled: s,
        variant: "promo",
        promoText: {
          bet: C
        },
        fluid: !0,
        animation: "off"
      })
    })]
  });
};
function hc(e) {
  var t = e.legs,
    r = void 0 === t ? [] : t,
    a = e.onClick,
    n = void 0 === a ? function () {} : a,
    o = e.price,
    i = e.title,
    l = e.disabled,
    s = void 0 !== l && l,
    c = e.selected,
    u = void 0 !== c && c,
    d = e.badge,
    p = void 0 === d ? "qp" : d,
    m = e.showBadge,
    f = e.id,
    v = Xe(function () {
      return yc({
        badge: p,
        title: i,
        showBadge: m,
        legs: r
      });
    }, [p, i, m, r]);
  return dt.exports.jsxs("div", {
    className: "cui-w-auto cui-flex cui-items-center cui-justify-between cui-gap-lg",
    role: "presentation",
    "data-cy": "quick-pick",
    children: [dt.exports.jsx("div", {
      className: "cui-w-3/4",
      role: "group",
      children: dt.exports.jsx(mc, {
        computedLegs: v
      })
    }), dt.exports.jsx("div", {
      className: "cui-max-w-[144px] cui-w-1/4",
      children: dt.exports.jsx(Mi, {
        id: "".concat(f, "-market-button"),
        variant: "highlight",
        odds: o,
        onClick: function onClick(e) {
          return n(r, e);
        },
        isSelected: u,
        isDisabled: s,
        fluid: !0,
        animation: "off"
      })
    })]
  });
}
var bc = {
    sm: "cui-rounded-sm",
    md: "cui-rounded-md",
    lg: "cui-rounded-lg",
    full: "cui-rounded-[9999px]"
  },
  Nc = function Nc(e) {
    var t = e.width,
      r = e.minWidth,
      a = void 0 === r ? "0" : r,
      n = e.height,
      o = e.className,
      i = e.rounded,
      l = void 0 === i ? "md" : i,
      s = Me(e, v),
      c = l in bc ? bc[l] : "",
      u = {};
    return t && (u.width = xc(t)), n && (u.height = xc(n)), a && "0" !== a && (u.minWidth = xc(a)), dt.exports.jsx("div", Te({
      className: "cui-bg-bg-layer-two cui-animate-pulse ".concat(c, " ").concat(o),
      style: u
    }, s));
  };
function xc(e) {
  return e ? /\%$/.test("".concat(e)) ? e : "".concat(e, "px") : "";
}
var kc = function kc(e) {
    var t = e.variant;
    return t && "minimal" === t ? dt.exports.jsx("div", {
      role: "presentation",
      className: "cui-flex cui-flex-col cui-px-xs cui-py-2xs cui-w-full cui-h-full cui-rounded-1 cui-box-border",
      children: dt.exports.jsxs("div", {
        className: "cui-flex",
        children: [dt.exports.jsxs("div", {
          className: "cui-flex-grow cui-flex cui-flex-col cui-gap-xs",
          children: [dt.exports.jsx(Nc, {
            width: 180,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 160,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 180,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 160,
            height: 12
          })]
        }), dt.exports.jsx("div", {
          className: "cui-w-auto cui-flex cui-items-center cui-ml-sm",
          children: dt.exports.jsx(Nc, {
            width: 96,
            height: 44
          })
        })]
      })
    }) : dt.exports.jsxs("div", {
      role: "presentation",
      className: "cui-flex cui-flex-col cui-p-xs small-mobile:cui-w-[300px] cui-w-[calc(100vw-32px)] cui-h-full cui-rounded-1 cui-box-border",
      children: [dt.exports.jsxs("div", {
        className: "cui-flex",
        children: [dt.exports.jsxs("div", {
          className: "cui-flex-grow cui-flex cui-flex-col cui-gap-xs",
          children: [dt.exports.jsx(Nc, {
            width: 140,
            height: 18
          }), dt.exports.jsx(Nc, {
            width: 180,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 160,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 180,
            height: 12
          }), dt.exports.jsx(Nc, {
            width: 160,
            height: 12
          })]
        }), dt.exports.jsx("div", {
          className: "cui-w-auto",
          children: dt.exports.jsx(Nc, {
            width: 48,
            height: 48,
            rounded: "full"
          })
        })]
      }), dt.exports.jsx("div", {
        className: "cui-mt-xs",
        children: dt.exports.jsx(Nc, {
          width: 284,
          height: 44
        })
      })]
    });
  },
  wc = function wc(e) {
    if (e.skeleton) return dt.exports.jsx(kc, {
      variant: e.variant
    });
    var t = Ge(Ra()),
      r = e.title,
      a = "cui__quick-pick-".concat(sc(void 0 === r ? "" : r), "-").concat(t.current);
    return "minimal" === e.variant ? dt.exports.jsx(hc, Te(Te({}, e), {}, {
      id: a
    })) : dt.exports.jsx("div", {
      className: "cui-h-[100%]",
      tabIndex: -1,
      children: dt.exports.jsx(gc, Te(Te({}, e), {}, {
        id: a
      }))
    });
  };
function _c(e) {
  return null !== e && "object" === ze(e) && "constructor" in e && e.constructor === Object;
}
function Fc(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function (r) {
    void 0 === e[r] ? e[r] = t[r] : _c(t[r]) && _c(e[r]) && Object.keys(t[r]).length > 0 && Fc(e[r], t[r]);
  });
}
var Sc = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ""
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Cc() {
  var e = "undefined" != typeof document ? document : {};
  return Fc(e, Sc), e;
}
var jc,
  Ec,
  Tc,
  Oc = {
    document: Sc,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState: function replaceState() {},
      pushState: function pushState() {},
      go: function go() {},
      back: function back() {}
    },
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return "";
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
      return {};
    },
    requestAnimationFrame: function requestAnimationFrame(e) {
      return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame: function cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    }
  };
function Ac() {
  var e = "undefined" != typeof window ? window : {};
  return Fc(e, Oc), e;
}
function Mc(e) {
  return void 0 === e && (e = ""), e.trim().split(" ").filter(function (e) {
    return !!e.trim();
  });
}
function Lc(e, t) {
  return void 0 === t && (t = 0), setTimeout(e, t);
}
function Dc() {
  return Date.now();
}
function Bc(e, t) {
  void 0 === t && (t = "x");
  var r,
    a,
    n,
    o = Ac(),
    i = function (e) {
      var t,
        r = Ac();
      return r.getComputedStyle && (t = r.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t;
    }(e);
  return o.WebKitCSSMatrix ? ((a = i.transform || i.webkitTransform).split(",").length > 6 && (a = a.split(", ").map(function (e) {
    return e.replace(",", ".");
  }).join(", ")), n = new o.WebKitCSSMatrix("none" === a ? "" : a)) : r = (n = i.MozTransform || i.OTransform || i.MsTransform || i.msTransform || i.transform || i.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (a = o.WebKitCSSMatrix ? n.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])), "y" === t && (a = o.WebKitCSSMatrix ? n.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])), a || 0;
}
function Pc(e) {
  return "object" === ze(e) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function Ic(e) {
  return "undefined" != typeof window && void 0 !== window.HTMLElement ? e instanceof HTMLElement : e && (1 === e.nodeType || 11 === e.nodeType);
}
function zc() {
  for (var e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"], r = 1; r < arguments.length; r += 1) {
    var a = r < 0 || arguments.length <= r ? void 0 : arguments[r];
    if (null != a && !Ic(a)) for (var n = Object.keys(Object(a)).filter(function (e) {
        return t.indexOf(e) < 0;
      }), o = 0, i = n.length; o < i; o += 1) {
      var l = n[o],
        s = Object.getOwnPropertyDescriptor(a, l);
      void 0 !== s && s.enumerable && (Pc(e[l]) && Pc(a[l]) ? a[l].__swiper__ ? e[l] = a[l] : zc(e[l], a[l]) : !Pc(e[l]) && Pc(a[l]) ? (e[l] = {}, a[l].__swiper__ ? e[l] = a[l] : zc(e[l], a[l])) : e[l] = a[l]);
    }
  }
  return e;
}
function Rc(e, t, r) {
  e.style.setProperty(t, r);
}
function Uc(e) {
  var t,
    r = e.swiper,
    a = e.targetPosition,
    n = e.side,
    o = Ac(),
    i = -r.translate,
    l = null,
    s = r.params.speed;
  r.wrapperEl.style.scrollSnapType = "none", o.cancelAnimationFrame(r.cssModeFrameID);
  var c = a > i ? "next" : "prev",
    u = function u(e, t) {
      return "next" === c && e >= t || "prev" === c && e <= t;
    };
  !function e() {
    t = new Date().getTime(), null === l && (l = t);
    var c = Math.max(Math.min((t - l) / s, 1), 0),
      d = .5 - Math.cos(c * Math.PI) / 2,
      p = i + d * (a - i);
    if (u(p, a) && (p = a), r.wrapperEl.scrollTo(Oe({}, n, p)), u(p, a)) return r.wrapperEl.style.overflow = "hidden", r.wrapperEl.style.scrollSnapType = "", setTimeout(function () {
      r.wrapperEl.style.overflow = "", r.wrapperEl.scrollTo(Oe({}, n, p));
    }), void o.cancelAnimationFrame(r.cssModeFrameID);
    r.cssModeFrameID = o.requestAnimationFrame(e);
  }();
}
function Hc(e, t) {
  return void 0 === t && (t = ""), Ce(e.children).filter(function (e) {
    return e.matches(t);
  });
}
function Gc(e) {
  try {
    return;
  } catch (e) {}
}
function Vc(e, t) {
  var r;
  void 0 === t && (t = []);
  var a = document.createElement(e);
  return (r = a.classList).add.apply(r, Ce(Array.isArray(t) ? t : Mc(t))), a;
}
function Wc(e) {
  var t = Ac(),
    r = Cc(),
    a = e.getBoundingClientRect(),
    n = r.body,
    o = e.clientTop || n.clientTop || 0,
    i = e.clientLeft || n.clientLeft || 0,
    l = e === t ? t.scrollY : e.scrollTop,
    s = e === t ? t.scrollX : e.scrollLeft;
  return {
    top: a.top + l - o,
    left: a.left + s - i
  };
}
function Kc(e, t) {
  return Ac().getComputedStyle(e, null).getPropertyValue(t);
}
function Yc(e) {
  var t,
    r = e;
  if (r) {
    for (t = 0; null !== (r = r.previousSibling);) 1 === r.nodeType && (t += 1);
    return t;
  }
}
function $c(e, t) {
  for (var r = [], a = e.parentElement; a;) t ? a.matches(t) && r.push(a) : r.push(a), a = a.parentElement;
  return r;
}
function qc(e, t) {
  t && e.addEventListener("transitionend", function r(a) {
    a.target === e && (t.call(e, a), e.removeEventListener("transitionend", r));
  });
}
function Jc(e, t, r) {
  var a = Ac();
  return r ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(a.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(a.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
function Xc(e) {
  return (Array.isArray(e) ? e : [e]).filter(function (e) {
    return !!e;
  });
}
function Zc() {
  return jc || (jc = function () {
    var e = Ac(),
      t = Cc();
    return {
      smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
      touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
    };
  }()), jc;
}
function Qc(e) {
  return void 0 === e && (e = {}), Ec || (Ec = function (e) {
    var t = (void 0 === e ? {} : e).userAgent,
      r = Zc(),
      a = Ac(),
      n = a.navigator.platform,
      o = t || a.navigator.userAgent,
      i = {
        ios: !1,
        android: !1
      },
      l = a.screen.width,
      s = a.screen.height,
      c = o.match(/(Android);?[\s\/]+([\d.]+)?/),
      u = o.match(/(iPad).*OS\s([\d_]+)/),
      d = o.match(/(iPod)(.*OS\s([\d_]+))?/),
      p = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      m = "Win32" === n,
      f = "MacIntel" === n;
    return !u && f && r.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf("".concat(l, "x").concat(s)) >= 0 && ((u = o.match(/(Version)\/([\d.]+)/)) || (u = [0, 1, "13_0_0"]), f = !1), c && !m && (i.os = "android", i.android = !0), (u || p || d) && (i.os = "ios", i.ios = !0), i;
  }(e)), Ec;
}
function eu() {
  return Tc || (Tc = function () {
    var e = Ac(),
      t = Qc(),
      r = !1;
    function a() {
      var t = e.navigator.userAgent.toLowerCase();
      return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    if (a()) {
      var n = String(e.navigator.userAgent);
      if (n.includes("Version/")) {
        var o = Le(n.split("Version/")[1].split(" ")[0].split(".").map(function (e) {
            return Number(e);
          }), 2),
          i = o[0],
          l = o[1];
        r = i < 16 || 16 === i && l < 2;
      }
    }
    var s = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
      c = a();
    return {
      isSafari: r || c,
      needPerspectiveFix: r,
      need3dFix: c || s && t.ios,
      isWebView: s
    };
  }()), Tc;
}
var tu = {
  on: function on(e, t, r) {
    var a = this;
    if (!a.eventsListeners || a.destroyed) return a;
    if ("function" != typeof t) return a;
    var n = r ? "unshift" : "push";
    return e.split(" ").forEach(function (e) {
      a.eventsListeners[e] || (a.eventsListeners[e] = []), a.eventsListeners[e][n](t);
    }), a;
  },
  once: function once(e, t, r) {
    var a = this;
    if (!a.eventsListeners || a.destroyed) return a;
    if ("function" != typeof t) return a;
    function n() {
      a.off(e, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
      t.apply(a, o);
    }
    return n.__emitterProxy = t, a.on(e, n, r);
  },
  onAny: function onAny(e, t) {
    var r = this;
    if (!r.eventsListeners || r.destroyed) return r;
    if ("function" != typeof e) return r;
    var a = t ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(e) < 0 && r.eventsAnyListeners[a](e), r;
  },
  offAny: function offAny(e) {
    var t = this;
    if (!t.eventsListeners || t.destroyed) return t;
    if (!t.eventsAnyListeners) return t;
    var r = t.eventsAnyListeners.indexOf(e);
    return r >= 0 && t.eventsAnyListeners.splice(r, 1), t;
  },
  off: function off(e, t) {
    var r = this;
    return !r.eventsListeners || r.destroyed ? r : r.eventsListeners ? (e.split(" ").forEach(function (e) {
      void 0 === t ? r.eventsListeners[e] = [] : r.eventsListeners[e] && r.eventsListeners[e].forEach(function (a, n) {
        (a === t || a.__emitterProxy && a.__emitterProxy === t) && r.eventsListeners[e].splice(n, 1);
      });
    }), r) : r;
  },
  emit: function emit() {
    var e,
      t,
      r,
      a = this;
    if (!a.eventsListeners || a.destroyed) return a;
    if (!a.eventsListeners) return a;
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) o[i] = arguments[i];
    "string" == typeof o[0] || Array.isArray(o[0]) ? (e = o[0], t = o.slice(1, o.length), r = a) : (e = o[0].events, t = o[0].data, r = o[0].context || a), t.unshift(r);
    var l = Array.isArray(e) ? e : e.split(" ");
    return l.forEach(function (e) {
      a.eventsAnyListeners && a.eventsAnyListeners.length && a.eventsAnyListeners.forEach(function (a) {
        a.apply(r, [e].concat(Ce(t)));
      }), a.eventsListeners && a.eventsListeners[e] && a.eventsListeners[e].forEach(function (e) {
        e.apply(r, t);
      });
    }), a;
  }
};
var ru = function ru(e, t) {
    if (e && !e.destroyed && e.params) {
      var r = t.closest(e.isElement ? "swiper-slide" : ".".concat(e.params.slideClass));
      if (r) {
        var a = r.querySelector(".".concat(e.params.lazyPreloaderClass));
        !a && e.isElement && (r.shadowRoot ? a = r.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass)) : requestAnimationFrame(function () {
          r.shadowRoot && (a = r.shadowRoot.querySelector(".".concat(e.params.lazyPreloaderClass))) && a.remove();
        })), a && a.remove();
      }
    }
  },
  au = function au(e, t) {
    if (e.slides[t]) {
      var r = e.slides[t].querySelector('[loading="lazy"]');
      r && r.removeAttribute("loading");
    }
  },
  nu = function nu(e) {
    if (e && !e.destroyed && e.params) {
      var t = e.params.lazyPreloadPrevNext,
        r = e.slides.length;
      if (r && t && !(t < 0)) {
        t = Math.min(t, r);
        var a = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
          n = e.activeIndex;
        if (e.params.grid && e.params.grid.rows > 1) {
          var o = n,
            i = [o - t];
          return i.push.apply(i, Ce(Array.from({
            length: t
          }).map(function (e, t) {
            return o + a + t;
          }))), void e.slides.forEach(function (t, r) {
            i.includes(t.column) && au(e, r);
          });
        }
        var l = n + a - 1;
        if (e.params.rewind || e.params.loop) for (var s = n - t; s <= l + t; s += 1) {
          var c = (s % r + r) % r;
          (c < n || c > l) && au(e, c);
        } else for (var u = Math.max(n - t, 0); u <= Math.min(l + t, r - 1); u += 1) u !== n && (u > l || u < n) && au(e, u);
      }
    }
  };
var ou = {
  updateSize: function updateSize() {
    var e,
      t,
      r = this,
      a = r.el;
    e = void 0 !== r.params.width && null !== r.params.width ? r.params.width : a.clientWidth, t = void 0 !== r.params.height && null !== r.params.height ? r.params.height : a.clientHeight, 0 === e && r.isHorizontal() || 0 === t && r.isVertical() || (e = e - parseInt(Kc(a, "padding-left") || 0, 10) - parseInt(Kc(a, "padding-right") || 0, 10), t = t - parseInt(Kc(a, "padding-top") || 0, 10) - parseInt(Kc(a, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(r, {
      width: e,
      height: t,
      size: r.isHorizontal() ? e : t
    }));
  },
  updateSlides: function updateSlides() {
    var e = this;
    function t(t, r) {
      return parseFloat(t.getPropertyValue(e.getDirectionLabel(r)) || 0);
    }
    var r = e.params,
      a = e.wrapperEl,
      n = e.slidesEl,
      o = e.size,
      i = e.rtlTranslate,
      l = e.wrongRTL,
      s = e.virtual && r.virtual.enabled,
      c = s ? e.virtual.slides.length : e.slides.length,
      u = Hc(n, ".".concat(e.params.slideClass, ", swiper-slide")),
      d = s ? e.virtual.slides.length : u.length,
      p = [],
      m = [],
      f = [],
      v = r.slidesOffsetBefore;
    "function" == typeof v && (v = r.slidesOffsetBefore.call(e));
    var y = r.slidesOffsetAfter;
    "function" == typeof y && (y = r.slidesOffsetAfter.call(e));
    var g = e.snapGrid.length,
      h = e.slidesGrid.length,
      b = r.spaceBetween,
      N = -v,
      x = 0,
      k = 0;
    if (void 0 !== o) {
      "string" == typeof b && b.indexOf("%") >= 0 ? b = parseFloat(b.replace("%", "")) / 100 * o : "string" == typeof b && (b = parseFloat(b)), e.virtualSize = -b, u.forEach(function (e) {
        i ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
      }), r.centeredSlides && r.cssMode && (Rc(a, "--swiper-centered-offset-before", ""), Rc(a, "--swiper-centered-offset-after", ""));
      var w,
        _ = r.grid && r.grid.rows > 1 && e.grid;
      _ ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
      for (var F = "auto" === r.slidesPerView && r.breakpoints && Object.keys(r.breakpoints).filter(function (e) {
          return void 0 !== r.breakpoints[e].slidesPerView;
        }).length > 0, S = 0; S < d; S += 1) {
        w = 0;
        var C = void 0;
        if (u[S] && (C = u[S]), _ && e.grid.updateSlide(S, C, u), !u[S] || "none" !== Kc(C, "display")) {
          if ("auto" === r.slidesPerView) {
            F && (u[S].style[e.getDirectionLabel("width")] = "");
            var j = getComputedStyle(C),
              E = C.style.transform,
              T = C.style.webkitTransform;
            if (E && (C.style.transform = "none"), T && (C.style.webkitTransform = "none"), r.roundLengths) w = e.isHorizontal() ? Jc(C, "width", !0) : Jc(C, "height", !0);else {
              var O = t(j, "width"),
                A = t(j, "padding-left"),
                M = t(j, "padding-right"),
                L = t(j, "margin-left"),
                D = t(j, "margin-right"),
                B = j.getPropertyValue("box-sizing");
              if (B && "border-box" === B) w = O + L + D;else {
                var P = C,
                  I = P.clientWidth;
                w = O + A + M + L + D + (P.offsetWidth - I);
              }
            }
            E && (C.style.transform = E), T && (C.style.webkitTransform = T), r.roundLengths && (w = Math.floor(w));
          } else w = (o - (r.slidesPerView - 1) * b) / r.slidesPerView, r.roundLengths && (w = Math.floor(w)), u[S] && (u[S].style[e.getDirectionLabel("width")] = "".concat(w, "px"));
          u[S] && (u[S].swiperSlideSize = w), f.push(w), r.centeredSlides ? (N = N + w / 2 + x / 2 + b, 0 === x && 0 !== S && (N = N - o / 2 - b), 0 === S && (N = N - o / 2 - b), Math.abs(N) < .001 && (N = 0), r.roundLengths && (N = Math.floor(N)), k % r.slidesPerGroup == 0 && p.push(N), m.push(N)) : (r.roundLengths && (N = Math.floor(N)), (k - Math.min(e.params.slidesPerGroupSkip, k)) % e.params.slidesPerGroup == 0 && p.push(N), m.push(N), N = N + w + b), e.virtualSize += w + b, x = w, k += 1;
        }
      }
      if (e.virtualSize = Math.max(e.virtualSize, o) + y, i && l && ("slide" === r.effect || "coverflow" === r.effect) && (a.style.width = "".concat(e.virtualSize + b, "px")), r.setWrapperSize && (a.style[e.getDirectionLabel("width")] = "".concat(e.virtualSize + b, "px")), _ && e.grid.updateWrapperSize(w, p), !r.centeredSlides) {
        for (var z = [], R = 0; R < p.length; R += 1) {
          var U = p[R];
          r.roundLengths && (U = Math.floor(U)), p[R] <= e.virtualSize - o && z.push(U);
        }
        p = z, Math.floor(e.virtualSize - o) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - o);
      }
      if (s && r.loop) {
        var H = f[0] + b;
        if (r.slidesPerGroup > 1) for (var G = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / r.slidesPerGroup), V = H * r.slidesPerGroup, W = 0; W < G; W += 1) p.push(p[p.length - 1] + V);
        for (var K = 0; K < e.virtual.slidesBefore + e.virtual.slidesAfter; K += 1) 1 === r.slidesPerGroup && p.push(p[p.length - 1] + H), m.push(m[m.length - 1] + H), e.virtualSize += H;
      }
      if (0 === p.length && (p = [0]), 0 !== b) {
        var Y = e.isHorizontal() && i ? "marginLeft" : e.getDirectionLabel("marginRight");
        u.filter(function (e, t) {
          return !(r.cssMode && !r.loop) || t !== u.length - 1;
        }).forEach(function (e) {
          e.style[Y] = "".concat(b, "px");
        });
      }
      if (r.centeredSlides && r.centeredSlidesBounds) {
        var $ = 0;
        f.forEach(function (e) {
          $ += e + (b || 0);
        });
        var q = ($ -= b) - o;
        p = p.map(function (e) {
          return e <= 0 ? -v : e > q ? q + y : e;
        });
      }
      if (r.centerInsufficientSlides) {
        var J = 0;
        if (f.forEach(function (e) {
          J += e + (b || 0);
        }), (J -= b) < o) {
          var X = (o - J) / 2;
          p.forEach(function (e, t) {
            p[t] = e - X;
          }), m.forEach(function (e, t) {
            m[t] = e + X;
          });
        }
      }
      if (Object.assign(e, {
        slides: u,
        snapGrid: p,
        slidesGrid: m,
        slidesSizesGrid: f
      }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
        Rc(a, "--swiper-centered-offset-before", "".concat(-p[0], "px")), Rc(a, "--swiper-centered-offset-after", "".concat(e.size / 2 - f[f.length - 1] / 2, "px"));
        var Z = -e.snapGrid[0],
          Q = -e.slidesGrid[0];
        e.snapGrid = e.snapGrid.map(function (e) {
          return e + Z;
        }), e.slidesGrid = e.slidesGrid.map(function (e) {
          return e + Q;
        });
      }
      if (d !== c && e.emit("slidesLengthChange"), p.length !== g && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), m.length !== h && e.emit("slidesGridLengthChange"), r.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !(s || r.cssMode || "slide" !== r.effect && "fade" !== r.effect)) {
        var ee = "".concat(r.containerModifierClass, "backface-hidden"),
          te = e.el.classList.contains(ee);
        d <= r.maxBackfaceHiddenSlides ? te || e.el.classList.add(ee) : te && e.el.classList.remove(ee);
      }
    }
  },
  updateAutoHeight: function updateAutoHeight(e) {
    var t,
      r = this,
      a = [],
      n = r.virtual && r.params.virtual.enabled,
      o = 0;
    "number" == typeof e ? r.setTransition(e) : !0 === e && r.setTransition(r.params.speed);
    var i = function i(e) {
      return n ? r.slides[r.getSlideIndexByData(e)] : r.slides[e];
    };
    if ("auto" !== r.params.slidesPerView && r.params.slidesPerView > 1) {
      if (r.params.centeredSlides) (r.visibleSlides || []).forEach(function (e) {
        a.push(e);
      });else for (t = 0; t < Math.ceil(r.params.slidesPerView); t += 1) {
        var l = r.activeIndex + t;
        if (l > r.slides.length && !n) break;
        a.push(i(l));
      }
    } else a.push(i(r.activeIndex));
    for (t = 0; t < a.length; t += 1) if (void 0 !== a[t]) {
      var s = a[t].offsetHeight;
      o = s > o ? s : o;
    }
    (o || 0 === o) && (r.wrapperEl.style.height = "".concat(o, "px"));
  },
  updateSlidesOffset: function updateSlidesOffset() {
    for (var e = this, t = e.slides, r = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0, a = 0; a < t.length; a += 1) t[a].swiperSlideOffset = (e.isHorizontal() ? t[a].offsetLeft : t[a].offsetTop) - r - e.cssOverflowAdjustment();
  },
  updateSlidesProgress: function updateSlidesProgress(e) {
    void 0 === e && (e = this && this.translate || 0);
    var t = this,
      r = t.params,
      a = t.slides,
      n = t.rtlTranslate,
      o = t.snapGrid;
    if (0 !== a.length) {
      void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset();
      var i = -e;
      n && (i = e), a.forEach(function (e) {
        e.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass);
      }), t.visibleSlidesIndexes = [], t.visibleSlides = [];
      var l = r.spaceBetween;
      "string" == typeof l && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * t.size : "string" == typeof l && (l = parseFloat(l));
      for (var s = 0; s < a.length; s += 1) {
        var c = a[s],
          u = c.swiperSlideOffset;
        r.cssMode && r.centeredSlides && (u -= a[0].swiperSlideOffset);
        var d = (i + (r.centeredSlides ? t.minTranslate() : 0) - u) / (c.swiperSlideSize + l),
          p = (i - o[0] + (r.centeredSlides ? t.minTranslate() : 0) - u) / (c.swiperSlideSize + l),
          m = -(i - u),
          f = m + t.slidesSizesGrid[s],
          v = m >= 0 && m <= t.size - t.slidesSizesGrid[s];
        (m >= 0 && m < t.size - 1 || f > 1 && f <= t.size || m <= 0 && f >= t.size) && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(s), a[s].classList.add(r.slideVisibleClass)), v && a[s].classList.add(r.slideFullyVisibleClass), c.progress = n ? -d : d, c.originalProgress = n ? -p : p;
      }
    }
  },
  updateProgress: function updateProgress(e) {
    var t = this;
    if (void 0 === e) {
      var r = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * r || 0;
    }
    var a = t.params,
      n = t.maxTranslate() - t.minTranslate(),
      o = t.progress,
      i = t.isBeginning,
      l = t.isEnd,
      s = t.progressLoop,
      c = i,
      u = l;
    if (0 === n) o = 0, i = !0, l = !0;else {
      o = (e - t.minTranslate()) / n;
      var d = Math.abs(e - t.minTranslate()) < 1,
        p = Math.abs(e - t.maxTranslate()) < 1;
      i = d || o <= 0, l = p || o >= 1, d && (o = 0), p && (o = 1);
    }
    if (a.loop) {
      var m = t.getSlideIndexByData(0),
        f = t.getSlideIndexByData(t.slides.length - 1),
        v = t.slidesGrid[m],
        y = t.slidesGrid[f],
        g = t.slidesGrid[t.slidesGrid.length - 1],
        h = Math.abs(e);
      (s = h >= v ? (h - v) / g : (h + g - y) / g) > 1 && (s -= 1);
    }
    Object.assign(t, {
      progress: o,
      progressLoop: s,
      isBeginning: i,
      isEnd: l
    }), (a.watchSlidesProgress || a.centeredSlides && a.autoHeight) && t.updateSlidesProgress(e), i && !c && t.emit("reachBeginning toEdge"), l && !u && t.emit("reachEnd toEdge"), (c && !i || u && !l) && t.emit("fromEdge"), t.emit("progress", o);
  },
  updateSlidesClasses: function updateSlidesClasses() {
    var e,
      t,
      r,
      a = this,
      n = a.slides,
      o = a.params,
      i = a.slidesEl,
      l = a.activeIndex,
      s = a.virtual && o.virtual.enabled,
      c = a.grid && o.grid && o.grid.rows > 1,
      u = function u(e) {
        return Hc(i, ".".concat(o.slideClass).concat(e, ", swiper-slide").concat(e))[0];
      };
    if (n.forEach(function (e) {
      e.classList.remove(o.slideActiveClass, o.slideNextClass, o.slidePrevClass);
    }), s) {
      if (o.loop) {
        var d = l - a.virtual.slidesBefore;
        d < 0 && (d = a.virtual.slides.length + d), d >= a.virtual.slides.length && (d -= a.virtual.slides.length), e = u('[data-swiper-slide-index="'.concat(d, '"]'));
      } else e = u('[data-swiper-slide-index="'.concat(l, '"]'));
    } else c ? (e = n.filter(function (e) {
      return e.column === l;
    })[0], r = n.filter(function (e) {
      return e.column === l + 1;
    })[0], t = n.filter(function (e) {
      return e.column === l - 1;
    })[0]) : e = n[l];
    e && (e.classList.add(o.slideActiveClass), c ? (r && r.classList.add(o.slideNextClass), t && t.classList.add(o.slidePrevClass)) : (r = function (e, t) {
      for (var r = []; e.nextElementSibling;) {
        var a = e.nextElementSibling;
        t ? a.matches(t) && r.push(a) : r.push(a), e = a;
      }
      return r;
    }(e, ".".concat(o.slideClass, ", swiper-slide"))[0], o.loop && !r && (r = n[0]), r && r.classList.add(o.slideNextClass), t = function (e, t) {
      for (var r = []; e.previousElementSibling;) {
        var a = e.previousElementSibling;
        t ? a.matches(t) && r.push(a) : r.push(a), e = a;
      }
      return r;
    }(e, ".".concat(o.slideClass, ", swiper-slide"))[0], o.loop && 0 === !t && (t = n[n.length - 1]), t && t.classList.add(o.slidePrevClass))), a.emitSlidesClasses();
  },
  updateActiveIndex: function updateActiveIndex(e) {
    var t,
      r = this,
      a = r.rtlTranslate ? r.translate : -r.translate,
      n = r.snapGrid,
      o = r.params,
      i = r.activeIndex,
      l = r.realIndex,
      s = r.snapIndex,
      c = e,
      u = function u(e) {
        var t = e - r.virtual.slidesBefore;
        return t < 0 && (t = r.virtual.slides.length + t), t >= r.virtual.slides.length && (t -= r.virtual.slides.length), t;
      };
    if (void 0 === c && (c = function (e) {
      for (var t, r = e.slidesGrid, a = e.params, n = e.rtlTranslate ? e.translate : -e.translate, o = 0; o < r.length; o += 1) void 0 !== r[o + 1] ? n >= r[o] && n < r[o + 1] - (r[o + 1] - r[o]) / 2 ? t = o : n >= r[o] && n < r[o + 1] && (t = o + 1) : n >= r[o] && (t = o);
      return a.normalizeSlideIndex && (t < 0 || void 0 === t) && (t = 0), t;
    }(r)), n.indexOf(a) >= 0) t = n.indexOf(a);else {
      var d = Math.min(o.slidesPerGroupSkip, c);
      t = d + Math.floor((c - d) / o.slidesPerGroup);
    }
    if (t >= n.length && (t = n.length - 1), c !== i || r.params.loop) {
      if (c === i && r.params.loop && r.virtual && r.params.virtual.enabled) r.realIndex = u(c);else {
        var p,
          m = r.grid && o.grid && o.grid.rows > 1;
        if (r.virtual && o.virtual.enabled && o.loop) p = u(c);else if (m) {
          var f = r.slides.filter(function (e) {
              return e.column === c;
            })[0],
            v = parseInt(f.getAttribute("data-swiper-slide-index"), 10);
          Number.isNaN(v) && (v = Math.max(r.slides.indexOf(f), 0)), p = Math.floor(v / o.grid.rows);
        } else if (r.slides[c]) {
          var y = r.slides[c].getAttribute("data-swiper-slide-index");
          p = y ? parseInt(y, 10) : c;
        } else p = c;
        Object.assign(r, {
          previousSnapIndex: s,
          snapIndex: t,
          previousRealIndex: l,
          realIndex: p,
          previousIndex: i,
          activeIndex: c
        }), r.initialized && nu(r), r.emit("activeIndexChange"), r.emit("snapIndexChange"), (r.initialized || r.params.runCallbacksOnInit) && (l !== p && r.emit("realIndexChange"), r.emit("slideChange"));
      }
    } else t !== s && (r.snapIndex = t, r.emit("snapIndexChange"));
  },
  updateClickedSlide: function updateClickedSlide(e, t) {
    var r = this,
      a = r.params,
      n = e.closest(".".concat(a.slideClass, ", swiper-slide"));
    !n && r.isElement && t && t.length > 1 && t.includes(e) && Ce(t.slice(t.indexOf(e) + 1, t.length)).forEach(function (e) {
      !n && e.matches && e.matches(".".concat(a.slideClass, ", swiper-slide")) && (n = e);
    });
    var o,
      i = !1;
    if (n) for (var l = 0; l < r.slides.length; l += 1) if (r.slides[l] === n) {
      i = !0, o = l;
      break;
    }
    if (!n || !i) return r.clickedSlide = void 0, void (r.clickedIndex = void 0);
    r.clickedSlide = n, r.virtual && r.params.virtual.enabled ? r.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : r.clickedIndex = o, a.slideToClickedSlide && void 0 !== r.clickedIndex && r.clickedIndex !== r.activeIndex && r.slideToClickedSlide();
  }
};
var iu = {
  getTranslate: function getTranslate(e) {
    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
    var t = this,
      r = t.params,
      a = t.rtlTranslate,
      n = t.translate,
      o = t.wrapperEl;
    if (r.virtualTranslate) return a ? -n : n;
    if (r.cssMode) return n;
    var i = Bc(o, e);
    return i += t.cssOverflowAdjustment(), a && (i = -i), i || 0;
  },
  setTranslate: function setTranslate(e, t) {
    var r = this,
      a = r.rtlTranslate,
      n = r.params,
      o = r.wrapperEl,
      i = r.progress,
      l = 0,
      s = 0;
    r.isHorizontal() ? l = a ? -e : e : s = e, n.roundLengths && (l = Math.floor(l), s = Math.floor(s)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? l : s, n.cssMode ? o[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -s : n.virtualTranslate || (r.isHorizontal() ? l -= r.cssOverflowAdjustment() : s -= r.cssOverflowAdjustment(), o.style.transform = "translate3d(".concat(l, "px, ").concat(s, "px, ").concat(0, "px)"));
    var c = r.maxTranslate() - r.minTranslate();
    (0 === c ? 0 : (e - r.minTranslate()) / c) !== i && r.updateProgress(e), r.emit("setTranslate", r.translate, t);
  },
  minTranslate: function minTranslate() {
    return -this.snapGrid[0];
  },
  maxTranslate: function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  },
  translateTo: function translateTo(e, t, r, a, n) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === r && (r = !0), void 0 === a && (a = !0);
    var o = this,
      i = o.params,
      l = o.wrapperEl;
    if (o.animating && i.preventInteractionOnTransition) return !1;
    var s,
      c = o.minTranslate(),
      u = o.maxTranslate();
    if (s = a && e > c ? c : a && e < u ? u : e, o.updateProgress(s), i.cssMode) {
      var d = o.isHorizontal();
      if (0 === t) l[d ? "scrollLeft" : "scrollTop"] = -s;else {
        var p;
        if (!o.support.smoothScroll) return Uc({
          swiper: o,
          targetPosition: -s,
          side: d ? "left" : "top"
        }), !0;
        l.scrollTo((Oe(p = {}, d ? "left" : "top", -s), Oe(p, "behavior", "smooth"), p));
      }
      return !0;
    }
    return 0 === t ? (o.setTransition(0), o.setTranslate(s), r && (o.emit("beforeTransitionStart", t, n), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(s), r && (o.emit("beforeTransitionStart", t, n), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function (e) {
      o && !o.destroyed && e.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, r && o.emit("transitionEnd"));
    }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
  }
};
function lu(e) {
  var t = e.swiper,
    r = e.runCallbacks,
    a = e.direction,
    n = e.step,
    o = t.activeIndex,
    i = t.previousIndex,
    l = a;
  if (l || (l = o > i ? "next" : o < i ? "prev" : "reset"), t.emit("transition".concat(n)), r && o !== i) {
    if ("reset" === l) return void t.emit("slideResetTransition".concat(n));
    t.emit("slideChangeTransition".concat(n)), "next" === l ? t.emit("slideNextTransition".concat(n)) : t.emit("slidePrevTransition".concat(n));
  }
}
var su = {
  setTransition: function setTransition(e, t) {
    var r = this;
    r.params.cssMode || (r.wrapperEl.style.transitionDuration = "".concat(e, "ms"), r.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), r.emit("setTransition", e, t);
  },
  transitionStart: function transitionStart(e, t) {
    void 0 === e && (e = !0);
    var r = this,
      a = r.params;
    a.cssMode || (a.autoHeight && r.updateAutoHeight(), lu({
      swiper: r,
      runCallbacks: e,
      direction: t,
      step: "Start"
    }));
  },
  transitionEnd: function transitionEnd(e, t) {
    void 0 === e && (e = !0);
    var r = this,
      a = r.params;
    r.animating = !1, a.cssMode || (r.setTransition(0), lu({
      swiper: r,
      runCallbacks: e,
      direction: t,
      step: "End"
    }));
  }
};
var cu = {
  slideTo: function slideTo(e, t, r, a, n) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === r && (r = !0), "string" == typeof e && (e = parseInt(e, 10));
    var o = this,
      i = e;
    i < 0 && (i = 0);
    var l = o.params,
      s = o.snapGrid,
      c = o.slidesGrid,
      u = o.previousIndex,
      d = o.activeIndex,
      p = o.rtlTranslate,
      m = o.wrapperEl,
      f = o.enabled;
    if (o.animating && l.preventInteractionOnTransition || !f && !a && !n || o.destroyed) return !1;
    var v = Math.min(o.params.slidesPerGroupSkip, i),
      y = v + Math.floor((i - v) / o.params.slidesPerGroup);
    y >= s.length && (y = s.length - 1);
    var g,
      h = -s[y];
    if (l.normalizeSlideIndex) for (var b = 0; b < c.length; b += 1) {
      var N = -Math.floor(100 * h),
        x = Math.floor(100 * c[b]),
        k = Math.floor(100 * c[b + 1]);
      void 0 !== c[b + 1] ? N >= x && N < k - (k - x) / 2 ? i = b : N >= x && N < k && (i = b + 1) : N >= x && (i = b);
    }
    if (o.initialized && i !== d) {
      if (!o.allowSlideNext && (p ? h > o.translate && h > o.minTranslate() : h < o.translate && h < o.minTranslate())) return !1;
      if (!o.allowSlidePrev && h > o.translate && h > o.maxTranslate() && (d || 0) !== i) return !1;
    }
    if (i !== (u || 0) && r && o.emit("beforeSlideChangeStart"), o.updateProgress(h), g = i > d ? "next" : i < d ? "prev" : "reset", p && -h === o.translate || !p && h === o.translate) return o.updateActiveIndex(i), l.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== l.effect && o.setTranslate(h), "reset" !== g && (o.transitionStart(r, g), o.transitionEnd(r, g)), !1;
    if (l.cssMode) {
      var w = o.isHorizontal(),
        _ = p ? h : -h;
      if (0 === t) {
        var F = o.virtual && o.params.virtual.enabled;
        F && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), F && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(function () {
          m[w ? "scrollLeft" : "scrollTop"] = _;
        })) : m[w ? "scrollLeft" : "scrollTop"] = _, F && requestAnimationFrame(function () {
          o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
        });
      } else {
        var S;
        if (!o.support.smoothScroll) return Uc({
          swiper: o,
          targetPosition: _,
          side: w ? "left" : "top"
        }), !0;
        m.scrollTo((Oe(S = {}, w ? "left" : "top", _), Oe(S, "behavior", "smooth"), S));
      }
      return !0;
    }
    return o.setTransition(t), o.setTranslate(h), o.updateActiveIndex(i), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, a), o.transitionStart(r, g), 0 === t ? o.transitionEnd(r, g) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function (e) {
      o && !o.destroyed && e.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(r, g));
    }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
  },
  slideToLoop: function slideToLoop(e, t, r, a) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === r && (r = !0), "string" == typeof e && (e = parseInt(e, 10));
    var n = this;
    if (!n.destroyed) {
      var o = n.grid && n.params.grid && n.params.grid.rows > 1,
        i = e;
      if (n.params.loop) if (n.virtual && n.params.virtual.enabled) i += n.virtual.slidesBefore;else {
        var l;
        if (o) {
          var s = i * n.params.grid.rows;
          l = n.slides.filter(function (e) {
            return 1 * e.getAttribute("data-swiper-slide-index") === s;
          })[0].column;
        } else l = n.getSlideIndexByData(i);
        var c = o ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length,
          u = n.params.centeredSlides,
          d = n.params.slidesPerView;
        "auto" === d ? d = n.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(n.params.slidesPerView, 10)), u && d % 2 == 0 && (d += 1));
        var p = c - l < d;
        if (u && (p = p || l < Math.ceil(d / 2)), p) {
          var m = u ? l < n.activeIndex ? "prev" : "next" : l - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
          n.loopFix({
            direction: m,
            slideTo: !0,
            activeSlideIndex: "next" === m ? l + 1 : l - c + 1,
            slideRealIndex: "next" === m ? n.realIndex : void 0
          });
        }
        if (o) {
          var f = i * n.params.grid.rows;
          i = n.slides.filter(function (e) {
            return 1 * e.getAttribute("data-swiper-slide-index") === f;
          })[0].column;
        } else i = n.getSlideIndexByData(i);
      }
      return requestAnimationFrame(function () {
        n.slideTo(i, t, r, a);
      }), n;
    }
  },
  slideNext: function slideNext(e, t, r) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
    var a = this,
      n = a.enabled,
      o = a.params,
      i = a.animating;
    if (!n || a.destroyed) return a;
    var l = o.slidesPerGroup;
    "auto" === o.slidesPerView && 1 === o.slidesPerGroup && o.slidesPerGroupAuto && (l = Math.max(a.slidesPerViewDynamic("current", !0), 1));
    var s = a.activeIndex < o.slidesPerGroupSkip ? 1 : l,
      c = a.virtual && o.virtual.enabled;
    if (o.loop) {
      if (i && !c && o.loopPreventsSliding) return !1;
      if (a.loopFix({
        direction: "next"
      }), a._clientLeft = a.wrapperEl.clientLeft, a.activeIndex === a.slides.length - 1 && o.cssMode) return requestAnimationFrame(function () {
        a.slideTo(a.activeIndex + s, e, t, r);
      }), !0;
    }
    return o.rewind && a.isEnd ? a.slideTo(0, e, t, r) : a.slideTo(a.activeIndex + s, e, t, r);
  },
  slidePrev: function slidePrev(e, t, r) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
    var a = this,
      n = a.params,
      o = a.snapGrid,
      i = a.slidesGrid,
      l = a.rtlTranslate,
      s = a.enabled,
      c = a.animating;
    if (!s || a.destroyed) return a;
    var u = a.virtual && n.virtual.enabled;
    if (n.loop) {
      if (c && !u && n.loopPreventsSliding) return !1;
      a.loopFix({
        direction: "prev"
      }), a._clientLeft = a.wrapperEl.clientLeft;
    }
    function d(e) {
      return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    var p,
      m = d(l ? a.translate : -a.translate),
      f = o.map(function (e) {
        return d(e);
      }),
      v = o[f.indexOf(m) - 1];
    void 0 === v && n.cssMode && (o.forEach(function (e, t) {
      m >= e && (p = t);
    }), void 0 !== p && (v = o[p > 0 ? p - 1 : p]));
    var y = 0;
    if (void 0 !== v && ((y = i.indexOf(v)) < 0 && (y = a.activeIndex - 1), "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (y = y - a.slidesPerViewDynamic("previous", !0) + 1, y = Math.max(y, 0))), n.rewind && a.isBeginning) {
      var g = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
      return a.slideTo(g, e, t, r);
    }
    return n.loop && 0 === a.activeIndex && n.cssMode ? (requestAnimationFrame(function () {
      a.slideTo(y, e, t, r);
    }), !0) : a.slideTo(y, e, t, r);
  },
  slideReset: function slideReset(e, t, r) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
    var a = this;
    if (!a.destroyed) return a.slideTo(a.activeIndex, e, t, r);
  },
  slideToClosest: function slideToClosest(e, t, r, a) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === a && (a = .5);
    var n = this;
    if (!n.destroyed) {
      var o = n.activeIndex,
        i = Math.min(n.params.slidesPerGroupSkip, o),
        l = i + Math.floor((o - i) / n.params.slidesPerGroup),
        s = n.rtlTranslate ? n.translate : -n.translate;
      if (s >= n.snapGrid[l]) {
        var c = n.snapGrid[l];
        s - c > (n.snapGrid[l + 1] - c) * a && (o += n.params.slidesPerGroup);
      } else {
        var u = n.snapGrid[l - 1];
        s - u <= (n.snapGrid[l] - u) * a && (o -= n.params.slidesPerGroup);
      }
      return o = Math.max(o, 0), o = Math.min(o, n.slidesGrid.length - 1), n.slideTo(o, e, t, r);
    }
  },
  slideToClickedSlide: function slideToClickedSlide() {
    var e = this;
    if (!e.destroyed) {
      var t,
        r = e.params,
        a = e.slidesEl,
        n = "auto" === r.slidesPerView ? e.slidesPerViewDynamic() : r.slidesPerView,
        o = e.clickedIndex,
        i = e.isElement ? "swiper-slide" : ".".concat(r.slideClass);
      if (r.loop) {
        if (e.animating) return;
        t = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), r.centeredSlides ? o < e.loopedSlides - n / 2 || o > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(), o = e.getSlideIndex(Hc(a, "".concat(i, '[data-swiper-slide-index="').concat(t, '"]'))[0]), Lc(function () {
          e.slideTo(o);
        })) : e.slideTo(o) : o > e.slides.length - n ? (e.loopFix(), o = e.getSlideIndex(Hc(a, "".concat(i, '[data-swiper-slide-index="').concat(t, '"]'))[0]), Lc(function () {
          e.slideTo(o);
        })) : e.slideTo(o);
      } else e.slideTo(o);
    }
  }
};
var uu = {
  loopCreate: function loopCreate(e) {
    var t = this,
      r = t.params,
      a = t.slidesEl;
    if (!(!r.loop || t.virtual && t.params.virtual.enabled)) {
      var n = function n() {
          Hc(a, ".".concat(r.slideClass, ", swiper-slide")).forEach(function (e, t) {
            e.setAttribute("data-swiper-slide-index", t);
          });
        },
        o = t.grid && r.grid && r.grid.rows > 1,
        i = r.slidesPerGroup * (o ? r.grid.rows : 1),
        l = t.slides.length % i != 0,
        s = o && t.slides.length % r.grid.rows != 0,
        c = function c(e) {
          for (var a = 0; a < e; a += 1) {
            var n = t.isElement ? Vc("swiper-slide", [r.slideBlankClass]) : Vc("div", [r.slideClass, r.slideBlankClass]);
            t.slidesEl.append(n);
          }
        };
      if (l) {
        if (r.loopAddBlankSlides) c(i - t.slides.length % i), t.recalcSlides(), t.updateSlides();else Gc();
        n();
      } else if (s) {
        if (r.loopAddBlankSlides) c(r.grid.rows - t.slides.length % r.grid.rows), t.recalcSlides(), t.updateSlides();else Gc();
        n();
      } else n();
      t.loopFix({
        slideRealIndex: e,
        direction: r.centeredSlides ? void 0 : "next"
      });
    }
  },
  loopFix: function loopFix(e) {
    var t = void 0 === e ? {} : e,
      r = t.slideRealIndex,
      a = t.slideTo,
      n = void 0 === a || a,
      o = t.direction,
      i = t.setTranslate,
      l = t.activeSlideIndex,
      s = t.byController,
      c = t.byMousewheel,
      u = this;
    if (u.params.loop) {
      u.emit("beforeLoopFix");
      var d = u.slides,
        p = u.allowSlidePrev,
        m = u.allowSlideNext,
        f = u.slidesEl,
        v = u.params,
        y = v.centeredSlides;
      if (u.allowSlidePrev = !0, u.allowSlideNext = !0, u.virtual && v.virtual.enabled) return n && (v.centeredSlides || 0 !== u.snapIndex ? v.centeredSlides && u.snapIndex < v.slidesPerView ? u.slideTo(u.virtual.slides.length + u.snapIndex, 0, !1, !0) : u.snapIndex === u.snapGrid.length - 1 && u.slideTo(u.virtual.slidesBefore, 0, !1, !0) : u.slideTo(u.virtual.slides.length, 0, !1, !0)), u.allowSlidePrev = p, u.allowSlideNext = m, void u.emit("loopFix");
      var g = v.slidesPerView;
      "auto" === g ? g = u.slidesPerViewDynamic() : (g = Math.ceil(parseFloat(v.slidesPerView, 10)), y && g % 2 == 0 && (g += 1));
      var h = v.slidesPerGroupAuto ? g : v.slidesPerGroup,
        b = h;
      b % h != 0 && (b += h - b % h), b += v.loopAdditionalSlides, u.loopedSlides = b;
      var N = u.grid && v.grid && v.grid.rows > 1;
      (d.length < g + b || N && "row" === v.grid.fill) && Gc();
      var x = [],
        k = [],
        w = u.activeIndex;
      void 0 === l ? l = u.getSlideIndex(d.filter(function (e) {
        return e.classList.contains(v.slideActiveClass);
      })[0]) : w = l;
      var _ = "next" === o || !o,
        F = "prev" === o || !o,
        S = 0,
        C = 0,
        j = N ? Math.ceil(d.length / v.grid.rows) : d.length,
        E = (N ? d[l].column : l) + (y && void 0 === i ? -g / 2 + .5 : 0);
      if (E < b) {
        S = Math.max(b - E, h);
        for (var T = 0; T < b - E; T += 1) {
          var O = T - Math.floor(T / j) * j;
          if (N) for (var A = j - O - 1, M = d.length - 1; M >= 0; M -= 1) d[M].column === A && x.push(M);else x.push(j - O - 1);
        }
      } else if (E + g > j - b) {
        C = Math.max(E - (j - 2 * b), h);
        for (var L = function L() {
            var e = D - Math.floor(D / j) * j;
            N ? d.forEach(function (t, r) {
              t.column === e && k.push(r);
            }) : k.push(e);
          }, D = 0; D < C; D += 1) L();
      }
      if (u.__preventObserver__ = !0, requestAnimationFrame(function () {
        u.__preventObserver__ = !1;
      }), F && x.forEach(function (e) {
        d[e].swiperLoopMoveDOM = !0, f.prepend(d[e]), d[e].swiperLoopMoveDOM = !1;
      }), _ && k.forEach(function (e) {
        d[e].swiperLoopMoveDOM = !0, f.append(d[e]), d[e].swiperLoopMoveDOM = !1;
      }), u.recalcSlides(), "auto" === v.slidesPerView ? u.updateSlides() : N && (x.length > 0 && F || k.length > 0 && _) && u.slides.forEach(function (e, t) {
        u.grid.updateSlide(t, e, u.slides);
      }), v.watchSlidesProgress && u.updateSlidesOffset(), n) if (x.length > 0 && F) {
        if (void 0 === r) {
          var B = u.slidesGrid[w],
            P = u.slidesGrid[w + S] - B;
          c ? u.setTranslate(u.translate - P) : (u.slideTo(w + Math.ceil(S), 0, !1, !0), i && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - P, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - P));
        } else if (i) {
          var I = N ? x.length / v.grid.rows : x.length;
          u.slideTo(u.activeIndex + I, 0, !1, !0), u.touchEventsData.currentTranslate = u.translate;
        }
      } else if (k.length > 0 && _) if (void 0 === r) {
        var z = u.slidesGrid[w],
          R = u.slidesGrid[w - C] - z;
        c ? u.setTranslate(u.translate - R) : (u.slideTo(w - C, 0, !1, !0), i && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - R, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - R));
      } else {
        var U = N ? k.length / v.grid.rows : k.length;
        u.slideTo(u.activeIndex - U, 0, !1, !0);
      }
      if (u.allowSlidePrev = p, u.allowSlideNext = m, u.controller && u.controller.control && !s) {
        var H = {
          slideRealIndex: r,
          direction: o,
          setTranslate: i,
          activeSlideIndex: l,
          byController: !0
        };
        Array.isArray(u.controller.control) ? u.controller.control.forEach(function (e) {
          !e.destroyed && e.params.loop && e.loopFix(Te(Te({}, H), {}, {
            slideTo: e.params.slidesPerView === v.slidesPerView && n
          }));
        }) : u.controller.control instanceof u.constructor && u.controller.control.params.loop && u.controller.control.loopFix(Te(Te({}, H), {}, {
          slideTo: u.controller.control.params.slidesPerView === v.slidesPerView && n
        }));
      }
      u.emit("loopFix");
    }
  },
  loopDestroy: function loopDestroy() {
    var e = this,
      t = e.params,
      r = e.slidesEl;
    if (!(!t.loop || e.virtual && e.params.virtual.enabled)) {
      e.recalcSlides();
      var a = [];
      e.slides.forEach(function (e) {
        var t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
        a[t] = e;
      }), e.slides.forEach(function (e) {
        e.removeAttribute("data-swiper-slide-index");
      }), a.forEach(function (e) {
        r.append(e);
      }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
    }
  }
};
function du(e, t, r) {
  var a = Ac(),
    n = e.params,
    o = n.edgeSwipeDetection,
    i = n.edgeSwipeThreshold;
  return !o || !(r <= i || r >= a.innerWidth - i) || "prevent" === o && (t.preventDefault(), !0);
}
function pu(e) {
  var t = this,
    r = Cc(),
    a = e;
  a.originalEvent && (a = a.originalEvent);
  var n = t.touchEventsData;
  if ("pointerdown" === a.type) {
    if (null !== n.pointerId && n.pointerId !== a.pointerId) return;
    n.pointerId = a.pointerId;
  } else "touchstart" === a.type && 1 === a.targetTouches.length && (n.touchId = a.targetTouches[0].identifier);
  if ("touchstart" !== a.type) {
    var o = t.params,
      i = t.touches;
    if (t.enabled && (o.simulateTouch || "mouse" !== a.pointerType) && (!t.animating || !o.preventInteractionOnTransition)) {
      !t.animating && o.cssMode && o.loop && t.loopFix();
      var l = a.target;
      if (("wrapper" !== o.touchEventsTarget || t.wrapperEl.contains(l)) && !("which" in a && 3 === a.which || "button" in a && a.button > 0 || n.isTouched && n.isMoved)) {
        var s = !!o.noSwipingClass && "" !== o.noSwipingClass,
          c = a.composedPath ? a.composedPath() : a.path;
        s && a.target && a.target.shadowRoot && c && (l = c[0]);
        var u = o.noSwipingSelector ? o.noSwipingSelector : ".".concat(o.noSwipingClass),
          d = !(!a.target || !a.target.shadowRoot);
        if (o.noSwiping && (d ? function (e, t) {
          return void 0 === t && (t = this), function t(r) {
            if (!r || r === Cc() || r === Ac()) return null;
            r.assignedSlot && (r = r.assignedSlot);
            var a = r.closest(e);
            return a || r.getRootNode ? a || t(r.getRootNode().host) : null;
          }(t);
        }(u, l) : l.closest(u))) t.allowClick = !0;else if (!o.swipeHandler || l.closest(o.swipeHandler)) {
          i.currentX = a.pageX, i.currentY = a.pageY;
          var p = i.currentX,
            m = i.currentY;
          if (du(t, a, p)) {
            Object.assign(n, {
              isTouched: !0,
              isMoved: !1,
              allowTouchCallbacks: !0,
              isScrolling: void 0,
              startMoving: void 0
            }), i.startX = p, i.startY = m, n.touchStartTime = Dc(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (n.allowThresholdMove = !1);
            var f = !0;
            l.matches(n.focusableElements) && (f = !1, "SELECT" === l.nodeName && (n.isTouched = !1)), r.activeElement && r.activeElement.matches(n.focusableElements) && r.activeElement !== l && r.activeElement.blur();
            var v = f && t.allowTouchMove && o.touchStartPreventDefault;
            !o.touchStartForcePreventDefault && !v || l.isContentEditable || a.preventDefault(), o.freeMode && o.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", a);
          }
        }
      }
    }
  } else du(t, a, a.targetTouches[0].pageX);
}
function mu(e) {
  var t = Cc(),
    r = this,
    a = r.touchEventsData,
    n = r.params,
    o = r.touches,
    i = r.rtlTranslate;
  if (r.enabled && (n.simulateTouch || "mouse" !== e.pointerType)) {
    var l,
      s = e;
    if (s.originalEvent && (s = s.originalEvent), "pointermove" === s.type) {
      if (null !== a.touchId) return;
      if (s.pointerId !== a.pointerId) return;
    }
    if ("touchmove" === s.type) {
      if (l = Ce(s.changedTouches).filter(function (e) {
        return e.identifier === a.touchId;
      })[0], !l || l.identifier !== a.touchId) return;
    } else l = s;
    if (a.isTouched) {
      var c = l.pageX,
        u = l.pageY;
      if (s.preventedByNestedSwiper) return o.startX = c, void (o.startY = u);
      if (!r.allowTouchMove) return s.target.matches(a.focusableElements) || (r.allowClick = !1), void (a.isTouched && (Object.assign(o, {
        startX: c,
        startY: u,
        currentX: c,
        currentY: u
      }), a.touchStartTime = Dc()));
      if (n.touchReleaseOnEdges && !n.loop) if (r.isVertical()) {
        if (u < o.startY && r.translate <= r.maxTranslate() || u > o.startY && r.translate >= r.minTranslate()) return a.isTouched = !1, void (a.isMoved = !1);
      } else if (c < o.startX && r.translate <= r.maxTranslate() || c > o.startX && r.translate >= r.minTranslate()) return;
      if (t.activeElement && s.target === t.activeElement && s.target.matches(a.focusableElements)) return a.isMoved = !0, void (r.allowClick = !1);
      a.allowTouchCallbacks && r.emit("touchMove", s), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = c, o.currentY = u;
      var d = o.currentX - o.startX,
        p = o.currentY - o.startY;
      if (!(r.params.threshold && Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) < r.params.threshold)) {
        var m;
        if (void 0 === a.isScrolling) r.isHorizontal() && o.currentY === o.startY || r.isVertical() && o.currentX === o.startX ? a.isScrolling = !1 : d * d + p * p >= 25 && (m = 180 * Math.atan2(Math.abs(p), Math.abs(d)) / Math.PI, a.isScrolling = r.isHorizontal() ? m > n.touchAngle : 90 - m > n.touchAngle);
        if (a.isScrolling && r.emit("touchMoveOpposite", s), void 0 === a.startMoving && (o.currentX === o.startX && o.currentY === o.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;else if (a.startMoving) {
          r.allowClick = !1, !n.cssMode && s.cancelable && s.preventDefault(), n.touchMoveStopPropagation && !n.nested && s.stopPropagation();
          var f = r.isHorizontal() ? d : p,
            v = r.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
          n.oneWayMovement && (f = Math.abs(f) * (i ? 1 : -1), v = Math.abs(v) * (i ? 1 : -1)), o.diff = f, f *= n.touchRatio, i && (f = -f, v = -v);
          var y = r.touchesDirection;
          r.swipeDirection = f > 0 ? "prev" : "next", r.touchesDirection = v > 0 ? "prev" : "next";
          var g = r.params.loop && !n.cssMode,
            h = "next" === r.touchesDirection && r.allowSlideNext || "prev" === r.touchesDirection && r.allowSlidePrev;
          if (!a.isMoved) {
            if (g && h && r.loopFix({
              direction: r.swipeDirection
            }), a.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
              var b = new window.CustomEvent("transitionend", {
                bubbles: !0,
                cancelable: !0
              });
              r.wrapperEl.dispatchEvent(b);
            }
            a.allowMomentumBounce = !1, !n.grabCursor || !0 !== r.allowSlideNext && !0 !== r.allowSlidePrev || r.setGrabCursor(!0), r.emit("sliderFirstMove", s);
          }
          if (new Date().getTime(), a.isMoved && a.allowThresholdMove && y !== r.touchesDirection && g && h && Math.abs(f) >= 1) return Object.assign(o, {
            startX: c,
            startY: u,
            currentX: c,
            currentY: u,
            startTranslate: a.currentTranslate
          }), a.loopSwapReset = !0, void (a.startTranslate = a.currentTranslate);
          r.emit("sliderMove", s), a.isMoved = !0, a.currentTranslate = f + a.startTranslate;
          var N = !0,
            x = n.resistanceRatio;
          if (n.touchReleaseOnEdges && (x = 0), f > 0 ? (g && h && a.allowThresholdMove && a.currentTranslate > (n.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] : r.minTranslate()) && r.loopFix({
            direction: "prev",
            setTranslate: !0,
            activeSlideIndex: 0
          }), a.currentTranslate > r.minTranslate() && (N = !1, n.resistance && (a.currentTranslate = r.minTranslate() - 1 + Math.pow(-r.minTranslate() + a.startTranslate + f, x)))) : f < 0 && (g && h && a.allowThresholdMove && a.currentTranslate < (n.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] : r.maxTranslate()) && r.loopFix({
            direction: "next",
            setTranslate: !0,
            activeSlideIndex: r.slides.length - ("auto" === n.slidesPerView ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
          }), a.currentTranslate < r.maxTranslate() && (N = !1, n.resistance && (a.currentTranslate = r.maxTranslate() + 1 - Math.pow(r.maxTranslate() - a.startTranslate - f, x)))), N && (s.preventedByNestedSwiper = !0), !r.allowSlideNext && "next" === r.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !r.allowSlidePrev && "prev" === r.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), r.allowSlidePrev || r.allowSlideNext || (a.currentTranslate = a.startTranslate), n.threshold > 0) {
            if (!(Math.abs(f) > n.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
            if (!a.allowThresholdMove) return a.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, a.currentTranslate = a.startTranslate, void (o.diff = r.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY);
          }
          n.followFinger && !n.cssMode && ((n.freeMode && n.freeMode.enabled && r.freeMode || n.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(a.currentTranslate), r.setTranslate(a.currentTranslate));
        }
      }
    } else a.startMoving && a.isScrolling && r.emit("touchMoveOpposite", s);
  }
}
function fu(e) {
  var t,
    r = this,
    a = r.touchEventsData,
    n = e;
  if (n.originalEvent && (n = n.originalEvent), "touchend" === n.type || "touchcancel" === n.type) {
    if (t = Ce(n.changedTouches).filter(function (e) {
      return e.identifier === a.touchId;
    })[0], !t || t.identifier !== a.touchId) return;
  } else {
    if (null !== a.touchId) return;
    if (n.pointerId !== a.pointerId) return;
    t = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (r.browser.isSafari || r.browser.isWebView))) return;
  a.pointerId = null, a.touchId = null;
  var o = r.params,
    i = r.touches,
    l = r.rtlTranslate,
    s = r.slidesGrid;
  if (r.enabled && (o.simulateTouch || "mouse" !== n.pointerType)) {
    if (a.allowTouchCallbacks && r.emit("touchEnd", n), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && o.grabCursor && r.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
    o.grabCursor && a.isMoved && a.isTouched && (!0 === r.allowSlideNext || !0 === r.allowSlidePrev) && r.setGrabCursor(!1);
    var c,
      u = Dc(),
      d = u - a.touchStartTime;
    if (r.allowClick) {
      var p = n.path || n.composedPath && n.composedPath();
      r.updateClickedSlide(p && p[0] || n.target, p), r.emit("tap click", n), d < 300 && u - a.lastClickTime < 300 && r.emit("doubleTap doubleClick", n);
    }
    if (a.lastClickTime = Dc(), Lc(function () {
      r.destroyed || (r.allowClick = !0);
    }), !a.isTouched || !a.isMoved || !r.swipeDirection || 0 === i.diff && !a.loopSwapReset || a.currentTranslate === a.startTranslate && !a.loopSwapReset) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);
    if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, c = o.followFinger ? l ? r.translate : -r.translate : -a.currentTranslate, !o.cssMode) if (o.freeMode && o.freeMode.enabled) r.freeMode.onTouchEnd({
      currentPos: c
    });else {
      for (var m = c >= -r.maxTranslate() && !r.params.loop, f = 0, v = r.slidesSizesGrid[0], y = 0; y < s.length; y += y < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup) {
        var g = y < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
        void 0 !== s[y + g] ? (m || c >= s[y] && c < s[y + g]) && (f = y, v = s[y + g] - s[y]) : (m || c >= s[y]) && (f = y, v = s[s.length - 1] - s[s.length - 2]);
      }
      var h = null,
        b = null;
      o.rewind && (r.isBeginning ? b = o.virtual && o.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1 : r.isEnd && (h = 0));
      var N = (c - s[f]) / v,
        x = f < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
      if (d > o.longSwipesMs) {
        if (!o.longSwipes) return void r.slideTo(r.activeIndex);
        "next" === r.swipeDirection && (N >= o.longSwipesRatio ? r.slideTo(o.rewind && r.isEnd ? h : f + x) : r.slideTo(f)), "prev" === r.swipeDirection && (N > 1 - o.longSwipesRatio ? r.slideTo(f + x) : null !== b && N < 0 && Math.abs(N) > o.longSwipesRatio ? r.slideTo(b) : r.slideTo(f));
      } else {
        if (!o.shortSwipes) return void r.slideTo(r.activeIndex);
        r.navigation && (n.target === r.navigation.nextEl || n.target === r.navigation.prevEl) ? n.target === r.navigation.nextEl ? r.slideTo(f + x) : r.slideTo(f) : ("next" === r.swipeDirection && r.slideTo(null !== h ? h : f + x), "prev" === r.swipeDirection && r.slideTo(null !== b ? b : f));
      }
    }
  }
}
function vu() {
  var e = this,
    t = e.params,
    r = e.el;
  if (!r || 0 !== r.offsetWidth) {
    t.breakpoints && e.setBreakpoint();
    var a = e.allowSlideNext,
      n = e.allowSlidePrev,
      o = e.snapGrid,
      i = e.virtual && e.params.virtual.enabled;
    e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
    var l = i && t.loop;
    !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || l ? e.params.loop && !i ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(function () {
      e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
    }, 500)), e.allowSlidePrev = n, e.allowSlideNext = a, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
  }
}
function yu(e) {
  var t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function gu() {
  var e = this,
    t = e.wrapperEl,
    r = e.rtlTranslate;
  if (e.enabled) {
    e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
    var a = e.maxTranslate() - e.minTranslate();
    (0 === a ? 0 : (e.translate - e.minTranslate()) / a) !== e.progress && e.updateProgress(r ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
  }
}
function hu(e) {
  var t = this;
  ru(t, e.target), t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update();
}
function bu() {
  var e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
var Nu = function Nu(e, t) {
  var r = Cc(),
    a = e.params,
    n = e.el,
    o = e.wrapperEl,
    i = e.device,
    l = !!a.nested,
    s = "on" === t ? "addEventListener" : "removeEventListener",
    c = t;
  r[s]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: l
  }), n[s]("touchstart", e.onTouchStart, {
    passive: !1
  }), n[s]("pointerdown", e.onTouchStart, {
    passive: !1
  }), r[s]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: l
  }), r[s]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: l
  }), r[s]("touchend", e.onTouchEnd, {
    passive: !0
  }), r[s]("pointerup", e.onTouchEnd, {
    passive: !0
  }), r[s]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), r[s]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), r[s]("pointerout", e.onTouchEnd, {
    passive: !0
  }), r[s]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), r[s]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (a.preventClicks || a.preventClicksPropagation) && n[s]("click", e.onClick, !0), a.cssMode && o[s]("scroll", e.onScroll), a.updateOnWindowResize ? e[c](i.ios || i.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", vu, !0) : e[c]("observerUpdate", vu, !0), n[s]("load", e.onLoad, {
    capture: !0
  });
};
var xu = function xu(e, t) {
  return e.grid && t.grid && t.grid.rows > 1;
};
var ku = {
  addClasses: function addClasses() {
    var e,
      t,
      r,
      a,
      n = this,
      o = n.classNames,
      i = n.params,
      l = n.rtl,
      s = n.el,
      c = n.device,
      u = (t = ["initialized", i.direction, {
        "free-mode": n.params.freeMode && i.freeMode.enabled
      }, {
        autoheight: i.autoHeight
      }, {
        rtl: l
      }, {
        grid: i.grid && i.grid.rows > 1
      }, {
        "grid-column": i.grid && i.grid.rows > 1 && "column" === i.grid.fill
      }, {
        android: c.android
      }, {
        ios: c.ios
      }, {
        "css-mode": i.cssMode
      }, {
        centered: i.cssMode && i.centeredSlides
      }, {
        "watch-progress": i.watchSlidesProgress
      }], r = i.containerModifierClass, a = [], t.forEach(function (e) {
        "object" === ze(e) ? Object.keys(e).forEach(function (t) {
          e[t] && a.push(r + t);
        }) : "string" == typeof e && a.push(r + e);
      }), a);
    o.push.apply(o, Ce(u)), (e = s.classList).add.apply(e, Ce(o)), n.emitContainerClasses();
  },
  removeClasses: function removeClasses() {
    var e,
      t = this,
      r = t.el,
      a = t.classNames;
    (e = r.classList).remove.apply(e, Ce(a)), t.emitContainerClasses();
  }
};
var wu = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: .5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: .85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function _u(e, t) {
  return function (r) {
    void 0 === r && (r = {});
    var a = Object.keys(r)[0],
      n = r[a];
    "object" === ze(n) && null !== n ? (!0 === e[a] && (e[a] = {
      enabled: !0
    }), "navigation" === a && e[a] && e[a].enabled && !e[a].prevEl && !e[a].nextEl && (e[a].auto = !0), ["pagination", "scrollbar"].indexOf(a) >= 0 && e[a] && e[a].enabled && !e[a].el && (e[a].auto = !0), a in e && "enabled" in n ? ("object" !== ze(e[a]) || "enabled" in e[a] || (e[a].enabled = !0), e[a] || (e[a] = {
      enabled: !1
    }), zc(t, r)) : zc(t, r)) : zc(t, r);
  };
}
var Fu = {
    eventsEmitter: tu,
    update: ou,
    translate: iu,
    transition: su,
    slide: cu,
    loop: uu,
    grabCursor: {
      setGrabCursor: function setGrabCursor(e) {
        var t = this;
        if (!(!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
          var r = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          t.isElement && (t.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(function () {
            t.__preventObserver__ = !1;
          });
        }
      },
      unsetGrabCursor: function unsetGrabCursor() {
        var e = this;
        e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(function () {
          e.__preventObserver__ = !1;
        }));
      }
    },
    events: {
      attachEvents: function attachEvents() {
        var e = this,
          t = e.params;
        e.onTouchStart = pu.bind(e), e.onTouchMove = mu.bind(e), e.onTouchEnd = fu.bind(e), e.onDocumentTouchStart = bu.bind(e), t.cssMode && (e.onScroll = gu.bind(e)), e.onClick = yu.bind(e), e.onLoad = hu.bind(e), Nu(e, "on");
      },
      detachEvents: function detachEvents() {
        Nu(this, "off");
      }
    },
    breakpoints: {
      setBreakpoint: function setBreakpoint() {
        var e = this,
          t = e.realIndex,
          r = e.initialized,
          a = e.params,
          n = e.el,
          o = a.breakpoints;
        if (o && (!o || 0 !== Object.keys(o).length)) {
          var i = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
          if (i && e.currentBreakpoint !== i) {
            var l = (i in o ? o[i] : void 0) || e.originalParams,
              s = xu(e, a),
              c = xu(e, l),
              u = a.enabled;
            s && !c ? (n.classList.remove("".concat(a.containerModifierClass, "grid"), "".concat(a.containerModifierClass, "grid-column")), e.emitContainerClasses()) : !s && c && (n.classList.add("".concat(a.containerModifierClass, "grid")), (l.grid.fill && "column" === l.grid.fill || !l.grid.fill && "column" === a.grid.fill) && n.classList.add("".concat(a.containerModifierClass, "grid-column")), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach(function (t) {
              if (void 0 !== l[t]) {
                var r = a[t] && a[t].enabled,
                  n = l[t] && l[t].enabled;
                r && !n && e[t].disable(), !r && n && e[t].enable();
              }
            });
            var d = l.direction && l.direction !== a.direction,
              p = a.loop && (l.slidesPerView !== a.slidesPerView || d),
              m = a.loop;
            d && r && e.changeDirection(), zc(e.params, l);
            var f = e.params.enabled,
              v = e.params.loop;
            Object.assign(e, {
              allowTouchMove: e.params.allowTouchMove,
              allowSlideNext: e.params.allowSlideNext,
              allowSlidePrev: e.params.allowSlidePrev
            }), u && !f ? e.disable() : !u && f && e.enable(), e.currentBreakpoint = i, e.emit("_beforeBreakpoint", l), r && (p ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !m && v ? (e.loopCreate(t), e.updateSlides()) : m && !v && e.loopDestroy()), e.emit("breakpoint", l);
          }
        }
      },
      getBreakpoint: function getBreakpoint(e, t, r) {
        if (void 0 === t && (t = "window"), e && ("container" !== t || r)) {
          var a = !1,
            n = Ac(),
            o = "window" === t ? n.innerHeight : r.clientHeight,
            i = Object.keys(e).map(function (e) {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                var t = parseFloat(e.substr(1));
                return {
                  value: o * t,
                  point: e
                };
              }
              return {
                value: e,
                point: e
              };
            });
          i.sort(function (e, t) {
            return parseInt(e.value, 10) - parseInt(t.value, 10);
          });
          for (var l = 0; l < i.length; l += 1) {
            var s = i[l],
              c = s.point,
              u = s.value;
            "window" === t ? n.matchMedia("(min-width: ".concat(u, "px)")).matches && (a = c) : u <= r.clientWidth && (a = c);
          }
          return a || "max";
        }
      }
    },
    checkOverflow: {
      checkOverflow: function checkOverflow() {
        var e = this,
          t = e.isLocked,
          r = e.params,
          a = r.slidesOffsetBefore;
        if (a) {
          var n = e.slides.length - 1,
            o = e.slidesGrid[n] + e.slidesSizesGrid[n] + 2 * a;
          e.isLocked = e.size > o;
        } else e.isLocked = 1 === e.snapGrid.length;
        !0 === r.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === r.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
      }
    },
    classes: ku
  },
  Su = {},
  Cu = function () {
    function e() {
      var t, r;
      Ne(this, e);
      for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];
      1 === n.length && n[0].constructor && "Object" === Object.prototype.toString.call(n[0]).slice(8, -1) ? r = n[0] : (t = n[0], r = n[1]), r || (r = {}), r = zc({}, r), t && !r.el && (r.el = t);
      var i = Cc();
      if (r.el && "string" == typeof r.el && i.querySelectorAll(r.el).length > 1) {
        var l = [];
        return i.querySelectorAll(r.el).forEach(function (t) {
          var a = zc({}, r, {
            el: t
          });
          l.push(new e(a));
        }), l;
      }
      var s,
        c = this;
      (c.__swiper__ = !0, c.support = Zc(), c.device = Qc({
        userAgent: r.userAgent
      }), c.browser = eu(), c.eventsListeners = {}, c.eventsAnyListeners = [], c.modules = Ce(c.__modules__), r.modules && Array.isArray(r.modules)) && (s = c.modules).push.apply(s, Ce(r.modules));
      var u = {};
      c.modules.forEach(function (e) {
        e({
          params: r,
          swiper: c,
          extendParams: _u(r, u),
          on: c.on.bind(c),
          once: c.once.bind(c),
          off: c.off.bind(c),
          emit: c.emit.bind(c)
        });
      });
      var d = zc({}, wu, u);
      return c.params = zc({}, d, Su, r), c.originalParams = zc({}, c.params), c.passedParams = zc({}, r), c.params && c.params.on && Object.keys(c.params.on).forEach(function (e) {
        c.on(e, c.params.on[e]);
      }), c.params && c.params.onAny && c.onAny(c.params.onAny), Object.assign(c, {
        enabled: c.params.enabled,
        el: t,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal: function isHorizontal() {
          return "horizontal" === c.params.direction;
        },
        isVertical: function isVertical() {
          return "vertical" === c.params.direction;
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment: function cssOverflowAdjustment() {
          return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
        },
        allowSlideNext: c.params.allowSlideNext,
        allowSlidePrev: c.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: c.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null
        },
        allowClick: !0,
        allowTouchMove: c.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        imagesToLoad: [],
        imagesLoaded: 0
      }), c.emit("_swiper"), c.params.init && c.init(), c;
    }
    return ke(e, [{
      key: "getDirectionLabel",
      value: function value(e) {
        return this.isHorizontal() ? e : {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom"
        }[e];
      }
    }, {
      key: "getSlideIndex",
      value: function value(e) {
        var t = this.slidesEl,
          r = this.params,
          a = Yc(Hc(t, ".".concat(r.slideClass, ", swiper-slide"))[0]);
        return Yc(e) - a;
      }
    }, {
      key: "getSlideIndexByData",
      value: function value(e) {
        return this.getSlideIndex(this.slides.filter(function (t) {
          return 1 * t.getAttribute("data-swiper-slide-index") === e;
        })[0]);
      }
    }, {
      key: "recalcSlides",
      value: function value() {
        var e = this,
          t = e.slidesEl,
          r = e.params;
        e.slides = Hc(t, ".".concat(r.slideClass, ", swiper-slide"));
      }
    }, {
      key: "enable",
      value: function value() {
        var e = this;
        e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
      }
    }, {
      key: "disable",
      value: function value() {
        var e = this;
        e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
      }
    }, {
      key: "setProgress",
      value: function value(e, t) {
        var r = this;
        e = Math.min(Math.max(e, 0), 1);
        var a = r.minTranslate(),
          n = (r.maxTranslate() - a) * e + a;
        r.translateTo(n, void 0 === t ? 0 : t), r.updateActiveIndex(), r.updateSlidesClasses();
      }
    }, {
      key: "emitContainerClasses",
      value: function value() {
        var e = this;
        if (e.params._emitClasses && e.el) {
          var t = e.el.className.split(" ").filter(function (t) {
            return 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass);
          });
          e.emit("_containerClasses", t.join(" "));
        }
      }
    }, {
      key: "getSlideClasses",
      value: function value(e) {
        var t = this;
        return t.destroyed ? "" : e.className.split(" ").filter(function (e) {
          return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass);
        }).join(" ");
      }
    }, {
      key: "emitSlidesClasses",
      value: function value() {
        var e = this;
        if (e.params._emitClasses && e.el) {
          var t = [];
          e.slides.forEach(function (r) {
            var a = e.getSlideClasses(r);
            t.push({
              slideEl: r,
              classNames: a
            }), e.emit("_slideClass", r, a);
          }), e.emit("_slideClasses", t);
        }
      }
    }, {
      key: "slidesPerViewDynamic",
      value: function value(e, t) {
        void 0 === e && (e = "current"), void 0 === t && (t = !1);
        var r = this,
          a = r.params,
          n = r.slides,
          o = r.slidesGrid,
          i = r.slidesSizesGrid,
          l = r.size,
          s = r.activeIndex,
          c = 1;
        if ("number" == typeof a.slidesPerView) return a.slidesPerView;
        if (a.centeredSlides) {
          for (var u, d = n[s] ? Math.ceil(n[s].swiperSlideSize) : 0, p = s + 1; p < n.length; p += 1) n[p] && !u && (c += 1, (d += Math.ceil(n[p].swiperSlideSize)) > l && (u = !0));
          for (var m = s - 1; m >= 0; m -= 1) n[m] && !u && (c += 1, (d += n[m].swiperSlideSize) > l && (u = !0));
        } else if ("current" === e) for (var f = s + 1; f < n.length; f += 1) {
          (t ? o[f] + i[f] - o[s] < l : o[f] - o[s] < l) && (c += 1);
        } else for (var v = s - 1; v >= 0; v -= 1) {
          o[s] - o[v] < l && (c += 1);
        }
        return c;
      }
    }, {
      key: "update",
      value: function value() {
        var e = this;
        if (e && !e.destroyed) {
          var t,
            r = e.snapGrid,
            a = e.params;
          if (a.breakpoints && e.setBreakpoint(), Ce(e.el.querySelectorAll('[loading="lazy"]')).forEach(function (t) {
            t.complete && ru(e, t);
          }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), a.freeMode && a.freeMode.enabled && !a.cssMode) o(), a.autoHeight && e.updateAutoHeight();else {
            if (("auto" === a.slidesPerView || a.slidesPerView > 1) && e.isEnd && !a.centeredSlides) {
              var n = e.virtual && a.virtual.enabled ? e.virtual.slides : e.slides;
              t = e.slideTo(n.length - 1, 0, !1, !0);
            } else t = e.slideTo(e.activeIndex, 0, !1, !0);
            t || o();
          }
          a.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
        }
        function o() {
          var t = e.rtlTranslate ? -1 * e.translate : e.translate,
            r = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
          e.setTranslate(r), e.updateActiveIndex(), e.updateSlidesClasses();
        }
      }
    }, {
      key: "changeDirection",
      value: function value(e, t) {
        void 0 === t && (t = !0);
        var r = this,
          a = r.params.direction;
        return e || (e = "horizontal" === a ? "vertical" : "horizontal"), e === a || "horizontal" !== e && "vertical" !== e || (r.el.classList.remove("".concat(r.params.containerModifierClass).concat(a)), r.el.classList.add("".concat(r.params.containerModifierClass).concat(e)), r.emitContainerClasses(), r.params.direction = e, r.slides.forEach(function (t) {
          "vertical" === e ? t.style.width = "" : t.style.height = "";
        }), r.emit("changeDirection"), t && r.update()), r;
      }
    }, {
      key: "changeLanguageDirection",
      value: function value(e) {
        var t = this;
        t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.el.classList.add("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "rtl") : (t.el.classList.remove("".concat(t.params.containerModifierClass, "rtl")), t.el.dir = "ltr"), t.update());
      }
    }, {
      key: "mount",
      value: function value(e) {
        var t = this;
        if (t.mounted) return !0;
        var r = e || t.params.el;
        if ("string" == typeof r && (r = document.querySelector(r)), !r) return !1;
        r.swiper = t, r.parentNode && r.parentNode.host && r.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
        var a = function a() {
            return ".".concat((t.params.wrapperClass || "").trim().split(" ").join("."));
          },
          n = r && r.shadowRoot && r.shadowRoot.querySelector ? r.shadowRoot.querySelector(a()) : Hc(r, a())[0];
        return !n && t.params.createElements && (n = Vc("div", t.params.wrapperClass), r.append(n), Hc(r, ".".concat(t.params.slideClass)).forEach(function (e) {
          n.append(e);
        })), Object.assign(t, {
          el: r,
          wrapperEl: n,
          slidesEl: t.isElement && !r.parentNode.host.slideSlots ? r.parentNode.host : n,
          hostEl: t.isElement ? r.parentNode.host : r,
          mounted: !0,
          rtl: "rtl" === r.dir.toLowerCase() || "rtl" === Kc(r, "direction"),
          rtlTranslate: "horizontal" === t.params.direction && ("rtl" === r.dir.toLowerCase() || "rtl" === Kc(r, "direction")),
          wrongRTL: "-webkit-box" === Kc(n, "display")
        }), !0;
      }
    }, {
      key: "init",
      value: function value(e) {
        var t = this;
        if (t.initialized) return t;
        if (!1 === t.mount(e)) return t;
        t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
        var r = Ce(t.el.querySelectorAll('[loading="lazy"]'));
        return t.isElement && r.push.apply(r, Ce(t.hostEl.querySelectorAll('[loading="lazy"]'))), r.forEach(function (e) {
          e.complete ? ru(t, e) : e.addEventListener("load", function (e) {
            ru(t, e.target);
          });
        }), nu(t), t.initialized = !0, nu(t), t.emit("init"), t.emit("afterInit"), t;
      }
    }, {
      key: "destroy",
      value: function value(e, t) {
        void 0 === e && (e = !0), void 0 === t && (t = !0);
        var r,
          a = this,
          n = a.params,
          o = a.el,
          i = a.wrapperEl,
          l = a.slides;
        return void 0 === a.params || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), n.loop && a.loopDestroy(), t && (a.removeClasses(), o.removeAttribute("style"), i.removeAttribute("style"), l && l.length && l.forEach(function (e) {
          e.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
        })), a.emit("destroy"), Object.keys(a.eventsListeners).forEach(function (e) {
          a.off(e);
        }), !1 !== e && (a.el.swiper = null, r = a, Object.keys(r).forEach(function (e) {
          try {
            r[e] = null;
          } catch (e) {}
          try {
            delete r[e];
          } catch (e) {}
        })), a.destroyed = !0), null;
      }
    }], [{
      key: "extendDefaults",
      value: function value(e) {
        zc(Su, e);
      }
    }, {
      key: "extendedDefaults",
      get: function get() {
        return Su;
      }
    }, {
      key: "defaults",
      get: function get() {
        return wu;
      }
    }, {
      key: "installModule",
      value: function value(t) {
        e.prototype.__modules__ || (e.prototype.__modules__ = []);
        var r = e.prototype.__modules__;
        "function" == typeof t && r.indexOf(t) < 0 && r.push(t);
      }
    }, {
      key: "use",
      value: function value(t) {
        return Array.isArray(t) ? (t.forEach(function (t) {
          return e.installModule(t);
        }), e) : (e.installModule(t), e);
      }
    }]), e;
  }();
Object.keys(Fu).forEach(function (e) {
  Object.keys(Fu[e]).forEach(function (t) {
    Cu.prototype[t] = Fu[e][t];
  });
}), Cu.use([function (e) {
  var t = e.swiper,
    r = e.on,
    a = e.emit,
    n = Ac(),
    o = null,
    i = null,
    l = function l() {
      t && !t.destroyed && t.initialized && (a("beforeResize"), a("resize"));
    },
    s = function s() {
      t && !t.destroyed && t.initialized && a("orientationchange");
    };
  r("init", function () {
    t.params.resizeObserver && void 0 !== n.ResizeObserver ? t && !t.destroyed && t.initialized && (o = new ResizeObserver(function (e) {
      i = n.requestAnimationFrame(function () {
        var r = t.width,
          a = t.height,
          n = r,
          o = a;
        e.forEach(function (e) {
          var r = e.contentBoxSize,
            a = e.contentRect,
            i = e.target;
          i && i !== t.el || (n = a ? a.width : (r[0] || r).inlineSize, o = a ? a.height : (r[0] || r).blockSize);
        }), n === r && o === a || l();
      });
    })).observe(t.el) : (n.addEventListener("resize", l), n.addEventListener("orientationchange", s));
  }), r("destroy", function () {
    i && n.cancelAnimationFrame(i), o && o.unobserve && t.el && (o.unobserve(t.el), o = null), n.removeEventListener("resize", l), n.removeEventListener("orientationchange", s);
  });
}, function (e) {
  var t = e.swiper,
    r = e.extendParams,
    a = e.on,
    n = e.emit,
    o = [],
    i = Ac(),
    l = function l(e, r) {
      void 0 === r && (r = {});
      var a = new (i.MutationObserver || i.WebkitMutationObserver)(function (e) {
        if (!t.__preventObserver__) if (1 !== e.length) {
          var r = function r() {
            n("observerUpdate", e[0]);
          };
          i.requestAnimationFrame ? i.requestAnimationFrame(r) : i.setTimeout(r, 0);
        } else n("observerUpdate", e[0]);
      });
      a.observe(e, {
        attributes: void 0 === r.attributes || r.attributes,
        childList: void 0 === r.childList || r.childList,
        characterData: void 0 === r.characterData || r.characterData
      }), o.push(a);
    };
  r({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), a("init", function () {
    if (t.params.observer) {
      if (t.params.observeParents) for (var e = $c(t.hostEl), r = 0; r < e.length; r += 1) l(e[r]);
      l(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), l(t.wrapperEl, {
        attributes: !1
      });
    }
  }), a("destroy", function () {
    o.forEach(function (e) {
      e.disconnect();
    }), o.splice(0, o.length);
  });
}]);
var ju = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "swiperElementNodeName", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopAdditionalSlides", "loopAddBlankSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideFullyVisibleClass", "slideNextClass", "slidePrevClass", "slideBlankClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function Eu(e) {
  return "object" === ze(e) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1) && !e.__swiper__;
}
function Tu(e, t) {
  var r = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter(function (e) {
    return r.indexOf(e) < 0;
  }).forEach(function (r) {
    void 0 === e[r] ? e[r] = t[r] : Eu(t[r]) && Eu(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : Tu(e[r], t[r]) : e[r] = t[r];
  });
}
function Ou(e) {
  return void 0 === e && (e = {}), e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
}
function Au(e) {
  return void 0 === e && (e = {}), e.pagination && void 0 === e.pagination.el;
}
function Mu(e) {
  return void 0 === e && (e = {}), e.scrollbar && void 0 === e.scrollbar.el;
}
function Lu(e) {
  void 0 === e && (e = "");
  var t = e.split(" ").map(function (e) {
      return e.trim();
    }).filter(function (e) {
      return !!e;
    }),
    r = [];
  return t.forEach(function (e) {
    r.indexOf(e) < 0 && r.push(e);
  }), r.join(" ");
}
function Du(e) {
  return void 0 === e && (e = ""), e ? e.includes("swiper-wrapper") ? e : "swiper-wrapper ".concat(e) : "swiper-wrapper";
}
function Bu() {
  return Bu = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Bu.apply(this, arguments);
}
function Pu(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function Iu(e) {
  var t = [];
  return Ue.Children.toArray(e).forEach(function (e) {
    Pu(e) ? t.push(e) : e.props && e.props.children && Iu(e.props.children).forEach(function (e) {
      return t.push(e);
    });
  }), t;
}
function zu(e) {
  var t = [],
    r = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return Ue.Children.toArray(e).forEach(function (e) {
    if (Pu(e)) t.push(e);else if (e.props && e.props.slot && r[e.props.slot]) r[e.props.slot].push(e);else if (e.props && e.props.children) {
      var a = Iu(e.props.children);
      a.length > 0 ? a.forEach(function (e) {
        return t.push(e);
      }) : r["container-end"].push(e);
    } else r["container-end"].push(e);
  }), {
    slides: t,
    slots: r
  };
}
function Ru(e, t) {
  return "undefined" == typeof window ? Ve(e, t) : We(e, t);
}
var Uu = Ze(null),
  Hu = Ze(null),
  Gu = qe(function (e, t) {
    var r = void 0 === e ? {} : e,
      a = r.className,
      n = r.tag,
      o = void 0 === n ? "div" : n,
      i = r.wrapperTag,
      l = void 0 === i ? "div" : i,
      s = r.children,
      c = r.onSwiper,
      u = Me(r, y),
      d = !1,
      p = Le(He("swiper"), 2),
      m = p[0],
      f = p[1],
      v = Le(He(null), 2),
      g = v[0],
      h = v[1],
      b = Le(He(!1), 2),
      N = b[0],
      x = b[1],
      k = Ge(!1),
      w = Ge(null),
      _ = Ge(null),
      F = Ge(null),
      S = Ge(null),
      C = Ge(null),
      j = Ge(null),
      E = Ge(null),
      T = Ge(null),
      O = function (e, t) {
        void 0 === e && (e = {}), void 0 === t && (t = !0);
        var r = {
            on: {}
          },
          a = {},
          n = {};
        Tu(r, wu), r._emitClasses = !0, r.init = !1;
        var o = {},
          i = ju.map(function (e) {
            return e.replace(/_/, "");
          }),
          l = Object.assign({}, e);
        return Object.keys(l).forEach(function (l) {
          void 0 !== e[l] && (i.indexOf(l) >= 0 ? Eu(e[l]) ? (r[l] = {}, n[l] = {}, Tu(r[l], e[l]), Tu(n[l], e[l])) : (r[l] = e[l], n[l] = e[l]) : 0 === l.search(/on[A-Z]/) && "function" == typeof e[l] ? t ? a["".concat(l[2].toLowerCase()).concat(l.substr(3))] = e[l] : r.on["".concat(l[2].toLowerCase()).concat(l.substr(3))] = e[l] : o[l] = e[l]);
        }), ["navigation", "pagination", "scrollbar"].forEach(function (e) {
          !0 === r[e] && (r[e] = {}), !1 === r[e] && delete r[e];
        }), {
          params: r,
          passedParams: n,
          rest: o,
          events: a
        };
      }(u),
      A = O.params,
      M = O.passedParams,
      L = O.rest,
      D = O.events,
      B = zu(s),
      P = B.slides,
      I = B.slots,
      z = function z() {
        x(!N);
      };
    Object.assign(A.on, {
      _containerClasses: function _containerClasses(e, t) {
        f(t);
      }
    });
    var R = function R() {
      Object.assign(A.on, D), d = !0;
      var e = Te({}, A);
      if (delete e.wrapperClass, _.current = new Cu(e), _.current.virtual && _.current.params.virtual.enabled) {
        _.current.virtual.slides = P;
        var t = {
          cache: !1,
          slides: P,
          renderExternal: h,
          renderExternalUpdate: !1
        };
        Tu(_.current.params.virtual, t), Tu(_.current.originalParams.virtual, t);
      }
    };
    w.current || R(), _.current && _.current.on("_beforeBreakpoint", z);
    return Ve(function () {
      return function () {
        _.current && _.current.off("_beforeBreakpoint", z);
      };
    }), Ve(function () {
      !k.current && _.current && (_.current.emitSlidesClasses(), k.current = !0);
    }), Ru(function () {
      if (t && (t.current = w.current), w.current) return _.current.destroyed && R(), function (e, t) {
        var r = e.el,
          a = e.nextEl,
          n = e.prevEl,
          o = e.paginationEl,
          i = e.scrollbarEl,
          l = e.swiper;
        Ou(t) && a && n && (l.params.navigation.nextEl = a, l.originalParams.navigation.nextEl = a, l.params.navigation.prevEl = n, l.originalParams.navigation.prevEl = n), Au(t) && o && (l.params.pagination.el = o, l.originalParams.pagination.el = o), Mu(t) && i && (l.params.scrollbar.el = i, l.originalParams.scrollbar.el = i), l.init(r);
      }({
        el: w.current,
        nextEl: C.current,
        prevEl: j.current,
        paginationEl: E.current,
        scrollbarEl: T.current,
        swiper: _.current
      }, A), c && !_.current.destroyed && c(_.current), function () {
        _.current && !_.current.destroyed && _.current.destroy(!0, !1);
      };
    }, []), Ru(function () {
      !d && D && _.current && Object.keys(D).forEach(function (e) {
        _.current.on(e, D[e]);
      });
      var e = function (e, t, r, a, n) {
        var o = [];
        if (!t) return o;
        var i = function i(e) {
          o.indexOf(e) < 0 && o.push(e);
        };
        if (r && a) {
          var l = a.map(n),
            s = r.map(n);
          l.join("") !== s.join("") && i("children"), a.length !== r.length && i("children");
        }
        return ju.filter(function (e) {
          return "_" === e[0];
        }).map(function (e) {
          return e.replace(/_/, "");
        }).forEach(function (r) {
          if (r in e && r in t) if (Eu(e[r]) && Eu(t[r])) {
            var a = Object.keys(e[r]),
              n = Object.keys(t[r]);
            a.length !== n.length ? i(r) : (a.forEach(function (a) {
              e[r][a] !== t[r][a] && i(r);
            }), n.forEach(function (a) {
              e[r][a] !== t[r][a] && i(r);
            }));
          } else e[r] !== t[r] && i(r);
        }), o;
      }(M, F.current, P, S.current, function (e) {
        return e.key;
      });
      return F.current = M, S.current = P, e.length && _.current && !_.current.destroyed && function (e) {
        var t,
          r,
          a,
          n,
          o,
          i,
          l,
          s,
          c = e.swiper,
          u = e.slides,
          d = e.passedParams,
          p = e.changedParams,
          m = e.nextEl,
          f = e.prevEl,
          v = e.scrollbarEl,
          y = e.paginationEl,
          g = p.filter(function (e) {
            return "children" !== e && "direction" !== e && "wrapperClass" !== e;
          }),
          h = c.params,
          b = c.pagination,
          N = c.navigation,
          x = c.scrollbar,
          k = c.virtual,
          w = c.thumbs;
        p.includes("thumbs") && d.thumbs && d.thumbs.swiper && h.thumbs && !h.thumbs.swiper && (t = !0), p.includes("controller") && d.controller && d.controller.control && h.controller && !h.controller.control && (r = !0), p.includes("pagination") && d.pagination && (d.pagination.el || y) && (h.pagination || !1 === h.pagination) && b && !b.el && (a = !0), p.includes("scrollbar") && d.scrollbar && (d.scrollbar.el || v) && (h.scrollbar || !1 === h.scrollbar) && x && !x.el && (n = !0), p.includes("navigation") && d.navigation && (d.navigation.prevEl || f) && (d.navigation.nextEl || m) && (h.navigation || !1 === h.navigation) && N && !N.prevEl && !N.nextEl && (o = !0);
        var _ = function _(e) {
          c[e] && (c[e].destroy(), "navigation" === e ? (c.isElement && (c[e].prevEl.remove(), c[e].nextEl.remove()), h[e].prevEl = void 0, h[e].nextEl = void 0, c[e].prevEl = void 0, c[e].nextEl = void 0) : (c.isElement && c[e].el.remove(), h[e].el = void 0, c[e].el = void 0));
        };
        p.includes("loop") && c.isElement && (h.loop && !d.loop ? i = !0 : !h.loop && d.loop ? l = !0 : s = !0), g.forEach(function (e) {
          if (Eu(h[e]) && Eu(d[e])) Object.assign(h[e], d[e]), "navigation" !== e && "pagination" !== e && "scrollbar" !== e || !("enabled" in d[e]) || d[e].enabled || _(e);else {
            var t = d[e];
            !0 !== t && !1 !== t || "navigation" !== e && "pagination" !== e && "scrollbar" !== e ? h[e] = d[e] : !1 === t && _(e);
          }
        }), g.includes("controller") && !r && c.controller && c.controller.control && h.controller && h.controller.control && (c.controller.control = h.controller.control), p.includes("children") && u && k && h.virtual.enabled ? (k.slides = u, k.update(!0)) : p.includes("virtual") && k && h.virtual.enabled && (u && (k.slides = u), k.update(!0)), p.includes("children") && u && h.loop && (s = !0), t && w.init() && w.update(!0), r && (c.controller.control = h.controller.control), a && (!c.isElement || y && "string" != typeof y || ((y = document.createElement("div")).classList.add("swiper-pagination"), y.part.add("pagination"), c.el.appendChild(y)), y && (h.pagination.el = y), b.init(), b.render(), b.update()), n && (!c.isElement || v && "string" != typeof v || ((v = document.createElement("div")).classList.add("swiper-scrollbar"), v.part.add("scrollbar"), c.el.appendChild(v)), v && (h.scrollbar.el = v), x.init(), x.updateSize(), x.setTranslate()), o && (c.isElement && (m && "string" != typeof m || ((m = document.createElement("div")).classList.add("swiper-button-next"), m.innerHTML = c.hostEl.constructor.nextButtonSvg, m.part.add("button-next"), c.el.appendChild(m)), f && "string" != typeof f || ((f = document.createElement("div")).classList.add("swiper-button-prev"), f.innerHTML = c.hostEl.constructor.prevButtonSvg, f.part.add("button-prev"), c.el.appendChild(f))), m && (h.navigation.nextEl = m), f && (h.navigation.prevEl = f), N.init(), N.update()), p.includes("allowSlideNext") && (c.allowSlideNext = d.allowSlideNext), p.includes("allowSlidePrev") && (c.allowSlidePrev = d.allowSlidePrev), p.includes("direction") && c.changeDirection(d.direction, !1), (i || s) && c.loopDestroy(), (l || s) && c.loopCreate(), c.update();
      }({
        swiper: _.current,
        slides: P,
        passedParams: M,
        changedParams: e,
        nextEl: C.current,
        prevEl: j.current,
        scrollbarEl: T.current,
        paginationEl: E.current
      }), function () {
        D && _.current && Object.keys(D).forEach(function (e) {
          _.current.off(e, D[e]);
        });
      };
    }), Ru(function () {
      var e;
      !(e = _.current) || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
    }, [g]), Ue.createElement(o, Bu({
      ref: w,
      className: Lu("".concat(m).concat(a ? " ".concat(a) : ""))
    }, L), Ue.createElement(Hu.Provider, {
      value: _.current
    }, I["container-start"], Ue.createElement(l, {
      className: Du(A.wrapperClass)
    }, I["wrapper-start"], A.virtual ? function (e, t, r) {
      if (!r) return null;
      for (var a = function a(e) {
          var r = e;
          return e < 0 ? r = t.length + e : r >= t.length && (r -= t.length), r;
        }, n = e.isHorizontal() ? Oe({}, e.rtlTranslate ? "right" : "left", "".concat(r.offset, "px")) : {
          top: "".concat(r.offset, "px")
        }, o = r.from, i = r.to, l = e.params.loop ? -t.length : 0, s = e.params.loop ? 2 * t.length : t.length, c = [], u = l; u < s; u += 1) u >= o && u <= i && c.push(t[a(u)]);
      return c.map(function (t, r) {
        return Ue.cloneElement(t, {
          swiper: e,
          style: n,
          key: t.props.virtualIndex || t.key || "slide-".concat(r)
        });
      });
    }(_.current, P, g) : P.map(function (e, t) {
      return Ue.cloneElement(e, {
        swiper: _.current,
        swiperSlideIndex: t
      });
    }), I["wrapper-end"]), Ou(A) && Ue.createElement(Ue.Fragment, null, Ue.createElement("div", {
      ref: j,
      className: "swiper-button-prev"
    }), Ue.createElement("div", {
      ref: C,
      className: "swiper-button-next"
    })), Mu(A) && Ue.createElement("div", {
      ref: T,
      className: "swiper-scrollbar"
    }), Au(A) && Ue.createElement("div", {
      ref: E,
      className: "swiper-pagination"
    }), I["container-end"]));
  });
Gu.displayName = "Swiper";
var Vu = qe(function (e, t) {
  var r = void 0 === e ? {} : e,
    a = r.tag,
    n = void 0 === a ? "div" : a,
    o = r.children,
    i = r.className,
    l = void 0 === i ? "" : i,
    s = r.swiper,
    c = r.zoom,
    u = r.lazy,
    d = r.virtualIndex,
    p = r.swiperSlideIndex,
    m = Me(r, g),
    f = Ge(null),
    v = Le(He("swiper-slide"), 2),
    y = v[0],
    h = v[1],
    b = Le(He(!1), 2),
    N = b[0],
    x = b[1];
  function k(e, t, r) {
    t === f.current && h(r);
  }
  Ru(function () {
    if (void 0 !== p && (f.current.swiperSlideIndex = p), t && (t.current = f.current), f.current && s) {
      if (!s.destroyed) return s.on("_slideClass", k), function () {
        s && s.off("_slideClass", k);
      };
      "swiper-slide" !== y && h("swiper-slide");
    }
  }), Ru(function () {
    s && f.current && !s.destroyed && h(s.getSlideClasses(f.current));
  }, [s]);
  var w = {
      isActive: y.indexOf("swiper-slide-active") >= 0,
      isVisible: y.indexOf("swiper-slide-visible") >= 0,
      isPrev: y.indexOf("swiper-slide-prev") >= 0,
      isNext: y.indexOf("swiper-slide-next") >= 0
    },
    _ = function _() {
      return "function" == typeof o ? o(w) : o;
    };
  return Ue.createElement(n, Bu({
    ref: f,
    className: Lu("".concat(y).concat(l ? " ".concat(l) : "")),
    "data-swiper-slide-index": d,
    onLoad: function onLoad() {
      x(!0);
    }
  }, m), c && Ue.createElement(Uu.Provider, {
    value: w
  }, Ue.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": "number" == typeof c ? c : void 0
  }, _(), u && !N && Ue.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !c && Ue.createElement(Uu.Provider, {
    value: w
  }, _(), u && !N && Ue.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Vu.displayName = "SwiperSlide";
var Wu = {
    cui__button: "Button-module_cui__button__hPii9",
    primary: "Button-module_primary__dgStd",
    secondary: "Button-module_secondary__r5wq6",
    tertiary: "Button-module_tertiary__bH-n8",
    minimal: "Button-module_minimal__bb-qi",
    destructive: "Button-module_destructive__rOiAw",
    loyalty: "Button-module_loyalty__XniXl",
    pill: "Button-module_pill__JTwTP",
    "status-pending": "Button-module_status-pending__aWaK2",
    "status-completed": "Button-module_status-completed__dju52",
    "status-alert": "Button-module_status-alert__IKEVQ",
    "status-destructive": "Button-module_status-destructive__9Lz46",
    disabled: "Button-module_disabled__FzEkB",
    skeleton: "Button-module_skeleton__8bTxC",
    "cui-pulse": "Button-module_cui-pulse__ggn43",
    selected: "Button-module_selected__RFoTH"
  },
  Ku = {
    completed: "ui_checkmark-circle",
    alert: "ui_warning",
    destructive: "ui_trash"
  },
  Yu = {
    xs: "cui-h-6 cui-min-w-[24px] cui-p-2xs",
    sm: "cui-h-8 cui-min-w-[32px] cui-p-xs",
    md: "cui-h-11 cui-min-w-[44px] cui-p-sm",
    lg: "cui-h-12 cui-min-w-[48px] cui-p-sm"
  },
  $u = {
    xs: "cui__pill_variant_sizes cui-h-6 cui-min-w-[24px] cui-p-2xs",
    sm: "cui__pill_variant_sizes cui-h-8 cui-min-w-[32px] cui-p-2xs",
    md: "cui__pill_variant_sizes cui-h-11 cui-min-w-[44px] cui-p-xs",
    lg: "cui__pill_variant_sizes cui-h-12 cui-min-w-[48px] cui-p-sm"
  },
  qu = function qu(e) {
    var t,
      r = e.size,
      a = e.type,
      n = e.fluid,
      o = void 0 !== n && n,
      i = e.selected,
      l = e.status,
      s = e.isDisabled,
      c = e.iconOnly,
      u = e.hasIcon,
      d = e.variant,
      p = e.hasRightIcon,
      m = e.hasDescription,
      f = !!l,
      v = !!d,
      y = (u || p || f) && !c,
      g = Wu[a];
    f && (g = "".concat(Wu["status-".concat(l)], " ").concat(Wu[a])), v && !f && (g = "".concat(Wu[d], " ").concat(Wu[a]));
    var h = "pill" === d,
      b = yt((Oe(t = {}, g, !0), Oe(t, function (e, t, r, a) {
        var n = "xs" === e,
          o = "sm" === e,
          i = "md" === e,
          l = "lg" === e,
          s = "tertiary" === r,
          c = "pill" === a,
          u = yt({
            "cui-px-xs cui-py-2xs": n,
            "cui-px-sm cui-py-xs": o,
            "cui-px-lg cui-py-sm": (i || l) && !t,
            "cui-px-lg cui-py-2xs": (i || l) && t
          }),
          d = !s && !c,
          p = s || c,
          m = yt({
            "heading-sm-bold": n && d,
            "heading-md-bold": o && d,
            "heading-lg-bold": i && d,
            "heading-xl-bold": l && d,
            "heading-sm": n && p,
            "heading-md": o && p,
            "heading-lg": i && p,
            "heading-xl": l && p
          }),
          f = yt({
            "cui-h-6": n,
            "cui-h-8": o,
            "cui-h-11": i,
            "cui-h-12": l
          });
        return "".concat(u, " ").concat(f, " ").concat(m);
      }(r, m, a, d), !c), Oe(t, Yu[r], c), Oe(t, $u[r], c && h), Oe(t, Wu.disabled, s && "pending" !== l), Oe(t, Wu.selected, i && !s), Oe(t, "cui-w-auto", !o), Oe(t, "cui-w-full", o), t), "".concat(Wu.cui__button));
    return {
      buttonClasses: b,
      innerButtonStyles: yt({
        "cui-gap-x-sm": y && ["lg", "md"].includes(r),
        "cui-gap-x-2xs": y && ("sm" === r || "xs" === r),
        "cui-justify-between": p,
        "cui-justify-center": !p,
        "cui-w-auto": !o,
        "cui-w-full": o
      })
    };
  },
  Ju = {
    xs: "sm",
    sm: "md",
    md: "lg",
    lg: "xl"
  },
  Xu = {
    xs: "md",
    sm: "lg",
    md: "xl",
    lg: "2xl"
  },
  Zu = ["2xs", "xs", "sm"],
  Qu = ["md", "lg", "xl"],
  ed = function ed(e) {
    return e.fluid ? dt.exports.jsx("span", {
      className: "cui__spacer cui-fluid-block cui-flex-grow"
    }) : null;
  },
  td = function td(e) {
    var t,
      r = e.size,
      a = e.rightIcon,
      n = e.fluid,
      o = e.FLAGS,
      i = (e.team, e.variant);
    if (o.iconOnly || !o.hasRightIcon) return null;
    var l = null;
    a && "string" == typeof a && (l = {
      name: a
    }), a && "object" === ze(a) && "name" in a && (l = a);
    var s = !!l && "color" in l && !!l.color;
    return dt.exports.jsxs(dt.exports.Fragment, {
      children: [dt.exports.jsx(ed, {
        fluid: n
      }), l ? dt.exports.jsx(rs, Te(Te({}, l), {}, {
        size: "pill" === i && r ? Ju[r] : r,
        className: yt(Oe({
          cui__color_icon: s,
          "cui-translate-y-2": Boolean(o.canShowDescription) && !!n
        }, "className" in l ? "".concat(null === (t = l) || void 0 === t ? void 0 : t.className) : "", !0))
      })) : null]
    });
  },
  rd = function rd(e) {
    var t,
      r = e.status,
      a = e.fluid,
      n = e.size,
      o = e.leftIcon,
      i = e.variant,
      l = e.team,
      s = e.FLAGS,
      c = null;
    o && "object" === ze(o) && "name" in o && (c = Te({}, o)), o && "string" == typeof o && (c = {
      name: o
    }), r && r in Ku && !o && null !== o && (c = {
      name: Ku[r]
    });
    var u = c && "color" in c && c.color,
      d = "pill" === i && n ? Ju[n] : n,
      p = "sm" === n || "xs" === n;
    return s.hasStatus && "pending" === r && !o && null !== o ? dt.exports.jsx(hn, {
      variant: "subtle",
      size: p ? "xs" : "sm"
    }) : s.hasIcon || s.hasRightIcon || l || s.hasStatus ? dt.exports.jsxs(dt.exports.Fragment, {
      children: [a && s.hasRightIcon ? dt.exports.jsx(ed, {
        fluid: a
      }) : null, c ? dt.exports.jsx(rs, Te(Te({}, c), {}, {
        size: d,
        className: [u ? "cui__color_icon" : "", "className" in c ? "".concat(null === (t = c) || void 0 === t ? void 0 : t.className) : ""].join(" ")
      })) : null, l ? dt.exports.jsx(Rs, {
        team: l,
        of: "athlete",
        size: n ? Xu[n] : n,
        className: yt({
          "-cui-ml-2xs cui-mr-2xs": Zu.includes(n),
          "-cui-ml-md cui-mr-xs": Qu.includes(n)
        })
      }) : null]
    }) : null;
  },
  ad = ["primary", "disabled", "desctructive"],
  nd = Ke(function (e) {
    var t = e.text,
      r = void 0 === t ? "" : t,
      a = e.description,
      n = void 0 === a ? "" : a,
      o = e.type,
      i = void 0 === o ? "primary" : o,
      l = e.size,
      s = void 0 === l ? "md" : l,
      c = e.fluid,
      u = void 0 !== c && c,
      d = e.leftIcon,
      p = e.rightIcon,
      m = e.selected,
      f = void 0 !== m && m,
      v = e.status,
      y = void 0 === v ? null : v,
      g = e.children,
      b = e.disabled,
      N = e.variant,
      x = void 0 === N ? null : N,
      k = e.team,
      w = e.minWidth,
      _ = e.onClick,
      F = e.accessibilityLabel,
      S = void 0 === F ? "" : F,
      C = e.className,
      j = void 0 === C ? "" : C,
      E = Me(e, h),
      T = !r && g ? g : r,
      O = Xe(function () {
        return {
          iconOnly: !T && !!d,
          hasIcon: !!d,
          hasStatus: !!y,
          hasRightIcon: !!p && "pending" !== y,
          isDisabled: !!b || "pending" === y,
          hasDescription: !!n,
          canShowDescription: !!n && ad.includes(i) && !!T && ("lg" === s || "md" === s)
        };
      }, [T, d, y, p, b, n, s]),
      A = Xe(function () {
        return qu(Te({
          size: s,
          type: i,
          fluid: u,
          selected: f,
          variant: x,
          status: y
        }, O));
      }, [s, i, u, f, y, x, O.isDisabled, O.iconOnly, O.hasIcon, O.hasRightIcon, O.hasDescription]),
      M = A.buttonClasses,
      L = A.innerButtonStyles,
      D = S ? {
        "aria-label": S
      } : {},
      B = !!n && "object" === ze(n),
      P = "object" === ze(n) ? n : {
        text: "",
        size: void 0,
        color: void 0
      },
      I = P.text,
      z = void 0 === I ? "" : I,
      R = P.size,
      U = void 0 === R ? "body-xs" : R,
      H = P.color,
      G = void 0 === H ? void 0 : H,
      V = {};
    return w && (r || g) && ("number" == typeof w && (V = {
      style: {
        minWidth: "".concat(w, "px")
      }
    }), "string" == typeof w && /px/.test(w) && (V = {
      style: {
        minWidth: w
      }
    })), dt.exports.jsxs("button", Te(Te(Te(Te({
      className: "".concat(M, " ").concat(j),
      onClick: function onClick(e) {
        return function (e, t, r) {
          !r && t && t(e);
        }(e, _, O.isDisabled);
      },
      disabled: b
    }, D), E), V), {}, {
      children: [dt.exports.jsxs("span", {
        className: "cui-flex cui-w-full cui-h-full cui-items-center ".concat(L),
        children: [dt.exports.jsx(rd, {
          FLAGS: O,
          status: y,
          fluid: u,
          type: i,
          size: s,
          leftIcon: d,
          variant: x,
          team: k
        }), dt.exports.jsx("span", {
          children: T || null
        }), dt.exports.jsx(td, {
          FLAGS: O,
          fluid: u,
          size: s,
          rightIcon: p,
          variant: x
        })]
      }), O.canShowDescription ? dt.exports.jsx("span", {
        className: "cui-relative cui-h-full cui-w-full",
        children: dt.exports.jsx("span", {
          className: yt({
            "cui-pr-2": O.hasRightIcon
          }, "cui-mx-auto ".concat(U, " ").concat(G || "", " cui-absolute cui-left-0 cui-w-full cui-h-full cui-truncate")),
          children: B ? z : n
        })
      }) : null]
    }));
  }),
  od = Ke(function (e) {
    var t = e.anchorTag,
      r = void 0 === t ? "" : t,
      a = e.label,
      n = void 0 === a ? "" : a,
      o = e.className,
      i = void 0 === o ? "" : o,
      l = Me(e, b);
    return r && !/^\#/.test(r) ? null : dt.exports.jsxs("a", Te(Te({
      href: r,
      className: "!cui-text-fg-inverse cui-absolute cui-top-sm cui-bg-bg-primary body-lg cui-rounded-1 cui-p-sm cui-outline-none cui-ring-1 cui-ring-offset-2 cui-ring-fg-focus cui-z-40 cui-left-[-9000px] focus:cui-outline-none focus:cui-left-sm focus-visible:cui-left-sm focus-within:cui-left-sm ".concat(i).trim()
    }, l), {}, {
      onClick: function onClick(e) {
        return function (e, t) {
          e.preventDefault();
          var r = document.querySelector(t);
          r && (null == r || r.focus());
        }(e, r);
      },
      "data-cy": "cui__skip_link",
      children: ["Skip the ", n]
    }));
  }),
  id = function id(e) {
    var t = e.className,
      r = e.slot,
      a = e.flip;
    return dt.exports.jsx("div", {
      slot: r,
      className: "cui-absolute ".concat(a ? "cui-bg-gradient-to-r" : "cui-bg-gradient-to-l", " cui-from-neutrals-transparent cui-to-bg-default cui-top-0 cui-h-full cui-w-0 small-mobile:cui-w-4 md:cui-w-8 cui-z-40 cui-transition-opacity cui-duration-200 cui-pointer-events-none ").concat(t)
    });
  };
function ld(e, t, r, a) {
  return e.params.createElements && Object.keys(a).forEach(function (n) {
    if (!r[n] && !0 === r.auto) {
      var o = Hc(e.el, ".".concat(a[n]))[0];
      o || ((o = Vc("div", a[n])).className = a[n], e.el.append(o)), r[n] = o, t[n] = o;
    }
  }), r;
}
function sd(e) {
  return void 0 === e && (e = ""), ".".concat(e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, "."));
}
var cd = [function (e) {
    var t = e.swiper,
      r = e.extendParams,
      a = e.on,
      n = e.emit;
    function o(e) {
      var r;
      return e && "string" == typeof e && t.isElement && (r = t.el.querySelector(e)) ? r : (e && ("string" == typeof e && (r = Ce(document.querySelectorAll(e))), t.params.uniqueNavElements && "string" == typeof e && r.length > 1 && 1 === t.el.querySelectorAll(e).length && (r = t.el.querySelector(e))), e && !r ? e : r);
    }
    function i(e, r) {
      var a = t.params.navigation;
      (e = Xc(e)).forEach(function (e) {
        var n;
        e && ((n = e.classList)[r ? "add" : "remove"].apply(n, Ce(a.disabledClass.split(" "))), "BUTTON" === e.tagName && (e.disabled = r), t.params.watchOverflow && t.enabled && e.classList[t.isLocked ? "add" : "remove"](a.lockClass));
      });
    }
    function l() {
      var e = t.navigation,
        r = e.nextEl,
        a = e.prevEl;
      if (t.params.loop) return i(a, !1), void i(r, !1);
      i(a, t.isBeginning && !t.params.rewind), i(r, t.isEnd && !t.params.rewind);
    }
    function s(e) {
      e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), n("navigationPrev"));
    }
    function c(e) {
      e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), n("navigationNext"));
    }
    function u() {
      var e = t.params.navigation;
      if (t.params.navigation = ld(t, t.originalParams.navigation, t.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      }), e.nextEl || e.prevEl) {
        var r = o(e.nextEl),
          a = o(e.prevEl);
        Object.assign(t.navigation, {
          nextEl: r,
          prevEl: a
        }), r = Xc(r), a = Xc(a);
        var n = function n(r, a) {
          var n;
          (r && r.addEventListener("click", "next" === a ? c : s), !t.enabled && r) && (n = r.classList).add.apply(n, Ce(e.lockClass.split(" ")));
        };
        r.forEach(function (e) {
          return n(e, "next");
        }), a.forEach(function (e) {
          return n(e, "prev");
        });
      }
    }
    function d() {
      var e = t.navigation,
        r = e.nextEl,
        a = e.prevEl;
      r = Xc(r), a = Xc(a);
      var n = function n(e, r) {
        var a;
        e.removeEventListener("click", "next" === r ? c : s), (a = e.classList).remove.apply(a, Ce(t.params.navigation.disabledClass.split(" ")));
      };
      r.forEach(function (e) {
        return n(e, "next");
      }), a.forEach(function (e) {
        return n(e, "prev");
      });
    }
    r({
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled"
      }
    }), t.navigation = {
      nextEl: null,
      prevEl: null
    }, a("init", function () {
      !1 === t.params.navigation.enabled ? p() : (u(), l());
    }), a("toEdge fromEdge lock unlock", function () {
      l();
    }), a("destroy", function () {
      d();
    }), a("enable disable", function () {
      var e = t.navigation,
        r = e.nextEl,
        a = e.prevEl;
      r = Xc(r), a = Xc(a), t.enabled ? l() : [].concat(Ce(r), Ce(a)).filter(function (e) {
        return !!e;
      }).forEach(function (e) {
        return e.classList.add(t.params.navigation.lockClass);
      });
    }), a("click", function (e, r) {
      var a = t.navigation,
        o = a.nextEl,
        i = a.prevEl;
      o = Xc(o), i = Xc(i);
      var l = r.target;
      if (t.params.navigation.hideOnClick && !i.includes(l) && !o.includes(l)) {
        if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === l || t.pagination.el.contains(l))) return;
        var s;
        o.length ? s = o[0].classList.contains(t.params.navigation.hiddenClass) : i.length && (s = i[0].classList.contains(t.params.navigation.hiddenClass)), n(!0 === s ? "navigationShow" : "navigationHide"), [].concat(Ce(o), Ce(i)).filter(function (e) {
          return !!e;
        }).forEach(function (e) {
          return e.classList.toggle(t.params.navigation.hiddenClass);
        });
      }
    });
    var p = function p() {
      var e;
      (e = t.el.classList).add.apply(e, Ce(t.params.navigation.navigationDisabledClass.split(" "))), d();
    };
    Object.assign(t.navigation, {
      enable: function enable() {
        var e;
        (e = t.el.classList).remove.apply(e, Ce(t.params.navigation.navigationDisabledClass.split(" "))), u(), l();
      },
      disable: p,
      update: l,
      init: u,
      destroy: d
    });
  }, function (e) {
    var t,
      r = e.swiper,
      a = e.extendParams,
      n = e.on,
      o = e.emit,
      i = "swiper-pagination";
    a({
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: "bullets",
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(e) {
          return e;
        },
        formatFractionTotal: function formatFractionTotal(e) {
          return e;
        },
        bulletClass: "".concat(i, "-bullet"),
        bulletActiveClass: "".concat(i, "-bullet-active"),
        modifierClass: "".concat(i, "-"),
        currentClass: "".concat(i, "-current"),
        totalClass: "".concat(i, "-total"),
        hiddenClass: "".concat(i, "-hidden"),
        progressbarFillClass: "".concat(i, "-progressbar-fill"),
        progressbarOppositeClass: "".concat(i, "-progressbar-opposite"),
        clickableClass: "".concat(i, "-clickable"),
        lockClass: "".concat(i, "-lock"),
        horizontalClass: "".concat(i, "-horizontal"),
        verticalClass: "".concat(i, "-vertical"),
        paginationDisabledClass: "".concat(i, "-disabled")
      }
    }), r.pagination = {
      el: null,
      bullets: []
    };
    var l = 0;
    function s() {
      return !r.params.pagination.el || !r.pagination.el || Array.isArray(r.pagination.el) && 0 === r.pagination.el.length;
    }
    function c(e, t) {
      var a = r.params.pagination.bulletActiveClass;
      e && (e = e["".concat("prev" === t ? "previous" : "next", "ElementSibling")]) && (e.classList.add("".concat(a, "-").concat(t)), (e = e["".concat("prev" === t ? "previous" : "next", "ElementSibling")]) && e.classList.add("".concat(a, "-").concat(t, "-").concat(t)));
    }
    function u(e) {
      var t = e.target.closest(sd(r.params.pagination.bulletClass));
      if (t) {
        e.preventDefault();
        var a = Yc(t) * r.params.slidesPerGroup;
        if (r.params.loop) {
          if (r.realIndex === a) return;
          r.slideToLoop(a);
        } else r.slideTo(a);
      }
    }
    function d() {
      var e = r.rtl,
        a = r.params.pagination;
      if (!s()) {
        var n,
          i,
          u = r.pagination.el;
        u = Xc(u);
        var d = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.slides.length,
          p = r.params.loop ? Math.ceil(d / r.params.slidesPerGroup) : r.snapGrid.length;
        if (r.params.loop ? (i = r.previousRealIndex || 0, n = r.params.slidesPerGroup > 1 ? Math.floor(r.realIndex / r.params.slidesPerGroup) : r.realIndex) : void 0 !== r.snapIndex ? (n = r.snapIndex, i = r.previousSnapIndex) : (i = r.previousIndex || 0, n = r.activeIndex || 0), "bullets" === a.type && r.pagination.bullets && r.pagination.bullets.length > 0) {
          var m,
            f,
            v,
            y = r.pagination.bullets;
          if (a.dynamicBullets && (t = Jc(y[0], r.isHorizontal() ? "width" : "height", !0), u.forEach(function (e) {
            e.style[r.isHorizontal() ? "width" : "height"] = "".concat(t * (a.dynamicMainBullets + 4), "px");
          }), a.dynamicMainBullets > 1 && void 0 !== i && ((l += n - (i || 0)) > a.dynamicMainBullets - 1 ? l = a.dynamicMainBullets - 1 : l < 0 && (l = 0)), m = Math.max(n - l, 0), v = ((f = m + (Math.min(y.length, a.dynamicMainBullets) - 1)) + m) / 2), y.forEach(function (e) {
            var t,
              r = Ce(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(function (e) {
                return "".concat(a.bulletActiveClass).concat(e);
              })).map(function (e) {
                return "string" == typeof e && e.includes(" ") ? e.split(" ") : e;
              }).flat();
            (t = e.classList).remove.apply(t, Ce(r));
          }), u.length > 1) y.forEach(function (e) {
            var t,
              o = Yc(e);
            o === n ? (t = e.classList).add.apply(t, Ce(a.bulletActiveClass.split(" "))) : r.isElement && e.setAttribute("part", "bullet");
            if (a.dynamicBullets) {
              var i;
              if (o >= m && o <= f) (i = e.classList).add.apply(i, Ce("".concat(a.bulletActiveClass, "-main").split(" ")));
              o === m && c(e, "prev"), o === f && c(e, "next");
            }
          });else {
            var g,
              h = y[n];
            if (h) (g = h.classList).add.apply(g, Ce(a.bulletActiveClass.split(" ")));
            if (r.isElement && y.forEach(function (e, t) {
              e.setAttribute("part", t === n ? "bullet-active" : "bullet");
            }), a.dynamicBullets) {
              for (var b = y[m], N = y[f], x = m; x <= f; x += 1) {
                var k;
                if (y[x]) (k = y[x].classList).add.apply(k, Ce("".concat(a.bulletActiveClass, "-main").split(" ")));
              }
              c(b, "prev"), c(N, "next");
            }
          }
          if (a.dynamicBullets) {
            var w = Math.min(y.length, a.dynamicMainBullets + 4),
              _ = (t * w - t) / 2 - v * t,
              F = e ? "right" : "left";
            y.forEach(function (e) {
              e.style[r.isHorizontal() ? F : "top"] = "".concat(_, "px");
            });
          }
        }
        u.forEach(function (e, t) {
          if ("fraction" === a.type && (e.querySelectorAll(sd(a.currentClass)).forEach(function (e) {
            e.textContent = a.formatFractionCurrent(n + 1);
          }), e.querySelectorAll(sd(a.totalClass)).forEach(function (e) {
            e.textContent = a.formatFractionTotal(p);
          })), "progressbar" === a.type) {
            var i;
            i = a.progressbarOpposite ? r.isHorizontal() ? "vertical" : "horizontal" : r.isHorizontal() ? "horizontal" : "vertical";
            var l = (n + 1) / p,
              s = 1,
              c = 1;
            "horizontal" === i ? s = l : c = l, e.querySelectorAll(sd(a.progressbarFillClass)).forEach(function (e) {
              e.style.transform = "translate3d(0,0,0) scaleX(".concat(s, ") scaleY(").concat(c, ")"), e.style.transitionDuration = "".concat(r.params.speed, "ms");
            });
          }
          "custom" === a.type && a.renderCustom ? (e.innerHTML = a.renderCustom(r, n + 1, p), 0 === t && o("paginationRender", e)) : (0 === t && o("paginationRender", e), o("paginationUpdate", e)), r.params.watchOverflow && r.enabled && e.classList[r.isLocked ? "add" : "remove"](a.lockClass);
        });
      }
    }
    function p() {
      var e = r.params.pagination;
      if (!s()) {
        var t = r.virtual && r.params.virtual.enabled ? r.virtual.slides.length : r.grid && r.params.grid.rows > 1 ? r.slides.length / Math.ceil(r.params.grid.rows) : r.slides.length,
          a = r.pagination.el;
        a = Xc(a);
        var n = "";
        if ("bullets" === e.type) {
          var i = r.params.loop ? Math.ceil(t / r.params.slidesPerGroup) : r.snapGrid.length;
          r.params.freeMode && r.params.freeMode.enabled && i > t && (i = t);
          for (var l = 0; l < i; l += 1) e.renderBullet ? n += e.renderBullet.call(r, l, e.bulletClass) : n += "<".concat(e.bulletElement, " ").concat(r.isElement ? 'part="bullet"' : "", ' class="').concat(e.bulletClass, '"></').concat(e.bulletElement, ">");
        }
        "fraction" === e.type && (n = e.renderFraction ? e.renderFraction.call(r, e.currentClass, e.totalClass) : '<span class="'.concat(e.currentClass, '"></span>') + " / " + '<span class="'.concat(e.totalClass, '"></span>')), "progressbar" === e.type && (n = e.renderProgressbar ? e.renderProgressbar.call(r, e.progressbarFillClass) : '<span class="'.concat(e.progressbarFillClass, '"></span>')), r.pagination.bullets = [], a.forEach(function (t) {
          var a;
          ("custom" !== e.type && (t.innerHTML = n || ""), "bullets" === e.type) && (a = r.pagination.bullets).push.apply(a, Ce(t.querySelectorAll(sd(e.bulletClass))));
        }), "custom" !== e.type && o("paginationRender", a[0]);
      }
    }
    function m() {
      r.params.pagination = ld(r, r.originalParams.pagination, r.params.pagination, {
        el: "swiper-pagination"
      });
      var e,
        t = r.params.pagination;
      t.el && ("string" == typeof t.el && r.isElement && (e = r.el.querySelector(t.el)), e || "string" != typeof t.el || (e = Ce(document.querySelectorAll(t.el))), e || (e = t.el), e && 0 !== e.length && (r.params.uniqueNavElements && "string" == typeof t.el && Array.isArray(e) && e.length > 1 && (e = Ce(r.el.querySelectorAll(t.el))).length > 1 && (e = e.filter(function (e) {
        return $c(e, ".swiper")[0] === r.el;
      })[0]), Array.isArray(e) && 1 === e.length && (e = e[0]), Object.assign(r.pagination, {
        el: e
      }), (e = Xc(e)).forEach(function (e) {
        var a;
        "bullets" === t.type && t.clickable && (a = e.classList).add.apply(a, Ce((t.clickableClass || "").split(" ")));
        e.classList.add(t.modifierClass + t.type), e.classList.add(r.isHorizontal() ? t.horizontalClass : t.verticalClass), "bullets" === t.type && t.dynamicBullets && (e.classList.add("".concat(t.modifierClass).concat(t.type, "-dynamic")), l = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && e.classList.add(t.progressbarOppositeClass), t.clickable && e.addEventListener("click", u), r.enabled || e.classList.add(t.lockClass);
      })));
    }
    function f() {
      var e = r.params.pagination;
      if (!s()) {
        var t = r.pagination.el;
        t && (t = Xc(t)).forEach(function (t) {
          var a;
          (t.classList.remove(e.hiddenClass), t.classList.remove(e.modifierClass + e.type), t.classList.remove(r.isHorizontal() ? e.horizontalClass : e.verticalClass), e.clickable) && ((a = t.classList).remove.apply(a, Ce((e.clickableClass || "").split(" "))), t.removeEventListener("click", u));
        }), r.pagination.bullets && r.pagination.bullets.forEach(function (t) {
          var r;
          return (r = t.classList).remove.apply(r, Ce(e.bulletActiveClass.split(" ")));
        });
      }
    }
    n("changeDirection", function () {
      if (r.pagination && r.pagination.el) {
        var e = r.params.pagination,
          t = r.pagination.el;
        (t = Xc(t)).forEach(function (t) {
          t.classList.remove(e.horizontalClass, e.verticalClass), t.classList.add(r.isHorizontal() ? e.horizontalClass : e.verticalClass);
        });
      }
    }), n("init", function () {
      !1 === r.params.pagination.enabled ? v() : (m(), p(), d());
    }), n("activeIndexChange", function () {
      void 0 === r.snapIndex && d();
    }), n("snapIndexChange", function () {
      d();
    }), n("snapGridLengthChange", function () {
      p(), d();
    }), n("destroy", function () {
      f();
    }), n("enable disable", function () {
      var e = r.pagination.el;
      e && (e = Xc(e)).forEach(function (e) {
        return e.classList[r.enabled ? "remove" : "add"](r.params.pagination.lockClass);
      });
    }), n("lock unlock", function () {
      d();
    }), n("click", function (e, t) {
      var a = t.target,
        n = Xc(r.pagination.el);
      if (r.params.pagination.el && r.params.pagination.hideOnClick && n && n.length > 0 && !a.classList.contains(r.params.pagination.bulletClass)) {
        if (r.navigation && (r.navigation.nextEl && a === r.navigation.nextEl || r.navigation.prevEl && a === r.navigation.prevEl)) return;
        var i = n[0].classList.contains(r.params.pagination.hiddenClass);
        o(!0 === i ? "paginationShow" : "paginationHide"), n.forEach(function (e) {
          return e.classList.toggle(r.params.pagination.hiddenClass);
        });
      }
    });
    var v = function v() {
      r.el.classList.add(r.params.pagination.paginationDisabledClass);
      var e = r.pagination.el;
      e && (e = Xc(e)).forEach(function (e) {
        return e.classList.add(r.params.pagination.paginationDisabledClass);
      }), f();
    };
    Object.assign(r.pagination, {
      enable: function enable() {
        r.el.classList.remove(r.params.pagination.paginationDisabledClass);
        var e = r.pagination.el;
        e && (e = Xc(e)).forEach(function (e) {
          return e.classList.remove(r.params.pagination.paginationDisabledClass);
        }), m(), p(), d();
      },
      disable: v,
      render: p,
      update: d,
      init: m,
      destroy: f
    });
  }, function (e) {
    var t,
      r,
      a,
      n,
      o = e.swiper,
      i = e.extendParams,
      l = e.on,
      s = e.emit,
      c = Cc(),
      u = !1,
      d = null,
      p = null;
    function m() {
      if (o.params.scrollbar.el && o.scrollbar.el) {
        var e = o.scrollbar,
          t = o.rtlTranslate,
          n = e.dragEl,
          i = e.el,
          l = o.params.scrollbar,
          s = o.params.loop ? o.progressLoop : o.progress,
          c = r,
          u = (a - r) * s;
        t ? (u = -u) > 0 ? (c = r - u, u = 0) : -u + r > a && (c = a + u) : u < 0 ? (c = r + u, u = 0) : u + r > a && (c = a - u), o.isHorizontal() ? (n.style.transform = "translate3d(".concat(u, "px, 0, 0)"), n.style.width = "".concat(c, "px")) : (n.style.transform = "translate3d(0px, ".concat(u, "px, 0)"), n.style.height = "".concat(c, "px")), l.hide && (clearTimeout(d), i.style.opacity = 1, d = setTimeout(function () {
          i.style.opacity = 0, i.style.transitionDuration = "400ms";
        }, 1e3));
      }
    }
    function f() {
      if (o.params.scrollbar.el && o.scrollbar.el) {
        var e = o.scrollbar,
          t = e.dragEl,
          i = e.el;
        t.style.width = "", t.style.height = "", a = o.isHorizontal() ? i.offsetWidth : i.offsetHeight, n = o.size / (o.virtualSize + o.params.slidesOffsetBefore - (o.params.centeredSlides ? o.snapGrid[0] : 0)), r = "auto" === o.params.scrollbar.dragSize ? a * n : parseInt(o.params.scrollbar.dragSize, 10), o.isHorizontal() ? t.style.width = "".concat(r, "px") : t.style.height = "".concat(r, "px"), i.style.display = n >= 1 ? "none" : "", o.params.scrollbar.hide && (i.style.opacity = 0), o.params.watchOverflow && o.enabled && e.el.classList[o.isLocked ? "add" : "remove"](o.params.scrollbar.lockClass);
      }
    }
    function v(e) {
      return o.isHorizontal() ? e.clientX : e.clientY;
    }
    function y(e) {
      var n,
        i = o.scrollbar,
        l = o.rtlTranslate,
        s = i.el;
      n = (v(e) - Wc(s)[o.isHorizontal() ? "left" : "top"] - (null !== t ? t : r / 2)) / (a - r), n = Math.max(Math.min(n, 1), 0), l && (n = 1 - n);
      var c = o.minTranslate() + (o.maxTranslate() - o.minTranslate()) * n;
      o.updateProgress(c), o.setTranslate(c), o.updateActiveIndex(), o.updateSlidesClasses();
    }
    function g(e) {
      var r = o.params.scrollbar,
        a = o.scrollbar,
        n = o.wrapperEl,
        i = a.el,
        l = a.dragEl;
      u = !0, t = e.target === l ? v(e) - e.target.getBoundingClientRect()[o.isHorizontal() ? "left" : "top"] : null, e.preventDefault(), e.stopPropagation(), n.style.transitionDuration = "100ms", l.style.transitionDuration = "100ms", y(e), clearTimeout(p), i.style.transitionDuration = "0ms", r.hide && (i.style.opacity = 1), o.params.cssMode && (o.wrapperEl.style["scroll-snap-type"] = "none"), s("scrollbarDragStart", e);
    }
    function h(e) {
      var t = o.scrollbar,
        r = o.wrapperEl,
        a = t.el,
        n = t.dragEl;
      u && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, y(e), r.style.transitionDuration = "0ms", a.style.transitionDuration = "0ms", n.style.transitionDuration = "0ms", s("scrollbarDragMove", e));
    }
    function b(e) {
      var t = o.params.scrollbar,
        r = o.scrollbar,
        a = o.wrapperEl,
        n = r.el;
      u && (u = !1, o.params.cssMode && (o.wrapperEl.style["scroll-snap-type"] = "", a.style.transitionDuration = ""), t.hide && (clearTimeout(p), p = Lc(function () {
        n.style.opacity = 0, n.style.transitionDuration = "400ms";
      }, 1e3)), s("scrollbarDragEnd", e), t.snapOnRelease && o.slideToClosest());
    }
    function N(e) {
      var t = o.scrollbar,
        r = o.params,
        a = t.el;
      if (a) {
        var n = a,
          i = !!r.passiveListeners && {
            passive: !1,
            capture: !1
          },
          l = !!r.passiveListeners && {
            passive: !0,
            capture: !1
          };
        if (n) {
          var s = "on" === e ? "addEventListener" : "removeEventListener";
          n[s]("pointerdown", g, i), c[s]("pointermove", h, i), c[s]("pointerup", b, l);
        }
      }
    }
    function x() {
      var e = o.scrollbar,
        t = o.el;
      o.params.scrollbar = ld(o, o.originalParams.scrollbar, o.params.scrollbar, {
        el: "swiper-scrollbar"
      });
      var r = o.params.scrollbar;
      if (r.el) {
        var a, n, i;
        if ("string" == typeof r.el && o.isElement && (a = o.el.querySelector(r.el)), a || "string" != typeof r.el) a || (a = r.el);else if (!(a = c.querySelectorAll(r.el)).length) return;
        if (o.params.uniqueNavElements && "string" == typeof r.el && a.length > 1 && 1 === t.querySelectorAll(r.el).length && (a = t.querySelector(r.el)), a.length > 0 && (a = a[0]), a.classList.add(o.isHorizontal() ? r.horizontalClass : r.verticalClass), a && ((n = a.querySelector(sd(o.params.scrollbar.dragClass))) || (n = Vc("div", o.params.scrollbar.dragClass), a.append(n))), Object.assign(e, {
          el: a,
          dragEl: n
        }), r.draggable && o.params.scrollbar.el && o.scrollbar.el && N("on"), a) (i = a.classList)[o.enabled ? "remove" : "add"].apply(i, Ce(Mc(o.params.scrollbar.lockClass)));
      }
    }
    function k() {
      var e,
        t = o.params.scrollbar,
        r = o.scrollbar.el;
      r && (e = r.classList).remove.apply(e, Ce(Mc(o.isHorizontal() ? t.horizontalClass : t.verticalClass)));
      o.params.scrollbar.el && o.scrollbar.el && N("off");
    }
    i({
      scrollbar: {
        el: null,
        dragSize: "auto",
        hide: !1,
        draggable: !1,
        snapOnRelease: !0,
        lockClass: "swiper-scrollbar-lock",
        dragClass: "swiper-scrollbar-drag",
        scrollbarDisabledClass: "swiper-scrollbar-disabled",
        horizontalClass: "swiper-scrollbar-horizontal",
        verticalClass: "swiper-scrollbar-vertical"
      }
    }), o.scrollbar = {
      el: null,
      dragEl: null
    }, l("changeDirection", function () {
      if (o.scrollbar && o.scrollbar.el) {
        var e = o.params.scrollbar,
          t = o.scrollbar.el;
        (t = Xc(t)).forEach(function (t) {
          t.classList.remove(e.horizontalClass, e.verticalClass), t.classList.add(o.isHorizontal() ? e.horizontalClass : e.verticalClass);
        });
      }
    }), l("init", function () {
      !1 === o.params.scrollbar.enabled ? w() : (x(), f(), m());
    }), l("update resize observerUpdate lock unlock changeDirection", function () {
      f();
    }), l("setTranslate", function () {
      m();
    }), l("setTransition", function (e, t) {
      !function (e) {
        o.params.scrollbar.el && o.scrollbar.el && (o.scrollbar.dragEl.style.transitionDuration = "".concat(e, "ms"));
      }(t);
    }), l("enable disable", function () {
      var e,
        t = o.scrollbar.el;
      t && (e = t.classList)[o.enabled ? "remove" : "add"].apply(e, Ce(Mc(o.params.scrollbar.lockClass)));
    }), l("destroy", function () {
      k();
    });
    var w = function w() {
      var e, t;
      ((e = o.el.classList).add.apply(e, Ce(Mc(o.params.scrollbar.scrollbarDisabledClass))), o.scrollbar.el) && (t = o.scrollbar.el.classList).add.apply(t, Ce(Mc(o.params.scrollbar.scrollbarDisabledClass)));
      k();
    };
    Object.assign(o.scrollbar, {
      enable: function enable() {
        var e, t;
        ((e = o.el.classList).remove.apply(e, Ce(Mc(o.params.scrollbar.scrollbarDisabledClass))), o.scrollbar.el) && (t = o.scrollbar.el.classList).remove.apply(t, Ce(Mc(o.params.scrollbar.scrollbarDisabledClass)));
        x(), f(), m();
      },
      disable: w,
      updateSize: f,
      setTranslate: m,
      init: x,
      destroy: k
    });
  }, function (e) {
    var t = e.swiper,
      r = e.extendParams,
      a = e.on;
    r({
      a11y: {
        enabled: !0,
        notificationClass: "swiper-notification",
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        slideLabelMessage: "{{index}} / {{slidesLength}}",
        containerMessage: null,
        containerRoleDescriptionMessage: null,
        itemRoleDescriptionMessage: null,
        slideRole: "group",
        id: null
      }
    }), t.a11y = {
      clicked: !1
    };
    var n = null;
    function o(e) {
      var t = n;
      0 !== t.length && (t.innerHTML = "", t.innerHTML = e);
    }
    function i(e) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("tabIndex", "0");
      });
    }
    function l(e) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("tabIndex", "-1");
      });
    }
    function s(e, t) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("role", t);
      });
    }
    function c(e, t) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("aria-roledescription", t);
      });
    }
    function u(e, t) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("aria-label", t);
      });
    }
    function d(e) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("aria-disabled", !0);
      });
    }
    function p(e) {
      (e = Xc(e)).forEach(function (e) {
        e.setAttribute("aria-disabled", !1);
      });
    }
    function m(e) {
      if (13 === e.keyCode || 32 === e.keyCode) {
        var r = t.params.a11y,
          a = e.target;
        t.pagination && t.pagination.el && (a === t.pagination.el || t.pagination.el.contains(e.target)) && !e.target.matches(sd(t.params.pagination.bulletClass)) || (t.navigation && t.navigation.nextEl && a === t.navigation.nextEl && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? o(r.lastSlideMessage) : o(r.nextSlideMessage)), t.navigation && t.navigation.prevEl && a === t.navigation.prevEl && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? o(r.firstSlideMessage) : o(r.prevSlideMessage)), t.pagination && a.matches(sd(t.params.pagination.bulletClass)) && a.click());
      }
    }
    function f() {
      return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
    }
    function v() {
      return f() && t.params.pagination.clickable;
    }
    var y = function y(e, t, r) {
        i(e), "BUTTON" !== e.tagName && (s(e, "button"), e.addEventListener("keydown", m)), u(e, r), function (e, t) {
          (e = Xc(e)).forEach(function (e) {
            e.setAttribute("aria-controls", t);
          });
        }(e, t);
      },
      g = function g() {
        t.a11y.clicked = !0;
      },
      h = function h() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            t.destroyed || (t.a11y.clicked = !1);
          });
        });
      },
      b = function b(e) {
        if (!t.a11y.clicked) {
          var r = e.target.closest(".".concat(t.params.slideClass, ", swiper-slide"));
          if (r && t.slides.includes(r)) {
            var a = t.slides.indexOf(r) === t.activeIndex,
              n = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(r);
            a || n || e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, t.slideTo(t.slides.indexOf(r), 0));
          }
        }
      },
      N = function N() {
        var e = t.params.a11y;
        e.itemRoleDescriptionMessage && c(t.slides, e.itemRoleDescriptionMessage), e.slideRole && s(t.slides, e.slideRole);
        var r = t.slides.length;
        e.slideLabelMessage && t.slides.forEach(function (a, n) {
          var o = t.params.loop ? parseInt(a.getAttribute("data-swiper-slide-index"), 10) : n;
          u(a, e.slideLabelMessage.replace(/\{\{index\}\}/, o + 1).replace(/\{\{slidesLength\}\}/, r));
        });
      },
      x = function x() {
        var e = t.params.a11y;
        t.el.append(n);
        var r = t.el;
        e.containerRoleDescriptionMessage && c(r, e.containerRoleDescriptionMessage), e.containerMessage && u(r, e.containerMessage);
        var a = t.wrapperEl,
          o = e.id || a.getAttribute("id") || "swiper-wrapper-".concat(function (e) {
            return void 0 === e && (e = 16), "x".repeat(e).replace(/x/g, function () {
              return Math.round(16 * Math.random()).toString(16);
            });
          }(16)),
          i = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
        !function (e, t) {
          (e = Xc(e)).forEach(function (e) {
            e.setAttribute("id", t);
          });
        }(a, o), function (e, t) {
          (e = Xc(e)).forEach(function (e) {
            e.setAttribute("aria-live", t);
          });
        }(a, i), N();
        var l = t.navigation ? t.navigation : {},
          s = l.nextEl,
          d = l.prevEl;
        (s = Xc(s), d = Xc(d), s && s.forEach(function (t) {
          return y(t, o, e.nextSlideMessage);
        }), d && d.forEach(function (t) {
          return y(t, o, e.prevSlideMessage);
        }), v()) && Xc(t.pagination.el).forEach(function (e) {
          e.addEventListener("keydown", m);
        });
        t.el.addEventListener("focus", b, !0), t.el.addEventListener("pointerdown", g, !0), t.el.addEventListener("pointerup", h, !0);
      };
    a("beforeInit", function () {
      (n = Vc("span", t.params.a11y.notificationClass)).setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
    }), a("afterInit", function () {
      t.params.a11y.enabled && x();
    }), a("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function () {
      t.params.a11y.enabled && N();
    }), a("fromEdge toEdge afterInit lock unlock", function () {
      t.params.a11y.enabled && function () {
        if (!t.params.loop && !t.params.rewind && t.navigation) {
          var e = t.navigation,
            r = e.nextEl,
            a = e.prevEl;
          a && (t.isBeginning ? (d(a), l(a)) : (p(a), i(a))), r && (t.isEnd ? (d(r), l(r)) : (p(r), i(r)));
        }
      }();
    }), a("paginationUpdate", function () {
      var e;
      t.params.a11y.enabled && (e = t.params.a11y, f() && t.pagination.bullets.forEach(function (r) {
        t.params.pagination.clickable && (i(r), t.params.pagination.renderBullet || (s(r, "button"), u(r, e.paginationBulletMessage.replace(/\{\{index\}\}/, Yc(r) + 1)))), r.matches(sd(t.params.pagination.bulletActiveClass)) ? r.setAttribute("aria-current", "true") : r.removeAttribute("aria-current");
      }));
    }), a("destroy", function () {
      t.params.a11y.enabled && function () {
        n && n.remove();
        var e = t.navigation ? t.navigation : {},
          r = e.nextEl,
          a = e.prevEl;
        r = Xc(r), a = Xc(a), r && r.forEach(function (e) {
          return e.removeEventListener("keydown", m);
        }), a && a.forEach(function (e) {
          return e.removeEventListener("keydown", m);
        }), v() && Xc(t.pagination.el).forEach(function (e) {
          e.removeEventListener("keydown", m);
        }), t.el.removeEventListener("focus", b, !0), t.el.removeEventListener("pointerdown", g, !0), t.el.removeEventListener("pointerup", h, !0);
      }();
    });
  }, function (e) {
    var t = e.swiper,
      r = e.extendParams,
      a = e.emit,
      n = e.once;
    r({
      freeMode: {
        enabled: !1,
        momentum: !0,
        momentumRatio: 1,
        momentumBounce: !0,
        momentumBounceRatio: 1,
        momentumVelocityRatio: 1,
        sticky: !1,
        minimumVelocity: .02
      }
    }), Object.assign(t, {
      freeMode: {
        onTouchStart: function onTouchStart() {
          if (!t.params.cssMode) {
            var e = t.getTranslate();
            t.setTranslate(e), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({
              currentPos: t.rtl ? t.translate : -t.translate
            });
          }
        },
        onTouchMove: function onTouchMove() {
          if (!t.params.cssMode) {
            var e = t.touchEventsData,
              r = t.touches;
            0 === e.velocities.length && e.velocities.push({
              position: r[t.isHorizontal() ? "startX" : "startY"],
              time: e.touchStartTime
            }), e.velocities.push({
              position: r[t.isHorizontal() ? "currentX" : "currentY"],
              time: Dc()
            });
          }
        },
        onTouchEnd: function onTouchEnd(e) {
          var r = e.currentPos;
          if (!t.params.cssMode) {
            var o = t.params,
              i = t.wrapperEl,
              l = t.rtlTranslate,
              s = t.snapGrid,
              c = t.touchEventsData,
              u = Dc() - c.touchStartTime;
            if (r < -t.minTranslate()) t.slideTo(t.activeIndex);else if (r > -t.maxTranslate()) t.slides.length < s.length ? t.slideTo(s.length - 1) : t.slideTo(t.slides.length - 1);else {
              if (o.freeMode.momentum) {
                if (c.velocities.length > 1) {
                  var d = c.velocities.pop(),
                    p = c.velocities.pop(),
                    m = d.position - p.position,
                    f = d.time - p.time;
                  t.velocity = m / f, t.velocity /= 2, Math.abs(t.velocity) < o.freeMode.minimumVelocity && (t.velocity = 0), (f > 150 || Dc() - d.time > 300) && (t.velocity = 0);
                } else t.velocity = 0;
                t.velocity *= o.freeMode.momentumVelocityRatio, c.velocities.length = 0;
                var v = 1e3 * o.freeMode.momentumRatio,
                  y = t.velocity * v,
                  g = t.translate + y;
                l && (g = -g);
                var h,
                  b,
                  N = !1,
                  x = 20 * Math.abs(t.velocity) * o.freeMode.momentumBounceRatio;
                if (g < t.maxTranslate()) o.freeMode.momentumBounce ? (g + t.maxTranslate() < -x && (g = t.maxTranslate() - x), h = t.maxTranslate(), N = !0, c.allowMomentumBounce = !0) : g = t.maxTranslate(), o.loop && o.centeredSlides && (b = !0);else if (g > t.minTranslate()) o.freeMode.momentumBounce ? (g - t.minTranslate() > x && (g = t.minTranslate() + x), h = t.minTranslate(), N = !0, c.allowMomentumBounce = !0) : g = t.minTranslate(), o.loop && o.centeredSlides && (b = !0);else if (o.freeMode.sticky) {
                  for (var k, w = 0; w < s.length; w += 1) if (s[w] > -g) {
                    k = w;
                    break;
                  }
                  g = -(g = Math.abs(s[k] - g) < Math.abs(s[k - 1] - g) || "next" === t.swipeDirection ? s[k] : s[k - 1]);
                }
                if (b && n("transitionEnd", function () {
                  t.loopFix();
                }), 0 !== t.velocity) {
                  if (v = l ? Math.abs((-g - t.translate) / t.velocity) : Math.abs((g - t.translate) / t.velocity), o.freeMode.sticky) {
                    var _ = Math.abs((l ? -g : g) - t.translate),
                      F = t.slidesSizesGrid[t.activeIndex];
                    v = _ < F ? o.speed : _ < 2 * F ? 1.5 * o.speed : 2.5 * o.speed;
                  }
                } else if (o.freeMode.sticky) return void t.slideToClosest();
                o.freeMode.momentumBounce && N ? (t.updateProgress(h), t.setTransition(v), t.setTranslate(g), t.transitionStart(!0, t.swipeDirection), t.animating = !0, qc(i, function () {
                  t && !t.destroyed && c.allowMomentumBounce && (a("momentumBounce"), t.setTransition(o.speed), setTimeout(function () {
                    t.setTranslate(h), qc(i, function () {
                      t && !t.destroyed && t.transitionEnd();
                    });
                  }, 0));
                })) : t.velocity ? (a("_freeModeNoMomentumRelease"), t.updateProgress(g), t.setTransition(v), t.setTranslate(g), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, qc(i, function () {
                  t && !t.destroyed && t.transitionEnd();
                }))) : t.updateProgress(g), t.updateActiveIndex(), t.updateSlidesClasses();
              } else {
                if (o.freeMode.sticky) return void t.slideToClosest();
                o.freeMode && a("_freeModeNoMomentumRelease");
              }
              (!o.freeMode.momentum || u >= o.longSwipesMs) && (a("_freeModeStaticRelease"), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
            }
          }
        }
      }
    });
  }, function (e) {
    var t = e.swiper,
      r = e.extendParams,
      a = e.on,
      n = e.emit,
      o = Cc(),
      i = Ac();
    function l(e) {
      if (t.enabled) {
        var r = t.rtlTranslate,
          a = e;
        a.originalEvent && (a = a.originalEvent);
        var l = a.keyCode || a.charCode,
          s = t.params.keyboard.pageUpDown,
          c = s && 33 === l,
          u = s && 34 === l,
          d = 37 === l,
          p = 39 === l,
          m = 38 === l,
          f = 40 === l;
        if (!t.allowSlideNext && (t.isHorizontal() && p || t.isVertical() && f || u)) return !1;
        if (!t.allowSlidePrev && (t.isHorizontal() && d || t.isVertical() && m || c)) return !1;
        if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || o.activeElement && o.activeElement.nodeName && ("input" === o.activeElement.nodeName.toLowerCase() || "textarea" === o.activeElement.nodeName.toLowerCase()))) {
          if (t.params.keyboard.onlyInViewport && (c || u || d || p || m || f)) {
            var v = !1;
            if ($c(t.el, ".".concat(t.params.slideClass, ", swiper-slide")).length > 0 && 0 === $c(t.el, ".".concat(t.params.slideActiveClass)).length) return;
            var y = t.el,
              g = y.clientWidth,
              h = y.clientHeight,
              b = i.innerWidth,
              N = i.innerHeight,
              x = Wc(y);
            r && (x.left -= y.scrollLeft);
            for (var k = [[x.left, x.top], [x.left + g, x.top], [x.left, x.top + h], [x.left + g, x.top + h]], w = 0; w < k.length; w += 1) {
              var _ = k[w];
              if (_[0] >= 0 && _[0] <= b && _[1] >= 0 && _[1] <= N) {
                if (0 === _[0] && 0 === _[1]) continue;
                v = !0;
              }
            }
            if (!v) return;
          }
          t.isHorizontal() ? ((c || u || d || p) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), ((u || p) && !r || (c || d) && r) && t.slideNext(), ((c || d) && !r || (u || p) && r) && t.slidePrev()) : ((c || u || m || f) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (u || f) && t.slideNext(), (c || m) && t.slidePrev()), n("keyPress", l);
        }
      }
    }
    function s() {
      t.keyboard.enabled || (o.addEventListener("keydown", l), t.keyboard.enabled = !0);
    }
    function c() {
      t.keyboard.enabled && (o.removeEventListener("keydown", l), t.keyboard.enabled = !1);
    }
    t.keyboard = {
      enabled: !1
    }, r({
      keyboard: {
        enabled: !1,
        onlyInViewport: !0,
        pageUpDown: !0
      }
    }), a("init", function () {
      t.params.keyboard.enabled && s();
    }), a("destroy", function () {
      t.keyboard.enabled && c();
    }), Object.assign(t.keyboard, {
      enable: s,
      disable: c
    });
  }, function (e) {
    var t,
      r = e.swiper,
      a = e.extendParams,
      n = e.on,
      o = e.emit,
      i = Ac();
    a({
      mousewheel: {
        enabled: !1,
        releaseOnEdges: !1,
        invert: !1,
        forceToAxis: !1,
        sensitivity: 1,
        eventsTarget: "container",
        thresholdDelta: null,
        thresholdTime: null,
        noMousewheelClass: "swiper-no-mousewheel"
      }
    }), r.mousewheel = {
      enabled: !1
    };
    var l,
      s = Dc(),
      c = [];
    function u() {
      r.enabled && (r.mouseEntered = !0);
    }
    function d() {
      r.enabled && (r.mouseEntered = !1);
    }
    function p(e) {
      return !(r.params.mousewheel.thresholdDelta && e.delta < r.params.mousewheel.thresholdDelta) && !(r.params.mousewheel.thresholdTime && Dc() - s < r.params.mousewheel.thresholdTime) && (e.delta >= 6 && Dc() - s < 60 || (e.direction < 0 ? r.isEnd && !r.params.loop || r.animating || (r.slideNext(), o("scroll", e.raw)) : r.isBeginning && !r.params.loop || r.animating || (r.slidePrev(), o("scroll", e.raw)), s = new i.Date().getTime(), !1));
    }
    function m(e) {
      var a = e;
      if (r.enabled && !e.target.closest(".".concat(r.params.mousewheel.noMousewheelClass))) {
        var n = r.params.mousewheel;
        r.params.cssMode && a.preventDefault();
        var i = r.el;
        "container" !== r.params.mousewheel.eventsTarget && (i = document.querySelector(r.params.mousewheel.eventsTarget));
        var s = i && i.contains(a.target);
        if (!r.mouseEntered && !s && !n.releaseOnEdges) return !0;
        a.originalEvent && (a = a.originalEvent);
        var u = 0,
          d = r.rtlTranslate ? -1 : 1,
          m = function (e) {
            var t = 0,
              r = 0,
              a = 0,
              n = 0;
            return "detail" in e && (r = e.detail), "wheelDelta" in e && (r = -e.wheelDelta / 120), "wheelDeltaY" in e && (r = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = r, r = 0), a = 10 * t, n = 10 * r, "deltaY" in e && (n = e.deltaY), "deltaX" in e && (a = e.deltaX), e.shiftKey && !a && (a = n, n = 0), (a || n) && e.deltaMode && (1 === e.deltaMode ? (a *= 40, n *= 40) : (a *= 800, n *= 800)), a && !t && (t = a < 1 ? -1 : 1), n && !r && (r = n < 1 ? -1 : 1), {
              spinX: t,
              spinY: r,
              pixelX: a,
              pixelY: n
            };
          }(a);
        if (n.forceToAxis) {
          if (r.isHorizontal()) {
            if (!(Math.abs(m.pixelX) > Math.abs(m.pixelY))) return !0;
            u = -m.pixelX * d;
          } else {
            if (!(Math.abs(m.pixelY) > Math.abs(m.pixelX))) return !0;
            u = -m.pixelY;
          }
        } else u = Math.abs(m.pixelX) > Math.abs(m.pixelY) ? -m.pixelX * d : -m.pixelY;
        if (0 === u) return !0;
        n.invert && (u = -u);
        var f = r.getTranslate() + u * n.sensitivity;
        if (f >= r.minTranslate() && (f = r.minTranslate()), f <= r.maxTranslate() && (f = r.maxTranslate()), (!!r.params.loop || !(f === r.minTranslate() || f === r.maxTranslate())) && r.params.nested && a.stopPropagation(), r.params.freeMode && r.params.freeMode.enabled) {
          var v = {
              time: Dc(),
              delta: Math.abs(u),
              direction: Math.sign(u)
            },
            y = l && v.time < l.time + 500 && v.delta <= l.delta && v.direction === l.direction;
          if (!y) {
            l = void 0;
            var g = r.getTranslate() + u * n.sensitivity,
              h = r.isBeginning,
              b = r.isEnd;
            if (g >= r.minTranslate() && (g = r.minTranslate()), g <= r.maxTranslate() && (g = r.maxTranslate()), r.setTransition(0), r.setTranslate(g), r.updateProgress(), r.updateActiveIndex(), r.updateSlidesClasses(), (!h && r.isBeginning || !b && r.isEnd) && r.updateSlidesClasses(), r.params.loop && r.loopFix({
              direction: v.direction < 0 ? "next" : "prev",
              byMousewheel: !0
            }), r.params.freeMode.sticky) {
              clearTimeout(t), t = void 0, c.length >= 15 && c.shift();
              var N = c.length ? c[c.length - 1] : void 0,
                x = c[0];
              if (c.push(v), N && (v.delta > N.delta || v.direction !== N.direction)) c.splice(0);else if (c.length >= 15 && v.time - x.time < 500 && x.delta - v.delta >= 1 && v.delta <= 6) {
                var k = u > 0 ? .8 : .2;
                l = v, c.splice(0), t = Lc(function () {
                  r.slideToClosest(r.params.speed, !0, void 0, k);
                }, 0);
              }
              t || (t = Lc(function () {
                l = v, c.splice(0), r.slideToClosest(r.params.speed, !0, void 0, .5);
              }, 500));
            }
            if (y || o("scroll", a), r.params.autoplay && r.params.autoplayDisableOnInteraction && r.autoplay.stop(), n.releaseOnEdges && (g === r.minTranslate() || g === r.maxTranslate())) return !0;
          }
        } else {
          var w = {
            time: Dc(),
            delta: Math.abs(u),
            direction: Math.sign(u),
            raw: e
          };
          c.length >= 2 && c.shift();
          var _ = c.length ? c[c.length - 1] : void 0;
          if (c.push(w), _ ? (w.direction !== _.direction || w.delta > _.delta || w.time > _.time + 150) && p(w) : p(w), function (e) {
            var t = r.params.mousewheel;
            if (e.direction < 0) {
              if (r.isEnd && !r.params.loop && t.releaseOnEdges) return !0;
            } else if (r.isBeginning && !r.params.loop && t.releaseOnEdges) return !0;
            return !1;
          }(w)) return !0;
        }
        return a.preventDefault ? a.preventDefault() : a.returnValue = !1, !1;
      }
    }
    function f(e) {
      var t = r.el;
      "container" !== r.params.mousewheel.eventsTarget && (t = document.querySelector(r.params.mousewheel.eventsTarget)), t[e]("mouseenter", u), t[e]("mouseleave", d), t[e]("wheel", m);
    }
    function v() {
      return r.params.cssMode ? (r.wrapperEl.removeEventListener("wheel", m), !0) : !r.mousewheel.enabled && (f("addEventListener"), r.mousewheel.enabled = !0, !0);
    }
    function y() {
      return r.params.cssMode ? (r.wrapperEl.addEventListener(event, m), !0) : !!r.mousewheel.enabled && (f("removeEventListener"), r.mousewheel.enabled = !1, !0);
    }
    n("init", function () {
      !r.params.mousewheel.enabled && r.params.cssMode && y(), r.params.mousewheel.enabled && v();
    }), n("destroy", function () {
      r.params.cssMode && v(), r.mousewheel.enabled && y();
    }), Object.assign(r.mousewheel, {
      enable: v,
      disable: y
    });
  }],
  ud = "280",
  dd = "768";
function pd(e, t, r, a) {
  a(!!r), t(!!e);
}
var md,
  fd = "Carousel-module_cui__carousel__oJU4W",
  vd = "Carousel-module_cui__carousel_controls_fadein__kYu-S",
  yd = {
    anchorTag: "",
    label: "Carousel"
  },
  gd = "280",
  hd = function hd(e) {
    var t = e.overlay,
      r = void 0 === t || t,
      a = e.showPagination,
      n = void 0 === a || a,
      o = e.showControls,
      i = void 0 === o ? "hover" : o,
      l = e.controlSize,
      s = void 0 === l ? "lg" : l,
      c = e.controlButtonType,
      u = void 0 === c ? "tertiary" : c,
      d = e.skipLink,
      p = void 0 === d ? yd : d,
      m = e.showFade,
      f = void 0 === m || m,
      v = e.showFadeLeft,
      y = void 0 === v || v,
      g = e.showFadeRight,
      h = void 0 === g || g,
      b = e.slideTo,
      k = void 0 === b ? 0 : b,
      w = e.itemsDescription,
      _ = void 0 === w ? "" : w,
      F = e.itemSpacing,
      S = void 0 === F ? "4" : F,
      C = e.centerSlides,
      j = (e.initialIndex, e.slideWrapperClasses),
      E = e.cssMode,
      T = void 0 !== E && E,
      O = e.tabbable,
      A = void 0 === O || O,
      M = e.id,
      L = e.role,
      D = void 0 === L ? "group" : L,
      B = e.forcePagination,
      P = e.onItemChange,
      I = e.handleItemImpression,
      z = e.children,
      R = Me(e, x),
      U = Ge(Ra()),
      H = "carousel-".concat(U.current),
      G = Xe(function () {
        return {
          nextElId: "cui__carousel-next-button-".concat(U.current),
          prevElId: "cui__carousel-prev-button-".concat(U.current)
        };
      }, []),
      V = "cui__carousel-pagination-".concat(U.current),
      W = Ge(null),
      K = Le(He(!1), 2),
      Y = K[0],
      $ = K[1],
      q = function (e) {
        var t = e.navBtns,
          r = e.paginationClass,
          a = e.showPagination,
          n = e.forcePagination,
          o = e.itemSpacing,
          i = e.centerSlides,
          l = void 0 === i || i,
          s = e.randStr,
          c = e.cssMode,
          u = e.onItemChange,
          d = e.handleItemImpression,
          p = Ge(null),
          m = Le(He({}), 2),
          f = m[0],
          v = m[1],
          y = Le(He(), 2),
          g = y[0],
          h = y[1],
          b = Le(He(!1), 2),
          x = b[0],
          k = b[1],
          w = Le(He(!1), 2),
          _ = w[0],
          F = w[1],
          S = Le(He(!1), 2),
          C = S[0],
          j = S[1],
          E = Le(He(null), 2),
          T = E[0],
          O = E[1],
          A = ha(function (e) {
            var t = e.isBeginning,
              r = e.isEnd,
              a = e.isLocked;
            pd(t, F, r, k), j(a);
          }, 200);
        function M(e) {
          e.forEach(function (t) {
            return d(t, e);
          });
        }
        var L = c;
        return "false" === c && (L = !1), "true" === c && (L = !0), Ve(function () {
          return function () {
            window && T && (window.clearTimeout(T), A.cancel());
          };
        }, [T]), Ve(function () {
          var e,
            i = (Oe(e = {}, ud, {
              centeredSlides: l,
              centeredSlidesBounds: l,
              freeMode: {
                enabled: !1,
                sticky: !0,
                momentumBounce: !1
              }
            }), Oe(e, dd, {
              centeredSlides: !1,
              centeredSlidesBounds: !1,
              grabCursor: !0,
              freeMode: {
                enabled: !0,
                sticky: !1,
                momentumBounce: !1
              }
            }), e);
          v({
            modules: cd,
            a11y: {
              prevSlideMessage: "Previous item",
              nextSlideMessage: "Next item"
            },
            breakpoints: i,
            navigation: {
              nextEl: "#".concat(t.nextElId),
              prevEl: "#".concat(t.prevElId)
            },
            pagination: a || n ? {
              dynamicBullets: !0,
              clickable: !0,
              el: ".".concat(r)
            } : {
              enabled: !1
            },
            slidesPerView: "auto",
            spaceBetween: o,
            keyboard: {
              enabled: !1,
              onlyInViewport: !0
            },
            mousewheel: {
              eventsTarget: ".cui__carousel.swiper-slide.cui__carousel_".concat(s.current)
            },
            speed: 200,
            focusableElements: "input, select, option, textarea, video, label",
            resizeObserver: !0,
            watchSlidesProgress: !0,
            cssMode: L,
            onSwiper: function onSwiper(e) {
              var t = e.isBeginning,
                r = e.isEnd,
                a = e.isLocked;
              pd(t, F, r, k), j(a), p.current = e;
            },
            onBreakpoint: function onBreakpoint(e) {
              var t = e.currentBreakpoint;
              h(t);
            },
            onSlideChange: function onSlideChange(e) {
              e.isEnd, e.isBeginning;
              var t = e.activeIndex,
                r = e.visibleSlidesIndexes,
                a = void 0 === r ? [] : r;
              e.realIndex, Me(e, N), "function" == typeof u && u(t), "function" == typeof d && a.length && M(a);
            },
            onReachEnd: function onReachEnd() {
              k(!0);
            },
            onReachBeginning: function onReachBeginning() {
              F(!0);
            },
            onFromEdge: function onFromEdge(e) {
              var t = e.isEnd;
              pd(e.isBeginning, F, t, k);
            },
            onResize: A,
            onAfterInit: function onAfterInit(e) {
              j(null == e ? void 0 : e.isLocked);
              var t = setTimeout(function () {
                if (void 0 !== e) {
                  null == e || e.update(), null == e || e.slideTo(0, 200);
                  var t = e.isBeginning,
                    r = e.isEnd,
                    a = e.visibleSlidesIndexes,
                    n = e.isLocked;
                  pd(t, F, r, k), j(n), "function" == typeof d && null != a && a.length && M(a);
                }
              }, 500);
              O(t);
            }
          });
        }, [l, d, u, a, n, r, o, t, c]), {
          config: f,
          swiperInstance: p,
          isEnd: x,
          isBeginning: _,
          breakpoint: g,
          isLocked: C
        };
      }({
        navBtns: G,
        paginationClass: V,
        cssMode: T,
        showPagination: n,
        forcePagination: B,
        itemSpacing: S,
        centerSlides: C,
        randStr: U,
        onItemChange: P,
        handleItemImpression: I
      }),
      J = q.config,
      X = q.breakpoint,
      Z = q.isEnd,
      Q = q.isBeginning,
      ee = q.isLocked,
      te = q.swiperInstance,
      re = {
        showFade: f,
        showFadeLeft: y,
        showFadeRight: h
      };
    We(function () {
      if (te.current) {
        var e = te.current;
        "number" == typeof k && e && e.slideTo(k, 200);
      }
    }, [n, k]), We(function () {
      if (te.current) {
        var e = te.current;
        Y ? e.keyboard.enable() : e.keyboard.disable();
      }
    }, [n, Y]);
    var ae = Ye(function (e) {
        $(!0);
      }, []),
      ne = Ye(function (e) {
        $(!1);
      }, []),
      oe = Ye(function (e) {
        var t;
        "Escape" === e.key && (null === (t = W.current) || void 0 === t ? void 0 : t.firstChild).focus();
      }, [W.current]),
      ie = Xe(function () {
        return Qe.map(z, function (e, t) {
          return dt.exports.jsx(Vu, {
            tabIndex: -1,
            virtualIndex: t,
            onKeyUp: oe,
            role: "group",
            children: e
          });
        });
      }, [z]),
      le = !!Object.entries(J).length;
    return dt.exports.jsx(bd, Te(Te({
      navigation: G,
      overlay: r,
      breakpoint: X,
      showPagination: n,
      showControls: i,
      controlSize: s,
      controlButtonType: u,
      isEnd: Z,
      isBeginning: Q,
      skipLink: p,
      onFocus: ae,
      onBlur: ne,
      itemsDescription: _,
      isLocked: ee,
      tabbable: A,
      forcePagination: B,
      slideWrapperClasses: j,
      paginationClass: V,
      role: D,
      ref: W,
      id: M || H
    }, R), {}, {
      children: le ? dt.exports.jsxs(Gu, Te(Te({}, J), {}, {
        className: "cui__carousel swiper-slide cui__carousel_".concat(U.current, " focus:cui-outline-none"),
        children: [ie, f ? dt.exports.jsxs(dt.exports.Fragment, {
          children: [dt.exports.jsx(id, {
            slot: "container-start",
            className: yt({
              "cui-opacity-0": Q || !re.showFadeLeft,
              "cui-opacity-100": !Q && re.showFadeLeft
            }, "cui-left-0")
          }), dt.exports.jsx(id, {
            slot: "container-end",
            className: yt({
              "cui-opacity-0": Z || !re.showFadeRight,
              "cui-opacity-100": !Z && re.showFadeRight
            }, "cui-right-0"),
            flip: !0
          })]
        }) : null]
      })) : null
    }));
  },
  bd = qe(function (e, t) {
    var r = e.navigation,
      a = r.nextElId,
      n = r.prevElId,
      o = e.overlay,
      i = e.breakpoint,
      l = e.showPagination,
      s = e.showControls,
      c = e.controlSize,
      u = e.controlButtonType,
      d = e.skipLink,
      p = e.isEnd,
      m = e.isBeginning,
      f = e.itemsDescription,
      v = void 0 === f ? "" : f,
      y = e.isLocked,
      g = e.onFocus,
      h = e.onBlur,
      b = e.id,
      N = e.role,
      x = void 0 === N ? "list" : N,
      w = e.className,
      _ = void 0 === w ? "" : w,
      F = e.forcePagination,
      S = e.paginationClass,
      C = e.slideWrapperClasses,
      j = void 0 === C ? "" : C,
      E = e.tabbable,
      T = void 0 === E || E,
      O = e.children,
      A = Me(e, k),
      M = !o && i !== gd && !y,
      L = o || i === gd,
      D = "none" !== s && !y && ("always" === s || M),
      B = l || F,
      P = yt({
        "cui-absolute": L,
        "cui-invisible": i === gd,
        "cui-relative": M,
        "cui-opacity-0 group-hover:cui-opacity-100": "hover" === s && L && !y,
        "cui-opacity-0": "none" === s && L || y
      }, "cui-z-10 cui-transition-opacity cui-duration-200"),
      I = !F && i === gd || !B;
    return dt.exports.jsxs("div", Te(Te({
      className: "".concat(fd, " cui-w-full cui-relative cui-flex cui-flex-col cui-group focus-visible:cui-outline-1 focus-visible:cui-outline-fg-focus focus-visible:cui-outline-offset-2 ").concat(_),
      onFocus: g,
      onBlur: h,
      ref: t,
      tabIndex: T ? 0 : -1,
      id: b,
      role: "region",
      "aria-label": "Carousel ".concat(v ? "for ".concat(v) : "")
    }, A), {}, {
      children: [d ? dt.exports.jsx(od, Te({}, d)) : null, dt.exports.jsxs("div", {
        className: "cui-flex cui-items-center cui-relative",
        children: [dt.exports.jsx("div", {
          className: yt(Oe({
            "cui-ml-2": L,
            "cui-mr-sm": M && !y
          }, vd, D), "cui-left-0 ".concat(P, " cui-transition-all cui-duration-200")),
          tabIndex: -1,
          children: dt.exports.jsx(nd, {
            id: n,
            size: c,
            type: u,
            leftIcon: "ui_chevron-left",
            disabled: m,
            tabIndex: -1,
            "aria-label": "Previous Item Button"
          })
        }), dt.exports.jsx("div", {
          className: "cui-relative cui-overflow-hidden ".concat(j),
          tabIndex: -1,
          role: x,
          children: O
        }), dt.exports.jsx("div", {
          className: yt(Oe({
            "cui-mr-2": L,
            "cui-ml-sm": M && !y
          }, vd, D), "cui-right-0 ".concat(P, " cui-transition-all cui-duration-200")),
          tabIndex: -1,
          children: dt.exports.jsx(nd, {
            id: a,
            size: c,
            type: u,
            disabled: p,
            leftIcon: "ui_chevron-right",
            tabIndex: -1,
            "aria-label": "Next Item Button"
          })
        })]
      }), dt.exports.jsx("div", {
        className: yt({
          "cui-invisible cui-hidden": I
        }, "cui__carousel-pagination-wrapper cui-flex cui-justify-center cui-mt-xs cui-pl-24"),
        tabIndex: B ? 0 : -1,
        children: dt.exports.jsx("div", {
          className: "cui__carousel-pagination ".concat(S),
          tabIndex: B ? 0 : -1,
          "aria-hidden": B ? "false" : "true"
        })
      })]
    }));
  }),
  Nd = "PromoMarketButton-module_test__P-2Ff",
  xd = "cui-w-full cui-bg-status-positive cui-text-fg-inverse cui-border-status-positive",
  kd = "cui-w-full cui-bg-status-negative cui-text-fg-inverse cui-border-status-negative",
  wd = Ke(function (e) {
    var t,
      r = e.isInBetSlip,
      a = void 0 !== r && r,
      n = e.prevState,
      o = Le(He(!1), 2),
      i = o[0],
      l = o[1],
      s = Ge(null),
      c = Ge(null);
    We(function () {
      c.current = Cr.timeline({
        targets: s.current,
        easing: "easeOutExpo",
        duration: 2e3,
        loop: !1,
        autoplay: !1,
        complete: function complete(e) {
          l(!1);
        }
      }), c.current.add({
        opacity: 1,
        duration: 0
      }).add({
        opacity: 0,
        duration: 2e3
      }, "+=2000");
    }, []), We(function () {
      var e;
      n !== a && (l(!0), null === (e = c.current) || void 0 === e || e.restart());
    }, [a, n]);
    var u = {
      isAdded: a,
      isRemoved: !a
    };
    return dt.exports.jsx("div", {
      id: "cui__market-button-notification",
      ref: s,
      className: yt((t = {}, Oe(t, xd, u.isAdded && i), Oe(t, kd, u.isRemoved && i), Oe(t, "cui-pointer-events-none cui-hidden", null === a || !i), t), "cui-select-none cui-font-refrigerator-deluxe cui-absolute cui-inset-0 cui-flex cui-justify-center cui-items-center cui-font-bold cui-text-size-3 cui-z-50"),
      children: u.isAdded ? "ADDED" : "REMOVED"
    });
  }),
  _d = function _d(e) {
    return dt.exports.jsx("svg", Te(Te({
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "current",
      id: "market-btn-lock"
    }, e), {}, {
      children: dt.exports.jsxs("g", {
        strokeWidth: "1",
        fill: "none",
        className: "cui-stroke-fg-moderate",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [dt.exports.jsx("path", {
          d: "M13.5,15.5H2.5a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1h11a1,1,0,0,1,1,1v7A1,1,0,0,1,13.5,15.5Z"
        }), dt.exports.jsx("path", {
          d: "M4.5,6.5V4A3.5,3.5,0,0,1,8,.5H8A3.5,3.5,0,0,1,11.5,4V6.5"
        }), dt.exports.jsx("circle", {
          cx: "8",
          cy: "11",
          r: "1.5",
          className: "cui-stroke-fg-moderate"
        })]
      })
    }));
  },
  Fd = function Fd(e) {
    var t = e.odds,
      r = e.oldOdds,
      a = e.selected,
      n = e.subtitle;
    return dt.exports.jsx("div", {
      className: yt({
        "cui-hidden": !t
      }, "cui-flex cui-flex-row cui-items-center cui-justify-center"),
      children: dt.exports.jsxs("div", {
        className: yt({
          "cui-hidden": !t,
          "cui-text-fg-primary": !a,
          "cui-text-fg-inverse": a
        }, "cui-w-full cui-text-left cui-text-size-5 lg:cui-text-size-8 cui-flex cui-flex-wrap cui-items-center cui-justify-center cui-font-refrigerator-deluxe cui-font-extraBold"),
        children: [dt.exports.jsxs("div", {
          children: [r && dt.exports.jsx("span", {
            className: "cui-line-through cui-font-regular cui-mr-1",
            children: r
          }), dt.exports.jsx("span", {
            className: "",
            children: t
          })]
        }), dt.exports.jsx("span", {
          className: yt({
            "cui-text-fg-moderate": !a,
            "cui-text-fg-inverse": a
          }, "cui-inline-block cui-ml-2 cui-font-refrigerator-deluxe cui-font-regular lg:cui-font-bold cui-text-size-1 lg:cui-text-size-3"),
          children: n
        })]
      })
    });
  },
  Sd = function Sd(e) {
    var t = e.index;
    return dt.exports.jsx("div", {
      className: "cui__market-button-loading-dot-".concat(t, " cui-rounded-[9999px] cui-w-2 cui-h-2 cui-bg-bg-primary")
    });
  },
  Cd = "#A0C7A5",
  jd = "#0F7F4F",
  Ed = "#095431",
  Td = function Td() {
    return Ve(function () {
      return Cr({
        targets: ".cui__market-button-loading-dot-1",
        duration: 800,
        easing: "steps(1)",
        keyframes: [{
          background: Ed
        }, {
          background: jd
        }, {
          background: Cd
        }],
        loop: !0
      }), Cr({
        targets: ".cui__market-button-loading-dot-2",
        duration: 800,
        easing: "steps(1)",
        keyframes: [{
          background: jd
        }, {
          background: Ed
        }, {
          background: jd
        }],
        loop: !0
      }), Cr({
        targets: ".cui__market-button-loading-dot-3",
        duration: 800,
        easing: "steps(1)",
        keyframes: [{
          background: Cd
        }, {
          background: jd
        }, {
          background: Ed
        }],
        loop: !0
      }), function () {
        Cr.remove([".cui__market-button-loading-dot-1", ".cui__market-button-loading-dot-2", ".cui__market-button-loading-dot-3"]);
      };
    }, []), dt.exports.jsx("div", {
      className: "cui-flex cui-gap-1",
      children: [1, 2, 3].map(function (e) {
        return dt.exports.jsx(Sd, {
          index: e
        }, "cui__market-button-loading-dot-".concat(e));
      })
    });
  },
  Od = function Od(e) {
    var t = e.children,
      r = e.variant,
      a = e.odds,
      n = e.isEnabled;
    return dt.exports.jsx("div", {
      className: yt({
        "cui-w-[60px] md:cui-w-[114px]": "fixed" === r && !a,
        "cui-w-[60px] md:cui-w-[114px] lg:cui-w-full lg:cui-max-w-[264px]": "fixed" === r && !!a,
        "cui-w-full": "fluid" === r,
        "cui-pointer-events-none": !n
      }, "cui__market-button-wrapper cui-relative cui-h-12 cui-rounded-[2px] cui-overflow-hidden cui-shadow-xs active:cui-shadow-[0px_0px_0px_#00000000]"),
      children: t
    });
  },
  Ad = function Ad(e) {
    var t = e.children;
    return dt.exports.jsx("div", {
      className: "cui-grid cui-grid-cols-1 cui-items-center cui-justify-center",
      children: t
    });
  },
  Md = "cui-border-1 cui-border-solid cui-bg-bg-layer-one active:cui-bg-bg-primary-minimal hover:cui-bg-bg-primary-minimal cui-text-fg-default cui-border-fg-primary-minimal cui-z-0 cui-bg-[linear-gradient(to_bottom_right,_#F5FDF3_50%,_#EDF8EB_0px)] cui-dark:cui-bg-[linear-gradient(to_bottom_right,_#27352F_50%,_#292A2A_0px)] cui-rounded-2 cui-border-1 lg:cui-border-2",
  Ld = "cui-border-1 cui-border-solid cui-border-fg-primary-strong cui-bg-bg-primary-strong hover:cui-bg-bg-primary cui-text-fg-inverse",
  Dd = "focus:cui-outline-2 focus:cui-outline-highlight-accent",
  Bd = "cui__market-button-disabled cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
  Pd = "cui__market-button-strikethrough cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
  Id = "cui__market-button-placeholder cui-border-solid cui-border-1 cui-bg-bg-layer-one cui-text-fg-moderate cui-fill-fg-moderate cui-border-fg-subtle cui-pointer-events-none",
  zd = "cui__market-button-loading cui-border-1 cui-border-solid cui-bg-bg-layer-one cui-text-fg-default cui-border-fg-primary-minimal cui-pointer-events-none",
  Rd = function Rd(e) {
    var t,
      r = e.id,
      a = e.odds,
      n = void 0 === a ? "" : a,
      o = e.oldOdds,
      i = e.isInBetSlip,
      l = void 0 !== i && i,
      s = e.isLoading,
      c = void 0 !== s && s,
      u = e.isDisabled,
      d = void 0 !== u && u,
      p = e.isStrikethrough,
      m = void 0 !== p && p,
      f = e.isPlaceholder,
      v = void 0 !== f && f,
      y = e.variant,
      g = void 0 === y ? "fixed" : y,
      h = e.subtitle,
      b = void 0 === h ? "" : h,
      N = e.onClick,
      x = Me(e, w),
      k = Le(He(l), 2),
      _ = k[0],
      F = k[1],
      S = Le(He(!1), 2),
      C = S[0],
      j = S[1];
    Ge(null);
    var E = Ge(l),
      T = !(c || d || m || v);
    n.length;
    var O = yt((Oe(t = {}, Md, !_ && T), Oe(t, Dd, C), Oe(t, Pd, m), Oe(t, Id, v), Oe(t, zd, c), Oe(t, Bd, d), Oe(t, "".concat(Ld, " cui-border-fg-moderate"), _ && !m), Oe(t, "cui-rounded-[2px]", !n), Oe(t, "cui-rounded-1", !!n), t), "cui-box-border cui-group cui-border-1 cui-relative cui-transition-all cui-duration-200 cui-w-full cui-h-full cui-p-2 cui-m-0 cui-inline-flex cui-flex-col cui-justify-center cui-items-center cui-relative cui-cursor-pointer cui-select-none"),
      A = function A() {
        j(function (e) {
          return !e;
        });
      };
    return Ve(function () {
      F(l), E.current = l;
    }, [l]), T ? dt.exports.jsxs(dt.exports.Fragment, {
      children: [dt.exports.jsxs(Od, {
        variant: g,
        odds: n,
        isEnabled: T,
        children: [!c && dt.exports.jsx(wd, {
          isInBetSlip: l,
          prevState: E.current
        }), dt.exports.jsx("button", Te(Te({
          id: "market-button-".concat(r),
          type: "button",
          role: "switch",
          "aria-checked": _,
          "aria-disabled": d,
          disabled: d,
          className: O
        }, x), {}, {
          onClick: function onClick(e) {
            return N(e, r);
          },
          onFocus: A,
          onBlur: A,
          children: dt.exports.jsx(dt.exports.Fragment, {
            children: dt.exports.jsx(Ad, {
              children: dt.exports.jsx(Fd, {
                odds: n,
                oldOdds: o,
                selected: _,
                subtitle: b
              })
            })
          })
        }))]
      }), dt.exports.jsx("div", {
        id: "test",
        className: Nd,
        children: dt.exports.jsx("span", {
          className: "test",
          children: "asdasd"
        })
      })]
    }) : dt.exports.jsx(Od, {
      variant: g,
      odds: n,
      isEnabled: T,
      children: dt.exports.jsxs("div", {
        className: O,
        children: [c && dt.exports.jsx(Td, {}), d && !c && dt.exports.jsx(_d, {
          className: "cui-fill-fg-bold"
        }), v && !c && !d && dt.exports.jsx("div", {
          className: "cui-flex cui-flex-col cui-w-full",
          children: dt.exports.jsx("div", {
            className: "cui-w-1/3 cui-h-1px cui-bg-fg-moderate cui-mx-auto"
          })
        }), !m || c || d || v ? null : dt.exports.jsx("div", {
          className: "cui-flex cui-flex-col cui-w-full",
          children: dt.exports.jsx("div", {
            className: "cui-line-through cui-text-fg-moderate cui-mx-auto",
            children: n
          })
        })]
      })
    });
  },
  Ud = [],
  Hd = "ResizeObserver loop completed with undelivered notifications.";
!function (e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
}(md || (md = {}));
var Gd,
  Vd = function Vd(e) {
    return Object.freeze(e);
  },
  Wd = function Wd(e, t) {
    this.inlineSize = e, this.blockSize = t, Vd(this);
  },
  Kd = function () {
    function e(e, t, r, a) {
      return this.x = e, this.y = t, this.width = r, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Vd(this);
    }
    return e.prototype.toJSON = function () {
      var e = this;
      return {
        x: e.x,
        y: e.y,
        top: e.top,
        right: e.right,
        bottom: e.bottom,
        left: e.left,
        width: e.width,
        height: e.height
      };
    }, e.fromRect = function (t) {
      return new e(t.x, t.y, t.width, t.height);
    }, e;
  }(),
  Yd = function Yd(e) {
    return e instanceof SVGElement && "getBBox" in e;
  },
  $d = function $d(e) {
    if (Yd(e)) {
      var t = e.getBBox(),
        r = t.width,
        a = t.height;
      return !r && !a;
    }
    var n = e,
      o = n.offsetWidth,
      i = n.offsetHeight;
    return !(o || i || e.getClientRects().length);
  },
  qd = function qd(e) {
    var t;
    if (e instanceof Element) return !0;
    var r = null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t ? void 0 : t.defaultView;
    return !!(r && e instanceof r.Element);
  },
  Jd = "undefined" != typeof window ? window : {},
  Xd = new WeakMap(),
  Zd = /auto|scroll/,
  Qd = /^tb|vertical/,
  ep = /msie|trident/i.test(Jd.navigator && Jd.navigator.userAgent),
  tp = function tp(e) {
    return parseFloat(e || "0");
  },
  rp = function rp(e, t, r) {
    return void 0 === e && (e = 0), void 0 === t && (t = 0), void 0 === r && (r = !1), new Wd((r ? t : e) || 0, (r ? e : t) || 0);
  },
  ap = Vd({
    devicePixelContentBoxSize: rp(),
    borderBoxSize: rp(),
    contentBoxSize: rp(),
    contentRect: new Kd(0, 0, 0, 0)
  }),
  np = function np(e, t) {
    if (void 0 === t && (t = !1), Xd.has(e) && !t) return Xd.get(e);
    if ($d(e)) return Xd.set(e, ap), ap;
    var r = getComputedStyle(e),
      a = Yd(e) && e.ownerSVGElement && e.getBBox(),
      n = !ep && "border-box" === r.boxSizing,
      o = Qd.test(r.writingMode || ""),
      i = !a && Zd.test(r.overflowY || ""),
      l = !a && Zd.test(r.overflowX || ""),
      s = a ? 0 : tp(r.paddingTop),
      c = a ? 0 : tp(r.paddingRight),
      u = a ? 0 : tp(r.paddingBottom),
      d = a ? 0 : tp(r.paddingLeft),
      p = a ? 0 : tp(r.borderTopWidth),
      m = a ? 0 : tp(r.borderRightWidth),
      f = a ? 0 : tp(r.borderBottomWidth),
      v = d + c,
      y = s + u,
      g = (a ? 0 : tp(r.borderLeftWidth)) + m,
      h = p + f,
      b = l ? e.offsetHeight - h - e.clientHeight : 0,
      N = i ? e.offsetWidth - g - e.clientWidth : 0,
      x = n ? v + g : 0,
      k = n ? y + h : 0,
      w = a ? a.width : tp(r.width) - x - N,
      _ = a ? a.height : tp(r.height) - k - b,
      F = w + v + N + g,
      S = _ + y + b + h,
      C = Vd({
        devicePixelContentBoxSize: rp(Math.round(w * devicePixelRatio), Math.round(_ * devicePixelRatio), o),
        borderBoxSize: rp(F, S, o),
        contentBoxSize: rp(w, _, o),
        contentRect: new Kd(d, s, w, _)
      });
    return Xd.set(e, C), C;
  },
  op = function op(e, t, r) {
    var a = np(e, r),
      n = a.borderBoxSize,
      o = a.contentBoxSize,
      i = a.devicePixelContentBoxSize;
    switch (t) {
      case md.DEVICE_PIXEL_CONTENT_BOX:
        return i;
      case md.BORDER_BOX:
        return n;
      default:
        return o;
    }
  },
  ip = function ip(e) {
    var t = np(e);
    this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = Vd([t.borderBoxSize]), this.contentBoxSize = Vd([t.contentBoxSize]), this.devicePixelContentBoxSize = Vd([t.devicePixelContentBoxSize]);
  },
  lp = function lp(e) {
    if ($d(e)) return 1 / 0;
    for (var t = 0, r = e.parentNode; r;) t += 1, r = r.parentNode;
    return t;
  },
  sp = function sp() {
    var e = 1 / 0,
      t = [];
    Ud.forEach(function (r) {
      if (0 !== r.activeTargets.length) {
        var a = [];
        r.activeTargets.forEach(function (t) {
          var r = new ip(t.target),
            n = lp(t.target);
          a.push(r), t.lastReportedSize = op(t.target, t.observedBox), n < e && (e = n);
        }), t.push(function () {
          r.callback.call(r.observer, a, r.observer);
        }), r.activeTargets.splice(0, r.activeTargets.length);
      }
    });
    for (var r = 0, a = t; r < a.length; r++) {
      (0, a[r])();
    }
    return e;
  },
  cp = function cp(e) {
    Ud.forEach(function (t) {
      t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (r) {
        r.isActive() && (lp(r.target) > e ? t.activeTargets.push(r) : t.skippedTargets.push(r));
      });
    });
  },
  up = function up() {
    var e = 0;
    for (cp(e); Ud.some(function (e) {
      return e.activeTargets.length > 0;
    });) e = sp(), cp(e);
    return Ud.some(function (e) {
      return e.skippedTargets.length > 0;
    }) && function () {
      var e;
      "function" == typeof ErrorEvent ? e = new ErrorEvent("error", {
        message: Hd
      }) : ((e = document.createEvent("Event")).initEvent("error", !1, !1), e.message = Hd), window.dispatchEvent(e);
    }(), e > 0;
  },
  dp = [],
  pp = function pp(e) {
    if (!Gd) {
      var t = 0,
        r = document.createTextNode("");
      new MutationObserver(function () {
        return dp.splice(0).forEach(function (e) {
          return e();
        });
      }).observe(r, {
        characterData: !0
      }), Gd = function Gd() {
        r.textContent = "".concat(t ? t-- : t++);
      };
    }
    dp.push(e), Gd();
  },
  mp = 0,
  fp = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
  },
  vp = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
  yp = function yp(e) {
    return void 0 === e && (e = 0), Date.now() + e;
  },
  gp = !1,
  hp = new (function () {
    function e() {
      var e = this;
      this.stopped = !0, this.listener = function () {
        return e.schedule();
      };
    }
    return e.prototype.run = function (e) {
      var t = this;
      if (void 0 === e && (e = 250), !gp) {
        gp = !0;
        var r,
          a = yp(e);
        r = function r() {
          var r = !1;
          try {
            r = up();
          } finally {
            if (gp = !1, e = a - yp(), !mp) return;
            r ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
          }
        }, pp(function () {
          requestAnimationFrame(r);
        });
      }
    }, e.prototype.schedule = function () {
      this.stop(), this.run();
    }, e.prototype.observe = function () {
      var e = this,
        t = function t() {
          return e.observer && e.observer.observe(document.body, fp);
        };
      document.body ? t() : Jd.addEventListener("DOMContentLoaded", t);
    }, e.prototype.start = function () {
      var e = this;
      this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), vp.forEach(function (t) {
        return Jd.addEventListener(t, e.listener, !0);
      }));
    }, e.prototype.stop = function () {
      var e = this;
      this.stopped || (this.observer && this.observer.disconnect(), vp.forEach(function (t) {
        return Jd.removeEventListener(t, e.listener, !0);
      }), this.stopped = !0);
    }, e;
  }())(),
  bp = function bp(e) {
    !mp && e > 0 && hp.start(), !(mp += e) && hp.stop();
  },
  Np = function () {
    function e(e, t) {
      this.target = e, this.observedBox = t || md.CONTENT_BOX, this.lastReportedSize = {
        inlineSize: 0,
        blockSize: 0
      };
    }
    return e.prototype.isActive = function () {
      var e,
        t = op(this.target, this.observedBox, !0);
      return e = this.target, Yd(e) || function (e) {
        switch (e.tagName) {
          case "INPUT":
            if ("image" !== e.type) break;
          case "VIDEO":
          case "AUDIO":
          case "EMBED":
          case "OBJECT":
          case "CANVAS":
          case "IFRAME":
          case "IMG":
            return !0;
        }
        return !1;
      }(e) || "inline" !== getComputedStyle(e).display || (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
    }, e;
  }(),
  xp = function xp(e, t) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
  },
  kp = new WeakMap(),
  wp = function wp(e, t) {
    for (var r = 0; r < e.length; r += 1) if (e[r].target === t) return r;
    return -1;
  },
  _p = function () {
    function e() {}
    return e.connect = function (e, t) {
      var r = new xp(e, t);
      kp.set(e, r);
    }, e.observe = function (e, t, r) {
      var a = kp.get(e),
        n = 0 === a.observationTargets.length;
      wp(a.observationTargets, t) < 0 && (n && Ud.push(a), a.observationTargets.push(new Np(t, r && r.box)), bp(1), hp.schedule());
    }, e.unobserve = function (e, t) {
      var r = kp.get(e),
        a = wp(r.observationTargets, t),
        n = 1 === r.observationTargets.length;
      a >= 0 && (n && Ud.splice(Ud.indexOf(r), 1), r.observationTargets.splice(a, 1), bp(-1));
    }, e.disconnect = function (e) {
      var t = this,
        r = kp.get(e);
      r.observationTargets.slice().forEach(function (r) {
        return t.unobserve(e, r.target);
      }), r.activeTargets.splice(0, r.activeTargets.length);
    }, e;
  }(),
  Fp = function () {
    function e(e) {
      if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
      if ("function" != typeof e) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
      _p.connect(this, e);
    }
    return e.prototype.observe = function (e, t) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!qd(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
      _p.observe(this, e, t);
    }, e.prototype.unobserve = function (e) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!qd(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
      _p.unobserve(this, e);
    }, e.prototype.disconnect = function () {
      _p.disconnect(this);
    }, e.toString = function () {
      return "function ResizeObserver () { [polyfill code] }";
    }, e;
  }(),
  Sp = Ue["undefined" != typeof document && void 0 !== document.createElement ? "useLayoutEffect" : "useEffect"];
function Cp() {}
var jp,
  Ep = "undefined" != typeof window && "ResizeObserver" in window ? window.ResizeObserver : Fp;
function Tp(e, t) {
  var r,
    a,
    n,
    o,
    i = jp || (r = 0, a = [], n = new Map(), o = new Ep(function (e, t) {
      a = a.concat(e), r || window.requestAnimationFrame(function () {
        for (var e = new Set(), o = function o(r) {
            if (e.has(a[r].target)) return "continue";
            e.add(a[r].target);
            var o = n.get(a[r].target);
            null == o || o.forEach(function (e) {
              return e(a[r], t);
            });
          }, i = 0; i < a.length; i++) o(i);
        a = [], r = 0;
      }), r = 1;
    }), jp = {
      observer: o,
      subscribe: function subscribe(e, t) {
        var r;
        o.observe(e);
        var a = null !== (r = n.get(e)) && void 0 !== r ? r : [];
        a.push(t), n.set(e, a);
      },
      unsubscribe: function unsubscribe(e, t) {
        var r,
          a = null !== (r = n.get(e)) && void 0 !== r ? r : [];
        if (1 === a.length) return o.unobserve(e), void n.delete(e);
        var i = a.indexOf(t);
        -1 !== i && a.splice(i, 1), n.set(e, a);
      }
    }),
    l = Ga(t);
  return Sp(function () {
    function t(e, t) {
      r || l.current(e, t);
    }
    var r = 0,
      a = e && "current" in e ? e.current : e;
    return a ? (i.subscribe(a, t), function () {
      r = 1, i.unsubscribe(a, t);
    }) : Cp;
  }, [e, i, l]), i.observer;
}
var Op = "Score-module_cui__score-xs__GbbYJ",
  Ap = "Score-module_cui__score-sm__NGy8z",
  Mp = "Score-module_cui__score-md__WKnY9",
  Lp = "Score-module_cui__score-lg__7VwGj",
  Dp = "Score-module_cui__score-xl__Gu0Kn",
  Bp = "Score-module_cui__score-2xl__aDuXm",
  Pp = "Score-module_cui__score-3xl__VG3wV",
  Ip = "Score-module_cui__score-slide-down-animation__GTqT6",
  zp = "Score-module_cui__score-slide-down-from-base-animation__vFxBh",
  Rp = !0,
  Up = function Up(e) {
    var t,
      r = e.value,
      a = e.isNew,
      n = e.showAnimation,
      o = Ra();
    return dt.exports.jsx("div", {
      className: yt((t = {}, Oe(t, "cui-z-[1] ".concat(Ip), a && n), Oe(t, zp, !a && n), t), "cui-relative cui-mx-auto"),
      children: r
    }, "cui__score-".concat(o));
  },
  Hp = ["xs", "sm", "md"],
  Gp = ["lg", "xl"],
  Vp = ["2xl", "3xl"],
  Wp = {
    "2xs": {
      height: 12,
      width: 12
    },
    xs: {
      height: 16,
      width: 16
    },
    sm: {
      height: 20,
      width: 18
    },
    md: {
      height: 24,
      width: 20
    },
    lg: {
      height: 32,
      width: 26
    },
    xl: {
      height: 40,
      width: 36
    },
    "2xl": {
      height: 52,
      width: 52
    },
    "3xl": {
      height: 68,
      width: 66
    }
  },
  Kp = function Kp(e) {
    var t,
      r,
      a = e.children,
      n = e.scoreLength,
      o = void 0 === n ? 1 : n,
      i = e.size,
      l = void 0 === i ? "xs" : i,
      s = e.variant,
      c = e.className;
    return dt.exports.jsx("span", {
      className: null === (t = yt((r = {
        "cui-px-2px": o > 2 && Hp.includes(l),
        "cui-px-2xs": o > 2 && Gp.includes(l),
        "cui-px-xs": o > 2 && Vp.includes(l)
      }, Oe(r, "".concat(Op, " cui-h-4 cui-min-w-[16px] display-xs-bold cui-rounded-2px"), "xs" === l), Oe(r, "".concat(Ap, " cui-h-5 cui-min-w-[18px] display-sm-bold cui-rounded-2px"), "sm" === l), Oe(r, "".concat(Mp, " cui-h-6 cui-min-w-[20px] display-md-bold cui-rounded-2px"), "md" === l), Oe(r, "".concat(Lp, " cui-h-7 cui-min-w-[26px] display-lg-bold cui-rounded-2px cui-px-2xs"), "lg" === l), Oe(r, "".concat(Dp, " cui-h-10 cui-min-w-[36px] display-xl-bold cui-rounded-2px cui-px-2xs"), "xl" === l), Oe(r, "".concat(Bp, " cui-h-13 cui-min-w-[52px] display-2xl-bold cui-rounded-sm cui-px-xs"), "2xl" === l), Oe(r, "".concat(Pp, " cui-h-17 cui-min-w-[66px] display-3xl-bold cui-rounded-sm cui-px-xs"), "3xl" === l), Oe(r, "cui-bg-highlight-accent-minimal cui-border-highlight-accent-subtle cui-text-highlight-accent", "default" === s), Oe(r, "cui-bg-bg-default cui-border-bg-default cui-text-fg-moderate", "black" === s), r), "cui-relative cui-inline-flex cui-flex-col cui-transition-all cui-duration-300 cui-overflow-hidden cui-border-1 cui-border-solid cui-box-border cui-pb-4 ".concat(c || ""))) || void 0 === t ? void 0 : t.trim(),
      children: a
    });
  },
  Yp = function Yp(e) {
    var t = e.score,
      r = void 0 === t ? 0 : t,
      a = e.showAnimation,
      n = void 0 === a || a,
      o = e.skeleton,
      i = e.size,
      l = void 0 === i ? "xs" : i,
      s = e.variant,
      c = void 0 === s ? "default" : s,
      u = e.className,
      d = e.children;
    if ("string" != typeof r && "number" != typeof r && !d) return null;
    if (o) return dt.exports.jsx(Nc, {
      width: Wp[l].height,
      height: Wp[l].width,
      rounded: "sm",
      className: "cui-mt-1"
    });
    var p = r && "string" == typeof r && "ad" !== r.toLowerCase() ? +r : r,
      m = Ge(p);
    Ve(function () {
      Rp = !1;
    }, []), Ve(function () {
      m.current = p;
    }, [r]);
    var f = !Rp && n && m.current !== p;
    return dt.exports.jsxs(Kp, {
      scoreLength: String(p).length,
      size: l,
      variant: c,
      className: u,
      children: [f ? dt.exports.jsx(Up, {
        value: p,
        isNew: !0,
        showAnimation: f
      }) : null, dt.exports.jsx(Up, {
        value: n ? m.current : p,
        isNew: !1,
        showAnimation: f
      })]
    });
  },
  $p = function $p(e) {
    var t = e.score,
      r = void 0 === t ? 0 : t,
      a = e.sport,
      n = (e.variant, Me(e, _));
    return null == r ? null : "object" === ze(r) && a && "tennis" === a ? dt.exports.jsxs("div", {
      className: "cui-flex cui-gap-2xs",
      children: [dt.exports.jsx(Yp, Te({
        score: r.set,
        variant: "black",
        className: "!cui-font-regular"
      }, n)), dt.exports.jsx(Yp, Te({
        score: r.game,
        className: "!cui-font-semiBold",
        variant: "black"
      }, n)), dt.exports.jsx(Yp, Te({
        score: r.points
      }, n))]
    }) : "object" === r && "tennis" !== a ? null : dt.exports.jsx(Yp, Te({}, e));
  },
  qp = function qp(e) {
    var t = e.inverse,
      r = e.iconSize;
    return on(r), dt.exports.jsxs("div", {
      className: "cui-flex cui-items-center",
      children: [dt.exports.jsx(Nc, {
        width: 24,
        minWidth: 24,
        height: 24,
        className: "".concat(t ? "cui-ml-2 cui-order-last" : "cui-mr-2")
      }), dt.exports.jsx(Nc, {
        width: 86,
        height: 16
      })]
    });
  },
  Jp = function Jp(e) {
    var t,
      r,
      a,
      n,
      o,
      i,
      l,
      s = e.icon,
      c = e.country,
      u = e.displayName,
      d = e.force,
      p = void 0 === d ? null : d,
      m = e.team,
      f = void 0 === m ? null : m,
      v = (e.usePreferredName, e.sport),
      y = void 0 === v ? "basketball" : v,
      g = e.iconSize,
      h = e.inverse,
      b = void 0 !== h && h,
      N = (e.home, e.possession),
      x = void 0 !== N && N,
      k = e.rank,
      w = e.score,
      _ = (e.groupBy, e.description),
      S = void 0 === _ ? "" : _,
      C = e.useAvatar,
      j = void 0 !== C && C,
      E = e.avatar,
      T = e.showAnimation,
      O = void 0 !== T && T,
      A = e.showIcon,
      M = void 0 === A || A,
      L = e.center,
      D = void 0 !== L && L,
      B = e.textSize,
      P = void 0 === B ? "heading-md" : B,
      I = e.skeleton,
      z = void 0 !== I && I,
      R = e.tabbable,
      U = void 0 === R || R,
      H = (e.hasPlayerName, e.breakpoints),
      G = void 0 === H ? {
        abbr: 140,
        full: 240
      } : H,
      V = e.compact,
      W = void 0 !== V && V,
      K = e.lineClamp,
      Y = void 0 === K ? 2 : K,
      $ = e.mode,
      q = void 0 === $ ? "light" : $,
      J = e.className,
      X = Me(e, F);
    if (z) return dt.exports.jsx(qp, {
      inverse: b,
      iconSize: g
    });
    var Z = !(!window || !window.CSS) && (null === (t = CSS) || void 0 === t ? void 0 : t.supports("container-type", "inline-size")),
      Q = {
        name: "",
        city: "",
        abbreviation: "",
        shortName: "",
        nickName: "",
        league: ""
      },
      ee = /\(W\)/gi,
      te = "string" == typeof f && ee.test(f),
      re = !!f,
      ae = !!u,
      ne = !!c,
      oe = re ? f.trim() : "";
    te && (oe = null == f ? void 0 : f.replace(ee, "").trim()), re && oe && (Q = Ss(oe) || Q);
    var ie = !(null === (r = Q) || void 0 === r || !r.name),
      le = "countries" === Q.league,
      se = u;
    !re || ie || ae || (se = oe);
    var ce = Ps.includes(null === (a = oe) || void 0 === a ? void 0 : a.toLowerCase()),
      ue = "xl";
    c && !g && (ue = "lg"), g && (ue = g);
    var de,
      pe = {
        name: "",
        size: ue,
        sport: y,
        mode: q
      };
    if (ie) "monaco" === oe.toLowerCase() && "soccer" !== y ? pe.name = "monaco" : pe.name = null === (de = Q) || void 0 === de ? void 0 : de.name;else if (ne) {
      var me = c.length <= 3 ? Ss("countries-".concat(c)) : Ss(c);
      pe.name = me ? me.name : c;
    } else s ? pe.name = s : Ps.includes(null === (n = oe) || void 0 === n ? void 0 : n.toLowerCase()) && (pe.name = "icon_ui_neutral-ban");
    var fe,
      ve = j && (re && ie || !!s || !!c || ce) ? dt.exports.jsx(Rs, Te({
        src: E && (null == E ? void 0 : E.src) || null,
        team: oe,
        icon: s,
        country: c,
        isCountry: le,
        size: E && (null == E ? void 0 : E.size) || "2xl",
        mode: q
      }, E)) : null,
      ye = [rs(pe), Ls(pe)],
      ge = ye[0],
      he = ye[1],
      be = ge && ne ? ge : dt.exports.jsx(rs, Te(Te({}, pe), {}, {
        name: "flag_placeholder"
      }));
    fe = ne ? be : he || ge;
    var Ne = j ? ve : fe,
      xe = Le(He(null), 2),
      ke = xe[0],
      we = xe[1],
      _e = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 250;
        if (arguments.length > 2 ? arguments[2] : void 0) return null;
        var r = Le(He(), 2),
          a = r[0],
          n = r[1],
          o = ha(function (e) {
            var t = e.contentRect;
            n(t);
          }, t);
        return We(function () {
          return e && n(e.getBoundingClientRect()), function () {
            o.cancel();
          };
        }, [e]), Tp(e, o), {
          width: (null == a ? void 0 : a.width) || null,
          height: (null == a ? void 0 : a.height) || null
        };
      }(ke, 100, Z) || {
        width: "auto",
        height: "auto"
      },
      Fe = _e.width,
      Se = (_e.height, ("string" == typeof w || "number" == typeof w || "object" === ze(w)) && null != w),
      Ce = "".concat(null === (o = Q) || void 0 === o ? void 0 : o.name, ", ").concat(S, ", ").concat(x ? "has possession, " : "", " ").concat(Se ? "score of ".concat(w, " ").concat(null !== (i = Q) && void 0 !== i && i.league && "mlb" === (null === (l = Q) || void 0 === l ? void 0 : l.league) ? "runs" : "points") : "", " "),
      je = M && Ne && ("soccer" !== y || "soccer" === y && le);
    return dt.exports.jsxs("div", Te(Te({
      className: "cui__competitor_wrapper cui-relative cui-w-full cui-inline-flex ".concat(J || "").trim(),
      "aria-label": Ce,
      tabIndex: U ? 0 : -1
    }, X), {}, {
      children: [dt.exports.jsx("div", {
        className: yt({
          "cui-justify-center": D,
          "cui-justify-end": b
        }, "cui-w-full cui-flex-grow cui-flex cui-items-center cui-relative"),
        ref: we,
        children: dt.exports.jsxs("div", {
          className: yt({
            "cui-@container": Z,
            "cui-flex-row cui-w-[calc(100%-16px)] cui-items-center": !D,
            "cui-w-full cui-justify-center cui-items-center": D,
            "cui-flex cui-flex-row-reverse": b,
            "cui-flex": !b
          }),
          children: [je ? dt.exports.jsx("div", {
            className: yt({
              "cui-pr-xs": !b,
              "cui-pl-xs": b
            }, "cui-flex"),
            children: Ne
          }) : null, dt.exports.jsxs("div", {
            className: "cui-flex cui-flex-col",
            children: [dt.exports.jsx(Zp, {
              displayName: se,
              teamInfo: Q,
              force: p,
              width: Fe,
              rank: k,
              textSize: P,
              inverse: b,
              breakpoints: G,
              hasContainerQueries: Z,
              isWomens: te,
              lineClamp: Y
            }), S ? dt.exports.jsx(fn, {
              size: "xs",
              className: yt({
                "cui-text-right": b
              }, "cui-m-0 -cui-mt-1 cui-line-clamp-1"),
              children: S
            }) : null]
          }), W ? dt.exports.jsx(em, {
            className: "cui-order-first",
            score: w,
            compact: W,
            possession: x,
            showAnimation: O,
            inverse: b,
            sport: y
          }) : null]
        })
      }), W ? null : dt.exports.jsx(em, {
        score: w,
        compact: W,
        possession: x,
        showAnimation: O,
        inverse: b,
        sport: y
      })]
    }));
  },
  Xp = {
    1: "cui-line-clamp-1",
    2: "cui-line-clamp-2",
    3: "cui-line-clamp-3",
    4: "cui-line-clamp-4"
  },
  Zp = function Zp(e) {
    var t = e.displayName,
      r = e.teamInfo,
      a = e.force,
      n = e.rank,
      o = e.width,
      i = e.textSize,
      l = e.inverse,
      s = e.breakpoints,
      c = e.hasContainerQueries,
      u = e.isWomens,
      d = e.lineClamp,
      p = r.name,
      m = r.abbreviation,
      f = r.shortName,
      v = r.city,
      y = r.nickName,
      g = r.league,
      h = "string" == typeof t ? !!t : !(!Array.isArray(t) || !t.length),
      b = Array.isArray(t) ? t.reduce(function (e, t, r) {
        var a = t.split(" ").join(" ");
        return 0 === r ? e = "".concat(a).concat(" ", "/") : e += " ".concat(a);
      }, "") : t,
      N = "";
    d && d >= 1 && d <= 4 || (N = ""), "number" == typeof d && d in Xp && (N = Xp[d]);
    var x = "cui-text-fg-default ".concat(N, " ").concat(i),
      k = f;
    if (!c && "number" == typeof o && (o && o > s.full && (k = "".concat(v, " ").concat(y)), o && o < s.abbr && (k = m), "college" === g && (k = v), a)) switch (a) {
      case "abbr":
      case "abbreviation":
        k = m;
        break;
      case "shortname":
        k = f;
        break;
      case "fullname":
        k = p;
        break;
      case "city":
        k = v;
        break;
      case "nickname":
        k = y;
    }
    var w = {
        abbr: m,
        abbreviation: m,
        city: v,
        nickname: y,
        shortname: f,
        fullname: p
      },
      _ = "college" === g || "soccer" === g;
    if (h) return dt.exports.jsxs("div", {
      className: "cui-flex cui-items-center cui-text-fg-default cui-gap-1",
      children: [n ? dt.exports.jsx(Qp, {
        inverse: l,
        rank: n
      }) : null, dt.exports.jsx("div", {
        className: "cui-flex-col cui-text-fg-default cui-w-full",
        children: dt.exports.jsx("div", {
          className: "cui-w-auto ".concat(N, " cui-text-ellipsis ").concat(i),
          children: Array.isArray(t) ? b : t
        })
      })]
    });
    if (r) {
      var F = u ? "(W)" : null;
      return dt.exports.jsxs("div", {
        className: "cui-flex cui-items-center cui-text-fg-default cui-gap-1",
        children: [n ? dt.exports.jsx(Qp, {
          inverse: l,
          rank: n
        }) : null, dt.exports.jsxs("div", {
          children: [c ? null : dt.exports.jsxs("span", {
            className: "".concat(x),
            children: [k, " ", F]
          }), !c || _ || a ? null : dt.exports.jsxs(dt.exports.Fragment, {
            children: [dt.exports.jsxs("span", {
              className: "".concat(x, " cui-block @[100px]:cui-hidden"),
              children: [m, " ", F]
            }), dt.exports.jsxs("span", {
              className: "".concat(x, " cui-hidden @[100px]:cui-block @[240px]:cui-hidden"),
              children: [f, " ", F]
            }), dt.exports.jsxs("span", {
              className: "".concat(x, " cui-hidden @[240px]:cui-block"),
              children: [v, " ", "countries" !== g ? y : null, " ", F]
            })]
          }), c && !a && _ ? dt.exports.jsxs("span", {
            className: "cui-text-fg-default ".concat(N, " ").concat(i),
            children: ["soccer" === g ? f : v, " ", F]
          }) : null, a && a in w ? dt.exports.jsxs("span", {
            className: "cui-text-fg-default ".concat(N, " ").concat(i),
            children: [w[a], " ", F]
          }) : null]
        })]
      });
    }
    return null;
  },
  Qp = function Qp(e) {
    var t = e.inverse,
      r = e.rank;
    return dt.exports.jsx(fn, {
      size: "xs-bold",
      className: yt({
        "cui-order-last cui-m-0": Boolean(t),
        "cui-order-first cui-m-0": !Boolean(t)
      }, "cui-min-w-[8px]"),
      color: "fg-moderate",
      children: r
    });
  },
  em = function em(e) {
    var t = e.score,
      r = e.inverse,
      a = e.showAnimation,
      n = e.compact,
      o = e.sport,
      i = e.possession,
      l = (e.className, ("string" == typeof t || "number" == typeof t || "object" === ze(t)) && null != t);
    return dt.exports.jsxs(dt.exports.Fragment, {
      children: [l ? dt.exports.jsx("div", {
        className: yt({
          "cui-mr-2 cui-ml-1 md:cui-mr-4 md:cui-ml-2px": r,
          "-cui-order-2 cui-flex-grow": !n && r,
          "cui-ml-2 cui-mr-1 md:cui-ml-4 md:cui-mr-2px": !r
        }, "cui-flex cui-items-center"),
        children: dt.exports.jsx($p, {
          score: t,
          showAnimation: a,
          sport: o
        })
      }) : null, dt.exports.jsx("div", {
        className: yt({
          "cui-opacity-0": !i,
          "cui-opacity-100": i,
          "-cui-ml-1": !r,
          "cui-order-first": r,
          "cui-ml-1": !r && !l,
          "cui-order-last": r && n
        }, "cui-flex cui-items-center cui-transition-opacity cui-duration-200 cui-select-none"),
        children: dt.exports.jsx(rs, {
          name: "icon_ui_triangle-sm-right",
          className: yt({
            "cui-rotate-180": !r
          }),
          size: "md",
          color: "highlight-accent"
        })
      })]
    });
  },
  tm = function tm() {
    return dt.exports.jsx("hr", {
      className: "cui-w-6 cui-h-1px cui-border-0 cui-bg-fg-moderate cui-my-xs cui-block"
    });
  },
  rm = {
    outlined: {
      wrapper: "cui-rounded-2px cui-border-1 cui-border-solid cui-border-fg-moderate",
      base: "cui-bg-bg-layer-two cui-border-0 cui-border-solid cui-border-fg-moderate",
      horizontal: "cui-border-r-1",
      vertical: "cui-border-b-1"
    },
    divider: {
      wrapper: "cui-rounded-2px cui-border-1 cui-border-solid cui-border-neutrals-transparent",
      base: "cui-border-0 cui-border-solid cui-border-fg-moderate",
      horizontal: "cui-border-r-1",
      vertical: "cui-border-b-1"
    }
  },
  am = function am(e) {
    var t = e.date,
      r = e.orientation,
      a = void 0 === r ? "horizontal" : r,
      n = e.variant,
      o = void 0 === n ? "divider" : n,
      i = Me(e, S),
      l = tc(t),
      s = "horizontal" === a;
    return dt.exports.jsxs("div", Te(Te({
      className: yt({
        "cui-flex-row": s,
        "cui-flex-col": !s
      }, "".concat(rm[o].wrapper, " cui-inline-flex cui-items-center cui-box-border"))
    }, i), {}, {
      children: [dt.exports.jsx(yn, {
        size: "xs",
        color: "fg-moderate",
        className: yt([rm[o].base, rm[o][a]], "cui-text-center cui-w-full cui-px-2"),
        children: l.isValid() ? l.format("ddd") : dt.exports.jsx(tm, {})
      }), dt.exports.jsx(yn, {
        size: "xs",
        color: "fg-moderate",
        className: "cui-px-2 cui-text-center cui-w-full cui-whitespace-nowrap",
        children: l.isValid() ? l.format("h:mm A") : dt.exports.jsx(tm, {})
      })]
    }));
  },
  nm = function nm() {
    return dt.exports.jsxs("div", {
      className: "cui-flex cui-w-auto cui-py-xs cui-px-md cui-justify-between",
      children: [dt.exports.jsxs("div", {
        className: "cui-flex cui-flex-col cui-w-1/2 cui-gap-xs",
        children: [dt.exports.jsxs("div", {
          className: "cui-flex cui-items-center cui-gap-sm",
          children: [dt.exports.jsx(Nc, {
            width: 24,
            height: 24,
            rounded: "full"
          }), dt.exports.jsx(Nc, {
            width: 60,
            height: 24
          })]
        }), dt.exports.jsxs("div", {
          className: "cui-flex cui-items-center cui-gap-sm",
          children: [dt.exports.jsx(Nc, {
            width: 24,
            height: 24,
            rounded: "full"
          }), dt.exports.jsx(Nc, {
            width: 60,
            height: 24
          })]
        })]
      }), dt.exports.jsxs("div", {
        className: "cui-flex cui-gap-sm",
        children: [dt.exports.jsx("div", {
          className: "cui-flex-col cui-flex cui-items-end cui-justify-center cui-gap-sm",
          children: dt.exports.jsx(Nc, {
            width: 96,
            height: 24
          })
        }), dt.exports.jsx("div", {
          className: "cui-flex-col cui-flex cui-items-center cui-justify-center cui-gap-sm",
          children: dt.exports.jsx(Nc, {
            width: 96,
            height: 48
          })
        })]
      })]
    });
  },
  om = function om() {
    return dt.exports.jsxs("div", {
      className: "cui-flex cui-w-auto cui-py-xs cui-px-md",
      children: [dt.exports.jsxs("div", {
        className: "cui-flex cui-items-center cui-gap-sm cui-w-1/3",
        children: [dt.exports.jsx(Nc, {
          width: 48,
          height: 48,
          rounded: "full"
        }), dt.exports.jsx(Nc, {
          width: 48,
          height: 24
        })]
      }), dt.exports.jsxs("div", {
        className: "cui-flex-col cui-flex cui-items-center cui-justify-center cui-gap-sm cui-flex-grow",
        children: [dt.exports.jsx(Nc, {
          width: 96,
          height: 24
        }), dt.exports.jsx(Nc, {
          width: 80,
          height: 24
        })]
      }), dt.exports.jsxs("div", {
        className: "cui-flex cui-items-center cui-justify-end cui-gap-sm cui-w-1/3",
        children: [dt.exports.jsx(Nc, {
          width: 48,
          height: 24
        }), dt.exports.jsx(Nc, {
          width: 48,
          height: 48,
          rounded: "full"
        })]
      })]
    });
  },
  im = function im(e) {
    var t = e.orientation,
      r = void 0 === t ? "horizontal" : t;
    return {
      vertical: dt.exports.jsx(nm, {}),
      horizontal: dt.exports.jsx(om, {})
    }[r];
  },
  lm = {
    exports: {}
  },
  sm = lm.exports = function (e, t) {
    t.prototype.isSameOrBefore = function (e, t) {
      return this.isSame(e, t) || this.isBefore(e, t);
    };
  },
  cm = {
    exports: {}
  },
  um = cm.exports = function (e, t) {
    t.prototype.isSameOrAfter = function (e, t) {
      return this.isSame(e, t) || this.isAfter(e, t);
    };
  },
  dm = {
    exports: {}
  },
  pm = dm.exports = function () {
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      },
      t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
      r = /\d\d/,
      a = /\d\d?/,
      n = /\d*[^-_:/,()\s\d]+/,
      o = {},
      i = function i(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
      },
      l = function l(e) {
        return function (t) {
          this[e] = +t;
        };
      },
      s = [/[+-]\d\d:?(\d\d)?|Z/, function (e) {
        (this.zone || (this.zone = {})).offset = function (e) {
          if (!e) return 0;
          if ("Z" === e) return 0;
          var t = e.match(/([+-]|\d\d)/g),
            r = 60 * t[1] + (+t[2] || 0);
          return 0 === r ? 0 : "+" === t[0] ? -r : r;
        }(e);
      }],
      c = function c(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
      },
      u = function u(e, t) {
        var r,
          a = o.meridiem;
        if (a) {
          for (var n = 1; n <= 24; n += 1) if (e.indexOf(a(n, 0, t)) > -1) {
            r = n > 12;
            break;
          }
        } else r = e === (t ? "pm" : "PM");
        return r;
      },
      d = {
        A: [n, function (e) {
          this.afternoon = u(e, !1);
        }],
        a: [n, function (e) {
          this.afternoon = u(e, !0);
        }],
        S: [/\d/, function (e) {
          this.milliseconds = 100 * +e;
        }],
        SS: [r, function (e) {
          this.milliseconds = 10 * +e;
        }],
        SSS: [/\d{3}/, function (e) {
          this.milliseconds = +e;
        }],
        s: [a, l("seconds")],
        ss: [a, l("seconds")],
        m: [a, l("minutes")],
        mm: [a, l("minutes")],
        H: [a, l("hours")],
        h: [a, l("hours")],
        HH: [a, l("hours")],
        hh: [a, l("hours")],
        D: [a, l("day")],
        DD: [r, l("day")],
        Do: [n, function (e) {
          var t = o.ordinal,
            r = e.match(/\d+/);
          if (this.day = r[0], t) for (var a = 1; a <= 31; a += 1) t(a).replace(/\[|\]/g, "") === e && (this.day = a);
        }],
        M: [a, l("month")],
        MM: [r, l("month")],
        MMM: [n, function (e) {
          var t = c("months"),
            r = (c("monthsShort") || t.map(function (e) {
              return e.slice(0, 3);
            })).indexOf(e) + 1;
          if (r < 1) throw new Error();
          this.month = r % 12 || r;
        }],
        MMMM: [n, function (e) {
          var t = c("months").indexOf(e) + 1;
          if (t < 1) throw new Error();
          this.month = t % 12 || t;
        }],
        Y: [/[+-]?\d+/, l("year")],
        YY: [r, function (e) {
          this.year = i(e);
        }],
        YYYY: [/\d{4}/, l("year")],
        Z: s,
        ZZ: s
      };
    function p(r) {
      var a, n;
      a = r, n = o && o.formats;
      for (var i = (r = a.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, r, a) {
          var o = a && a.toUpperCase();
          return r || n[a] || e[a] || n[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (e, t, r) {
            return t || r.slice(1);
          });
        })).match(t), l = i.length, s = 0; s < l; s += 1) {
        var c = i[s],
          u = d[c],
          p = u && u[0],
          m = u && u[1];
        i[s] = m ? {
          regex: p,
          parser: m
        } : c.replace(/^\[|\]$/g, "");
      }
      return function (e) {
        for (var t = {}, r = 0, a = 0; r < l; r += 1) {
          var n = i[r];
          if ("string" == typeof n) a += n.length;else {
            var o = n.regex,
              s = n.parser,
              c = e.slice(a),
              u = o.exec(c)[0];
            s.call(t, u), e = e.replace(u, "");
          }
        }
        return function (e) {
          var t = e.afternoon;
          if (void 0 !== t) {
            var r = e.hours;
            t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
          }
        }(t), t;
      };
    }
    return function (e, t, r) {
      r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (i = e.parseTwoDigitYear);
      var a = t.prototype,
        n = a.parse;
      a.parse = function (e) {
        var t = e.date,
          a = e.utc,
          i = e.args;
        this.$u = a;
        var l = i[1];
        if ("string" == typeof l) {
          var s = !0 === i[2],
            c = !0 === i[3],
            u = s || c,
            d = i[2];
          c && (d = i[2]), o = this.$locale(), !s && d && (o = r.Ls[d]), this.$d = function (e, t, r) {
            try {
              if (["x", "X"].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
              var a = p(t)(e),
                n = a.year,
                o = a.month,
                i = a.day,
                l = a.hours,
                s = a.minutes,
                c = a.seconds,
                u = a.milliseconds,
                d = a.zone,
                m = new Date(),
                f = i || (n || o ? 1 : m.getDate()),
                v = n || m.getFullYear(),
                y = 0;
              n && !o || (y = o > 0 ? o - 1 : m.getMonth());
              var g = l || 0,
                h = s || 0,
                b = c || 0,
                N = u || 0;
              return d ? new Date(Date.UTC(v, y, f, g, h, b, N + 60 * d.offset * 1e3)) : r ? new Date(Date.UTC(v, y, f, g, h, b, N)) : new Date(v, y, f, g, h, b, N);
            } catch (e) {
              return new Date("");
            }
          }(t, l, a), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(l) && (this.$d = new Date("")), o = {};
        } else if (l instanceof Array) for (var m = l.length, f = 1; f <= m; f += 1) {
          i[1] = l[f - 1];
          var v = r.apply(this, i);
          if (v.isValid()) {
            this.$d = v.$d, this.$L = v.$L, this.init();
            break;
          }
          f === m && (this.$d = new Date(""));
        } else n.call(this, e);
      };
    };
  }(),
  mm = {
    exports: {}
  },
  fm = mm.exports = function () {
    var e,
      t,
      r = 1e3,
      a = 6e4,
      n = 36e5,
      o = 864e5,
      i = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
      l = 31536e6,
      s = 2592e6,
      c = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
      u = {
        years: l,
        months: s,
        days: o,
        hours: n,
        minutes: a,
        seconds: r,
        milliseconds: 1,
        weeks: 6048e5
      },
      d = function d(e) {
        return e instanceof h;
      },
      p = function p(e, t, r) {
        return new h(e, r, t.$l);
      },
      m = function m(e) {
        return t.p(e) + "s";
      },
      f = function f(e) {
        return e < 0;
      },
      v = function v(e) {
        return f(e) ? Math.ceil(e) : Math.floor(e);
      },
      y = function y(e) {
        return Math.abs(e);
      },
      g = function g(e, t) {
        return e ? f(e) ? {
          negative: !0,
          format: "" + y(e) + t
        } : {
          negative: !1,
          format: "" + e + t
        } : {
          negative: !1,
          format: ""
        };
      },
      h = function () {
        function f(e, t, r) {
          var a = this;
          if (this.$d = {}, this.$l = r, void 0 === e && (this.$ms = 0, this.parseFromMilliseconds()), t) return p(e * u[m(t)], this);
          if ("number" == typeof e) return this.$ms = e, this.parseFromMilliseconds(), this;
          if ("object" == ze(e)) return Object.keys(e).forEach(function (t) {
            a.$d[m(t)] = e[t];
          }), this.calMilliseconds(), this;
          if ("string" == typeof e) {
            var n = e.match(c);
            if (n) {
              var o = n.slice(2).map(function (e) {
                return null != e ? Number(e) : 0;
              });
              return this.$d.years = o[0], this.$d.months = o[1], this.$d.weeks = o[2], this.$d.days = o[3], this.$d.hours = o[4], this.$d.minutes = o[5], this.$d.seconds = o[6], this.calMilliseconds(), this;
            }
          }
          return this;
        }
        var y = f.prototype;
        return y.calMilliseconds = function () {
          var e = this;
          this.$ms = Object.keys(this.$d).reduce(function (t, r) {
            return t + (e.$d[r] || 0) * u[r];
          }, 0);
        }, y.parseFromMilliseconds = function () {
          var e = this.$ms;
          this.$d.years = v(e / l), e %= l, this.$d.months = v(e / s), e %= s, this.$d.days = v(e / o), e %= o, this.$d.hours = v(e / n), e %= n, this.$d.minutes = v(e / a), e %= a, this.$d.seconds = v(e / r), e %= r, this.$d.milliseconds = e;
        }, y.toISOString = function () {
          var e = g(this.$d.years, "Y"),
            t = g(this.$d.months, "M"),
            r = +this.$d.days || 0;
          this.$d.weeks && (r += 7 * this.$d.weeks);
          var a = g(r, "D"),
            n = g(this.$d.hours, "H"),
            o = g(this.$d.minutes, "M"),
            i = this.$d.seconds || 0;
          this.$d.milliseconds && (i += this.$d.milliseconds / 1e3);
          var l = g(i, "S"),
            s = e.negative || t.negative || a.negative || n.negative || o.negative || l.negative,
            c = n.format || o.format || l.format ? "T" : "",
            u = (s ? "-" : "") + "P" + e.format + t.format + a.format + c + n.format + o.format + l.format;
          return "P" === u || "-P" === u ? "P0D" : u;
        }, y.toJSON = function () {
          return this.toISOString();
        }, y.format = function (e) {
          var r = e || "YYYY-MM-DDTHH:mm:ss",
            a = {
              Y: this.$d.years,
              YY: t.s(this.$d.years, 2, "0"),
              YYYY: t.s(this.$d.years, 4, "0"),
              M: this.$d.months,
              MM: t.s(this.$d.months, 2, "0"),
              D: this.$d.days,
              DD: t.s(this.$d.days, 2, "0"),
              H: this.$d.hours,
              HH: t.s(this.$d.hours, 2, "0"),
              m: this.$d.minutes,
              mm: t.s(this.$d.minutes, 2, "0"),
              s: this.$d.seconds,
              ss: t.s(this.$d.seconds, 2, "0"),
              SSS: t.s(this.$d.milliseconds, 3, "0")
            };
          return r.replace(i, function (e, t) {
            return t || String(a[e]);
          });
        }, y.as = function (e) {
          return this.$ms / u[m(e)];
        }, y.get = function (e) {
          var t = this.$ms,
            r = m(e);
          return "milliseconds" === r ? t %= 1e3 : t = "weeks" === r ? v(t / u[r]) : this.$d[r], 0 === t ? 0 : t;
        }, y.add = function (e, t, r) {
          var a;
          return a = t ? e * u[m(t)] : d(e) ? e.$ms : p(e, this).$ms, p(this.$ms + a * (r ? -1 : 1), this);
        }, y.subtract = function (e, t) {
          return this.add(e, t, !0);
        }, y.locale = function (e) {
          var t = this.clone();
          return t.$l = e, t;
        }, y.clone = function () {
          return p(this.$ms, this);
        }, y.humanize = function (t) {
          return e().add(this.$ms, "ms").locale(this.$l).fromNow(!t);
        }, y.milliseconds = function () {
          return this.get("milliseconds");
        }, y.asMilliseconds = function () {
          return this.as("milliseconds");
        }, y.seconds = function () {
          return this.get("seconds");
        }, y.asSeconds = function () {
          return this.as("seconds");
        }, y.minutes = function () {
          return this.get("minutes");
        }, y.asMinutes = function () {
          return this.as("minutes");
        }, y.hours = function () {
          return this.get("hours");
        }, y.asHours = function () {
          return this.as("hours");
        }, y.days = function () {
          return this.get("days");
        }, y.asDays = function () {
          return this.as("days");
        }, y.weeks = function () {
          return this.get("weeks");
        }, y.asWeeks = function () {
          return this.as("weeks");
        }, y.months = function () {
          return this.get("months");
        }, y.asMonths = function () {
          return this.as("months");
        }, y.years = function () {
          return this.get("years");
        }, y.asYears = function () {
          return this.as("years");
        }, f;
      }();
    return function (r, a, n) {
      e = n, t = n().$utils(), n.duration = function (e, t) {
        var r = n.locale();
        return p(e, {
          $l: r
        }, t);
      }, n.isDuration = d;
      var o = a.prototype.add,
        i = a.prototype.subtract;
      a.prototype.add = function (e, t) {
        return d(e) && (e = e.asMilliseconds()), o.bind(this)(e, t);
      }, a.prototype.subtract = function (e, t) {
        return d(e) && (e = e.asMilliseconds()), i.bind(this)(e, t);
      };
    };
  }(),
  vm = Math.floor;
var ym = function ym(e, t) {
  var r = "";
  if (!e || t < 1 || t > 9007199254740991) return r;
  do {
    t % 2 && (r += e), (t = vm(t / 2)) && (e += e);
  } while (t);
  return r;
};
var gm = function (e) {
    return function (t) {
      return null == t ? void 0 : t[e];
    };
  }("length"),
  hm = "[\\ud800-\\udfff]",
  bm = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
  Nm = "\\ud83c[\\udffb-\\udfff]",
  xm = "[^\\ud800-\\udfff]",
  km = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  wm = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  _m = "(?:" + bm + "|" + Nm + ")" + "?",
  Fm = "[\\ufe0e\\ufe0f]?" + _m + ("(?:\\u200d(?:" + [xm, km, wm].join("|") + ")[\\ufe0e\\ufe0f]?" + _m + ")*"),
  Sm = "(?:" + [xm + bm + "?", bm, km, wm, hm].join("|") + ")",
  Cm = RegExp(Nm + "(?=" + Nm + ")|" + Sm + Fm, "g");
var jm = gm,
  Em = Ui,
  Tm = function Tm(e) {
    for (var t = Cm.lastIndex = 0; Cm.test(e);) ++t;
    return t;
  };
var Om = function Om(e) {
    return Em(e) ? Tm(e) : jm(e);
  },
  Am = ym,
  Mm = di,
  Lm = zi,
  Dm = Ui,
  Bm = Om,
  Pm = rl,
  Im = Math.ceil;
var zm = da;
var Rm = function Rm(e) {
  return e ? Infinity === (e = zm(e)) || -Infinity === e ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
};
var Um = function Um(e, t) {
    var r = (t = void 0 === t ? " " : Mm(t)).length;
    if (r < 2) return r ? Am(t, e) : t;
    var a = Am(t, Im(e / Bm(t)));
    return Dm(t) ? Lm(Pm(a), 0, e).join("") : a.slice(0, e);
  },
  Hm = Om,
  Gm = function Gm(e) {
    var t = Rm(e),
      r = t % 1;
    return t == t ? r ? t - r : t : 0;
  },
  Vm = mi;
var Wm = function Wm(e, t, r) {
  e = Vm(e);
  var a = (t = Gm(t)) ? Hm(e) : 0;
  return t && a < t ? Um(t - a, r) + e : e;
};
tc.extend(sm), tc.extend(um), tc.extend(fm), tc.extend(pm);
function Km(e) {
  return "number" == typeof e && e.toString().length < 4 ? "number" : tc(e).isValid() ? "date" : tc(e, "HH:mm:ss").isValid() ? "timestamp" : null;
}
function Ym(e) {
  var t = e.isNumber,
    r = e.isTimestamp,
    a = e.isDate,
    n = e.interval,
    o = e.time,
    i = e.stopAt,
    l = e.finishedText,
    s = e.el,
    c = e.countUp,
    u = e.setIsCounting,
    d = e.onStop;
  if (s.current) {
    var p = {
      number: !1,
      timestamp: !1,
      date: !1
    };
    return !!((p = c ? {
      number: t && Number(o.current) >= Number(i),
      timestamp: r && tc(o.current).isValid() && tc(o.current).isSameOrAfter(tc(i, "HH:mm:ss")),
      date: a && tc(o.current).isSameOrAfter(tc(i))
    } : {
      number: t && Number(o.current) <= Number(i),
      timestamp: r && tc(o.current).isValid() && tc(o.current).isSameOrBefore(tc(i, "HH:mm:ss")),
      date: a && tc(o.current).isSameOrAfter(tc(i))
    }).number || p.timestamp || p.date) && (clearInterval(n.current), Ft(s.current, l), u(!1), d && d(), !0);
  }
}
function $m(e) {
  var t,
    r = e.isNumber,
    a = e.isTimestamp,
    n = e.isDate,
    o = e.time,
    i = e.stopAt,
    l = e.el,
    s = e.countUp,
    c = e.setCharLen;
  if (l.current && (r && Ft(l.current, o.current ? null === (t = o.current) || void 0 === t ? void 0 : t.toString() : ""), a && o.current && Ft(l.current, tc(o.current).format("HH:mm:ss")), n)) {
    tc.duration(tc(i).diff(o.current)).asSeconds();
    var u = o.current && tc.duration(tc(o.current).diff(i));
    if (s) Ft(l.current, tc(o.current).format("HH:mm:ss"));else {
      var d = Le(u ? [Math.abs(u.days()) + 30 * Math.abs(u.months()), Wm("".concat(Math.abs(u.get("hours"))), 2, "0"), Wm("".concat(Math.abs(u.get("minutes"))), 2, "0"), Wm("".concat(Math.abs(u.get("seconds"))), 2, "0")] : [], 4),
        p = d[0],
        m = d[1],
        f = d[2],
        v = d[3],
        y = u ? "".concat(p ? "".concat(p, " Day").concat(p > 1 ? "s" : "", " &") : "", " ").concat(m, ":").concat(f, ":").concat(v) : "--:--:--";
      c(y.length), Ft(l.current, y);
    }
  }
}
var qm = function qm(e) {
  var t = e.from,
    r = e.by,
    a = void 0 === r ? 1e3 : r,
    n = e.delay,
    o = void 0 === n ? 1e3 : n,
    i = e.stopAt,
    l = void 0 === i ? 0 : i,
    s = e.finishedText,
    c = void 0 === s ? "Live" : s,
    u = e.format,
    d = void 0 === u ? "ddd MMM DD h:mm:ss A" : u,
    p = e.countUp,
    m = void 0 !== p && p,
    f = e.color,
    v = void 0 === f ? "highlight-accent" : f,
    y = e.className,
    g = void 0 === y ? "" : y,
    h = e.onStop,
    b = Me(e, C),
    N = Km(t),
    x = Ge(!0),
    k = Km(l),
    w = Ge(null),
    _ = v in dn ? dn[v] : v,
    F = [[N, k].every(function (e) {
      return "number" === e;
    }), [N, k].every(function (e) {
      return "timestamp" === e;
    }), [N, k].every(function (e) {
      return "date" === e;
    })],
    S = F[0],
    j = F[1],
    E = F[2];
  if (x.current) {
    switch (N) {
      case "number":
        w.current = t;
        break;
      case "date":
        w.current = tc(t);
        break;
      case "timestamp":
        w.current = tc(t, "HH:mm:ss");
    }
    x.current = !1;
  }
  var T = Ge(null),
    O = Ge(null),
    A = Le(He(0), 2),
    M = A[0],
    L = A[1],
    D = Le(He(!0), 2),
    B = D[0],
    P = D[1],
    I = {
      isNumber: S,
      isTimestamp: j,
      isDate: E,
      interval: T,
      time: w,
      stopAt: l,
      stopAtType: k,
      finishedText: c,
      el: O,
      format: d,
      countUp: m,
      setCharLen: L,
      setIsCounting: P,
      onStop: h
    };
  return Ve(function () {
    return Ym(I) || $m(I), T.current = setInterval(function () {
      if (O.current && w.current) {
        var e, t, r, n;
        if (m) S && (w.current = w.current + a), j && (w.current = null === (e = w.current) || void 0 === e ? void 0 : e.add(a, "ms")), E && (w.current = null === (t = w.current) || void 0 === t ? void 0 : t.add(a, "ms"));else S && (w.current = w.current - a), j && (w.current = null === (r = w.current) || void 0 === r ? void 0 : r.subtract(a, "ms")), E && (w.current = null === (n = w.current) || void 0 === n ? void 0 : n.add(a, "ms"));
        Ym(I) || $m(I);
      }
    }, o), function () {
      clearInterval(T.current), x.current = !0;
    };
  }, [t]), B ? dt.exports.jsx("div", Te(Te({
    className: yt(Oe({
      "cui-w-12": M <= 9,
      "cui-w-[96px]": M > 10 && M <= 16,
      "cui-w-[104px]": 17 === M,
      "cui-w-[110px]": 18 === M,
      "cui-w-[116px]": 19 === M
    }, g, !0), "cui-relative cui-h-4")
  }, b), {}, {
    children: dt.exports.jsx("span", {
      className: "cui-absolute cui-top-0 cui-left-0 ".concat(_, " display-sm cui-whitespace-nowrap cui-text-fg-highlight-accent"),
      ref: O,
      role: "timer"
    })
  })) : dt.exports.jsx("div", {
    className: "".concat(_, " display-sm"),
    children: c
  });
};
tc.extend(um);
var Jm = function Jm(e) {
  var t = e.date,
    r = e.className,
    a = e.hide;
  return !tc(t).isSameOrAfter(Date.now()) || a ? null : dt.exports.jsx(yn, {
    size: "xs",
    color: "fg-moderate",
    className: "cui-whitespace-nowrap cui-mt-2px ".concat(r),
    children: "Starts In"
  });
};
tc.extend(um), tc.extend(fm);
var Xm = function Xm() {
    return dt.exports.jsxs(fn, {
      size: "xs-bold",
      className: "cui-m-0 cui-flex cui-items-center cui-whitespace-nowrap",
      color: "fg-moderate",
      children: [dt.exports.jsx(rs, {
        name: "ui_watch",
        size: "sm",
        color: "highlight-accent",
        className: "cui-mr-2xs"
      }), "Livestream Available"]
    });
  },
  Zm = function Zm(e) {
    var t = e.date,
      r = e.hasLiveStream,
      a = e.variant,
      n = e.showCountdown,
      o = Le(He(!1), 2),
      i = o[0],
      l = o[1],
      s = Ye(function () {
        l(!0);
      }, []);
    return dt.exports.jsx("div", {
      className: yt({
        "cui-flex cui-min-h-[50px]": "vertical" === a,
        "cui-flex cui-flex-col cui-min-h-[58px]": "horizontal" === a
      }, "cui-items-center cui-justify-center cui-pointer-events-none cui-gap-2px"),
      children: "vertical" === a ? dt.exports.jsxs(dt.exports.Fragment, {
        children: [dt.exports.jsxs("div", {
          className: "cui-flex cui-flex-col cui-pr-xs cui-items-end",
          children: [n ? dt.exports.jsxs("div", {
            className: "cui-flex cui-flex-col cui-items-end",
            children: [dt.exports.jsx(Jm, {
              date: t,
              hide: i
            }), dt.exports.jsx(qm, {
              from: Date.now(),
              stopAt: t,
              onStop: s,
              className: "-cui-mr-2px"
            })]
          }) : null, r ? dt.exports.jsx(Xm, {}) : null]
        }), dt.exports.jsx(am, {
          date: t,
          orientation: "vertical",
          variant: "outlined"
        })]
      }) : dt.exports.jsxs(dt.exports.Fragment, {
        children: [n ? dt.exports.jsxs("div", {
          className: "cui-flex cui-flex-wrap sbk-phone:cui-flex-nowrap cui-text-center cui-justify-center cui-items-center",
          children: [dt.exports.jsx(Jm, {
            date: t,
            className: "cui-pr-2xs",
            hide: i
          }), dt.exports.jsx(qm, {
            from: Date.now(),
            stopAt: t,
            onStop: s
          })]
        }) : null, dt.exports.jsx("div", {
          className: "cui-text-center",
          children: dt.exports.jsx(am, {
            date: t,
            variant: "outlined"
          })
        }), r ? dt.exports.jsx(Xm, {}) : null]
      })
    });
  },
  Qm = {
    displayName: "--"
  },
  ef = function e(t) {
    var r = t.id,
      a = void 0 === r ? "" : r,
      n = t.competitors,
      o = t.gameState,
      i = t.date,
      l = t.hasLiveStream,
      s = void 0 !== l && l,
      c = t.onClick,
      u = t.showCountdown,
      d = void 0 === u || u,
      p = t.preGameVariant,
      m = void 0 === p ? "horizontal" : p,
      f = t.skeleton,
      v = Me(t, E),
      y = n ? wi(n, 0, Qm) : Qm,
      g = n ? wi(n, 1, Qm) : Qm,
      h = "cui__box_score_".concat(tc(i).toISOString().replace(/\:|\.|-/g, "_"), "-").concat(wi(y, "displayName", "-"), "-").concat(wi(g, "displayName", "-")),
      b = a || h;
    return "pregame" === o ? dt.exports.jsx(e.PreGame, Te({
      id: b,
      competitors: n,
      date: i,
      onClick: c,
      variant: m,
      hasLiveStream: s,
      showCountdown: d,
      skeleton: f
    }, v)) : dt.exports.jsx(dt.exports.Fragment, {});
  };
ef.displayName = "BoxScore", ef.PreGame = function (e) {
  var t,
    r = e.id,
    a = e.competitors,
    n = e.date,
    o = e.variant,
    i = void 0 === o ? "horizontal" : o,
    l = e.hasLiveStream,
    s = e.showCountdown,
    c = void 0 === s || s,
    u = e.skeleton,
    d = e.onClick,
    p = Me(e, j),
    m = c && !!n,
    f = Xe(function () {
      return {
        date: n,
        hasLiveStream: l,
        variant: i,
        showCountdown: m
      };
    }, [n, l, i, m]),
    v = a ? wi(a, 0, Qm) : Qm,
    y = a ? wi(a, 1, Qm) : Qm,
    g = "cui__box_score_".concat(tc(n).toISOString().replace(/\:|\.|-/g, "_"), "-").concat(wi(v, "displayName", "-"), "-").concat(wi(y, "displayName", "-")),
    h = r || g;
  if (n && tc(n).isSameOrAfter(tc(Date.now()))) {
    var b = n && tc.duration(tc(Date.now()).diff(n)),
      N = 30 * Math.abs(b.months()) + Math.abs(b.days()),
      x = N > 0 ? "starts in ".concat(N, " ").concat(N > 1 ? "days" : "day") : "starts in";
    t = "".concat(x, " ").concat(Math.abs(b.hours()), " hours, ").concat(Math.abs(b.minutes()), " minutes, ").concat(Math.abs(b.seconds()), " seconds");
  } else t = "event started";
  return u ? dt.exports.jsx(im, {
    orientation: i
  }) : dt.exports.jsx("div", Te(Te({
    className: "cui-w-auto cui-flex cui-items-center cui-justify-between cui-py-xs cui-px-md cui-border-1 cui-border-solid cui-border-fg-minimal cui-bg-bg-layer-one cui-select-none cui-outline-none focus:cui-outline-none focus-visible:cui-ring-2 focus-visible:cui-ring-offset-1 focus-visible:cui-ring-fg-focus",
    "aria-label": "Link, All bets for ".concat((null == v ? void 0 : v.displayName) || wi(v, "team", "unknown"), " at ").concat((null == y ? void 0 : y.displayName) || wi(y, "team", "unknon"), ", ").concat(tc(n).format("ddd h:mm:A"), ", ").concat(t, ", ").concat(l ? "livestream available" : ""),
    onClick: function onClick(e) {
      d && d(a, e);
    },
    tabIndex: 0,
    id: h
  }, p), {}, {
    children: "vertical" === i ? dt.exports.jsxs(dt.exports.Fragment, {
      children: [dt.exports.jsxs("div", {
        className: "cui-flex cui-flex-col cui-w-full",
        children: [dt.exports.jsx(Jp, Te(Te({}, v), {}, {
          iconSize: "lg",
          tabbable: !1,
          textSize: "display-sm"
        })), dt.exports.jsx(Jp, Te(Te({}, y), {}, {
          iconSize: "lg",
          tabbable: !1,
          textSize: "display-sm"
        }))]
      }), dt.exports.jsx(Zm, Te({}, f))]
    }) : dt.exports.jsxs(dt.exports.Fragment, {
      children: [dt.exports.jsx(Jp, Te(Te({}, v), {}, {
        force: "abbreviation",
        iconSize: "3xl",
        textSize: "display-lg",
        tabbable: !1
      })), dt.exports.jsx(Zm, Te({}, f)), dt.exports.jsx(Jp, Te(Te({}, y), {}, {
        force: "abbreviation",
        inverse: !0,
        iconSize: "3xl",
        textSize: "display-lg",
        tabbable: !1
      }))]
    })
  }));
};
var tf = function tf(e) {
    (0, e.setActive)(e.id);
  },
  rf = {
    label: "Pill Menu",
    anchorTag: "#"
  },
  af = function af(e) {
    var t = e.items,
      r = void 0 === t ? [] : t,
      a = e.size,
      n = void 0 === a ? "sm" : a,
      o = e.initialActive,
      i = void 0 === o ? 0 : o,
      l = e.activateItem,
      s = e.overlay,
      c = void 0 !== s && s,
      u = e.skipLink,
      d = void 0 === u ? rf : u,
      p = e.tabbable,
      m = void 0 === p || p,
      f = e.onActiveItem,
      v = Me(e, T),
      y = Le(He(i), 2),
      g = y[0],
      h = y[1],
      b = Le(He(!1), 2),
      N = b[0],
      x = b[1],
      k = Le(He(i), 2),
      w = k[0],
      _ = k[1],
      F = Ge(Ra()),
      S = Xe(function () {
        return r.length ? r.reduce(function (e, t, r) {
          return e[t.id] = r, e;
        }, {}) : {};
      }, [r]),
      C = Xe(function () {
        if (Array.isArray(r) && r.length) {
          if ("object" === ze(r[0])) return r.map(function (e, t) {
            var r = e.id,
              a = e.label,
              o = e.iconName,
              i = void 0 === o ? "" : o,
              l = e.team;
            return dt.exports.jsx(nd, {
              text: a,
              variant: "pill",
              size: n,
              leftIcon: i,
              selected: g === t,
              id: r ? "cui__pill-nav-".concat(r, "-").concat(F.current) : "cui__pill-nav-item-".concat(F.current),
              team: l,
              "aria-label": "Button ".concat(a ? "for ".concat(a) : "", " ").concat(i ? "with icon ".concat(i) : ""),
              role: "menuitem",
              onClick: function onClick() {
                return tf({
                  setActive: h,
                  id: S[r]
                });
              }
            }, "cui__pill_nav_item-".concat(a, "-").concat(t, "-").concat(F.current));
          });
          if ("string" == typeof r[0]) return r.map(function (e, t) {
            return dt.exports.jsx(nd, {
              text: e,
              variant: "pill",
              size: n,
              selected: g === t,
              id: "cui__pill-nav-".concat(e, "-").concat(F.current),
              "aria-label": "Button ".concat(e ? "for ".concat(e) : ""),
              onClick: function onClick() {
                return tf({
                  setActive: h,
                  id: t
                });
              },
              role: "menuitem"
            }, t);
          });
        }
      }, [r, n, g, i]),
      j = Ye(function (e) {
        _(e);
      }, []);
    return Ve(function () {
      f && void 0 !== g && f(g), x(g !== w);
    }, [g, w]), Ve(function () {
      "object" === ze(r[0]) && void 0 !== l && h(S[l]), "string" == typeof r[0] && void 0 !== l && "number" == typeof l && h(l);
    }, [l]), dt.exports.jsx(hd, Te(Te({
      controlSize: n,
      overlay: c,
      showPagination: !1,
      slideTo: g,
      centerSlides: !1,
      onItemChange: j,
      showFadeLeft: N,
      "data-cy": "cui__pill_nav",
      skipLink: d,
      tabbable: m,
      role: "menu"
    }, v), {}, {
      children: C
    }));
  },
  nf = function nf(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      r = Ge(t);
    return Ve(function () {
      e && ("function" == typeof e ? e(r.current) : e.current = r.current);
    }, [e]), r;
  },
  of = qe(function (e, t) {
    var r = e.containerRef,
      a = e.handleItemImpression,
      n = e.index,
      o = e.inView,
      i = e.item,
      l = e.setInView,
      s = Le(He(!1), 2),
      c = s[0],
      u = s[1],
      d = nf(t);
    Ve(function () {
      var e = Ce(o);
      e[n] = c, l(e);
    }, [c]), Ve(function () {
      if (d.current && r.current) {
        var e = new IntersectionObserver(function (e) {
          var t = Le(e, 1)[0];
          u(t.isIntersecting), t.isIntersecting && a(i.props);
        }, {
          root: r.current,
          threshold: 1
        });
        return d.current && (null == e || e.observe(d.current)), function () {
          return e.disconnect();
        };
      }
    }, []);
    var p = ["cui-snap-always", "cui-snap-center", "cui-mt-4", "cui-mx-4", "cui-mb-xs", "cui-ml-0", "first:cui-ml-4", "empty:cui-hidden", "last:cui-mr-4"].join(" ");
    return dt.exports.jsx("div", {
      className: p,
      ref: d,
      id: "carousel-item-".concat(n),
      children: i
    });
  }),
  lf = of,
  sf = ["cui-flex", "large-mobile:cui-hidden", "cui-justify-center", "cui-align-center", "cui-m-1"].join(" "),
  cf = ["cui-mx-1", "cui-mx-2px", "cui-h-2", "cui-w-2", "cui-rounded-lg"].join(" "),
  uf = function uf(e) {
    var t = e.current,
      r = e.items;
    return dt.exports.jsx("aside", {
      id: "carousel-pagination-container",
      className: sf,
      children: r.map(function (e, r) {
        return dt.exports.jsx("div", {
          className: "".concat(cf, " ").concat(t === r ? "cui-bg-fg-default" : "cui-bg-fg-subtle"),
          id: "pagination-bubble-".concat(r)
        }, "pagination-bubble-".concat(r));
      })
    });
  },
  df = function df(e) {
    var t = e.children,
      r = e.handleItemImpression,
      a = e.pagination,
      n = void 0 !== a && a,
      o = Le(He(new Array(t.length).fill(!1)), 2),
      i = o[0],
      l = o[1],
      s = Le(He(0), 2),
      c = s[0],
      u = s[1],
      d = Ge(null),
      p = Ge([]),
      m = Ge(Date.now());
    p.current = t.map(function (e, t) {
      var r;
      return null !== (r = p.current[t]) && void 0 !== r ? r : et();
    }), Ve(function () {
      var e = i.indexOf(!0);
      u(e);
    }, [i]);
    var f = ["cui-flex", "cui-overflow-hidden", "cui-overflow-x-auto", "cui-no-scrollbar", "cui-snap-x", "cui-snap-mandatory"].join(" ");
    return dt.exports.jsxs("section", {
      id: "carousel-".concat(m.current),
      "data-cy": "carousel",
      className: "cui-flex cui-flex-col cui-relative",
      children: [dt.exports.jsx("div", {
        ref: d,
        className: f,
        children: Ue.Children.map(t, function (e, t) {
          return dt.exports.jsx(lf, {
            containerRef: d,
            handleItemImpression: r,
            index: t,
            inView: i,
            item: e,
            setInView: l,
            ref: p.current[t]
          }, "carousel-item-".concat(t));
        })
      }), n && t.length > 1 && dt.exports.jsx(uf, {
        current: c,
        items: t
      })]
    });
  },
  pf = Mo;
var mf = Mo,
  ff = Lo,
  vf = Xo;
var yf = Mo,
  gf = function gf() {
    this.__data__ = new pf(), this.size = 0;
  },
  hf = function hf(e) {
    var t = this.__data__,
      r = t.delete(e);
    return this.size = t.size, r;
  },
  bf = function bf(e) {
    return this.__data__.get(e);
  },
  Nf = function Nf(e) {
    return this.__data__.has(e);
  },
  xf = function xf(e, t) {
    var r = this.__data__;
    if (r instanceof mf) {
      var a = r.__data__;
      if (!ff || a.length < 199) return a.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new vf(a);
    }
    return r.set(e, t), this.size = r.size, this;
  };
function kf(e) {
  var t = this.__data__ = new yf(e);
  this.size = t.size;
}
kf.prototype.clear = gf, kf.prototype.delete = hf, kf.prototype.get = bf, kf.prototype.has = Nf, kf.prototype.set = xf;
var wf = kf;
var _f = function _f(e, t) {
    for (var r = -1, a = null == e ? 0 : e.length; ++r < a && !1 !== t(e[r], r, e););
    return e;
  },
  Ff = Jn,
  Sf = function () {
    try {
      var e = Ff(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (e) {}
  }(),
  Cf = Sf,
  jf = Cf;
var Ef = function Ef(e, t, r) {
    "__proto__" == t && jf ? jf(e, t, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : e[t] = r;
  },
  Tf = Ef,
  Of = yo,
  Af = Object.prototype.hasOwnProperty;
var Mf = function Mf(e, t, r) {
    var a = e[t];
    Af.call(e, t) && Of(a, r) && (void 0 !== r || t in e) || Tf(e, t, r);
  },
  Lf = Mf,
  Df = Ef;
var Bf = function Bf(e, t, r, a) {
  var n = !r;
  r || (r = {});
  for (var o = -1, i = t.length; ++o < i;) {
    var l = t[o],
      s = a ? a(r[l], e[l], l, r, e) : void 0;
    void 0 === s && (s = e[l]), n ? Df(r, l, s) : Lf(r, l, s);
  }
  return r;
};
var Pf = function Pf(e, t) {
    for (var r = -1, a = Array(e); ++r < e;) a[r] = t(r);
    return a;
  },
  If = Qr,
  zf = ea;
var Rf = function Rf(e) {
    return zf(e) && "[object Arguments]" == If(e);
  },
  Uf = ea,
  Hf = Object.prototype,
  Gf = Hf.hasOwnProperty,
  Vf = Hf.propertyIsEnumerable,
  Wf = Rf(function () {
    return arguments;
  }()) ? Rf : function (e) {
    return Uf(e) && Gf.call(e, "callee") && !Vf.call(e, "callee");
  },
  Kf = {
    exports: {}
  };
var Yf = function Yf() {
  return !1;
};
!function (e, t) {
  var r = Lr,
    a = Yf,
    n = t && !t.nodeType && t,
    o = n && e && !e.nodeType && e,
    i = o && o.exports === n ? r.Buffer : void 0,
    l = (i ? i.isBuffer : void 0) || a;
  e.exports = l;
}(Kf, Kf.exports);
var $f = /^(?:0|[1-9]\d*)$/;
var qf = function qf(e, t) {
  var r = ze(e);
  return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && $f.test(e)) && e > -1 && e % 1 == 0 && e < t;
};
var Jf = function Jf(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
  },
  Xf = Qr,
  Zf = Jf,
  Qf = ea,
  ev = {};
ev["[object Float32Array]"] = ev["[object Float64Array]"] = ev["[object Int8Array]"] = ev["[object Int16Array]"] = ev["[object Int32Array]"] = ev["[object Uint8Array]"] = ev["[object Uint8ClampedArray]"] = ev["[object Uint16Array]"] = ev["[object Uint32Array]"] = !0, ev["[object Arguments]"] = ev["[object Array]"] = ev["[object ArrayBuffer]"] = ev["[object Boolean]"] = ev["[object DataView]"] = ev["[object Date]"] = ev["[object Error]"] = ev["[object Function]"] = ev["[object Map]"] = ev["[object Number]"] = ev["[object Object]"] = ev["[object RegExp]"] = ev["[object Set]"] = ev["[object String]"] = ev["[object WeakMap]"] = !1;
var tv = function tv(e) {
  return Qf(e) && Zf(e.length) && !!ev[Xf(e)];
};
var rv = function rv(e) {
    return function (t) {
      return e(t);
    };
  },
  av = {
    exports: {}
  };
!function (e, t) {
  var r = Or,
    a = t && !t.nodeType && t,
    n = a && e && !e.nodeType && e,
    o = n && n.exports === a && r.process,
    i = function () {
      try {
        var e = n && n.require && n.require("util").types;
        return e || o && o.binding && o.binding("util");
      } catch (e) {}
    }();
  e.exports = i;
}(av, av.exports);
var nv = tv,
  ov = rv,
  iv = av.exports,
  lv = iv && iv.isTypedArray,
  sv = lv ? ov(lv) : nv,
  cv = Pf,
  uv = Wf,
  dv = wn,
  pv = Kf.exports,
  mv = qf,
  fv = sv,
  vv = Object.prototype.hasOwnProperty;
var yv = function yv(e, t) {
    var r = dv(e),
      a = !r && uv(e),
      n = !r && !a && pv(e),
      o = !r && !a && !n && fv(e),
      i = r || a || n || o,
      l = i ? cv(e.length, String) : [],
      s = l.length;
    for (var c in e) !t && !vv.call(e, c) || i && ("length" == c || n && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || mv(c, s)) || l.push(c);
    return l;
  },
  gv = Object.prototype;
var hv = function hv(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || gv);
};
var bv = function bv(e, t) {
    return function (r) {
      return e(t(r));
    };
  },
  Nv = bv(Object.keys, Object),
  xv = hv,
  kv = Nv,
  wv = Object.prototype.hasOwnProperty;
var _v = An,
  Fv = Jf;
var Sv = function Sv(e) {
    return null != e && Fv(e.length) && !_v(e);
  },
  Cv = yv,
  jv = function jv(e) {
    if (!xv(e)) return kv(e);
    var t = [];
    for (var r in Object(e)) wv.call(e, r) && "constructor" != r && t.push(r);
    return t;
  },
  Ev = Sv;
var Tv = function Tv(e) {
    return Ev(e) ? Cv(e) : jv(e);
  },
  Ov = Bf,
  Av = Tv;
var Mv = function Mv(e, t) {
  return e && Ov(t, Av(t), e);
};
var Lv = Tr,
  Dv = hv,
  Bv = function Bv(e) {
    var t = [];
    if (null != e) for (var r in Object(e)) t.push(r);
    return t;
  },
  Pv = Object.prototype.hasOwnProperty;
var Iv = yv,
  zv = function zv(e) {
    if (!Lv(e)) return Bv(e);
    var t = Dv(e),
      r = [];
    for (var a in e) ("constructor" != a || !t && Pv.call(e, a)) && r.push(a);
    return r;
  },
  Rv = Sv;
var Uv = function Uv(e) {
    return Rv(e) ? Iv(e, !0) : zv(e);
  },
  Hv = Bf,
  Gv = Uv;
var Vv = function Vv(e, t) {
    return e && Hv(t, Gv(t), e);
  },
  Wv = {
    exports: {}
  };
!function (e, t) {
  var r = Lr,
    a = t && !t.nodeType && t,
    n = a && e && !e.nodeType && e,
    o = n && n.exports === a ? r.Buffer : void 0,
    i = o ? o.allocUnsafe : void 0;
  e.exports = function (e, t) {
    if (t) return e.slice();
    var r = e.length,
      a = i ? i(r) : new e.constructor(r);
    return e.copy(a), a;
  };
}(Wv, Wv.exports);
var Kv = function Kv(e, t) {
  var r = -1,
    a = e.length;
  for (t || (t = Array(a)); ++r < a;) t[r] = e[r];
  return t;
};
var Yv = function Yv(e, t) {
  for (var r = -1, a = null == e ? 0 : e.length, n = 0, o = []; ++r < a;) {
    var i = e[r];
    t(i, r, e) && (o[n++] = i);
  }
  return o;
};
var $v = function $v() {
    return [];
  },
  qv = Yv,
  Jv = $v,
  Xv = Object.prototype.propertyIsEnumerable,
  Zv = Object.getOwnPropertySymbols,
  Qv = Zv ? function (e) {
    return null == e ? [] : (e = Object(e), qv(Zv(e), function (t) {
      return Xv.call(e, t);
    }));
  } : Jv,
  ey = Bf,
  ty = Qv;
var ry = function ry(e, t) {
  return ey(e, ty(e), t);
};
var ay = function ay(e, t) {
    for (var r = -1, a = t.length, n = e.length; ++r < a;) e[n + r] = t[r];
    return e;
  },
  ny = bv(Object.getPrototypeOf, Object),
  oy = ay,
  iy = ny,
  ly = Qv,
  sy = $v,
  cy = Object.getOwnPropertySymbols ? function (e) {
    for (var t = []; e;) oy(t, ly(e)), e = iy(e);
    return t;
  } : sy,
  uy = Bf,
  dy = cy;
var py = function py(e, t) {
    return uy(e, dy(e), t);
  },
  my = ay,
  fy = wn;
var vy = function vy(e, t, r) {
    var a = t(e);
    return fy(e) ? a : my(a, r(e));
  },
  yy = vy,
  gy = Qv,
  hy = Tv;
var by = function by(e) {
    return yy(e, hy, gy);
  },
  Ny = vy,
  xy = cy,
  ky = Uv;
var wy = function wy(e) {
    return Ny(e, ky, xy);
  },
  _y = Jn(Lr, "DataView"),
  Fy = Lo,
  Sy = Jn(Lr, "Promise"),
  Cy = Jn(Lr, "Set"),
  jy = Jn(Lr, "WeakMap"),
  Ey = Qr,
  Ty = Pn,
  Oy = Ty(_y),
  Ay = Ty(Fy),
  My = Ty(Sy),
  Ly = Ty(Cy),
  Dy = Ty(jy),
  By = Ey;
(_y && "[object DataView]" != By(new _y(new ArrayBuffer(1))) || Fy && "[object Map]" != By(new Fy()) || Sy && "[object Promise]" != By(Sy.resolve()) || Cy && "[object Set]" != By(new Cy()) || jy && "[object WeakMap]" != By(new jy())) && (By = function By(e) {
  var t = Ey(e),
    r = "[object Object]" == t ? e.constructor : void 0,
    a = r ? Ty(r) : "";
  if (a) switch (a) {
    case Oy:
      return "[object DataView]";
    case Ay:
      return "[object Map]";
    case My:
      return "[object Promise]";
    case Ly:
      return "[object Set]";
    case Dy:
      return "[object WeakMap]";
  }
  return t;
});
var Py = By,
  Iy = Object.prototype.hasOwnProperty;
var zy = function zy(e) {
    var t = e.length,
      r = new e.constructor(t);
    return t && "string" == typeof e[0] && Iy.call(e, "index") && (r.index = e.index, r.input = e.input), r;
  },
  Ry = Lr.Uint8Array;
var Uy = function Uy(e) {
    var t = new e.constructor(e.byteLength);
    return new Ry(t).set(new Ry(e)), t;
  },
  Hy = Uy;
var Gy = function Gy(e, t) {
    var r = t ? Hy(e.buffer) : e.buffer;
    return new e.constructor(r, e.byteOffset, e.byteLength);
  },
  Vy = /\w*$/;
var Wy = function Wy(e) {
    var t = new e.constructor(e.source, Vy.exec(e));
    return t.lastIndex = e.lastIndex, t;
  },
  Ky = Hr ? Hr.prototype : void 0,
  Yy = Ky ? Ky.valueOf : void 0;
var $y = Uy;
var qy = function qy(e, t) {
    var r = t ? $y(e.buffer) : e.buffer;
    return new e.constructor(r, e.byteOffset, e.length);
  },
  Jy = Uy,
  Xy = Gy,
  Zy = Wy,
  Qy = function Qy(e) {
    return Yy ? Object(Yy.call(e)) : {};
  },
  eg = qy;
var tg = function tg(e, t, r) {
    var a = e.constructor;
    switch (t) {
      case "[object ArrayBuffer]":
        return Jy(e);
      case "[object Boolean]":
      case "[object Date]":
        return new a(+e);
      case "[object DataView]":
        return Xy(e, r);
      case "[object Float32Array]":
      case "[object Float64Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object Int32Array]":
      case "[object Uint8Array]":
      case "[object Uint8ClampedArray]":
      case "[object Uint16Array]":
      case "[object Uint32Array]":
        return eg(e, r);
      case "[object Map]":
      case "[object Set]":
        return new a();
      case "[object Number]":
      case "[object String]":
        return new a(e);
      case "[object RegExp]":
        return Zy(e);
      case "[object Symbol]":
        return Qy(e);
    }
  },
  rg = Tr,
  ag = Object.create,
  ng = function () {
    function e() {}
    return function (t) {
      if (!rg(t)) return {};
      if (ag) return ag(t);
      e.prototype = t;
      var r = new e();
      return e.prototype = void 0, r;
    };
  }(),
  og = ny,
  ig = hv;
var lg = function lg(e) {
    return "function" != typeof e.constructor || ig(e) ? {} : ng(og(e));
  },
  sg = Py,
  cg = ea;
var ug = function ug(e) {
    return cg(e) && "[object Map]" == sg(e);
  },
  dg = rv,
  pg = av.exports,
  mg = pg && pg.isMap,
  fg = mg ? dg(mg) : ug,
  vg = Py,
  yg = ea;
var gg = function gg(e) {
    return yg(e) && "[object Set]" == vg(e);
  },
  hg = rv,
  bg = av.exports,
  Ng = bg && bg.isSet,
  xg = Ng ? hg(Ng) : gg,
  kg = wf,
  wg = _f,
  _g = Mf,
  Fg = Mv,
  Sg = Vv,
  Cg = Wv.exports,
  jg = Kv,
  Eg = ry,
  Tg = py,
  Og = by,
  Ag = wy,
  Mg = Py,
  Lg = zy,
  Dg = tg,
  Bg = lg,
  Pg = wn,
  Ig = Kf.exports,
  zg = fg,
  Rg = Tr,
  Ug = xg,
  Hg = Tv,
  Gg = Uv,
  Vg = {};
Vg["[object Arguments]"] = Vg["[object Array]"] = Vg["[object ArrayBuffer]"] = Vg["[object DataView]"] = Vg["[object Boolean]"] = Vg["[object Date]"] = Vg["[object Float32Array]"] = Vg["[object Float64Array]"] = Vg["[object Int8Array]"] = Vg["[object Int16Array]"] = Vg["[object Int32Array]"] = Vg["[object Map]"] = Vg["[object Number]"] = Vg["[object Object]"] = Vg["[object RegExp]"] = Vg["[object Set]"] = Vg["[object String]"] = Vg["[object Symbol]"] = Vg["[object Uint8Array]"] = Vg["[object Uint8ClampedArray]"] = Vg["[object Uint16Array]"] = Vg["[object Uint32Array]"] = !0, Vg["[object Error]"] = Vg["[object Function]"] = Vg["[object WeakMap]"] = !1;
var Wg = function e(t, r, a, n, o, i) {
    var l,
      s = 1 & r,
      c = 2 & r,
      u = 4 & r;
    if (a && (l = o ? a(t, n, o, i) : a(t)), void 0 !== l) return l;
    if (!Rg(t)) return t;
    var d = Pg(t);
    if (d) {
      if (l = Lg(t), !s) return jg(t, l);
    } else {
      var p = Mg(t),
        m = "[object Function]" == p || "[object GeneratorFunction]" == p;
      if (Ig(t)) return Cg(t, s);
      if ("[object Object]" == p || "[object Arguments]" == p || m && !o) {
        if (l = c || m ? {} : Bg(t), !s) return c ? Tg(t, Sg(l, t)) : Eg(t, Fg(l, t));
      } else {
        if (!Vg[p]) return o ? t : {};
        l = Dg(t, p, s);
      }
    }
    i || (i = new kg());
    var f = i.get(t);
    if (f) return f;
    i.set(t, l), Ug(t) ? t.forEach(function (n) {
      l.add(e(n, r, a, n, t, i));
    }) : zg(t) && t.forEach(function (n, o) {
      l.set(o, e(n, r, a, o, t, i));
    });
    var v = d ? void 0 : (u ? c ? Ag : Og : c ? Gg : Hg)(t);
    return wg(v || t, function (n, o) {
      v && (n = t[o = n]), _g(l, o, e(n, r, a, o, t, i));
    }), l;
  },
  Kg = Wg;
var Yg = function Yg(e) {
    return Kg(e, 5);
  },
  $g = Symbol.for("immer-nothing"),
  qg = Symbol.for("immer-draftable"),
  Jg = Symbol.for("immer-state"),
  Xg = "production" !== process.env.NODE_ENV ? [function (e) {
    return "The plugin for '".concat(e, "' has not been loaded into Immer. To enable the plugin, import and call `enable").concat(e, "()` when initializing your application.");
  }, function (e) {
    return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '".concat(e, "'");
  }, "This object has been frozen and should not be mutated", function (e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  }, "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", "Immer forbids circular references", "The first or second argument to `produce` must be a function", "The third argument to `produce` must be a function or undefined", "First argument to `createDraft` must be a plain object, an array, or an immerable object", "First argument to `finishDraft` must be a draft returned by `createDraft`", function (e) {
    return "'current' expects a draft, got: ".concat(e);
  }, "Object.defineProperty() cannot be used on an Immer draft", "Object.setPrototypeOf() cannot be used on an Immer draft", "Immer only supports deleting array indices", "Immer only supports setting array indices and the 'length' property", function (e) {
    return "'original' expects a draft, got: ".concat(e);
  }] : [];
function Zg(e) {
  if ("production" !== process.env.NODE_ENV) {
    for (var t = Xg[e], r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) a[n - 1] = arguments[n];
    var o = "function" == typeof t ? t.apply(null, a) : t;
    throw new Error("[Immer] ".concat(o));
  }
  throw new Error("[Immer] minified error nr: ".concat(e, ". Full error at: https://bit.ly/3cXEKWf"));
}
var Qg = Object.getPrototypeOf;
function eh(e) {
  return !!e && !!e[Jg];
}
function th(e) {
  var t;
  return !!e && (ah(e) || Array.isArray(e) || !!e[qg] || !(null === (t = e.constructor) || void 0 === t || !t[qg]) || sh(e) || ch(e));
}
var rh = Object.prototype.constructor.toString();
function ah(e) {
  if (!e || "object" !== ze(e)) return !1;
  var t = Qg(e);
  if (null === t) return !0;
  var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object || "function" == typeof r && Function.toString.call(r) === rh;
}
function nh(e, t) {
  0 === oh(e) ? Object.entries(e).forEach(function (r) {
    var a = Le(r, 2),
      n = a[0],
      o = a[1];
    t(n, o, e);
  }) : e.forEach(function (r, a) {
    return t(a, r, e);
  });
}
function oh(e) {
  var t = e[Jg];
  return t ? t.type_ : Array.isArray(e) ? 1 : sh(e) ? 2 : ch(e) ? 3 : 0;
}
function ih(e, t) {
  return 2 === oh(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function lh(e, t, r) {
  var a = oh(e);
  2 === a ? e.set(t, r) : 3 === a ? e.add(r) : e[t] = r;
}
function sh(e) {
  return e instanceof Map;
}
function ch(e) {
  return e instanceof Set;
}
function uh(e) {
  return e.copy_ || e.base_;
}
function dh(e, t) {
  if (sh(e)) return new Map(e);
  if (ch(e)) return new Set(e);
  if (Array.isArray(e)) return Array.prototype.slice.call(e);
  if (!t && ah(e)) {
    if (!Qg(e)) {
      var r = Object.create(null);
      return Object.assign(r, e);
    }
    return Te({}, e);
  }
  var a = Object.getOwnPropertyDescriptors(e);
  delete a[Jg];
  for (var n = Reflect.ownKeys(a), o = 0; o < n.length; o++) {
    var i = n[o],
      l = a[i];
    !1 === l.writable && (l.writable = !0, l.configurable = !0), (l.get || l.set) && (a[i] = {
      configurable: !0,
      writable: !0,
      enumerable: l.enumerable,
      value: e[i]
    });
  }
  return Object.create(Qg(e), a);
}
function ph(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  return fh(e) || eh(e) || !th(e) || (oh(e) > 1 && (e.set = e.add = e.clear = e.delete = mh), Object.freeze(e), t && nh(e, function (e, t) {
    return ph(t, !0);
  })), e;
}
function mh() {
  Zg(2);
}
function fh(e) {
  return Object.isFrozen(e);
}
var vh,
  yh = {};
function gh(e) {
  var t = yh[e];
  return t || Zg(0, e), t;
}
function hh() {
  return vh;
}
function bh(e, t) {
  t && (gh("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Nh(e) {
  xh(e), e.drafts_.forEach(wh), e.drafts_ = null;
}
function xh(e) {
  e === vh && (vh = e.parent_);
}
function kh(e) {
  return vh = {
    drafts_: [],
    parent_: vh,
    immer_: e,
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function wh(e) {
  var t = e[Jg];
  0 === t.type_ || 1 === t.type_ ? t.revoke_() : t.revoked_ = !0;
}
function _h(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  var r = t.drafts_[0];
  return void 0 !== e && e !== r ? (r[Jg].modified_ && (Nh(t), Zg(4)), th(e) && (e = Fh(t, e), t.parent_ || Ch(t, e)), t.patches_ && gh("Patches").generateReplacementPatches_(r[Jg].base_, e, t.patches_, t.inversePatches_)) : e = Fh(t, r, []), Nh(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== $g ? e : void 0;
}
function Fh(e, t, r) {
  if (fh(t)) return t;
  var a = t[Jg];
  if (!a) return nh(t, function (n, o) {
    return Sh(e, a, t, n, o, r);
  }), t;
  if (a.scope_ !== e) return t;
  if (!a.modified_) return Ch(e, a.base_, !0), a.base_;
  if (!a.finalized_) {
    a.finalized_ = !0, a.scope_.unfinalizedDrafts_--;
    var n = a.copy_,
      o = n,
      i = !1;
    3 === a.type_ && (o = new Set(n), n.clear(), i = !0), nh(o, function (t, o) {
      return Sh(e, a, n, t, o, r, i);
    }), Ch(e, n, !1), r && e.patches_ && gh("Patches").generatePatches_(a, r, e.patches_, e.inversePatches_);
  }
  return a.copy_;
}
function Sh(e, t, r, a, n, o, i) {
  if ("production" !== process.env.NODE_ENV && n === r && Zg(5), eh(n)) {
    var l = Fh(e, n, o && t && 3 !== t.type_ && !ih(t.assigned_, a) ? o.concat(a) : void 0);
    if (lh(r, a, l), !eh(l)) return;
    e.canAutoFreeze_ = !1;
  } else i && r.add(n);
  if (th(n) && !fh(n)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1) return;
    Fh(e, n), t && t.scope_.parent_ || Ch(e, n);
  }
}
function Ch(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && ph(t, r);
}
var jh = {
    get: function get(e, t) {
      if (t === Jg) return e;
      var r = uh(e);
      if (!ih(r, t)) return function (e, t, r) {
        var a,
          n = Oh(t, r);
        return n ? "value" in n ? n.value : null === (a = n.get) || void 0 === a ? void 0 : a.call(e.draft_) : void 0;
      }(e, r, t);
      var a = r[t];
      return e.finalized_ || !th(a) ? a : a === Th(e.base_, t) ? (Mh(e), e.copy_[t] = Dh(a, e)) : a;
    },
    has: function has(e, t) {
      return t in uh(e);
    },
    ownKeys: function ownKeys(e) {
      return Reflect.ownKeys(uh(e));
    },
    set: function set(e, t, r) {
      var a,
        n,
        o = Oh(uh(e), t);
      if (null != o && o.set) return o.set.call(e.draft_, r), !0;
      if (!e.modified_) {
        var i = Th(uh(e), t),
          l = null == i ? void 0 : i[Jg];
        if (l && l.base_ === r) return e.copy_[t] = r, e.assigned_[t] = !1, !0;
        if (((a = r) === (n = i) ? 0 !== a || 1 / a == 1 / n : a != a && n != n) && (void 0 !== r || ih(e.base_, t))) return !0;
        Mh(e), Ah(e);
      }
      return e.copy_[t] === r && (void 0 !== r || t in e.copy_) || Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
    },
    deleteProperty: function deleteProperty(e, t) {
      return void 0 !== Th(e.base_, t) || t in e.base_ ? (e.assigned_[t] = !1, Mh(e), Ah(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
      var r = uh(e),
        a = Reflect.getOwnPropertyDescriptor(r, t);
      return a ? {
        writable: !0,
        configurable: 1 !== e.type_ || "length" !== t,
        enumerable: a.enumerable,
        value: r[t]
      } : a;
    },
    defineProperty: function defineProperty() {
      Zg(11);
    },
    getPrototypeOf: function getPrototypeOf(e) {
      return Qg(e.base_);
    },
    setPrototypeOf: function setPrototypeOf() {
      Zg(12);
    }
  },
  Eh = {};
function Th(e, t) {
  var r = e[Jg];
  return (r ? uh(r) : e)[t];
}
function Oh(e, t) {
  if (t in e) for (var r = Qg(e); r;) {
    var a = Object.getOwnPropertyDescriptor(r, t);
    if (a) return a;
    r = Qg(r);
  }
}
function Ah(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Ah(e.parent_));
}
function Mh(e) {
  e.copy_ || (e.copy_ = dh(e.base_, e.scope_.immer_.useStrictShallowCopy_));
}
nh(jh, function (e, t) {
  Eh[e] = function () {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Eh.deleteProperty = function (e, t) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(t)) && Zg(13), Eh.set.call(this, e, t, void 0);
}, Eh.set = function (e, t, r) {
  return "production" !== process.env.NODE_ENV && "length" !== t && isNaN(parseInt(t)) && Zg(14), jh.set.call(this, e[0], t, r, e[0]);
};
var Lh = function () {
  function e(t) {
    var r = this;
    Ne(this, e), this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = function (e, t, a) {
      if ("function" == typeof e && "function" != typeof t) {
        var n = t;
        t = e;
        var o = r;
        return function () {
          for (var e = this, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n, a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++) i[l - 1] = arguments[l];
          return o.produce(r, function (r) {
            var a;
            return (a = t).call.apply(a, [e, r].concat(i));
          });
        };
      }
      var i;
      if ("function" != typeof t && Zg(6), void 0 !== a && "function" != typeof a && Zg(7), th(e)) {
        var l = kh(r),
          s = Dh(e, void 0),
          c = !0;
        try {
          i = t(s), c = !1;
        } finally {
          c ? Nh(l) : xh(l);
        }
        return bh(l, a), _h(i, l);
      }
      if (!e || "object" !== ze(e)) {
        if (void 0 === (i = t(e)) && (i = e), i === $g && (i = void 0), r.autoFreeze_ && ph(i, !0), a) {
          var u = [],
            d = [];
          gh("Patches").generateReplacementPatches_(e, i, u, d), a(u, d);
        }
        return i;
      }
      Zg(1, e);
    }, this.produceWithPatches = function (e, t) {
      return "function" == typeof e ? function (t) {
        for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) n[o - 1] = arguments[o];
        return r.produceWithPatches(t, function (t) {
          return e.apply(void 0, [t].concat(n));
        });
      } : [r.produce(e, t, function (e, t) {
        a = e, n = t;
      }), a, n];
      var a, n;
    }, "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze), "boolean" == typeof (null == t ? void 0 : t.useStrictShallowCopy) && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  return ke(e, [{
    key: "createDraft",
    value: function value(e) {
      th(e) || Zg(8), eh(e) && (e = function (e) {
        eh(e) || Zg(10, e);
        return Bh(e);
      }(e));
      var t = kh(this),
        r = Dh(e, void 0);
      return r[Jg].isManual_ = !0, xh(t), r;
    }
  }, {
    key: "finishDraft",
    value: function value(e, t) {
      var r = e && e[Jg];
      r && r.isManual_ || Zg(9);
      var a = r.scope_;
      return bh(a, t), _h(void 0, a);
    }
  }, {
    key: "setAutoFreeze",
    value: function value(e) {
      this.autoFreeze_ = e;
    }
  }, {
    key: "setUseStrictShallowCopy",
    value: function value(e) {
      this.useStrictShallowCopy_ = e;
    }
  }, {
    key: "applyPatches",
    value: function value(e, t) {
      var r;
      for (r = t.length - 1; r >= 0; r--) {
        var a = t[r];
        if (0 === a.path.length && "replace" === a.op) {
          e = a.value;
          break;
        }
      }
      r > -1 && (t = t.slice(r + 1));
      var n = gh("Patches").applyPatches_;
      return eh(e) ? n(e, t) : this.produce(e, function (e) {
        return n(e, t);
      });
    }
  }]), e;
}();
function Dh(e, t) {
  var r = sh(e) ? gh("MapSet").proxyMap_(e, t) : ch(e) ? gh("MapSet").proxySet_(e, t) : function (e, t) {
    var r = Array.isArray(e),
      a = {
        type_: r ? 1 : 0,
        scope_: t ? t.scope_ : hh(),
        modified_: !1,
        finalized_: !1,
        assigned_: {},
        parent_: t,
        base_: e,
        draft_: null,
        copy_: null,
        revoke_: null,
        isManual_: !1
      },
      n = a,
      o = jh;
    r && (n = [a], o = Eh);
    var i = Proxy.revocable(n, o),
      l = i.revoke,
      s = i.proxy;
    return a.draft_ = s, a.revoke_ = l, s;
  }(e, t);
  return (t ? t.scope_ : hh()).drafts_.push(r), r;
}
function Bh(e) {
  if (!th(e) || fh(e)) return e;
  var t,
    r = e[Jg];
  if (r) {
    if (!r.modified_) return r.base_;
    r.finalized_ = !0, t = dh(e, r.scope_.immer_.useStrictShallowCopy_);
  } else t = dh(e, !0);
  return nh(t, function (e, r) {
    lh(t, e, Bh(r));
  }), r && (r.finalized_ = !1), t;
}
var Ph = new Lh(),
  Ih = Ph.produce;
Ph.produceWithPatches.bind(Ph), Ph.setAutoFreeze.bind(Ph), Ph.setUseStrictShallowCopy.bind(Ph), Ph.applyPatches.bind(Ph), Ph.createDraft.bind(Ph), Ph.finishDraft.bind(Ph);
var zh = Ef,
  Rh = yo;
var Uh = function Uh(e, t, r) {
  (void 0 !== r && !Rh(e[t], r) || void 0 === r && !(t in e)) && zh(e, t, r);
};
var Hh = function Hh(e) {
    return function (t, r, a) {
      for (var n = -1, o = Object(t), i = a(t), l = i.length; l--;) {
        var s = i[e ? l : ++n];
        if (!1 === r(o[s], s, o)) break;
      }
      return t;
    };
  },
  Gh = Hh(),
  Vh = Sv,
  Wh = ea;
var Kh = function Kh(e) {
    return Wh(e) && Vh(e);
  },
  Yh = Qr,
  $h = ny,
  qh = ea,
  Jh = Function.prototype,
  Xh = Object.prototype,
  Zh = Jh.toString,
  Qh = Xh.hasOwnProperty,
  eb = Zh.call(Object);
var tb = function tb(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
  },
  rb = Bf,
  ab = Uv;
var nb = Uh,
  ob = Wv.exports,
  ib = qy,
  lb = Kv,
  sb = lg,
  cb = Wf,
  ub = wn,
  db = Kh,
  pb = Kf.exports,
  mb = An,
  fb = Tr,
  vb = function vb(e) {
    if (!qh(e) || "[object Object]" != Yh(e)) return !1;
    var t = $h(e);
    if (null === t) return !0;
    var r = Qh.call(t, "constructor") && t.constructor;
    return "function" == typeof r && r instanceof r && Zh.call(r) == eb;
  },
  yb = sv,
  gb = tb,
  hb = function hb(e) {
    return rb(e, ab(e));
  };
var bb = function bb(e, t, r, a, n, o, i) {
    var l = gb(e, r),
      s = gb(t, r),
      c = i.get(s);
    if (c) nb(e, r, c);else {
      var u = o ? o(l, s, r + "", e, t, i) : void 0,
        d = void 0 === u;
      if (d) {
        var p = ub(s),
          m = !p && pb(s),
          f = !p && !m && yb(s);
        u = s, p || m || f ? ub(l) ? u = l : db(l) ? u = lb(l) : m ? (d = !1, u = ob(s, !0)) : f ? (d = !1, u = ib(s, !0)) : u = [] : vb(s) || cb(s) ? (u = l, cb(l) ? u = hb(l) : fb(l) && !mb(l) || (u = sb(s))) : d = !1;
      }
      d && (i.set(s, u), n(u, s, a, o, i), i.delete(s)), nb(e, r, u);
    }
  },
  Nb = wf,
  xb = Uh,
  kb = Gh,
  wb = bb,
  _b = Tr,
  Fb = Uv,
  Sb = tb;
var Cb = function e(t, r, a, n, o) {
  t !== r && kb(r, function (i, l) {
    if (o || (o = new Nb()), _b(i)) wb(t, r, l, a, e, n, o);else {
      var s = n ? n(Sb(t, l), i, l + "", t, r, o) : void 0;
      void 0 === s && (s = i), xb(t, l, s);
    }
  }, Fb);
};
var jb = function jb(e) {
  return e;
};
var Eb = function Eb(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);
      case 1:
        return e.call(t, r[0]);
      case 2:
        return e.call(t, r[0], r[1]);
      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }
    return e.apply(t, r);
  },
  Tb = Eb,
  Ob = Math.max;
var Ab = function Ab(e, t, r) {
  return t = Ob(void 0 === t ? e.length - 1 : t, 0), function () {
    for (var a = arguments, n = -1, o = Ob(a.length - t, 0), i = Array(o); ++n < o;) i[n] = a[t + n];
    n = -1;
    for (var l = Array(t + 1); ++n < t;) l[n] = a[n];
    return l[t] = r(i), Tb(e, this, l);
  };
};
var Mb = function Mb(e) {
    return function () {
      return e;
    };
  },
  Lb = Cf,
  Db = Lb ? function (e, t) {
    return Lb(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Mb(t),
      writable: !0
    });
  } : jb,
  Bb = Db,
  Pb = Date.now;
var Ib = function Ib(e) {
    var t = 0,
      r = 0;
    return function () {
      var a = Pb(),
        n = 16 - (a - r);
      if (r = a, n > 0) {
        if (++t >= 800) return arguments[0];
      } else t = 0;
      return e.apply(void 0, arguments);
    };
  },
  zb = Ib(Bb),
  Rb = jb,
  Ub = Ab,
  Hb = zb;
var Gb = function Gb(e, t) {
    return Hb(Ub(e, t, Rb), e + "");
  },
  Vb = yo,
  Wb = Sv,
  Kb = qf,
  Yb = Tr;
var $b = function $b(e, t, r) {
    if (!Yb(r)) return !1;
    var a = ze(t);
    return !!("number" == a ? Wb(r) && Kb(t, r.length) : "string" == a && t in r) && Vb(r[t], e);
  },
  qb = Gb,
  Jb = $b;
var Xb = function Xb(e) {
    return qb(function (t, r) {
      var a = -1,
        n = r.length,
        o = n > 1 ? r[n - 1] : void 0,
        i = n > 2 ? r[2] : void 0;
      for (o = e.length > 3 && "function" == typeof o ? (n--, o) : void 0, i && Jb(r[0], r[1], i) && (o = n < 3 ? void 0 : o, n = 1), t = Object(t); ++a < n;) {
        var l = r[a];
        l && e(t, l, a, o);
      }
      return t;
    });
  },
  Zb = Cb,
  Qb = Xb(function (e, t, r) {
    Zb(e, t, r);
  }),
  eN = function eN(e) {
    var t,
      r,
      a,
      n,
      o,
      i,
      l,
      s,
      c = e.markets,
      u = e.eventDetails,
      d = e.type,
      p = e.useAvatar,
      m = c.flat(1 / 0),
      f = function (e) {
        var t = He(function () {
            return ph("function" == typeof e ? e() : e, !0);
          }),
          r = t[1];
        return [t[0], Ye(function (e) {
          r("function" == typeof e ? Ih(e) : ph(e));
        }, [])];
      }(m),
      v = Le(f, 2),
      y = v[0],
      g = v[1],
      h = u.home,
      b = u.away,
      N = u.competitor1,
      x = u.competitor2,
      k = u.sport,
      w = "soccer" === k ? h : b || N || {},
      _ = "soccer" === k ? b : h || x || {};
    Ve(function () {
      g(function (e) {
        var t = e.map(function (e, t) {
          return Qb(Yg(e), m[t]);
        });
        return t;
      });
    }, [c]), Ve(function () {
      g(function (e) {
        e.forEach(function (e, t) {
          var r,
            a,
            n,
            o = "competitor" in e && !!e.competitor,
            i = "competitors" in e && (null === (r = e.competitors) || void 0 === r ? void 0 : r.length);
          if (o && !i && "competitor" in e && null !== (a = e.competitor) && void 0 !== a && a.useAvatar && null !== (n = e.competitor) && void 0 !== n && n.hasPlayerName && u) {
            var l,
              s,
              c,
              m,
              f,
              v = null !== (l = e.competitor) && void 0 !== l && l.team ? null === (s = e.competitor) || void 0 === s ? void 0 : s.team : "";
            if (null !== (c = e.competitor) && void 0 !== c && c.hasPlayerName && u && "home" in u && "away" in u) v = e.competitor.home ? null === (m = u.home) || void 0 === m ? void 0 : m.team : null === (f = u.away) || void 0 === f ? void 0 : f.team;
            e.competitor = Te(Te({}, e.competitor), {
              team: v,
              groupBy: v
            });
          }
          if (o && "useAvatar" in (null == e ? void 0 : e.competitor) || i || (e.competitor = Te(Te({}, e.competitor), {
            useAvatar: p,
            avatar: {
              bgColor: "bg-default"
            }
          })), o && "sixpack" === d) 0 === t && (e.competitor = Object.assign(e.competitor, Te(Te({}, w), {}, {
            sport: k
          }))), 1 === t && (e.competitor = Object.assign(e.competitor, Te(Te({}, _), {}, {
            sport: k
          })));else if (i && "sixpack" === d) {
            var y;
            null === (y = e.competitors) || void 0 === y || y.forEach(function (e, t) {
              0 === t && (e = Object.assign(e, Te(Te({}, w), {}, {
                sport: k
              }))), 1 === t && (e = Object.assign(e, Te(Te({}, _), {}, {
                sport: k
              })));
            });
          }
        });
      });
    }, [u, null == u || null === (t = u.away) || void 0 === t ? void 0 : t.score, null == u || null === (r = u.away) || void 0 === r ? void 0 : r.possession, null == u || null === (a = u.home) || void 0 === a ? void 0 : a.score, null === (n = u.home) || void 0 === n ? void 0 : n.possession, null == u || null === (o = u.competitor1) || void 0 === o ? void 0 : o.score, null == u || null === (i = u.competitor1) || void 0 === i ? void 0 : i.possession, null == u || null === (l = u.competitor2) || void 0 === l ? void 0 : l.score, null == u || null === (s = u.competitor2) || void 0 === s ? void 0 : s.possession]);
    return [y, function (e) {
      var t = e.id,
        r = e.mutation;
      g(function (e) {
        var a = e.find(function (e) {
            return e.selections.some(function (e) {
              return e.id === t;
            });
          }),
          n = null == a ? void 0 : a.selections.findIndex(function (e) {
            return e.id === t;
          });
        void 0 !== n && a && (a.selections[n] = Te(Te({}, a.selections[n]), r));
      });
    }, g];
  },
  tN = {
    auto: "cui-col-auto",
    start: {
      1: "cui-col-start-1",
      2: "cui-col-start-2",
      3: "cui-col-start-3",
      4: "cui-col-start-4",
      5: "cui-col-start-5",
      6: "cui-col-start-6",
      7: "cui-col-start-7",
      8: "cui-col-start-8",
      9: "cui-col-start-9",
      10: "cui-col-start-10",
      11: "cui-col-start-11",
      12: "cui-col-start-12",
      auto: "cui-col-start-auto",
      halfway: "cui-col-start-[calc(calc(var(--cui-grid-cols)/2)+1)]"
    },
    end: {
      1: "cui-col-end-1",
      2: "cui-col-end-2",
      3: "cui-col-end-3",
      4: "cui-col-end-4",
      5: "cui-col-end-5",
      6: "cui-col-end-6",
      7: "cui-col-end-7",
      8: "cui-col-end-8",
      9: "cui-col-end-9",
      10: "cui-col-end-10",
      11: "cui-col-end-11",
      12: "cui-col-end-12",
      auto: "cui-col-end-auto",
      last: "cui-col-end-[-1]"
    },
    span: {
      1: "cui-col-span-1",
      2: "cui-col-span-2",
      3: "cui-col-span-3",
      4: "cui-col-span-4",
      5: "cui-col-span-5",
      6: "cui-col-span-6",
      7: "cui-col-span-7",
      8: "cui-col-span-8",
      9: "cui-col-span-9",
      10: "cui-col-span-10",
      11: "cui-col-span-11",
      12: "cui-col-span-12",
      full: "cui-col-span-full",
      auto: "cui-col-auto"
    }
  },
  rN = {
    auto: "cui-row-auto",
    start: {
      1: "cui-row-start-1",
      2: "cui-row-start-2",
      3: "cui-row-start-3",
      4: "cui-row-start-4",
      5: "cui-row-start-5",
      6: "cui-row-start-6",
      7: "cui-row-start-7",
      8: "cui-row-start-8",
      9: "cui-row-start-9",
      10: "cui-row-start-10",
      11: "cui-row-start-11",
      12: "cui-row-start-12",
      auto: "cui-row-start-auto",
      halfway: "cui-row-start-[calc(calc(var(--cui-grid-cols)/2)+1)]"
    },
    end: {
      1: "cui-row-end-1",
      2: "cui-row-end-2",
      3: "cui-row-end-3",
      4: "cui-row-end-4",
      5: "cui-row-end-5",
      6: "cui-row-end-6",
      7: "cui-row-end-7",
      8: "cui-row-end-8",
      9: "cui-row-end-9",
      10: "cui-row-end-10",
      11: "cui-row-end-11",
      12: "cui-row-end-12",
      auto: "cui-row-end-auto",
      last: "cui-row-end-[-1]"
    },
    span: {
      1: "cui-row-span-1",
      2: "cui-row-span-2",
      3: "cui-row-span-3",
      4: "cui-row-span-4",
      5: "cui-row-span-5",
      6: "cui-row-span-6",
      7: "cui-row-span-7",
      8: "cui-row-span-8",
      9: "cui-row-span-9",
      10: "cui-row-span-10",
      11: "cui-row-span-11",
      12: "cui-row-span-12",
      full: "cui-row-span-full",
      auto: "cui-row-auto"
    }
  },
  aN = {
    1: "cui-grid-cols-1",
    2: "cui-grid-cols-2",
    4: "cui-grid-cols-4",
    6: "cui-grid-cols-6",
    8: "cui-grid-cols-8",
    10: "cui-grid-cols-10",
    12: "cui-grid-cols-12"
  },
  nN = {
    "2px": "cui-gap-2px",
    "2xs": "cui-gap-2xs",
    xs: "cui-gap-xs",
    sm: "cui-gap-sm",
    md: "cui-gap-md",
    lg: "cui-gap-lg",
    none: "cui-gap-none"
  },
  oN = function oN(e) {
    var t = e.columns,
      r = void 0 === t ? 12 : t,
      a = e.flush,
      n = e.gap,
      o = void 0 === n ? "2xs" : n,
      i = e.children,
      l = e.className,
      s = void 0 === l ? "" : l,
      c = Me(e, O),
      u = {
        "--cui-grid-cols": r
      };
    return dt.exports.jsx("div", Te(Te({
      className: yt({
        "cui-mx-md": !a
      }, "cui-grid ".concat(aN[r], " ").concat(nN[o], " ").concat(s)),
      style: u
    }, c), {}, {
      children: i
    }));
  };
oN.Cell = function (e) {
  var t,
    r,
    a = e.colStart,
    n = e.colEnd,
    o = e.colSpan,
    i = void 0 === o ? 1 : o,
    l = e.rowStart,
    s = e.rowEnd,
    c = e.rowSpan,
    u = void 0 === c ? 1 : c,
    d = e.items,
    p = e.collapse,
    m = void 0 !== p && p,
    f = e.children,
    v = e.className,
    y = void 0 === v ? "" : v,
    g = Me(e, A),
    h = (Oe(t = {
      "cui-grid cui-place-items-center": "center" === d,
      "cui-grid cui-place-items-end": "end" === d
    }, tN.span[i], !!i && !m), Oe(t, rN.span[u], !!u && !m), t);
  return a && (h[tN.start[a]] = !!a), n && (h[tN.end[n]] = !!n), l && (h[rN.start[l]] = !!l), s && (h[rN.end[s]] = !!s), dt.exports.jsx("div", Te(Te({
    className: null === (r = yt(h, "".concat(y))) || void 0 === r ? void 0 : r.trim()
  }, g), {}, {
    children: f
  }));
};
var iN = {
  american: "a",
  decimal: "d",
  fraction: "f",
  a: "a",
  d: "d",
  f: "f"
};
function lN(e) {
  var t = "".concat(e),
    r = /\//.test(t),
    a = /\./.test(t);
  return /^\-/.test(t) || r || a ? "".concat(t) : "+".concat(t);
}
var sN = ["sp", "evs"];
function cN(e) {
  var t,
    r,
    a,
    n = e.competitor,
    o = e.competitors,
    i = e.marketHeader,
    l = e.marketTemplateTitle,
    s = e.sport,
    c = e.name,
    u = e.i,
    d = n && (null == n ? void 0 : n.displayName) || "",
    p = n && null != n && n.team ? n.team : "",
    m = (null == i || null === (t = i.labels) || void 0 === t ? void 0 : t.length) && (null == i ? void 0 : i.labels[u]) || "";
  o && o.length && ("soccer" === s ? (d = "", p = "", m = "money line") : (d = (null === (r = o[u]) || void 0 === r ? void 0 : r.displayName) || "", p = (null === (a = o[u]) || void 0 === a ? void 0 : a.team) || ""));
  return {
    columnHeader: m,
    displayName: d,
    team: p,
    marketName: c,
    marketTemplateTitle: l
  };
}
function uN(e, t, r) {
  var a = r.type,
    n = r.onSelectionClick,
    o = r.updateMarket,
    i = r.name,
    l = r.marketTemplateTitle,
    s = r.oddsFormat,
    c = r.buttonOnly,
    u = r.dataFilterGroup,
    d = r.sport,
    p = r.canSelectMarkets,
    m = r.selectedSelectionId,
    f = r.marketHeader,
    v = r.competitor,
    y = r.competitors,
    g = Ye(function (t, r) {
      (p || m && m === e.id) && n({
        e: t,
        id: r,
        selection: e,
        updateMarket: o
      });
    }, [e, o, m, p]),
    h = function (e, t) {
      return e ? e && "string" == typeof e && sN.includes(null == e ? void 0 : e.toLowerCase()) ? e : "object" === ze(e) ? e ? lN(e[iN[t]]) : null : "string" == typeof e ? /^\-|\+/.test(e) ? e : lN(e) : null : null;
    }(null == e ? void 0 : e.odds, s),
    b = cN({
      competitor: v,
      competitors: y,
      marketHeader: f,
      sport: d,
      name: i,
      i: t,
      marketTemplateTitle: l
    });
  return "row" === a ? dt.exports.jsx(oN.Cell, {
    colSpan: 2,
    items: "center",
    children: dt.exports.jsx(Mi, Te(Te({}, e), {}, {
      odds: h,
      fluid: !0,
      description: c && i && !e.description ? i : e.description,
      metadata: b,
      onClick: g,
      animation: "reduced"
    }))
  }, "msw-".concat("id" in e ? e.id : t)) : dt.exports.jsx(oN.Cell, {
    colSpan: 2,
    "data-filter-group": u,
    children: dt.exports.jsx(Mi, Te(Te({}, e), {}, {
      odds: h,
      metadata: b,
      fluid: !0,
      description: c && i && !e.description ? i : e.description,
      onClick: g,
      isDisabled: e.isDisabled || !p && m !== e.id,
      animation: "reduced"
    }))
  }, "msw-".concat("id" in e ? e.id : t));
}
var dN = Ke(function (e) {
    var t = e.competitor,
      r = e.name,
      a = e.hasMultipleCompetitors,
      n = e.buttonOnly,
      o = e.type,
      i = e.sport,
      l = e.hideScore,
      s = void 0 !== l && l,
      c = e.className,
      u = e.mode;
    if (n && !a) return null;
    var d = null != t && t.displayName ? null == t ? void 0 : t.displayName : r || "",
      p = r && !(null != t && t.displayName) && !(null != t && t.team) && !(null != t && t.country);
    return t ? dt.exports.jsx(Jp, Te(Te({}, t), {}, {
      displayName: d,
      score: s || null == t ? void 0 : t.score,
      center: "col" === o || "list-view-col" === o,
      className: c,
      tabbable: !1,
      lineClamp: p ? null : 2,
      sport: i,
      mode: u
    })) : dt.exports.jsx("span", {
      className: "heading-md",
      children: r
    });
  }),
  pN = function pN() {
    return dt.exports.jsxs("div", {
      className: "cui-h-[3px] cui-w-full cui-my-xs cui-relative",
      children: [dt.exports.jsx("div", {
        className: "cui-absolute cui-right-8 cui-h-1px cui-w-[calc(100%-64px)] cui-bg-fg-minimal"
      }), dt.exports.jsx("div", {
        className: "cui-absolute -cui-top-[6px] cui-h-3 cui-left-0 cui-w-6 cui-pr-2 heading-xs cui-bg-neutrals-transparent cui-text-fg-moderate cui-flex cui-items-center cui-justify-center",
        children: "vs"
      })]
    });
  },
  mN = {
    1: 10,
    2: 8,
    3: 6
  },
  fN = function fN() {},
  vN = function vN(e) {
    var t = e.selections,
      r = e.competitor,
      a = e.competitors,
      n = e.type,
      o = void 0 === n ? "row" : n,
      i = e.name,
      l = e.marketHeader,
      s = e.buttonOnly,
      c = void 0 !== s && s,
      u = (e.displayOrder, e.groupBy, e.oddsFormat),
      d = void 0 === u ? "american" : u,
      p = e.dataFilterGroup,
      m = void 0 === p ? "all" : p,
      f = e.canSelectMarkets,
      v = void 0 === f || f,
      y = e.selectedSelectionId,
      g = e.marketTemplateTitle,
      h = e.onSelectionClick,
      b = void 0 === h ? fN : h,
      N = e.updateMarket,
      x = void 0 === N ? fN : N,
      k = e.useSingleSelection,
      w = void 0 !== k && k,
      _ = e.showVersusDivider,
      F = void 0 === _ || _,
      S = e.id,
      C = e.sport,
      j = e.mode,
      E = Me(e, M),
      T = Ge("cui__market-".concat(Ra())),
      O = !(null == r || !r.displayName) || !(null == r || !r.team),
      A = !!i,
      L = Array.isArray(a) && 2 === a.length,
      D = Ye(function (e, r) {
        (v || y && y === t[0].id) && b({
          e: e,
          id: r,
          selection: t[0],
          updateMarket: x
        });
      }, [t[0], x, v]),
      B = {
        type: o,
        onSelectionClick: b,
        oddsFormat: d,
        updateMarket: x,
        buttonOnly: c,
        sport: C,
        name: i,
        canSelectMarkets: v,
        selectedSelectionId: y,
        dataFilterGroup: m,
        marketHeader: l,
        marketTemplateTitle: g,
        competitor: r,
        competitors: a
      },
      P = cN({
        competitor: r,
        competitors: a,
        marketHeader: l,
        sport: C,
        name: i,
        i: 0,
        marketTemplateTitle: g
      });
    return "row" === o ? dt.exports.jsxs(oN, Te(Te({
      className: "cui__market-row",
      "data-filter-group": w ? null : m,
      id: S || T.current
    }, E), {}, {
      flush: !0,
      children: [O || L || A ? dt.exports.jsx(oN.Cell, {
        colSpan: mN[null == t ? void 0 : t.length],
        className: "cui-flex cui-items-center",
        children: L ? dt.exports.jsxs("div", {
          className: "cui-w-full cui-flex cui-flex-col",
          children: [dt.exports.jsx(dN, {
            competitor: a[0],
            hasMultipleCompetitors: L,
            name: i,
            buttonOnly: c,
            type: o,
            sport: C,
            mode: j
          }), F ? dt.exports.jsx(pN, {}) : null, dt.exports.jsx(dN, {
            competitor: a[1],
            hasMultipleCompetitors: L,
            name: i,
            buttonOnly: c,
            type: o,
            sport: C,
            mode: j
          })]
        }) : dt.exports.jsx(dN, {
          competitor: r,
          hasMultipleCompetitors: L,
          name: i,
          buttonOnly: c,
          type: o,
          sport: C,
          mode: j
        })
      }) : null, null == t ? void 0 : t.map(function (e, t) {
        return uN(e, t, B);
      })]
    })) : dt.exports.jsxs("div", {
      className: "cui__market-col cui-flex cui-flex-col cui-gap-2xs",
      "data-filter-group-set": "cui__market-col-".concat(S),
      children: [O || A ? dt.exports.jsx(oN.Cell, {
        className: "cui-flex cui-items-center cui-justify-center",
        children: dt.exports.jsx(dN, {
          competitor: r,
          name: i,
          buttonOnly: c,
          type: o,
          hideScore: !0
        })
      }) : null, w ? dt.exports.jsx(Mi, Te(Te({}, t[0]), {}, {
        metadata: P,
        onClick: D,
        animation: "reduced",
        fluid: !0,
        isDisabled: t[0].isDisabled || !v && y !== t[0].id
      })) : null == t ? void 0 : t.map(function (e, t) {
        return uN(e, t, B);
      })]
    });
  },
  yN = {
    0: "full",
    1: 10,
    2: 8,
    3: 6,
    4: 4
  },
  gN = {
    1: 2,
    2: 4,
    3: 6,
    4: 8
  },
  hN = function hN(e) {
    var t = e.caption,
      r = e.numberOfLabels;
    return dt.exports.jsx(oN.Cell, {
      colSpan: gN[r],
      items: "center",
      className: yt(Oe({}, "cui-border-0 cui-border-solid cui-border-b-1 cui-border-fg-primary-minimal !cui-gap-r-0", !!t), "cui-text-fg-primary-strong cui-text-center heading-xs-bold cui-line-clamp-2"),
      children: t
    });
  },
  bN = function bN(e) {
    var t,
      r = e.caption,
      a = e.labels,
      n = void 0 === a ? [] : a,
      o = e.details,
      i = e.title,
      l = e.description,
      s = e.bg,
      c = void 0 === s ? "neutrals-transparent" : s,
      u = e.noBorder,
      d = e.hasSGP,
      p = e.className,
      m = Me(e, L);
    if (!(null != n && n.length || l || i || r)) return null;
    var f = null == n ? void 0 : n.length,
      v = n.map(function (e, t) {
        var r = {
          hasWhiteSpace: !0,
          hasSGP: !1,
          label: ""
        };
        return "string" == typeof e && e ? (r.hasWhiteSpace = /\s/.test(e), r.hasSGP = /^\[SGP\]/.test(e), r.label = r.hasSGP ? e.replace(/^\[SGP\]/, "").trim() : e.trim()) : "object" === ze(e) && "text" in e && e.text && (r.hasWhiteSpace = /\s/.test(e.text), r.hasSGP = (null == e ? void 0 : e.hasSGP) || !1, r.label = e.text.trim()), dt.exports.jsx(oN.Cell, {
          colSpan: 2,
          items: "center",
          className: "",
          children: dt.exports.jsxs("div", {
            className: yt({
              "cui-break-words": r.hasWhiteSpace,
              "cui-truncate": !r.hasWhiteSpace
            }, "heading-xs cui-text-fg-moderate cui-text-center cui-w-full cui-inline"),
            children: [r.hasSGP ? dt.exports.jsx(rs, {
              name: "ui_sgp",
              size: "sm",
              className: "cui-mr-1 cui-align-text-top",
              color: "fg-primary-strong"
            }) : null, dt.exports.jsx("span", {
              children: r.label
            })]
          })
        }, "mh-".concat(e, "-").concat(t));
      });
    return dt.exports.jsxs(oN, Te(Te({
      className: yt((t = {}, Oe(t, pn[c], "none" !== c), Oe(t, "cui-pb-1 cui-border-0 cui-border-solid cui-border-b-1 cui-border-fg-minimal", !u), t), "".concat(p))
    }, m), {}, {
      flush: !0,
      children: [dt.exports.jsx(NN, {
        hasCaption: !!r,
        hasDetails: Array.isArray(o) && !!o.length,
        details: o,
        hasSGP: d,
        numLabels: f,
        title: i,
        description: l
      }), r ? dt.exports.jsx(hN, {
        caption: r,
        numberOfLabels: f
      }) : null, !r && i && l && f > 2 ? dt.exports.jsx(oN.Cell, {
        colSpan: yN[f]
      }) : null, l ? dt.exports.jsx(oN.Cell, {
        colSpan: yN[f],
        className: "body-xs cui-text-fg-moderate",
        children: l
      }) : null, v]
    }));
  },
  NN = function NN(e) {
    var t = e.hasDetails,
      r = e.hasCaption,
      a = e.numLabels,
      n = e.details,
      o = e.title,
      i = e.hasSGP,
      l = e.description,
      s = {
        colSpan: yN[a],
        rowSpan: !r || l || o ? 1 : 2
      },
      c = i ? [{
        leftIcon: {
          name: "ui_sgp",
          size: "lg",
          color: "fg-primary-strong"
        }
      }] : [];
    return Array.isArray(n) && n.length && c.push.apply(c, Ce(n)), o ? dt.exports.jsx(oN.Cell, Te(Te({}, s), {}, {
      className: "heading-sm-bold cui-text-fg-moderate",
      children: o
    })) : t || i ? dt.exports.jsx(dt.exports.Fragment, {
      children: dt.exports.jsx(oN.Cell, Te(Te({}, s), {}, {
        children: dt.exports.jsx("div", {
          className: yt({
            "-cui-ml-1": i && !(null != n && n.length)
          }, "cui-flex cui-items-center cui-h-full"),
          children: dt.exports.jsx(cc, {
            list: c
          })
        })
      }))
    }) : dt.exports.jsx(oN.Cell, Te({}, s));
  },
  xN = function xN() {},
  kN = function kN(e) {
    var t = e.details,
      r = e.hasSGP,
      a = void 0 !== r && r,
      n = e.hasFirebets,
      o = void 0 !== n && n,
      i = e.moreWagers,
      l = void 0 !== i && i,
      s = e.showMore,
      c = void 0 !== s && s,
      u = e.showLimit,
      d = (e.filters, e.showMoreTotal),
      p = e.canShowLess,
      m = void 0 === p || p,
      f = e.onShowMoreClick,
      v = void 0 === f ? xN : f,
      y = Me(e, D),
      g = (t || {}).list,
      h = Xe(function () {
        var e = [a ? {
          type: "sgp"
        } : null, o ? {
          type: "firebets"
        } : null, l ? {
          tag: "More",
          fgColor: "fg-primary",
          rightIcon: {
            name: "ui_chevron-right",
            color: "fg-primary"
          }
        } : null].filter(function (e) {
          return !!e;
        });
        return e.length ? e : [];
      }, [l, o, a]);
    return dt.exports.jsxs(oN, Te(Te({}, y), {}, {
      flush: !0,
      children: [dt.exports.jsx(oN.Cell, {
        colSpan: 8,
        children: null != g && g.length ? dt.exports.jsx(cc, {
          list: g
        }) : null
      }), dt.exports.jsx(oN.Cell, {
        colSpan: 4,
        items: "end",
        className: "cui-items-start",
        children: h.length ? dt.exports.jsx(cc, {
          list: h
        }) : null
      }), "all" !== u && c ? dt.exports.jsx(oN.Cell, {
        colSpan: "full",
        children: dt.exports.jsx("div", {
          className: "cui-flex cui-justify-center cui-text-fg-primary body-md-bold",
          children: dt.exports.jsx(nd, {
            text: "Show More ".concat(d && -1 !== Math.sign(d) ? "(".concat(d, ")") : ""),
            type: "minimal",
            size: "sm",
            rightIcon: "ui_chevron-down",
            onClick: v
          })
        })
      }) : m && "all" === u ? dt.exports.jsx(oN.Cell, {
        colSpan: "full",
        children: dt.exports.jsx("div", {
          className: "cui-flex cui-justify-center cui-text-fg-primary body-md-bold",
          children: dt.exports.jsx(nd, {
            text: "Show Less",
            type: "minimal",
            size: "sm",
            rightIcon: "ui_chevron-up",
            onClick: v
          })
        })
      }) : null]
    }));
  };
function wN(e, t) {
  return e && dt.exports.jsx(e.type, Te(Te({}, e.props), t));
}
function _N(e) {
  return _N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _N(e);
}
function FN(e) {
  var t = function (e, t) {
    if ("object" !== _N(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== _N(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === _N(t) ? t : String(t);
}
function SN(e, t, r) {
  return (t = FN(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function CN(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function jN(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? CN(Object(r), !0).forEach(function (t) {
      SN(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CN(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function EN(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function TN(e, t) {
  if (e) {
    if ("string" == typeof e) return EN(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? EN(e, t) : void 0;
  }
}
function ON(e) {
  return function (e) {
    if (Array.isArray(e)) return EN(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || TN(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function AN(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || TN(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var MN = {
  exports: {}
};
!function (e) {
  !function () {
    var t = {}.hasOwnProperty;
    function r() {
      for (var e = [], a = 0; a < arguments.length; a++) {
        var n = arguments[a];
        if (n) {
          var o = ze(n);
          if ("string" === o || "number" === o) e.push(n);else if (Array.isArray(n)) {
            if (n.length) {
              var i = r.apply(null, n);
              i && e.push(i);
            }
          } else if ("object" === o) {
            if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) {
              e.push(n.toString());
              continue;
            }
            for (var l in n) t.call(n, l) && n[l] && e.push(l);
          }
        }
      }
      return e.join(" ");
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  }();
}(MN);
var LN = MN.exports;
function DN(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function BN(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return DN(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? DN(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function PN(e) {
  var t = Re.useRef();
  t.current = e;
  var r = Re.useCallback(function () {
    for (var e, r = arguments.length, a = new Array(r), n = 0; n < r; n++) a[n] = arguments[n];
    return null === (e = t.current) || void 0 === e ? void 0 : e.call.apply(e, [t].concat(a));
  }, []);
  return r;
}
function IN() {
  return !("undefined" == typeof window || !window.document || !window.document.createElement);
}
var zN = "test" !== process.env.NODE_ENV && IN() ? Re.useLayoutEffect : Re.useEffect,
  RN = function RN(e, t) {
    var r = Re.useRef(!0);
    zN(function () {
      return e(r.current);
    }, t), zN(function () {
      return r.current = !1, function () {
        r.current = !0;
      };
    }, []);
  },
  UN = function UN(e, t) {
    RN(function (t) {
      if (!t) return e();
    }, t);
  };
function HN(e) {
  var t = Re.useRef(!1),
    r = BN(Re.useState(e), 2),
    a = r[0],
    n = r[1];
  return Re.useEffect(function () {
    return t.current = !1, function () {
      t.current = !0;
    };
  }, []), [a, function (e, r) {
    r && t.current || n(e);
  }];
}
function GN(e) {
  return void 0 !== e;
}
function VN(e) {
  return VN = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, VN(e);
}
var WN = {},
  KN = [];
function YN(e, t) {
  if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
    var r = KN.reduce(function (e, t) {
      return t(null != e ? e : "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function $N(e, t) {
  if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
    var r = KN.reduce(function (e, t) {
      return t(null != e ? e : "", "note");
    }, t);
    r && "Note: ".concat(r);
  }
}
function qN(e, t, r) {
  t || WN[r] || (e(!1, r), WN[r] = !0);
}
function JN(e, t) {
  qN(YN, e, t);
}
JN.preMessage = function (e) {
  KN.push(e);
}, JN.resetWarned = function () {
  WN = {};
}, JN.noteOnce = function (e, t) {
  qN($N, e, t);
};
var XN = Re.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
});
function ZN() {
  return ZN = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, ZN.apply(this, arguments);
}
function QN(e, t) {
  if (null == e) return {};
  var r,
    a,
    n = function (e, t) {
      if (null == e) return {};
      var r,
        a,
        n = {},
        o = Object.keys(e);
      for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || (n[r] = e[r]);
      return n;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var ex = {
    MAC_ENTER: 3,
    BACKSPACE: 8,
    TAB: 9,
    NUM_CENTER: 12,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINT_SCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    QUESTION_MARK: 63,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    WIN_KEY_RIGHT: 92,
    CONTEXT_MENU: 93,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUMLOCK: 144,
    SEMICOLON: 186,
    DASH: 189,
    EQUALS: 187,
    COMMA: 188,
    PERIOD: 190,
    SLASH: 191,
    APOSTROPHE: 192,
    SINGLE_QUOTE: 222,
    OPEN_SQUARE_BRACKET: 219,
    BACKSLASH: 220,
    CLOSE_SQUARE_BRACKET: 221,
    WIN_KEY: 224,
    MAC_FF_META: 224,
    WIN_IME: 229,
    isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
      var t = e.keyCode;
      if (e.altKey && !e.ctrlKey || e.metaKey || t >= ex.F1 && t <= ex.F12) return !1;
      switch (t) {
        case ex.ALT:
        case ex.CAPS_LOCK:
        case ex.CONTEXT_MENU:
        case ex.CTRL:
        case ex.DOWN:
        case ex.END:
        case ex.ESC:
        case ex.HOME:
        case ex.INSERT:
        case ex.LEFT:
        case ex.MAC_FF_META:
        case ex.META:
        case ex.NUMLOCK:
        case ex.NUM_CENTER:
        case ex.PAGE_DOWN:
        case ex.PAGE_UP:
        case ex.PAUSE:
        case ex.PRINT_SCREEN:
        case ex.RIGHT:
        case ex.SHIFT:
        case ex.UP:
        case ex.WIN_KEY:
        case ex.WIN_KEY_RIGHT:
          return !1;
        default:
          return !0;
      }
    },
    isCharacterKey: function isCharacterKey(e) {
      if (e >= ex.ZERO && e <= ex.NINE) return !0;
      if (e >= ex.NUM_ZERO && e <= ex.NUM_MULTIPLY) return !0;
      if (e >= ex.A && e <= ex.Z) return !0;
      if (-1 !== window.navigator.userAgent.indexOf("WebKit") && 0 === e) return !0;
      switch (e) {
        case ex.SPACE:
        case ex.QUESTION_MARK:
        case ex.NUM_PLUS:
        case ex.NUM_MINUS:
        case ex.NUM_PERIOD:
        case ex.NUM_DIVISION:
        case ex.SEMICOLON:
        case ex.DASH:
        case ex.EQUALS:
        case ex.COMMA:
        case ex.PERIOD:
        case ex.SLASH:
        case ex.APOSTROPHE:
        case ex.SINGLE_QUOTE:
        case ex.OPEN_SQUARE_BRACKET:
        case ex.BACKSLASH:
        case ex.CLOSE_SQUARE_BRACKET:
          return !0;
        default:
          return !1;
      }
    }
  },
  tx = ex;
function rx(e, t, r) {
  return (e - t) / (r - t);
}
function ax(e, t, r, a) {
  var n = rx(t, r, a),
    o = {};
  switch (e) {
    case "rtl":
      o.right = "".concat(100 * n, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(100 * n, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(100 * n, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(100 * n, "%"), o.transform = "translateX(-50%)";
  }
  return o;
}
function nx(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var ox = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange"],
  ix = Re.forwardRef(function (e, t) {
    var r,
      a,
      n = e.prefixCls,
      o = e.value,
      i = e.valueIndex,
      l = e.onStartMove,
      s = e.style,
      c = e.render,
      u = e.dragging,
      d = e.onOffsetChange,
      p = QN(e, ox),
      m = Re.useContext(XN),
      f = m.min,
      v = m.max,
      y = m.direction,
      g = m.disabled,
      h = m.keyboard,
      b = m.range,
      N = m.tabIndex,
      x = m.ariaLabelForHandle,
      k = m.ariaLabelledByForHandle,
      w = m.ariaValueTextFormatterForHandle,
      _ = m.styles,
      F = m.classNames,
      S = "".concat(n, "-handle"),
      C = function C(e) {
        g || l(e, i);
      },
      j = ax(y, o, f, v),
      E = Re.createElement("div", ZN({
        ref: t,
        className: LN(S, (r = {}, SN(r, "".concat(S, "-").concat(i + 1), b), SN(r, "".concat(S, "-dragging"), u), r), F.handle),
        style: jN(jN(jN({}, j), s), _.handle),
        onMouseDown: C,
        onTouchStart: C,
        onKeyDown: function onKeyDown(e) {
          if (!g && h) {
            var t = null;
            switch (e.which || e.keyCode) {
              case tx.LEFT:
                t = "ltr" === y || "btt" === y ? -1 : 1;
                break;
              case tx.RIGHT:
                t = "ltr" === y || "btt" === y ? 1 : -1;
                break;
              case tx.UP:
                t = "ttb" !== y ? 1 : -1;
                break;
              case tx.DOWN:
                t = "ttb" !== y ? -1 : 1;
                break;
              case tx.HOME:
                t = "min";
                break;
              case tx.END:
                t = "max";
                break;
              case tx.PAGE_UP:
                t = 2;
                break;
              case tx.PAGE_DOWN:
                t = -2;
            }
            null !== t && (e.preventDefault(), d(t, i));
          }
        },
        tabIndex: g ? null : nx(N, i),
        role: "slider",
        "aria-valuemin": f,
        "aria-valuemax": v,
        "aria-valuenow": o,
        "aria-disabled": g,
        "aria-label": nx(x, i),
        "aria-labelledby": nx(k, i),
        "aria-valuetext": null === (a = nx(w, i)) || void 0 === a ? void 0 : a(o),
        "aria-orientation": "ltr" === y || "rtl" === y ? "horizontal" : "vertical"
      }, p));
    return c && (E = c(E, {
      index: i,
      prefixCls: n,
      value: o,
      dragging: u
    })), E;
  });
"production" !== process.env.NODE_ENV && (ix.displayName = "Handle");
var lx = ix,
  sx = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "draggingIndex"],
  cx = Re.forwardRef(function (e, t) {
    var r = e.prefixCls,
      a = e.style,
      n = e.onStartMove,
      o = e.onOffsetChange,
      i = e.values,
      l = e.handleRender,
      s = e.draggingIndex,
      c = QN(e, sx),
      u = Re.useRef({});
    return Re.useImperativeHandle(t, function () {
      return {
        focus: function focus(e) {
          var t;
          null === (t = u.current[e]) || void 0 === t || t.focus();
        }
      };
    }), Re.createElement(Re.Fragment, null, i.map(function (e, t) {
      return Re.createElement(lx, ZN({
        ref: function ref(e) {
          e ? u.current[t] = e : delete u.current[t];
        },
        dragging: s === t,
        prefixCls: r,
        style: nx(a, t),
        key: t,
        value: e,
        valueIndex: t,
        onStartMove: n,
        onOffsetChange: o,
        render: l
      }, c));
    }));
  });
"production" !== process.env.NODE_ENV && (cx.displayName = "Handles");
var ux = cx;
function dx(e) {
  var t = "touches" in e ? e.touches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function px(e) {
  var t = e.prefixCls,
    r = e.style,
    a = e.children,
    n = e.value,
    o = e.onClick,
    i = Re.useContext(XN),
    l = i.min,
    s = i.max,
    c = i.direction,
    u = i.includedStart,
    d = i.includedEnd,
    p = i.included,
    m = "".concat(t, "-text"),
    f = ax(c, n, l, s);
  return Re.createElement("span", {
    className: LN(m, SN({}, "".concat(m, "-active"), p && u <= n && n <= d)),
    style: jN(jN({}, f), r),
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    },
    onClick: function onClick() {
      o(n);
    }
  }, a);
}
function mx(e) {
  var t = e.prefixCls,
    r = e.marks,
    a = e.onClick,
    n = "".concat(t, "-mark");
  return r.length ? Re.createElement("div", {
    className: n
  }, r.map(function (e) {
    var t = e.value,
      r = e.style,
      o = e.label;
    return Re.createElement(px, {
      key: t,
      prefixCls: n,
      style: r,
      value: t,
      onClick: a
    }, o);
  })) : null;
}
function fx(e) {
  var t = e.prefixCls,
    r = e.value,
    a = e.style,
    n = e.activeStyle,
    o = Re.useContext(XN),
    i = o.min,
    l = o.max,
    s = o.direction,
    c = o.included,
    u = o.includedStart,
    d = o.includedEnd,
    p = "".concat(t, "-dot"),
    m = c && u <= r && r <= d,
    f = jN(jN({}, ax(s, r, i, l)), "function" == typeof a ? a(r) : a);
  return m && (f = jN(jN({}, f), "function" == typeof n ? n(r) : n)), Re.createElement("span", {
    className: LN(p, SN({}, "".concat(p, "-active"), m)),
    style: f
  });
}
function vx(e) {
  var t = e.prefixCls,
    r = e.marks,
    a = e.dots,
    n = e.style,
    o = e.activeStyle,
    i = Re.useContext(XN),
    l = i.min,
    s = i.max,
    c = i.step,
    u = Re.useMemo(function () {
      var e = new Set();
      if (r.forEach(function (t) {
        e.add(t.value);
      }), a && null !== c) for (var t = l; t <= s;) e.add(t), t += c;
      return Array.from(e);
    }, [l, s, c, a, r]);
  return Re.createElement("div", {
    className: "".concat(t, "-step")
  }, u.map(function (e) {
    return Re.createElement(fx, {
      prefixCls: t,
      key: e,
      value: e,
      style: n,
      activeStyle: o
    });
  }));
}
function yx(e) {
  var t,
    r = e.prefixCls,
    a = e.style,
    n = e.start,
    o = e.end,
    i = e.index,
    l = e.onStartMove,
    s = e.replaceCls,
    c = Re.useContext(XN),
    u = c.direction,
    d = c.min,
    p = c.max,
    m = c.disabled,
    f = c.range,
    v = c.classNames,
    y = "".concat(r, "-track"),
    g = rx(n, d, p),
    h = rx(o, d, p),
    b = function b(e) {
      !m && l && l(e, -1);
    },
    N = {};
  switch (u) {
    case "rtl":
      N.right = "".concat(100 * g, "%"), N.width = "".concat(100 * h - 100 * g, "%");
      break;
    case "btt":
      N.bottom = "".concat(100 * g, "%"), N.height = "".concat(100 * h - 100 * g, "%");
      break;
    case "ttb":
      N.top = "".concat(100 * g, "%"), N.height = "".concat(100 * h - 100 * g, "%");
      break;
    default:
      N.left = "".concat(100 * g, "%"), N.width = "".concat(100 * h - 100 * g, "%");
  }
  var x = s || LN(y, (SN(t = {}, "".concat(y, "-").concat(i + 1), null !== i && f), SN(t, "".concat(r, "-track-draggable"), l), t), v.track);
  return Re.createElement("div", {
    className: x,
    style: jN(jN({}, N), a),
    onMouseDown: b,
    onTouchStart: b
  });
}
function gx(e) {
  var t = e.prefixCls,
    r = e.style,
    a = e.values,
    n = e.startPoint,
    o = e.onStartMove,
    i = Re.useContext(XN),
    l = i.included,
    s = i.range,
    c = i.min,
    u = i.styles,
    d = i.classNames,
    p = Re.useMemo(function () {
      if (!s) {
        if (0 === a.length) return [];
        var e = null != n ? n : c,
          t = a[0];
        return [{
          start: Math.min(e, t),
          end: Math.max(e, t)
        }];
      }
      for (var r = [], o = 0; o < a.length - 1; o += 1) r.push({
        start: a[o],
        end: a[o + 1]
      });
      return r;
    }, [a, s, n, c]),
    m = null;
  return (d.tracks || u.tracks) && (m = Re.createElement(yx, {
    index: null,
    prefixCls: t,
    start: p[0].start,
    end: p[p.length - 1].end,
    replaceCls: LN(d.tracks, "".concat(t, "-tracks")),
    style: u.tracks
  })), l ? Re.createElement(Re.Fragment, null, m, p.map(function (e, a) {
    var n = e.start,
      i = e.end;
    return Re.createElement(yx, {
      index: a,
      prefixCls: t,
      style: jN(jN({}, nx(r, a)), u.track),
      start: n,
      end: i,
      key: a,
      onStartMove: o
    });
  })) : null;
}
var hx = Re.forwardRef(function (e, t) {
  var r,
    a = e.prefixCls,
    n = void 0 === a ? "rc-slider" : a,
    o = e.className,
    i = e.style,
    l = e.classNames,
    s = e.styles,
    c = e.disabled,
    u = void 0 !== c && c,
    d = e.keyboard,
    p = void 0 === d || d,
    m = e.autoFocus,
    f = e.onFocus,
    v = e.onBlur,
    y = e.min,
    g = void 0 === y ? 0 : y,
    h = e.max,
    b = void 0 === h ? 100 : h,
    N = e.step,
    x = void 0 === N ? 1 : N,
    k = e.value,
    w = e.defaultValue,
    _ = e.range,
    F = e.count,
    S = e.onChange,
    C = e.onBeforeChange,
    j = e.onAfterChange,
    E = e.allowCross,
    T = void 0 === E || E,
    O = e.pushable,
    A = void 0 !== O && O,
    M = e.draggableTrack,
    L = e.reverse,
    D = e.vertical,
    B = e.included,
    P = void 0 === B || B,
    I = e.startPoint,
    z = e.trackStyle,
    R = e.handleStyle,
    U = e.railStyle,
    H = e.dotStyle,
    G = e.activeDotStyle,
    V = e.marks,
    W = e.dots,
    K = e.handleRender,
    Y = e.tabIndex,
    $ = void 0 === Y ? 0 : Y,
    q = e.ariaLabelForHandle,
    J = e.ariaLabelledByForHandle,
    X = e.ariaValueTextFormatterForHandle,
    Z = Re.useRef(),
    Q = Re.useRef(),
    ee = Re.useMemo(function () {
      return D ? L ? "ttb" : "btt" : L ? "rtl" : "ltr";
    }, [L, D]),
    te = Re.useMemo(function () {
      return isFinite(g) ? g : 0;
    }, [g]),
    re = Re.useMemo(function () {
      return isFinite(b) ? b : 100;
    }, [b]),
    ae = Re.useMemo(function () {
      return null !== x && x <= 0 ? 1 : x;
    }, [x]),
    ne = Re.useMemo(function () {
      return "boolean" == typeof A ? !!A && ae : A >= 0 && A;
    }, [A, ae]),
    oe = Re.useMemo(function () {
      return Object.keys(V || {}).map(function (e) {
        var t = V[e],
          r = {
            value: Number(e)
          };
        return t && "object" === _N(t) && !Re.isValidElement(t) && ("label" in t || "style" in t) ? (r.style = t.style, r.label = t.label) : r.label = t, r;
      }).filter(function (e) {
        var t = e.label;
        return t || "number" == typeof t;
      }).sort(function (e, t) {
        return e.value - t.value;
      });
    }, [V]),
    ie = function (e, t, r, a, n, o) {
      var i = Re.useCallback(function (r) {
          var a = isFinite(r) ? r : e;
          return a = Math.min(t, r), Math.max(e, a);
        }, [e, t]),
        l = Re.useCallback(function (a) {
          if (null !== r) {
            var n = e + Math.round((i(a) - e) / r) * r,
              o = function o(e) {
                return (String(e).split(".")[1] || "").length;
              },
              l = Math.max(o(r), o(t), o(e)),
              s = Number(n.toFixed(l));
            return e <= s && s <= t ? s : null;
          }
          return null;
        }, [r, e, t, i]),
        s = Re.useCallback(function (n) {
          var o = i(n),
            s = a.map(function (e) {
              return e.value;
            });
          null !== r && s.push(l(n)), s.push(e, t);
          var c = s[0],
            u = t - e;
          return s.forEach(function (e) {
            var t = Math.abs(o - e);
            t <= u && (c = e, u = t);
          }), c;
        }, [e, t, a, r, i, l]),
        c = function n(o, i, s) {
          var c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit";
          if ("number" == typeof i) {
            var u,
              d = o[s],
              p = d + i,
              m = [];
            a.forEach(function (e) {
              m.push(e.value);
            }), m.push(e, t), m.push(l(d));
            var f = i > 0 ? 1 : -1;
            "unit" === c ? m.push(l(d + f * r)) : m.push(l(p)), m = m.filter(function (e) {
              return null !== e;
            }).filter(function (e) {
              return i < 0 ? e <= d : e >= d;
            }), "unit" === c && (m = m.filter(function (e) {
              return e !== d;
            }));
            var v = "unit" === c ? d : p;
            u = m[0];
            var y = Math.abs(u - v);
            if (m.forEach(function (e) {
              var t = Math.abs(e - v);
              t < y && (u = e, y = t);
            }), void 0 === u) return i < 0 ? e : t;
            if ("dist" === c) return u;
            if (Math.abs(i) > 1) {
              var g = ON(o);
              return g[s] = u, n(g, i - f, s, c);
            }
            return u;
          }
          return "min" === i ? e : "max" === i ? t : void 0;
        },
        u = function u(e, t, r) {
          var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit",
            n = e[r],
            o = c(e, t, r, a);
          return {
            value: o,
            changed: o !== n
          };
        },
        d = function d(e) {
          return null === o && 0 === e || "number" == typeof o && e < o;
        };
      return [s, function (e, t, r) {
        var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit",
          i = e.map(s),
          l = i[r],
          p = c(i, t, r, a);
        if (i[r] = p, !1 === n) {
          var m = o || 0;
          r > 0 && i[r - 1] !== l && (i[r] = Math.max(i[r], i[r - 1] + m)), r < i.length - 1 && i[r + 1] !== l && (i[r] = Math.min(i[r], i[r + 1] - m));
        } else if ("number" == typeof o || null === o) {
          for (var f = r + 1; f < i.length; f += 1) for (var v = !0; d(i[f] - i[f - 1]) && v;) {
            var y = u(i, 1, f);
            i[f] = y.value, v = y.changed;
          }
          for (var g = r; g > 0; g -= 1) for (var h = !0; d(i[g] - i[g - 1]) && h;) {
            var b = u(i, -1, g - 1);
            i[g - 1] = b.value, h = b.changed;
          }
          for (var N = i.length - 1; N > 0; N -= 1) for (var x = !0; d(i[N] - i[N - 1]) && x;) {
            var k = u(i, -1, N - 1);
            i[N - 1] = k.value, x = k.changed;
          }
          for (var w = 0; w < i.length - 1; w += 1) for (var _ = !0; d(i[w + 1] - i[w]) && _;) {
            var F = u(i, 1, w + 1);
            i[w + 1] = F.value, _ = F.changed;
          }
        }
        return {
          value: i[r],
          values: i
        };
      }];
    }(te, re, ae, oe, T, ne),
    le = AN(ie, 2),
    se = le[0],
    ce = le[1],
    ue = function (e, t) {
      var r = t || {},
        a = r.defaultValue,
        n = r.value,
        o = r.onChange,
        i = r.postState,
        l = BN(HN(function () {
          return GN(n) ? n : GN(a) ? "function" == typeof a ? a() : a : "function" == typeof e ? e() : e;
        }), 2),
        s = l[0],
        c = l[1],
        u = void 0 !== n ? n : s,
        d = i ? i(u) : u,
        p = PN(o),
        m = BN(HN([u]), 2),
        f = m[0],
        v = m[1];
      return UN(function () {
        var e = f[0];
        s !== e && p(s, e);
      }, [f]), UN(function () {
        GN(n) || c(n);
      }, [n]), [d, PN(function (e, t) {
        c(e, t), v([u], t);
      })];
    }(w, {
      value: k
    }),
    de = AN(ue, 2),
    pe = de[0],
    me = de[1],
    fe = Re.useMemo(function () {
      var e = null == pe ? [] : Array.isArray(pe) ? pe : [pe],
        t = AN(e, 1)[0],
        r = null === pe ? [] : [void 0 === t ? te : t];
      if (_) {
        if (r = ON(e), F || void 0 === pe) {
          var a = F >= 0 ? F + 1 : 2;
          for (r = r.slice(0, a); r.length < a;) {
            var n;
            r.push(null !== (n = r[r.length - 1]) && void 0 !== n ? n : te);
          }
        }
        r.sort(function (e, t) {
          return e - t;
        });
      }
      return r.forEach(function (e, t) {
        r[t] = se(e);
      }), r;
    }, [pe, _, te, F, se]),
    ve = Re.useRef(fe);
  ve.current = fe;
  var ye = function ye(e) {
      return _ ? e : e[0];
    },
    ge = function ge(e) {
      var t = ON(e).sort(function (e, t) {
        return e - t;
      });
      S && !function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          a = new Set();
        function n(e, t) {
          var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            i = a.has(e);
          if (JN(!i, "Warning: There may be circular references"), i) return !1;
          if (e === t) return !0;
          if (r && o > 1) return !1;
          a.add(e);
          var l = o + 1;
          if (Array.isArray(e)) {
            if (!Array.isArray(t) || e.length !== t.length) return !1;
            for (var s = 0; s < e.length; s++) if (!n(e[s], t[s], l)) return !1;
            return !0;
          }
          if (e && t && "object" === VN(e) && "object" === VN(t)) {
            var c = Object.keys(e);
            return c.length === Object.keys(t).length && c.every(function (r) {
              return n(e[r], t[r], l);
            });
          }
          return !1;
        }
        return n(e, t);
      }(t, ve.current, !0) && S(ye(t)), me(t);
    },
    he = function (e, t, r, a, n, o, i, l, s) {
      var c = AN(Re.useState(null), 2),
        u = c[0],
        d = c[1],
        p = AN(Re.useState(-1), 2),
        m = p[0],
        f = p[1],
        v = AN(Re.useState(r), 2),
        y = v[0],
        g = v[1],
        h = AN(Re.useState(r), 2),
        b = h[0],
        N = h[1],
        x = Re.useRef(null),
        k = Re.useRef(null);
      Re.useEffect(function () {
        -1 === m && g(r);
      }, [r, m]), Re.useEffect(function () {
        return function () {
          document.removeEventListener("mousemove", x.current), document.removeEventListener("mouseup", k.current), document.removeEventListener("touchmove", x.current), document.removeEventListener("touchend", k.current);
        };
      }, []);
      var w = function w(e, t) {
          y.some(function (t, r) {
            return t !== e[r];
          }) && (void 0 !== t && d(t), g(e), i(e));
        },
        _ = function _(e, t) {
          if (-1 === e) {
            var r = b[0],
              i = b[b.length - 1],
              l = a - r,
              c = n - i,
              u = t * (n - a);
            u = Math.max(u, l), u = Math.min(u, c);
            var d = o(r + u);
            u = d - r;
            var p = b.map(function (e) {
              return e + u;
            });
            w(p);
          } else {
            var m = (n - a) * t,
              f = ON(y);
            f[e] = b[e];
            var v = s(f, m, e, "dist");
            w(v.values, v.value);
          }
        },
        F = Re.useRef(_);
      F.current = _;
      var S = Re.useMemo(function () {
        var e = ON(r).sort(function (e, t) {
            return e - t;
          }),
          t = ON(y).sort(function (e, t) {
            return e - t;
          });
        return e.every(function (e, r) {
          return e === t[r];
        }) ? y : r;
      }, [r, y]);
      return [m, u, S, function (a, n, o) {
        a.stopPropagation();
        var i = o || r,
          s = i[n];
        f(n), d(s), N(i);
        var c = dx(a),
          u = c.pageX,
          p = c.pageY,
          m = function m(r) {
            r.preventDefault();
            var a,
              o = dx(r),
              i = o.pageX,
              l = o.pageY,
              s = i - u,
              c = l - p,
              d = e.current.getBoundingClientRect(),
              m = d.width,
              f = d.height;
            switch (t) {
              case "btt":
                a = -c / f;
                break;
              case "ttb":
                a = c / f;
                break;
              case "rtl":
                a = -s / m;
                break;
              default:
                a = s / m;
            }
            F.current(n, a);
          },
          v = function e(t) {
            t.preventDefault(), document.removeEventListener("mouseup", e), document.removeEventListener("mousemove", m), document.removeEventListener("touchend", e), document.removeEventListener("touchmove", m), x.current = null, k.current = null, f(-1), l();
          };
        document.addEventListener("mouseup", v), document.addEventListener("mousemove", m), document.addEventListener("touchend", v), document.addEventListener("touchmove", m), x.current = m, k.current = v;
      }];
    }(Q, ee, fe, te, re, se, ge, function () {
      null == j || j(ye(ve.current));
    }, ce),
    be = AN(he, 4),
    Ne = be[0],
    xe = be[1],
    ke = be[2],
    we = be[3],
    _e = function _e(e, t) {
      if (!u) {
        var r = 0,
          a = re - te;
        fe.forEach(function (t, n) {
          var o = Math.abs(e - t);
          o <= a && (a = o, r = n);
        });
        var n = ON(fe);
        n[r] = e, _ && !fe.length && void 0 === F && n.push(e), null == C || C(ye(n)), ge(n), null == j || j(ye(n)), t && we(t, r, n);
      }
    },
    Fe = AN(Re.useState(null), 2),
    Se = Fe[0],
    Ce = Fe[1];
  Re.useEffect(function () {
    if (null !== Se) {
      var e = fe.indexOf(Se);
      e >= 0 && Z.current.focus(e);
    }
    Ce(null);
  }, [Se]);
  var je = Re.useMemo(function () {
      return M && null === ae ? ("production" !== process.env.NODE_ENV && JN(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : M;
    }, [M, ae]),
    Ee = function Ee(e, t) {
      we(e, t), null == C || C(ye(ve.current));
    },
    Te = -1 !== Ne;
  Re.useEffect(function () {
    if (!Te) {
      var e = fe.lastIndexOf(xe);
      Z.current.focus(e);
    }
  }, [Te]);
  var Oe = Re.useMemo(function () {
      return ON(ke).sort(function (e, t) {
        return e - t;
      });
    }, [ke]),
    Ae = AN(Re.useMemo(function () {
      return _ ? [Oe[0], Oe[Oe.length - 1]] : [te, Oe[0]];
    }, [Oe, _, te]), 2),
    Me = Ae[0],
    Le = Ae[1];
  Re.useImperativeHandle(t, function () {
    return {
      focus: function focus() {
        Z.current.focus(0);
      },
      blur: function blur() {
        var e = document.activeElement;
        Q.current.contains(e) && (null == e || e.blur());
      }
    };
  }), Re.useEffect(function () {
    m && Z.current.focus(0);
  }, []);
  var De = Re.useMemo(function () {
    return {
      min: te,
      max: re,
      direction: ee,
      disabled: u,
      keyboard: p,
      step: ae,
      included: P,
      includedStart: Me,
      includedEnd: Le,
      range: _,
      tabIndex: $,
      ariaLabelForHandle: q,
      ariaLabelledByForHandle: J,
      ariaValueTextFormatterForHandle: X,
      styles: s || {},
      classNames: l || {}
    };
  }, [te, re, ee, u, p, ae, P, Me, Le, _, $, q, J, X, s, l]);
  return Re.createElement(XN.Provider, {
    value: De
  }, Re.createElement("div", {
    ref: Q,
    className: LN(n, o, (r = {}, SN(r, "".concat(n, "-disabled"), u), SN(r, "".concat(n, "-vertical"), D), SN(r, "".concat(n, "-horizontal"), !D), SN(r, "".concat(n, "-with-marks"), oe.length), r)),
    style: i,
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      var t,
        r = Q.current.getBoundingClientRect(),
        a = r.width,
        n = r.height,
        o = r.left,
        i = r.top,
        l = r.bottom,
        s = r.right,
        c = e.clientX,
        u = e.clientY;
      switch (ee) {
        case "btt":
          t = (l - u) / n;
          break;
        case "ttb":
          t = (u - i) / n;
          break;
        case "rtl":
          t = (s - c) / a;
          break;
        default:
          t = (c - o) / a;
      }
      _e(se(te + t * (re - te)), e);
    }
  }, Re.createElement("div", {
    className: LN("".concat(n, "-rail"), null == l ? void 0 : l.rail),
    style: jN(jN({}, U), null == s ? void 0 : s.rail)
  }), Re.createElement(gx, {
    prefixCls: n,
    style: z,
    values: Oe,
    startPoint: I,
    onStartMove: je ? Ee : null
  }), Re.createElement(vx, {
    prefixCls: n,
    marks: oe,
    dots: W,
    style: H,
    activeStyle: G
  }), Re.createElement(ux, {
    ref: Z,
    prefixCls: n,
    style: R,
    values: ke,
    draggingIndex: Ne,
    onStartMove: Ee,
    onOffsetChange: function onOffsetChange(e, t) {
      if (!u) {
        var r = ce(fe, e, t);
        null == C || C(ye(fe)), ge(r.values), null == j || j(ye(r.values)), Ce(r.value);
      }
    },
    onFocus: f,
    onBlur: v,
    handleRender: K
  }), Re.createElement(mx, {
    prefixCls: n,
    marks: oe,
    onClick: _e
  })));
});
"production" !== process.env.NODE_ENV && (hx.displayName = "Slider");
var bx = hx;
function Nx(e) {
  var t = e.children,
    r = e.prefixCls,
    a = e.id,
    n = e.overlayInnerStyle,
    o = e.className,
    i = e.style;
  return Re.createElement("div", {
    className: LN("".concat(r, "-content"), o),
    style: i
  }, Re.createElement("div", {
    className: "".concat(r, "-inner"),
    id: a,
    role: "tooltip",
    style: n
  }, "function" == typeof t ? t() : t));
}
function xx() {
  return xx = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, xx.apply(this, arguments);
}
function kx(e) {
  return kx = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, kx(e);
}
function wx(e) {
  var t = function (e, t) {
    if ("object" !== kx(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== kx(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === kx(t) ? t : String(t);
}
function _x(e, t, r) {
  return (t = wx(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Fx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Sx(e, t) {
  if (null == e) return {};
  var r,
    a,
    n = function (e, t) {
      if (null == e) return {};
      var r,
        a,
        n = {},
        o = Object.keys(e);
      for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || (n[r] = e[r]);
      return n;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Cx(e) {
  return Cx = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Cx(e);
}
function jx(e) {
  var t = function (e, t) {
    if ("object" !== Cx(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== Cx(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === Cx(t) ? t : String(t);
}
function Ex(e, t, r) {
  return (t = jx(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Tx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Ox(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Tx(Object(r), !0).forEach(function (t) {
      Ex(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tx(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Ax(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function Mx(e, t) {
  if (e) {
    if ("string" == typeof e) return Ax(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ax(e, t) : void 0;
  }
}
function Lx(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || Mx(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Dx(e, t) {
  if (null == e) return {};
  var r,
    a,
    n = function (e, t) {
      if (null == e) return {};
      var r,
        a,
        n = {},
        o = Object.keys(e);
      for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || (n[r] = e[r]);
      return n;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++) r = o[a], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Bx(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function Px(e, t) {
  if (e) {
    if ("string" == typeof e) return Bx(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Bx(e, t) : void 0;
  }
}
function Ix(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || Px(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var zx,
  Rx = {
    exports: {}
  },
  Ux = {};
var Hx,
  Gx = {};
function Vx(e, t, r) {
  var a = Re.useRef({});
  return "value" in a.current && !r(a.current.condition, t) || (a.current.value = e(), a.current.condition = t), a.current.value;
}
function Wx(e, t) {
  "function" == typeof e ? e(t) : "object" === VN(e) && e && "current" in e && (e.current = t);
}
function Kx() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  var a = t.filter(function (e) {
    return e;
  });
  return a.length <= 1 ? a[0] : function (e) {
    t.forEach(function (t) {
      Wx(t, e);
    });
  };
}
function Yx() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return Vx(function () {
    return Kx.apply(void 0, t);
  }, t, function (e, t) {
    return e.length !== t.length || e.every(function (e, r) {
      return e !== t[r];
    });
  });
}
function $x(e) {
  var t,
    r,
    a = Rx.exports.isMemo(e) ? e.type.type : e.type;
  return !!("function" != typeof a || null !== (t = a.prototype) && void 0 !== t && t.render) && !!("function" != typeof e || null !== (r = e.prototype) && void 0 !== r && r.render);
}
!function (e) {
  "production" === process.env.NODE_ENV ? e.exports = function () {
    if (zx) return Ux;
    zx = 1;
    var e,
      t = Symbol.for("react.element"),
      r = Symbol.for("react.portal"),
      a = Symbol.for("react.fragment"),
      n = Symbol.for("react.strict_mode"),
      o = Symbol.for("react.profiler"),
      i = Symbol.for("react.provider"),
      l = Symbol.for("react.context"),
      s = Symbol.for("react.server_context"),
      c = Symbol.for("react.forward_ref"),
      u = Symbol.for("react.suspense"),
      d = Symbol.for("react.suspense_list"),
      p = Symbol.for("react.memo"),
      m = Symbol.for("react.lazy"),
      f = Symbol.for("react.offscreen");
    function v(e) {
      if ("object" === ze(e) && null !== e) {
        var f = e.$$typeof;
        switch (f) {
          case t:
            switch (e = e.type) {
              case a:
              case o:
              case n:
              case u:
              case d:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case l:
                  case c:
                  case m:
                  case p:
                  case i:
                    return e;
                  default:
                    return f;
                }
            }
          case r:
            return f;
        }
      }
    }
    return e = Symbol.for("react.module.reference"), Ux.ContextConsumer = l, Ux.ContextProvider = i, Ux.Element = t, Ux.ForwardRef = c, Ux.Fragment = a, Ux.Lazy = m, Ux.Memo = p, Ux.Portal = r, Ux.Profiler = o, Ux.StrictMode = n, Ux.Suspense = u, Ux.SuspenseList = d, Ux.isAsyncMode = function () {
      return !1;
    }, Ux.isConcurrentMode = function () {
      return !1;
    }, Ux.isContextConsumer = function (e) {
      return v(e) === l;
    }, Ux.isContextProvider = function (e) {
      return v(e) === i;
    }, Ux.isElement = function (e) {
      return "object" === ze(e) && null !== e && e.$$typeof === t;
    }, Ux.isForwardRef = function (e) {
      return v(e) === c;
    }, Ux.isFragment = function (e) {
      return v(e) === a;
    }, Ux.isLazy = function (e) {
      return v(e) === m;
    }, Ux.isMemo = function (e) {
      return v(e) === p;
    }, Ux.isPortal = function (e) {
      return v(e) === r;
    }, Ux.isProfiler = function (e) {
      return v(e) === o;
    }, Ux.isStrictMode = function (e) {
      return v(e) === n;
    }, Ux.isSuspense = function (e) {
      return v(e) === u;
    }, Ux.isSuspenseList = function (e) {
      return v(e) === d;
    }, Ux.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === a || t === o || t === n || t === u || t === d || t === f || "object" === ze(t) && null !== t && (t.$$typeof === m || t.$$typeof === p || t.$$typeof === i || t.$$typeof === l || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
    }, Ux.typeOf = v, Ux;
  }() : e.exports = (Hx || (Hx = 1, "production" !== process.env.NODE_ENV && function () {
    var e,
      t = Symbol.for("react.element"),
      r = Symbol.for("react.portal"),
      a = Symbol.for("react.fragment"),
      n = Symbol.for("react.strict_mode"),
      o = Symbol.for("react.profiler"),
      i = Symbol.for("react.provider"),
      l = Symbol.for("react.context"),
      s = Symbol.for("react.server_context"),
      c = Symbol.for("react.forward_ref"),
      u = Symbol.for("react.suspense"),
      d = Symbol.for("react.suspense_list"),
      p = Symbol.for("react.memo"),
      m = Symbol.for("react.lazy"),
      f = Symbol.for("react.offscreen");
    function v(e) {
      if ("object" === ze(e) && null !== e) {
        var f = e.$$typeof;
        switch (f) {
          case t:
            var v = e.type;
            switch (v) {
              case a:
              case o:
              case n:
              case u:
              case d:
                return v;
              default:
                var y = v && v.$$typeof;
                switch (y) {
                  case s:
                  case l:
                  case c:
                  case m:
                  case p:
                  case i:
                    return y;
                  default:
                    return f;
                }
            }
          case r:
            return f;
        }
      }
    }
    e = Symbol.for("react.module.reference");
    var y = l,
      g = i,
      h = t,
      b = c,
      N = a,
      x = m,
      k = p,
      w = r,
      _ = o,
      F = n,
      S = u,
      C = d,
      j = !1,
      E = !1;
    Gx.ContextConsumer = y, Gx.ContextProvider = g, Gx.Element = h, Gx.ForwardRef = b, Gx.Fragment = N, Gx.Lazy = x, Gx.Memo = k, Gx.Portal = w, Gx.Profiler = _, Gx.StrictMode = F, Gx.Suspense = S, Gx.SuspenseList = C, Gx.isAsyncMode = function (e) {
      return j || (j = !0), !1;
    }, Gx.isConcurrentMode = function (e) {
      return E || (E = !0), !1;
    }, Gx.isContextConsumer = function (e) {
      return v(e) === l;
    }, Gx.isContextProvider = function (e) {
      return v(e) === i;
    }, Gx.isElement = function (e) {
      return "object" === ze(e) && null !== e && e.$$typeof === t;
    }, Gx.isForwardRef = function (e) {
      return v(e) === c;
    }, Gx.isFragment = function (e) {
      return v(e) === a;
    }, Gx.isLazy = function (e) {
      return v(e) === m;
    }, Gx.isMemo = function (e) {
      return v(e) === p;
    }, Gx.isPortal = function (e) {
      return v(e) === r;
    }, Gx.isProfiler = function (e) {
      return v(e) === o;
    }, Gx.isStrictMode = function (e) {
      return v(e) === n;
    }, Gx.isSuspense = function (e) {
      return v(e) === u;
    }, Gx.isSuspenseList = function (e) {
      return v(e) === d;
    }, Gx.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === a || t === o || t === n || t === u || t === d || t === f || "object" === ze(t) && null !== t && (t.$$typeof === m || t.$$typeof === p || t.$$typeof === i || t.$$typeof === l || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
    }, Gx.typeOf = v;
  }()), Gx);
}(Rx);
var qx = Re.createContext(null);
function Jx(e) {
  return function (e) {
    if (Array.isArray(e)) return Bx(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Px(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var Xx = [];
var Zx,
  Qx = new Map();
function ek() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : "rc-util-key";
}
function tk(e) {
  return e.attachTo ? e.attachTo : document.querySelector("head") || document.body;
}
function rk(e) {
  return "queue" === e ? "prependQueue" : e ? "prepend" : "append";
}
function ak(e) {
  return Array.from((Qx.get(e) || e).children).filter(function (e) {
    return "STYLE" === e.tagName;
  });
}
function nk(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if (!IN()) return null;
  var r = t.csp,
    a = t.prepend,
    n = t.priority,
    o = void 0 === n ? 0 : n,
    i = rk(a),
    l = "prependQueue" === i,
    s = document.createElement("style");
  s.setAttribute("data-rc-order", i), l && o && s.setAttribute("data-rc-priority", "".concat(o)), null != r && r.nonce && (s.nonce = null == r ? void 0 : r.nonce), s.innerHTML = e;
  var c = tk(t),
    u = c.firstChild;
  if (a) {
    if (l) {
      var d = ak(c).filter(function (e) {
        if (!["prepend", "prependQueue"].includes(e.getAttribute("data-rc-order"))) return !1;
        var t = Number(e.getAttribute("data-rc-priority") || 0);
        return o >= t;
      });
      if (d.length) return c.insertBefore(s, d[d.length - 1].nextSibling), s;
    }
    c.insertBefore(s, u);
  } else c.appendChild(s);
  return s;
}
function ok(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = tk(t);
  return ak(r).find(function (r) {
    return r.getAttribute(ek(t)) === e;
  });
}
function ik(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = ok(e, t);
  if (r) {
    var a = tk(t);
    a.removeChild(r);
  }
}
function lk(e, t) {
  var r = Qx.get(e);
  if (!r || !function (e, t) {
    if (!e) return !1;
    if (e.contains) return e.contains(t);
    for (var r = t; r;) {
      if (r === e) return !0;
      r = r.parentNode;
    }
    return !1;
  }(document, r)) {
    var a = nk("", t),
      n = a.parentNode;
    Qx.set(e, n), e.removeChild(a);
  }
}
function sk(e) {
  var t = e.match(/^(.*)px$/),
    r = Number(null == t ? void 0 : t[1]);
  return Number.isNaN(r) ? function (e) {
    if ("undefined" == typeof document) return 0;
    if (e || void 0 === Zx) {
      var t = document.createElement("div");
      t.style.width = "100%", t.style.height = "200px";
      var r = document.createElement("div"),
        a = r.style;
      a.position = "absolute", a.top = "0", a.left = "0", a.pointerEvents = "none", a.visibility = "hidden", a.width = "200px", a.height = "150px", a.overflow = "hidden", r.appendChild(t), document.body.appendChild(r);
      var n = t.offsetWidth;
      r.style.overflow = "scroll";
      var o = t.offsetWidth;
      n === o && (o = r.clientWidth), document.body.removeChild(r), Zx = n - o;
    }
    return Zx;
  }() : r;
}
var ck = "rc-util-locker-".concat(Date.now()),
  uk = 0;
function dk(e) {
  var t = !!e,
    r = Ix(Re.useState(function () {
      return uk += 1, "".concat(ck, "_").concat(uk);
    }), 1)[0];
  RN(function () {
    if (t) {
      var e = function (e) {
          if (!("undefined" != typeof document && e && e instanceof Element)) return {
            width: 0,
            height: 0
          };
          var t = getComputedStyle(e, "::-webkit-scrollbar"),
            r = t.width,
            a = t.height;
          return {
            width: sk(r),
            height: sk(a)
          };
        }(document.body).width,
        a = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
      !function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        lk(tk(r), r);
        var a = ok(t, r);
        if (a) {
          var n, o, i;
          return null !== (n = r.csp) && void 0 !== n && n.nonce && a.nonce !== (null === (o = r.csp) || void 0 === o ? void 0 : o.nonce) && (a.nonce = null === (i = r.csp) || void 0 === i ? void 0 : i.nonce), a.innerHTML !== e && (a.innerHTML = e), a;
        }
        var l = nk(e, r);
        l.setAttribute(ek(r), t);
      }("\nhtml body {\n  overflow-y: hidden;\n  ".concat(a ? "width: calc(100% - ".concat(e, "px);") : "", "\n}"), r);
    } else ik(r);
    return function () {
      ik(r);
    };
  }, [t, r]);
}
var pk = !1;
var mk = function mk(e) {
    return !1 !== e && (IN() && e ? "string" == typeof e ? document.querySelector(e) : "function" == typeof e ? e() : e : null);
  },
  fk = Re.forwardRef(function (e, t) {
    var r = e.open,
      a = e.autoLock,
      n = e.getContainer,
      o = e.debug,
      i = e.autoDestroy,
      l = void 0 === i || i,
      s = e.children,
      c = Ix(Re.useState(r), 2),
      u = c[0],
      d = c[1],
      p = u || r;
    "production" !== process.env.NODE_ENV && JN(IN() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), Re.useEffect(function () {
      (l || r) && d(r);
    }, [r, l]);
    var m = Ix(Re.useState(function () {
        return mk(n);
      }), 2),
      f = m[0],
      v = m[1];
    Re.useEffect(function () {
      var e = mk(n);
      v(null != e ? e : null);
    });
    var y = function (e, t) {
        var r = Ix(Re.useState(function () {
            if (!IN()) return null;
            var e = document.createElement("div");
            return "production" !== process.env.NODE_ENV && t && e.setAttribute("data-debug", t), e;
          }), 1)[0],
          a = Re.useRef(!1),
          n = Re.useContext(qx),
          o = Ix(Re.useState(Xx), 2),
          i = o[0],
          l = o[1],
          s = n || (a.current ? void 0 : function (e) {
            l(function (t) {
              return [e].concat(Jx(t));
            });
          });
        function c() {
          r.parentElement || document.body.appendChild(r), a.current = !0;
        }
        function u() {
          var e;
          null === (e = r.parentElement) || void 0 === e || e.removeChild(r), a.current = !1;
        }
        return RN(function () {
          return e ? n ? n(c) : c() : u(), u;
        }, [e]), RN(function () {
          i.length && (i.forEach(function (e) {
            return e();
          }), l(Xx));
        }, [i]), [r, s];
      }(p && !f, o),
      g = Ix(y, 2),
      h = g[0],
      b = g[1],
      N = null != f ? f : h;
    dk(a && r && IN() && (N === h || N === document.body));
    var x = null;
    s && $x(s) && t && (x = s.ref);
    var k = Yx(x, t);
    if (!p || !IN() || void 0 === f) return null;
    var w,
      _ = !1 === N || ("boolean" == typeof w && (pk = w), pk),
      F = s;
    return t && (F = Re.cloneElement(s, {
      ref: k
    })), Re.createElement(qx.Provider, {
      value: b
    }, _ ? F : lt(F, N));
  });
"production" !== process.env.NODE_ENV && (fk.displayName = "Portal");
var vk = fk;
function yk() {
  return yk = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, yk.apply(this, arguments);
}
function gk(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = [];
  return Ue.Children.forEach(e, function (e) {
    (null != e || t.keepEmpty) && (Array.isArray(e) ? r = r.concat(gk(e)) : Rx.exports.isFragment(e) && e.props ? r = r.concat(gk(e.props.children, t)) : r.push(e));
  }), r;
}
function hk(e) {
  return hk = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, hk(e);
}
function bk(e) {
  var t = function (e, t) {
    if ("object" !== hk(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== hk(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === hk(t) ? t : String(t);
}
function Nk(e, t, r) {
  return (t = bk(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function xk(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function kk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xk(Object(r), !0).forEach(function (t) {
      Nk(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xk(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function wk(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function _k(e) {
  return wk(e) ? e : e instanceof Ue.Component ? it.findDOMNode(e) : null;
}
var Fk = Re.createContext(null);
var Sk = function () {
    if ("undefined" != typeof Map) return Map;
    function e(e, t) {
      var r = -1;
      return e.some(function (e, a) {
        return e[0] === t && (r = a, !0);
      }), r;
    }
    return function () {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function (t) {
        var r = e(this.__entries__, t),
          a = this.__entries__[r];
        return a && a[1];
      }, t.prototype.set = function (t, r) {
        var a = e(this.__entries__, t);
        ~a ? this.__entries__[a][1] = r : this.__entries__.push([t, r]);
      }, t.prototype.delete = function (t) {
        var r = this.__entries__,
          a = e(r, t);
        ~a && r.splice(a, 1);
      }, t.prototype.has = function (t) {
        return !!~e(this.__entries__, t);
      }, t.prototype.clear = function () {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function (e, t) {
        void 0 === t && (t = null);
        for (var r = 0, a = this.__entries__; r < a.length; r++) {
          var n = a[r];
          e.call(t, n[1], n[0]);
        }
      }, t;
    }();
  }(),
  Ck = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
  jk = "undefined" != typeof global && global.Math === Math ? global : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
  Ek = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(jk) : function (e) {
    return setTimeout(function () {
      return e(Date.now());
    }, 1e3 / 60);
  };
var Tk = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
  Ok = "undefined" != typeof MutationObserver,
  Ak = function () {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
        var r = !1,
          a = !1,
          n = 0;
        function o() {
          r && (r = !1, e()), a && l();
        }
        function i() {
          Ek(o);
        }
        function l() {
          var e = Date.now();
          if (r) {
            if (e - n < 2) return;
            a = !0;
          } else r = !0, a = !1, setTimeout(i, t);
          n = e;
        }
        return l;
      }(this.refresh.bind(this), 20);
    }
    return e.prototype.addObserver = function (e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function (e) {
      var t = this.observers_,
        r = t.indexOf(e);
      ~r && t.splice(r, 1), !t.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function () {
      this.updateObservers_() && this.refresh();
    }, e.prototype.updateObservers_ = function () {
      var e = this.observers_.filter(function (e) {
        return e.gatherActive(), e.hasActive();
      });
      return e.forEach(function (e) {
        return e.broadcastActive();
      }), e.length > 0;
    }, e.prototype.connect_ = function () {
      Ck && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Ok ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function () {
      Ck && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function (e) {
      var t = e.propertyName,
        r = void 0 === t ? "" : t;
      Tk.some(function (e) {
        return !!~r.indexOf(e);
      }) && this.refresh();
    }, e.getInstance = function () {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }(),
  Mk = function Mk(e, t) {
    for (var r = 0, a = Object.keys(t); r < a.length; r++) {
      var n = a[r];
      Object.defineProperty(e, n, {
        value: t[n],
        enumerable: !1,
        writable: !1,
        configurable: !0
      });
    }
    return e;
  },
  Lk = function Lk(e) {
    return e && e.ownerDocument && e.ownerDocument.defaultView || jk;
  },
  Dk = Uk(0, 0, 0, 0);
function Bk(e) {
  return parseFloat(e) || 0;
}
function Pk(e) {
  for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
  return t.reduce(function (t, r) {
    return t + Bk(e["border-" + r + "-width"]);
  }, 0);
}
function Ik(e) {
  var t = e.clientWidth,
    r = e.clientHeight;
  if (!t && !r) return Dk;
  var a = Lk(e).getComputedStyle(e),
    n = function (e) {
      for (var t = {}, r = 0, a = ["top", "right", "bottom", "left"]; r < a.length; r++) {
        var n = a[r],
          o = e["padding-" + n];
        t[n] = Bk(o);
      }
      return t;
    }(a),
    o = n.left + n.right,
    i = n.top + n.bottom,
    l = Bk(a.width),
    s = Bk(a.height);
  if ("border-box" === a.boxSizing && (Math.round(l + o) !== t && (l -= Pk(a, "left", "right") + o), Math.round(s + i) !== r && (s -= Pk(a, "top", "bottom") + i)), !function (e) {
    return e === Lk(e).document.documentElement;
  }(e)) {
    var c = Math.round(l + o) - t,
      u = Math.round(s + i) - r;
    1 !== Math.abs(c) && (l -= c), 1 !== Math.abs(u) && (s -= u);
  }
  return Uk(n.left, n.top, l, s);
}
var zk = "undefined" != typeof SVGGraphicsElement ? function (e) {
  return e instanceof Lk(e).SVGGraphicsElement;
} : function (e) {
  return e instanceof Lk(e).SVGElement && "function" == typeof e.getBBox;
};
function Rk(e) {
  return Ck ? zk(e) ? function (e) {
    var t = e.getBBox();
    return Uk(0, 0, t.width, t.height);
  }(e) : Ik(e) : Dk;
}
function Uk(e, t, r, a) {
  return {
    x: e,
    y: t,
    width: r,
    height: a
  };
}
var Hk = function () {
    function e(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Uk(0, 0, 0, 0), this.target = e;
    }
    return e.prototype.isActive = function () {
      var e = Rk(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function () {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, e;
  }(),
  Gk = function Gk(e, t) {
    var r,
      a,
      n,
      o,
      i,
      l,
      s,
      c = (a = (r = t).x, n = r.y, o = r.width, i = r.height, l = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, s = Object.create(l.prototype), Mk(s, {
        x: a,
        y: n,
        width: o,
        height: i,
        top: n,
        right: a + o,
        bottom: i + n,
        left: a
      }), s);
    Mk(this, {
      target: e,
      contentRect: c
    });
  },
  Vk = function () {
    function e(e, t, r) {
      if (this.activeObservations_ = [], this.observations_ = new Sk(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = t, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function (e) {
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      if ("undefined" != typeof Element && Element instanceof Object) {
        if (!(e instanceof Lk(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var t = this.observations_;
        t.has(e) || (t.set(e, new Hk(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function (e) {
      if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
      if ("undefined" != typeof Element && Element instanceof Object) {
        if (!(e instanceof Lk(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var t = this.observations_;
        t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function () {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function () {
      var e = this;
      this.clearActive(), this.observations_.forEach(function (t) {
        t.isActive() && e.activeObservations_.push(t);
      });
    }, e.prototype.broadcastActive = function () {
      if (this.hasActive()) {
        var e = this.callbackCtx_,
          t = this.activeObservations_.map(function (e) {
            return new Gk(e.target, e.broadcastRect());
          });
        this.callback_.call(e, t, e), this.clearActive();
      }
    }, e.prototype.clearActive = function () {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function () {
      return this.activeObservations_.length > 0;
    }, e;
  }(),
  Wk = "undefined" != typeof WeakMap ? new WeakMap() : new Sk(),
  Kk = function e(t) {
    if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
    if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
    var r = Ak.getInstance(),
      a = new Vk(t, r, this);
    Wk.set(this, a);
  };
["observe", "unobserve", "disconnect"].forEach(function (e) {
  Kk.prototype[e] = function () {
    var t;
    return (t = Wk.get(this))[e].apply(t, arguments);
  };
});
var Yk = void 0 !== jk.ResizeObserver ? jk.ResizeObserver : Kk,
  $k = new Map();
function qk(e) {
  e.forEach(function (e) {
    var t,
      r = e.target;
    null === (t = $k.get(r)) || void 0 === t || t.forEach(function (e) {
      return e(r);
    });
  });
}
var Jk = new Yk(qk);
function Xk(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Zk(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, bk(a.key), a);
  }
}
function Qk(e, t) {
  return Qk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, Qk(e, t);
}
function ew(e) {
  return ew = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, ew(e);
}
function tw(e, t) {
  if (t && ("object" === hk(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e);
}
function rw(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      a = ew(e);
    if (t) {
      var n = ew(this).constructor;
      r = Reflect.construct(a, arguments, n);
    } else r = a.apply(this, arguments);
    return tw(this, r);
  };
}
process.env.NODE_ENV, process.env.NODE_ENV;
var aw = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && Qk(e, t);
  }(o, Re.Component);
  var t,
    r,
    a,
    n = rw(o);
  function o() {
    return Xk(this, o), n.apply(this, arguments);
  }
  return t = o, (r = [{
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]) && Zk(t.prototype, r), a && Zk(t, a), Object.defineProperty(t, "prototype", {
    writable: !1
  }), o;
}();
function nw(e, t) {
  var r = e.children,
    a = e.disabled,
    n = Re.useRef(null),
    o = Re.useRef(null),
    i = Re.useContext(Fk),
    l = "function" == typeof r,
    s = l ? r(n) : r,
    c = Re.useRef({
      width: -1,
      height: -1,
      offsetWidth: -1,
      offsetHeight: -1
    }),
    u = !l && Re.isValidElement(s) && $x(s),
    d = Yx(u ? s.ref : null, n),
    p = function p() {
      var e;
      return _k(n.current) || (n.current && "object" === hk(n.current) ? _k(null === (e = n.current) || void 0 === e ? void 0 : e.nativeElement) : null) || _k(o.current);
    };
  Re.useImperativeHandle(t, function () {
    return p();
  });
  var m = Re.useRef(e);
  m.current = e;
  var f = Re.useCallback(function (e) {
    var t = m.current,
      r = t.onResize,
      a = t.data,
      n = e.getBoundingClientRect(),
      o = n.width,
      l = n.height,
      s = e.offsetWidth,
      u = e.offsetHeight,
      d = Math.floor(o),
      p = Math.floor(l);
    if (c.current.width !== d || c.current.height !== p || c.current.offsetWidth !== s || c.current.offsetHeight !== u) {
      var f = {
        width: d,
        height: p,
        offsetWidth: s,
        offsetHeight: u
      };
      c.current = f;
      var v = s === Math.round(o) ? o : s,
        y = u === Math.round(l) ? l : u,
        g = kk(kk({}, f), {}, {
          offsetWidth: v,
          offsetHeight: y
        });
      null == i || i(g, e, a), r && Promise.resolve().then(function () {
        r(g, e);
      });
    }
  }, []);
  return Re.useEffect(function () {
    var e,
      t,
      r = p();
    return r && !a && (e = r, t = f, $k.has(e) || ($k.set(e, new Set()), Jk.observe(e)), $k.get(e).add(t)), function () {
      return function (e, t) {
        $k.has(e) && ($k.get(e).delete(t), $k.get(e).size || (Jk.unobserve(e), $k.delete(e)));
      }(r, f);
    };
  }, [n.current, a]), Re.createElement(aw, {
    ref: o
  }, u ? Re.cloneElement(s, {
    ref: d
  }) : s);
}
var ow = Re.forwardRef(nw);
"production" !== process.env.NODE_ENV && (ow.displayName = "SingleObserver");
var iw = ow;
function lw(e, t) {
  var r = e.children,
    a = "function" == typeof r ? [r] : gk(r);
  return "production" !== process.env.NODE_ENV && (a.length > 1 ? YN(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : 0 === a.length && YN(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), a.map(function (r, a) {
    var n = (null == r ? void 0 : r.key) || "".concat("rc-observer-key", "-").concat(a);
    return Re.createElement(iw, yk({}, e, {
      key: n,
      ref: 0 === a ? t : void 0
    }), r);
  });
}
var sw = Re.forwardRef(lw);
"production" !== process.env.NODE_ENV && (sw.displayName = "ResizeObserver"), sw.Collection = function (e) {
  var t = e.children,
    r = e.onBatchResize,
    a = Re.useRef(0),
    n = Re.useRef([]),
    o = Re.useContext(Fk),
    i = Re.useCallback(function (e, t, i) {
      a.current += 1;
      var l = a.current;
      n.current.push({
        size: e,
        element: t,
        data: i
      }), Promise.resolve().then(function () {
        l === a.current && (null == r || r(n.current), n.current = []);
      }), null == o || o(e, t, i);
    }, [r, o]);
  return Re.createElement(Fk.Provider, {
    value: i
  }, t);
};
var cw = sw;
function uw(e) {
  var t;
  return null == e || null === (t = e.getRootNode) || void 0 === t ? void 0 : t.call(e);
}
function dw(e) {
  return function (e) {
    return uw(e) instanceof ShadowRoot;
  }(e) ? uw(e) : null;
}
function pw(e) {
  var t = function (e, t) {
    if ("object" !== VN(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== VN(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === VN(t) ? t : String(t);
}
function mw(e, t, r) {
  return (t = pw(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function fw(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
var vw,
  yw = 0,
  gw = (vw = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? fw(Object(r), !0).forEach(function (t) {
        mw(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fw(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }({}, Re), vw.useId),
  hw = gw ? function (e) {
    var t = gw();
    return e || ("test" === process.env.NODE_ENV ? "test-id" : t);
  } : function (e) {
    var t = BN(Re.useState("ssr-id"), 2),
      r = t[0],
      a = t[1];
    return Re.useEffect(function () {
      var e = yw;
      yw += 1, a("rc_unique_".concat(e));
    }, []), e || ("test" === process.env.NODE_ENV ? "test-id" : r);
  },
  bw = function bw() {
    if ("undefined" == typeof navigator || "undefined" == typeof window) return !1;
    var e = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(null == e ? void 0 : e.substr(0, 4));
  };
function Nw() {
  return Nw = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, Nw.apply(this, arguments);
}
function xw(e) {
  return xw = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xw(e);
}
function kw(e) {
  var t = function (e, t) {
    if ("object" !== xw(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 !== r) {
      var a = r.call(e, t || "default");
      if ("object" !== xw(a)) return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === xw(t) ? t : String(t);
}
function ww(e, t, r) {
  return (t = kw(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function _w(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function Fw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? _w(Object(r), !0).forEach(function (t) {
      ww(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _w(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function Sw(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function Cw(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var a,
        n,
        o,
        i,
        l = [],
        s = !0,
        c = !1;
      try {
        if (o = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          s = !1;
        } else for (; !(s = (a = o.call(r)).done) && (l.push(a.value), l.length !== t); s = !0);
      } catch (e) {
        c = !0, n = e;
      } finally {
        try {
          if (!s && null != r.return && (i = r.return(), Object(i) !== i)) return;
        } finally {
          if (c) throw n;
        }
      }
      return l;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return Sw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Sw(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var jw = Re.createContext({});
function Ew(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Tw(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, kw(a.key), a);
  }
}
function Ow(e, t) {
  return Ow = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, Ow(e, t);
}
function Aw(e) {
  return Aw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Aw(e);
}
function Mw(e, t) {
  if (t && ("object" === xw(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e);
}
function Lw(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var r,
      a = Aw(e);
    if (t) {
      var n = Aw(this).constructor;
      r = Reflect.construct(a, arguments, n);
    } else r = a.apply(this, arguments);
    return Mw(this, r);
  };
}
var Dw = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && Ow(e, t);
  }(o, Re.Component);
  var t,
    r,
    a,
    n = Lw(o);
  function o() {
    return Ew(this, o), n.apply(this, arguments);
  }
  return t = o, (r = [{
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]) && Tw(t.prototype, r), a && Tw(t, a), Object.defineProperty(t, "prototype", {
    writable: !1
  }), o;
}();
function Bw(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
var Pw,
  Iw,
  zw,
  Rw = (Pw = IN(), Iw = "undefined" != typeof window ? window : {}, zw = {
    animationend: Bw("Animation", "AnimationEnd"),
    transitionend: Bw("Transition", "TransitionEnd")
  }, Pw && ("AnimationEvent" in Iw || delete zw.animationend.animation, "TransitionEvent" in Iw || delete zw.transitionend.transition), zw),
  Uw = {};
if (IN()) {
  var Hw = document.createElement("div");
  Uw = Hw.style;
}
var Gw = {};
function Vw(e) {
  if (Gw[e]) return Gw[e];
  var t = Rw[e];
  if (t) for (var r = Object.keys(t), a = r.length, n = 0; n < a; n += 1) {
    var o = r[n];
    if (Object.prototype.hasOwnProperty.call(t, o) && o in Uw) return Gw[e] = t[o], Gw[e];
  }
  return "";
}
var Ww = Vw("animationend"),
  Kw = Vw("transitionend"),
  Yw = !(!Ww || !Kw),
  $w = Ww || "animationend",
  qw = Kw || "transitionend";
function Jw(e, t) {
  return e ? "object" === xw(e) ? e[t.replace(/-\w/g, function (e) {
    return e[1].toUpperCase();
  })] : "".concat(e, "-").concat(t) : null;
}
var Xw = IN() ? We : Ve,
  Zw = function Zw(e) {
    return +setTimeout(e, 16);
  },
  Qw = function Qw(e) {
    return clearTimeout(e);
  };
"undefined" != typeof window && "requestAnimationFrame" in window && (Zw = function Zw(e) {
  return window.requestAnimationFrame(e);
}, Qw = function Qw(e) {
  return window.cancelAnimationFrame(e);
});
var e_ = 0,
  t_ = new Map();
function r_(e) {
  t_.delete(e);
}
var a_ = function a_(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
    r = e_ += 1;
  function a(t) {
    if (0 === t) r_(r), e();else {
      var n = Zw(function () {
        a(t - 1);
      });
      t_.set(r, n);
    }
  }
  return a(t), r;
};
a_.cancel = function (e) {
  var t = t_.get(e);
  return r_(e), Qw(t);
}, "production" !== process.env.NODE_ENV && (a_.ids = function () {
  return t_;
});
var n_ = a_,
  o_ = ["prepare", "start", "active", "end"],
  i_ = ["prepare", "prepared"];
function l_(e) {
  return "active" === e || "end" === e;
}
var s_ = function s_(e, t, r) {
  var a = Cw(HN("none"), 2),
    n = a[0],
    o = a[1],
    i = function () {
      var e = Re.useRef(null);
      function t() {
        n_.cancel(e.current);
      }
      return Re.useEffect(function () {
        return function () {
          t();
        };
      }, []), [function r(a) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
        t();
        var o = n_(function () {
          n <= 1 ? a({
            isCanceled: function isCanceled() {
              return o !== e.current;
            }
          }) : r(a, n - 1);
        });
        e.current = o;
      }, t];
    }(),
    l = Cw(i, 2),
    s = l[0],
    c = l[1];
  var u = t ? i_ : o_;
  return Xw(function () {
    if ("none" !== n && "end" !== n) {
      var e = u.indexOf(n),
        t = u[e + 1],
        a = r(n);
      false === a ? o(t, !0) : t && s(function (e) {
        function r() {
          e.isCanceled() || o(t, !0);
        }
        !0 === a ? r() : Promise.resolve(a).then(r);
      });
    }
  }, [e, n]), Re.useEffect(function () {
    return function () {
      c();
    };
  }, []), [function () {
    o("prepare", !0);
  }, n];
};
function c_(e, t, r, a) {
  var n = a.motionEnter,
    o = void 0 === n || n,
    i = a.motionAppear,
    l = void 0 === i || i,
    s = a.motionLeave,
    c = void 0 === s || s,
    u = a.motionDeadline,
    d = a.motionLeaveImmediately,
    p = a.onAppearPrepare,
    m = a.onEnterPrepare,
    f = a.onLeavePrepare,
    v = a.onAppearStart,
    y = a.onEnterStart,
    g = a.onLeaveStart,
    h = a.onAppearActive,
    b = a.onEnterActive,
    N = a.onLeaveActive,
    x = a.onAppearEnd,
    k = a.onEnterEnd,
    w = a.onLeaveEnd,
    _ = a.onVisibleChanged,
    F = Cw(HN(), 2),
    S = F[0],
    C = F[1],
    j = Cw(HN("none"), 2),
    E = j[0],
    T = j[1],
    O = Cw(HN(null), 2),
    A = O[0],
    M = O[1],
    L = Ge(!1),
    D = Ge(null);
  function B() {
    return r();
  }
  var P = Ge(!1);
  function I() {
    T("none", !0), M(null, !0);
  }
  function z(e) {
    var t = B();
    if (!e || e.deadline || e.target === t) {
      var r,
        a = P.current;
      "appear" === E && a ? r = null == x ? void 0 : x(t, e) : "enter" === E && a ? r = null == k ? void 0 : k(t, e) : "leave" === E && a && (r = null == w ? void 0 : w(t, e)), "none" !== E && a && !1 !== r && I();
    }
  }
  var R = function (e) {
      var t = Ge(),
        r = Ge(e);
      r.current = e;
      var a = Re.useCallback(function (e) {
        r.current(e);
      }, []);
      function n(e) {
        e && (e.removeEventListener(qw, a), e.removeEventListener($w, a));
      }
      return Re.useEffect(function () {
        return function () {
          n(t.current);
        };
      }, []), [function (e) {
        t.current && t.current !== e && n(t.current), e && e !== t.current && (e.addEventListener(qw, a), e.addEventListener($w, a), t.current = e);
      }, n];
    }(z),
    U = Cw(R, 1)[0],
    H = function H(e) {
      var t, r, a;
      switch (e) {
        case "appear":
          return ww(t = {}, "prepare", p), ww(t, "start", v), ww(t, "active", h), t;
        case "enter":
          return ww(r = {}, "prepare", m), ww(r, "start", y), ww(r, "active", b), r;
        case "leave":
          return ww(a = {}, "prepare", f), ww(a, "start", g), ww(a, "active", N), a;
        default:
          return {};
      }
    },
    G = Re.useMemo(function () {
      return H(E);
    }, [E]),
    V = Cw(s_(E, !e, function (e) {
      if ("prepare" === e) {
        var t = G.prepare;
        return !!t && t(B());
      }
      var r;
      K in G && M((null === (r = G[K]) || void 0 === r ? void 0 : r.call(G, B(), null)) || null);
      return "active" === K && (U(B()), u > 0 && (clearTimeout(D.current), D.current = setTimeout(function () {
        z({
          deadline: !0
        });
      }, u))), "prepared" === K && I(), true;
    }), 2),
    W = V[0],
    K = V[1],
    Y = l_(K);
  P.current = Y, Xw(function () {
    C(t);
    var r,
      a = L.current;
    L.current = !0, !a && t && l && (r = "appear"), a && t && o && (r = "enter"), (a && !t && c || !a && d && !t && c) && (r = "leave");
    var n = H(r);
    r && (e || n.prepare) ? (T(r), W()) : T("none");
  }, [t]), Ve(function () {
    ("appear" === E && !l || "enter" === E && !o || "leave" === E && !c) && T("none");
  }, [l, o, c]), Ve(function () {
    return function () {
      L.current = !1, clearTimeout(D.current);
    };
  }, []);
  var $ = Re.useRef(!1);
  Ve(function () {
    S && ($.current = !0), void 0 !== S && "none" === E && (($.current || S) && (null == _ || _(S)), $.current = !0);
  }, [S, E]);
  var q = A;
  return G.prepare && "start" === K && (q = Fw({
    transition: "none"
  }, q)), [E, K, q, null != S ? S : t];
}
var u_ = function (e) {
  var t = e;
  "object" === xw(e) && (t = e.transitionSupport);
  var r = Re.forwardRef(function (e, r) {
    var a = e.visible,
      n = void 0 === a || a,
      o = e.removeOnLeave,
      i = void 0 === o || o,
      l = e.forceRender,
      s = e.children,
      c = e.motionName,
      u = e.leavedClassName,
      d = e.eventProps,
      p = function (e, r) {
        return !(!e.motionName || !t || !1 === r);
      }(e, Re.useContext(jw).motion),
      m = Ge(),
      f = Ge();
    var v = Cw(c_(p, n, function () {
        try {
          return m.current instanceof HTMLElement ? m.current : _k(f.current);
        } catch (e) {
          return null;
        }
      }, e), 4),
      y = v[0],
      g = v[1],
      h = v[2],
      b = v[3],
      N = Re.useRef(b);
    b && (N.current = !0);
    var x,
      k = Re.useCallback(function (e) {
        m.current = e, Wx(r, e);
      }, [r]),
      w = Fw(Fw({}, d), {}, {
        visible: n
      });
    if (s) {
      if ("none" === y) x = b ? s(Fw({}, w), k) : !i && N.current && u ? s(Fw(Fw({}, w), {}, {
        className: u
      }), k) : l || !i && !u ? s(Fw(Fw({}, w), {}, {
        style: {
          display: "none"
        }
      }), k) : null;else {
        var _, F;
        "prepare" === g ? F = "prepare" : l_(g) ? F = "active" : "start" === g && (F = "start");
        var S = Jw(c, "".concat(y, "-").concat(F));
        x = s(Fw(Fw({}, w), {}, {
          className: LN(Jw(c, y), (_ = {}, ww(_, S, S && F), ww(_, c, "string" == typeof c), _)),
          style: h
        }), k);
      }
    } else x = null;
    Re.isValidElement(x) && $x(x) && (x.ref || (x = Re.cloneElement(x, {
      ref: k
    })));
    return Re.createElement(Dw, {
      ref: f
    }, x);
  });
  return r.displayName = "CSSMotion", r;
}(Yw);
function d_(e) {
  var t = e.prefixCls,
    r = e.align,
    a = e.arrow,
    n = e.arrowPos,
    o = a || {},
    i = o.className,
    l = o.content,
    s = n.x,
    c = void 0 === s ? 0 : s,
    u = n.y,
    d = void 0 === u ? 0 : u,
    p = Re.useRef();
  if (!r || !r.points) return null;
  var m = {
    position: "absolute"
  };
  if (!1 !== r.autoArrow) {
    var f = r.points[0],
      v = r.points[1],
      y = f[0],
      g = f[1],
      h = v[0],
      b = v[1];
    y !== h && ["t", "b"].includes(y) ? "t" === y ? m.top = 0 : m.bottom = 0 : m.top = d, g !== b && ["l", "r"].includes(g) ? "l" === g ? m.left = 0 : m.right = 0 : m.left = c;
  }
  return Re.createElement("div", {
    ref: p,
    className: LN("".concat(t, "-arrow"), i),
    style: m
  }, l);
}
function p_(e) {
  var t = e.prefixCls,
    r = e.open,
    a = e.zIndex,
    n = e.mask,
    o = e.motion;
  return n ? Re.createElement(u_, Nw({}, o, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function (e) {
    var r = e.className;
    return Re.createElement("div", {
      style: {
        zIndex: a
      },
      className: LN("".concat(t, "-mask"), r)
    });
  }) : null;
}
var m_ = Re.memo(function (e) {
  return e.children;
}, function (e, t) {
  return t.cache;
});
"production" !== process.env.NODE_ENV && (m_.displayName = "PopupContent");
var f_ = m_,
  v_ = Re.forwardRef(function (e, t) {
    var r = e.popup,
      a = e.className,
      n = e.prefixCls,
      o = e.style,
      i = e.target,
      l = e.onVisibleChanged,
      s = e.open,
      c = e.keepDom,
      u = e.fresh,
      d = e.onClick,
      p = e.mask,
      m = e.arrow,
      f = e.arrowPos,
      v = e.align,
      y = e.motion,
      g = e.maskMotion,
      h = e.forceRender,
      b = e.getPopupContainer,
      N = e.autoDestroy,
      x = e.portal,
      k = e.zIndex,
      w = e.onMouseEnter,
      _ = e.onMouseLeave,
      F = e.onPointerEnter,
      S = e.ready,
      C = e.offsetX,
      j = e.offsetY,
      E = e.offsetR,
      T = e.offsetB,
      O = e.onAlign,
      A = e.onPrepare,
      M = e.stretch,
      L = e.targetWidth,
      D = e.targetHeight,
      B = "function" == typeof r ? r() : r,
      P = s || c,
      I = (null == b ? void 0 : b.length) > 0,
      z = Lx(Re.useState(!b || !I), 2),
      R = z[0],
      U = z[1];
    if (RN(function () {
      !R && I && i && U(!0);
    }, [R, I, i]), !R) return null;
    var H = "auto",
      G = {
        left: "-1000vw",
        top: "-1000vh",
        right: H,
        bottom: H
      };
    if (S || !s) {
      var V,
        W = v.points,
        K = v.dynamicInset || (null === (V = v._experimental) || void 0 === V ? void 0 : V.dynamicInset),
        Y = K && "r" === W[0][1],
        $ = K && "b" === W[0][0];
      Y ? (G.right = E, G.left = H) : (G.left = C, G.right = H), $ ? (G.bottom = T, G.top = H) : (G.top = j, G.bottom = H);
    }
    var q = {};
    return M && (M.includes("height") && D ? q.height = D : M.includes("minHeight") && D && (q.minHeight = D), M.includes("width") && L ? q.width = L : M.includes("minWidth") && L && (q.minWidth = L)), s || (q.pointerEvents = "none"), Re.createElement(x, {
      open: h || P,
      getContainer: b && function () {
        return b(i);
      },
      autoDestroy: N
    }, Re.createElement(p_, {
      prefixCls: n,
      open: s,
      zIndex: k,
      mask: p,
      motion: g
    }), Re.createElement(cw, {
      onResize: O,
      disabled: !s
    }, function (e) {
      return Re.createElement(u_, Nw({
        motionAppear: !0,
        motionEnter: !0,
        motionLeave: !0,
        removeOnLeave: !1,
        forceRender: h,
        leavedClassName: "".concat(n, "-hidden")
      }, y, {
        onAppearPrepare: A,
        onEnterPrepare: A,
        visible: s,
        onVisibleChanged: function onVisibleChanged(e) {
          var t;
          null == y || null === (t = y.onVisibleChanged) || void 0 === t || t.call(y, e), l(e);
        }
      }), function (r, i) {
        var l = r.className,
          c = r.style,
          p = LN(n, l, a);
        return Re.createElement("div", {
          ref: Kx(e, t, i),
          className: p,
          style: Ox(Ox(Ox(Ox({
            "--arrow-x": "".concat(f.x || 0, "px"),
            "--arrow-y": "".concat(f.y || 0, "px")
          }, G), q), c), {}, {
            boxSizing: "border-box",
            zIndex: k
          }, o),
          onMouseEnter: w,
          onMouseLeave: _,
          onPointerEnter: F,
          onClick: d
        }, m && Re.createElement(d_, {
          prefixCls: n,
          arrow: m,
          arrowPos: f,
          align: v
        }), Re.createElement(f_, {
          cache: !s && !u
        }, B));
      });
    }));
  });
"production" !== process.env.NODE_ENV && (v_.displayName = "Popup");
var y_ = v_,
  g_ = Re.forwardRef(function (e, t) {
    var r = e.children,
      a = e.getTriggerDOMNode,
      n = $x(r),
      o = Yx(Re.useCallback(function (e) {
        Wx(t, a ? a(e) : e);
      }, [a]), r.ref);
    return n ? Re.cloneElement(r, {
      ref: o
    }) : r;
  });
"production" !== process.env.NODE_ENV && (g_.displayName = "TriggerWrapper");
var h_ = g_,
  b_ = Re.createContext(null);
function N_(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function x_(e, t, r, a) {
  return Re.useMemo(function () {
    var n = N_(null != r ? r : t),
      o = N_(null != a ? a : t),
      i = new Set(n),
      l = new Set(o);
    return e && (i.has("hover") && (i.delete("hover"), i.add("click")), l.has("hover") && (l.delete("hover"), l.add("click"))), [i, l];
  }, [e, t, r, a]);
}
function k_() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
    r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function w_(e, t, r, a) {
  for (var n = r.points, o = Object.keys(e), i = 0; i < o.length; i += 1) {
    var l,
      s = o[i];
    if (k_(null === (l = e[s]) || void 0 === l ? void 0 : l.points, n, a)) return "".concat(t, "-placement-").concat(s);
  }
  return "";
}
function __(e, t, r, a) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : a ? {
    motionName: a
  } : null);
}
function F_(e) {
  return e.ownerDocument.defaultView;
}
function S_(e) {
  for (var t = [], r = null == e ? void 0 : e.parentElement, a = ["hidden", "scroll", "clip", "auto"]; r;) {
    var n = F_(r).getComputedStyle(r);
    [n.overflowX, n.overflowY, n.overflow].some(function (e) {
      return a.includes(e);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function C_(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function j_(e) {
  return C_(parseFloat(e), 0);
}
function E_(e, t) {
  var r = Ox({}, e);
  return (t || []).forEach(function (e) {
    if (!(e instanceof HTMLBodyElement || e instanceof HTMLHtmlElement)) {
      var t = F_(e).getComputedStyle(e),
        a = t.overflow,
        n = t.overflowClipMargin,
        o = t.borderTopWidth,
        i = t.borderBottomWidth,
        l = t.borderLeftWidth,
        s = t.borderRightWidth,
        c = e.getBoundingClientRect(),
        u = e.offsetHeight,
        d = e.clientHeight,
        p = e.offsetWidth,
        m = e.clientWidth,
        f = j_(o),
        v = j_(i),
        y = j_(l),
        g = j_(s),
        h = C_(Math.round(c.width / p * 1e3) / 1e3),
        b = C_(Math.round(c.height / u * 1e3) / 1e3),
        N = (p - m - y - g) * h,
        x = (u - d - f - v) * b,
        k = f * b,
        w = v * b,
        _ = y * h,
        F = g * h,
        S = 0,
        C = 0;
      if ("clip" === a) {
        var j = j_(n);
        S = j * h, C = j * b;
      }
      var E = c.x + _ - S,
        T = c.y + k - C,
        O = E + c.width + 2 * S - _ - F - N,
        A = T + c.height + 2 * C - k - w - x;
      r.left = Math.max(r.left, E), r.top = Math.max(r.top, T), r.right = Math.min(r.right, O), r.bottom = Math.min(r.bottom, A);
    }
  }), r;
}
function T_(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    r = "".concat(t),
    a = r.match(/^(.*)\%$/);
  return a ? e * (parseFloat(a[1]) / 100) : parseFloat(r);
}
function O_(e, t) {
  var r = Lx(t || [], 2),
    a = r[0],
    n = r[1];
  return [T_(e.width, a), T_(e.height, n)];
}
function A_() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return [e[0], e[1]];
}
function M_(e, t) {
  var r,
    a = t[0],
    n = t[1];
  return r = "t" === a ? e.y : "b" === a ? e.y + e.height : e.y + e.height / 2, {
    x: "l" === n ? e.x : "r" === n ? e.x + e.width : e.x + e.width / 2,
    y: r
  };
}
function L_(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function (e, a) {
    return a === t ? r[e] || "c" : e;
  }).join("");
}
function D_(e, t, r, a, n, o, i) {
  var l = Lx(Re.useState({
      ready: !1,
      offsetX: 0,
      offsetY: 0,
      offsetR: 0,
      offsetB: 0,
      arrowX: 0,
      arrowY: 0,
      scaleX: 1,
      scaleY: 1,
      align: n[a] || {}
    }), 2),
    s = l[0],
    c = l[1],
    u = Re.useRef(0),
    d = Re.useMemo(function () {
      return t ? S_(t) : [];
    }, [t]),
    p = Re.useRef({});
  e || (p.current = {});
  var m = PN(function () {
      if (t && r && e) {
        var l,
          s,
          u,
          m = function m(e, t) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $,
              a = j.x + e,
              n = j.y + t,
              o = a + P,
              i = n + B,
              l = Math.max(a, r.left),
              s = Math.max(n, r.top),
              c = Math.min(o, r.right),
              u = Math.min(i, r.bottom);
            return Math.max(0, (c - l) * (u - s));
          },
          f = function f() {
            le = j.y + be, se = le + B, ce = j.x + he, ue = ce + P;
          },
          v = t,
          y = v.ownerDocument,
          g = F_(v).getComputedStyle(v),
          h = g.width,
          b = g.height,
          N = g.position,
          x = v.style.left,
          k = v.style.top,
          w = v.style.right,
          _ = v.style.bottom,
          F = Ox(Ox({}, n[a]), o),
          S = y.createElement("div");
        if (null === (l = v.parentElement) || void 0 === l || l.appendChild(S), S.style.left = "".concat(v.offsetLeft, "px"), S.style.top = "".concat(v.offsetTop, "px"), S.style.position = N, S.style.height = "".concat(v.offsetHeight, "px"), S.style.width = "".concat(v.offsetWidth, "px"), v.style.left = "0", v.style.top = "0", v.style.right = "auto", v.style.bottom = "auto", Array.isArray(r)) u = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };else {
          var C = r.getBoundingClientRect();
          u = {
            x: C.x,
            y: C.y,
            width: C.width,
            height: C.height
          };
        }
        var j = v.getBoundingClientRect(),
          E = y.documentElement,
          T = E.clientWidth,
          O = E.clientHeight,
          A = E.scrollWidth,
          M = E.scrollHeight,
          L = E.scrollTop,
          D = E.scrollLeft,
          B = j.height,
          P = j.width,
          I = u.height,
          z = u.width,
          R = {
            left: 0,
            top: 0,
            right: T,
            bottom: O
          },
          U = {
            left: -D,
            top: -L,
            right: A - D,
            bottom: M - L
          },
          H = F.htmlRegion,
          G = "visible",
          V = "visibleFirst";
        "scroll" !== H && H !== V && (H = G);
        var W = H === V,
          K = E_(U, d),
          Y = E_(R, d),
          $ = H === G ? Y : K,
          q = W ? Y : $;
        v.style.left = "auto", v.style.top = "auto", v.style.right = "0", v.style.bottom = "0";
        var J = v.getBoundingClientRect();
        v.style.left = x, v.style.top = k, v.style.right = w, v.style.bottom = _, null === (s = v.parentElement) || void 0 === s || s.removeChild(S);
        var X = C_(Math.round(P / parseFloat(h) * 1e3) / 1e3),
          Z = C_(Math.round(B / parseFloat(b) * 1e3) / 1e3);
        if (0 === X || 0 === Z || wk(r) && !function (e) {
          if (!e) return !1;
          if (e instanceof Element) {
            if (e.offsetParent) return !0;
            if (e.getBBox) {
              var t = e.getBBox(),
                r = t.width,
                a = t.height;
              if (r || a) return !0;
            }
            if (e.getBoundingClientRect) {
              var n = e.getBoundingClientRect(),
                o = n.width,
                i = n.height;
              if (o || i) return !0;
            }
          }
          return !1;
        }(r)) return;
        var Q = F.offset,
          ee = F.targetOffset,
          te = Lx(O_(j, Q), 2),
          re = te[0],
          ae = te[1],
          ne = Lx(O_(u, ee), 2),
          oe = ne[0],
          ie = ne[1];
        u.x -= oe, u.y -= ie;
        var le,
          se,
          ce,
          ue,
          de = Lx(F.points || [], 2),
          pe = de[0],
          me = A_(de[1]),
          fe = A_(pe),
          ve = M_(u, me),
          ye = M_(j, fe),
          ge = Ox({}, F),
          he = ve.x - ye.x + re,
          be = ve.y - ye.y + ae,
          Ne = m(he, be),
          xe = m(he, be, Y),
          ke = M_(u, ["t", "l"]),
          we = M_(j, ["t", "l"]),
          _e = M_(u, ["b", "r"]),
          Fe = M_(j, ["b", "r"]),
          Se = F.overflow || {},
          Ce = Se.adjustX,
          je = Se.adjustY,
          Ee = Se.shiftX,
          Te = Se.shiftY,
          Oe = function Oe(e) {
            return "boolean" == typeof e ? e : e >= 0;
          };
        f();
        var Ae = Oe(je),
          Me = fe[0] === me[0];
        if (Ae && "t" === fe[0] && (se > q.bottom || p.current.bt)) {
          var Le = be;
          Me ? Le -= B - I : Le = ke.y - Fe.y - ae;
          var De = m(he, Le),
            Be = m(he, Le, Y);
          De > Ne || De === Ne && (!W || Be >= xe) ? (p.current.bt = !0, be = Le, ae = -ae, ge.points = [L_(fe, 0), L_(me, 0)]) : p.current.bt = !1;
        }
        if (Ae && "b" === fe[0] && (le < q.top || p.current.tb)) {
          var Pe = be;
          Me ? Pe += B - I : Pe = _e.y - we.y - ae;
          var Ie = m(he, Pe),
            ze = m(he, Pe, Y);
          Ie > Ne || Ie === Ne && (!W || ze >= xe) ? (p.current.tb = !0, be = Pe, ae = -ae, ge.points = [L_(fe, 0), L_(me, 0)]) : p.current.tb = !1;
        }
        var Re = Oe(Ce),
          Ue = fe[1] === me[1];
        if (Re && "l" === fe[1] && (ue > q.right || p.current.rl)) {
          var He = he;
          Ue ? He -= P - z : He = ke.x - Fe.x - re;
          var Ge = m(He, be),
            Ve = m(He, be, Y);
          Ge > Ne || Ge === Ne && (!W || Ve >= xe) ? (p.current.rl = !0, he = He, re = -re, ge.points = [L_(fe, 1), L_(me, 1)]) : p.current.rl = !1;
        }
        if (Re && "r" === fe[1] && (ce < q.left || p.current.lr)) {
          var We = he;
          Ue ? We += P - z : We = _e.x - we.x - re;
          var Ke = m(We, be),
            Ye = m(We, be, Y);
          Ke > Ne || Ke === Ne && (!W || Ye >= xe) ? (p.current.lr = !0, he = We, re = -re, ge.points = [L_(fe, 1), L_(me, 1)]) : p.current.lr = !1;
        }
        f();
        var $e = !0 === Ee ? 0 : Ee;
        "number" == typeof $e && (ce < Y.left && (he -= ce - Y.left - re, u.x + z < Y.left + $e && (he += u.x - Y.left + z - $e)), ue > Y.right && (he -= ue - Y.right - re, u.x > Y.right - $e && (he += u.x - Y.right + $e)));
        var qe = !0 === Te ? 0 : Te;
        "number" == typeof qe && (le < Y.top && (be -= le - Y.top - ae, u.y + I < Y.top + qe && (be += u.y - Y.top + I - qe)), se > Y.bottom && (be -= se - Y.bottom - ae, u.y > Y.bottom - qe && (be += u.y - Y.bottom + qe)));
        var Je = j.x + he,
          Xe = Je + P,
          Ze = j.y + be,
          Qe = Ze + B,
          et = u.x,
          tt = et + z,
          rt = u.y,
          at = rt + I,
          nt = (Math.max(Je, et) + Math.min(Xe, tt)) / 2 - Je,
          ot = (Math.max(Ze, rt) + Math.min(Qe, at)) / 2 - Ze;
        null == i || i(t, ge);
        var it = J.right - j.x - (he + j.width),
          lt = J.bottom - j.y - (be + j.height);
        c({
          ready: !0,
          offsetX: he / X,
          offsetY: be / Z,
          offsetR: it / X,
          offsetB: lt / Z,
          arrowX: nt / X,
          arrowY: ot / Z,
          scaleX: X,
          scaleY: Z,
          align: ge
        });
      }
    }),
    f = function f() {
      c(function (e) {
        return Ox(Ox({}, e), {}, {
          ready: !1
        });
      });
    };
  return RN(f, [a]), RN(function () {
    e || f();
  }, [e]), [s.ready, s.offsetX, s.offsetY, s.offsetR, s.offsetB, s.arrowX, s.arrowY, s.scaleX, s.scaleY, s.align, function () {
    u.current += 1;
    var e = u.current;
    Promise.resolve().then(function () {
      u.current === e && m();
    });
  }];
}
function B_(e) {
  return function (e) {
    if (Array.isArray(e)) return Ax(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Mx(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function P_(e, t, r, a, n) {
  RN(function () {
    if (e && t && r) {
      var o = function o() {
          a(), n();
        },
        i = r,
        l = S_(t),
        s = S_(i),
        c = F_(i),
        u = new Set([c].concat(B_(l), B_(s)));
      return u.forEach(function (e) {
        e.addEventListener("scroll", o, {
          passive: !0
        });
      }), c.addEventListener("resize", o, {
        passive: !0
      }), a(), function () {
        u.forEach(function (e) {
          e.removeEventListener("scroll", o), c.removeEventListener("resize", o);
        });
      };
    }
  }, [e, t, r]);
}
function I_(e, t, r, a, n, o, i, l) {
  var s = Re.useRef(e),
    c = Re.useRef(!1);
  s.current !== e && (c.current = !0, s.current = e), Re.useEffect(function () {
    var e = n_(function () {
      c.current = !1;
    });
    return function () {
      n_.cancel(e);
    };
  }, [e]), Re.useEffect(function () {
    if (t && a && (!n || o)) {
      var e = function e() {
          var e = !1;
          return [function (t) {
            var r = t.target;
            e = i(r);
          }, function (t) {
            var r = t.target;
            c.current || !s.current || e || i(r) || l(!1);
          }];
        },
        u = Lx(e(), 2),
        d = u[0],
        p = u[1],
        m = Lx(e(), 2),
        f = m[0],
        v = m[1],
        y = F_(a);
      y.addEventListener("mousedown", d, !0), y.addEventListener("click", p, !0), y.addEventListener("contextmenu", p, !0);
      var g,
        h,
        b = dw(r);
      if (b && (b.addEventListener("mousedown", f, !0), b.addEventListener("click", v, !0), b.addEventListener("contextmenu", v, !0)), "production" !== process.env.NODE_ENV) YN((null == r || null === (g = r.getRootNode) || void 0 === g ? void 0 : g.call(r)) === (null === (h = a.getRootNode) || void 0 === h ? void 0 : h.call(a)), "trigger element and popup element should in same shadow root.");
      return function () {
        y.removeEventListener("mousedown", d, !0), y.removeEventListener("click", p, !0), y.removeEventListener("contextmenu", p, !0), b && (b.removeEventListener("mousedown", f, !0), b.removeEventListener("click", v, !0), b.removeEventListener("contextmenu", v, !0));
      };
    }
  }, [t, r, a, n, o]);
}
var z_ = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
var R_ = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : vk,
      t = Re.forwardRef(function (t, r) {
        var a = t.prefixCls,
          n = void 0 === a ? "rc-trigger-popup" : a,
          o = t.children,
          i = t.action,
          l = void 0 === i ? "hover" : i,
          s = t.showAction,
          c = t.hideAction,
          u = t.popupVisible,
          d = t.defaultPopupVisible,
          p = t.onPopupVisibleChange,
          m = t.afterPopupVisibleChange,
          f = t.mouseEnterDelay,
          v = t.mouseLeaveDelay,
          y = void 0 === v ? .1 : v,
          g = t.focusDelay,
          h = t.blurDelay,
          b = t.mask,
          N = t.maskClosable,
          x = void 0 === N || N,
          k = t.getPopupContainer,
          w = t.forceRender,
          _ = t.autoDestroy,
          F = t.destroyPopupOnHide,
          S = t.popup,
          C = t.popupClassName,
          j = t.popupStyle,
          E = t.popupPlacement,
          T = t.builtinPlacements,
          O = void 0 === T ? {} : T,
          A = t.popupAlign,
          M = t.zIndex,
          L = t.stretch,
          D = t.getPopupClassNameFromAlign,
          B = t.fresh,
          P = t.alignPoint,
          I = t.onPopupClick,
          z = t.onPopupAlign,
          R = t.arrow,
          U = t.popupMotion,
          H = t.maskMotion,
          G = t.popupTransitionName,
          V = t.popupAnimation,
          W = t.maskTransitionName,
          K = t.maskAnimation,
          Y = t.className,
          $ = t.getTriggerDOMNode,
          q = Dx(t, z_),
          J = _ || F || !1,
          X = Lx(Re.useState(!1), 2),
          Z = X[0],
          Q = X[1];
        RN(function () {
          Q(bw());
        }, []);
        var ee = Re.useRef({}),
          te = Re.useContext(b_),
          re = Re.useMemo(function () {
            return {
              registerSubPopup: function registerSubPopup(e, t) {
                ee.current[e] = t, null == te || te.registerSubPopup(e, t);
              }
            };
          }, [te]),
          ae = hw(),
          ne = Lx(Re.useState(null), 2),
          oe = ne[0],
          ie = ne[1],
          le = PN(function (e) {
            wk(e) && oe !== e && ie(e), null == te || te.registerSubPopup(ae, e);
          }),
          se = Lx(Re.useState(null), 2),
          ce = se[0],
          ue = se[1],
          de = Re.useRef(null),
          pe = PN(function (e) {
            wk(e) && ce !== e && (ue(e), de.current = e);
          }),
          me = Re.Children.only(o),
          fe = (null == me ? void 0 : me.props) || {},
          ve = {},
          ye = PN(function (e) {
            var t,
              r,
              a = ce;
            return (null == a ? void 0 : a.contains(e)) || (null === (t = dw(a)) || void 0 === t ? void 0 : t.host) === e || e === a || (null == oe ? void 0 : oe.contains(e)) || (null === (r = dw(oe)) || void 0 === r ? void 0 : r.host) === e || e === oe || Object.values(ee.current).some(function (t) {
              return (null == t ? void 0 : t.contains(e)) || e === t;
            });
          }),
          ge = __(n, U, V, G),
          he = __(n, H, K, W),
          be = Lx(Re.useState(d || !1), 2),
          Ne = be[0],
          xe = be[1],
          ke = null != u ? u : Ne,
          we = PN(function (e) {
            void 0 === u && xe(e);
          });
        RN(function () {
          xe(u || !1);
        }, [u]);
        var _e = Re.useRef(ke);
        _e.current = ke;
        var Fe = Re.useRef([]);
        Fe.current = [];
        var Se = PN(function (e) {
            var t;
            we(e), (null !== (t = Fe.current[Fe.current.length - 1]) && void 0 !== t ? t : ke) !== e && (Fe.current.push(e), null == p || p(e));
          }),
          Ce = Re.useRef(),
          je = function je() {
            clearTimeout(Ce.current);
          },
          Ee = function Ee(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            je(), 0 === t ? Se(e) : Ce.current = setTimeout(function () {
              Se(e);
            }, 1e3 * t);
          };
        Re.useEffect(function () {
          return je;
        }, []);
        var Te = Lx(Re.useState(!1), 2),
          Oe = Te[0],
          Ae = Te[1];
        RN(function (e) {
          e && !ke || Ae(!0);
        }, [ke]);
        var Me = Lx(Re.useState(null), 2),
          Le = Me[0],
          De = Me[1],
          Be = Lx(Re.useState([0, 0]), 2),
          Pe = Be[0],
          Ie = Be[1],
          ze = function ze(e) {
            Ie([e.clientX, e.clientY]);
          },
          Ue = Lx(D_(ke, oe, P ? Pe : ce, E, O, A, z), 11),
          He = Ue[0],
          Ge = Ue[1],
          Ve = Ue[2],
          We = Ue[3],
          Ke = Ue[4],
          Ye = Ue[5],
          $e = Ue[6],
          qe = Ue[7],
          Je = Ue[8],
          Xe = Ue[9],
          Ze = Ue[10],
          Qe = Lx(x_(Z, l, s, c), 2),
          et = Qe[0],
          tt = Qe[1],
          rt = et.has("click"),
          at = tt.has("click") || tt.has("contextMenu"),
          nt = PN(function () {
            Oe || Ze();
          });
        P_(ke, ce, oe, nt, function () {
          _e.current && P && at && Ee(!1);
        }), RN(function () {
          nt();
        }, [Pe, E]), RN(function () {
          !ke || null != O && O[E] || nt();
        }, [JSON.stringify(A)]);
        var ot = Re.useMemo(function () {
          var e = w_(O, n, Xe, P);
          return LN(e, null == D ? void 0 : D(Xe));
        }, [Xe, D, O, n, P]);
        Re.useImperativeHandle(r, function () {
          return {
            nativeElement: de.current,
            forceAlign: nt
          };
        });
        var it = Lx(Re.useState(0), 2),
          lt = it[0],
          st = it[1],
          ct = Lx(Re.useState(0), 2),
          ut = ct[0],
          dt = ct[1],
          pt = function pt() {
            if (L && ce) {
              var e = ce.getBoundingClientRect();
              st(e.width), dt(e.height);
            }
          };
        function mt(e, t, r, a) {
          ve[e] = function (n) {
            var o;
            null == a || a(n), Ee(t, r);
            for (var i = arguments.length, l = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++) l[s - 1] = arguments[s];
            null === (o = fe[e]) || void 0 === o || o.call.apply(o, [fe, n].concat(l));
          };
        }
        RN(function () {
          Le && (Ze(), Le(), De(null));
        }, [Le]), (rt || at) && (ve.onClick = function (e) {
          var t;
          _e.current && at ? Ee(!1) : !_e.current && rt && (ze(e), Ee(!0));
          for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) a[n - 1] = arguments[n];
          null === (t = fe.onClick) || void 0 === t || t.call.apply(t, [fe, e].concat(a));
        }), I_(ke, at, ce, oe, b, x, ye, Ee);
        var ft,
          vt,
          yt = et.has("hover"),
          gt = tt.has("hover");
        yt && (mt("onMouseEnter", !0, f, function (e) {
          ze(e);
        }), mt("onPointerEnter", !0, f, function (e) {
          ze(e);
        }), ft = function ft() {
          (ke || Oe) && Ee(!0, f);
        }, P && (ve.onMouseMove = function (e) {
          var t;
          null === (t = fe.onMouseMove) || void 0 === t || t.call(fe, e);
        })), gt && (mt("onMouseLeave", !1, y), mt("onPointerLeave", !1, y), vt = function vt() {
          Ee(!1, y);
        }), et.has("focus") && mt("onFocus", !0, g), tt.has("focus") && mt("onBlur", !1, h), et.has("contextMenu") && (ve.onContextMenu = function (e) {
          var t;
          _e.current && tt.has("contextMenu") ? Ee(!1) : (ze(e), Ee(!0)), e.preventDefault();
          for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) a[n - 1] = arguments[n];
          null === (t = fe.onContextMenu) || void 0 === t || t.call.apply(t, [fe, e].concat(a));
        }), Y && (ve.className = LN(fe.className, Y));
        var ht = Ox(Ox({}, fe), ve),
          bt = {};
        ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"].forEach(function (e) {
          q[e] && (bt[e] = function () {
            for (var t, r = arguments.length, a = new Array(r), n = 0; n < r; n++) a[n] = arguments[n];
            null === (t = ht[e]) || void 0 === t || t.call.apply(t, [ht].concat(a)), q[e].apply(q, a);
          });
        });
        var Nt = Re.cloneElement(me, Ox(Ox({}, ht), bt)),
          xt = {
            x: Ye,
            y: $e
          },
          kt = R ? Ox({}, !0 !== R ? R : {}) : null;
        return Re.createElement(Re.Fragment, null, Re.createElement(cw, {
          disabled: !ke,
          ref: pe,
          onResize: function onResize() {
            pt(), nt();
          }
        }, Re.createElement(h_, {
          getTriggerDOMNode: $
        }, Nt)), Re.createElement(b_.Provider, {
          value: re
        }, Re.createElement(y_, {
          portal: e,
          ref: le,
          prefixCls: n,
          popup: S,
          className: LN(C, ot),
          style: j,
          target: ce,
          onMouseEnter: ft,
          onMouseLeave: vt,
          onPointerEnter: ft,
          zIndex: M,
          open: ke,
          keepDom: Oe,
          fresh: B,
          onClick: I,
          mask: b,
          motion: ge,
          maskMotion: he,
          onVisibleChanged: function onVisibleChanged(e) {
            Ae(!1), Ze(), null == m || m(e);
          },
          onPrepare: function onPrepare() {
            return new Promise(function (e) {
              pt(), De(function () {
                return e;
              });
            });
          },
          forceRender: w,
          autoDestroy: J,
          getPopupContainer: k,
          align: Xe,
          arrow: kt,
          arrowPos: xt,
          ready: He,
          offsetX: Ge,
          offsetY: Ve,
          offsetR: We,
          offsetB: Ke,
          onAlign: nt,
          stretch: L,
          targetWidth: lt / qe,
          targetHeight: ut / Je
        })));
      });
    return "production" !== process.env.NODE_ENV && (t.displayName = "Trigger"), t;
  }(vk),
  U_ = {
    shiftX: 64,
    adjustY: 1
  },
  H_ = {
    adjustX: 1,
    shiftY: !0
  },
  G_ = [0, 0],
  V_ = {
    left: {
      points: ["cr", "cl"],
      overflow: H_,
      offset: [-4, 0],
      targetOffset: G_
    },
    right: {
      points: ["cl", "cr"],
      overflow: H_,
      offset: [4, 0],
      targetOffset: G_
    },
    top: {
      points: ["bc", "tc"],
      overflow: U_,
      offset: [0, -4],
      targetOffset: G_
    },
    bottom: {
      points: ["tc", "bc"],
      overflow: U_,
      offset: [0, 4],
      targetOffset: G_
    },
    topLeft: {
      points: ["bl", "tl"],
      overflow: U_,
      offset: [0, -4],
      targetOffset: G_
    },
    leftTop: {
      points: ["tr", "tl"],
      overflow: H_,
      offset: [-4, 0],
      targetOffset: G_
    },
    topRight: {
      points: ["br", "tr"],
      overflow: U_,
      offset: [0, -4],
      targetOffset: G_
    },
    rightTop: {
      points: ["tl", "tr"],
      overflow: H_,
      offset: [4, 0],
      targetOffset: G_
    },
    bottomRight: {
      points: ["tr", "br"],
      overflow: U_,
      offset: [0, 4],
      targetOffset: G_
    },
    rightBottom: {
      points: ["bl", "br"],
      overflow: H_,
      offset: [4, 0],
      targetOffset: G_
    },
    bottomLeft: {
      points: ["tl", "bl"],
      overflow: U_,
      offset: [0, 4],
      targetOffset: G_
    },
    leftBottom: {
      points: ["br", "bl"],
      overflow: H_,
      offset: [-4, 0],
      targetOffset: G_
    }
  },
  W_ = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"],
  K_ = function K_(e, t) {
    var r = e.overlayClassName,
      a = e.trigger,
      n = void 0 === a ? ["hover"] : a,
      o = e.mouseEnterDelay,
      i = void 0 === o ? 0 : o,
      l = e.mouseLeaveDelay,
      s = void 0 === l ? .1 : l,
      c = e.overlayStyle,
      u = e.prefixCls,
      d = void 0 === u ? "rc-tooltip" : u,
      p = e.children,
      m = e.onVisibleChange,
      f = e.afterVisibleChange,
      v = e.transitionName,
      y = e.animation,
      g = e.motion,
      h = e.placement,
      b = void 0 === h ? "right" : h,
      N = e.align,
      x = void 0 === N ? {} : N,
      k = e.destroyTooltipOnHide,
      w = void 0 !== k && k,
      _ = e.defaultVisible,
      F = e.getTooltipContainer,
      S = e.overlayInnerStyle;
    e.arrowContent;
    var C = e.overlay,
      j = e.id,
      E = e.showArrow,
      T = void 0 === E || E,
      O = Sx(e, W_),
      A = Ge(null);
    tt(t, function () {
      return A.current;
    });
    var M = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Fx(Object(r), !0).forEach(function (t) {
          _x(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fx(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }({}, O);
    "visible" in e && (M.popupVisible = e.visible);
    return Re.createElement(R_, xx({
      popupClassName: r,
      prefixCls: d,
      popup: function popup() {
        return Re.createElement(Nx, {
          key: "content",
          prefixCls: d,
          id: j,
          overlayInnerStyle: S
        }, C);
      },
      action: n,
      builtinPlacements: V_,
      popupPlacement: b,
      ref: A,
      popupAlign: x,
      getPopupContainer: F,
      onPopupVisibleChange: m,
      afterPopupVisibleChange: f,
      popupTransitionName: v,
      popupAnimation: y,
      popupMotion: g,
      defaultPopupVisible: _,
      autoDestroy: w,
      mouseLeaveDelay: s,
      popupStyle: c,
      mouseEnterDelay: i,
      arrow: T
    }, M), p);
  },
  Y_ = qe(K_),
  $_ = "Slider-module_cui__slider__B2Gjx",
  q_ = "Slider-module_cui__slider-extension__LeU9s",
  J_ = "Slider-module_rc-slider-override__FOQdL",
  X_ = {};
function Z_(e, t, r) {
  return e === t ? (r({
    min: !1,
    max: !0
  }), !0) : 0 === e ? (r({
    min: !0,
    max: !1
  }), !0) : (r({
    min: !1,
    max: !1
  }), !1);
}
function Q_(e, t, r, a, n, o, i, l) {
  var s = "increment" === e ? r[t] + 1 : r[t] - 1,
    c = a[s];
  return n(s), o(c), Z_(s, i, l), c;
}
var eF = function eF(e) {
    var t,
      r,
      a = e.onChange,
      n = void 0 === a ? function (e) {} : a,
      o = e.id,
      i = (e.isCordovaApp, e.marks),
      l = void 0 === i ? X_ : i,
      s = e.minStep,
      c = void 0 === s ? 0 : s,
      u = e.maxStep,
      d = void 0 === u ? 100 : u,
      p = (e.value, e.step),
      m = void 0 === p ? 1 : p,
      f = e.defaultValue,
      v = void 0 === f ? 0 : f,
      y = e.disabled,
      g = void 0 !== y && y,
      h = e.included,
      b = void 0 !== h && h,
      N = e.showCenterMark,
      x = void 0 !== N && N,
      k = e.withButtons,
      w = void 0 === k || k,
      _ = e.showTooltips,
      F = void 0 !== _ && _,
      S = e.showFirstAndLastMarks,
      C = void 0 !== S && S,
      j = (e.origin, e.className),
      E = void 0 === j ? "" : j,
      T = e.automationTags,
      O = void 0 === T ? function (e) {
        return {};
      } : T,
      A = null === (t = Object.entries(l)) || void 0 === t || null === (r = t.reduce(function (e, t) {
        var r = Le(t, 2),
          a = r[0];
        r[1];
        return e.push(+a), e;
      }, [])) || void 0 === r ? void 0 : r.sort(function (e, t) {
        return "string" == typeof e && "string" == typeof t ? +e > +t ? 1 : -1 : e > t ? 1 : -1;
      }),
      M = !!A.length,
      L = M ? A.length - 1 : null,
      D = Xe(function () {
        var e = Te({}, l);
        return C && A.forEach(function (t, r) {
          0 !== r && r !== A.length - 1 ? e[t] = {
            style: {
              opacity: 0,
              cursor: "pointer"
            },
            label: l[t]
          } : e[t] = {
            label: l[t],
            style: {
              cursor: "pointer"
            }
          };
        }), e;
      }, [C]),
      B = A.at(0),
      P = A.at(-1),
      I = null != B ? +B : c,
      z = null != P ? +P : d,
      R = M ? Math.round((A.length - 1) / 2) : null,
      U = !!F,
      H = v || 0,
      G = Le(He(H), 2),
      V = G[0],
      W = G[1],
      K = A.reduce(function (e, t, r, a) {
        return e[r] = t, e;
      }, {}),
      Y = Object.entries(K).reduce(function (e, t) {
        var r = Le(t, 2),
          a = r[0],
          n = r[1];
        return e["".concat(n)] = +a, e;
      }, {}),
      $ = Le(He(R), 2),
      q = ($[0], $[1]),
      J = Le(He({
        min: !1,
        max: !1
      }), 2),
      X = J[0],
      Z = J[1],
      Q = Ye(function (e) {
        W(e), M && q(function () {
          var t = Y[e.toString()];
          return Z_(t, L, Z), t;
        }), n(e);
      }, []),
      ee = Ye(function () {
        W(function (e) {
          return Q_("increment", e, Y, K, q, n, L, Z);
        });
      }, []),
      te = Ye(function () {
        W(function (e) {
          return Q_("decrement", e, Y, K, q, n, L, Z);
        });
      }, []),
      re = Ye(function (e, t) {
        return U ? dt.exports.jsx(Y_, {
          placement: "top",
          overlay: l[V],
          overlayInnerStyle: {
            minHeight: "auto"
          },
          trigger: "hover",
          children: e
        }) : e;
      }, [U, V]);
    return dt.exports.jsx("div", Te(Te({}, O("slider-override")), {}, {
      className: "".concat($_, " ").concat(J_, " ").concat(E),
      id: o,
      "data-disabled": g,
      children: dt.exports.jsxs("div", Te(Te({}, O("wh-slider-extension")), {}, {
        className: "cui__slider-extension ".concat(q_, " cui-gap-xs"),
        "data-show-center-mark": x,
        children: [w ? dt.exports.jsx(nd, {
          leftIcon: "ui_minus",
          size: "xs",
          type: "minimal",
          className: "-cui-mt-1",
          onClick: te,
          disabled: X.min || g
        }) : null, dt.exports.jsx(bx, {
          min: I,
          max: z,
          marks: D,
          step: M ? null : m,
          onChange: Q,
          value: V,
          defaultValue: H,
          disabled: g,
          included: b,
          draggableTrack: !M,
          className: "".concat(J_),
          handleRender: re
        }), w ? dt.exports.jsx(nd, {
          leftIcon: "ui_plus",
          size: "xs",
          type: "minimal",
          className: "-cui-mt-1",
          onClick: ee,
          disabled: X.max || g
        }) : null]
      }))
    }));
  },
  tF = Ke(vN, function (e, t) {
    return JSON.stringify(e) === JSON.stringify(t);
  }),
  rF = function rF(e) {
    var t,
      r,
      a,
      n = e.children,
      o = e.showLimit,
      i = e.filters,
      l = (e.showVersusDivider, Me(e, B));
    return Ue.Children.forEach(n, function (e) {
      var n, l, s;
      if (Ue.isValidElement(e)) {
        var c = {
            showLimit: o,
            filters: i
          },
          u = (null == e || null === (n = e.type) || void 0 === n || null === (l = n.type) || void 0 === l ? void 0 : l.name) || (null == e || null === (s = e.type) || void 0 === s ? void 0 : s.name) || "";
        switch (!0) {
          case "MarketLayoutFooter" === u:
            t = wN(e, c);
            break;
          case "MarketLayoutHeader" === u:
            r = e;
            break;
          case "MarketLayoutMarkets" === u:
            a = wN(e, c);
        }
      }
    }), dt.exports.jsxs(oN, Te(Te({}, l), {}, {
      children: [r ? dt.exports.jsx(oN.Cell, {
        colSpan: "full",
        children: r
      }) : null, a ? dt.exports.jsx(oN.Cell, {
        colSpan: "full",
        children: a
      }) : null, t ? dt.exports.jsx(oN.Cell, {
        colSpan: "full",
        children: t
      }) : null]
    }));
  },
  aF = function aF(e) {
    var t = e.children,
      r = e.showLimit,
      a = Me(e, P);
    return t ? dt.exports.jsx("div", Te(Te({}, a), {}, {
      children: t
    })) : dt.exports.jsx(kN, Te(Te({}, a), {}, {
      showLimit: r
    }));
  };
aF.displayName = "MarketLayoutFooter";
rF.Footer = aF, rF.Markets = Ke(function (e) {
  var t = e.markets,
    r = e.type,
    a = void 0 === r ? "row" : r,
    n = e.children,
    o = e.sliderKeyBy,
    i = void 0 === o ? "line" : o,
    l = e.marketHeader,
    s = e.marketTemplateTitle,
    c = Le(He(0), 2),
    u = c[0],
    d = c[1],
    p = Le(t.map(function (e) {
      return e.selections;
    }).flat().filter(function (e) {
      return e.isSelected;
    }) || [], 1)[0],
    m = !!p,
    f = "row" === a || !("slider" !== a && "list-view-col" !== a || m),
    v = n || t.map(function (t, r) {
      return function (e, t, r, a, n, o, i, l) {
        var s,
          c,
          u = r.groupBy,
          d = r.showVersusDivider,
          p = void 0 !== d && d,
          m = r.versusText,
          f = void 0 === m ? "at" : m,
          v = r.type,
          y = void 0 === v ? "row" : v,
          g = (r.activeFilter, r.sport),
          h = r.mode,
          b = r.onSelectionClick,
          N = r.updateMarket,
          x = r.oddsFormat,
          k = "after:cui-content-[''] ".concat("tennis" === g ? "after:cui-w-[calc(80%-72px)]" : "after:cui-w-[calc(50%-72px)]", " after:cui-h-1px after:cui-bg-fg-minimal after:cui-absolute after:cui-left-8 after:-cui-top-2px"),
          w = yt(Oe({}, "".concat("before:cui-absolute before:cui-top-[-12px] before:cui-left-2 before:cui-content-[attr(data-versus-text)] before:cui-text-fg-moderate before:cui-font-semiBold before:cui-text-size-1", " ").concat(k), p && 1 === t), "cui-mb-1 last:cui-mb-0 cui-relative"),
          _ = "id" in e ? e.id : "market-".concat(t);
        u && u in (null == e ? void 0 : e.competitor) && (c = u), null != e && null !== (s = e.competitor) && void 0 !== s && s.team && (c = "team");
        var F = c ? null == e ? void 0 : e.competitor[c] : "all";
        if ("slider" === y) {
          var S = e.competitor,
            C = [e.selections[Math.abs(a)]];
          return dt.exports.jsx(vN, {
            competitor: S,
            selections: C,
            oddsFormat: x,
            marketHeader: i,
            marketTemplateTitle: l,
            showVersusDivider: p,
            sport: g,
            useSingleSelection: !0,
            id: _,
            type: "col",
            className: w,
            mode: h,
            "data-versus-text": f,
            dataFilterGroup: F,
            onSelectionClick: b,
            canSelectMarkets: n,
            selectedSelectionId: o,
            updateMarket: N
          }, _);
        }
        return $e(tF, Te(Te({}, e), {}, {
          marketHeader: i,
          marketTemplateTitle: l,
          oddsFormat: x,
          showVersusDivider: p,
          sport: g,
          key: _,
          type: y,
          className: w,
          mode: h,
          "data-versus-text": f,
          "data-filter-group": F,
          canSelectMarkets: n,
          selectedSelectionId: o,
          onSelectionClick: b,
          updateMarket: N
        }));
      }(t, r, e, u, f, null == p ? void 0 : p.id, l, s);
    }),
    y = Ye(function (e) {
      d(e);
    }, []),
    g = {},
    h = {};
  return "col" === a || "list-view-col" === a ? dt.exports.jsx(oN, {
    columns: 2,
    flush: !0,
    children: v
  }) : "slider" === a ? (t.forEach(function (e, t) {
    e.selections.forEach(function (e, r) {
      if ("id" in e) {
        var a = 0 === t ? -r : r;
        g[a] = i in e ? e[i] : e.id, h[e.id] = a;
      }
    });
  }), m && u !== h[null == p ? void 0 : p.id] && d(h[null == p ? void 0 : p.id]), dt.exports.jsxs(dt.exports.Fragment, {
    children: [dt.exports.jsx(oN, {
      columns: 2,
      flush: !0,
      children: v
    }), dt.exports.jsx("div", {
      className: "cui-mt-xs cui-h-17 cui-grid cui-items-center",
      children: dt.exports.jsx(eF, {
        showCenterMark: !0,
        marks: g,
        defaultValue: h[(null == p ? void 0 : p.id) || 0],
        onChange: y,
        origin: "center",
        showFirstAndLastMarks: !0,
        disabled: !f
      })
    })]
  })) : v;
}), rF.Header = function (e) {
  return Object.keys(e).length ? e.children ? e.children : dt.exports.jsx(bN, Te({}, e)) : null;
};
var nF = {
    "2xs": "cui-rounded-2xs",
    xs: "cui-rounded-xs",
    sm: "cui-rounded-sm",
    md: "cui-rounded-md",
    lg: "cui-rounded-lg",
    none: "cui-rounded-none"
  },
  oF = "production" === process.env.NODE_ENV;
function iF(e, t) {
  if (!oF) {
    if (e) return;
    var r = "Warning: " + t;
    try {
      throw Error(r);
    } catch (e) {}
  }
}
var lF = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && he(e, t);
    }(n, ve(Error));
    var t,
      r,
      a = (t = n, r = ge(), function () {
        var e,
          a = be(t);
        if (r) {
          var n = be(this).constructor;
          e = Reflect.construct(a, arguments, n);
        } else e = a.apply(this, arguments);
        return fe(this, e);
      });
    function n(e) {
      return Ne(this, n), a.call(this, "react-collapsed: ".concat(e));
    }
    return ke(n);
  }(),
  sF = function sF() {
    return iF(arguments.length <= 0 ? void 0 : arguments[0], "[react-collapsed] -- ".concat(arguments.length <= 1 ? void 0 : arguments[1]));
  };
function cF(e) {
  var t = Ge(e);
  return Ve(function () {
    t.current = e;
  }), Ye(function () {
    for (var e, r = arguments.length, a = new Array(r), n = 0; n < r; n++) a[n] = arguments[n];
    return null === (e = t.current) || void 0 === e ? void 0 : e.call.apply(e, [t].concat(a));
  }, []);
}
function uF(e, t, r) {
  var a = Le(He(t), 2),
    n = a[0],
    o = a[1],
    i = Ge(void 0 !== e),
    l = i.current ? e : n,
    s = cF(r),
    c = Ye(function (e) {
      var t = "function" == typeof e ? e(l) : e;
      i.current || o(t), null == s || s(t);
    }, [s, l]);
  return Ve(function () {
    sF(!(i.current && null == e), "`isExpanded` state is changing from controlled to uncontrolled. useCollapse should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."), sF(!(!i.current && null != e), "`isExpanded` state is changing from uncontrolled to controlled. useCollapse should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop.");
  }, [e]), [l, c];
}
function dF() {
  var e = Le(He(!1), 2),
    t = e[0],
    r = e[1];
  return Ve(function () {
    if ("undefined" != typeof window && "function" == typeof window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion: reduce)");
      r(e.matches);
      var t = function t(e) {
        r(e.matches);
      };
      return e.addEventListener ? (e.addEventListener("change", t), function () {
        e.removeEventListener("change", t);
      }) : e.addListener ? (e.addListener(t), function () {
        e.removeListener(t);
      }) : void 0;
    }
  }, []), t;
}
var pF = Re["useId".toString()] || function () {};
var mF = "undefined" != typeof window ? Re.useLayoutEffect : Re.useEffect,
  fF = !1,
  vF = 0,
  yF = function yF() {
    return ++vF;
  };
function gF(e) {
  var t,
    r = null != (t = pF()) ? t : "",
    a = function (e) {
      var t = e || (fF ? yF() : null),
        r = Le(Re.useState(t), 2),
        a = r[0],
        n = r[1];
      return mF(function () {
        null === a && n(yF());
      }, []), Re.useEffect(function () {
        !1 === fF && (fF = !0);
      }, []), null != a ? String(a) : void 0;
    }(e);
  return "string" == typeof e ? e : "string" == typeof r ? r : a;
}
function hF(e, t) {
  var r = performance.now(),
    a = {};
  return function n() {
    a.id = requestAnimationFrame(function (a) {
      a - r > t ? e() : n();
    });
  }(), a;
}
function bF(e) {
  e.id && cancelAnimationFrame(e.id);
}
function NF(e) {
  return null != e && e.current ? e.current.scrollHeight : (sF(!0, "Was not able to find a ref to the collapse element via `getCollapseProps`. Ensure that the element exposes its `ref` prop. If it exposes the ref prop under a different name (like `innerRef`), use the `refKey` property to change it. Example:\n\nconst collapseProps = getCollapseProps({refKey: 'innerRef'})"), 0);
}
function xF(e) {
  if (!e || "string" == typeof e) return 0;
  var t = e / 36;
  return Math.round(10 * (4 + 15 * Math.pow(t, .25) + t / 5));
}
function kF(e, t) {
  if (null != e) if ("function" == typeof e) e(t);else try {
    e.current = t;
  } catch (r) {
    throw new lF('Cannot assign value "'.concat(t, '" to ref "').concat(e, '"'));
  }
}
function wF() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return t.every(function (e) {
    return null == e;
  }) ? null : function (e) {
    t.forEach(function (t) {
      kF(t, e);
    });
  };
}
function _F(e) {
  var t;
  t = function t(e) {
    if (null != e && e.current) {
      var t = window.getComputedStyle(e.current),
        r = t.paddingTop,
        a = t.paddingBottom;
      sF(!(r && "0px" !== r || a && "0px" !== a), "Padding applied to the collapse element will cause the animation to break and not perform as expected. To fix, apply equivalent padding to the direct descendent of the collapse element. Example:\n\nBefore:   <div {...getCollapseProps({style: {padding: 10}})}>{children}</div>\n\nAfter:   <div {...getCollapseProps()}>\n             <div style={{padding: 10}}>\n                 {children}\n             </div>\n          </div>");
    }
  }, Ve(function () {
    t(e);
  }, [e]);
}
var FF = "undefined" == typeof window ? Ve : We;
var SF = function SF(e) {
  var t = e.title,
    r = e.description,
    a = e.actionText,
    n = e.details,
    o = void 0 === n ? [] : n,
    i = e.onClick,
    l = e.collapsible,
    s = e.bg,
    c = void 0 === s ? "bg-default" : s,
    u = e.fg,
    d = void 0 === u ? "fg-default" : u,
    p = e.headingSize,
    m = void 0 === p ? "md-bold" : p,
    f = e.icon,
    v = e.isOpen;
  return t || r || a || o.length ? dt.exports.jsxs(oN, {
    gap: "none",
    className: yt(Oe({}, pn[c], !0), "cui__card-header cui-py-sm cui-px-md hover:cui-bg-bg-layer-one active:cui-bg-bg-layer-two cui-cursor-pointer"),
    flush: !0,
    onClick: i,
    children: [dt.exports.jsxs(oN.Cell, {
      colSpan: 9,
      className: "cui-flex-col",
      children: [t ? dt.exports.jsxs("div", {
        className: "cui-flex cui-items-center",
        role: "presentation",
        children: [f ? dt.exports.jsx(rs, {
          name: f,
          className: "cui-mr-1"
        }) : null, dt.exports.jsx(vn, {
          size: m,
          role: "heading",
          "aria-level": 1,
          className: "cui-select-none",
          color: d,
          children: t
        })]
      }) : null, r ? dt.exports.jsx(fn, {
        size: "sm",
        color: d || "fg-moderate",
        tag: "div",
        children: r
      }) : null]
    }), dt.exports.jsx(oN.Cell, {
      colSpan: 3,
      items: "center",
      children: dt.exports.jsxs("span", {
        className: "cui-w-full cui-inline-flex cui-justify-end",
        children: [o.length ? dt.exports.jsx(cc, {
          list: o
        }) : null, a ? dt.exports.jsx(fn, {
          tag: "span",
          size: "sm-bold",
          color: d,
          children: a
        }) : null, l ? dt.exports.jsx(rs, {
          name: "ui_chevron-up",
          size: "md",
          color: d || "fg-moderate",
          className: yt({
            "cui-rotate-180": !v
          }, "cui-transition-transform cui-duration-200 cui-ml-1")
        }) : null]
      })
    })]
  }) : null;
};
SF.displayName = "CardHeader";
var CF = function CF(e) {
    var t,
      r,
      a = e.t,
      n = e.x,
      o = e.b,
      i = e.noPad,
      l = e.children,
      s = e.className,
      c = (e.collapsible, e.isOpen, Me(e, R)),
      u = null === (t = yt((Oe(r = {}, "".concat(n), !i && !!n), Oe(r, "".concat(a), !i && !!a), Oe(r, "".concat(o), !i && !!o), Oe(r, "".concat(s || ""), !0), r))) || void 0 === t ? void 0 : t.trim();
    return dt.exports.jsx("div", Te(Te({
      className: u
    }, c), {}, {
      children: l
    }));
  },
  jF = function jF(e) {
    var t = e.children,
      r = Me(e, U);
    return dt.exports.jsx(CF, Te(Te({}, r), {}, {
      children: t
    }));
  },
  EF = function EF(e) {
    var t = e.children,
      r = e.noPad,
      a = Me(e, H);
    return t ? dt.exports.jsx(jF, Te(Te({
      x: r ? "" : "cui-px-md"
    }, a), {}, {
      children: t
    })) : dt.exports.jsx(SF, Te({}, a));
  };
EF.displayName = "CardHeader";
var TF = function TF(e) {
  var t = e.children,
    r = Me(e, G);
  return dt.exports.jsx(jF, Te(Te({
    x: "cui-px-md"
  }, r), {}, {
    children: t
  }));
};
TF.displayName = "CardPreFooter";
var OF = function OF(e) {
  var t = e.children,
    r = e.isOpen,
    a = Me(e, V);
  return dt.exports.jsx(jF, Te(Te({
    x: "cui-px-md",
    b: r ? "" : "cui-pb-sm"
  }, a), {}, {
    children: t
  }));
};
OF.displayName = "CardFooter";
var AF = function AF(e) {
  var t = e.children,
    r = Me(e, W);
  return dt.exports.jsx(jF, Te(Te({
    x: "cui__card-subheader cui-px-md"
  }, r), {}, {
    children: t
  }));
};
AF.displayName = "CardSubHeader";
var MF = function MF(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      r = Ge(t);
    return Ve(function () {
      e && ("function" == typeof e ? e(r.current) : e.current = r.current);
    }, [e]), r;
  },
  LF = function LF(e) {
    var t = e.getToggleProps,
      r = e.defaultHeader,
      a = e.header,
      n = void 0 === a ? null : a,
      o = e.usesDefaultHeader,
      i = e.headProps;
    if (o) return r || dt.exports.jsx(SF, Te({}, i));
    if (n && !o && Je(n)) {
      var l = wN(n, {
        isOpen: null == i ? void 0 : i.isOpen
      });
      return dt.exports.jsx("div", Te(Te({}, t()), {}, {
        children: l
      }));
    }
    return null;
  },
  DF = qe(function (e, t) {
    var r,
      a,
      n,
      o,
      i,
      l = e.id,
      s = void 0 === l ? "" : l,
      c = e.rounded,
      u = void 0 === c ? "sm" : c,
      d = e.bg,
      p = void 0 === d ? "bg-default" : d,
      m = e.noPad,
      f = e.showBorder,
      v = void 0 === f || f,
      y = e.className,
      g = void 0 === y ? "" : y,
      h = e.title,
      b = e.description,
      N = e.actionText,
      x = e.children,
      k = e.collapsible,
      w = (e.expandable, e.restrictTo),
      _ = e.gap,
      F = void 0 === _ ? "none" : _,
      S = e.flow,
      C = void 0 === S ? "column" : S,
      j = e.initiallyOpen,
      E = void 0 === j || j,
      T = e.defaultHeader,
      O = e.headerBg,
      A = e.headerDetails,
      M = void 0 === A ? [] : A,
      L = e.onToggle,
      D = e.onCardClick,
      B = Me(e, K),
      P = Ge(Ra()),
      R = MF(t),
      U = s || "cui__card-".concat(P.current),
      H = "cui__card-body-".concat(s || P.current),
      G = Le(He(E), 2),
      V = G[0],
      W = G[1],
      Y = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.duration,
          r = e.easing,
          a = void 0 === r ? "cubic-bezier(0.4, 0, 0.2, 1)" : r,
          n = e.onTransitionStateChange,
          o = void 0 === n ? function () {} : n,
          i = e.isExpanded,
          l = e.defaultExpanded,
          s = void 0 !== l && l,
          c = e.hasDisabledAnimation,
          u = e.id,
          d = Me(e, I),
          p = cF(o),
          m = gF(u ? "".concat(u) : void 0),
          f = Le(uF(i, s), 2),
          v = f[0],
          y = f[1],
          g = Ge(v),
          h = Le(He(!1), 2),
          b = h[0],
          N = h[1],
          x = dF(),
          k = null != c ? c : x,
          w = Ge(),
          _ = Ge(),
          F = Ge(null),
          S = Le(He(null), 2),
          C = S[0],
          j = S[1];
        _F(F);
        var E = "".concat(d.collapsedHeight || 0, "px");
        function T(e) {
          if (F.current) {
            var t = F.current;
            for (var r in e) {
              var a = e[r];
              a ? t.style[r] = a : t.style.removeProperty(r);
            }
          }
        }
        return FF(function () {
          if (F.current && v !== g.current) {
            g.current = v;
            var e = function e(_e4) {
                return "height ".concat(n(_e4), "ms ").concat(a);
              },
              r = function r(e) {
                _.current && bF(_.current), _.current = hF(function () {
                  v ? (T({
                    height: "",
                    overflow: "",
                    transition: "",
                    display: ""
                  }), p("expandEnd")) : (T({
                    transition: ""
                  }), p("collapseEnd")), N(!1);
                }, e);
              };
            return N(!0), w.current = v ? requestAnimationFrame(function () {
              p("expandStart"), T({
                display: "block",
                overflow: "hidden",
                height: E
              }), w.current = requestAnimationFrame(function () {
                p("expanding");
                var t = NF(F);
                r(n(t)), F.current && (F.current.style.transition = e(t), F.current.style.height = "".concat(t, "px"));
              });
            }) : requestAnimationFrame(function () {
              p("collapseStart");
              var t = NF(F);
              r(n(t)), T({
                transition: e(t),
                height: "".concat(t, "px")
              }), w.current = requestAnimationFrame(function () {
                p("collapsing"), T({
                  height: E,
                  overflow: "hidden"
                });
              });
            }), function () {
              w.current && cancelAnimationFrame(w.current), _.current && bF(_.current);
            };
          }
          function n(e) {
            return k ? 0 : null != t ? t : xF(e);
          }
        }, [v, E, k, t, a, p]), {
          isExpanded: v,
          setExpanded: y,
          getToggleProps: function getToggleProps(e) {
            var t = Te({
                refKey: "ref",
                onClick: function onClick() {},
                disabled: !1
              }, e),
              r = t.disabled,
              a = t.onClick,
              n = t.refKey,
              o = Me(t, z),
              i = C ? "BUTTON" === C.tagName : void 0,
              l = null == e ? void 0 : e[n || "ref"],
              s = Oe({
                id: "react-collapsed-toggle-".concat(m),
                "aria-controls": "react-collapsed-panel-".concat(m),
                "aria-expanded": v,
                onClick: function onClick(e) {
                  r || (null == a || a(e), y(function (e) {
                    return !e;
                  }));
                }
              }, n || "ref", wF(l, j)),
              c = {
                type: "button",
                disabled: !!r || void 0
              },
              u = {
                "aria-disabled": !!r || void 0,
                role: "button",
                tabIndex: r ? -1 : 0
              };
            return Te(!1 === i ? Te(Te({}, s), u) : !0 === i ? Te(Te({}, s), c) : Te(Te(Te({}, s), c), u), o);
          },
          getCollapseProps: function getCollapseProps(e) {
            var t,
              r = Te({
                refKey: "ref",
                style: {}
              }, e),
              a = r.style,
              n = r.refKey,
              o = null == e ? void 0 : e[n || "ref"];
            return Te(Te({
              id: "react-collapsed-panel-".concat(m),
              "aria-hidden": !v,
              "aria-labelledby": "react-collapsed-toggle-".concat(m),
              role: "region"
            }, e), {}, (Oe(t = {}, n || "ref", wF(F, o)), Oe(t, "style", Te(Te({
              boxSizing: "border-box"
            }, b || v ? {} : {
              display: "0px" === E ? "none" : "block",
              height: E,
              overflow: "hidden"
            }), a)), t));
          }
        };
      }({
        isExpanded: V,
        duration: 300
      }),
      $ = Y.getCollapseProps,
      q = Y.getToggleProps,
      J = !!(h || b || N || M.length),
      X = [],
      Z = function Z(e) {
        return L && L({
          isOpen: !e,
          id: s
        }), !e;
      },
      Q = Ye(function (e) {
        var t = e.key,
          r = e.code,
          a = e.keyCode;
        e.target !== e.currentTarget || "Enter" !== t && !(" " === t || "Space" === r || 32 === a) || (e.preventDefault(), k && W(Z));
      }, []),
      ee = Ye(function () {
        k && W(Z);
      }, [k]);
    Qe.forEach(x, function (e) {
      var t;
      if (e && (Je(e) || "string" == typeof e)) if ("string" == typeof e) X.push(e);else if ("object" === ze(e)) {
        var r;
        switch (t = wi(e.props, "mdxType", null) || (null === (r = wi(e.type, "displayName", null)) || void 0 === r ? void 0 : r.replace(".", "")) || wi(e.type, "name", null)) {
          case "CardFooter":
            a = wN(a = Te({}, e), {
              noPad: m,
              isOpen: V
            });
            break;
          case "CardPreFooter":
            o = wN(o = Te({}, e), {
              noPad: m
            });
            break;
          case "CardHeader":
            n = Te({}, e);
            var l = {
              onClick: ee,
              isOpen: V
            };
            void 0 !== k && (l.collapsible = k), M.length && (l.details = M), O && (l.bg = O), n = wN(n, l);
            break;
          case "CardSubHeader":
            i = wN(i = Te({}, e), {
              noPad: m
            });
            break;
          default:
            t && w && Array.isArray(w) && w.length && w.includes(t) ? X.push(e) : w || X.push(e);
        }
      }
    });
    var te = Xe(function () {
      return {
        title: h,
        description: b,
        actionText: N,
        isOpen: V,
        onClick: ee,
        collapsible: k,
        details: M,
        bg: O
      };
    }, [h, b, N, V, ee, k, M, O]);
    return dt.exports.jsxs("div", Te(Te({
      className: yt((r = {}, Oe(r, nF[u], !0), Oe(r, pn[p], !0), Oe(r, "cui-py-sm", !(m || a || n || J)), Oe(r, "cui-pt-sm", !m && !n && !J), Oe(r, "cui-pb-sm", !m && !a && V), Oe(r, "cui-border-1 cui-border-solid cui-border-fg-subtle", v), Oe(r, nN[F], !0), Oe(r, "".concat(g || ""), !0), r), "cui__card-wrapper cui-relative cui-overflow-hidden cui-box-border cui-grid focus-visible:cui-ring-2 focus-visible:cui-ring-fg-focus focus-visible:cui-ring-offset-2 focus-visible:cui-outline-none"),
      tabIndex: 0,
      "data-cy": "cui__card",
      ref: R,
      id: U,
      onClick: D,
      onKeyDown: Q,
      "aria-controls": H,
      "aria-expanded": V ? "true" : "false",
      role: "button"
    }, B), {}, {
      children: [dt.exports.jsx(LF, {
        getToggleProps: q,
        usesDefaultHeader: J,
        header: n,
        defaultHeader: T,
        headProps: te
      }), dt.exports.jsxs("div", Te(Te({
        className: "cui__card-contents cui-w-auto cui-h-auto"
      }, $()), {}, {
        id: H,
        "aria-labelledby": U,
        children: [i || null, X ? dt.exports.jsx("div", {
          className: yt(Oe({
            "cui-px-md": !m,
            "cui-flex cui-flex-col": "column" === C,
            "cui-flex cui-flex-wrap": "row" === C
          }, nN[F], !0), "cui__card-body"),
          children: X
        }) : null, o || null, a || null]
      }))]
    }));
  }),
  BF = Object.assign({}, DF, {
    Header: EF,
    SubHeader: AF,
    PreFooter: TF,
    Footer: OF,
    displayName: "Card"
  }),
  PF = function PF(e) {
    var t = e.hasSGP,
      r = e.isOddsBoost,
      a = e.header,
      n = e.isOpen,
      o = e.collapsible;
    return dt.exports.jsxs("div", {
      className: "cui-flex cui-py-sm cui-items-center",
      children: [t && !r ? dt.exports.jsx(rs, {
        name: "ui_sgp",
        size: 18,
        className: "cui-mr-sm",
        color: "fg-primary-strong"
      }) : null, r ? dt.exports.jsx(rs, {
        name: "ui_boost",
        size: 18,
        className: "cui-mr-sm",
        color: "fg-primary-strong"
      }) : null, dt.exports.jsx("div", {
        className: "heading-md cui-flex-grow cui-text-fg-default",
        children: null == a ? void 0 : a.title
      }), o ? dt.exports.jsx(IF, {
        className: yt({
          "cui-rotate-180": !n
        })
      }) : null]
    });
  },
  IF = function IF(e) {
    var t = e.className,
      r = void 0 === t ? "" : t;
    return dt.exports.jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      className: r,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [dt.exports.jsx("g", {
        clipPath: "url(#clip0_4651_8)",
        children: dt.exports.jsx("path", {
          d: "M1.99937 19C1.79489 19 1.60555 18.9243 1.44651 18.7804L0.242348 17.6898C0.0833073 17.5459 4.70958e-07 17.3793 4.8751e-07 17.19C5.04062e-07 17.0006 0.0833073 16.834 0.242348 16.6901L11.4434 6.53424C11.6024 6.39034 11.7917 6.31461 11.9962 6.31461C12.2007 6.31461 12.39 6.39034 12.5491 6.53424L23.7577 16.6977C23.9167 16.8416 24 17.0082 24 17.1975C24 17.3869 23.9167 17.5535 23.7577 17.6974L22.5611 18.7804C22.402 18.9243 22.2127 19 22.0082 19C21.8037 19 21.6144 18.9243 21.4553 18.7804L12.0038 10.2225L2.5598 18.7804C2.40076 18.9243 2.21142 19 2.00694 19L1.99937 19Z",
          fill: "var(--fg-moderate)"
        })
      }), dt.exports.jsx("defs", {
        children: dt.exports.jsx("clipPath", {
          id: "clip0_4651_8",
          children: dt.exports.jsx("rect", {
            width: "24",
            height: "24",
            fill: "var(--fg-moderate)"
          })
        })
      })]
    });
  },
  zF = {
    hasLivestream: function hasLivestream(e) {
      var t = e.hasLivestream;
      return void 0 !== t && t ? {
        type: "livestream"
      } : null;
    },
    startTime: function startTime(e) {
      var t = e.startTime,
        r = void 0 === t ? null : t,
        a = e.isLive;
      return r && !(void 0 !== a && a) ? {
        type: "date",
        date: r
      } : null;
    },
    isLive: function isLive(e) {
      var t = e.isLive,
        r = void 0 !== t && t,
        a = e.hasLivestream;
      return r && !(void 0 !== a && a) ? {
        type: "live"
      } : null;
    },
    gameState: function gameState(e) {
      var t = e.gameState,
        r = void 0 === t ? null : t;
      return r ? {
        type: "highlight",
        tag: r
      } : null;
    },
    tennisSet: function tennisSet(e) {
      var t = e.tennisSet,
        r = void 0 === t ? null : t;
      return r ? {
        type: "highlight",
        tag: "Set ".concat(r)
      } : null;
    },
    tennisGame: function tennisGame(e) {
      var t = e.tennisGame,
        r = void 0 === t ? null : t;
      return r ? {
        type: "highlight",
        tag: "Game ".concat(r)
      } : null;
    },
    gameTime: function gameTime(e) {
      var t = e.gameTime,
        r = void 0 === t ? null : t,
        a = e.sport;
      return r && "baseball" !== (void 0 === a ? "any" : a) ? {
        type: "highlight",
        tag: r
      } : null;
    },
    downAndDistance: function downAndDistance(e, t) {
      var r = e.downAndDistance,
        a = void 0 === r ? null : r;
      return a ? {
        tag: HF(a, t)
      } : null;
    },
    yardLine: function yardLine(e, t) {
      var r = e.yardLine,
        a = void 0 === r ? null : r,
        n = e.redZone;
      return a && !(void 0 === n ? null : n) ? {
        tag: HF(a, t)
      } : null;
    },
    lastScore: function lastScore(e, t) {
      var r = e.lastScore,
        a = void 0 === r ? null : r;
      return a ? {
        tag: HF(a, t)
      } : null;
    },
    batterCount: function batterCount(e) {
      var t = e.batterCount,
        r = void 0 === t ? null : t;
      if (!r) return null;
      if ("object" === ze(r)) {
        var a = r.balls,
          n = void 0 === a ? "-" : a,
          o = r.strikes,
          i = void 0 === o ? "-" : o;
        return r ? {
          tag: "".concat(n, "-").concat(i)
        } : null;
      }
      return {
        tag: r,
        showDivider: !1
      };
    },
    onBase: function onBase(e) {
      var t = e.onBase,
        r = void 0 === t ? {
          first: !1,
          second: !1,
          third: !1
        } : t;
      return r ? {
        type: "men-on-base",
        options: r,
        showDivider: !1
      } : null;
    },
    outs: function outs(e) {
      var t = e.outs,
        r = void 0 === t ? null : t;
      return r ? {
        tag: "".concat(r, " Outs"),
        showDivider: !1
      } : null;
    },
    powerPlay: function powerPlay(e, t) {
      var r = e.powerPlay,
        a = void 0 === r ? null : r;
      return a ? {
        tag: HF(a, t)
      } : null;
    },
    redZone: function redZone(e, t) {
      var r = e.redZone,
        a = void 0 === r ? null : r;
      return a ? {
        tag: HF(a, t),
        fgColor: "red-700"
      } : null;
    },
    fireBet: function fireBet(e) {
      var t = e.fireBets,
        r = void 0 === t ? null : t;
      return r ? {
        tag: r
      } : null;
    },
    isSuspended: function isSuspended(e) {
      var t = e.isSuspended;
      return void 0 !== t && t ? {
        type: "suspended"
      } : null;
    },
    isRainDelayed: function isRainDelayed(e) {
      var t = e.isRainDelayed;
      return void 0 !== t && t ? {
        type: "rain-delay"
      } : null;
    }
  },
  RF = ["nickName", "shortName", "name", "city"];
function UF(e) {
  return e && "object" === ze(e) ? Object.entries(e).map(function (e) {
    var t = Le(e, 2),
      r = t[0],
      a = t[1];
    return RF.includes(r) ? a : null;
  }).filter(function (e) {
    return !!e;
  }).join("|") : "";
}
function HF(e, t) {
  var r = t.home,
    a = t.away,
    n = "";
  return e && "string" == typeof e && (n = e.replace(r.re, r.abbr).replace(a.re, a.abbr)), n;
}
var GF = Object.prototype;
function VF(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || GF);
}
var WF,
  KF,
  YF = (WF = Object.keys, KF = Object, function (e) {
    return WF(KF(e));
  }),
  $F = Object.prototype.hasOwnProperty;
var qF = "object" == ("undefined" == typeof global ? "undefined" : ze(global)) && global && global.Object === Object && global,
  JF = "object" == ("undefined" == typeof self ? "undefined" : ze(self)) && self && self.Object === Object && self,
  XF = qF || JF || Function("return this")(),
  ZF = XF.Symbol,
  QF = Object.prototype,
  eS = QF.hasOwnProperty,
  tS = QF.toString,
  rS = ZF ? ZF.toStringTag : void 0;
var aS = Object.prototype.toString;
var nS = ZF ? ZF.toStringTag : void 0;
function oS(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : nS && nS in Object(e) ? function (e) {
    var t = eS.call(e, rS),
      r = e[rS];
    try {
      e[rS] = void 0;
      var a = !0;
    } catch (e) {}
    var n = tS.call(e);
    return a && (t ? e[rS] = r : delete e[rS]), n;
  }(e) : function (e) {
    return aS.call(e);
  }(e);
}
function iS(e) {
  var t = ze(e);
  return null != e && ("object" == t || "function" == t);
}
function lS(e) {
  if (!iS(e)) return !1;
  var t = oS(e);
  return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}
var sS = XF["__core-js_shared__"],
  cS = function () {
    var e = /[^.]+$/.exec(sS && sS.keys && sS.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }();
var uS = Function.prototype.toString;
function dS(e) {
  if (null != e) {
    try {
      return uS.call(e);
    } catch (e) {}
    try {
      return e + "";
    } catch (e) {}
  }
  return "";
}
var pS = /^\[object .+?Constructor\]$/,
  mS = Function.prototype,
  fS = Object.prototype,
  vS = mS.toString,
  yS = fS.hasOwnProperty,
  gS = RegExp("^" + vS.call(yS).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function hS(e) {
  return !(!iS(e) || function (e) {
    return !!cS && cS in e;
  }(e)) && (lS(e) ? gS : pS).test(dS(e));
}
function bS(e, t) {
  var r = function (e, t) {
    return null == e ? void 0 : e[t];
  }(e, t);
  return hS(r) ? r : void 0;
}
var NS = bS(XF, "DataView"),
  xS = bS(XF, "Map"),
  kS = bS(XF, "Promise"),
  wS = bS(XF, "Set"),
  _S = bS(XF, "WeakMap"),
  FS = dS(NS),
  SS = dS(xS),
  CS = dS(kS),
  jS = dS(wS),
  ES = dS(_S),
  TS = oS;
(NS && "[object DataView]" != TS(new NS(new ArrayBuffer(1))) || xS && "[object Map]" != TS(new xS()) || kS && "[object Promise]" != TS(kS.resolve()) || wS && "[object Set]" != TS(new wS()) || _S && "[object WeakMap]" != TS(new _S())) && (TS = function TS(e) {
  var t = oS(e),
    r = "[object Object]" == t ? e.constructor : void 0,
    a = r ? dS(r) : "";
  if (a) switch (a) {
    case FS:
      return "[object DataView]";
    case SS:
      return "[object Map]";
    case CS:
      return "[object Promise]";
    case jS:
      return "[object Set]";
    case ES:
      return "[object WeakMap]";
  }
  return t;
});
var OS = TS;
function AS(e) {
  return null != e && "object" == ze(e);
}
function MS(e) {
  return AS(e) && "[object Arguments]" == oS(e);
}
var LS = Object.prototype,
  DS = LS.hasOwnProperty,
  BS = LS.propertyIsEnumerable,
  PS = MS(function () {
    return arguments;
  }()) ? MS : function (e) {
    return AS(e) && DS.call(e, "callee") && !BS.call(e, "callee");
  },
  IS = Array.isArray;
function zS(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
var RS = "object" == ("undefined" == typeof exports ? "undefined" : ze(exports)) && exports && !exports.nodeType && exports,
  US = RS && "object" == ("undefined" == typeof module ? "undefined" : ze(module)) && module && !module.nodeType && module,
  HS = US && US.exports === RS ? XF.Buffer : void 0,
  GS = (HS ? HS.isBuffer : void 0) || function () {
    return !1;
  },
  VS = {};
VS["[object Float32Array]"] = VS["[object Float64Array]"] = VS["[object Int8Array]"] = VS["[object Int16Array]"] = VS["[object Int32Array]"] = VS["[object Uint8Array]"] = VS["[object Uint8ClampedArray]"] = VS["[object Uint16Array]"] = VS["[object Uint32Array]"] = !0, VS["[object Arguments]"] = VS["[object Array]"] = VS["[object ArrayBuffer]"] = VS["[object Boolean]"] = VS["[object DataView]"] = VS["[object Date]"] = VS["[object Error]"] = VS["[object Function]"] = VS["[object Map]"] = VS["[object Number]"] = VS["[object Object]"] = VS["[object RegExp]"] = VS["[object Set]"] = VS["[object String]"] = VS["[object WeakMap]"] = !1;
var WS = "object" == ("undefined" == typeof exports ? "undefined" : ze(exports)) && exports && !exports.nodeType && exports,
  KS = WS && "object" == ("undefined" == typeof module ? "undefined" : ze(module)) && module && !module.nodeType && module,
  YS = KS && KS.exports === WS && qF.process,
  $S = function () {
    try {
      var e = KS && KS.require && KS.require("util").types;
      return e || YS && YS.binding && YS.binding("util");
    } catch (e) {}
  }(),
  qS = $S && $S.isTypedArray,
  JS = qS ? function (e) {
    return function (t) {
      return e(t);
    };
  }(qS) : function (e) {
    return AS(e) && zS(e.length) && !!VS[oS(e)];
  },
  XS = JS,
  ZS = Object.prototype.hasOwnProperty;
function QS(e) {
  if (null == e) return !0;
  if (function (e) {
    return null != e && zS(e.length) && !lS(e);
  }(e) && (IS(e) || "string" == typeof e || "function" == typeof e.splice || GS(e) || XS(e) || PS(e))) return !e.length;
  var t = OS(e);
  if ("[object Map]" == t || "[object Set]" == t) return !e.size;
  if (VF(e)) return !function (e) {
    if (!VF(e)) return YF(e);
    var t = [];
    for (var r in Object(e)) $F.call(e, r) && "constructor" != r && t.push(r);
    return t;
  }(e).length;
  for (var r in e) if (ZS.call(e, r)) return !1;
  return !0;
}
function eC(e) {
  return "symbol" == ze(e) || AS(e) && "[object Symbol]" == oS(e);
}
var tC = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  rC = /^\w*$/;
var aC = bS(Object, "create");
var nC = Object.prototype.hasOwnProperty;
var oC = Object.prototype.hasOwnProperty;
function iC(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
function lC(e, t) {
  for (var r, a, n = e.length; n--;) if ((r = e[n][0]) === (a = t) || r != r && a != a) return n;
  return -1;
}
iC.prototype.clear = function () {
  this.__data__ = aC ? aC(null) : {}, this.size = 0;
}, iC.prototype.delete = function (e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}, iC.prototype.get = function (e) {
  var t = this.__data__;
  if (aC) {
    var r = t[e];
    return "__lodash_hash_undefined__" === r ? void 0 : r;
  }
  return nC.call(t, e) ? t[e] : void 0;
}, iC.prototype.has = function (e) {
  var t = this.__data__;
  return aC ? void 0 !== t[e] : oC.call(t, e);
}, iC.prototype.set = function (e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = aC && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var sC = Array.prototype.splice;
function cC(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
function uC(e, t) {
  var r,
    a,
    n = e.__data__;
  return ("string" == (a = ze(r = t)) || "number" == a || "symbol" == a || "boolean" == a ? "__proto__" !== r : null === r) ? n["string" == typeof t ? "string" : "hash"] : n.map;
}
function dC(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
cC.prototype.clear = function () {
  this.__data__ = [], this.size = 0;
}, cC.prototype.delete = function (e) {
  var t = this.__data__,
    r = lC(t, e);
  return !(r < 0) && (r == t.length - 1 ? t.pop() : sC.call(t, r, 1), --this.size, !0);
}, cC.prototype.get = function (e) {
  var t = this.__data__,
    r = lC(t, e);
  return r < 0 ? void 0 : t[r][1];
}, cC.prototype.has = function (e) {
  return lC(this.__data__, e) > -1;
}, cC.prototype.set = function (e, t) {
  var r = this.__data__,
    a = lC(r, e);
  return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
}, dC.prototype.clear = function () {
  this.size = 0, this.__data__ = {
    hash: new iC(),
    map: new (xS || cC)(),
    string: new iC()
  };
}, dC.prototype.delete = function (e) {
  var t = uC(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}, dC.prototype.get = function (e) {
  return uC(this, e).get(e);
}, dC.prototype.has = function (e) {
  return uC(this, e).has(e);
}, dC.prototype.set = function (e, t) {
  var r = uC(this, e),
    a = r.size;
  return r.set(e, t), this.size += r.size == a ? 0 : 1, this;
};
function pC(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
  var r = function r() {
    var a = arguments,
      n = t ? t.apply(this, a) : a[0],
      o = r.cache;
    if (o.has(n)) return o.get(n);
    var i = e.apply(this, a);
    return r.cache = o.set(n, i) || o, i;
  };
  return r.cache = new (pC.Cache || dC)(), r;
}
pC.Cache = dC;
var mC = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  fC = /\\(\\)?/g,
  vC = function (e) {
    var t = pC(e, function (e) {
        return 500 === r.size && r.clear(), e;
      }),
      r = t.cache;
    return t;
  }(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(mC, function (e, r, a, n) {
      t.push(a ? n.replace(fC, "$1") : r || e);
    }), t;
  }),
  yC = vC;
var gC = ZF ? ZF.prototype : void 0,
  hC = gC ? gC.toString : void 0;
function bC(e) {
  if ("string" == typeof e) return e;
  if (IS(e)) return function (e, t) {
    for (var r = -1, a = null == e ? 0 : e.length, n = Array(a); ++r < a;) n[r] = t(e[r], r, e);
    return n;
  }(e, bC) + "";
  if (eC(e)) return hC ? hC.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
}
function NC(e, t) {
  return IS(e) ? e : function (e, t) {
    if (IS(e)) return !1;
    var r = ze(e);
    return !("number" != r && "symbol" != r && "boolean" != r && null != e && !eC(e)) || rC.test(e) || !tC.test(e) || null != t && e in Object(t);
  }(e, t) ? [e] : yC(function (e) {
    return null == e ? "" : bC(e);
  }(e));
}
function xC(e) {
  if ("string" == typeof e || eC(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
}
function kC(e, t, r) {
  var a = null == e ? void 0 : function (e, t) {
    for (var r = 0, a = (t = NC(t, e)).length; null != e && r < a;) e = e[xC(t[r++])];
    return r && r == a ? e : void 0;
  }(e, t);
  return void 0 === a ? r : a;
}
var wC = function wC(e) {
    if (!e) return "";
    var t = me(e.toUpperCase().split(" ")),
      r = t[0],
      a = t[1];
    t.slice(2);
    return a ? "".concat(r[0], ". ").concat(a.slice(0, 3)) : r.slice(0, 3);
  },
  _C = function _C() {},
  FC = function FC() {
    return dt.exports.jsxs("div", {
      className: "cui-flex-col",
      children: [dt.exports.jsxs("div", {
        className: "cui-flex",
        children: [dt.exports.jsx(Nc, {
          width: "60%",
          height: "20"
        }), dt.exports.jsx("div", {
          className: "cui-flex-grow"
        }), dt.exports.jsx(Nc, {
          width: "4%",
          height: "20"
        })]
      }), dt.exports.jsxs("div", {
        className: "cui-flex cui-gap-xs cui-my-lg",
        children: [dt.exports.jsx(Nc, {
          width: "10%",
          height: "20"
        }), dt.exports.jsx(Nc, {
          width: "20%",
          height: "20"
        }), dt.exports.jsx(Nc, {
          width: "20%",
          height: "20"
        })]
      }), dt.exports.jsxs("div", {
        className: "cui-flex cui-gap-xs cui-my-lg",
        children: [dt.exports.jsx("div", {
          className: "cui-flex-grow"
        }), dt.exports.jsx(Nc, {
          width: "16%",
          height: "20"
        }), dt.exports.jsx(Nc, {
          width: "16%",
          height: "20"
        })]
      })]
    });
  },
  SC = function SC(e) {
    var t = e.width,
      r = void 0 === t ? "40%" : t;
    return dt.exports.jsxs("div", {
      className: "cui-flex cui-gap-xs cui-my-xs cui-items-center",
      children: [dt.exports.jsx(Nc, {
        width: r,
        height: "20"
      }), dt.exports.jsx("div", {
        className: "cui-flex-grow"
      }), dt.exports.jsx(Nc, {
        width: "16%",
        height: "48"
      }), dt.exports.jsx(Nc, {
        width: "16%",
        height: "48"
      })]
    });
  },
  CC = function CC() {
    return dt.exports.jsx("div", {
      className: "cui-flex cui-gap-xs cui-mt-lg cui-items-center cui-justify-center",
      children: dt.exports.jsx(Nc, {
        width: "20%",
        height: "20"
      })
    });
  },
  jC = function jC() {
    return dt.exports.jsxs("div", {
      className: "cui-w-auto",
      children: [dt.exports.jsx(FC, {}), dt.exports.jsx(SC, {
        width: "25%"
      }), dt.exports.jsx(SC, {
        width: "40%"
      }), dt.exports.jsx(SC, {
        width: "30%"
      }), dt.exports.jsx(SC, {
        width: "25%"
      }), dt.exports.jsx(SC, {
        width: "30%"
      }), dt.exports.jsx(CC, {})]
    });
  },
  EC = function EC() {},
  TC = function TC(e) {
    var t = e.eventName,
      r = e.startTime,
      a = e.onEventHeaderClick,
      n = void 0 === a ? EC : a,
      o = e.id,
      i = e.isOddsBoost,
      l = [i ? {
        leftIcon: {
          name: "ui_boost",
          size: "lg",
          color: "fg-primary"
        }
      } : null, {
        tag: t,
        textSize: i ? "display-sm-bold" : "heading-sm-bold",
        fgColor: "fg-default",
        showDivider: !i
      }, {
        leftIcon: {
          name: "ui_chevron-right",
          size: i ? "sm" : "xs",
          color: "fg-primary"
        },
        showDivider: !1
      }],
      s = [{
        type: "date",
        date: "".concat(r),
        textSize: i ? "heading-sm" : "body-xs",
        fgColor: "fg-default"
      }],
      c = Ye(function (e) {
        n && "function" == typeof n && n(e, o);
      }, [n]);
    return dt.exports.jsxs("div", {
      className: "cui__market-template-event-header active:cui-bg-bg-layer-one cui-cursor-pointer",
      onClick: c,
      children: [t ? dt.exports.jsx(cc, {
        list: l,
        className: "!cui-p-0 cui-ml-0 [&>span]:cui-pr-0",
        noWrap: !0
      }) : null, r ? dt.exports.jsx(cc, {
        list: s,
        className: "-cui-mt-2"
      }) : null]
    });
  },
  OC = !0,
  AC = function AC(e, t, r, a, n, o, i) {
    var l = Ge(""),
      s = Ge(),
      c = t.toLowerCase(),
      u = "string" == typeof r ? r.toLowerCase() : r;
    "list view" === c && (c = "all"), "list view" === u && (u = "all");
    var d = "slider" === i && "all" === c,
      p = d ? "[data-filter-group-set]" : "[data-filter-group]";
    We(function () {
      if (e && window && "document" in window) {
        if (d) {
          var t = Array.from(e.querySelectorAll("".concat(p)));
          s.current = t.map(function (e) {
            return Array.from(e.querySelectorAll("[data-filter-group]"));
          });
        } else s.current = Array.from(e.querySelectorAll("".concat(p)));
        s.current && (d ? s.current.forEach(function (e) {
          return e.forEach(MC(l, u, c));
        }) : s.current.forEach(MC(l, u, c)));
      }
    }, [t, e, r, n, a, o]);
  };
function MC(e, t, r) {
  return function (a, n) {
    var o;
    OC && (e.current = window.getComputedStyle(a).display, OC = !1);
    var i = function (e, t) {
      return {
        show: function show() {
          e.style.display = t;
        },
        hide: function hide() {
          e.style.display = "none";
        }
      };
    }(a, e.current);
    "all" === t && "all" === r || "all" === r && "all" !== t && "number" == typeof t && n < t || "all" !== r && (null === (o = a.dataset.filterGroup) || void 0 === o ? void 0 : o.toLowerCase()) === r ? i.show() : i.hide();
  };
}
var LC = function LC() {},
  DC = function DC(e) {
    var t = e.id,
      r = e.header,
      a = e.marketHeader,
      n = e.markets,
      o = void 0 === n ? [] : n,
      i = (e.marketFooter, e.footer),
      l = void 0 === i ? {} : i,
      s = e.showBorder,
      c = void 0 !== s && s,
      u = e.showBottomBorder,
      d = void 0 === u || u,
      p = e.showVersusDivider,
      m = void 0 !== p && p,
      f = e.type,
      v = void 0 === f ? "standard" : f,
      y = e.versusText,
      g = e.groupBy,
      h = void 0 === g ? null : g,
      b = e.showLimit,
      N = void 0 === b ? "all" : b,
      x = e.filters,
      k = e.canShowLess,
      w = void 0 === k || k,
      _ = e.oddsFormat,
      F = void 0 === _ ? "american" : _,
      S = e.initiallyOpen,
      C = void 0 === S || S,
      j = e.hasSGP,
      E = void 0 !== j && j,
      T = (e.hasFirebets, e.isOddsBoost),
      O = (e.showMoreWagers, e.skeleton),
      A = e.eventDetails,
      M = e.showEventHeader,
      L = void 0 === M || M,
      D = e.mode,
      B = e.updateMarket,
      P = e.onSelectionClick,
      I = void 0 === P ? LC : P,
      z = e.onHeaderClick,
      R = (e.onTemplateClick, e.onEventHeaderClick),
      U = (e.updateMarkets, Me(e, $)),
      H = Le(He(null), 2),
      G = H[0],
      V = H[1],
      W = Ge(N).current,
      K = Le(He(N), 2),
      Y = K[0],
      q = K[1],
      J = Le(He(!1), 2),
      X = J[0],
      Z = J[1],
      Q = Le(He(C), 2),
      ee = Q[0],
      te = Q[1];
    He(null);
    var re = Le(He("all"), 2),
      ae = re[0],
      ne = re[1],
      oe = Ye(function () {
        q("all" === Y ? N : "all");
      }, [Y, x]),
      ie = Ye(function (e) {
        if (x && x.length) {
          var t = Le(x.filter(function (t) {
            return "id" in t && (null == t ? void 0 : t.id) === e;
          }), 1)[0];
          ne(null == t ? void 0 : t.label);
        } else ne("all");
      }, [ae]),
      le = Ye(function (e) {
        var t = e.isOpen;
        e.id;
        te(t), X || Z(!0), z && z(e);
      }, []),
      se = Xe(function () {
        return "number" == typeof N ? (null == o ? void 0 : o.length) - N : o.length;
      }, [null == o ? void 0 : o.length, N]),
      ce = !!r && "object" === ze(r) && !QS(r),
      ue = x && Array.isArray(x) && x.length,
      de = !!A && !QS(A) && L,
      pe = !C && !X,
      me = (de || ue) && !pe;
    AC(G, ae, Y, h, ue, X, v);
    var fe = E ? [{
        leftIcon: {
          name: "ui_sgp",
          color: "fg-primary",
          size: "lg"
        }
      }] : [],
      ve = r ? Te(Te({}, r), {}, {
        headerDetails: fe
      }) : {},
      ye = function (e) {
        var t = e.title,
          r = e.description,
          a = e.hasSGP;
        return e.isOpen, Te({}, {
          "aria-label": [t, r, a ? "SGP" : null].filter(function (e) {
            return !!e;
          }).join(", ")
        });
      }({
        title: null == r ? void 0 : r.title,
        description: null == r ? void 0 : r.description,
        hasSGP: E,
        isOpen: ee
      }),
      ge = "boolean" != typeof (null == r ? void 0 : r.collapsible) || (null == r ? void 0 : r.collapsible);
    return O ? dt.exports.jsx(jC, {}) : dt.exports.jsxs(BF, Te(Te(Te({}, U), {}, {
      id: t,
      showBorder: c,
      collapsible: ce && ge,
      className: yt({
        "cui-border-solid cui-border-x-0 cui-border-t-0 cui-border-b-1 cui-border-fg-minimal": !ee && d,
        "cui-mb-sm": !1
      }, "cui__market-template"),
      initiallyOpen: C,
      onToggle: le,
      ref: V
    }, ye), {}, {
      noPad: !0,
      children: [Je(r) && r, dt.exports.jsx(BF.Header, {
        collapsible: ce && ge,
        noPad: !0,
        children: ce ? dt.exports.jsx(PF, {
          hasSGP: ce && E,
          isOddsBoost: T,
          isOpen: ee,
          header: ve,
          collapsible: ce && ge
        }) : null
      }), me ? dt.exports.jsxs(BF.SubHeader, {
        children: [de ? dt.exports.jsx(TC, {
          eventName: null == A ? void 0 : A.eventName,
          startTime: null == A ? void 0 : A.startTime,
          id: t,
          isOddsBoost: T,
          onEventHeaderClick: R
        }) : null, ue ? dt.exports.jsx(af, {
          className: "-cui-ml-1 cui-mb-xs",
          size: "xs",
          items: x,
          cssMode: !0,
          showControls: "none",
          overlay: !0,
          onActiveItem: ie,
          skipLink: null,
          tabbable: !1
        }) : null]
      }) : null, a && !pe ? dt.exports.jsx(rF.Header, Te(Te({}, Te(Te({}, a), {}, {
        noBorder: !0
      })), {}, {
        className: "cui-mb-1"
      })) : null, pe ? null : dt.exports.jsx(rF.Markets, {
        markets: o,
        marketHeader: a,
        marketTemplateTitle: null == ve ? void 0 : ve.title,
        oddsFormat: F,
        showVersusDivider: m,
        versusText: y,
        showLimit: Y,
        groupBy: h,
        onSelectionClick: I,
        mode: D,
        updateMarket: B
      }), Je(l) ? dt.exports.jsx(rF.Footer, {
        showLimit: Y,
        filters: x,
        onShowMoreClick: oe,
        children: l
      }) : l && Object.keys(l).length || Y ? dt.exports.jsx(rF.Footer, Te(Te({}, l), {}, {
        showLimit: Y,
        filters: x,
        showMore: "all" !== Y && "number" == typeof Y && Y < o.length && "all" === (null == ae ? void 0 : ae.toString().toLowerCase()),
        showMoreTotal: se,
        canShowLess: w && "string" == typeof ae && "all" === (null == ae ? void 0 : ae.toLowerCase()) && "all" !== W,
        className: "cui-mt-1",
        onShowMoreClick: oe
      })) : null]
    }));
  },
  BC = function BC() {},
  PC = {
    sixpack: {
      name: "sixpack",
      useAvatar: !1,
      template: function template(e) {
        var t,
          r,
          a,
          n,
          o,
          i,
          l,
          s,
          c = e.id,
          u = e.header,
          d = e.marketHeader,
          p = void 0 === d ? {} : d,
          m = e.markets,
          f = void 0 === m ? [] : m,
          v = (e.marketFooter, e.footer),
          y = void 0 === v ? {} : v,
          g = e.showBorder,
          h = void 0 !== g && g,
          b = e.showVersusDivider,
          N = void 0 !== b && b,
          x = (e.type, e.versusText),
          k = void 0 === x ? "vs" : x,
          w = (e.groupBy, e.showLimit, e.filters, e.sport),
          _ = (e.canShowLess, e.oddsFormat, e.initiallyOpen),
          F = void 0 === _ || _,
          S = e.eventDetails,
          C = e.showMoreWagers,
          j = void 0 !== C && C,
          E = e.hasSGP,
          T = void 0 !== E && E,
          O = e.hasFirebets,
          A = void 0 !== O && O,
          M = e.mode,
          L = void 0 === M ? "light" : M,
          D = e.onSelectionClick,
          B = void 0 === D ? _C : D,
          P = e.onHeaderClick,
          I = (e.onEventHeaderClick, e.onTemplateClick),
          z = e.updateMarket,
          R = void 0 === z ? function () {} : z,
          U = (e.updateMarkets, Me(e, Y)),
          H = Le(He(!1), 2),
          G = (H[0], H[1]),
          V = Le(He(F), 2),
          W = V[0],
          K = V[1],
          $ = Le(He(!1), 2),
          q = $[0],
          J = $[1],
          X = Xe(function () {
            return function (e) {
              var t, r, a, n, o, i, l, s;
              if (!e && "object" !== ze(e)) return [];
              var c,
                u,
                d,
                p,
                m = [],
                f = /\(W\)/gi,
                v = "string" == typeof (null == e || null === (t = e.home) || void 0 === t ? void 0 : t.team) && f.test(null == e || null === (r = e.home) || void 0 === r ? void 0 : r.team) && "string" == typeof (null == e || null === (a = e.away) || void 0 === a ? void 0 : a.team) && f.test(null == e || null === (n = e.away) || void 0 === n ? void 0 : n.team),
                y = v ? "(W)" : "",
                g = (null == e || null === (o = e.home) || void 0 === o || null === (i = o.team) || void 0 === i ? void 0 : i.trim()) || "",
                h = (null == e || null === (l = e.away) || void 0 === l || null === (s = l.team) || void 0 === s ? void 0 : s.trim()) || "";
              v && (g = null == e || null === (c = e.home) || void 0 === c || null === (u = c.team) || void 0 === u ? void 0 : u.replace(f, "").trim(), h = null == e || null === (d = e.away) || void 0 === d || null === (p = d.team) || void 0 === p ? void 0 : p.replace(f, "").trim());
              var b = g ? Ss(g) : null,
                N = h ? Ss(h) : null,
                x = new RegExp(UF(b), "ig"),
                k = new RegExp(UF(N), "ig"),
                w = {
                  home: {
                    re: x,
                    abbr: "".concat(null != b && b.abbreviation ? b.abbreviation : "", " ").concat(y).trim() || ""
                  },
                  away: {
                    re: k,
                    abbr: "".concat(null != N && N.abbreviation ? null == N ? void 0 : N.abbreviation : "", " ").concat(y).trim() || ""
                  }
                };
              for (var _ in zF) if (_ in e) {
                var F = zF[_](e, w);
                F && m.push(F);
              }
              return {
                detailsList: m,
                teamInfo: {
                  homeTeamInfo: b,
                  awayTeamInfo: N
                }
              };
            }(w ? Te(Te({}, S), {}, {
              sport: w
            }) : Te({}, S));
          }, [S, null == S || null === (t = S.home) || void 0 === t ? void 0 : t.score, null == S || null === (r = S.away) || void 0 === r ? void 0 : r.score, null == S || null === (a = S.home) || void 0 === a ? void 0 : a.possession, null == S || null === (n = S.away) || void 0 === n ? void 0 : n.possession, null == S ? void 0 : S.gameState, null == S ? void 0 : S.isLive, null == S ? void 0 : S.isRainDelayed, null == S ? void 0 : S.isSuspended, null == S ? void 0 : S.gameTime, null == S || null === (o = S.competitor1) || void 0 === o ? void 0 : o.score, null == S || null === (i = S.competitor2) || void 0 === i ? void 0 : i.score, null == S || null === (l = S.competitor1) || void 0 === l ? void 0 : l.possession, null == S || null === (s = S.competitor2) || void 0 === s ? void 0 : s.possession, w]),
          Z = X.detailsList,
          Q = X.teamInfo,
          ee = Te({}, p);
        if ("soccer" === w) {
          var te,
            re,
            ae = kC(f, "[0].competitors[0].team", null) || kC(f, "[0].competitors[0].displayName", null),
            ne = kC(f, "[0].competitors[1].team", null) || kC(f, "[0].competitors[1].displayName", null),
            oe = (null == Q || null === (te = Q.homeTeamInfo) || void 0 === te ? void 0 : te.abbreviation) || wC(ae),
            ie = (null == Q || null === (re = Q.awayTeamInfo) || void 0 === re ? void 0 : re.abbreviation) || wC(ne);
          ee = Te(Te({}, ee), {}, {
            labels: [oe, "Draw", ie]
          });
        }
        var le = Xe(function () {
            return Te(Te({}, y), {}, {
              moreWagers: j,
              hasSGP: T,
              hasFirebets: A,
              details: {
                list: Z
              }
            });
          }, [y, X, T, j]),
          se = !QS(u),
          ce = Ye(function (e) {
            var t, r;
            "BUTTON" !== (null === (t = e.target) || void 0 === t || null === (r = t.offsetParent) || void 0 === r ? void 0 : r.nodeName) && I && I(e);
          }, [I]),
          ue = Ye(function (e) {
            var t, r;
            "BUTTON" !== (null === (t = e.target) || void 0 === t || null === (r = t.offsetParent) || void 0 === r ? void 0 : r.nodeName) && G(function (e) {
              return !e;
            });
          }, []),
          de = Ye(function (e) {
            var t = e.isOpen;
            e.id;
            K(t), q || J(!0), P && P(e);
          }, []),
          pe = Te(Te({}, u), {}, {
            initiallyOpen: F
          }),
          me = "boolean" != typeof (null == u ? void 0 : u.collapsible) || (null == u ? void 0 : u.collapsible);
        return dt.exports.jsxs(BF, Te(Te({}, U), {}, {
          id: "".concat(c),
          className: "cui-cursor-pointer",
          showBorder: h,
          initiallyOpen: F,
          collapsible: me,
          onToggle: de,
          onCardClick: ce,
          onMouseDown: ue,
          onMouseUp: ue,
          children: [u && Je(u) ? wN(u, {
            onClick: P
          }) : se ? dt.exports.jsx(BF.Header, {
            children: dt.exports.jsx(PF, {
              hasSGP: T,
              isOpen: W,
              header: pe,
              collapsible: me
            })
          }) : null, p ? dt.exports.jsx(BF.SubHeader, {
            children: dt.exports.jsx(rF.Header, Te(Te({}, ee), {}, {
              noBorder: !0,
              className: "cui-mb-1"
            }))
          }) : null, dt.exports.jsx(rF.Markets, {
            markets: f,
            marketHeader: p,
            showVersusDivider: N,
            sport: w,
            mode: L,
            versusText: k,
            updateMarket: R,
            onSelectionClick: B
          }), Je(y) ? dt.exports.jsx(rF.Footer, {
            children: y
          }) : le && Object.keys(le).length ? dt.exports.jsx(rF.Footer, Te(Te({}, le), {}, {
            className: "cui-mt-1"
          })) : null]
        }));
      }
    },
    standard: {
      name: "standard",
      useAvatar: !0,
      template: DC
    },
    markettabs: {
      name: "markettabs",
      useAvatar: !0,
      template: DC
    },
    selectiontabs: {
      name: "selectiontabs",
      useAvatar: !0,
      template: DC
    },
    combined: {
      name: "combined",
      useAvatar: !0,
      template: DC
    },
    stacked: {
      name: "stacked",
      useAvatar: !0,
      template: DC
    },
    slider: {
      name: "slider",
      useAvatar: !1,
      template: function template(e) {
        var t,
          r,
          a = e.header,
          n = e.marketHeader,
          o = e.markets,
          i = void 0 === o ? [] : o,
          l = (e.marketFooter, e.footer),
          s = void 0 === l ? {} : l,
          c = e.showBorder,
          u = void 0 !== c && c,
          d = e.showVersusDivider,
          p = void 0 !== d && d,
          m = e.type,
          f = void 0 === m ? "slider" : m,
          v = e.versusText,
          y = e.groupBy,
          g = void 0 === y ? null : y,
          h = e.showLimit,
          b = void 0 === h ? "all" : h,
          N = e.filters,
          x = e.canShowLess,
          k = void 0 === x || x,
          w = e.oddsFormat,
          _ = void 0 === w ? "american" : w,
          F = e.initiallyOpen,
          S = void 0 === F || F,
          C = e.hasSGP,
          j = void 0 !== C && C,
          E = e.skeleton,
          T = (e.eventDetails, e.sliderKeyBy),
          O = void 0 === T ? "line" : T,
          A = e.updateMarket,
          M = (e.onTemplateClick, e.onSelectionClick),
          L = void 0 === M ? BC : M,
          D = e.onHeaderClick,
          B = (e.updateMarkets, Me(e, q)),
          P = Le(He(null), 2),
          I = P[0],
          z = P[1],
          R = Ge(b).current,
          U = Le(He(b), 2),
          H = U[0],
          G = U[1],
          V = Le(He(!1), 2),
          W = V[0],
          K = V[1],
          Y = ["Slider View", "List View"],
          $ = Le(He("all"), 2),
          J = $[0],
          X = $[1],
          Z = Ye(function () {
            G("all" === H ? b : "all");
          }, [H, Y]),
          Q = Ye(function (e) {
            return X(Y[e]);
          }, [J]),
          ee = Ye(function (e) {
            W || K(!0), D && D(e);
          }, []),
          te = Xe(function () {
            return "number" == typeof b ? i.length - b : i.length;
          }, [i.length, b]),
          re = N && Array.isArray(Y) && Y.length,
          ae = !S && !W,
          ne = j ? [{
            leftIcon: {
              name: "ui_sgp",
              color: "fg-primary",
              size: "lg"
            }
          }] : [],
          oe = Te(Te({}, a), {}, {
            headerDetails: ne
          });
        AC(I, J, H, g, re, W, f);
        var ie = "all" !== H && "number" == typeof H && H < (null === (t = i[0]) || void 0 === t || null === (r = t.selections) || void 0 === r ? void 0 : r.length) && "list view" === (null == J ? void 0 : J.toString().toLowerCase()),
          le = k && "string" == typeof J && "list view" === (null == J ? void 0 : J.toLowerCase()) && "all" !== R;
        return E ? dt.exports.jsx(jC, {}) : dt.exports.jsxs(BF, Te(Te(Te({}, B), {}, {
          showBorder: u,
          collapsible: !0
        }, oe), {}, {
          className: "cui-mb-sm",
          initiallyOpen: S,
          onToggle: ee,
          ref: z,
          children: [a && Je(a) && a, Y && Y.length && !ae ? dt.exports.jsx(BF.SubHeader, {
            children: dt.exports.jsx(af, {
              className: "-cui-ml-1 cui-mb-xs",
              size: "xs",
              items: Y,
              cssMode: !0,
              showControls: "none",
              overlay: !0,
              onActiveItem: Q,
              skipLink: null
            })
          }) : null, n && !ae ? dt.exports.jsx(rF.Header, Te(Te({}, Te(Te({}, n), {}, {
            labels: null,
            noBorder: !0
          })), {}, {
            className: "cui-mb-1"
          })) : null, !ae && J ? dt.exports.jsx(rF.Markets, {
            markets: i,
            marketHeader: n,
            type: "List View" === J ? "list-view-col" : "slider",
            oddsFormat: _,
            showVersusDivider: p,
            versusText: v,
            showLimit: H,
            groupBy: g,
            onSelectionClick: L,
            sliderKeyBy: O,
            updateMarket: A
          }) : null, Je(s) ? dt.exports.jsx(rF.Footer, {
            showLimit: H,
            filters: N,
            onShowMoreClick: Z,
            children: s
          }) : s && Object.keys(s).length || H ? dt.exports.jsx(rF.Footer, Te(Te({}, s), {}, {
            showLimit: H,
            filters: N,
            showMore: ie,
            showMoreTotal: te,
            canShowLess: le,
            className: "cui-mt-1",
            onShowMoreClick: Z
          })) : null]
        }));
      }
    }
  },
  IC = function IC(e) {
    var t,
      r = Ge("cui__market-template-".concat(Ra())),
      a = e.id,
      n = void 0 === a ? r.current : a,
      o = e.markets,
      i = void 0 === o ? [] : o,
      l = e.type,
      s = void 0 === l ? "standard" : l,
      c = e.filters,
      u = void 0 === c ? [] : c,
      d = e.sport,
      p = e.eventDetails,
      m = (e.skeleton, Xe(function () {
        return function (e) {
          var t = Array.isArray(e) && e.length ? e.map(function (e, t) {
            var r = {};
            if ("object" === ze(e)) {
              var a = e.id,
                n = e.label,
                o = e.team;
              r = {
                id: a || t + 1,
                label: n
              }, o && (r.team = o);
            } else "string" == typeof e && (r = {
              id: t + 1,
              label: e,
              team: e
            });
            return r;
          }) : null;
          return (null == t ? void 0 : t.length) && (null == t || t.unshift({
            id: 0,
            label: "All"
          })), t;
        }(u);
      }, [u])),
      f = Te(Te({}, p), {}, {
        sport: d
      }),
      v = Le(eN({
        markets: i,
        eventDetails: f,
        type: s,
        useAvatar: null === (t = PC[s]) || void 0 === t ? void 0 : t.useAvatar
      }), 3),
      y = v[0],
      g = v[1];
    v[2];
    return s in PC ? PC[s].template(Te(Te({}, e), {}, {
      id: n,
      markets: y,
      filters: m,
      updateMarket: g
    })) : null;
  },
  zC = qe(function (e, t) {
    var r = e.children,
      a = e.gap,
      n = void 0 === a ? "xs" : a,
      o = e.restrictTo,
      i = void 0 === o ? [] : o,
      l = Me(e, J),
      s = MF(t),
      c = i && Array.isArray(i) && null != i && i.length ? ["Card", "Cardstack"].concat(Ce(i)) : null;
    return dt.exports.jsx(BF, Te(Te({}, l), {}, {
      gap: n,
      restrictTo: c,
      ref: s,
      children: r
    }));
  }),
  RC = Object.assign({}, zC, {
    Header: BF.Header,
    SubHeader: BF.SubHeader,
    PreFooter: BF.PreFooter,
    Footer: BF.Footer,
    displayName: "Cardstack"
  }),
  UC = function UC(e) {
    var t = "xs" === e.size ? 20 : 24,
      r = "round" === e.shape ? "full" : "sm";
    return dt.exports.jsx(Nc, {
      width: t,
      height: t,
      rounded: r
    });
  },
  HC = "Badge-module_cui__badge__43aeK",
  GC = function GC(e) {
    return /^#/.test(e) || /rgba?|hsla?/.test(e) ? e : "var(--".concat(e, ")");
  },
  VC = new Intl.NumberFormat("en", {
    notation: "compact",
    roundingMode: "floor"
  }),
  WC = Object.entries({
    bg: "--bg-color",
    fg: "--fg-color",
    border: "--border-color",
    icon: "--icon-color",
    secondaryText: "--secondary-text"
  });
function KC() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  var a = t[0],
    n = t[1],
    o = {};
  return WC.forEach(function (e) {
    var t = Le(e, 2),
      r = t[0],
      i = t[1];
    a && a.type && n && n in a.type && (r in a.type[n] ? o[i] = GC(a.type[n][r]) : o[i] = GC("fg" in a.type[n] ? a.type[n].fg : ""));
  }), o;
}
var YC = {
    type: {
      strong: {
        bg: "bg-primary-strong",
        fg: "fg-inverse",
        border: "neutrals-transparent"
      },
      subtle: {
        bg: "bg-primary-minimal",
        fg: "fg-primary-strong",
        border: "neutrals-transparent"
      },
      minimal: {
        bg: "neutral-transparent",
        fg: "fg-primary",
        border: "fg-primary"
      }
    },
    skeleton: {
      type: {
        strong: {
          bg: "neutrals-transparent",
          fg: "neutrals-transparent",
          border: "neutrals-transparent"
        }
      }
    },
    status: {
      positive: {
        type: {
          strong: {
            bg: "status-positive",
            fg: "status-positive-minimal",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "status-positive-minimal",
            fg: "fg-primary-strong",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "fg-primary",
            border: "status-positive-subtle"
          }
        }
      },
      negative: {
        type: {
          strong: {
            bg: "status-negative",
            fg: "status-negative-minimal",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "status-negative-minimal",
            fg: "status-negative-strong",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "status-negative",
            border: "status-negative"
          }
        }
      },
      alert: {
        type: {
          strong: {
            bg: "status-alert",
            fg: "fg-global-black",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "status-alert-minimal",
            fg: "status-alert-strong",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "status-alert-strong",
            border: "status-alert"
          }
        }
      },
      info: {
        type: {
          strong: {
            bg: "status-informational",
            fg: "status-informational-minimal",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "status-informational-minimal",
            fg: "status-informational-strong",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "status-informational",
            border: "status-informational"
          }
        }
      },
      accent: {
        type: {
          strong: {
            bg: "highlight-accent",
            fg: "highlight-accent-minimal",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "highlight-accent-minimal",
            fg: "highlight-accent",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "highlight-accent",
            border: "highlight-accent"
          }
        }
      },
      brand: {
        type: {
          strong: {
            bg: "highlight-brand",
            fg: "fg-inverse",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "highlight-brand-minimal",
            fg: "highlight-brand",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "highlight-brand",
            border: "highlight-brand"
          }
        }
      },
      pending: {
        type: {
          strong: {
            bg: "highlight-accent",
            fg: "neutrals-transparent",
            border: "neutrals-transparent"
          },
          subtle: {
            bg: "highlight-accent-minimal",
            fg: "neutrals-transparent",
            border: "neutrals-transparent"
          },
          minimal: {
            bg: "neutrals-transparent",
            fg: "neutrals-transparent",
            border: "highlight-accent"
          }
        }
      }
    },
    variant: {
      rewards: {
        type: {
          strong: {
            bg: "neutrals-transparent",
            fg: "rewards-background",
            border: "rewards-background"
          }
        }
      },
      "rewards-seven-stars": {
        type: {
          strong: {
            bg: "rewards-seven-stars",
            fg: "fg-global-white",
            border: "neutrals-transparent"
          }
        }
      },
      "rewards-gold": {
        type: {
          strong: {
            bg: "rewards-gold",
            fg: "fg-global-black",
            border: "neutrals-transparent"
          }
        }
      },
      "rewards-platinum": {
        type: {
          strong: {
            bg: "rewards-platinum",
            fg: "fg-global-black",
            border: "neutrals-transparent"
          }
        }
      },
      "rewards-diamond": {
        type: {
          strong: {
            bg: "rewards-diamond",
            fg: "fg-global-black",
            border: "neutrals-transparent"
          }
        }
      },
      "rewards-diamond-plus": {
        type: {
          strong: {
            bg: "rewards-diamond",
            fg: "fg-global-black",
            border: "neutrals-transparent"
          }
        }
      },
      "rewards-diamond-elite": {
        type: {
          strong: {
            bg: "rewards-diamond",
            fg: "fg-global-black",
            secondaryText: "rewards-seven-stars",
            border: "neutrals-transparent"
          }
        }
      }
    }
  },
  $C = {
    base: "cui-box-border cui-inline-flex cui-items-center cui-justify-center cui-ring-1 cui-w-auto",
    size: {
      xs: {
        type: {
          strong: "body-xs-bold cui-h-5 cui-min-w-[20px] cui-py-2px cui-px-2xs",
          subtle: "body-xs cui-h-5 cui-min-w-[20px] cui-py-2px cui-px-2xs",
          minimal: "body-xs cui-h-5 cui-min-w-[20px] cui-py-2px cui-px-2xs"
        }
      },
      sm: {
        type: {
          strong: "body-sm-bold cui-h-6 cui-min-w-[20px] cui-py-2xs cui-px-xs",
          subtle: "body-sm cui-h-6 cui-min-w-[20px] cui-py-2xs cui-px-xs",
          minimal: "body-sm cui-h-6 cui-min-w-[20px] cui-py-2xs cui-px-xs"
        }
      }
    },
    variant: {
      size: {
        xs: {
          type: {
            strong: "heading-xs cui-h-5 cui-min-w-[20px] cui-py-2px cui-px-2xs"
          }
        },
        sm: {
          type: {
            strong: "heading-sm cui-h-6 cui-min-w-[20px] cui-py-2xs cui-px-xs"
          }
        }
      }
    },
    shape: {
      size: {
        xs: {
          round: "cui-rounded-[9999px]",
          square: "cui-rounded-sm"
        },
        sm: {
          round: "cui-rounded-[9999px]",
          square: "cui-rounded-sm"
        }
      }
    },
    position: {
      topLeft: {
        size: {
          xs: "-cui-top-4 -cui-left-4",
          sm: "-cui-top-5 -cui-left-5"
        }
      },
      topRight: {
        size: {
          xs: "-cui-top-4 -cui-right-4",
          sm: "-cui-top-5 -cui-right-5"
        }
      },
      bottomLeft: {
        size: {
          xs: "-cui-bottom-4 -cui-left-4",
          sm: "-cui-bottom-5 -cui-left-5"
        }
      },
      bottomRight: {
        size: {
          xs: "-cui-bottom-4 -cui-right-4",
          sm: "-cui-bottom-5 -cui-right-5"
        }
      },
      topCenter: {
        size: {
          xs: "-cui-top-4 cui-left-1/2 -cui-translate-x-1/2",
          sm: "-cui-top-5 cui-left-1/2 -cui-translate-x-1/2"
        }
      },
      bottomCenter: {
        size: {
          xs: "-cui-bottom-4 cui-left-1/2 -cui-translate-x-1/2",
          sm: "-cui-bottom-5 cui-left-1/2 -cui-translate-x-1/2"
        }
      },
      center: {
        size: {
          xs: "cui-top-1/2 -cui-translate-y-1/2 cui-left-1/2 -cui-translate-x-1/2",
          sm: "cui-top-1/2 -cui-translate-y-1/2 cui-left-1/2 -cui-translate-x-1/2"
        }
      }
    }
  },
  qC = function qC(e) {
    var t = e.type,
      r = void 0 === t ? "strong" : t,
      a = e.size,
      n = void 0 === a ? "xs" : a,
      o = e.shape,
      i = void 0 === o ? "round" : o,
      l = e.overlay,
      s = void 0 !== l && l,
      c = e.position,
      u = void 0 === c ? "topRight" : c,
      d = e.textFormat,
      p = e.status,
      m = e.variant,
      f = e.skeleton,
      v = void 0 !== f && f,
      y = e.icon,
      g = e.bgColor,
      h = e.fgColor,
      b = e.borderColor,
      N = e.iconColor,
      x = e.text,
      k = void 0 === x ? "" : x,
      w = e.children,
      _ = e.maxNumber,
      F = void 0 === _ ? 1 / 0 : _,
      S = e.numberAbbreviation,
      C = void 0 !== S && S,
      j = e.className,
      E = Me(e, X),
      T = !!p,
      O = !!r,
      A = p && "pending" === p,
      M = (!!y || A) && !m,
      L = Xe(function () {
        var e = k || w || null,
          t = function (e) {
            var t = e.text,
              r = ["xs" === e.size ? "body-xs" : "body-sm", "cui-ml-2px cui-text-[var(--secondary-text)]"].join(" ");
            return {
              rewards: t || "Caesars Rewards",
              "rewards-gold": "Gold",
              "rewards-seven-stars": "Seven Stars",
              "rewards-platinum": "Platinum",
              "rewards-diamond": "Diamond",
              "rewards-diamond-plus": dt.exports.jsxs(dt.exports.Fragment, {
                children: [dt.exports.jsx("span", {
                  children: "Diamond"
                }), dt.exports.jsx("span", {
                  className: r,
                  children: "Plus"
                })]
              }),
              "rewards-diamond-elite": dt.exports.jsxs(dt.exports.Fragment, {
                children: [dt.exports.jsx("span", {
                  children: "Diamond"
                }), dt.exports.jsx("span", {
                  className: r,
                  children: "Elite"
                })]
              })
            };
          }({
            size: n,
            text: e
          });
        if (m) return m in t ? t[m] : "variant";
        if (e) {
          var r = "".concat(e),
            a = r.match(/(\d+)/g);
          return null == a || a.forEach(function (e) {
            r = r.replace("".concat(e), function (e, t, r) {
              if (e <= t) return r ? VC.format(e) : e;
              var a = r ? VC.format(t) : t;
              return "".concat(a).concat(e < t ? "" : "+");
            }(e, F, C));
          }), function (e, t) {
            return null == t ? e : "titlecase" === t ? e.split(" ").map(function (e) {
              var t = me(e),
                r = t[0],
                a = t.slice(1);
              return "".concat(r.toUpperCase()).concat(a.join(""));
            }).join(" ") : e.toUpperCase();
          }(r, d);
        }
        return "";
      }, [k, w, d, m, n, p, C, F]),
      D = Xe(function () {
        var e = [],
          t = m ? "square" : i,
          a = m ? $C.variant.size : $C.size;
        return n in a && (m ? e.push(a[n].type.strong) : e.push(a[n].type[r])), t in $C.shape.size[n] && e.push($C.shape.size[n][t]), s ? (e.push("cui-absolute"), u && "string" == typeof u && u in $C.position && n in $C.position[u].size && e.push($C.position[u].size[n])) : e.push("cui-relative"), yt(e, "".concat($C.base, " ").concat(HC));
      }, [s, n, r, i, m, u]),
      B = Xe(function () {
        var e = {};
        return v ? KC(YC.skeleton, "strong") : m ? KC(YC.variant[m], "strong") : (!T && r && r in YC.type && (e = KC(YC, r)), T && p in YC.status && O && r in YC.status[p].type && (e = KC(YC.status[p], r)), g && (e["--bg-color"] = GC(g)), h && (e["--fg-color"] = GC(h)), b && (e["--border-color"] = GC(b)), N && (e["--icon-color"] = GC(N)), u && "object" === ze(u) && (e = Te(Te({}, e), u)), e);
      }, [g, h, N, b, p, r, m, v]),
      P = Xe(function () {
        return A && !m ? dt.exports.jsx(hn, {
          type: "dots",
          variant: "strong" === r ? "inverse" : "subtle",
          size: n
        }) : M && "object" === ze(y) && "name" in y ? dt.exports.jsx(rs, Te(Te({}, y), {}, {
          size: "size" in y ? null == y ? void 0 : y.size : n,
          className: "cui-mr-2xs"
        })) : M && "string" == typeof y ? dt.exports.jsx(rs, {
          name: y,
          size: n,
          className: "cui-mr-2xs"
        }) : void 0;
      }, [y, p, n, r]);
    return v ? dt.exports.jsx(UC, {
      size: n,
      shape: i
    }) : dt.exports.jsxs("span", Te(Te({
      className: "".concat(D, " ").concat(j),
      style: B
    }, E), {}, {
      children: [M && !m ? P : null, !A || m ? L : null]
    }));
  },
  JC = {
    cui__toggle: "Toggle-module_cui__toggle__Bi9un",
    "cui__toggle-with-animation": "Toggle-module_cui__toggle-with-animation__BkNE-",
    "cui__toggle-track": "Toggle-module_cui__toggle-track__5u7zF",
    "cui__toggle-knob": "Toggle-module_cui__toggle-knob__KHeVw",
    "cui__toggle-shape-round": "Toggle-module_cui__toggle-shape-round__tvZFQ",
    "cui__toggle-shape-square": "Toggle-module_cui__toggle-shape-square__LCKHI",
    "cui__toggle-size-sm": "Toggle-module_cui__toggle-size-sm__xBADx",
    "cui__toggle-size-lg": "Toggle-module_cui__toggle-size-lg__7sAru",
    "cui__toggle-type-primary": "Toggle-module_cui__toggle-type-primary__e4cmj",
    "cui__toggle-type-accent": "Toggle-module_cui__toggle-type-accent__P6HLY",
    "cui__toggle-type-disabled": "Toggle-module_cui__toggle-type-disabled__05dGf",
    "cui__toggle-type-error": "Toggle-module_cui__toggle-type-error__trD9a",
    "cui__toggle-type-alert": "Toggle-module_cui__toggle-type-alert__ApN0P"
  },
  XC = {
    trackColor: "--track-color",
    trackBorderColor: "--track-border-color",
    trackBorderColorSelected: "--track-border-color-selected",
    trackColorSelected: "--track-color-selected",
    knobColor: "--knob-color",
    knobColorSelected: "--knob-color-selected",
    knobBorderColor: "--knob-border-color",
    knobBorderColorSelected: "--knob-border-color-selected",
    knobIconColor: "--knob-icon-color",
    knobIconColorSelected: "--knob-icon-color-selected"
  },
  ZC = {
    primary: "ui_checkmark",
    accent: "ui_checkmark",
    disabled: "ui_locked",
    error: "ui_error",
    alert: "ui_warning"
  },
  QC = function QC(e) {
    var t = e.id,
      r = void 0 === t ? "" : t,
      a = e.selected,
      n = void 0 !== a && a,
      o = e.size,
      i = void 0 === o ? "lg" : o,
      l = e.shape,
      s = void 0 === l ? "round" : l,
      c = e.type,
      u = void 0 === c ? "primary" : c,
      d = e.icon,
      p = e.disabled,
      m = void 0 !== p && p,
      f = e.customColors,
      v = e.accessibilityLabel,
      y = void 0 === v ? "Toggle" : v,
      g = e.showAnimation,
      h = void 0 === g || g,
      b = e.className,
      N = e.onToggle,
      x = Me(e, Z),
      k = Le(He(n), 2),
      w = k[0],
      _ = k[1],
      F = Ge("cui__toggle-id-".concat(Ra())),
      S = r || F.current,
      C = Ge(null),
      j = m ? "disabled" : u,
      E = h ? JC["cui__toggle-with-animation"] : "",
      T = "".concat(JC.cui__toggle, " ").concat(JC["cui__toggle-type-".concat(j)], " ").concat(JC["cui__toggle-size-".concat(i)], " ").concat(JC["cui__toggle-shape-".concat(s)], " ").concat(E, " ").concat(b, "\n  }").trim(),
      O = f && !QS(f) ? Object.values(f) : [],
      A = Xe(function () {
        var e = {};
        return !f || QS(f) || m || (e = Object.entries(f).reduce(function (e, t) {
          var r = Le(t, 2),
            a = r[0],
            n = r[1];
          return e[XC[a]] = GC(n), e;
        }, {})), e;
      }, [].concat(Ce(O), [m])),
      M = !m && w ? {
        defaultChecked: !0
      } : {},
      L = Te(Te({}, m ? {
        disabled: m
      } : {}), M),
      D = Ye(function (e) {
        e.target.checked, _(e.target.checked);
      }, []);
    return Ve(function () {
      !m && _(function (e) {
        return C.current && (C.current.checked = n), n;
      });
    }, [n, m]), Ve(function () {
      N && N({
        id: S,
        selected: w
      });
    }, [w]), dt.exports.jsxs("div", Te(Te({
      className: T,
      style: A
    }, x), {}, {
      children: [dt.exports.jsx("input", Te(Te({
        className: "cui-sr-only",
        type: "checkbox",
        id: S,
        role: "switch",
        tabIndex: 0,
        "aria-checked": w,
        "aria-label": y,
        onChange: D
      }, L), {}, {
        ref: C
      })), dt.exports.jsx(tj, {
        htmlFor: S,
        type: j,
        selected: n,
        children: dt.exports.jsx(ej, {
          icon: d,
          type: j,
          selected: n,
          disabled: m,
          size: i
        })
      })]
    }));
  },
  ej = function ej(e) {
    var t = e.icon,
      r = e.type,
      a = e.size,
      n = e.disabled,
      o = r ? dt.exports.jsx(rs, {
        name: ZC[r],
        size: "sm" === a ? "xs" : "sm"
      }) : null;
    return t && "object" === ze(t) && "name" in t && !n && (o = dt.exports.jsx(rs, Te({}, t))), dt.exports.jsx("div", {
      className: JC["cui__toggle-knob"],
      children: o
    });
  },
  tj = function tj(e) {
    var t = e.children,
      r = e.htmlFor;
    return dt.exports.jsx("label", {
      htmlFor: r,
      className: JC["cui__toggle-track"],
      children: t
    });
  },
  rj = function rj(e) {
    var t,
      r,
      a = e.title,
      n = e.id,
      o = e.description,
      i = e.leadingIcon,
      l = e.trailingDetails,
      s = void 0 === l ? [] : l,
      c = e.collapsible,
      u = e.headerBg,
      d = void 0 === u ? "bg-primary-minimal" : u,
      p = e.isOpen,
      m = e.onClick;
    "string" == typeof i && (r = dt.exports.jsx(rs, {
      name: i,
      size: "lg"
    })), "object" === ze(i) && (r = dt.exports.jsx(rs, Te({}, i)));
    var f = Xe(function () {
      var e = {
        tag: "More",
        rightIcon: {
          name: "ui_chevron-right",
          size: "md",
          color: "fg-primary"
        },
        fgColor: "fg-primary"
      };
      return s && Array.isArray(s) ? [].concat(Ce(s), [e]) : [e];
    }, [a, i]);
    return dt.exports.jsxs("div", {
      className: yt((t = {}, Oe(t, pn[d], !0), Oe(t, "cui-items-center", !o), Oe(t, "cui-items-start", !!o), t), "cui-flex cui-justify-between cui-px-md cui-py-sm cui-cursor-pointer cui-min-h-[32px]"),
      style: {
        background: d
      },
      onClick: function onClick(e) {
        m && m({
          e: e,
          id: n
        });
      },
      children: [dt.exports.jsxs("div", {
        className: "cui-flex-col",
        children: [dt.exports.jsxs("div", {
          className: "cui-flex cui-items-start",
          children: [r ? dt.exports.jsx("div", {
            className: "cui-h-2",
            children: r
          }) : null, dt.exports.jsx("div", {
            className: yt({
              "cui-ml-xs": !!r
            }, "heading-lg-bold cui-text-fg-default cui-self-center"),
            children: a
          })]
        }), o ? dt.exports.jsx("span", {
          className: "heading-xs-bold cui-text-fg-default",
          children: o
        }) : null]
      }), c ? dt.exports.jsx(IF, {
        className: yt({
          "cui-rotate-180": !p
        })
      }) : dt.exports.jsx(cc, {
        list: f
      })]
    });
  },
  aj = qe(function (e, t) {
    var r = e.marketTemplates,
      a = e.id,
      n = e.title,
      o = e.description,
      i = e.leadingIcon,
      l = e.trailingDetails,
      s = e.collapsible,
      c = void 0 !== s && s,
      u = e.headerBg,
      d = (e.mode, e.children),
      p = e.initiallyOpen,
      m = void 0 === p || p,
      f = e.onHeaderClick,
      v = e.restrictTo,
      y = Me(e, Q);
    if (!r && !d) return null;
    var g = Le(He(m), 2),
      h = g[0],
      b = g[1],
      N = Ge(Ra()),
      x = a || "cui__market-fixture-id-".concat(N.current),
      k = Array.isArray(l) && null != l && l.length ? l : null,
      w = Ye(function (e) {
        f && f({
          e: e,
          id: x
        });
      }, []),
      _ = Ye(function (e) {
        var t = e.isOpen;
        b(t);
      }, []);
    return dt.exports.jsxs(RC, Te(Te({
      restrictTo: v,
      noPad: !0,
      ref: t
    }, y), {}, {
      id: x,
      collapsible: c,
      initiallyOpen: !c || m,
      onToggle: _,
      children: [dt.exports.jsx(RC.Header, {
        noPad: !0,
        children: dt.exports.jsx(rj, {
          id: x,
          title: n,
          description: o,
          leadingIcon: i,
          trailingDetails: k,
          collapsible: c,
          headerBg: u,
          isOpen: h,
          onClick: w
        })
      }), d, r ? r.map(function (e, t) {
        var r = "cui__market-fixture-key-$".concat((null == e ? void 0 : e.id) || N.current, "-").concat(t);
        return $e(IC, Te(Te({}, e), {}, {
          key: r
        }));
      }) : null]
    }));
  }),
  nj = Object.assign({}, aj, {
    Header: RC.Header,
    SubHeader: RC.SubHeader,
    PreFooter: RC.PreFooter,
    Footer: RC.Footer,
    displayName: "MarketFixture"
  });
function oj() {
  return oj = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, oj.apply(this, arguments);
}
function ij(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    a = r.checkForDefaultPrevented,
    n = void 0 === a || a;
  return function (r) {
    if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
  };
}
function lj(e, t) {
  "function" == typeof e ? e(t) : null != e && (e.current = t);
}
function sj() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return function (e) {
    return t.forEach(function (t) {
      return lj(t, e);
    });
  };
}
function cj() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  return Ye(sj.apply(void 0, t), t);
}
function uj() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
  var a = t[0];
  if (1 === t.length) return a;
  var n = function n() {
    var e = t.map(function (e) {
      return {
        useScope: e(),
        scopeName: e.scopeName
      };
    });
    return function (t) {
      var r = e.reduce(function (e, r) {
        var a = r.useScope,
          n = r.scopeName,
          o = a(t)["__scope".concat(n)];
        return Te(Te({}, e), o);
      }, {});
      return Xe(function () {
        return Oe({}, "__scope".concat(a.scopeName), r);
      }, [r]);
    };
  };
  return n.scopeName = a.scopeName, n;
}
var dj = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? We : function () {},
  pj = Re["useId".toString()] || function () {},
  mj = 0;
function fj(e) {
  var t = Le(Re.useState(pj()), 2),
    r = t[0],
    a = t[1];
  return dj(function () {
    e || a(function (e) {
      return null != e ? e : String(mj++);
    });
  }, [e]), e || (r ? "radix-".concat(r) : "");
}
function vj(e) {
  var t = Ge(e);
  return Ve(function () {
    t.current = e;
  }), Xe(function () {
    return function () {
      for (var e, r, a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];
      return null === (r = t.current) || void 0 === r ? void 0 : (e = r).call.apply(e, [t].concat(n));
    };
  }, []);
}
function yj(e) {
  var t = e.prop,
    r = e.defaultProp,
    a = e.onChange,
    n = void 0 === a ? function () {} : a,
    o = function (e) {
      var t = e.defaultProp,
        r = e.onChange,
        a = He(t),
        n = Le(a, 1)[0],
        o = Ge(n),
        i = vj(r);
      return Ve(function () {
        o.current !== n && (i(n), o.current = n);
      }, [n, o, i]), a;
    }({
      defaultProp: r,
      onChange: n
    }),
    i = Le(o, 2),
    l = i[0],
    s = i[1],
    c = void 0 !== t,
    u = c ? t : l,
    d = vj(n);
  return [u, Ye(function (e) {
    if (c) {
      var r = "function" == typeof e ? e(t) : e;
      r !== t && d(r);
    } else s(e);
  }, [c, t, s, d])];
}
var gj = qe(function (e, t) {
  var r = e.children,
    a = Me(e, te),
    n = Qe.toArray(r),
    o = n.find(Nj);
  if (o) {
    var i = o.props.children,
      l = n.map(function (e) {
        return e === o ? Qe.count(i) > 1 ? Qe.only(null) : Je(i) ? i.props.children : null : e;
      });
    return $e(hj, oj({}, a, {
      ref: t
    }), Je(i) ? at(i, void 0, l) : null);
  }
  return $e(hj, oj({}, a, {
    ref: t
  }), r);
});
gj.displayName = "Slot";
var hj = qe(function (e, t) {
  var r = e.children,
    a = Me(e, re);
  return Je(r) ? at(r, Te(Te({}, function (e, t) {
    var r = Te({}, t),
      a = function a() {
        var a = e[n],
          o = t[n];
        /^on[A-Z]/.test(n) ? a && o ? r[n] = function () {
          o.apply(void 0, arguments), a.apply(void 0, arguments);
        } : a && (r[n] = a) : "style" === n ? r[n] = Te(Te({}, a), o) : "className" === n && (r[n] = [a, o].filter(Boolean).join(" "));
      };
    for (var n in t) a();
    return Te(Te({}, e), r);
  }(a, r.props)), {}, {
    ref: t ? sj(t, r.ref) : r.ref
  })) : Qe.count(r) > 1 ? Qe.only(null) : null;
});
hj.displayName = "SlotClone";
var bj = function bj(e) {
  var t = e.children;
  return $e(nt, null, t);
};
function Nj(e) {
  return Je(e) && e.type === bj;
}
var xj = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
  var r = qe(function (e, r) {
    var a = e.asChild,
      n = Me(e, ae),
      o = a ? gj : t;
    return Ve(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), $e(o, oj({}, n, {
      ref: r
    }));
  });
  return r.displayName = "Primitive.".concat(t), Te(Te({}, e), {}, Oe({}, t, r));
}, {});
var kj,
  wj = Ze({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
  }),
  _j = qe(function (e, t) {
    var r,
      a = e.disableOutsidePointerEvents,
      n = void 0 !== a && a,
      o = e.onEscapeKeyDown,
      i = e.onPointerDownOutside,
      l = e.onFocusOutside,
      s = e.onInteractOutside,
      c = e.onDismiss,
      u = Me(e, ne),
      d = rt(wj),
      p = Le(He(null), 2),
      m = p[0],
      f = p[1],
      v = null !== (r = null == m ? void 0 : m.ownerDocument) && void 0 !== r ? r : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document,
      y = Le(He({}), 2)[1],
      g = cj(t, function (e) {
        return f(e);
      }),
      h = Array.from(d.layers),
      b = Le(Ce(d.layersWithOutsidePointerEventsDisabled).slice(-1), 1)[0],
      N = h.indexOf(b),
      x = m ? h.indexOf(m) : -1,
      k = d.layersWithOutsidePointerEventsDisabled.size > 0,
      w = x >= N,
      _ = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document,
          r = vj(e),
          a = Ge(!1),
          n = Ge(function () {});
        return Ve(function () {
          var e = function e(_e5) {
              if (_e5.target && !a.current) {
                var o = function o() {
                    Sj("dismissableLayer.pointerDownOutside", r, i, {
                      discrete: !0
                    });
                  },
                  i = {
                    originalEvent: _e5
                  };
                "touch" === _e5.pointerType ? (t.removeEventListener("click", n.current), n.current = o, t.addEventListener("click", n.current, {
                  once: !0
                })) : o();
              } else t.removeEventListener("click", n.current);
              a.current = !1;
            },
            o = window.setTimeout(function () {
              t.addEventListener("pointerdown", e);
            }, 0);
          return function () {
            window.clearTimeout(o), t.removeEventListener("pointerdown", e), t.removeEventListener("click", n.current);
          };
        }, [t, r]), {
          onPointerDownCapture: function onPointerDownCapture() {
            return a.current = !0;
          }
        };
      }(function (e) {
        var t = e.target,
          r = Ce(d.branches).some(function (e) {
            return e.contains(t);
          });
        w && !r && (null == i || i(e), null == s || s(e), e.defaultPrevented || null == c || c());
      }, v),
      F = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document,
          r = vj(e),
          a = Ge(!1);
        return Ve(function () {
          var e = function e(_e6) {
            _e6.target && !a.current && Sj("dismissableLayer.focusOutside", r, {
              originalEvent: _e6
            }, {
              discrete: !1
            });
          };
          return t.addEventListener("focusin", e), function () {
            return t.removeEventListener("focusin", e);
          };
        }, [t, r]), {
          onFocusCapture: function onFocusCapture() {
            return a.current = !0;
          },
          onBlurCapture: function onBlurCapture() {
            return a.current = !1;
          }
        };
      }(function (e) {
        var t = e.target;
        Ce(d.branches).some(function (e) {
          return e.contains(t);
        }) || (null == l || l(e), null == s || s(e), e.defaultPrevented || null == c || c());
      }, v);
    return function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document,
        r = vj(e);
      Ve(function () {
        var e = function e(_e7) {
          "Escape" === _e7.key && r(_e7);
        };
        return t.addEventListener("keydown", e), function () {
          return t.removeEventListener("keydown", e);
        };
      }, [r, t]);
    }(function (e) {
      x === d.layers.size - 1 && (null == o || o(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
    }, v), Ve(function () {
      if (m) return n && (0 === d.layersWithOutsidePointerEventsDisabled.size && (kj = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(m)), d.layers.add(m), Fj(), function () {
        n && 1 === d.layersWithOutsidePointerEventsDisabled.size && (v.body.style.pointerEvents = kj);
      };
    }, [m, v, n, d]), Ve(function () {
      return function () {
        m && (d.layers.delete(m), d.layersWithOutsidePointerEventsDisabled.delete(m), Fj());
      };
    }, [m, d]), Ve(function () {
      var e = function e() {
        return y({});
      };
      return document.addEventListener("dismissableLayer.update", e), function () {
        return document.removeEventListener("dismissableLayer.update", e);
      };
    }, []), $e(xj.div, oj({}, u, {
      ref: g,
      style: Te({
        pointerEvents: k ? w ? "auto" : "none" : void 0
      }, e.style),
      onFocusCapture: ij(e.onFocusCapture, F.onFocusCapture),
      onBlurCapture: ij(e.onBlurCapture, F.onBlurCapture),
      onPointerDownCapture: ij(e.onPointerDownCapture, _.onPointerDownCapture)
    }));
  });
function Fj() {
  var e = new CustomEvent("dismissableLayer.update");
  document.dispatchEvent(e);
}
function Sj(e, t, r, a) {
  var n = a.discrete,
    o = r.originalEvent.target,
    i = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: r
    });
  t && o.addEventListener(e, t, {
    once: !0
  }), n ? function (e, t) {
    e && st(function () {
      return e.dispatchEvent(t);
    });
  }(o, i) : o.dispatchEvent(i);
}
var Cj = {
    bubbles: !1,
    cancelable: !0
  },
  jj = qe(function (e, t) {
    var r = e.loop,
      a = void 0 !== r && r,
      n = e.trapped,
      o = void 0 !== n && n,
      i = e.onMountAutoFocus,
      l = e.onUnmountAutoFocus,
      s = Me(e, oe),
      c = Le(He(null), 2),
      u = c[0],
      d = c[1],
      p = vj(i),
      m = vj(l),
      f = Ge(null),
      v = cj(t, function (e) {
        return d(e);
      }),
      y = Ge({
        paused: !1,
        pause: function pause() {
          this.paused = !0;
        },
        resume: function resume() {
          this.paused = !1;
        }
      }).current;
    Ve(function () {
      if (o) {
        var e = function e(_e8) {
            if (!y.paused && u) {
              var t = _e8.target;
              u.contains(t) ? f.current = t : Mj(f.current, {
                select: !0
              });
            }
          },
          t = function t(e) {
            if (!y.paused && u) {
              var t = e.relatedTarget;
              null !== t && (u.contains(t) || Mj(f.current, {
                select: !0
              }));
            }
          };
        document.addEventListener("focusin", e), document.addEventListener("focusout", t);
        var r = new MutationObserver(function (e) {
          if (document.activeElement === document.body) {
            var t,
              r = Se(e);
            try {
              for (r.s(); !(t = r.n()).done;) {
                t.value.removedNodes.length > 0 && Mj(u);
              }
            } catch (e) {
              r.e(e);
            } finally {
              r.f();
            }
          }
        });
        return u && r.observe(u, {
          childList: !0,
          subtree: !0
        }), function () {
          document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
        };
      }
    }, [o, u, y.paused]), Ve(function () {
      if (u) {
        Dj.add(y);
        var e = document.activeElement;
        if (!u.contains(e)) {
          var t = new CustomEvent("focusScope.autoFocusOnMount", Cj);
          u.addEventListener("focusScope.autoFocusOnMount", p), u.dispatchEvent(t), t.defaultPrevented || (!function (e) {
            var t,
              r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).select,
              a = void 0 !== r && r,
              n = document.activeElement,
              o = Se(e);
            try {
              for (o.s(); !(t = o.n()).done;) {
                if (Mj(t.value, {
                  select: a
                }), document.activeElement !== n) return;
              }
            } catch (e) {
              o.e(e);
            } finally {
              o.f();
            }
          }((r = Ej(u), r.filter(function (e) {
            return "A" !== e.tagName;
          })), {
            select: !0
          }), document.activeElement === e && Mj(u));
        }
        return function () {
          u.removeEventListener("focusScope.autoFocusOnMount", p), setTimeout(function () {
            var t = new CustomEvent("focusScope.autoFocusOnUnmount", Cj);
            u.addEventListener("focusScope.autoFocusOnUnmount", m), u.dispatchEvent(t), t.defaultPrevented || Mj(null != e ? e : document.body, {
              select: !0
            }), u.removeEventListener("focusScope.autoFocusOnUnmount", m), Dj.remove(y);
          }, 0);
        };
      }
      var r;
    }, [u, p, m, y]);
    var g = Ye(function (e) {
      if ((a || o) && !y.paused) {
        var t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
          r = document.activeElement;
        if (t && r) {
          var n = e.currentTarget,
            i = function (e) {
              var t = Ej(e),
                r = Tj(t, e),
                a = Tj(t.reverse(), e);
              return [r, a];
            }(n),
            l = Le(i, 2),
            s = l[0],
            c = l[1];
          s && c ? e.shiftKey || r !== c ? e.shiftKey && r === s && (e.preventDefault(), a && Mj(c, {
            select: !0
          })) : (e.preventDefault(), a && Mj(s, {
            select: !0
          })) : r === n && e.preventDefault();
        }
      }
    }, [a, o, y.paused]);
    return $e(xj.div, oj({
      tabIndex: -1
    }, s, {
      ref: v,
      onKeyDown: g
    }));
  });
function Ej(e) {
  for (var t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function acceptNode(e) {
        var t = "INPUT" === e.tagName && "hidden" === e.type;
        return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    }); r.nextNode();) t.push(r.currentNode);
  return t;
}
function Tj(e, t) {
  var r,
    a = Se(e);
  try {
    for (a.s(); !(r = a.n()).done;) {
      var n = r.value;
      if (!Oj(n, {
        upTo: t
      })) return n;
    }
  } catch (e) {
    a.e(e);
  } finally {
    a.f();
  }
}
function Oj(e, t) {
  var r = t.upTo;
  if ("hidden" === getComputedStyle(e).visibility) return !0;
  for (; e;) {
    if (void 0 !== r && e === r) return !1;
    if ("none" === getComputedStyle(e).display) return !0;
    e = e.parentElement;
  }
  return !1;
}
function Aj(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Mj(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.select,
    a = void 0 !== r && r;
  if (e && e.focus) {
    var n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Aj(e) && a && e.select();
  }
}
var Lj,
  Dj = (Lj = [], {
    add: function add(e) {
      var t = Lj[0];
      e !== t && (null == t || t.pause()), (Lj = Bj(Lj, e)).unshift(e);
    },
    remove: function remove(e) {
      var t;
      null === (t = (Lj = Bj(Lj, e))[0]) || void 0 === t || t.resume();
    }
  });
function Bj(e, t) {
  var r = Ce(e),
    a = r.indexOf(t);
  return -1 !== a && r.splice(a, 1), r;
}
var Pj = qe(function (e, t) {
  var r,
    a = e.container,
    n = void 0 === a ? null === globalThis || void 0 === globalThis || null === (r = globalThis.document) || void 0 === r ? void 0 : r.body : a,
    o = Me(e, ie);
  return n ? it.createPortal($e(xj.div, oj({}, o, {
    ref: t
  })), n) : null;
});
var Ij = function Ij(e) {
  var t = e.present,
    r = e.children,
    a = function (e) {
      var t = Le(He(), 2),
        r = t[0],
        a = t[1],
        n = Ge({}),
        o = Ge(e),
        i = Ge("none"),
        l = Le(function (e, t) {
          return ot(function (e, r) {
            var a = t[e][r];
            return null != a ? a : e;
          }, e);
        }(e ? "mounted" : "unmounted", {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        }), 2),
        s = l[0],
        c = l[1];
      return Ve(function () {
        var e = zj(n.current);
        i.current = "mounted" === s ? e : "none";
      }, [s]), dj(function () {
        var t = n.current,
          r = o.current;
        if (r !== e) {
          var a = i.current,
            l = zj(t);
          if (e) c("MOUNT");else if ("none" === l || "none" === (null == t ? void 0 : t.display)) c("UNMOUNT");else {
            c(r && a !== l ? "ANIMATION_OUT" : "UNMOUNT");
          }
          o.current = e;
        }
      }, [e, c]), dj(function () {
        if (r) {
          var e = function e(_e9) {
              var t = zj(n.current).includes(_e9.animationName);
              _e9.target === r && t && st(function () {
                return c("ANIMATION_END");
              });
            },
            t = function t(e) {
              e.target === r && (i.current = zj(n.current));
            };
          return r.addEventListener("animationstart", t), r.addEventListener("animationcancel", e), r.addEventListener("animationend", e), function () {
            r.removeEventListener("animationstart", t), r.removeEventListener("animationcancel", e), r.removeEventListener("animationend", e);
          };
        }
        c("ANIMATION_END");
      }, [r, c]), {
        isPresent: ["mounted", "unmountSuspended"].includes(s),
        ref: Ye(function (e) {
          e && (n.current = getComputedStyle(e)), a(e);
        }, [])
      };
    }(t),
    n = "function" == typeof r ? r({
      present: a.isPresent
    }) : Qe.only(r),
    o = cj(a.ref, n.ref);
  return "function" == typeof r || a.isPresent ? at(n, {
    ref: o
  }) : null;
};
function zj(e) {
  return (null == e ? void 0 : e.animationName) || "none";
}
Ij.displayName = "Presence";
var Rj = 0;
function Uj() {
  var e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var _Hj = function Hj() {
  return _Hj = Object.assign || function (e) {
    for (var t, r = 1, a = arguments.length; r < a; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  }, _Hj.apply(this, arguments);
};
function Gj(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;
    for (a = Object.getOwnPropertySymbols(e); n < a.length; n++) t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
  }
  return r;
}
function Vj(e, t) {
  return r = t || null, a = function a(t) {
    return e.forEach(function (e) {
      return function (e, t) {
        return "function" == typeof e ? e(t) : e && (e.current = t), e;
      }(e, t);
    });
  }, (n = He(function () {
    return {
      value: r,
      callback: a,
      facade: {
        get current() {
          return n.value;
        },
        set current(e) {
          var t = n.value;
          t !== e && (n.value = e, n.callback(e, t));
        }
      }
    };
  })[0]).callback = a, n.facade;
  var r, a, n;
}
function Wj(e) {
  return e;
}
var Kj = function Kj(e) {
  var t = e.sideCar,
    r = Gj(e, ["sideCar"]);
  if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var a = t.read();
  if (!a) throw new Error("Sidecar medium not found");
  return Re.createElement(a, _Hj({}, r));
};
Kj.isSideCarExport = !0;
var Yj = function (e) {
    void 0 === e && (e = {});
    var t = function (e, t) {
      void 0 === t && (t = Wj);
      var r = [],
        a = !1;
      return {
        read: function read() {
          if (a) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
          return r.length ? r[r.length - 1] : e;
        },
        useMedium: function useMedium(e) {
          var n = t(e, a);
          return r.push(n), function () {
            r = r.filter(function (e) {
              return e !== n;
            });
          };
        },
        assignSyncMedium: function assignSyncMedium(e) {
          for (a = !0; r.length;) {
            var t = r;
            r = [], t.forEach(e);
          }
          r = {
            push: function push(t) {
              return e(t);
            },
            filter: function filter() {
              return r;
            }
          };
        },
        assignMedium: function assignMedium(e) {
          a = !0;
          var t = [];
          if (r.length) {
            var n = r;
            r = [], n.forEach(e), t = r;
          }
          var o = function o() {
              var r = t;
              t = [], r.forEach(e);
            },
            i = function i() {
              return Promise.resolve().then(o);
            };
          i(), r = {
            push: function push(e) {
              t.push(e), i();
            },
            filter: function filter(e) {
              return t = t.filter(e), r;
            }
          };
        }
      };
    }(null);
    return t.options = _Hj({
      async: !0,
      ssr: !1
    }, e), t;
  }(),
  $j = function $j() {},
  qj = Re.forwardRef(function (e, t) {
    var r = Re.useRef(null),
      a = Re.useState({
        onScrollCapture: $j,
        onWheelCapture: $j,
        onTouchMoveCapture: $j
      }),
      n = a[0],
      o = a[1],
      i = e.forwardProps,
      l = e.children,
      s = e.className,
      c = e.removeScrollBar,
      u = e.enabled,
      d = e.shards,
      p = e.sideCar,
      m = e.noIsolation,
      f = e.inert,
      v = e.allowPinchZoom,
      y = e.as,
      g = void 0 === y ? "div" : y,
      h = Gj(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
      b = p,
      N = Vj([r, t]),
      x = _Hj(_Hj({}, h), n);
    return Re.createElement(Re.Fragment, null, u && Re.createElement(b, {
      sideCar: Yj,
      removeScrollBar: c,
      shards: d,
      noIsolation: m,
      inert: f,
      setCallbacks: o,
      allowPinchZoom: !!v,
      lockRef: r
    }), i ? Re.cloneElement(Re.Children.only(l), _Hj(_Hj({}, x), {
      ref: N
    })) : Re.createElement(g, _Hj({}, x, {
      className: s,
      ref: N
    }), l));
  });
qj.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
}, qj.classNames = {
  fullWidth: "width-before-scroll-bar",
  zeroRight: "right-scroll-bar-position"
};
function Jj() {
  if (!document) return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = function () {
    if ("undefined" != typeof __webpack_nonce__) return __webpack_nonce__;
  }();
  return t && e.setAttribute("nonce", t), e;
}
var Xj = function Xj() {
    var e = 0,
      t = null;
    return {
      add: function add(r) {
        var a, n;
        0 == e && (t = Jj()) && (n = r, (a = t).styleSheet ? a.styleSheet.cssText = n : a.appendChild(document.createTextNode(n)), function (e) {
          (document.head || document.getElementsByTagName("head")[0]).appendChild(e);
        }(t)), e++;
      },
      remove: function remove() {
        ! --e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
  Zj = function Zj() {
    var e,
      t = (e = Xj(), function (t, r) {
        Re.useEffect(function () {
          return e.add(t), function () {
            e.remove();
          };
        }, [t && r]);
      });
    return function (e) {
      var r = e.styles,
        a = e.dynamic;
      return t(r, a), null;
    };
  },
  Qj = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
  eE = function eE(e) {
    return parseInt(e || "", 10) || 0;
  },
  tE = function tE(e) {
    if (void 0 === e && (e = "margin"), "undefined" == typeof window) return Qj;
    var t = function (e) {
        var t = window.getComputedStyle(document.body),
          r = t["padding" === e ? "paddingLeft" : "marginLeft"],
          a = t["padding" === e ? "paddingTop" : "marginTop"],
          n = t["padding" === e ? "paddingRight" : "marginRight"];
        return [eE(r), eE(a), eE(n)];
      }(e),
      r = document.documentElement.clientWidth,
      a = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, a - r + t[2] - t[0])
    };
  },
  rE = Zj(),
  aE = function aE(e, t, r, a) {
    var n = e.left,
      o = e.top,
      i = e.right,
      l = e.gap;
    return void 0 === r && (r = "margin"), "\n  .".concat("with-scroll-bars-hidden", " {\n   overflow: hidden ").concat(a, ";\n   padding-right: ").concat(l, "px ").concat(a, ";\n  }\n  body {\n    overflow: hidden ").concat(a, ";\n    overscroll-behavior: contain;\n    ").concat([t && "position: relative ".concat(a, ";"), "margin" === r && "\n    padding-left: ".concat(n, "px;\n    padding-top: ").concat(o, "px;\n    padding-right: ").concat(i, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(l, "px ").concat(a, ";\n    "), "padding" === r && "padding-right: ".concat(l, "px ").concat(a, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat("right-scroll-bar-position", " {\n    right: ").concat(l, "px ").concat(a, ";\n  }\n  \n  .").concat("width-before-scroll-bar", " {\n    margin-right: ").concat(l, "px ").concat(a, ";\n  }\n  \n  .").concat("right-scroll-bar-position", " .").concat("right-scroll-bar-position", " {\n    right: 0 ").concat(a, ";\n  }\n  \n  .").concat("width-before-scroll-bar", " .").concat("width-before-scroll-bar", " {\n    margin-right: 0 ").concat(a, ";\n  }\n  \n  body {\n    ").concat("--removed-body-scroll-bar-size", ": ").concat(l, "px;\n  }\n");
  },
  nE = function nE(e) {
    var t = e.noRelative,
      r = e.noImportant,
      a = e.gapMode,
      n = void 0 === a ? "margin" : a,
      o = Re.useMemo(function () {
        return tE(n);
      }, [n]);
    return Re.createElement(rE, {
      styles: aE(o, !t, n, r ? "" : "!important")
    });
  },
  oE = !1;
if ("undefined" != typeof window) try {
  var iE = Object.defineProperty({}, "passive", {
    get: function get() {
      return oE = !0, !0;
    }
  });
  window.addEventListener("test", iE, iE), window.removeEventListener("test", iE, iE);
} catch (e) {
  oE = !1;
}
var lE = !!oE && {
    passive: !1
  },
  sE = function sE(e, t) {
    var r = window.getComputedStyle(e);
    return "hidden" !== r[t] && !(r.overflowY === r.overflowX && !function (e) {
      return "TEXTAREA" === e.tagName;
    }(e) && "visible" === r[t]);
  },
  cE = function cE(e, t) {
    var r = t;
    do {
      if ("undefined" != typeof ShadowRoot && r instanceof ShadowRoot && (r = r.host), uE(e, r)) {
        var a = dE(e, r);
        if (a[1] > a[2]) return !0;
      }
      r = r.parentNode;
    } while (r && r !== document.body);
    return !1;
  },
  uE = function uE(e, t) {
    return "v" === e ? function (e) {
      return sE(e, "overflowY");
    }(t) : function (e) {
      return sE(e, "overflowX");
    }(t);
  },
  dE = function dE(e, t) {
    return "v" === e ? [(r = t).scrollTop, r.scrollHeight, r.clientHeight] : function (e) {
      return [e.scrollLeft, e.scrollWidth, e.clientWidth];
    }(t);
    var r;
  },
  pE = function pE(e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
  mE = function mE(e) {
    return [e.deltaX, e.deltaY];
  },
  fE = function fE(e) {
    return e && "current" in e ? e.current : e;
  },
  vE = function vE(e) {
    return "\n  .block-interactivity-".concat(e, " {pointer-events: none;}\n  .allow-interactivity-").concat(e, " {pointer-events: all;}\n");
  },
  yE = 0,
  gE = [];
var hE,
  bE = (hE = function hE(e) {
    var t = Re.useRef([]),
      r = Re.useRef([0, 0]),
      a = Re.useRef(),
      n = Re.useState(yE++)[0],
      o = Re.useState(function () {
        return Zj();
      })[0],
      i = Re.useRef(e);
    Re.useEffect(function () {
      i.current = e;
    }, [e]), Re.useEffect(function () {
      if (e.inert) {
        document.body.classList.add("block-interactivity-".concat(n));
        var t = function (e, t, r) {
          if (r || 2 === arguments.length) for (var a, n = 0, o = t.length; n < o; n++) !a && n in t || (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
          return e.concat(a || Array.prototype.slice.call(t));
        }([e.lockRef.current], (e.shards || []).map(fE), !0).filter(Boolean);
        return t.forEach(function (e) {
          return e.classList.add("allow-interactivity-".concat(n));
        }), function () {
          document.body.classList.remove("block-interactivity-".concat(n)), t.forEach(function (e) {
            return e.classList.remove("allow-interactivity-".concat(n));
          });
        };
      }
    }, [e.inert, e.lockRef.current, e.shards]);
    var l = Re.useCallback(function (e, t) {
        if ("touches" in e && 2 === e.touches.length) return !i.current.allowPinchZoom;
        var n,
          o = pE(e),
          l = r.current,
          s = "deltaX" in e ? e.deltaX : l[0] - o[0],
          c = "deltaY" in e ? e.deltaY : l[1] - o[1],
          u = e.target,
          d = Math.abs(s) > Math.abs(c) ? "h" : "v";
        if ("touches" in e && "h" === d && "range" === u.type) return !1;
        var p = cE(d, u);
        if (!p) return !0;
        if (p ? n = d : (n = "v" === d ? "h" : "v", p = cE(d, u)), !p) return !1;
        if (!a.current && "changedTouches" in e && (s || c) && (a.current = n), !n) return !0;
        var m = a.current || n;
        return function (e, t, r, a, n) {
          var o = function (e, t) {
              return "h" === e && "rtl" === t ? -1 : 1;
            }(e, window.getComputedStyle(t).direction),
            i = o * a,
            l = r.target,
            s = t.contains(l),
            c = !1,
            u = i > 0,
            d = 0,
            p = 0;
          do {
            var m = dE(e, l),
              f = m[0],
              v = m[1] - m[2] - o * f;
            (f || v) && uE(e, l) && (d += v, p += f), l = l.parentNode;
          } while (!s && l !== document.body || s && (t.contains(l) || t === l));
          return (u && (n && 0 === d || !n && i > d) || !u && (n && 0 === p || !n && -i > p)) && (c = !0), c;
        }(m, t, e, "h" === m ? s : c, !0);
      }, []),
      s = Re.useCallback(function (e) {
        var r = e;
        if (gE.length && gE[gE.length - 1] === o) {
          var a = "deltaY" in r ? mE(r) : pE(r),
            n = t.current.filter(function (e) {
              return e.name === r.type && e.target === r.target && (t = e.delta, n = a, t[0] === n[0] && t[1] === n[1]);
              var t, n;
            })[0];
          if (n && n.should) r.cancelable && r.preventDefault();else if (!n) {
            var s = (i.current.shards || []).map(fE).filter(Boolean).filter(function (e) {
              return e.contains(r.target);
            });
            (s.length > 0 ? l(r, s[0]) : !i.current.noIsolation) && r.cancelable && r.preventDefault();
          }
        }
      }, []),
      c = Re.useCallback(function (e, r, a, n) {
        var o = {
          name: e,
          delta: r,
          target: a,
          should: n
        };
        t.current.push(o), setTimeout(function () {
          t.current = t.current.filter(function (e) {
            return e !== o;
          });
        }, 1);
      }, []),
      u = Re.useCallback(function (e) {
        r.current = pE(e), a.current = void 0;
      }, []),
      d = Re.useCallback(function (t) {
        c(t.type, mE(t), t.target, l(t, e.lockRef.current));
      }, []),
      p = Re.useCallback(function (t) {
        c(t.type, pE(t), t.target, l(t, e.lockRef.current));
      }, []);
    Re.useEffect(function () {
      return gE.push(o), e.setCallbacks({
        onScrollCapture: d,
        onWheelCapture: d,
        onTouchMoveCapture: p
      }), document.addEventListener("wheel", s, lE), document.addEventListener("touchmove", s, lE), document.addEventListener("touchstart", u, lE), function () {
        gE = gE.filter(function (e) {
          return e !== o;
        }), document.removeEventListener("wheel", s, lE), document.removeEventListener("touchmove", s, lE), document.removeEventListener("touchstart", u, lE);
      };
    }, []);
    var m = e.removeScrollBar,
      f = e.inert;
    return Re.createElement(Re.Fragment, null, f ? Re.createElement(o, {
      styles: vE(n)
    }) : null, m ? Re.createElement(nE, {
      gapMode: "margin"
    }) : null);
  }, Yj.useMedium(hE), Kj),
  NE = Re.forwardRef(function (e, t) {
    return Re.createElement(qj, _Hj({}, e, {
      ref: t,
      sideCar: bE
    }));
  });
NE.classNames = qj.classNames;
var xE = NE,
  kE = new WeakMap(),
  wE = new WeakMap(),
  _E = {},
  FE = 0,
  SE = function e(t) {
    return t && (t.host || e(t.parentNode));
  },
  CE = function CE(e, t, r, a) {
    var n = function (e, t) {
      return t.map(function (t) {
        if (e.contains(t)) return t;
        var r = SE(t);
        return r && e.contains(r) ? r : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
      }).filter(function (e) {
        return Boolean(e);
      });
    }(t, Array.isArray(e) ? e : [e]);
    _E[r] || (_E[r] = new WeakMap());
    var o = _E[r],
      i = [],
      l = new Set(),
      s = new Set(n);
    n.forEach(function e(t) {
      t && !l.has(t) && (l.add(t), e(t.parentNode));
    });
    return function e(t) {
      t && !s.has(t) && Array.prototype.forEach.call(t.children, function (t) {
        if (l.has(t)) e(t);else {
          var n = t.getAttribute(a),
            s = null !== n && "false" !== n,
            c = (kE.get(t) || 0) + 1,
            u = (o.get(t) || 0) + 1;
          kE.set(t, c), o.set(t, u), i.push(t), 1 === c && s && wE.set(t, !0), 1 === u && t.setAttribute(r, "true"), s || t.setAttribute(a, "true");
        }
      });
    }(t), l.clear(), FE++, function () {
      i.forEach(function (e) {
        var t = kE.get(e) - 1,
          n = o.get(e) - 1;
        kE.set(e, t), o.set(e, n), t || (wE.has(e) || e.removeAttribute(a), wE.delete(e)), n || e.removeAttribute(r);
      }), --FE || (kE = new WeakMap(), kE = new WeakMap(), wE = new WeakMap(), _E = {});
    };
  },
  jE = function jE(e, t, r) {
    void 0 === r && (r = "data-aria-hidden");
    var a = Array.from(Array.isArray(e) ? e : [e]),
      n = t || function (e) {
        return "undefined" == typeof document ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
      }(e);
    return n ? (a.push.apply(a, Array.from(n.querySelectorAll("[aria-live]"))), CE(a, n, r, "aria-hidden")) : function () {
      return null;
    };
  },
  EE = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      r = [];
    function a(t, a) {
      var n = Ze(a),
        o = r.length;
      function i(t) {
        var r = t.scope,
          a = t.children,
          i = Me(t, ee),
          l = (null == r ? void 0 : r[e][o]) || n,
          s = Xe(function () {
            return i;
          }, Object.values(i));
        return $e(l.Provider, {
          value: s
        }, a);
      }
      return r = [].concat(Ce(r), [a]), i.displayName = t + "Provider", [i, function (r, i) {
        var l = (null == i ? void 0 : i[e][o]) || n,
          s = rt(l);
        if (s) return s;
        if (void 0 !== a) return a;
        throw new Error("`".concat(r, "` must be used within `").concat(t, "`"));
      }];
    }
    var n = function n() {
      var t = r.map(function (e) {
        return Ze(e);
      });
      return function (r) {
        var a = (null == r ? void 0 : r[e]) || t;
        return Xe(function () {
          return Oe({}, "__scope".concat(e), Te(Te({}, r), {}, Oe({}, e, a)));
        }, [r, a]);
      };
    };
    return n.scopeName = e, [a, uj.apply(void 0, [n].concat(Ce(t)))];
  }("Dialog"),
  TE = Le(EE, 2),
  OE = TE[0],
  AE = (TE[1], Le(OE("Dialog"), 2)),
  ME = AE[0],
  LE = AE[1],
  DE = Le(OE("DialogPortal", {
    forceMount: void 0
  }), 2),
  BE = DE[0],
  PE = DE[1],
  IE = qe(function (e, t) {
    var r = PE("DialogOverlay", e.__scopeDialog),
      a = e.forceMount,
      n = void 0 === a ? r.forceMount : a,
      o = Me(e, le),
      i = LE("DialogOverlay", e.__scopeDialog);
    return i.modal ? $e(Ij, {
      present: n || i.open
    }, $e(zE, oj({}, o, {
      ref: t
    }))) : null;
  }),
  zE = qe(function (e, t) {
    var r = e.__scopeDialog,
      a = Me(e, se),
      n = LE("DialogOverlay", r);
    return $e(xE, {
      as: gj,
      allowPinchZoom: !0,
      shards: [n.contentRef]
    }, $e(xj.div, oj({
      "data-state": VE(n.open)
    }, a, {
      ref: t,
      style: Te({
        pointerEvents: "auto"
      }, a.style)
    })));
  }),
  RE = qe(function (e, t) {
    var r = PE("DialogContent", e.__scopeDialog),
      a = e.forceMount,
      n = void 0 === a ? r.forceMount : a,
      o = Me(e, ce),
      i = LE("DialogContent", e.__scopeDialog);
    return $e(Ij, {
      present: n || i.open
    }, i.modal ? $e(UE, oj({}, o, {
      ref: t
    })) : $e(HE, oj({}, o, {
      ref: t
    })));
  }),
  UE = qe(function (e, t) {
    var r = LE("DialogContent", e.__scopeDialog),
      a = Ge(null),
      n = cj(t, r.contentRef, a);
    return Ve(function () {
      var e = a.current;
      if (e) return jE(e);
    }, []), $e(GE, oj({}, e, {
      ref: n,
      trapFocus: r.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: ij(e.onCloseAutoFocus, function (e) {
        var t;
        e.preventDefault(), null === (t = r.triggerRef.current) || void 0 === t || t.focus();
      }),
      onPointerDownOutside: ij(e.onPointerDownOutside, function (e) {
        var t = e.detail.originalEvent,
          r = 0 === t.button && !0 === t.ctrlKey;
        (2 === t.button || r) && e.preventDefault();
      }),
      onFocusOutside: ij(e.onFocusOutside, function (e) {
        return e.preventDefault();
      })
    }));
  }),
  HE = qe(function (e, t) {
    var r = LE("DialogContent", e.__scopeDialog),
      a = Ge(!1),
      n = Ge(!1);
    return $e(GE, oj({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: function onCloseAutoFocus(t) {
        var o, i;
        (null === (o = e.onCloseAutoFocus) || void 0 === o || o.call(e, t), t.defaultPrevented) || (a.current || null === (i = r.triggerRef.current) || void 0 === i || i.focus(), t.preventDefault());
        a.current = !1, n.current = !1;
      },
      onInteractOutside: function onInteractOutside(t) {
        var o, i;
        null === (o = e.onInteractOutside) || void 0 === o || o.call(e, t), t.defaultPrevented || (a.current = !0, "pointerdown" === t.detail.originalEvent.type && (n.current = !0));
        var l = t.target;
        (null === (i = r.triggerRef.current) || void 0 === i ? void 0 : i.contains(l)) && t.preventDefault(), "focusin" === t.detail.originalEvent.type && n.current && t.preventDefault();
      }
    }));
  }),
  GE = qe(function (e, t) {
    var r = e.__scopeDialog,
      a = e.trapFocus,
      n = e.onOpenAutoFocus,
      o = e.onCloseAutoFocus,
      i = Me(e, ue),
      l = LE("DialogContent", r),
      s = cj(t, Ge(null));
    return Ve(function () {
      var e,
        t,
        r = document.querySelectorAll("[data-radix-focus-guard]");
      return document.body.insertAdjacentElement("afterbegin", null !== (e = r[0]) && void 0 !== e ? e : Uj()), document.body.insertAdjacentElement("beforeend", null !== (t = r[1]) && void 0 !== t ? t : Uj()), Rj++, function () {
        1 === Rj && document.querySelectorAll("[data-radix-focus-guard]").forEach(function (e) {
          return e.remove();
        }), Rj--;
      };
    }, []), $e(nt, null, $e(jj, {
      asChild: !0,
      loop: !0,
      trapped: a,
      onMountAutoFocus: n,
      onUnmountAutoFocus: o
    }, $e(_j, oj({
      role: "dialog",
      id: l.contentId,
      "aria-describedby": l.descriptionId,
      "aria-labelledby": l.titleId,
      "data-state": VE(l.open)
    }, i, {
      ref: s,
      onDismiss: function onDismiss() {
        return l.onOpenChange(!1);
      }
    }))), !1);
  });
function VE(e) {
  return e ? "open" : "closed";
}
var WE = function WE(e) {
    var t = e.__scopeDialog,
      r = e.children,
      a = e.open,
      n = e.defaultOpen,
      o = e.onOpenChange,
      i = e.modal,
      l = void 0 === i || i,
      s = Ge(null),
      c = Ge(null),
      u = Le(yj({
        prop: a,
        defaultProp: n,
        onChange: o
      }), 2),
      d = u[0],
      p = void 0 !== d && d,
      m = u[1];
    return $e(ME, {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: fj(),
      titleId: fj(),
      descriptionId: fj(),
      open: p,
      onOpenChange: m,
      onOpenToggle: Ye(function () {
        return m(function (e) {
          return !e;
        });
      }, [m]),
      modal: l
    }, r);
  },
  KE = function KE(e) {
    var t = e.__scopeDialog,
      r = e.forceMount,
      a = e.children,
      n = e.container,
      o = LE("DialogPortal", t);
    return $e(BE, {
      scope: t,
      forceMount: r
    }, Qe.map(a, function (e) {
      return $e(Ij, {
        present: r || o.open
      }, $e(Pj, {
        asChild: !0,
        container: n
      }, e));
    }));
  },
  YE = IE,
  $E = RE,
  qE = qe(function (e, t) {
    var r = e.__scopeDialog,
      a = Me(e, de),
      n = LE("DialogTitle", r);
    return $e(xj.h2, oj({
      id: n.titleId
    }, a, {
      ref: t
    }));
  }),
  JE = qe(function (e, t) {
    var r = e.__scopeDialog,
      a = Me(e, pe),
      n = LE("DialogDescription", r);
    return $e(xj.p, oj({
      id: n.descriptionId
    }, a, {
      ref: t
    }));
  }),
  XE = function XE() {
    return dt.exports.jsx("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: dt.exports.jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 12.7906L14.9594 15.75L15.75 14.9594L12.7906 12L15.75 9.04062L14.9594 8.25L12 11.2094L9.04062 8.25L8.25 9.04062L11.2094 12L8.25 14.9594L9.04062 15.75L12 12.7906Z"
      })
    });
  },
  ZE = function ZE(e) {
    var t = e.root,
      r = e.type,
      a = void 0 === r ? "Modal" : r,
      n = e.open,
      o = e.onOpenChange,
      i = void 0 === o ? function () {} : o,
      l = e.showClose,
      s = void 0 === l || l,
      c = e.stayOpen,
      u = void 0 !== c && c,
      d = e.size,
      p = e.content,
      m = e.children,
      f = e.headerDivider,
      v = e.ctaInline,
      y = void 0 === v || v,
      g = e.ctaSticky,
      h = void 0 !== g && g,
      b = e.textAlign,
      N = e.zIndex,
      x = "Sheet" === a,
      k = "Drawer" === a,
      w = "left" === b,
      _ = "center" === b,
      F = "right" === b,
      S = "justify" === b;
    return dt.exports.jsx(WE, {
      modal: !0,
      open: n,
      onOpenChange: u ? function () {} : i,
      children: dt.exports.jsxs(KE, Te(Te({}, t && document.getElementById(t) ? {
        container: document.getElementById(t)
      } : {}), {}, {
        children: [dt.exports.jsx(YE, {
          style: N ? {
            zIndex: N
          } : {},
          className: yt({
            drawer: k
          }, "DialogOverlay")
        }), dt.exports.jsxs($E, {
          style: N ? {
            zIndex: N + 1
          } : {},
          tabIndex: -1,
          "aria-modal": !0,
          className: yt({
            drawer: k,
            sheet: x,
            large: "lg" === d,
            ctaSticky: h,
            "cui-text-left": w,
            "cui-text-center": _,
            "cui-text-right": F,
            "cui-text-justify": S
          }, "DialogContent"),
          children: [s && !u && dt.exports.jsx("div", {
            className: "DialogCloseIcon",
            children: dt.exports.jsx(nd, {
              tabIndex: 1,
              type: "tertiary",
              "aria-label": "Close",
              onClick: function onClick() {
                i(!1);
              },
              children: dt.exports.jsx(XE, {})
            })
          }), m || dt.exports.jsxs(dt.exports.Fragment, {
            children: [(null == p ? void 0 : p.icon) && dt.exports.jsx(rs, Te({}, p.icon)), (null == p ? void 0 : p.title) && dt.exports.jsx(qE, {
              asChild: !0,
              children: dt.exports.jsx(vn, {
                size: "xl-bold",
                children: dt.exports.jsx(dt.exports.Fragment, {
                  children: p.title
                })
              })
            }), f && "none" !== f && dt.exports.jsx("div", {
              className: yt({
                small: "sm" === f,
                "cui-ml-auto": F,
                "cui-mx-auto": _,
                "cui-mr-auto": w
              }, "DialogContentDivider")
            }), (null == p ? void 0 : p.media) && dt.exports.jsx("div", {
              children: p.media
            }), (null == p ? void 0 : p.slot) && dt.exports.jsx("div", {
              children: p.slot
            }), (null == p ? void 0 : p.body) && dt.exports.jsx(JE, {
              asChild: !0,
              children: dt.exports.jsx(fn, {
                className: yt({
                  sheet: x
                }, "DialogBody"),
                size: "md",
                children: dt.exports.jsx(dt.exports.Fragment, {
                  children: p.body
                })
              })
            }), ((null == p ? void 0 : p.primaryCta) || (null == p ? void 0 : p.secondaryCta)) && dt.exports.jsxs("div", {
              className: yt({
                ctaSticky: h,
                ctaInline: y,
                sheet: x
              }, "DialogButtonContainer"),
              children: [(null == p ? void 0 : p.primaryCta) && dt.exports.jsx(nd, Te(Te({
                tabIndex: 1
              }, p.primaryButton), {}, {
                children: p.primaryCta
              })), (null == p ? void 0 : p.secondaryCta) && dt.exports.jsx(nd, Te(Te({
                tabIndex: 1
              }, Te({
                type: "minimal"
              }, p.secondaryButton)), {}, {
                children: p.secondaryCta
              }))]
            })]
          })]
        })]
      }))
    });
  };
export { Rs as Avatar, qC as Badge, fn as Body, ef as BoxScore, nd as Button, gt as ButtonGroup, wc as CannedParlay, BF as Card, RC as Cardstack, hd as Carousel, df as CarouselV1, qm as Countdown, am as DateDetails, cc as Details, yn as Display, vn as Heading, rs as Icon, pc as Legs, hn as Loading, Mi as MarketButton, nj as MarketFixture, IC as MarketTemplate, ZE as Overlay, af as PillNav, Rd as PromoMarketButton, wc as QuickPick, $p as Score, Nc as Skeleton, od as SkipLink, eF as Slider, Ls as TeamLogo, QC as Toggle };